/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		168707334958949:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + window["webpackManifest"][chunkId];
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// expose the chunks object
/******/ 	__webpack_require__.s = installedChunks;
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(705);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(824)();
	}


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(77);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(98);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(97);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(207);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(206);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(459));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context),
	    flush = _createEmotion.flush,
	    hydrate = _createEmotion.hydrate,
	    cx = _createEmotion.cx,
	    merge = _createEmotion.merge,
	    getRegisteredStyles = _createEmotion.getRegisteredStyles,
	    injectGlobal = _createEmotion.injectGlobal,
	    keyframes = _createEmotion.keyframes,
	    css = _createEmotion.css,
	    sheet = _createEmotion.sheet,
	    caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = exports.replace = exports.push = undefined;
	
	var _extends2 = __webpack_require__(206);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(381);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(207);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(77);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(98);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(97);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	/* eslint-disable react/no-deprecated */
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___push(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	/* eslint-enable */
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var push = exports.push = function push(to) {
	  window.___push(to);
	};
	
	var replace = exports.replace = function replace(to) {
	  window.___replace(to);
	};
	
	var navigateTo = exports.navigateTo = push;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * React FitText
	 * https://github.com/gianu/react-fittext
	 *
	 * A port of the jQuery plugin: http://github.com/davatron5000/FitText.js
	 *
	 * Released under the MIT license
	 * http://gianu.mit-license.org
	 */
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(59);
	var ReactPropTypes = __webpack_require__(2);
	var createClass = __webpack_require__(461);
	
	module.exports = createClass({
	  displayName: 'ReactFitText',
	
	  propTypes: {
	    children: ReactPropTypes.element.isRequired,
	    compressor: ReactPropTypes.number,
	    minFontSize: ReactPropTypes.number,
	    maxFontSize: ReactPropTypes.number
	  },
	
	  getDefaultProps: function() {
	    return {
	      compressor: 1.0,
	      minFontSize: Number.NEGATIVE_INFINITY,
	      maxFontSize: Number.POSITIVE_INFINITY
	    };
	  },
	
	  componentDidMount: function() {
	    window.addEventListener("resize", this._onBodyResize);
	    this._onBodyResize();
	  },
	
	  componentWillUnmount: function() {
	    window.removeEventListener("resize", this._onBodyResize);
	  },
	
	  componentDidUpdate: function() {
	    this._onBodyResize();
	  },
	
	  _onBodyResize: function() {
	    var element = ReactDOM.findDOMNode(this);
	    var width = element.offsetWidth;
	    element.style.fontSize = Math.max(
	                      Math.min((width / (this.props.compressor*10)),
	                                parseFloat(this.props.maxFontSize)),
	                      parseFloat(this.props.minFontSize)) + 'px';
	  },
	  _renderChildren: function(){
	    var _this = this;
	
	    return React.Children.map(this.props.children, function (child) {
	      return React.cloneElement(child, { ref: function ref(c) {
	        return _this._childRef = c;
	      } });
	    });
	  },
	  render: function() {
	    return this._renderChildren()[0];
	  }
	});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(188));
	var _inheritsLoose = _interopDefault(__webpack_require__(189));
	var _assertThisInitialized = _interopDefault(__webpack_require__(245));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(190));
	var React = _interopDefault(__webpack_require__(1));
	var ReactDOM = _interopDefault(__webpack_require__(59));
	
	var bugfixes = undefined;
	var applyAnimatedValues = undefined;
	var colorNames = [];
	var requestFrame = function requestFrame(cb) {
	  return typeof window !== 'undefined' && window.requestAnimationFrame(cb);
	};
	var cancelFrame = function cancelFrame(cb) {
	  return typeof window !== 'undefined' && window.cancelAnimationFrame(cb);
	};
	var interpolation = undefined;
	var now = function now() {
	  return Date.now();
	};
	var defaultElement = undefined;
	var injectApplyAnimatedValues = function injectApplyAnimatedValues(fn, transform) {
	  return applyAnimatedValues = {
	    fn: fn,
	    transform: transform
	  };
	};
	var injectColorNames = function injectColorNames(names) {
	  return colorNames = names;
	};
	var injectBugfixes = function injectBugfixes(fn) {
	  return bugfixes = fn;
	};
	var injectInterpolation = function injectInterpolation(cls) {
	  return interpolation = cls;
	};
	var injectFrame = function injectFrame(raf, caf) {
	  var _ref;
	
	  return _ref = [raf, caf], requestFrame = _ref[0], cancelFrame = _ref[1], _ref;
	};
	var injectNow = function injectNow(nowFn) {
	  return now = nowFn;
	};
	var injectDefaultElement = function injectDefaultElement(el) {
	  return defaultElement = el;
	};
	
	var Globals = /*#__PURE__*/Object.freeze({
	  get bugfixes () { return bugfixes; },
	  get applyAnimatedValues () { return applyAnimatedValues; },
	  get colorNames () { return colorNames; },
	  get requestFrame () { return requestFrame; },
	  get cancelFrame () { return cancelFrame; },
	  get interpolation () { return interpolation; },
	  get now () { return now; },
	  get defaultElement () { return defaultElement; },
	  injectApplyAnimatedValues: injectApplyAnimatedValues,
	  injectColorNames: injectColorNames,
	  injectBugfixes: injectBugfixes,
	  injectInterpolation: injectInterpolation,
	  injectFrame: injectFrame,
	  injectNow: injectNow,
	  injectDefaultElement: injectDefaultElement
	});
	
	// http://www.w3.org/TR/css3-color/#svg-color
	var colors = {
	  transparent: 0x00000000,
	  aliceblue: 0xf0f8ffff,
	  antiquewhite: 0xfaebd7ff,
	  aqua: 0x00ffffff,
	  aquamarine: 0x7fffd4ff,
	  azure: 0xf0ffffff,
	  beige: 0xf5f5dcff,
	  bisque: 0xffe4c4ff,
	  black: 0x000000ff,
	  blanchedalmond: 0xffebcdff,
	  blue: 0x0000ffff,
	  blueviolet: 0x8a2be2ff,
	  brown: 0xa52a2aff,
	  burlywood: 0xdeb887ff,
	  burntsienna: 0xea7e5dff,
	  cadetblue: 0x5f9ea0ff,
	  chartreuse: 0x7fff00ff,
	  chocolate: 0xd2691eff,
	  coral: 0xff7f50ff,
	  cornflowerblue: 0x6495edff,
	  cornsilk: 0xfff8dcff,
	  crimson: 0xdc143cff,
	  cyan: 0x00ffffff,
	  darkblue: 0x00008bff,
	  darkcyan: 0x008b8bff,
	  darkgoldenrod: 0xb8860bff,
	  darkgray: 0xa9a9a9ff,
	  darkgreen: 0x006400ff,
	  darkgrey: 0xa9a9a9ff,
	  darkkhaki: 0xbdb76bff,
	  darkmagenta: 0x8b008bff,
	  darkolivegreen: 0x556b2fff,
	  darkorange: 0xff8c00ff,
	  darkorchid: 0x9932ccff,
	  darkred: 0x8b0000ff,
	  darksalmon: 0xe9967aff,
	  darkseagreen: 0x8fbc8fff,
	  darkslateblue: 0x483d8bff,
	  darkslategray: 0x2f4f4fff,
	  darkslategrey: 0x2f4f4fff,
	  darkturquoise: 0x00ced1ff,
	  darkviolet: 0x9400d3ff,
	  deeppink: 0xff1493ff,
	  deepskyblue: 0x00bfffff,
	  dimgray: 0x696969ff,
	  dimgrey: 0x696969ff,
	  dodgerblue: 0x1e90ffff,
	  firebrick: 0xb22222ff,
	  floralwhite: 0xfffaf0ff,
	  forestgreen: 0x228b22ff,
	  fuchsia: 0xff00ffff,
	  gainsboro: 0xdcdcdcff,
	  ghostwhite: 0xf8f8ffff,
	  gold: 0xffd700ff,
	  goldenrod: 0xdaa520ff,
	  gray: 0x808080ff,
	  green: 0x008000ff,
	  greenyellow: 0xadff2fff,
	  grey: 0x808080ff,
	  honeydew: 0xf0fff0ff,
	  hotpink: 0xff69b4ff,
	  indianred: 0xcd5c5cff,
	  indigo: 0x4b0082ff,
	  ivory: 0xfffff0ff,
	  khaki: 0xf0e68cff,
	  lavender: 0xe6e6faff,
	  lavenderblush: 0xfff0f5ff,
	  lawngreen: 0x7cfc00ff,
	  lemonchiffon: 0xfffacdff,
	  lightblue: 0xadd8e6ff,
	  lightcoral: 0xf08080ff,
	  lightcyan: 0xe0ffffff,
	  lightgoldenrodyellow: 0xfafad2ff,
	  lightgray: 0xd3d3d3ff,
	  lightgreen: 0x90ee90ff,
	  lightgrey: 0xd3d3d3ff,
	  lightpink: 0xffb6c1ff,
	  lightsalmon: 0xffa07aff,
	  lightseagreen: 0x20b2aaff,
	  lightskyblue: 0x87cefaff,
	  lightslategray: 0x778899ff,
	  lightslategrey: 0x778899ff,
	  lightsteelblue: 0xb0c4deff,
	  lightyellow: 0xffffe0ff,
	  lime: 0x00ff00ff,
	  limegreen: 0x32cd32ff,
	  linen: 0xfaf0e6ff,
	  magenta: 0xff00ffff,
	  maroon: 0x800000ff,
	  mediumaquamarine: 0x66cdaaff,
	  mediumblue: 0x0000cdff,
	  mediumorchid: 0xba55d3ff,
	  mediumpurple: 0x9370dbff,
	  mediumseagreen: 0x3cb371ff,
	  mediumslateblue: 0x7b68eeff,
	  mediumspringgreen: 0x00fa9aff,
	  mediumturquoise: 0x48d1ccff,
	  mediumvioletred: 0xc71585ff,
	  midnightblue: 0x191970ff,
	  mintcream: 0xf5fffaff,
	  mistyrose: 0xffe4e1ff,
	  moccasin: 0xffe4b5ff,
	  navajowhite: 0xffdeadff,
	  navy: 0x000080ff,
	  oldlace: 0xfdf5e6ff,
	  olive: 0x808000ff,
	  olivedrab: 0x6b8e23ff,
	  orange: 0xffa500ff,
	  orangered: 0xff4500ff,
	  orchid: 0xda70d6ff,
	  palegoldenrod: 0xeee8aaff,
	  palegreen: 0x98fb98ff,
	  paleturquoise: 0xafeeeeff,
	  palevioletred: 0xdb7093ff,
	  papayawhip: 0xffefd5ff,
	  peachpuff: 0xffdab9ff,
	  peru: 0xcd853fff,
	  pink: 0xffc0cbff,
	  plum: 0xdda0ddff,
	  powderblue: 0xb0e0e6ff,
	  purple: 0x800080ff,
	  rebeccapurple: 0x663399ff,
	  red: 0xff0000ff,
	  rosybrown: 0xbc8f8fff,
	  royalblue: 0x4169e1ff,
	  saddlebrown: 0x8b4513ff,
	  salmon: 0xfa8072ff,
	  sandybrown: 0xf4a460ff,
	  seagreen: 0x2e8b57ff,
	  seashell: 0xfff5eeff,
	  sienna: 0xa0522dff,
	  silver: 0xc0c0c0ff,
	  skyblue: 0x87ceebff,
	  slateblue: 0x6a5acdff,
	  slategray: 0x708090ff,
	  slategrey: 0x708090ff,
	  snow: 0xfffafaff,
	  springgreen: 0x00ff7fff,
	  steelblue: 0x4682b4ff,
	  tan: 0xd2b48cff,
	  teal: 0x008080ff,
	  thistle: 0xd8bfd8ff,
	  tomato: 0xff6347ff,
	  turquoise: 0x40e0d0ff,
	  violet: 0xee82eeff,
	  wheat: 0xf5deb3ff,
	  white: 0xffffffff,
	  whitesmoke: 0xf5f5f5ff,
	  yellow: 0xffff00ff,
	  yellowgreen: 0x9acd32ff
	};
	
	var Interpolation =
	/*#__PURE__*/
	function () {
	  function Interpolation() {}
	
	  Interpolation.create = function create(config, arg) {
	    if (typeof config === 'function') return config;else if (interpolation && config.output && typeof config.output[0] === 'string') return interpolation(config);else if (Array.isArray(config)) return Interpolation.create({
	      range: config,
	      output: arg
	    });
	    var outputRange = config.output;
	    var inputRange = config.range || [0, 1];
	
	    var easing = config.easing || function (t) {
	      return t;
	    };
	
	    var extrapolateLeft = 'extend';
	    var map = config.map;
	    if (config.extrapolateLeft !== undefined) extrapolateLeft = config.extrapolateLeft;else if (config.extrapolate !== undefined) extrapolateLeft = config.extrapolate;
	    var extrapolateRight = 'extend';
	    if (config.extrapolateRight !== undefined) extrapolateRight = config.extrapolateRight;else if (config.extrapolate !== undefined) extrapolateRight = config.extrapolate;
	    return function (input) {
	      var range = findRange(input, inputRange);
	      return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, map);
	    };
	  };
	
	  return Interpolation;
	}();
	
	function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
	  var result = map ? map(input) : input; // Extrapolate
	
	  if (result < inputMin) {
	    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
	  }
	
	  if (result > inputMax) {
	    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
	  }
	
	  if (outputMin === outputMax) return outputMin;
	  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range
	
	  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing
	
	  result = easing(result); // Output Range
	
	  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
	  return result;
	}
	
	function findRange(input, inputRange) {
	  for (var i = 1; i < inputRange.length - 1; ++i) {
	    if (inputRange[i] >= input) break;
	  }
	
	  return i - 1;
	}
	
	// const INTEGER = '[-+]?\\d+';
	var NUMBER = '[-+]?\\d*\\.?\\d+';
	var PERCENTAGE = NUMBER + '%';
	
	function call() {
	  return '\\(\\s*(' + Array.prototype.slice.call(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
	}
	
	var rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
	var rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
	var hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
	var hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
	var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
	var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
	var hex6 = /^#([0-9a-fA-F]{6})$/;
	var hex8 = /^#([0-9a-fA-F]{8})$/;
	
	/*
	https://github.com/react-community/normalize-css-color
	
	BSD 3-Clause License
	
	Copyright (c) 2016, React Community
	All rights reserved.
	
	Redistribution and use in source and binary forms, with or without
	modification, are permitted provided that the following conditions are met:
	
	* Redistributions of source code must retain the above copyright notice, this
	  list of conditions and the following disclaimer.
	
	* Redistributions in binary form must reproduce the above copyright notice,
	  this list of conditions and the following disclaimer in the documentation
	  and/or other materials provided with the distribution.
	
	* Neither the name of the copyright holder nor the names of its
	  contributors may be used to endorse or promote products derived from
	  this software without specific prior written permission.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
	FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
	DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
	SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
	CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
	OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	function normalizeColor(color) {
	  var match;
	
	  if (typeof color === 'number') {
	    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
	  } // Ordered based on occurrences on Facebook codebase
	
	
	  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
	  if (colors.hasOwnProperty(color)) return colors[color];
	
	  if (match = rgb.exec(color)) {
	    return (parse255(match[1]) << 24 | // r
	    parse255(match[2]) << 16 | // g
	    parse255(match[3]) << 8 | // b
	    0x000000ff) >>> // a
	    0;
	  }
	
	  if (match = rgba.exec(color)) {
	    return (parse255(match[1]) << 24 | // r
	    parse255(match[2]) << 16 | // g
	    parse255(match[3]) << 8 | // b
	    parse1(match[4])) >>> // a
	    0;
	  }
	
	  if (match = hex3.exec(color)) {
	    return parseInt(match[1] + match[1] + // r
	    match[2] + match[2] + // g
	    match[3] + match[3] + // b
	    'ff', // a
	    16) >>> 0;
	  } // https://drafts.csswg.org/css-color-4/#hex-notation
	
	
	  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
	
	  if (match = hex4.exec(color)) {
	    return parseInt(match[1] + match[1] + // r
	    match[2] + match[2] + // g
	    match[3] + match[3] + // b
	    match[4] + match[4], // a
	    16) >>> 0;
	  }
	
	  if (match = hsl.exec(color)) {
	    return (hslToRgb(parse360(match[1]), // h
	    parsePercentage(match[2]), // s
	    parsePercentage(match[3]) // l
	    ) | 0x000000ff) >>> // a
	    0;
	  }
	
	  if (match = hsla.exec(color)) {
	    return (hslToRgb(parse360(match[1]), // h
	    parsePercentage(match[2]), // s
	    parsePercentage(match[3]) // l
	    ) | parse1(match[4])) >>> // a
	    0;
	  }
	
	  return null;
	}
	
	function hue2rgb(p, q, t) {
	  if (t < 0) t += 1;
	  if (t > 1) t -= 1;
	  if (t < 1 / 6) return p + (q - p) * 6 * t;
	  if (t < 1 / 2) return q;
	  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	  return p;
	}
	
	function hslToRgb(h, s, l) {
	  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	  var p = 2 * l - q;
	  var r = hue2rgb(p, q, h + 1 / 3);
	  var g = hue2rgb(p, q, h);
	  var b = hue2rgb(p, q, h - 1 / 3);
	  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
	}
	
	function parse255(str) {
	  var int = parseInt(str, 10);
	  if (int < 0) return 0;
	  if (int > 255) return 255;
	  return int;
	}
	
	function parse360(str) {
	  var int = parseFloat(str);
	  return (int % 360 + 360) % 360 / 360;
	}
	
	function parse1(str) {
	  var num = parseFloat(str);
	  if (num < 0) return 0;
	  if (num > 1) return 255;
	  return Math.round(num * 255);
	}
	
	function parsePercentage(str) {
	  // parseFloat conveniently ignores the final %
	  var int = parseFloat(str);
	  if (int < 0) return 0;
	  if (int > 100) return 1;
	  return int / 100;
	}
	
	function colorToRgba(input) {
	  var int32Color = normalizeColor(input);
	  if (int32Color === null) return input;
	  int32Color = int32Color || 0;
	  var r = (int32Color & 0xff000000) >>> 24;
	  var g = (int32Color & 0x00ff0000) >>> 16;
	  var b = (int32Color & 0x0000ff00) >>> 8;
	  var a = (int32Color & 0x000000ff) / 255;
	  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
	} // Problem: https://github.com/animatedjs/animated/pull/102
	// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662
	
	
	var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
	// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e
	
	var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)
	
	var colorNamesRegex = new RegExp("(" + Object.keys(colors).join('|') + ")", 'g');
	/**
	 * Supports string shapes by extracting numbers so new values can be computed,
	 * and recombines those values into new strings of the same shape.  Supports
	 * things like:
	 *
	 *   rgba(123, 42, 99, 0.36)           // colors
	 *   -45deg                            // values with units
	 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
	 */
	
	function createInterpolation(config) {
	  // Replace colors with rgba
	  var outputRange = config.output.map(function (rangeValue) {
	    return rangeValue.replace(colorRegex, colorToRgba);
	  }).map(function (rangeValue) {
	    return rangeValue.replace(colorNamesRegex, colorToRgba);
	  }); // ->
	  // [
	  //   [0, 50],
	  //   [100, 150],
	  //   [200, 250],
	  //   [0, 0.5],
	  // ]
	
	  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
	    return [];
	  });
	  outputRange.forEach(function (value) {
	    value.match(stringShapeRegex).forEach(function (number, i) {
	      return outputRanges[i].push(+number);
	    });
	  });
	  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
	    return Interpolation.create(_extends({}, config, {
	      output: outputRanges[i]
	    }));
	  });
	  var shouldRound = /^rgb/.test(outputRange[0]);
	  return function (input) {
	    var i = 0;
	    return outputRange[0] // 'rgba(0, 100, 200, 0)'
	    // ->
	    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
	    .replace(stringShapeRegex, function () {
	      return interpolations[i++](input);
	    }) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
	    // round the opacity (4th column).
	    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (_, p1, p2, p3, p4) {
	      return "rgba(" + Math.round(p1) + ", " + Math.round(p2) + ", " + Math.round(p3) + ", " + p4 + ")";
	    });
	  };
	}
	
	var Animated =
	/*#__PURE__*/
	function () {
	  function Animated() {}
	
	  var _proto = Animated.prototype;
	
	  _proto.attach = function attach() {};
	
	  _proto.detach = function detach() {};
	
	  _proto.getValue = function getValue() {};
	
	  _proto.getAnimatedValue = function getAnimatedValue() {
	    return this.getValue();
	  };
	
	  _proto.addChild = function addChild(child) {};
	
	  _proto.removeChild = function removeChild(child) {};
	
	  _proto.getChildren = function getChildren() {
	    return [];
	  };
	
	  return Animated;
	}();
	
	var getValues = function getValues(object) {
	  return Object.keys(object).map(function (k) {
	    return object[k];
	  });
	};
	
	var AnimatedWithChildren =
	/*#__PURE__*/
	function (_Animated) {
	  _inheritsLoose(AnimatedWithChildren, _Animated);
	
	  function AnimatedWithChildren() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Animated.call.apply(_Animated, [this].concat(args)) || this;
	    _this.children = [];
	
	    _this.getChildren = function () {
	      return _this.children;
	    };
	
	    _this.getPayload = function (index) {
	      if (index === void 0) {
	        index = undefined;
	      }
	
	      return index !== void 0 && _this.payload ? _this.payload[index] : _this.payload || _assertThisInitialized(_assertThisInitialized(_this));
	    };
	
	    return _this;
	  }
	
	  var _proto = AnimatedWithChildren.prototype;
	
	  _proto.addChild = function addChild(child) {
	    if (this.children.length === 0) this.attach();
	    this.children.push(child);
	  };
	
	  _proto.removeChild = function removeChild(child) {
	    var index = this.children.indexOf(child);
	
	    if (index === -1) {
	      if (({"API_URL":"jk-wp.jkstaging.com","PROTOCOL":"https","FULLPAGE_LICENSE":"37D7F782-2DB0468E-B8CF0709-EE848D63","STRIPE_KEY":"pk_live_e5tzuesC80q4X6j5oCym6Doh00fpojxSmn","STRIPE_KEY_TEST":"pk_test_DICWgc31UVmZN6OpAapFEnMo00hJrj1SKX","NODE_ENV":"production","PUBLIC_DIR":"/Users/coryp/Sites/jk.design/public","GATSBY_TELEMETRY_DISABLED":"1"}).NODEENV !== 'production') {
	        console.warn("Trying to remove a child that doesn't exist");
	      }
	
	      return;
	    }
	
	    this.children.splice(index, 1);
	    if (this.children.length === 0) this.detach();
	  };
	
	  return AnimatedWithChildren;
	}(Animated);
	var AnimatedArrayWithChildren =
	/*#__PURE__*/
	function (_AnimatedWithChildren) {
	  _inheritsLoose(AnimatedArrayWithChildren, _AnimatedWithChildren);
	
	  function AnimatedArrayWithChildren() {
	    var _this2;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _AnimatedWithChildren.call.apply(_AnimatedWithChildren, [this].concat(args)) || this;
	    _this2.payload = [];
	
	    _this2.getAnimatedValue = function () {
	      return _this2.getValue();
	    };
	
	    _this2.attach = function () {
	      return _this2.payload.forEach(function (p) {
	        return p instanceof Animated && p.addChild(_assertThisInitialized(_assertThisInitialized(_this2)));
	      });
	    };
	
	    _this2.detach = function () {
	      return _this2.payload.forEach(function (p) {
	        return p instanceof Animated && p.removeChild(_assertThisInitialized(_assertThisInitialized(_this2)));
	      });
	    };
	
	    return _this2;
	  }
	
	  return AnimatedArrayWithChildren;
	}(AnimatedWithChildren);
	var AnimatedObjectWithChildren =
	/*#__PURE__*/
	function (_AnimatedWithChildren2) {
	  _inheritsLoose(AnimatedObjectWithChildren, _AnimatedWithChildren2);
	
	  function AnimatedObjectWithChildren() {
	    var _this3;
	
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    _this3 = _AnimatedWithChildren2.call.apply(_AnimatedWithChildren2, [this].concat(args)) || this;
	    _this3.payload = {};
	
	    _this3.getAnimatedValue = function () {
	      return _this3.getValue(true);
	    };
	
	    _this3.attach = function () {
	      return getValues(_this3.payload).forEach(function (s) {
	        return s instanceof Animated && s.addChild(_assertThisInitialized(_assertThisInitialized(_this3)));
	      });
	    };
	
	    _this3.detach = function () {
	      return getValues(_this3.payload).forEach(function (s) {
	        return s instanceof Animated && s.removeChild(_assertThisInitialized(_assertThisInitialized(_this3)));
	      });
	    };
	
	    return _this3;
	  }
	
	  var _proto2 = AnimatedObjectWithChildren.prototype;
	
	  _proto2.getValue = function getValue(animated) {
	    if (animated === void 0) {
	      animated = false;
	    }
	
	    var payload = {};
	
	    for (var key in this.payload) {
	      var value = this.payload[key];
	      if (animated && !(value instanceof Animated)) continue;
	      payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
	    }
	
	    return payload;
	  };
	
	  return AnimatedObjectWithChildren;
	}(AnimatedWithChildren);
	
	var AnimatedInterpolation =
	/*#__PURE__*/
	function (_AnimatedArrayWithChi) {
	  _inheritsLoose(AnimatedInterpolation, _AnimatedArrayWithChi);
	
	  function AnimatedInterpolation(parents, _config, _arg) {
	    var _this;
	
	    _this = _AnimatedArrayWithChi.call(this) || this;
	
	    _this.getValue = function () {
	      var _this2;
	
	      return (_this2 = _this).calc.apply(_this2, _this.payload.map(function (value) {
	        return value.getValue();
	      }));
	    };
	
	    _this.updateConfig = function (config, arg) {
	      return _this.calc = Interpolation.create(config, arg);
	    };
	
	    _this.interpolate = function (config, arg) {
	      return new AnimatedInterpolation(_assertThisInitialized(_assertThisInitialized(_this)), config, arg);
	    };
	
	    _this.payload = // AnimatedArrays should unfold, except AnimatedInterpolation which is taken as is
	    parents instanceof AnimatedArrayWithChildren && !parents.updateConfig ? parents.payload : Array.isArray(parents) ? parents : [parents];
	    _this.calc = Interpolation.create(_config, _arg);
	    return _this;
	  }
	
	  return AnimatedInterpolation;
	}(AnimatedArrayWithChildren);
	var interpolate$1 = function interpolate(parents, config, arg) {
	  return parents && new AnimatedInterpolation(parents, config, arg);
	};
	
	/**
	 * Animated works by building a directed acyclic graph of dependencies
	 * transparently when you render your Animated components.
	 *
	 *               new Animated.Value(0)
	 *     .interpolate()        .interpolate()    new Animated.Value(1)
	 *         opacity               translateY      scale
	 *          style                         transform
	 *         View#234                         style
	 *                                         View#123
	 *
	 * A) Top Down phase
	 * When an Animated.Value is updated, we recursively go down through this
	 * graph in order to find leaf nodes: the views that we flag as needing
	 * an update.
	 *
	 * B) Bottom Up phase
	 * When a view is flagged as needing an update, we recursively go back up
	 * in order to build the new value that it needs. The reason why we need
	 * this two-phases process is to deal with composite props such as
	 * transform which can receive values from multiple parents.
	 */
	
	function findAnimatedStyles(node, styles) {
	  if (typeof node.update === 'function') styles.add(node);else node.getChildren().forEach(function (child) {
	    return findAnimatedStyles(child, styles);
	  });
	}
	/**
	 * Standard value for driving animations.  One `Animated.Value` can drive
	 * multiple properties in a synchronized fashion, but can only be driven by one
	 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
	 * or calling `setValue`) will stop any previous ones.
	 */
	
	
	var AnimatedValue =
	/*#__PURE__*/
	function (_AnimatedWithChildren) {
	  _inheritsLoose(AnimatedValue, _AnimatedWithChildren);
	
	  function AnimatedValue(_value) {
	    var _this;
	
	    _this = _AnimatedWithChildren.call(this) || this;
	
	    _this.getValue = function () {
	      return _this.value;
	    };
	
	    _this.updateStyles = function () {
	      return findAnimatedStyles(_assertThisInitialized(_assertThisInitialized(_this)), _this.animatedStyles);
	    };
	
	    _this.updateValue = function (value) {
	      return _this.flush(_this.value = value);
	    };
	
	    _this.interpolate = function (config, arg) {
	      return new AnimatedInterpolation(_assertThisInitialized(_assertThisInitialized(_this)), config, arg);
	    };
	
	    _this.value = _value;
	    _this.animatedStyles = new Set();
	    _this.done = false;
	    _this.startPosition = _value;
	    _this.lastPosition = _value;
	    _this.lastVelocity = undefined;
	    _this.lastTime = undefined;
	    _this.controller = undefined;
	    return _this;
	  }
	
	  var _proto = AnimatedValue.prototype;
	
	  _proto.flush = function flush() {
	    if (this.animatedStyles.size === 0) this.updateStyles();
	    this.animatedStyles.forEach(function (animatedStyle) {
	      return animatedStyle.update();
	    });
	  };
	
	  _proto.prepare = function prepare(controller) {
	    // Values stay loyal to their original controller, this is also a way to
	    // detect trailing values originating from a foreign controller
	    if (this.controller === undefined) this.controller = controller;
	
	    if (this.controller === controller) {
	      this.startPosition = this.value;
	      this.lastPosition = this.value;
	      this.lastVelocity = controller.isActive ? this.lastVelocity : undefined;
	      this.lastTime = controller.isActive ? this.lastTime : undefined;
	      this.done = false;
	      this.animatedStyles.clear();
	    }
	  };
	
	  return AnimatedValue;
	}(AnimatedWithChildren);
	
	var AnimatedArray =
	/*#__PURE__*/
	function (_AnimatedArrayWithChi) {
	  _inheritsLoose(AnimatedArray, _AnimatedArrayWithChi);
	
	  function AnimatedArray(array) {
	    var _this;
	
	    _this = _AnimatedArrayWithChi.call(this) || this;
	
	    _this.setValue = function (values) {
	      return values.length === _this.payload.length && values.forEach(function (v, i) {
	        return _this.payload[i].setValue(v);
	      });
	    };
	
	    _this.getValue = function () {
	      return _this.payload.map(function (v) {
	        return v.getValue();
	      });
	    };
	
	    _this.interpolate = function (config, arg) {
	      return new AnimatedInterpolation(_assertThisInitialized(_assertThisInitialized(_this)), config, arg);
	    };
	
	    _this.payload = array instanceof AnimatedArray ? array.payload : array.map(function (n) {
	      return new AnimatedValue(n);
	    });
	    return _this;
	  }
	
	  return AnimatedArray;
	}(AnimatedArrayWithChildren);
	
	function withDefault(value, defaultValue) {
	  return value === undefined || value === null ? defaultValue : value;
	}
	function toArray(a) {
	  return a !== void 0 ? Array.isArray(a) ? a : [a] : [];
	}
	function shallowEqual(a, b) {
	  if (typeof a !== typeof b) return false;
	  if (typeof a === 'string' || typeof a === 'number') return a === b;
	  var i;
	
	  for (i in a) {
	    if (!(i in b)) return false;
	  }
	
	  for (i in b) {
	    if (a[i] !== b[i]) return false;
	  }
	
	  return i === void 0 ? a === b : true;
	}
	function callProp(obj, state) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  return typeof obj === 'function' ? obj.apply(void 0, [state].concat(args)) : obj;
	}
	function getValues$1(object) {
	  return Object.keys(object).map(function (k) {
	    return object[k];
	  });
	}
	function getForwardProps(props) {
	  var to = props.to,
	      from = props.from,
	      config = props.config,
	      native = props.native,
	      onStart = props.onStart,
	      onRest = props.onRest,
	      onFrame = props.onFrame,
	      children = props.children,
	      reset = props.reset,
	      reverse = props.reverse,
	      force = props.force,
	      immediate = props.immediate,
	      impl = props.impl,
	      inject = props.inject,
	      delay = props.delay,
	      attach = props.attach,
	      destroyed = props.destroyed,
	      track = props.track,
	      interpolateTo = props.interpolateTo,
	      autoStart = props.autoStart,
	      forward = _objectWithoutPropertiesLoose(props, ["to", "from", "config", "native", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "impl", "inject", "delay", "attach", "destroyed", "track", "interpolateTo", "autoStart"]);
	
	  return forward;
	}
	function interpolateTo(props) {
	  var forward = getForwardProps(props);
	  var rest = Object.keys(props).reduce(function (a, k) {
	    var _extends2;
	
	    return forward[k] !== void 0 ? a : _extends({}, a, (_extends2 = {}, _extends2[k] = props[k], _extends2));
	  }, {});
	  return _extends({
	    to: forward
	  }, rest);
	}
	function convertToAnimatedValue(acc, _ref) {
	  var _extends3;
	
	  var name = _ref[0],
	      value = _ref[1];
	  return _extends({}, acc, (_extends3 = {}, _extends3[name] = new (Array.isArray(value) ? AnimatedArray : AnimatedValue)(value), _extends3));
	}
	function convertValues(props) {
	  var from = props.from,
	      to = props.to,
	      native = props.native;
	  var allProps = Object.entries(_extends({}, from, to));
	  return native ? allProps.reduce(convertToAnimatedValue, {}) : _extends({}, from, to);
	}
	function handleRef(ref, forward) {
	  if (forward) {
	    // If it's a function, assume it's a ref callback
	    if (typeof forward === 'function') forward(ref);else if (typeof forward === 'object') // If it's an object and has a 'current' property, assume it's a ref object
	      forward.current = ref;
	  }
	
	  return ref;
	}
	
	var check = function check(value) {
	  return value === 'auto';
	};
	
	var overwrite = function overwrite(width, height) {
	  return function (acc, _ref) {
	    var _extends2;
	
	    var name = _ref[0],
	        value = _ref[1];
	    return _extends({}, acc, (_extends2 = {}, _extends2[name] = value === 'auto' ? ~name.indexOf('height') ? height : width : value, _extends2));
	  };
	};
	
	function fixAuto(props, callback) {
	  var from = props.from,
	      to = props.to,
	      children = props.children; // Dry-route props back if nothing's using 'auto' in there
	  // TODO: deal with "null"
	
	  if (!(getValues$1(to).some(check) || getValues$1(from).some(check))) return; // Fetch render v-dom
	
	  var element = children(convertValues(props)); // A spring can return undefined/null, check against that (#153)
	
	  if (!element) return;
	  var elementStyles = element.props.style; // Return v.dom with injected ref
	
	  return React.createElement(element.type, _extends({
	    key: element.key ? element.key : undefined
	  }, element.props, {
	    style: _extends({}, elementStyles, {
	      position: 'absolute',
	      visibility: 'hidden'
	    }),
	    ref: function ref(_ref2) {
	      if (_ref2) {
	        // Once it's rendered out, fetch bounds (minus padding/margin/borders)
	        var node = ReactDOM.findDOMNode(_ref2);
	        var width, height;
	        var cs = getComputedStyle(node);
	
	        if (cs.boxSizing === 'border-box') {
	          width = node.offsetWidth;
	          height = node.offsetHeight;
	        } else {
	          var paddingX = parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
	          var paddingY = parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0);
	          var borderX = parseFloat(cs.borderLeftWidth || 0) + parseFloat(cs.borderRightWidth || 0);
	          var borderY = parseFloat(cs.borderTopWidth || 0) + parseFloat(cs.borderBottomWidth || 0);
	          width = node.offsetWidth - paddingX - borderX;
	          height = node.offsetHeight - paddingY - borderY;
	        }
	
	        var convert = overwrite(width, height);
	        callback(_extends({}, props, {
	          from: Object.entries(from).reduce(convert, from),
	          to: Object.entries(to).reduce(convert, to)
	        }));
	      }
	    }
	  }));
	}
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	var prefixKey = function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	};
	
	var prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
	isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
	  prefixes.forEach(function (prefix) {
	    return acc[prefixKey(prefix, prop)] = acc[prop];
	  });
	  return acc;
	}, isUnitlessNumber);
	
	function dangerousStyleValue(name, value, isCustomProperty) {
	  if (value == null || typeof value === 'boolean' || value === '') return '';
	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	
	  return ('' + value).trim();
	}
	
	var attributeCache = {};
	injectDefaultElement('div');
	injectInterpolation(createInterpolation);
	injectColorNames(colors);
	injectBugfixes(fixAuto);
	injectApplyAnimatedValues(function (instance, props) {
	  if (instance.nodeType && instance.setAttribute !== undefined) {
	    var style = props.style,
	        children = props.children,
	        scrollTop = props.scrollTop,
	        scrollLeft = props.scrollLeft,
	        attributes = _objectWithoutPropertiesLoose(props, ["style", "children", "scrollTop", "scrollLeft"]);
	
	    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
	    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value
	
	    if (children !== void 0) instance.textContent = children; // Set styles ...
	
	    for (var styleName in style) {
	      if (!style.hasOwnProperty(styleName)) continue;
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
	      if (styleName === 'float') styleName = 'cssFloat';
	      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
	    } // Set attributes ...
	
	
	    for (var name in attributes) {
	      // Attributes are written in dash case
	      var dashCase = attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, function (n) {
	        return '-' + n.toLowerCase();
	      }));
	      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
	    }
	  } else return false;
	}, function (style) {
	  return style;
	});
	
	var AnimatedStyle =
	/*#__PURE__*/
	function (_AnimatedObjectWithCh) {
	  _inheritsLoose(AnimatedStyle, _AnimatedObjectWithCh);
	
	  function AnimatedStyle(style) {
	    var _this;
	
	    _this = _AnimatedObjectWithCh.call(this) || this;
	    style = style || {};
	    if (style.transform && !(style.transform instanceof Animated)) style = applyAnimatedValues.transform(style);
	    _this.payload = style;
	    return _this;
	  }
	
	  return AnimatedStyle;
	}(AnimatedObjectWithChildren);
	
	var AnimatedProps =
	/*#__PURE__*/
	function (_AnimatedObjectWithCh) {
	  _inheritsLoose(AnimatedProps, _AnimatedObjectWithCh);
	
	  function AnimatedProps(props, callback) {
	    var _this;
	
	    _this = _AnimatedObjectWithCh.call(this) || this;
	    if (props.style) props = _extends({}, props, {
	      style: new AnimatedStyle(props.style)
	    });
	    _this.payload = props;
	    _this.update = callback;
	
	    _this.attach();
	
	    return _this;
	  }
	
	  return AnimatedProps;
	}(AnimatedObjectWithChildren);
	
	var now$1, isDone, noChange, configIdx, valIdx, config, animation, position, from, tracked, to, endOfAnimation, lastTime, velocity, numSteps, force, damping, acceleration, stepIdx, isOvershooting, isVelocity, isDisplacement;
	
	var Controller =
	/*#__PURE__*/
	function () {
	  function Controller(props, _config) {
	    var _this = this;
	
	    if (_config === void 0) {
	      _config = {
	        native: true,
	        track: true,
	        interpolateTo: true,
	        autoStart: true
	      };
	    }
	
	    this.getValues = function () {
	      return _this.props.native ? _this.interpolations : _this.animatedProps;
	    };
	
	    this.raf = function () {
	      now$1 = now();
	      isDone = true;
	      noChange = true;
	
	      for (configIdx = 0; configIdx < _this.configs.length; configIdx++) {
	        config = _this.configs[configIdx]; // Doing delay here instead of setTimeout is one async worry less
	
	        if (config.delay && now$1 - _this.startTime < config.delay) {
	          isDone = false;
	          continue;
	        }
	
	        for (valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
	          animation = config.animatedValues[valIdx];
	          position = animation.lastPosition;
	          from = config.fromValues[valIdx];
	          tracked = config.parent.track && config.parent.track.getPayload(valIdx);
	          to = tracked ? tracked.getValue() : config.toValues[valIdx]; // If an animation is done, skip, until all of them conclude
	
	          if (animation.done) continue; // Break animation when animation is immediate or string values are involved
	
	          if (config.immediate || typeof from === 'string' || typeof to === 'string') {
	            animation.updateValue(to);
	            animation.done = true;
	            continue;
	          } else noChange = false;
	
	          if (config.duration) {
	            position = from + config.easing((now$1 - _this.startTime - config.delay) / config.duration) * (to - from);
	            endOfAnimation = now$1 >= _this.startTime + config.delay + config.duration;
	          } else {
	            lastTime = animation.lastTime !== void 0 ? animation.lastTime : now$1;
	            velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.
	
	            if (now$1 > lastTime + 64) lastTime = now$1; // http://gafferongames.com/game-physics/fix-your-timestep/
	
	            numSteps = Math.floor(now$1 - lastTime);
	
	            for (stepIdx = 0; stepIdx < numSteps; ++stepIdx) {
	              force = -config.tension * (position - to);
	              damping = -config.friction * velocity;
	              acceleration = (force + damping) / config.mass;
	              velocity = velocity + acceleration * 1 / 1000;
	              position = position + velocity * 1 / 1000;
	            } // Conditions for stopping the spring animation
	
	
	            isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
	            isVelocity = Math.abs(velocity) <= config.precision;
	            isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
	            endOfAnimation = isOvershooting || isVelocity && isDisplacement;
	            animation.lastVelocity = velocity;
	            animation.lastTime = now$1;
	          } // Trails aren't done until their parents conclude
	
	
	          if (config.parent.track && !tracked.done) endOfAnimation = false;
	
	          if (endOfAnimation) {
	            // Ensure that we end up with a round value
	            if (animation.value !== to) position = to;
	            animation.done = true;
	          } else isDone = false;
	
	          animation.updateValue(position);
	          animation.lastPosition = position;
	        } // Keep track of updated values only when necessary
	
	
	        if (_this.props.onFrame || !_this.props.native) _this.animatedProps[config.name] = config.interpolation.getValue();
	      } // Update callbacks in the end of the frame
	
	
	      if (_this.props.onFrame || !_this.props.native) {
	        if (!_this.props.native && _this.onUpdate) _this.onUpdate();
	        if (_this.props.onFrame) _this.props.onFrame(_this.animatedProps);
	      } // Either call onEnd or next frame
	
	
	      if (isDone) return _this.debouncedOnEnd({
	        finished: true,
	        noChange: noChange
	      });
	      _this.frame = requestFrame(_this.raf);
	    };
	
	    this.dependents = new Set();
	    this.isActive = false;
	    this.hasChanged = false;
	    this.props = {};
	    this.merged = {};
	    this.animations = {};
	    this.interpolations = {};
	    this.animatedProps = {};
	    this.configs = [];
	    this.frame = undefined;
	    this.startTime = undefined;
	    this.lastTime = undefined;
	    this.update(_extends({}, props, _config));
	  }
	  /**
	   * props: to: { ... }
	   *
	   *  { name: value }             pairs
	   *  { name: AnimatedValue() }   animated values
	   *  { name: [1,2,3] }           plain numeric arrays
	   *  { name: AnimatedArray() }   animated arrays
	   *
	   * Plain values can be:
	   *
	   *  123                         Numbers
	   *  "hello"                     Strings
	   *  "#3d4d5d" ...               Colors (rga, rgba, hex, plain names)
	   *  "something 12 something"    Interpolation patterns with numbers in them
	   *
	   * Additionally, springs are allowed to "attach" to another AnimationController, fetching the
	   * values from there, if present.
	   */
	
	
	  var _proto = Controller.prototype;
	
	  _proto.update = function update(props) {
	    var _this2 = this;
	
	    this.props = _extends({}, this.props, props);
	
	    var _ref = this.props.interpolateTo ? interpolateTo(this.props) : this.props,
	        _ref$from = _ref.from,
	        from = _ref$from === void 0 ? {} : _ref$from,
	        _ref$to = _ref.to,
	        to = _ref$to === void 0 ? {} : _ref$to,
	        _ref$config = _ref.config,
	        config = _ref$config === void 0 ? {} : _ref$config,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === void 0 ? 0 : _ref$delay,
	        reverse = _ref.reverse,
	        attach = _ref.attach,
	        reset = _ref.reset,
	        immediate = _ref.immediate,
	        native = _ref.native,
	        onFrame = _ref.onFrame,
	        track = _ref.track,
	        autoStart = _ref.autoStart; // Reverse values when requested
	
	
	    if (reverse) {
	      var _ref2 = [to, from];
	      from = _ref2[0];
	      to = _ref2[1];
	    }
	
	    this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring
	
	    var target = attach && attach(this); // Reset merged props when necessary
	
	    var extra = reset ? {} : this.merged; // This will collect all props that were ever set
	
	    this.merged = _extends({}, from, extra, to); // Reduces input { name: value } pairs into animated values
	
	    this.animations = Object.entries(this.merged).reduce(function (acc, _ref3, i) {
	      var name = _ref3[0],
	          value = _ref3[1];
	      // Issue cached entries, except on reset
	      var entry = !reset && acc[name] || {}; // Attach allows a spring to fetch its values elsewhere
	
	      var _value = value,
	          _entry;
	
	      if (target && target.animations[name]) {
	        _entry = target.animations[name];
	        value = _entry.parent;
	      } // Figure out what the value is supposed to be
	
	
	      var isArray, isString, isNumber, isInterpolation;
	      var isAnimated = value instanceof Animated;
	
	      if (!isAnimated) {
	        isArray = Array.isArray(value);
	        isNumber = typeof value === 'number';
	        isString = typeof value === 'string' && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
	        isInterpolation = !isNumber && !isString && !isArray;
	      } // Carry actual values (including animated) in order to change detect
	
	
	      var changes = isAnimated ? value.getPayload() : value; // Detect changes, animated values will be checked in the raf-loop
	
	      if (isAnimated || !shallowEqual(entry.changes, changes)) {
	        var _extends2;
	
	        _this2.hasChanged = true;
	        var parent, interpolation$$1;
	
	        var _from = from[name] !== void 0 ? from[name] : value;
	
	        var _config2 = callProp(config, name);
	
	        if (isAnimated) {
	          // We end up here if the value we're shifting to is an animated value or array
	          parent = entry.parent || new value.constructor(value.getValue());
	          interpolation$$1 = entry.interpolation || parent; // In the next step we're going to check if that value is interpolated
	
	          if (_entry && _entry.interpolation.calc) {
	            var _config3 = {
	              output: [interpolation$$1.calc ? interpolation$$1.calc(parent.value) : _entry.interpolation.calc(0), _value]
	            };
	            if (interpolation$$1.calc) interpolation$$1.updateConfig(_config3);else interpolation$$1 = parent.interpolate(_config3);
	            parent.value = 0;
	          }
	        } else if (isNumber || isString) {
	          parent = interpolation$$1 = entry.parent || new AnimatedValue(_from);
	        } else if (isArray) {
	          parent = interpolation$$1 = entry.parent || new AnimatedArray(_from);
	        } else if (isInterpolation) {
	          // Deal with interpolations
	          var prev = entry.interpolation && entry.interpolation.calc(entry.parent.value); // Interpolations are not addaptive, start with 0
	
	          if (entry.parent) {
	            parent = entry.parent;
	            parent.value = 0;
	          } else parent = new AnimatedValue(0); // Map from-to on a scale between 0-1
	
	
	          var range = {
	            output: [prev !== void 0 ? prev : _from, value]
	          };
	
	          if (entry.interpolation) {
	            interpolation$$1 = entry.interpolation;
	            entry.interpolation.updateConfig(range);
	          } else interpolation$$1 = parent.interpolate(range); // And stop at 1
	
	
	          value = 1;
	        }
	
	        parent.controller = _this2;
	        if (isAnimated && value.controller !== _this2) value.controller.dependents.add(_this2);
	        parent.track = isAnimated ? value : undefined; // Set immediate values
	
	        if (callProp(immediate, name)) parent.value = value; // Map output values to an array so reading out is easier later on
	
	        var animatedValues = toArray(parent.getPayload());
	        var fromValues = toArray(parent.getValue());
	        var toValues = toArray(isAnimated ? value.getValue() : value); // Reset animated values
	
	        animatedValues.forEach(function (value) {
	          return value.prepare(_this2);
	        });
	        return _extends({}, acc, (_extends2 = {}, _extends2[name] = _extends({}, entry, {
	          name: name,
	          parent: parent,
	          // The animated object on which the update-cb is called
	          interpolation: interpolation$$1,
	          // The parents interpolation, if any. If not it refers to the parent
	          animatedValues: animatedValues,
	          // An array of all animated values taking part in this op
	          fromValues: fromValues,
	          // Raw/numerical start-state values
	          toValues: toValues,
	          // Raw/numerical/end-state values
	          changes: changes,
	          immediate: callProp(immediate, name),
	          delay: withDefault(_config2.delay, delay || 0),
	          initialVelocity: withDefault(_config2.velocity, 0),
	          clamp: withDefault(_config2.clamp, false),
	          precision: withDefault(_config2.precision, 0.01),
	          tension: withDefault(_config2.tension, 170),
	          friction: withDefault(_config2.friction, 26),
	          mass: withDefault(_config2.mass, 1),
	          duration: withDefault(_config2.duration, 0),
	          easing: withDefault(_config2.easing, function (t) {
	            return t;
	          })
	        }), _extends2));
	      } else return acc;
	    }, this.animations);
	
	    if (this.hasChanged) {
	      this.configs = getValues$1(this.animations);
	      this.animatedProps = {};
	      this.interpolations = {};
	
	      for (var key in this.animations) {
	        this.interpolations[key] = this.animations[key].interpolation;
	        this.animatedProps[key] = this.animations[key].interpolation.getValue();
	      }
	    }
	
	    for (var _len = arguments.length, start = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      start[_key - 1] = arguments[_key];
	    }
	
	    if (autoStart || start.length) this.start.apply(this, start);
	    return this.getValues();
	  };
	
	  _proto.start = function start(onEnd, onUpdate) {
	    this.startTime = now();
	    if (this.isActive) this.stop();
	    this.isActive = true;
	    this.onEnd = typeof onEnd === 'function' && onEnd;
	    this.onUpdate = onUpdate;
	    if (this.props.onStart) this.props.onStart(); // Start RAF loop
	
	    this.frame = requestFrame(this.raf); // Call dependent controllers
	
	    if (this.props.track) {
	      for (var _iterator = this.dependents, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref4;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref4 = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref4 = _i.value;
	        }
	
	        var controller = _ref4;
	        controller.update(_extends({}, controller.props, controller.merged), true);
	      }
	    }
	  };
	
	  _proto.stop = function stop(finished) {
	    if (finished === void 0) {
	      finished = false;
	    }
	
	    config = undefined;
	    animation = undefined;
	    from = undefined;
	    tracked = undefined;
	    to = undefined; // Reset collected changes since the animation has been stopped cold turkey
	
	    if (finished) getValues$1(this.animations).forEach(function (a) {
	      return a.changes = undefined;
	    });
	    this.isActive = false;
	    cancelFrame(this.frame);
	    this.debouncedOnEnd({
	      finished: finished
	    });
	  };
	
	  _proto.debouncedOnEnd = function debouncedOnEnd(result) {
	    this.isActive = false;
	    var onEnd = this.onEnd;
	    this.onEnd = null;
	    onEnd && onEnd(result);
	  };
	
	  return Controller;
	}();
	
	function createAnimatedComponent(Component) {
	  var AnimatedComponent =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(AnimatedComponent, _React$Component);
	
	    function AnimatedComponent(props) {
	      var _this;
	
	      _this = _React$Component.call(this) || this;
	
	      _this.callback = function () {
	        if (_this.node) {
	          var didUpdate = applyAnimatedValues.fn(_this.node, _this.propsAnimated.getAnimatedValue(), _assertThisInitialized(_assertThisInitialized(_this)));
	          if (didUpdate === false) _this.forceUpdate();
	        }
	      };
	
	      _this.attachProps(props);
	
	      return _this;
	    }
	
	    var _proto = AnimatedComponent.prototype;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.propsAnimated && this.propsAnimated.detach();
	    };
	
	    _proto.setNativeProps = function setNativeProps(props) {
	      var didUpdate = applyAnimatedValues.fn(this.node, props, this);
	      if (didUpdate === false) this.forceUpdate();
	    }; // The system is best designed when setNativeProps is implemented. It is
	    // able to avoid re-rendering and directly set the attributes that
	    // changed. However, setNativeProps can only be implemented on leaf
	    // native components. If you want to animate a composite component, you
	    // need to re-render it. In this case, we have a fallback that uses
	    // forceUpdate.
	
	
	    _proto.attachProps = function attachProps(_ref) {
	      var forwardRef = _ref.forwardRef,
	          nextProps = _objectWithoutPropertiesLoose(_ref, ["forwardRef"]);
	
	      var oldPropsAnimated = this.propsAnimated;
	      this.propsAnimated = new AnimatedProps(nextProps, this.callback); // When you call detach, it removes the element from the parent list
	      // of children. If it goes to 0, then the parent also detaches itself
	      // and so on.
	      // An optimization is to attach the new elements and THEN detach the old
	      // ones instead of detaching and THEN attaching.
	      // This way the intermediate state isn't to go to 0 and trigger
	      // this expensive recursive detaching to then re-attach everything on
	      // the very next operation.
	
	      oldPropsAnimated && oldPropsAnimated.detach();
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
	      var style = props.style,
	          nextProps = _objectWithoutPropertiesLoose(props, ["style"]);
	
	      var _this$props = this.props,
	          currentStyle = _this$props.style,
	          currentProps = _objectWithoutPropertiesLoose(_this$props, ["style"]);
	
	      if (!shallowEqual(currentProps, nextProps) || !shallowEqual(currentStyle, style)) {
	        this.attachProps(props);
	        return true;
	      }
	
	      return false;
	    };
	
	    _proto.render = function render() {
	      var _this2 = this;
	
	      var forwardRef = this.props.forwardRef;
	
	      var _this$propsAnimated$g = this.propsAnimated.getValue(),
	          scrollTop = _this$propsAnimated$g.scrollTop,
	          scrollLeft = _this$propsAnimated$g.scrollLeft,
	          animatedProps = _objectWithoutPropertiesLoose(_this$propsAnimated$g, ["scrollTop", "scrollLeft"]);
	
	      return React.createElement(Component, _extends({}, animatedProps, {
	        ref: function ref(node) {
	          return _this2.node = handleRef(node, _this2.props.forwardRef);
	        }
	      }));
	    };
	
	    return AnimatedComponent;
	  }(React.Component);
	
	  return React.forwardRef(function (props, ref) {
	    return React.createElement(AnimatedComponent, _extends({}, props, {
	      forwardRef: ref
	    }));
	  });
	}
	
	var config$1 = {
	  default: {
	    tension: 170,
	    friction: 26
	  },
	  gentle: {
	    tension: 120,
	    friction: 14
	  },
	  wobbly: {
	    tension: 180,
	    friction: 12
	  },
	  stiff: {
	    tension: 210,
	    friction: 20
	  },
	  slow: {
	    tension: 280,
	    friction: 60
	  },
	  molasses: {
	    tension: 280,
	    friction: 120
	  }
	};
	
	var v = React.version.split('.');
	
	if (false) {
	  console.warn('Please consider upgrading to react/react-dom 16.4.x or higher! Older React versions break getDerivedStateFromProps, see https://github.com/facebook/react/issues/12898');
	}
	
	var Spring =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Spring, _React$Component);
	
	  function Spring() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      lastProps: {
	        from: {},
	        to: {}
	      },
	      propsChanged: false,
	      internal: false
	    };
	    _this.controller = new Controller(null, null);
	    _this.didUpdate = false;
	    _this.didInject = false;
	    _this.finished = true;
	
	    _this.start = function () {
	      _this.finished = false;
	      var wasMounted = _this.mounted;
	
	      _this.controller.start(function (props) {
	        return _this.finish(_extends({}, props, {
	          wasMounted: wasMounted
	        }));
	      }, _this.update);
	    };
	
	    _this.stop = function () {
	      return _this.controller.stop(true);
	    };
	
	    _this.update = function () {
	      return _this.setState({
	        internal: true
	      });
	    };
	
	    _this.finish = function (_ref) {
	      var finished = _ref.finished,
	          noChange = _ref.noChange,
	          wasMounted = _ref.wasMounted;
	      _this.finished = true;
	
	      if (_this.mounted && finished) {
	        // Only call onRest if either we *were* mounted, or when there were changes
	        if (_this.props.onRest && (wasMounted || !noChange)) _this.props.onRest(_this.controller.merged); // Restore end-state
	
	        if (_this.didInject) {
	          _this.afterInject = convertValues(_this.props);
	
	          _this.setState({
	            internal: true
	          });
	        } // If we have an inject or values to apply after the animation we ping here
	
	
	        if (_this.mounted && (_this.didInject || _this.props.after)) _this.setState({
	          internal: true
	        });
	        _this.didInject = false;
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = Spring.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    // componentDidUpdate isn't called on mount, we call it here to start animating
	    this.componentDidUpdate();
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    // Stop all ongoing animtions
	    this.mounted = false;
	    this.stop();
	  };
	
	  Spring.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
	    var internal = _ref2.internal,
	        lastProps = _ref2.lastProps;
	    // The following is a test against props that could alter the animation
	    var from = props.from,
	        to = props.to,
	        reset = props.reset,
	        force = props.force;
	    var propsChanged = !shallowEqual(to, lastProps.to) || !shallowEqual(from, lastProps.from) || reset && !internal || force && !internal;
	    return {
	      propsChanged: propsChanged,
	      lastProps: props,
	      internal: false
	    };
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        native = _this$props.native,
	        onFrame = _this$props.onFrame,
	        children = _this$props.children;
	    var propsChanged = this.state.propsChanged; // Inject phase -----------------------------------------------------------
	    // Handle injected frames, for instance targets/web/fix-auto
	    // An inject will return an intermediary React node which measures itself out
	    // .. and returns a callback when the values sought after are ready, usually "auto".
	
	    if (this.props.inject && propsChanged && !this.injectProps) {
	      var frame = this.props.inject(this.props, function (injectProps) {
	        // The inject frame has rendered, now let's update animations...
	        _this2.injectProps = injectProps;
	
	        _this2.setState({
	          internal: true
	        });
	      }); // Render out injected frame
	
	      if (frame) return frame;
	    } // Update phase -----------------------------------------------------------
	
	
	    if (this.injectProps || propsChanged) {
	      // We can potentially cause setState, but we're inside render, the flag prevents that
	      this.didInject = false; // Update animations, this turns from/to props into AnimatedValues
	      // An update can occur on injected props, or when own-props have changed.
	
	      if (this.injectProps) {
	        this.controller.update(this.injectProps); // didInject is needed, because there will be a 3rd stage, where the original values
	        // .. will be restored after the animation is finished. When someone animates towards
	        // .. "auto", the end-result should be "auto", not "1999px", which would block nested
	        // .. height/width changes.
	
	        this.didInject = true;
	      } else if (propsChanged) this.controller.update(this.props); // Flag an update that occured, componentDidUpdate will start the animation later on
	
	
	      this.didUpdate = true;
	      this.afterInject = undefined;
	      this.injectProps = undefined;
	    } // Render phase -----------------------------------------------------------
	    // Render out raw values or AnimatedValues depending on "native"
	
	
	    var values = _extends({}, this.controller.getValues(), this.afterInject);
	
	    if (this.finished) values = _extends({}, values, this.props.after);
	    return values && Object.keys(values).length ? children(values) : null;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    // The animation has to start *after* render, since at that point the scene
	    // .. graph should be established, so we do it here. Unfortunatelly, non-native
	    // .. animations as well as "auto"-injects call forceUpdate, so it's causing a loop.
	    // .. didUpdate prevents that as it gets set only on prop changes.
	    if (this.didUpdate) this.start();
	    this.didUpdate = false;
	  };
	
	  return Spring;
	}(React.Component);
	
	Spring.defaultProps = {
	  from: {},
	  to: {},
	  config: config$1.default,
	  native: false,
	  immediate: false,
	  reset: false,
	  force: false,
	  inject: bugfixes
	};
	function useSpring(_ref3) {
	  var onRest = _ref3.onRest,
	      props = _objectWithoutPropertiesLoose(_ref3, ["onRest"]);
	
	  var _React$useState = React.useState(function () {
	    return {
	      ctrl: new Controller(props),
	      onHalt: function onHalt(_ref4) {
	        var finished = _ref4.finished;
	        return finished && onRest && onRest(ctrl.merged);
	      }
	    };
	  }),
	      _React$useState$ = _React$useState[0],
	      ctrl = _React$useState$.ctrl,
	      onHalt = _React$useState$.onHalt;
	
	  React.useEffect(function () {
	    return void ctrl.update(props, onHalt);
	  });
	  return [ctrl.getValues(), function (props) {
	    return ctrl.update(props, onHalt);
	  }];
	}
	
	var Trail =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(Trail, _React$PureComponent);
	
	  function Trail() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
	    _this.first = true;
	    _this.instances = new Set();
	
	    _this.hook = function (instance, index, length, reverse) {
	      // Add instance to set
	      _this.instances.add(instance); // Return undefined on the first index and from then on the previous instance
	
	
	      if (reverse ? index === length - 1 : index === 0) return undefined;else return Array.from(_this.instances)[reverse ? index + 1 : index - 1];
	    };
	
	    return _this;
	  }
	
	  var _proto = Trail.prototype;
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        items = _this$props.items,
	        _children = _this$props.children,
	        _this$props$from = _this$props.from,
	        from = _this$props$from === void 0 ? {} : _this$props$from,
	        initial = _this$props.initial,
	        reverse = _this$props.reverse,
	        keys = _this$props.keys,
	        delay = _this$props.delay,
	        onRest = _this$props.onRest,
	        props = _objectWithoutPropertiesLoose(_this$props, ["items", "children", "from", "initial", "reverse", "keys", "delay", "onRest"]);
	
	    var array = toArray(items);
	    return toArray(array).map(function (item, i) {
	      return React.createElement(Spring, _extends({
	        onRest: i === 0 ? onRest : null,
	        key: typeof keys === 'function' ? keys(item) : toArray(keys)[i],
	        from: _this2.first && initial !== void 0 ? initial || {} : from
	      }, props, {
	        delay: i === 0 && delay || undefined,
	        attach: function attach(instance) {
	          return _this2.hook(instance, i, array.length, reverse);
	        },
	        children: function children(props) {
	          var child = _children(item, i);
	
	          return child ? child(props) : null;
	        }
	      }));
	    });
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    this.first = false;
	    if (prevProps.items !== this.props.items) this.instances.clear();
	  };
	
	  return Trail;
	}(React.PureComponent);
	
	Trail.defaultProps = {
	  keys: function keys(item) {
	    return item;
	  }
	};
	
	var DEFAULT = '__default';
	
	var KeyframesImpl =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(KeyframesImpl, _React$PureComponent);
	
	  function KeyframesImpl() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
	    _this.guid = 0;
	    _this.state = {
	      props: {},
	      oldProps: {},
	      resolve: function resolve() {
	        return null;
	      },
	      last: true,
	      index: 0
	    };
	
	    _this.next = function (props, last, index) {
	      if (last === void 0) {
	        last = true;
	      }
	
	      if (index === void 0) {
	        index = 0;
	      }
	
	      _this.running = true;
	      return new Promise(function (resolve) {
	        _this.mounted && _this.setState(function (state) {
	          return {
	            props: props,
	            oldProps: _extends({}, _this.state.props),
	            resolve: resolve,
	            last: last,
	            index: index
	          };
	        }, function () {
	          return _this.running = false;
	        });
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = KeyframesImpl.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.componentDidUpdate({});
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(previous) {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        states = _this$props.states,
	        f = _this$props.filter,
	        state = _this$props.state;
	
	    if (previous.state !== this.props.state || this.props.reset && !this.running || !shallowEqual(states[state], previous.states[previous.state])) {
	      if (states && state && states[state]) {
	        (function () {
	          var localId = ++_this2.guid;
	          var slots = states[state];
	
	          if (slots) {
	            if (Array.isArray(slots)) {
	              var q = Promise.resolve();
	
	              var _loop = function _loop(i) {
	                var index = i;
	                var slot = slots[index];
	                var last = index === slots.length - 1;
	                q = q.then(function () {
	                  return localId === _this2.guid && _this2.next(f(slot), last, index);
	                });
	              };
	
	              for (var i = 0; i < slots.length; i++) {
	                _loop(i);
	              }
	            } else if (typeof slots === 'function') {
	              var index = 0;
	              slots( // next
	              function (props, last) {
	                if (last === void 0) {
	                  last = false;
	                }
	
	                return localId === _this2.guid && _this2.next(f(props), last, index++);
	              }, // cancel
	              function () {
	                return requestFrame(function () {
	                  return _this2.instance && _this2.instance.stop();
	                });
	              }, // ownprops
	              _this2.props);
	            } else {
	              _this2.next(f(states[state]));
	            }
	          }
	        })();
	      }
	    }
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$state = this.state,
	        props = _this$state.props,
	        oldProps = _this$state.oldProps,
	        resolve = _this$state.resolve,
	        last = _this$state.last,
	        index = _this$state.index;
	    if (!props || Object.keys(props).length === 0) return null;
	
	    var _this$props2 = this.props,
	        state = _this$props2.state,
	        filter = _this$props2.filter,
	        states = _this$props2.states,
	        config$$1 = _this$props2.config,
	        Component = _this$props2.primitive,
	        _onRest = _this$props2.onRest,
	        forwardRef = _this$props2.forwardRef,
	        rest = _objectWithoutPropertiesLoose(_this$props2, ["state", "filter", "states", "config", "primitive", "onRest", "forwardRef"]); // Arrayed configs need an index to process
	
	
	    if (Array.isArray(config$$1)) config$$1 = config$$1[index];
	    return React.createElement(Component, _extends({
	      ref: function ref(_ref) {
	        return _this3.instance = handleRef(_ref, forwardRef);
	      },
	      config: config$$1
	    }, rest, props, {
	      onRest: function onRest(args) {
	        resolve(args);
	        if (_onRest && last) _onRest(args);
	      }
	    }));
	  };
	
	  return KeyframesImpl;
	}(React.PureComponent);
	
	KeyframesImpl.defaultProps = {
	  state: DEFAULT
	};
	var Keyframes = React.forwardRef(function (props, ref) {
	  return React.createElement(KeyframesImpl, _extends({}, props, {
	    forwardRef: ref
	  }));
	});
	
	Keyframes.create = function (primitive) {
	  return function (states, filter) {
	    var _states;
	
	    if (filter === void 0) {
	      filter = function filter(states) {
	        return states;
	      };
	    }
	
	    if (typeof states === 'function' || Array.isArray(states)) states = (_states = {}, _states[DEFAULT] = states, _states);
	    return function (props) {
	      return React.createElement(KeyframesImpl, _extends({
	        primitive: primitive,
	        states: states,
	        filter: filter
	      }, props));
	    };
	  };
	};
	
	Keyframes.Spring = function (states) {
	  return Keyframes.create(Spring)(states, interpolateTo);
	};
	
	Keyframes.Trail = function (states) {
	  return Keyframes.create(Trail)(states, interpolateTo);
	};
	
	var guid = 0;
	
	var get = function get(props) {
	  var items = props.items,
	      keys = props.keys,
	      rest = _objectWithoutPropertiesLoose(props, ["items", "keys"]);
	
	  items = toArray(items !== void 0 ? items : null);
	  keys = typeof keys === 'function' ? items.map(keys) : toArray(keys); // Make sure numeric keys are interpreted as Strings (5 !== "5")
	
	  return _extends({
	    items: items,
	    keys: keys.map(function (key) {
	      return String(key);
	    })
	  }, rest);
	};
	
	var Transition =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(Transition, _React$PureComponent);
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  function Transition(prevProps) {
	    var _this;
	
	    _this = _React$PureComponent.call(this, prevProps) || this;
	
	    _this.destroyItem = function (item, key, state) {
	      return function (values) {
	        var _this$props = _this.props,
	            onRest = _this$props.onRest,
	            onDestroyed = _this$props.onDestroyed;
	
	        if (_this.mounted) {
	          onDestroyed && onDestroyed(item);
	
	          _this.setState(function (_ref) {
	            var deleted = _ref.deleted;
	            return {
	              deleted: deleted.filter(function (t) {
	                return t.key !== key;
	              })
	            };
	          });
	
	          onRest && onRest(item, state, values);
	        }
	      };
	    };
	
	    _this.state = {
	      first: true,
	      transitions: [],
	      current: {},
	      deleted: [],
	      prevProps: prevProps
	    };
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
	    var first = _ref2.first,
	        prevProps = _ref2.prevProps,
	        state = _objectWithoutPropertiesLoose(_ref2, ["first", "prevProps"]);
	
	    var _get = get(props),
	        items = _get.items,
	        keys = _get.keys,
	        initial = _get.initial,
	        from = _get.from,
	        enter = _get.enter,
	        leave = _get.leave,
	        update = _get.update,
	        _get$trail = _get.trail,
	        trail = _get$trail === void 0 ? 0 : _get$trail,
	        unique = _get.unique,
	        config$$1 = _get.config;
	
	    var _get2 = get(prevProps),
	        _keys = _get2.keys,
	        _items = _get2.items;
	
	    var current = _extends({}, state.current);
	
	    var deleted = state.deleted.concat(); // Compare next keys with current keys
	
	    var currentKeys = Object.keys(current);
	    var currentSet = new Set(currentKeys);
	    var nextSet = new Set(keys);
	    var added = keys.filter(function (item) {
	      return !currentSet.has(item);
	    });
	    var removed = state.transitions.filter(function (item) {
	      return !item.destroyed && !nextSet.has(item.originalKey);
	    }).map(function (i) {
	      return i.originalKey;
	    });
	    var updated = keys.filter(function (item) {
	      return currentSet.has(item);
	    });
	    var delay = 0;
	    added.forEach(function (key) {
	      // In unique mode, remove fading out transitions if their key comes in again
	      if (unique && deleted.find(function (d) {
	        return d.originalKey === key;
	      })) deleted = deleted.filter(function (t) {
	        return t.originalKey !== key;
	      });
	      var keyIndex = keys.indexOf(key);
	      var item = items[keyIndex];
	      var state = 'enter';
	      current[key] = {
	        state: state,
	        originalKey: key,
	        key: unique ? String(key) : guid++,
	        item: item,
	        trail: delay = delay + trail,
	        config: callProp(config$$1, item, state),
	        from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
	        to: callProp(enter, item)
	      };
	    });
	    removed.forEach(function (key) {
	      var keyIndex = _keys.indexOf(key);
	
	      var item = _items[keyIndex];
	      var state = 'leave';
	      deleted.push(_extends({}, current[key], {
	        state: state,
	        destroyed: true,
	        left: _keys[Math.max(0, keyIndex - 1)],
	        right: _keys[Math.min(_keys.length, keyIndex + 1)],
	        trail: delay = delay + trail,
	        config: callProp(config$$1, item, state),
	        to: callProp(leave, item)
	      }));
	      delete current[key];
	    });
	    updated.forEach(function (key) {
	      var keyIndex = keys.indexOf(key);
	      var item = items[keyIndex];
	      var state = 'update';
	      current[key] = _extends({}, current[key], {
	        item: item,
	        state: state,
	        trail: delay = delay + trail,
	        config: callProp(config$$1, item, state),
	        to: callProp(update, item)
	      });
	    }); // This tries to restore order for deleted items by finding their last known siblings
	
	    var out = keys.map(function (key) {
	      return current[key];
	    });
	    deleted.forEach(function (_ref3) {
	      var left = _ref3.left,
	          right = _ref3.right,
	          transition = _objectWithoutPropertiesLoose(_ref3, ["left", "right"]);
	
	      var pos; // Was it the element on the left, if yes, move there ...
	
	      if ((pos = out.findIndex(function (t) {
	        return t.originalKey === left;
	      })) !== -1) pos += 1; // Or how about the element on the right ...
	
	      if (pos === -1) pos = out.findIndex(function (t) {
	        return t.originalKey === right;
	      }); // Maybe we'll find it in the list of deleted items
	
	      if (pos === -1) pos = deleted.findIndex(function (t) {
	        return t.originalKey === left;
	      }); // Checking right side as well
	
	      if (pos === -1) pos = deleted.findIndex(function (t) {
	        return t.originalKey === right;
	      }); // And if nothing else helps, move it to the start ¯\_(ツ)_/¯
	
	      pos = Math.max(0, pos);
	      out = out.slice(0, pos).concat([transition], out.slice(pos));
	    });
	    return {
	      first: first && added.length === 0,
	      transitions: out,
	      current: current,
	      deleted: deleted,
	      prevProps: props
	    };
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props2 = this.props,
	        initial = _this$props2.initial,
	        _this$props2$from = _this$props2.from,
	        _this$props2$enter = _this$props2.enter,
	        _this$props2$leave = _this$props2.leave,
	        _this$props2$update = _this$props2.update,
	        onDestroyed = _this$props2.onDestroyed,
	        keys = _this$props2.keys,
	        items = _this$props2.items,
	        onFrame = _this$props2.onFrame,
	        onRest = _this$props2.onRest,
	        onStart = _this$props2.onStart,
	        trail = _this$props2.trail,
	        config$$1 = _this$props2.config,
	        _children = _this$props2.children,
	        unique = _this$props2.unique,
	        reset = _this$props2.reset,
	        extra = _objectWithoutPropertiesLoose(_this$props2, ["initial", "from", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "trail", "config", "children", "unique", "reset"]);
	
	    return this.state.transitions.map(function (_ref4, i) {
	      var _ref5;
	
	      var state = _ref4.state,
	          key = _ref4.key,
	          item = _ref4.item,
	          from = _ref4.from,
	          to = _ref4.to,
	          trail = _ref4.trail,
	          config$$1 = _ref4.config,
	          destroyed = _ref4.destroyed;
	      return React.createElement(Keyframes, _extends({
	        reset: reset && state === 'enter',
	        primitive: Spring,
	        state: state,
	        filter: interpolateTo,
	        states: (_ref5 = {}, _ref5[state] = to, _ref5),
	        key: key,
	        onRest: destroyed ? _this2.destroyItem(item, key, state) : onRest && function (values) {
	          return onRest(item, state, values);
	        },
	        onStart: onStart && function () {
	          return onStart(item, state);
	        },
	        onFrame: onFrame && function (values) {
	          return onFrame(item, state, values);
	        },
	        delay: trail,
	        config: config$$1
	      }, extra, {
	        from: from,
	        children: function children(props) {
	          var child = _children(item, state, i);
	
	          return child ? child(props) : null;
	        }
	      }));
	    });
	  };
	
	  return Transition;
	}(React.PureComponent);
	
	Transition.defaultProps = {
	  keys: function keys(item) {
	    return item;
	  },
	  unique: false,
	  reset: false
	};
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	var extendedAnimated = domElements.reduce(function (acc, element) {
	  acc[element] = createAnimatedComponent(element);
	  return acc;
	}, createAnimatedComponent);
	
	exports.Spring = Spring;
	exports.Keyframes = Keyframes;
	exports.Transition = Transition;
	exports.Trail = Trail;
	exports.Controller = Controller;
	exports.config = config$1;
	exports.animated = extendedAnimated;
	exports.interpolate = interpolate$1;
	exports.Globals = Globals;
	exports.useSpring = useSpring;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(178);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reveal = function (_Component) {
	  _inherits(Reveal, _Component);
	
	  function Reveal() {
	    _classCallCheck(this, Reveal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.onEnter = function (_ref) {
	      var previousPosition = _ref.previousPosition,
	          currentPosition = _ref.currentPosition,
	          event = _ref.event;
	
	      if (previousPosition === _reactWaypoint2.default.below) {
	        _this.setState({
	          isInView: true
	        });
	      }
	    };
	
	    _this.onLeave = function (_ref2) {
	      var previousPosition = _ref2.previousPosition,
	          currentPosition = _ref2.currentPosition,
	          event = _ref2.event;
	
	      if (currentPosition === _reactWaypoint2.default.below) {
	        _this.setState({
	          isInView: false
	        });
	      }
	    };
	
	    _this.state = {
	      isInView: false
	    };
	    return _this;
	  }
	
	  Reveal.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      renrender: window.location.href
	    });
	  };
	
	  Reveal.prototype.render = function render() {
	    var _this2 = this;
	
	    var children = _react2.default.Children.map(this.props.children, function (child) {
	      return _react2.default.cloneElement(child, {
	        isInView: _this2.state.isInView
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { key: this.props.key },
	      _react2.default.createElement(_reactWaypoint2.default, { onEnter: this.onEnter, onLeave: this.onLeave }),
	      children
	    );
	  };
	
	  return Reveal;
	}(_react.Component);
	
	exports.default = Reveal;
	module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceBreakWithSpace = exports.checkActivePage = exports.returnDepartmentNodeTitle = exports.returnDepartmentTitle = exports.returnSectionBoolean = exports.detectSection = exports.stripHTML = exports.capitalizeFirstLetter = exports.fullYear = exports.convertDate = exports.showHeaderColor = exports.displayHeader = exports.chunk = exports.filterPosts = exports.filterProjects = exports.isMobileDevice = exports.detectBrowser = exports.resetScrollPos = exports.scrollLockOff = exports.scrollLockOn = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _string_decoder = __webpack_require__(874);
	
	var scrollLockOn = exports.scrollLockOn = function scrollLockOn() {
	  document.getElementsByTagName('html')[0].classList.add('no-scroll');
	};
	
	var scrollLockOff = exports.scrollLockOff = function scrollLockOff() {
	  document.getElementsByTagName('html')[0].classList.remove('no-scroll');
	};
	
	var resetScrollPos = exports.resetScrollPos = function resetScrollPos() {
	  if (typeof window !== 'undefined') {
	    setTimeout(function () {
	      window.scrollTo(0, -40);
	    }, 500);
	  }
	};
	
	var detectBrowser = exports.detectBrowser = function detectBrowser() {
	  if (typeof window !== 'undefined') {
	    var ua = window.navigator.userAgent;
	    var msie = ua.indexOf('MSIE');
	    var trident = ua.indexOf('Trident/');
	    var iPhone = !!ua.match(/iPhone/i);
	    var iPad = ua.match(/iPad/i) != null;
	    var webkit = !!ua.match(/WebKit/i);
	    var iOSSafari = iPhone && webkit && !ua.match(/CriOS/i);
	
	    if (msie !== -1 || trident !== -1) {
	      return 'IE';
	    } else if (iOSSafari) {
	      return 'iOS';
	    } else if (iPad) {
	      return 'iPad';
	    } else {
	      return false;
	    }
	  }
	};
	
	var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
	  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
	};
	
	var filterProjects = exports.filterProjects = function filterProjects(allProjects, projectList) {
	  var projects = allProjects.filter(function (project, index) {
	    return projectList.indexOf(project.node.slug) != -1;
	  });
	  return projects;
	};
	
	var filterPosts = exports.filterPosts = function filterPosts(allPosts, filterName) {
	  var posts = allPosts.filter(function (post) {
	    return post.node.categories[0].name === filterName;
	  });
	  return posts;
	};
	
	var chunk = exports.chunk = function chunk(array, size) {
	  var chunked_arr = [];
	  if (typeof array === 'undefined' || array.length === 0) {
	    return chunked_arr;
	  }
	  var index = 0;
	  while (index < array.length) {
	    chunked_arr.push(array.slice(index, size + index));
	    index += size;
	  }
	  return chunked_arr;
	};
	
	var updateLocationName = function updateLocationName(location) {
	  var locationSplit = location.split('/');
	  var locationFiltered = locationSplit.filter(function (value) {
	    if (value !== '') {
	      return value;
	    }
	  });
	  return locationFiltered;
	};
	
	var displayHeader = exports.displayHeader = function displayHeader(headerLocation) {
	  var locationSlashless = headerLocation.split('/')[1];
	  var locationDownload = headerLocation.split('/')[2];
	  if (locationDownload === 'download') {
	    return true;
	  }
	  switch (locationSlashless) {
	    case 'webinar':
	      return false;
	      break;
	    default:
	      return true;
	      break;
	  }
	};
	
	var showHeaderColor = exports.showHeaderColor = function showHeaderColor(headerLocation) {
	  var locationSlashless = headerLocation.split('/')[1];
	  var location = updateLocationName(headerLocation);
	
	  if (location.length > 1) {
	    // is a sub page
	    switch (locationSlashless) {
	      case 'our-work':
	        return false;
	        break;
	      case 'capabilities':
	        return false;
	        break;
	      default:
	        break;
	    }
	    return true;
	  }
	
	  switch (locationSlashless) {
	    case 'amplify':
	      return true;
	      break;
	    case 'anniversary':
	      return true;
	      break;
	    case 'awkwardoffice':
	      return true;
	      break;
	    case 'blog':
	      return true;
	      break;
	    case 'brandwithjk':
	      return true;
	      break;
	    case 'contact':
	      return true;
	      break;
	    case 'employerbranding-webinar':
	      return true;
	      break;
	    case 'internalcomms':
	      return true;
	      break;
	    case 'happyholidays2020':
	      return true;
	      break;
	    case 'job-success':
	      return true;
	      break;
	    case 'not-found':
	      return true;
	      break;
	    case 'people':
	      return true;
	      break;
	    case 'our-work':
	      return true;
	      break;
	    case 'payment':
	      return true;
	      break;
	    case 'payment-success':
	      return true;
	      break;
	    case 'privacy-policy':
	      return true;
	      break;
	    case 'qa':
	      return true;
	    case 'site-map':
	      return true;
	      break;
	    case 'terms-of-service':
	      return true;
	      break;
	    case 'workplacebranding':
	      return true;
	      break;
	    case '13questions':
	      return true;
	      break;
	    default:
	      break;
	  }
	};
	
	var convertDate = exports.convertDate = function convertDate(date) {
	  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  var dateMod = date.substring(0, date.indexOf('T')).split('-');
	  var month = monthNames[parseInt(dateMod[1], 10) - 1];
	  var day = dateMod[2];
	  var year = dateMod[0];
	  return month + ' ' + day + ', ' + year;
	};
	
	var fullYear = exports.fullYear = function fullYear() {
	  var date = new Date();
	  return date.getFullYear();
	};
	
	var capitalizeFirstLetter = exports.capitalizeFirstLetter = function capitalizeFirstLetter(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	};
	
	var stripHTML = exports.stripHTML = function stripHTML(html) {
	  if (typeof window !== 'undefined') {
	    var tmp = document.createElement('DIV');
	    tmp.innerHTML = html;
	    return tmp.textContent || tmp.innerText;
	  }
	};
	
	var isProjectHome = function isProjectHome(state) {
	  return {
	    home: function home() {
	      if (typeof state.mappedIndex !== 'undefined' && typeof state.currentSectionIndex !== 'undefined') {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  };
	};
	
	var returnSection = function returnSection(state) {
	  return {
	    section: function section() {
	      if (state.mappedIndex + 1 === state.currentSectionIndex) {
	        return 'active';
	      } else {
	        return 'inactive';
	      }
	    }
	  };
	};
	
	var detectSection = exports.detectSection = function detectSection(mappedIndex, currentSectionIndex) {
	  var state = {
	    mappedIndex: mappedIndex,
	    currentSectionIndex: currentSectionIndex
	  };
	
	  return _extends(state, isProjectHome(state), returnSection(state));
	};
	
	var returnSectionBoolean = exports.returnSectionBoolean = function returnSectionBoolean(detectSectionFn) {
	  if (detectSectionFn() === 'active') {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	var returnDepartmentTitle = exports.returnDepartmentTitle = function returnDepartmentTitle(departments, id) {
	  return departments.filter(function (department, index) {
	    if (department.id === id) {
	      return department.title;
	    }
	  });
	};
	
	var returnDepartmentNodeTitle = exports.returnDepartmentNodeTitle = function returnDepartmentNodeTitle(departments, id) {
	  return departments.filter(function (department, index) {
	    if (department.node.wordpress_id === id) {
	      return department.node.slug;
	    }
	  });
	};
	
	var checkActivePage = exports.checkActivePage = function checkActivePage(url, styles) {
	  var defaultItem = styles.item;
	  var activeItem = [styles.item, styles.active].join(' ');
	  var urlSlashless = url.split('/')[1];
	  var locationSlashless = location.pathname.split('/')[1];
	  if (locationSlashless === urlSlashless) {
	    return activeItem;
	  } else {
	    return defaultItem;
	  }
	};
	
	var replaceBreakWithSpace = exports.replaceBreakWithSpace = function replaceBreakWithSpace(str) {
	  return str.replace(/<br\s*\/?>/gi, ' ');
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(853);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(829);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(830);
	
	var _HelmetConstants = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.5 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"row":"src-components-form----form-module---row---1Kwob","inputWrapper":"src-components-form----form-module---inputWrapper---36iK-","rowDownload":"src-components-form----form-module---rowDownload---3gFY5","inputDownload":"src-components-form----form-module---inputDownload---Upuz-","input":"src-components-form----form-module---input---DpU3c","rowTwo":"src-components-form----form-module---rowTwo---31_Ln","successMessage":"src-components-form----form-module---successMessage---12d3a"};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _projectBlurbModule = __webpack_require__(511);
	
	var _projectBlurbModule2 = _interopRequireDefault(_projectBlurbModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectBlurb = function ProjectBlurb(_ref) {
	  var blurb = _ref.blurb;
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'h5',
	      { className: _projectBlurbModule2.default.message },
	      blurb
	    )
	  );
	};
	
	ProjectBlurb.propTypes = {
	  blurb: _propTypes2.default.string
	};
	
	exports.default = ProjectBlurb;
	module.exports = exports['default'];

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderSpacer = function HeaderSpacer() {
	  return _react2.default.createElement('div', { style: { height: '103px', background: '#f0f0f2' } });
	};
	
	exports.default = HeaderSpacer;
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(156)('wks');
	var uid = __webpack_require__(159);
	var Symbol = __webpack_require__(17).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(195);
	var isBuffer = __webpack_require__(717);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n              color: ', ';\n            '], ['\n              color: ', ';\n            ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n            background: ', ';\n          '], ['\n            background: ', ';\n          ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(5);
	
	var _reactSpring = __webpack_require__(8);
	
	var _projectBreadcrumbModule = __webpack_require__(515);
	
	var _projectBreadcrumbModule2 = _interopRequireDefault(_projectBreadcrumbModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectBreadcrumb = function ProjectBreadcrumb(_ref) {
	  var preTitle = _ref.preTitle,
	      title = _ref.title,
	      color = _ref.color,
	      isHome = _ref.isHome,
	      returnSection = _ref.returnSection;
	
	  var renderAwkwardOffice = function renderAwkwardOffice() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        {
	          className: [_projectBreadcrumbModule2.default.preTitle, (0, _emotion.css)(_templateObject, color)]
	        },
	        'The Employee Experience'
	      )
	    );
	  };
	
	  var renderBlog = function renderBlog() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/blog',
	          className: [_projectBreadcrumbModule2.default.preTitle, _projectBreadcrumbModule2.default.link, (0, _emotion.css)(_templateObject, color)].join(' ')
	        },
	        'Blog'
	      )
	    );
	  };
	
	  var renderOurService = function renderOurService() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/capabilities',
	          className: [_projectBreadcrumbModule2.default.preTitle, _projectBreadcrumbModule2.default.link].join(' ')
	        },
	        'Capabilities'
	      )
	    );
	  };
	
	  var renderCareers = function renderCareers() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _projectBreadcrumbModule2.default.preTitle },
	        'Careers'
	      )
	    );
	  };
	
	  var renderSales = function renderSales() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _projectBreadcrumbModule2.default.preTitle },
	        'Project snapshots'
	      )
	    );
	  };
	
	  var renderCareer = function renderCareer() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/careers',
	          className: [_projectBreadcrumbModule2.default.preTitle, _projectBreadcrumbModule2.default.link, (0, _emotion.css)(_templateObject, color)].join(' ')
	        },
	        'Careers'
	      )
	    );
	  };
	
	  var renderInternships = function renderInternships() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/internships',
	          className: [_projectBreadcrumbModule2.default.preTitle, _projectBreadcrumbModule2.default.link, (0, _emotion.css)(_templateObject, color)].join(' ')
	        },
	        'Internships'
	      )
	    );
	  };
	
	  var renderAbout = function renderAbout() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _projectBreadcrumbModule2.default.preTitle },
	        'About Us'
	      )
	    );
	  };
	
	  var renderBranding = function renderBranding() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _projectBreadcrumbModule2.default.preTitle },
	        'Super charge your brand'
	      )
	    );
	  };
	
	  var renderOurWork = function renderOurWork() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/our-work',
	          className: [_projectBreadcrumbModule2.default.preTitle, _projectBreadcrumbModule2.default.link].join(' ')
	        },
	        'Our Work'
	      )
	    );
	  };
	
	  var renderCapabilities = function renderCapabilities() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _projectBreadcrumbModule2.default.preTitle },
	        'Capabilities'
	      )
	    );
	  };
	
	  var renderPreTitle = function renderPreTitle() {
	    switch (preTitle) {
	      case 'about':
	        return renderAbout();
	      case 'awkwardoffice':
	        return renderAwkwardOffice();
	      case 'blog':
	        return renderBlog();
	        break;
	      case 'branding':
	        return renderBranding();
	        break;
	      case 'capabilities':
	        return renderCapabilities();
	      case 'career':
	        return renderCareer();
	        break;
	      case 'careers':
	        return renderCareers();
	        break;
	      case 'internships':
	        return renderInternships();
	        break;
	      case 'our-work':
	        return renderOurWork();
	        break;
	      case 'our-service':
	        return renderOurService();
	        break;
	      case 'salesenablement':
	        return renderSales();
	        break;
	      default:
	        break;
	    }
	  };
	
	  var showTitle = function showTitle(preTitle) {
	    switch (preTitle) {
	      case 'awkwardoffice':
	        return false;
	      case 'branding':
	        return false;
	        break;
	      case 'careers':
	        return false;
	        break;
	      case 'internships':
	        return false;
	        break;
	      case 'about':
	        return false;
	        break;
	      case 'capabilities':
	        return false;
	      case 'salesenablement':
	        return false;
	      default:
	        return true;
	    }
	  };
	
	  var renderDash = function renderDash(animation) {
	    return _react2.default.createElement('span', {
	      className: [_projectBreadcrumbModule2.default.dash, (0, _emotion.css)(_templateObject2, color)].join(' '),
	      style: animation
	    });
	  };
	
	  var renderTitle = function renderTitle(animation) {
	    return _react2.default.createElement('div', {
	      className: _projectBreadcrumbModule2.default.pageTitle,
	      dangerouslySetInnerHTML: { __html: title },
	      style: animation
	    });
	  };
	
	  var renderDefaultAnimation = function renderDefaultAnimation() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h5',
	        { className: _projectBreadcrumbModule2.default.title, style: { color: color } },
	        renderPreTitle(),
	        _react2.default.createElement(
	          _reactSpring.Spring,
	          { from: { width: '10px' }, to: { width: '18px' }, delay: 400 },
	          function (animation) {
	            return renderDash(animation);
	          }
	        ),
	        showTitle(preTitle) && _react2.default.createElement(
	          _reactSpring.Spring,
	          {
	            from: { opacity: 0 },
	            to: { opacity: 1 },
	            delay: 800,
	            config: { tension: 180, friction: 60 }
	          },
	          function (animation) {
	            return renderTitle(animation);
	          }
	        )
	      )
	    );
	  };
	
	  var renderHomeAnimation = function renderHomeAnimation() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h5',
	        { className: _projectBreadcrumbModule2.default.title, style: { color: color } },
	        renderPreTitle(),
	        _react2.default.createElement(
	          _reactSpring.Spring,
	          {
	            from: { width: '10px' },
	            to: { width: returnSection === 'active' ? '18px' : '10px' },
	            delay: 400
	          },
	          function (animation) {
	            return renderDash(animation);
	          }
	        ),
	        showTitle(preTitle) && _react2.default.createElement(
	          _reactSpring.Spring,
	          {
	            from: { opacity: 0 },
	            to: { opacity: returnSection === 'active' ? 1 : 0 },
	            delay: 800,
	            config: { tension: 180, friction: 60 }
	          },
	          function (animation) {
	            return renderTitle(animation);
	          }
	        )
	      )
	    );
	  };
	
	  if (isHome !== true) {
	    return renderDefaultAnimation();
	  } else {
	    return renderHomeAnimation();
	  }
	};
	
	exports.default = ProjectBreadcrumb;
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectHeadlineModule = __webpack_require__(516);
	
	var _projectHeadlineModule2 = _interopRequireDefault(_projectHeadlineModule);
	
	var _reactSpring = __webpack_require__(8);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectHeadline = function ProjectHeadline(_ref) {
	  var headline = _ref.headline,
	      isHome = _ref.isHome,
	      returnSection = _ref.returnSection,
	      _ref$colorOverride = _ref.colorOverride,
	      colorOverride = _ref$colorOverride === undefined ? '#ffffff' : _ref$colorOverride,
	      _ref$fontOverride = _ref.fontOverride,
	      fontOverride = _ref$fontOverride === undefined ? 'montbold' : _ref$fontOverride;
	
	  var renderHeadline = function renderHeadline(animation) {
	    return _react2.default.createElement(
	      'div',
	      { style: animation },
	      _react2.default.createElement(
	        _reactFittext2.default,
	        { compressor: 0.9, maxFontSize: 70 },
	        _react2.default.createElement('h1', {
	          className: _projectHeadlineModule2.default.content,
	          dangerouslySetInnerHTML: { __html: headline },
	          style: { color: colorOverride, fontFamily: fontOverride }
	        })
	      )
	    );
	  };
	
	  var renderDefaultAnimation = function renderDefaultAnimation() {
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0, transform: 'translateY(20px)' },
	        to: { opacity: 1, transform: 'translateY(0)' },
	        delay: 600,
	        config: { tension: 180, friction: 60 }
	      },
	      function (animation) {
	        return renderHeadline(animation);
	      }
	    );
	  };
	
	  var renderHomeAnimation = function renderHomeAnimation() {
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0, transform: 'translateY(20px)' },
	        to: {
	          opacity: returnSection === 'active' ? 1 : 0,
	          transform: returnSection === 'active' ? 'translateY(0)' : 'translateY(20px)'
	        },
	        delay: 600,
	        config: { tension: 180, friction: 60 }
	      },
	      function (animation) {
	        return renderHeadline(animation);
	      }
	    );
	  };
	
	  if (isHome !== true) {
	    return renderDefaultAnimation();
	  } else {
	    return renderHomeAnimation();
	  }
	};
	exports.default = ProjectHeadline;
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sectionTitleModule = __webpack_require__(542);
	
	var _sectionTitleModule2 = _interopRequireDefault(_sectionTitleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionTitle = function SectionTitle(_ref) {
	  var title = _ref.title;
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: _sectionTitleModule2.default.copy },
	      title
	    )
	  );
	};
	
	SectionTitle.propTypes = {
	  title: _propTypes2.default.string
	};
	
	exports.default = SectionTitle;
	module.exports = exports['default'];

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RevealEdges = function RevealEdges(_ref) {
	  var isInView = _ref.isInView;
	
	  var animationConfig = {
	    delay: 300,
	    duration: 900,
	    easing: easings.easeCubicOut
	  };
	  var edges = function edges(animation) {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement('div', {
	        style: {
	          position: 'absolute',
	          top: 0,
	          bottom: 0,
	          left: 0,
	          right: animation.right,
	          zIndex: 2,
	          background: 'rgb(240, 240, 242)'
	        }
	      }),
	      _react2.default.createElement('div', {
	        style: {
	          position: 'absolute',
	          top: 0,
	          bottom: 0,
	          left: animation.left,
	          right: '0',
	          zIndex: 2,
	          background: 'rgb(240, 240, 242)'
	        }
	      })
	    );
	  };
	  return _react2.default.createElement(
	    _reactSpring.Spring,
	    {
	      from: { left: '95%', right: '95%' },
	      to: {
	        left: isInView ? '100%' : '95%',
	        right: isInView ? '100%' : '95%'
	      },
	      config: animationConfig
	    },
	    function (animation) {
	      return edges(animation);
	    }
	  );
	};
	
	RevealEdges.propTypes = {
	  isInView: _propTypes2.default.bool
	};
	
	exports.default = RevealEdges;
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n            padding: ', ';\n            position: relative;\n          '], ['\n            padding: ', ';\n            position: relative;\n          ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _revealEdges = __webpack_require__(26);
	
	var _revealEdges2 = _interopRequireDefault(_revealEdges);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _projectBlurb = __webpack_require__(14);
	
	var _projectBlurb2 = _interopRequireDefault(_projectBlurb);
	
	var _emotion = __webpack_require__(5);
	
	var _projectVideoLoopModule = __webpack_require__(536);
	
	var _projectVideoLoopModule2 = _interopRequireDefault(_projectVideoLoopModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectVideo = function ProjectVideo(props) {
	  var isInView = props.isInView;
	
	  if (isInView !== true) {
	    return _react2.default.createElement(
	      _reveal2.default,
	      null,
	      _react2.default.createElement(ProjectVideoContent, props)
	    );
	  } else {
	    return _react2.default.createElement(ProjectVideoContent, props);
	  }
	};
	
	var ProjectVideoContent = function (_Component) {
	  _inherits(ProjectVideoContent, _Component);
	
	  function ProjectVideoContent() {
	    _classCallCheck(this, ProjectVideoContent);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.videosRefs = [{ name: 'videoOne' }];
	
	    _this.state = {
	      playerOne: null
	    };
	    return _this;
	  }
	
	  ProjectVideoContent.prototype.componentDidMount = function componentDidMount() {
	    var VimeoPlayer = __webpack_require__(115);
	    this.setState({
	      playerOne: new VimeoPlayer(this.refs[0])
	    });
	  };
	
	  ProjectVideoContent.prototype.render = function render() {
	    var _props = this.props,
	        background = _props.background,
	        muted = _props.muted,
	        videoId = _props.videoId,
	        wrapperPadding = _props.wrapperPadding,
	        blurb = _props.blurb,
	        isInView = _props.isInView,
	        autoplay = _props.autoplay,
	        hideBlurb = _props.hideBlurb;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)(_templateObject, wrapperPadding)
	        },
	        _react2.default.createElement(_revealEdges2.default, { isInView: isInView }),
	        _react2.default.createElement(
	          'div',
	          { className: _projectVideoLoopModule2.default.videoWrapper },
	          _react2.default.createElement('div', {
	            className: _projectVideoLoopModule2.default.video,
	            'data-vimeo-id': videoId,
	            'data-vimeo-autoplay': autoplay,
	            'data-vimeo-muted': muted,
	            'data-vimeo-maxwidth': '1219',
	            'data-vimeo-maxheight': '700',
	            'data-vimeo-title': '0',
	            'data-vimeo-background': background,
	            ref: 0
	          })
	        ),
	        hideBlurb !== true && _react2.default.createElement(_projectBlurb2.default, { blurb: blurb })
	      )
	    );
	  };
	
	  return ProjectVideoContent;
	}(_react.Component);
	
	ProjectVideo.propTypes = {
	  background: _propTypes2.default.string,
	  muted: _propTypes2.default.string,
	  videoId: _propTypes2.default.string,
	  wrapperPadding: _propTypes2.default.string,
	  blurb: _propTypes2.default.string,
	  isInView: _propTypes2.default.bool
	};
	
	exports.default = ProjectVideo;
	module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scrollDownModule = __webpack_require__(540);
	
	var _scrollDownModule2 = _interopRequireDefault(_scrollDownModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollDown = function ScrollDown(_ref) {
	  var color = _ref.color;
	
	  var scrollStyles = {
	    default: {
	      direction: _scrollDownModule2.default.direction,
	      line: _scrollDownModule2.default.line
	    },
	    white: {
	      direction: [_scrollDownModule2.default.direction, _scrollDownModule2.default.directionWhite].join(' '),
	      line: [_scrollDownModule2.default.line, _scrollDownModule2.default.lineWhite].join(' ')
	    }
	  };
	
	  var renderScrollDown = function renderScrollDown(directionStyles, lineStyles) {
	    return _react2.default.createElement(
	      'div',
	      { className: _scrollDownModule2.default.align },
	      _react2.default.createElement(
	        'div',
	        { className: _scrollDownModule2.default.wrapper },
	        _react2.default.createElement(
	          'span',
	          { className: directionStyles },
	          'Scroll'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _scrollDownModule2.default.lineAlign },
	          _react2.default.createElement(
	            'div',
	            { className: _scrollDownModule2.default.lineWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: lineStyles },
	              _react2.default.createElement('div', null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    color === 'white' ? renderScrollDown(scrollStyles.white.direction, scrollStyles.white.line) : renderScrollDown(scrollStyles.default.direction, scrollStyles.default.line)
	  );
	};
	
	ScrollDown.propTypes = {
	  color: _propTypes2.default.string
	};
	
	exports.default = ScrollDown;
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(712);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(250);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formSubmitModule = __webpack_require__(481);
	
	var _formSubmitModule2 = _interopRequireDefault(_formSubmitModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormSubmit = function FormSubmit(_ref) {
	  var submitForm = _ref.submitForm,
	      submitted = _ref.submitted;
	
	  var submitHandler = function submitHandler(event) {
	    submitForm(event);
	  };
	
	  var returnMessage = function returnMessage() {
	    if (submitted === 1) {
	      return 'Success';
	    } else if (submitted == 2) {
	      return 'Sending';
	    } else {
	      return 'Submit';
	    }
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'button',
	      { className: _formSubmitModule2.default.wrapper, onClick: submitHandler, type: 'submit' },
	      _react2.default.createElement(
	        'span',
	        { className: _formSubmitModule2.default.submit },
	        returnMessage()
	      )
	    )
	  );
	};
	
	FormSubmit.propTypes = {
	  submitForm: _propTypes2.default.func,
	  submitted: _propTypes2.default.number
	};
	
	exports.default = FormSubmit;
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputHoneypot = function InputHoneypot(_ref) {
	  var captureFieldData = _ref.captureFieldData;
	
	  var handleCaptureData = function handleCaptureData(event) {
	    captureFieldData(event);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { display: 'none' } },
	    '>',
	    _react2.default.createElement('input', {
	      name: 'honeypot',
	      type: 'text',
	      onChange: function onChange(event) {
	        return handleCaptureData(event);
	      }
	    })
	  );
	};
	
	InputHoneypot.propTypes = {
	  captureFieldData: _propTypes2.default.func
	};
	
	exports.default = InputHoneypot;
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n                  color: ', ';\n                  ::placeholder {\n                    color: ', ';\n                  }\n                '], ['\n                  color: ', ';\n                  ::placeholder {\n                    color: ', ';\n                  }\n                ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n                  border-color: #d0021b;\n                  color: ', ';\n                  ::placeholder {\n                    color: #d0021b;\n                  }\n                '], ['\n                  border-color: #d0021b;\n                  color: ', ';\n                  ::placeholder {\n                    color: #d0021b;\n                  }\n                ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(5);
	
	var _formModule = __webpack_require__(13);
	
	var _formModule2 = _interopRequireDefault(_formModule);
	
	var _inputsModule = __webpack_require__(85);
	
	var _inputsModule2 = _interopRequireDefault(_inputsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InputRequired = function InputRequired(_ref) {
	  var formErrors = _ref.formErrors,
	      captureFieldData = _ref.captureFieldData,
	      theme = _ref.theme,
	      name = _ref.name,
	      placeholder = _ref.placeholder,
	      type = _ref.type;
	
	  var handleCaptureData = function handleCaptureData(event) {
	    captureFieldData(event);
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement('input', {
	      id: name,
	      name: name,
	      placeholder: typeof formErrors === 'undefined' || formErrors.length === 0 ? placeholder : formErrors,
	      type: type,
	      className: typeof formErrors === 'undefined' || formErrors.length === 0 ? [(0, _emotion.css)(_templateObject, theme, theme), _inputsModule2.default.input, _formModule2.default.input].join(' ') : [_inputsModule2.default.input, _formModule2.default.input, (0, _emotion.css)(_templateObject2, theme)].join(' '),
	      onChange: function onChange(event) {
	        return handleCaptureData(event);
	      }
	    })
	  );
	};
	
	InputRequired.propTypes = {
	  formErrors: _propTypes2.default.string,
	  captureFieldData: _propTypes2.default.func,
	  theme: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	exports.default = InputRequired;
	module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpring = __webpack_require__(8);
	
	var _gradients = __webpack_require__(291);
	
	var _gradients2 = _interopRequireDefault(_gradients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GradientBGTransition = function (_Component) {
	  _inherits(GradientBGTransition, _Component);
	
	  function GradientBGTransition() {
	    _classCallCheck(this, GradientBGTransition);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.loop = function (i) {
	      _this.timerHandle = setTimeout(function () {
	        if (i === 4) {
	          i = 0;
	        }
	        _this.setState(function (state) {
	          return {
	            index: state.index === 3 ? 0 : state.index + 1
	          };
	        });
	        _this.loop(i + 1);
	        _this.timerHandle = 0;
	      }, 3500);
	    };
	
	    _this.state = {
	      index: 0
	    };
	    return _this;
	  }
	
	  GradientBGTransition.prototype.componentDidMount = function componentDidMount() {
	    this.loop(0);
	  };
	
	  GradientBGTransition.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timerHandle) {
	      clearTimeout(this.timerHandle);
	      this.timerHandle = 0;
	    }
	  };
	
	  GradientBGTransition.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactSpring.Transition,
	      {
	        native: true,
	        items: this.state.index,
	        from: { opacity: 0 },
	        enter: { opacity: 1 },
	        leave: { opacity: 0 },
	        config: { tension: 60, friction: 100 }
	      },
	      function (index) {
	        return _gradients2.default[index];
	      }
	    );
	  };
	
	  return GradientBGTransition;
	}(_react.Component);
	
	exports.default = GradientBGTransition;
	module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var emailValidation = function emailValidation(email, validation) {
	  if (email.length === 0) {
	    validation.errors['email'] = 'Please enter email.';
	    validation.formIsValid = false;
	  }
	
	  if (email.length !== 0) {
	    var lastAtPos = email.lastIndexOf('@');
	    var lastDotPos = email.lastIndexOf('.');
	
	    if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && email.length - lastDotPos > 2)) {
	      document.getElementById('email').value = '';
	      validation.formIsValid = false;
	      validation.errors['email'] = 'Email is not valid.';
	    }
	  }
	};
	
	var nameValidation = function nameValidation(name, validation) {
	  if (name.length === 0) {
	    validation.errors['name'] = 'Please enter name.';
	    validation.formIsValid = false;
	  }
	};
	
	var firstNameValidation = function firstNameValidation(name, validation) {
	  if (name.length === 0) {
	    validation.errors['first'] = 'Please enter first name.';
	    validation.formIsValid = false;
	  }
	};
	
	var lastNameValidation = function lastNameValidation(name, validation) {
	  if (name.length === 0) {
	    validation.errors['last'] = 'Please enter last name.';
	    validation.formIsValid = false;
	  }
	};
	
	var companyValidation = function companyValidation(company, validation) {
	  if (company.length === 0) {
	    validation.errors['company'] = 'Please enter company name.';
	    validation.formIsValid = false;
	  }
	};
	
	var titleValidation = function titleValidation(title, validation) {
	  if (title.length === 0) {
	    validation.errors['title'] = 'Please enter organization title.';
	    validation.formIsValid = false;
	  }
	};
	
	var interestsValidation = function interestsValidation(interests, validation) {
	  if (interests.length === 0) {
	    validation.errors['interests'] = 'Please let us know how we can help you.';
	    validation.formIsValid = false;
	  }
	};
	
	var commentsValidation = function commentsValidation(comments, validation) {
	  if (comments.length === 0) {
	    validation.errors['comments'] = 'Please enter comments.';
	    validation.formIsValid = false;
	  }
	};
	
	var uploadValidation = function uploadValidation(file, validation) {
	  if (typeof file.name === 'undefined') {
	    validation.errors['file'] = 'Please upload file.';
	    validation.formIsValid = false;
	  }
	};
	
	var handleContactValidation = exports.handleContactValidation = function handleContactValidation(name, email, interests) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  nameValidation(name, validation);
	  emailValidation(email, validation);
	  interestsValidation(interests, validation);
	
	  return validation;
	};
	
	var handleEmailValidation = exports.handleEmailValidation = function handleEmailValidation(email) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  emailValidation(email, validation);
	
	  return validation;
	};
	
	var handleConnectValidation = exports.handleConnectValidation = function handleConnectValidation(name, email, company) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  nameValidation(name, validation);
	  emailValidation(email, validation);
	  companyValidation(company, validation);
	
	  return validation;
	};
	
	var handleWebinarValidation = exports.handleWebinarValidation = function handleWebinarValidation(first, last, email, company) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  firstNameValidation(first, validation);
	  lastNameValidation(last, validation);
	  emailValidation(email, validation);
	  companyValidation(company, validation);
	
	  return validation;
	};
	
	var handleMeaningfulValidation = exports.handleMeaningfulValidation = function handleMeaningfulValidation(first, last, email) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  firstNameValidation(first, validation);
	  lastNameValidation(last, validation);
	  emailValidation(email, validation);
	
	  return validation;
	};
	
	var handleEventContactValidation = exports.handleEventContactValidation = function handleEventContactValidation(name, email) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  nameValidation(name, validation);
	  emailValidation(email, validation);
	
	  return validation;
	};
	
	var handleGeneralSubmissionsValidation = exports.handleGeneralSubmissionsValidation = function handleGeneralSubmissionsValidation(name, email, comments) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  nameValidation(name, validation);
	  emailValidation(email, validation);
	  commentsValidation(comments, validation);
	
	  return validation;
	};
	
	var handlePositionValidation = exports.handlePositionValidation = function handlePositionValidation(name, email, file) {
	  var validation = {
	    errors: {},
	    formIsValid: true
	  };
	
	  nameValidation(name, validation);
	  emailValidation(email, validation);
	  uploadValidation(file, validation);
	
	  return validation;
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n            color: ', ';\n            ::placeholder {\n              color: ', ';\n            }\n          '], ['\n            color: ', ';\n            ::placeholder {\n              color: ', ';\n            }\n          ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(5);
	
	var _formModule = __webpack_require__(13);
	
	var _formModule2 = _interopRequireDefault(_formModule);
	
	var _inputsModule = __webpack_require__(85);
	
	var _inputsModule2 = _interopRequireDefault(_inputsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InputDefaultTextArea = function InputDefaultTextArea(_ref) {
	  var captureFieldData = _ref.captureFieldData,
	      theme = _ref.theme,
	      name = _ref.name,
	      placeholder = _ref.placeholder,
	      type = _ref.type;
	
	  var handleCaptureData = function handleCaptureData(event) {
	    captureFieldData(event);
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement('textarea', {
	      name: name,
	      placeholder: placeholder,
	      type: type,
	      className: [(0, _emotion.css)(_templateObject, theme, theme), _inputsModule2.default.input, _formModule2.default.input].join(' '),
	      onChange: function onChange(event) {
	        return handleCaptureData(event);
	      }
	    })
	  );
	};
	
	InputDefaultTextArea.propTypes = {
	  captureFieldData: _propTypes2.default.func,
	  theme: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	exports.default = InputDefaultTextArea;
	module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n            color: ', ';\n            ::placeholder {\n              color: ', ';\n            }\n          '], ['\n            color: ', ';\n            ::placeholder {\n              color: ', ';\n            }\n          ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(5);
	
	var _formModule = __webpack_require__(13);
	
	var _formModule2 = _interopRequireDefault(_formModule);
	
	var _inputsModule = __webpack_require__(85);
	
	var _inputsModule2 = _interopRequireDefault(_inputsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InputDefault = function InputDefault(_ref) {
	  var captureFieldData = _ref.captureFieldData,
	      theme = _ref.theme,
	      name = _ref.name,
	      placeholder = _ref.placeholder,
	      type = _ref.type;
	
	  var handleCaptureData = function handleCaptureData(event) {
	    captureFieldData(event);
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement('input', {
	      name: name,
	      placeholder: placeholder,
	      type: type,
	      className: [(0, _emotion.css)(_templateObject, theme, theme), _inputsModule2.default.input, _formModule2.default.input].join(' '),
	      onChange: function onChange(event) {
	        return handleCaptureData(event);
	      }
	    })
	  );
	};
	
	InputDefault.propTypes = {
	  captureFieldData: _propTypes2.default.func,
	  theme: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	exports.default = InputDefault;
	module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _reactSpring = __webpack_require__(8);
	
	var _heroMessageModule = __webpack_require__(486);
	
	var _heroMessageModule2 = _interopRequireDefault(_heroMessageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroMessage = function HeroMessage(_ref) {
	  var message = _ref.message;
	
	  return _react2.default.createElement(
	    _reactSpring.Spring,
	    {
	      from: { opacity: 0, transform: 'translateY(20px)' },
	      to: { opacity: 1, transform: 'translateY(0)' },
	      delay: 800,
	      config: { tension: 180, friction: 60 }
	    },
	    function (animation) {
	      return _react2.default.createElement(
	        'div',
	        { style: animation },
	        _react2.default.createElement(
	          _reactFittext2.default,
	          { compressor: 3.4, minFontSize: 16, maxFontSize: 22 },
	          _react2.default.createElement('h4', {
	            className: _heroMessageModule2.default.copy,
	            dangerouslySetInnerHTML: { __html: message }
	          })
	        )
	      );
	    }
	  );
	};
	
	exports.default = HeroMessage;
	module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _sectionMessageModule = __webpack_require__(541);
	
	var _sectionMessageModule2 = _interopRequireDefault(_sectionMessageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionMessage = function SectionMessage(_ref) {
	  var message = _ref.message,
	      secondary = _ref.secondary;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _sectionMessageModule2.default.wrapper },
	    _react2.default.createElement(
	      _reactFittext2.default,
	      { compressor: 3.35, minFontSize: 16, maxFontSize: 20 },
	      _react2.default.createElement('p', {
	        className: _sectionMessageModule2.default.copy,
	        dangerouslySetInnerHTML: { __html: message }
	      })
	    ),
	    typeof secondary !== 'undefined' ? _react2.default.createElement(
	      _reactFittext2.default,
	      { compressor: 3.35, minFontSize: 16, maxFontSize: 20 },
	      _react2.default.createElement('p', {
	        style: { marginTop: '1rem' },
	        className: _sectionMessageModule2.default.copy,
	        dangerouslySetInnerHTML: { __html: secondary }
	      })
	    ) : null
	  );
	};
	
	SectionMessage.propTypes = {
	  message: _propTypes2.default.string,
	  secondary: _propTypes2.default.string
	};
	
	exports.default = SectionMessage;
	module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(52)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(859);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _adLogo = __webpack_require__(919);
	
	var _adLogo2 = _interopRequireDefault(_adLogo);
	
	var _adWorkLogo = __webpack_require__(920);
	
	var _adWorkLogo2 = _interopRequireDefault(_adWorkLogo);
	
	var _adpLogo = __webpack_require__(921);
	
	var _adpLogo2 = _interopRequireDefault(_adpLogo);
	
	var _amerluxLogo = __webpack_require__(923);
	
	var _amerluxLogo2 = _interopRequireDefault(_amerluxLogo);
	
	var _allCladLogo = __webpack_require__(922);
	
	var _allCladLogo2 = _interopRequireDefault(_allCladLogo);
	
	var _dupontLogo = __webpack_require__(925);
	
	var _dupontLogo2 = _interopRequireDefault(_dupontLogo);
	
	var _centricaLogo = __webpack_require__(924);
	
	var _centricaLogo2 = _interopRequireDefault(_centricaLogo);
	
	var _heineken = __webpack_require__(927);
	
	var _heineken2 = _interopRequireDefault(_heineken);
	
	var _infosysLogo = __webpack_require__(928);
	
	var _infosysLogo2 = _interopRequireDefault(_infosysLogo);
	
	var _philips = __webpack_require__(932);
	
	var _philips2 = _interopRequireDefault(_philips);
	
	var _lgLogo = __webpack_require__(929);
	
	var _lgLogo2 = _interopRequireDefault(_lgLogo);
	
	var _ricohLogo = __webpack_require__(935);
	
	var _ricohLogo2 = _interopRequireDefault(_ricohLogo);
	
	var _signifyLogo = __webpack_require__(936);
	
	var _signifyLogo2 = _interopRequireDefault(_signifyLogo);
	
	var _steveMaddenLogo = __webpack_require__(937);
	
	var _steveMaddenLogo2 = _interopRequireDefault(_steveMaddenLogo);
	
	var _firmenichLogo = __webpack_require__(926);
	
	var _firmenichLogo2 = _interopRequireDefault(_firmenichLogo);
	
	var _lupinLogo = __webpack_require__(930);
	
	var _lupinLogo2 = _interopRequireDefault(_lupinLogo);
	
	var _peprotechLogo = __webpack_require__(931);
	
	var _peprotechLogo2 = _interopRequireDefault(_peprotechLogo);
	
	var _pinnacleLogo = __webpack_require__(933);
	
	var _pinnacleLogo2 = _interopRequireDefault(_pinnacleLogo);
	
	var _questDiagnosticsLogo = __webpack_require__(934);
	
	var _questDiagnosticsLogo2 = _interopRequireDefault(_questDiagnosticsLogo);
	
	var _brandingMessaging = __webpack_require__(915);
	
	var _brandingMessaging2 = _interopRequireDefault(_brandingMessaging);
	
	var _digital = __webpack_require__(916);
	
	var _digital2 = _interopRequireDefault(_digital);
	
	var _employeeExperience = __webpack_require__(917);
	
	var _employeeExperience2 = _interopRequireDefault(_employeeExperience);
	
	var _strategicMarketing = __webpack_require__(918);
	
	var _strategicMarketing2 = _interopRequireDefault(_strategicMarketing);
	
	var _weichertLogo = __webpack_require__(939);
	
	var _weichertLogo2 = _interopRequireDefault(_weichertLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logos = function Logos(_ref) {
	  var slug = _ref.slug;
	
	  switch (slug) {
	    case 'ad':
	      return _react2.default.createElement(_adLogo2.default, null);
	      break;
	    case 'ad-work':
	      return _react2.default.createElement(_adWorkLogo2.default, null);
	      break;
	    case 'adp':
	      return _react2.default.createElement(_adpLogo2.default, null);
	      break;
	    case 'all-clad':
	      return _react2.default.createElement(_allCladLogo2.default, null);
	      break;
	    case 'amerlux':
	      return _react2.default.createElement(_amerluxLogo2.default, null);
	      break;
	    case 'branding-and-messaging':
	      return _react2.default.createElement(_brandingMessaging2.default, null);
	    case 'centrica':
	      return _react2.default.createElement(_centricaLogo2.default, null);
	      break;
	    case 'digital-engagement':
	      return _react2.default.createElement(_digital2.default, null);
	      break;
	    case 'dupont':
	      return _react2.default.createElement(_dupontLogo2.default, null);
	      break;
	    case 'employee-experience':
	      return _react2.default.createElement(_employeeExperience2.default, null);
	      break;
	    case 'firmenich':
	      return _react2.default.createElement(_firmenichLogo2.default, null);
	    case 'heineken':
	      return _react2.default.createElement(_heineken2.default, null);
	      break;
	    case 'infosys':
	      return _react2.default.createElement(_infosysLogo2.default, null);
	      break;
	    case 'lg':
	      return _react2.default.createElement(_lgLogo2.default, null);
	      break;
	    case 'lupin':
	      return _react2.default.createElement(_lupinLogo2.default, null);
	    case 'peprotech':
	      return _react2.default.createElement(_peprotechLogo2.default, null);
	    case 'pinnacle':
	      return _react2.default.createElement(_pinnacleLogo2.default, null);
	    case 'philips':
	      return _react2.default.createElement(_philips2.default, null);
	      break;
	    case 'quest-diagnostics':
	      return _react2.default.createElement(_questDiagnosticsLogo2.default, null);
	    case 'ricoh':
	      return _react2.default.createElement(_ricohLogo2.default, null);
	    case 'signify':
	      return _react2.default.createElement(_signifyLogo2.default, null);
	      break;
	    case 'strategic-marketing':
	      return _react2.default.createElement(_strategicMarketing2.default, null);
	      break;
	    case 'steve-madden':
	      return _react2.default.createElement(_steveMaddenLogo2.default, null);
	      break;
	    case 'weichert-franchising':
	      return _react2.default.createElement(_weichertLogo2.default, null);
	      break;
	    default:
	      return _react2.default.createElement(_react2.default.Fragment, null);
	  }
	};
	
	Logos.propTypes = {
	  slug: _propTypes2.default.string
	};
	
	exports.default = Logos;
	module.exports = exports['default'];

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var core = __webpack_require__(25);
	var ctx = __webpack_require__(210);
	var hide = __webpack_require__(53);
	var has = __webpack_require__(43);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(55);
	var createDesc = __webpack_require__(102);
	module.exports = __webpack_require__(42) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(78);
	var IE8_DOM_DEFINE = __webpack_require__(212);
	var toPrimitive = __webpack_require__(146);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(42) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(213);
	var defined = __webpack_require__(137);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(144)('wks');
	var uid = __webpack_require__(104);
	var Symbol = __webpack_require__(36).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(110);
	var createDesc = __webpack_require__(226);
	module.exports = __webpack_require__(80) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(704);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(112).GenIcon
	module.exports.IoIosAddCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosAddCircleOutline.displayName = "IoIosAddCircleOutline";
	module.exports.IoIosAddCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm90.5 224H272v74.5c0 8.8-7.2 16-16 16-4.4 0-8.4-1.8-11.3-4.7-2.9-2.9-4.7-6.9-4.7-11.3V272h-74.5c-4.4 0-8.4-1.8-11.3-4.7-2.9-2.9-4.7-6.9-4.7-11.3 0-8.8 7.2-16 16-16H240v-74.5c0-8.8 7.2-16 16-16s16 7.2 16 16V240h74.5c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosAddCircle.displayName = "IoIosAddCircle";
	module.exports.IoIosAdd = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.5 240H272v-96.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-96.5c-8.8 0-16 7.2-16 16 0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7H240v96.5c0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7 8.8 0 16-7.2 16-16V272h96.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}}]})(props);
	};
	module.exports.IoIosAdd.displayName = "IoIosAdd";
	module.exports.IoIosAirplane = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.7 224c-3.4 0-14.8.1-18 .3l-64.9 1.7c-.7 0-1.4-.3-1.7-.9L225.8 79.4c-2.9-4.6-8.1-7.4-13.5-7.4h-23.7c-5.6 0-7.5 5.6-5.5 10.8l50.1 142.8c.5 1.3-.4 2.7-1.8 2.7L109 230.1c-2.6.1-5-1.1-6.6-3.1l-37-45c-3-3.9-7.7-6.1-12.6-6.1H36c-2.8 0-4.7 2.7-3.8 5.3l19.9 68.7c1.5 3.8 1.5 8.1 0 11.9l-19.9 68.7c-.9 2.6 1 5.3 3.8 5.3h16.7c4.9 0 9.6-2.3 12.6-6.1L103 284c1.6-2 4.1-3.2 6.6-3.1l121.7 2.7c1.4.1 2.3 1.4 1.8 2.7L183 429.2c-2 5.2-.1 10.8 5.5 10.8h23.7c5.5 0 10.6-2.8 13.5-7.4L323.1 287c.4-.6 1-.9 1.7-.9l64.9 1.7c3.3.2 14.6.3 18 .3 44.3 0 72.3-14.3 72.3-32S452.1 224 407.7 224z"}}]})(props);
	};
	module.exports.IoIosAirplane.displayName = "IoIosAirplane";
	module.exports.IoIosAlarm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M381.2 64.1c-1.3-.1-2.6-.1-3.9-.1h-.2c-16.2 0-32 5.4-44.6 15.1-1.6 1.3-2.6 3.2-2.7 5.2-.1 2 .8 4 2.3 5.4l89.8 80.5c1.3 1.1 2.9 1.8 4.6 1.8h.4c1.9-.1 3.6-1 4.8-2.4C440.9 159 448 150.8 448 133c.1-36.4-29.1-66.8-66.8-68.9zM64 133c0 17.8 7.1 26 16.3 36.6 1.2 1.4 2.9 2.3 4.8 2.4h.4c1.7 0 3.3-.6 4.6-1.8L180 89.7c1.5-1.4 2.4-3.3 2.3-5.4-.1-2-1-3.9-2.7-5.2C167 69.4 151.2 64 135 64h-.2c-1.3 0-2.6 0-3.9.1-37.7 2.1-67 32.5-66.9 68.9z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M390 386c26.2-30.7 42-70.5 42-114 0-97.2-78.8-176-176-176S80 174.8 80 272c0 43.5 15.8 83.3 42 114l-34.7 35.5c-6.2 6.3-6 15.5.3 21.6 3.1 3 7.4 4.8 11.4 4.8 4.2 0 8.1-1.9 11.2-5.1l34.6-34.5c30.3 24.7 69 39.6 111.2 39.6s80.9-14.8 111.2-39.6l33.6 34.5c3.1 3.2 7.3 5.1 11.5 5.1 4 0 8.1-1.8 11.2-4.8 6.3-6.2 7.5-15.3 1.3-21.6L390 386zM270 274c0 7.7-6.3 14-14 14h-82c-7.7 0-14-6.3-14-14s6.3-14 14-14h68V158c0-7.7 6.3-14 14-14s14 6.3 14 14v116z"}}]}]})(props);
	};
	module.exports.IoIosAlarm.displayName = "IoIosAlarm";
	module.exports.IoIosAlbums = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460.9 161H51.1C31.8 161 16 176.8 16 196.1V428c0 19.3 15.8 35.1 35.1 35.1H461c19.3 0 35.1-15.8 35.1-35.1V196.1c-.1-19.3-15.9-35.1-35.2-35.1zM434 133H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h356c7.7 0 14 6.3 14 14s-6.3 14-14 14zM403.2 77H108.8c-7 0-12.8-5.8-12.8-12.8v-2.4c0-7 5.8-12.8 12.8-12.8h294.4c7 0 12.8 5.8 12.8 12.8v2.4c0 7-5.8 12.8-12.8 12.8z"}}]})(props);
	};
	module.exports.IoIosAlbums.displayName = "IoIosAlbums";
	module.exports.IoIosAlert = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm17.2 109.6l-3.1 115.1c-.2 8.2-5.9 14.8-14.1 14.8s-13.9-6.6-14.1-14.8l-3.1-115.1c-.2-9.6 7.5-17.6 17.2-17.6 9.6 0 17.4 7.9 17.2 17.6zM256 354c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4c10.7 0 19.1 8.1 19.1 18.4S266.7 354 256 354z"}}]})(props);
	};
	module.exports.IoIosAlert.displayName = "IoIosAlert";
	module.exports.IoIosAmericanFootball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378.6 133.4C338.1 92.9 283.9 71 231.4 59.6L59.6 231.4C71 284 92.9 338.1 133.4 378.6c40.5 40.5 94.7 62.4 147.2 73.8l171.8-171.8c-11.4-52.5-33.3-106.7-73.8-147.2zM344.1 288l-19.2 19.2 14.8 14.8c4.9 4.9 4.9 12.7 0 17.6-4.9 4.9-12.7 4.9-17.6 0l-14.8-14.8-19.3 19.4c-2 2-4.5 3.4-7.3 3.9-4.2.7-8.4-.7-11.3-3.6-1.5-1.5-2.6-3.3-3.2-5.3-1.4-4.9-.1-9.7 3.2-13.1l19.5-19.5-15.6-15.6-19.3 19.3c-2.1 2.1-4.7 3.5-7.6 3.9-5.5.7-10.7-1.9-13.4-7-.3-.6-.6-1.2-.8-1.9-1.5-4.9-.2-9.8 3.2-13.2l19.5-19.5-15.5-15.6-19.3 19.3c-2.1 2.1-4.7 3.5-7.6 3.9-5.5.7-10.7-1.9-13.4-7-.3-.6-.6-1.2-.8-1.9-1.5-4.9-.2-9.8 3.2-13.2l19.5-19.5-15.5-15.6-19.3 19.3c-2.1 2.1-4.7 3.5-7.6 3.9-5.5.7-10.7-1.9-13.4-7-.3-.6-.6-1.2-.8-1.9-1.5-4.9-.2-9.8 3.2-13.2l19.5-19.5-14.8-14.8c-4.9-4.9-4.9-12.7 0-17.6 4.9-4.9 12.7-4.9 17.6 0l14.8 14.8 19.3-19.3c2.1-2.1 4.7-3.5 7.6-3.9 5.5-.7 10.7 1.9 13.4 7 .3.6.6 1.2.8 1.9 1.5 4.9.2 9.8-3.2 13.2l-19.5 19.5 15.6 15.6 19.3-19.3c2-2 4.5-3.4 7.3-3.9 4.2-.7 8.4.7 11.3 3.6 1.5 1.4 2.6 3.2 3.2 5.2 1.5 4.9.2 9.8-3.2 13.2L257 239.4l15.6 15.6 19.3-19.3c2.1-2.1 4.7-3.5 7.6-3.9 5.5-.7 10.7 1.9 13.4 7 .3.6.6 1.2.8 1.9 1.5 4.9.2 9.8-3.2 13.2L291 273.4l15.6 15.6 19.3-19.3c2.2-2.2 5-3.6 8-4 4.4-.5 8.6 1.2 11.4 4.6 4.1 5 3.5 13.1-1.2 17.7zM395.1 464c27.6 0 48.8-1.8 58.8-2.9 3.7-.4 6.7-3.4 7.1-7.1 2-18.9 6.8-77.6-3.2-143.7L310.3 457.9c31 4.7 60.4 6.1 84.8 6.1zM116.8 48C89.3 48 68 49.8 58 50.9c-3.7.4-6.7 3.4-7.1 7.1-2 18.9-6.8 77.6 3.2 143.6L201.6 54.1c-31-4.7-60.4-6.1-84.8-6.1z"}}]})(props);
	};
	module.exports.IoIosAmericanFootball.displayName = "IoIosAmericanFootball";
	module.exports.IoIosAnalytics = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zM76 256c0-48.1 18.7-93.3 52.7-127.3S207.9 76 256 76c48.1 0 93.3 18.7 127.3 52.7 32.2 32.2 50.7 74.5 52.6 119.7-8.8-10.3-24.2-24-43.8-24-27.5 0-41.7 25.7-51 42.7-1.4 2.5-2.7 4.9-3.9 7-11.4 19.2-27.3 30-42.5 28.9-13.4-.9-24.8-11.2-32.2-28.8-9.2-22.1-29.1-45.8-52.9-49.2-11.3-1.6-28.1.8-44.7 21.4-3.2 4-6.9 9.4-11.1 15.6-10.4 15.5-26.2 38.8-38.1 40.8-17.3 2.8-30.9-7.5-36.4-12.3-2.2-11.2-3.3-22.8-3.3-34.5z"}}]})(props);
	};
	module.exports.IoIosAnalytics.displayName = "IoIosAnalytics";
	module.exports.IoIosAperture = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M250.2 371.4c-1.8 0-2.7 2.2-1.4 3.4l54.9 54.9L326 452c42.4-15.2 78.5-43.7 103.1-80.6H250.2zM167 334.6V444c27 12.8 57.1 20 89 20 14.1 0 27.9-1.4 41.2-4.1L170.4 333.2c-1.2-1.3-3.4-.4-3.4 1.4zM256 48c-13.9 0-27.4 1.4-40.5 4l126.8 126.8c1.3 1.3 3.4.4 3.4-1.4V68.3C318.6 55.3 288.2 48 256 48zM68.1 166.6C55.2 193.7 48 224 48 256c0 14.1 1.4 27.9 4.1 41.2L179.2 170c1.3-1.3.4-3.4-1.4-3.4H68.1zM186.7 59.9C144 75 107.7 103.6 83 140.7h179.7c1.8 0 2.7-2.2 1.4-3.4l-77.4-77.4zM167 220.6v70.7c0 1.1.4 2.1 1.2 2.8l50 50c.8.8 1.8 1.2 2.8 1.2h70.7c1.1 0 2.1-.4 2.8-1.2l50-50c.8-.8 1.2-1.8 1.2-2.8v-70.7c0-1.1-.4-2.1-1.2-2.8l-50-50c-.8-.8-1.8-1.2-2.8-1.2H221c-1.1 0-2.1.4-2.8 1.2l-50 50c-.7.8-1.2 1.8-1.2 2.8zM460 215.5L333.6 342c-1.3 1.3-.4 3.4 1.4 3.4h108.8c13-27.1 20.2-57.4 20.2-89.4 0-13.9-1.4-27.4-4-40.5zM371.8 83.2v179c0 1.8 2.2 2.7 3.4 1.4l76.9-76.9c-15-42.6-43.5-78.8-80.3-103.5zM60.1 325.9c15.2 42.6 43.9 78.8 81 103.4V249.8c0-1.8-2.2-2.7-3.4-1.4l-77.6 77.5z"}}]})(props);
	};
	module.exports.IoIosAperture.displayName = "IoIosAperture";
	module.exports.IoIosApps = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.8 137.6L285.4 69.5c-16.2-7.4-42.7-7.4-58.9 0L77.2 137.6c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.6-8 17.6-21.1 0-29.1zM225.2 375.2l-99.8-45.5c-4.2-1.9-9.1-1.9-13.3 0l-34.9 15.9c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-34.9-15.9c-4.2-1.9-9.1-1.9-13.3 0l-99.8 45.5c-16.9 7.7-44.7 7.7-61.6 0z"}},{"tag":"path","attr":{"d":"M434.8 241.6l-31.7-14.4c-4.2-1.9-9-1.9-13.2 0l-108 48.9c-15.3 5.2-36.6 5.2-51.9 0l-108-48.9c-4.2-1.9-9-1.9-13.2 0l-31.7 14.4c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.7-8 17.7-21.1.1-29.1z"}}]})(props);
	};
	module.exports.IoIosApps.displayName = "IoIosApps";
	module.exports.IoIosAppstore = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-78.9 296.9c-2.7 4.6-7.5 7.1-12.5 7.1-2.5 0-5-.6-7.3-2-6.9-4-9.2-12.8-5.2-19.7l14.2-23.6c1.5-2.5 4.1-4 7-4h2.1c10.3 0 17.5 6.2 19.6 12.2l-17.9 30zm120.2-46.4l-93 .1h-61.8c-8.2 0-14.8-6.8-14.4-15 .3-7.8 7.1-13.7 14.9-13.7h44.8l53.1-90.4-17.2-29.3c-3.9-6.7-2.2-15.5 4.4-19.7 7-4.5 16.2-2.2 20.3 4.8l9.2 15.7h.1l9.2-15.7c4.1-7 13.4-9.3 20.3-4.8 6.6 4.2 8.3 13 4.4 19.7l-17.2 29.3-16.7 28.5-36.3 61.9v.1h53.5c6.7 0 15.1 3.6 18.5 9.4l.3.6c3 5.1 4.7 8.6 4.7 13.7-.1 2.8-1.1 4.8-1.1 4.8zm72.2.1h-25.2v.1l18.4 31.3c4 6.8 2.1 15.8-4.8 20-2.3 1.4-4.9 2.1-7.5 2.1-5 0-9.8-2.6-12.5-7.1l-27.2-46.3-16.9-28.8-21.8-37.3c-6.4-10.9-6.7-24.5-.6-35.3 4.3-7.6 7.6-9.6 7.6-9.6l48.5 82.1h41.7c7.8 0 14.5 6 14.9 13.7.3 8.3-6.3 15.1-14.6 15.1z"}}]})(props);
	};
	module.exports.IoIosAppstore.displayName = "IoIosAppstore";
	module.exports.IoIosArchive = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 120H52c-2.2 0-4-1.8-4-4V96c0-17.7 14.3-32 32-32h352c17.7 0 32 14.3 32 32v20c0 2.2-1.8 4-4 4zM440 146H72c-4.4 0-8 3.6-8 8v262c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V154c0-4.4-3.6-8-8-8zM306 288h-99.6c-7.1 0-13.4-5.2-14.3-12.3-1-8.5 5.6-15.7 13.9-15.7h99.6c7.1 0 13.4 5.2 14.3 12.3 1 8.4-5.6 15.7-13.9 15.7z"}}]})(props);
	};
	module.exports.IoIosArchive.displayName = "IoIosArchive";
	module.exports.IoIosArrowBack = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"}}]})(props);
	};
	module.exports.IoIosArrowBack.displayName = "IoIosArrowBack";
	module.exports.IoIosArrowDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"}}]})(props);
	};
	module.exports.IoIosArrowDown.displayName = "IoIosArrowDown";
	module.exports.IoIosArrowDropdownCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm289.1-43.4c7.5-7.5 19.8-7.5 27.3 0 3.8 3.8 5.6 8.7 5.6 13.6s-1.9 9.9-5.7 13.7l-94.3 94c-7.6 6.9-19.3 6.7-26.6-.6l-95.7-95.4c-7.5-7.5-7.6-19.7 0-27.3 7.5-7.5 19.7-7.6 27.3 0l81.1 81.9 81-79.9z"}}]})(props);
	};
	module.exports.IoIosArrowDropdownCircle.displayName = "IoIosArrowDropdownCircle";
	module.exports.IoIosArrowDropdown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M147.6 210.7c-7.5 7.5-7.5 19.8 0 27.3l95.7 95.4c7.3 7.3 19.1 7.5 26.6.6l94.3-94c3.8-3.8 5.7-8.7 5.7-13.7 0-4.9-1.9-9.9-5.6-13.6-7.5-7.5-19.7-7.6-27.3 0l-81 79.8-81.1-81.9c-7.5-7.5-19.7-7.5-27.3.1z"}},{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm332.4-124.4C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4C347.2 413.7 303 432 256 432s-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256s18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6z"}}]})(props);
	};
	module.exports.IoIosArrowDropdown.displayName = "IoIosArrowDropdown";
	module.exports.IoIosArrowDropleftCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm43.4 289.1c7.5 7.5 7.5 19.8 0 27.3-3.8 3.8-8.7 5.6-13.6 5.6s-9.9-1.9-13.7-5.7l-94-94.3c-6.9-7.6-6.7-19.3.6-26.6l95.4-95.7c7.5-7.5 19.7-7.6 27.3 0 7.5 7.5 7.6 19.7 0 27.3l-81.9 81 79.9 81.1z"}}]})(props);
	};
	module.exports.IoIosArrowDropleftCircle.displayName = "IoIosArrowDropleftCircle";
	module.exports.IoIosArrowDropleft = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M301.3 147.6c-7.5-7.5-19.8-7.5-27.3 0l-95.4 95.7c-7.3 7.3-7.5 19.1-.6 26.6l94 94.3c3.8 3.8 8.7 5.7 13.7 5.7 4.9 0 9.9-1.9 13.6-5.6 7.5-7.5 7.6-19.7 0-27.3l-79.8-81 81.9-81.1c7.5-7.5 7.5-19.7-.1-27.3z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm124.4 332.4C347.2 413.7 303 432 256 432s-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256s18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4z"}}]})(props);
	};
	module.exports.IoIosArrowDropleft.displayName = "IoIosArrowDropleft";
	module.exports.IoIosArrowDroprightCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm244.5 0l-81.9-81.1c-7.5-7.5-7.5-19.8 0-27.3s19.8-7.5 27.3 0l95.4 95.7c7.3 7.3 7.5 19.1.6 26.6l-94 94.3c-3.8 3.8-8.7 5.7-13.7 5.7-4.9 0-9.9-1.9-13.6-5.6-7.5-7.5-7.6-19.7 0-27.3l79.9-81z"}}]})(props);
	};
	module.exports.IoIosArrowDroprightCircle.displayName = "IoIosArrowDroprightCircle";
	module.exports.IoIosArrowDropright = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M210.7 147.6c7.5-7.5 19.8-7.5 27.3 0l95.4 95.7c7.3 7.3 7.5 19.1.6 26.6l-94 94.3c-3.8 3.8-8.7 5.7-13.7 5.7-4.9 0-9.9-1.9-13.6-5.6-7.5-7.5-7.6-19.7 0-27.3l79.9-81.1-81.9-81.1c-7.6-7.4-7.6-19.6 0-27.2z"}},{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm32 0c0-47 18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4C347.2 413.7 303 432 256 432s-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256z"}}]})(props);
	};
	module.exports.IoIosArrowDropright.displayName = "IoIosArrowDropright";
	module.exports.IoIosArrowDropupCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256s93.1 208 208 208zm0-244.5l-81.1 81.9c-7.5 7.5-19.8 7.5-27.3 0s-7.5-19.8 0-27.3l95.7-95.4c7.3-7.3 19.1-7.5 26.6-.6l94.3 94c3.8 3.8 5.7 8.7 5.7 13.7 0 4.9-1.9 9.9-5.6 13.6-7.5 7.5-19.7 7.6-27.3 0l-81-79.9z"}}]})(props);
	};
	module.exports.IoIosArrowDropupCircle.displayName = "IoIosArrowDropupCircle";
	module.exports.IoIosArrowDropup = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M147.6 301.3c-7.5-7.5-7.5-19.8 0-27.3l95.7-95.4c7.3-7.3 19.1-7.5 26.6-.6l94.3 94c3.8 3.8 5.7 8.7 5.7 13.7 0 4.9-1.9 9.9-5.6 13.6-7.5 7.5-19.7 7.6-27.3 0l-81-79.8-81.1 81.9c-7.5 7.5-19.7 7.5-27.3-.1z"}},{"tag":"path","attr":{"d":"M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256s93.1 208 208 208zm0-32c-47 0-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256s18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4C347.2 413.7 303 432 256 432z"}}]})(props);
	};
	module.exports.IoIosArrowDropup.displayName = "IoIosArrowDropup";
	module.exports.IoIosArrowForward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"}}]})(props);
	};
	module.exports.IoIosArrowForward.displayName = "IoIosArrowForward";
	module.exports.IoIosArrowRoundBack = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216.4 163.7c5.1 5 5.1 13.3.1 18.4L155.8 243h231.3c7.1 0 12.9 5.8 12.9 13s-5.8 13-12.9 13H155.8l60.8 60.9c5 5.1 4.9 13.3-.1 18.4-5.1 5-13.2 5-18.3-.1l-82.4-83c-1.1-1.2-2-2.5-2.7-4.1-.7-1.6-1-3.3-1-5 0-3.4 1.3-6.6 3.7-9.1l82.4-83c4.9-5.2 13.1-5.3 18.2-.3z"}}]})(props);
	};
	module.exports.IoIosArrowRoundBack.displayName = "IoIosArrowRoundBack";
	module.exports.IoIosArrowRoundDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M348.3 295.6c-5-5.1-13.3-5.1-18.4-.1L269 356.2V124.9c0-7.1-5.8-12.9-13-12.9s-13 5.8-13 12.9v231.3l-60.9-60.8c-5.1-5-13.3-4.9-18.4.1-5 5.1-5 13.2.1 18.3l83 82.4c1.2 1.1 2.5 2 4.1 2.7 1.6.7 3.3 1 5 1 3.4 0 6.6-1.3 9.1-3.7l83-82.4c5.2-4.9 5.3-13.1.3-18.2z"}}]})(props);
	};
	module.exports.IoIosArrowRoundDown.displayName = "IoIosArrowRoundDown";
	module.exports.IoIosArrowRoundForward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M295.6 163.7c-5.1 5-5.1 13.3-.1 18.4l60.8 60.9H124.9c-7.1 0-12.9 5.8-12.9 13s5.8 13 12.9 13h231.3l-60.8 60.9c-5 5.1-4.9 13.3.1 18.4 5.1 5 13.2 5 18.3-.1l82.4-83c1.1-1.2 2-2.5 2.7-4.1.7-1.6 1-3.3 1-5 0-3.4-1.3-6.6-3.7-9.1l-82.4-83c-4.9-5.2-13.1-5.3-18.2-.3z"}}]})(props);
	};
	module.exports.IoIosArrowRoundForward.displayName = "IoIosArrowRoundForward";
	module.exports.IoIosArrowRoundUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M348.3 216.4c-5 5.1-13.3 5.1-18.4.1L269 155.8v231.3c0 7.1-5.8 12.9-13 12.9s-13-5.8-13-12.9V155.8l-60.9 60.8c-5.1 5-13.3 4.9-18.4-.1-5-5.1-5-13.2.1-18.3l83-82.4c1.2-1.1 2.5-2 4.1-2.7 1.6-.7 3.3-1 5-1 3.4 0 6.6 1.3 9.1 3.7l83 82.4c5.2 4.9 5.3 13.1.3 18.2z"}}]})(props);
	};
	module.exports.IoIosArrowRoundUp.displayName = "IoIosArrowRoundUp";
	module.exports.IoIosArrowUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"}}]})(props);
	};
	module.exports.IoIosArrowUp.displayName = "IoIosArrowUp";
	module.exports.IoIosAt = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 234.3c0 74.1-34.7 120.8-89.6 120.8-28.1 0-49.5-15-53.2-37.3h-4c-9.9 23.2-30.3 35.9-57.7 35.9-48.8 0-81.4-39.1-81.4-97.3 0-55.9 32.8-94.8 80.7-94.8 24.6 0 45.5 12.4 54.7 32.7h4v-27.8h39.9v129.3c0 16.1 8.9 25.8 24.9 25.8 27.7 0 45.3-33.6 45.3-85.8 0-83.3-62.4-139-154.6-139-91.2 0-156.2 66.5-156.2 160.6 0 96.2 64.3 157.6 164.4 157.6 19.6 0 39.3-1.7 54.4-4.6 9.8-1.8 18.8 5.6 18.8 15.5 0 7.3-5 13.7-12.1 15.4-18.2 4.3-40.1 6.8-62.7 6.8C141.9 448 64 372.8 64 256.1 64 142.2 143.5 64 259.4 64 370.8 64 448 133.5 448 234.3zm-242.8 23c0 37 17.4 59.4 45.7 59.4 29.8 0 48.6-23 48.6-59.4s-18.8-58.9-48.1-58.9c-29.1 0-46.2 21.8-46.2 58.9z"}}]})(props);
	};
	module.exports.IoIosAt.displayName = "IoIosAt";
	module.exports.IoIosAttach = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M355.9 161.1c-8.6 0-15.6 7-15.6 15.6v194.4c0 20.3-8 40.4-22 55.1-13.9 14.6-35.2 23.7-55.5 23.7h-13.6c-19.6 0-39.5-8.9-54.8-24.6-15.2-15.5-23.9-35.6-23.9-55.2V119.3c0-14.9 6.2-28.9 17.3-39.5 11.1-10.5 25.7-16.3 41-16.3 15.1 0 29.3 5.8 39.8 16.2 10.5 10.5 16.4 24.6 16.4 39.6v234.2c0 17.1-13.6 32.2-29 32.2-13.6 0-28.2-12.9-28.2-32.2V219.9c0-8.6-7-15.6-15.6-15.6s-15.6 7-15.6 15.6v133.6c0 35.5 25.5 62.3 59.4 62.3 16.5 0 31.7-6.1 42.7-17.3 11.3-11.4 17.5-27.4 17.5-45V119.3c0-23.4-9.1-45.4-25.7-61.8C274 41 252 32 228.5 32s-45.5 9-62.2 25.5c-16.7 16.5-25.9 38.4-25.9 61.9v250.8c0 28.7 12.2 57.9 32.6 78 20.9 20.6 47.9 31.9 76.1 31.9h13.6c27.6 0 55.3-11.7 75.9-32.1 10.2-10.1 18.2-21.7 23.9-34.6 5.9-13.5 8.9-27.7 8.9-42.1V176.7c.1-8.6-6.9-15.6-15.5-15.6z"}}]})(props);
	};
	module.exports.IoIosAttach.displayName = "IoIosAttach";
	module.exports.IoIosBackspace = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M395 96H230c-46.7 0-73.2 34.7-102 63.5s-72.1 74.7-72.1 74.7C51 239.8 48 247 48 255.1c0 8 3 15.3 7.9 21 0 0 34.3 37.6 72.1 75.5 37.8 37.8 56.7 64.5 102 64.5h165c38.5 0 69-32.5 69-71V165c0-38.5-30.5-69-69-69zm-17.7 212.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.2-16.4 6.2-22.6 0L302 278.6l-52.7 52.7c-6.2 6.2-16.3 6.4-22.6 0-6.4-6.4-6.7-15.9 0-22.6l52.7-52.7-52.7-52.7c-6-6-7.1-15.6 0-22.6 7.1-7.1 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L324.6 256l52.7 52.7z"}}]})(props);
	};
	module.exports.IoIosBackspace.displayName = "IoIosBackspace";
	module.exports.IoIosBarcode = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M121.6 388H80.8c-2.2 0-4-1.8-4-4V128c0-2.2 1.8-4 4-4h40.5c7.9 0 14.5-6.4 14.7-14 .1-3.9-1.3-7.2-4.1-10-2.7-2.8-8-4-11.9-4H66c-10 0-18 6-18 16v288c0 10 7 16 17 16h56.3c7.9 0 14.5-5.2 14.7-12.8.1-3.9-1.3-7.5-4.1-10.3-2.7-2.8-6.4-4.9-10.3-4.9zM447 96h-56.3c-9.5 0-17.1 8.3-14 18.3.2.7.5 1.3.8 1.9 2.7 5.2 7.6 7.8 12.9 7.8h40.8c2.2 0 4 1.8 4 4v255.9c0 2.2-1.8 4-4 4h-40.5c-7.9 0-14.5 6.2-14.7 13.9-.1 3.9 1.3 7.6 4.1 10.4 2.7 2.8 6.4 3.8 10.3 3.8H447c10 0 17-6 17-16.4V112c0-10-7-16-17-16z"}},{"tag":"path","attr":{"d":"M122.5 176c-7.7 0-14 6.3-14 13.9V322c0 7.7 6.3 13.9 14 13.9s14-6.3 14-13.9V189.9c0-7.6-6.3-13.9-14-13.9zM389.5 336c7.7 0 14-6.3 14-13.9V189.9c0-7.7-6.3-13.9-14-13.9s-14 6.3-14 13.9V322c0 7.7 6.3 14 14 14zM326.5 144c-7.7 0-14 6.5-14 14.4v195.1c0 8 6.3 14.4 14 14.4s14-6.5 14-14.4V158.4c0-7.9-6.3-14.4-14-14.4zM185.5 144c-7.7 0-14 6.5-14 14.4v195.1c0 8 6.3 14.4 14 14.4s14-6.5 14-14.4V158.4c0-7.9-6.2-14.4-14-14.4zM256 160c-7.7 0-14 6.4-14 14.2v163.5c0 7.8 6.3 14.2 14 14.2s14-6.4 14-14.2V174.2c0-7.8-6.3-14.2-14-14.2z"}}]})(props);
	};
	module.exports.IoIosBarcode.displayName = "IoIosBarcode";
	module.exports.IoIosBaseball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.3 74.2l9.7-3.1c4.7-1.5 9.7 1.1 11.2 5.7l.1.4c1.5 4.7-1.1 9.7-5.7 11.2L260.1 92c-2.1.7-3.2 2.9-2.6 4.9 2.1 6.9 4.5 13.7 7.2 20.5 1.9 4.6 3.9 9.2 6.1 13.7 1.1 2.2 3.8 3 5.9 1.6l8.5-5.8c4.1-2.7 9.6-1.7 12.3 2.4l.2.3c2.7 4.1 1.7 9.6-2.4 12.3l-10.4 7.1a4 4 0 0 0-1.2 5.4c7 11 14.9 21.5 23.7 31.3 1.5 1.7 4.2 1.8 5.8.2l7.5-7.5c3.5-3.5 9.1-3.5 12.5 0l.3.3c3.5 3.5 3.5 9.1 0 12.5l-7.5 7.5c-1.6 1.6-1.5 4.3.2 5.8 10.2 9.1 21 17.3 32.5 24.4a4 4 0 0 0 5.4-1.2l6.9-10.2c2.7-4.1 8.3-5.1 12.3-2.4l.3.2c4.1 2.7 5.1 8.3 2.4 12.3l-5.5 8.1c-1.4 2-.6 4.8 1.6 5.9 4.1 1.9 8.2 3.8 12.4 5.5 7.1 2.9 14.3 5.4 21.7 7.6 2.1.6 4.3-.5 5-2.6l3.5-10.8c1.5-4.7 6.5-7.2 11.2-5.7l.4.1c4.7 1.5 7.2 6.5 5.7 11.2l-2.8 8.8c-.7 2.3.7 4.7 3.1 5.2 7.1 1.3 14.3 2.3 21.5 2.9.1-2.6.2-5.3.2-7.9 0-114.9-93.1-208-208-208-2.7 0-5.3.1-8 .2.7 7.7 1.7 15.3 3.1 22.9.4 2.5 2.9 3.9 5.2 3.2zM258 447.2c-.4-2.4-2.8-3.9-5.2-3.2l-11.6 3.7c-4.7 1.5-9.7-1.1-11.2-5.7l-.1-.4c-1.5-4.7 1.1-9.7 5.7-11.2l13.8-4.4c2-.7 3.2-2.8 2.6-4.9-2.3-7.9-5-15.6-8.1-23.3-1.6-4-3.3-7.9-5.2-11.8-1-2.2-3.8-3-5.9-1.6l-10.9 7.4c-4.1 2.7-9.6 1.7-12.3-2.4l-.2-.3c-2.7-4.1-1.7-9.6 2.4-12.3l13-8.8a4 4 0 0 0 1.2-5.4c-7.2-11.7-15.5-22.7-24.8-33.1-1.5-1.7-4.2-1.8-5.8-.2l-9.9 9.9c-3.5 3.5-9.1 3.5-12.5 0l-.3-.3c-3.5-3.5-3.5-9.1 0-12.5l9.9-9.9c1.6-1.6 1.5-4.3-.2-5.8-10-9-20.6-17-31.9-24a4 4 0 0 0-5.4 1.2l-9 13.3c-2.7 4.1-8.3 5.1-12.3 2.4l-.3-.2c-4.1-2.7-5.1-8.3-2.4-12.3l7.6-11.3c1.4-2 .6-4.8-1.6-5.9-4.3-2.1-8.6-4-13.1-5.8-7.3-2.9-14.6-5.5-22.1-7.7-2-.6-4.3.6-4.9 2.6l-4.6 14.4c-1.5 4.7-6.5 7.2-11.2 5.7l-.4-.1c-4.7-1.5-7.2-6.5-5.7-11.2l4-12.4c.7-2.3-.7-4.8-3.1-5.2-5.8-1-11.7-1.8-17.6-2.4-.1 0-.3 0-.4-.1v4.2c0 114.9 93.1 208 208 208h4.2c0-.1-.1-.3-.1-.4-.5-5.4-1.2-10.9-2.1-16.3z"}},{"tag":"path","attr":{"d":"M431.1 280.9l-5.9 18.4c-1.5 4.7-6.5 7.2-11.2 5.7l-.4-.1c-4.7-1.5-7.2-6.5-5.7-11.2l5.3-16.6c.7-2.1-.5-4.4-2.7-5.1-13.5-4-26.8-9.2-39.7-15.6-1.8-.9-4-.3-5.1 1.3l-10.5 15.4c-2.7 4.1-8.3 5.1-12.3 2.4l-.3-.2c-4.1-2.7-5.1-8.3-2.4-12.3l9.2-13.6c1.3-1.9.7-4.4-1.2-5.6-12.3-7.7-24.1-16.6-35.2-26.7-1.6-1.4-4-1.4-5.5.1L294.7 230c-3.5 3.5-9.1 3.5-12.5 0l-.3-.3c-3.5-3.5-3.5-9.1 0-12.5l12.8-12.8c1.5-1.5 1.6-3.9.1-5.5-9.7-10.8-18.4-22.2-26-34-1.2-1.9-3.8-2.5-5.6-1.2l-13.3 9c-4.1 2.7-9.6 1.7-12.3-2.4l-.2-.3c-2.7-4.1-1.7-9.6 2.4-12.3l15.1-10.2c1.7-1.1 2.2-3.3 1.3-5.1-6.4-12.9-11.7-26.2-15.8-39.7-.7-2.1-2.9-3.4-5.1-2.7l-15.9 5.1c-4.7 1.5-9.7-1.1-11.2-5.7l-.1-.4c-1.5-4.7 1.1-9.7 5.7-11.2l17.6-5.6c1.9-.6 3.1-2.6 2.7-4.6-1.8-9.2-3.1-18.6-3.9-27.9-95.4 11.8-170.8 88.2-181 184.1h1c7.5.7 15 1.8 22.4 3.2 2 .4 4-.8 4.6-2.7l4.7-14.8c1.5-4.7 6.5-7.2 11.2-5.7l.4.1c4.7 1.5 7.2 6.5 5.7 11.2l-4.2 13c-.7 2.2.5 4.4 2.7 5.1 13.9 4.1 27.5 9.4 40.7 16 1.8.9 4 .3 5.1-1.3l8.3-12.3c2.7-4.1 8.3-5.1 12.3-2.4l.3.2c4.1 2.7 5.1 8.3 2.4 12.3l-7.1 10.5c-1.3 1.9-.7 4.4 1.2 5.6 12.1 7.7 23.7 16.4 34.6 26.3 1.6 1.4 4 1.4 5.5-.1l10.4-10.4c3.5-3.5 9.1-3.5 12.5 0l.3.3c3.5 3.5 3.5 9.1 0 12.5L214 310.8c-1.5 1.5-1.6 3.9-.1 5.5 10.2 11.3 19.2 23.3 27 35.8 1.2 2 3.7 2.5 5.7 1.2l10.8-7.3c4.1-2.7 9.6-1.7 12.3 2.4l.2.3c2.7 4.1 1.7 9.6-2.4 12.3l-12.7 8.6c-1.7 1.1-2.2 3.3-1.3 5.1 6.4 13.2 11.7 26.7 15.7 40.6.6 2.2 2.9 3.4 5.1 2.7l13.6-4.4c4.7-1.5 9.7 1.1 11.2 5.7l.1.4c1.5 4.7-1.1 9.7-5.7 11.2l-15.6 5c-1.9.6-3.1 2.6-2.7 4.6 1.3 7 2.3 14.1 3 21.2v1c95.9-10.2 172.3-85.6 184.1-181-8.9-.7-17.9-1.9-26.7-3.6-1.9-.3-3.9.9-4.5 2.8z"}}]})(props);
	};
	module.exports.IoIosBaseball.displayName = "IoIosBaseball";
	module.exports.IoIosBasket = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M387.9 373.7h49.2l17.5-75.4h-66.7zM387.9 448h.5c18.7 0 33.4-12.5 38.3-29.5l6-25.9h-44.8V448zM265.4 392.5h103.7V448H265.4zM75 373.7h49v-75.4H57.5zM142.9 192h103.7v87.5H142.9zM265.4 192h103.7v87.5H265.4zM85.5 418.3c4.7 17 19.4 29.7 38.1 29.7h.5v-55.5H79.4l6.1 25.8zM142.9 392.5h103.7V448H142.9zM265.4 298.3h103.7v75.4H265.4zM142.9 298.3h103.7v75.4H142.9z"}},{"tag":"path","attr":{"d":"M464 192h-47.9V96c0-17.6-14.4-32-32-32H127.9c-17.6 0-32 14.4-32 32v96H48c-10.3 0-17.9 9.6-15.6 19.6l19.7 67.9H124V106c0-7.7 6.3-14 14-14h236c7.7 0 14 6.3 14 14v173.5h72l19.6-67.9c2.3-10-5.3-19.6-15.6-19.6z"}}]})(props);
	};
	module.exports.IoIosBasket.displayName = "IoIosBasket";
	module.exports.IoIosBasketball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M218.6 306.4c14.3-11.8 28.3-24.4 41.4-37.6l6.1-6.1c-2.8-2.9-5.6-5.8-8.3-8.5-49.9-49.9-107.7-89.6-171.8-118.1-18.4 26.1-31 56.6-35.8 89.6 32.2 2.3 63.2 10.5 92.2 24.5 28.8 13.9 54.4 32.8 76.2 56.2zM326.1 185.6c.5.5 1.1 1.1 1.7 1.6 20.9-30.5 38.8-63.2 53.5-97.4-33.8-25.5-75.6-41-121-41.9 2.4 22.3 8 44.1 16.7 64.7 11.5 27.4 28.1 52 49.1 73zM399 234.8c20.7 8.8 42.6 14.4 65 16.7-1.2-56.3-24.8-107.1-62.2-143.9-15 33.8-33.3 66.3-54.4 96.8 15.8 12.4 33.2 22.6 51.6 30.4zM193.9 318.1c-21.1-21.1-45.6-37.6-72.9-49.2-23.2-9.8-47.7-15.6-72.9-17.4 0 1.5-.1 3-.1 4.4 0 48.7 16.7 93.5 44.8 128.9 37.3-17 72.7-37.9 105.4-62.4-1.5-1.4-2.9-2.9-4.3-4.3zM283.8 243.6c10.1-11.3 19.7-23.1 28.8-35.1-44.5-42.3-72.1-98.6-78.2-159.5-51.9 5.4-98.1 29.8-131.5 66.2 33.4 15.3 65.5 33.8 95.6 55.1 30.5 21.7 59.2 46.3 85.3 73.3zM301.4 262.8c38.9 44 70.9 93.2 95.3 146.4 36.4-33.5 60.9-79.8 66.2-131.7-47.7-4.7-92.8-22.6-130.8-52-9.6 12.7-20 25.3-30.7 37.3zM235.3 326.2c29.9 39.5 47.5 86.2 51 135.6 33-4.8 63.5-17.4 89.5-35.8-23.4-52.6-54.3-101-92.2-144.2-15.2 15.6-31.4 30.5-48.3 44.4zM214.9 342.3c-32.4 24.4-67.4 45.5-104 62.8 37.5 36.5 88.6 59 145.1 59 1.5 0 3 0 4.5-.1-1.8-25.2-7.6-49.7-17.4-72.9-7.4-17.5-16.8-33.8-28.2-48.8z"}}]})(props);
	};
	module.exports.IoIosBasketball.displayName = "IoIosBasketball";
	module.exports.IoIosBatteryCharging = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 144H64c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h332c26.4 0 48-21.6 48-48V192c0-26.4-21.6-48-48-48zm20 176c0 11-9 20-20 20H64c-11 0-20-9-20-20V192c0-11 9-20 20-20h332c11 0 20 9 20 20v128zM464 204.6v102.8c16 0 32-27.7 32-51.4s-16-51.4-32-51.4z"}},{"tag":"path","attr":{"d":"M384 192H76c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h308c6.6 0 12-5.4 12-12V204c0-6.6-5.4-12-12-12zM218.8 308l8.4-43H200l45.2-61-8.4 43H264l-45.2 61z"}}]})(props);
	};
	module.exports.IoIosBatteryCharging.displayName = "IoIosBatteryCharging";
	module.exports.IoIosBatteryDead = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 144H64c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h332c26.4 0 48-21.6 48-48V192c0-26.4-21.6-48-48-48zm20 176c0 11-9 20-20 20H64c-11 0-20-9-20-20V192c0-11 9-20 20-20h332c11 0 20 9 20 20v128zM464 204.6v102.8c16 0 32-27.7 32-51.4s-16-51.4-32-51.4z"}}]})(props);
	};
	module.exports.IoIosBatteryDead.displayName = "IoIosBatteryDead";
	module.exports.IoIosBatteryFull = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 144H64c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h332c26.4 0 48-21.6 48-48V192c0-26.4-21.6-48-48-48zm20 176c0 11-9 20-20 20H64c-11 0-20-9-20-20V192c0-11 9-20 20-20h332c11 0 20 9 20 20v128zM464 204.6v102.8c16 0 32-27.7 32-51.4s-16-51.4-32-51.4z"}},{"tag":"path","attr":{"d":"M384 192H76c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h308c6.6 0 12-5.4 12-12V204c0-6.6-5.4-12-12-12z"}}]})(props);
	};
	module.exports.IoIosBatteryFull.displayName = "IoIosBatteryFull";
	module.exports.IoIosBeaker = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M445.2 48H128.5C74.1 48 64 75.9 64 88.2c30.3 4.2 32 4.2 32 36.2v275.5c0 35.3 28.9 64 64.2 64H368c35.4 0 63-29.2 63-64.5V89.2c2-17.5 12.5-31.6 13.6-33.3 1.2-1.9 3.4-4.4 3.4-5.5 0-1.2-.3-2.4-2.8-2.4zm-333 29.3c0-.1 0-.1 0 0 6-1 12-1.3 16.3-1.3H405c-.9 3.7-1.5 7.1-1.8 10-.1 1.1-.2 2.1-.2 3.2v70.9-.1H124v-35.5c0-17.6 0-34.2-11.8-47.2z"}}]})(props);
	};
	module.exports.IoIosBeaker.displayName = "IoIosBeaker";
	module.exports.IoIosBed = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458.2 208h-.4c-12 0-21.8 9.8-21.8 21.8 0 1.2-1 2.2-2.2 2.2H78.2c-1.2 0-2.2-1-2.2-2.2 0-12-9.8-21.8-21.8-21.8h-.4c-12 0-21.8 9.8-21.8 21.8v180.4c0 12 9.8 21.8 21.8 21.8h.4c12 0 21.8-9.8 21.8-21.8V404c0-2.2 1.8-4 4-4h352c2.2 0 4 1.8 4 4v6.2c0 12 9.8 21.8 21.8 21.8h.4c12 0 21.8-9.8 21.8-21.8V229.8c0-12-9.8-21.8-21.8-21.8z"}},{"tag":"path","attr":{"d":"M84 214h22.5c2.2 0 4-1.8 4-4v-13c0-8.8 7.2-16 16-16H224c8.8 0 16 7.2 16 16v13c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-13c0-8.8 7.2-16 16-16h97.5c8.8 0 16 7.2 16 16v13c0 2.2 1.8 4 4 4H428c4.4 0 8-3.6 8-8v-94c0-17.6-14.4-32-32-32H108c-17.6 0-32 14.4-32 32v94c0 4.4 3.6 8 8 8z"}}]})(props);
	};
	module.exports.IoIosBed.displayName = "IoIosBed";
	module.exports.IoIosBeer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112 162c0-13.3 10.7-24 24-24h229.5c4.9 0 9.6 1.5 13.5 4.4 2 1.5 4.9 0 4.8-2.5-.1-5.7-.2-9.3-.2-21.6 0-20.8-17.2-38.3-38.1-38.3h-.2c-5.7-.4-10.8-4-12.9-9.3-9-22.6-32.3-38.6-56.4-38.6-21 0-34.2 7-44 18.3-4.4 5-11.8 5.9-17.4 2.4-7.3-4.6-16.1-7.1-25.5-7.1-14.4 0-27.2 7.1-35.8 17.4-4 4.9-10.4 7-16.6 5.9-5.2-1-12.6-1.8-22.7-1.8-25 0-50 16.6-50 42.4v4c0 28.8 16 22.9 16 41.8v50.8c0 13.4-11.2 19.3-11.2 35.2 0 8.8 8 16.8 16.8 16.8H112V162zM386 452H110c-7.7 0-14 6.3-14 14s6.3 14 14 14h276c7.7 0 14-6.3 14-14s-6.3-14-14-14z"}},{"tag":"path","attr":{"d":"M400 194h-32v-24c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v213.8c0 12.1-1.1 18.2-3.2 30.1l-.1.5c-.8 4.7.2 9.5 2.8 13.5 3.4 5.1 9.1 8.2 15.3 8.2h213.9c4.1 0 8.1-1.4 11.1-4.1 4.7-4.1 6.5-10.3 5.2-16-2.7-11.8-4.5-17.8-4.8-29.9H400c26.4 0 48-21.6 48-48v-96c0-26.5-21.6-48.1-48-48.1zm20 144c0 11-9 20-20 20h-32V222h32c11 0 20 9 20 20v96z"}}]})(props);
	};
	module.exports.IoIosBeer.displayName = "IoIosBeer";
	module.exports.IoIosBicycle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M125.3 289.3c17.3 0 33.7 6.8 46.1 19.2 12.4 12.4 19.2 28.8 19.2 46.1s-6.8 33.7-19.2 46.1c-12.4 12.4-28.8 19.2-46.1 19.2s-33.7-6.8-46.1-19.2C66.8 388.4 60 372 60 354.7s6.8-33.7 19.2-46.1c12.4-12.4 28.8-19.3 46.1-19.3m0-28c-51.3 0-93.3 42-93.3 93.3C32 406 74 448 125.3 448s93.3-42 93.3-93.3c.1-51.4-41.9-93.4-93.3-93.4zM319.8 127.8c17.8 0 32-14.2 32-32S337.8 64 320 64s-32.2 14-32.2 31.8c0 17.7 14.3 32 32 32zM386.7 289.3c17.3 0 33.7 6.8 46.1 19.2 12.4 12.4 19.2 28.8 19.2 46.1s-6.8 33.7-19.2 46.1C420.4 413.2 404 420 386.7 420s-33.7-6.8-46.1-19.2c-12.4-12.4-19.2-28.8-19.2-46.1s6.8-33.7 19.2-46.1c12.3-12.4 28.7-19.3 46.1-19.3m0-28c-51.3 0-93.3 42-93.3 93.3s42 93.3 93.3 93.3 93.3-42 93.3-93.3-42-93.3-93.3-93.3z"}},{"tag":"path","attr":{"d":"M368 192h-48l-29.5-60.1c-5.6-9.3-15.9-15.9-27.1-15.9-8.4 0-16.8 3.7-22.4 9.3l-71.7 69.1c-5.6 5.6-9.3 14-9.3 22.4 0 17.4 12.6 23.6 18.5 27.1C224 270.1 240 273 240 286.1V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-90c0-13.2-30.4-24-48.3-38l48.9-51.5c18.7 28.5 27.3 51.5 38 51.5H368c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}}]})(props);
	};
	module.exports.IoIosBicycle.displayName = "IoIosBicycle";
	module.exports.IoIosBluetooth = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378.5 333l-88.3-77 88.2-76.1c6.9-6 7.4-16.3 1.1-22.9L262.7 35.6c-2.2-2.3-5.4-3.6-8.6-3.6-6.1 0-11.1 4.9-11.1 10.8V212l-86.3-73.3c-7.1-6-17.8-5.3-24.1 1.5-6.5 7-5.8 17.9 1.6 24.1L243 256l-108.1 90.9c-7.3 6.1-8.1 16.8-1.7 23.9l.3.3c6.3 7 17.3 7.7 24.5 1.5l85-73.6v169.8c0 6.2 5.1 11.2 11.5 11.2 3.2 0 6.2-1.3 8.4-3.5L379.6 356c6.3-6.6 5.8-16.9-1.1-23zm-99.1-232.1l62.7 65.9c.8.8.7 2.1-.2 2.9l-62.7 53c-1.3 1.1-3.4.2-3.4-1.5V102.3c.1-1.9 2.4-2.7 3.6-1.4zm-3.5 309V291.6c0-1.7 2.1-2.6 3.4-1.5l62.7 53c.9.7.9 2 .2 2.9l-62.7 65.3c-1.3 1.3-3.6.4-3.6-1.4z"}}]})(props);
	};
	module.exports.IoIosBluetooth.displayName = "IoIosBluetooth";
	module.exports.IoIosBoat = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M351.8 422c-26.2 9.2-66.5 14.9-96.1 14.9-29.6 0-69.9-5.7-96.1-14.9 0 0-26.1 23.9-62.3 36.2-2.3.8-1.5 4.2.9 3.9 22.6-2.6 40.2-6.5 61.4-12 23 9 66.7 13.9 96.1 13.9 29.4 0 74.1-3.8 96.1-13.9 21.5 5.6 38.8 9.6 62 12.1 2.4.3 3.2-3.1.9-3.9-35.7-12.4-62.9-36.3-62.9-36.3zM445.5 263l-186.2-85.5c-2.1-1-4.6-1-6.7 0L66.5 263c-6.2 2.9-10.5 9.1-10.5 16.4 0 2.4.5 4.6 1.3 6.7L112 422c27.5 0 56.7-22 56.7-22 18 9 53.1 17.1 79.3 18.6 2.8.2 5.5.2 8 .2s5.2-.1 8-.2c26.2-1.5 61.3-9.5 79.3-18.6 0 0 29.2 22 56.7 22l54.7-135.9c.8-2.1 1.3-4.3 1.3-6.7 0-7.3-4.3-13.5-10.5-16.4zM212 288c-6.6 0-12-9.8-12-22s5.4-22 12-22 12 9.8 12 22-5.4 22-12 22zm88 0c-6.6 0-12-9.8-12-22s5.4-22 12-22 12 9.8 12 22-5.4 22-12 22z"}},{"tag":"path","attr":{"d":"M391.9 127v-.1C386.3 100.3 374.4 80 352 80h-34.6l-2-8c-3.6-14.1-16.4-24-31-24h-57c-14.6 0-27.4 9.9-31 24.1l-2 7.9H160c-22.9 0-35.1 20.7-39.8 47L102 223.8c-.6 3.2 2.6 5.7 5.6 4.4l25.3-11.6c1.2-.5 2-1.6 2.3-2.9l16.2-85.6c2.5-10.7 7.3-16 16.1-16h177.1c8.9 0 13.1 5 16.1 16l16.2 85.6c.2 1.3 1.1 2.4 2.3 2.9l25.4 11.7c3 1.4 6.2-1.2 5.6-4.4L391.9 127z"}}]})(props);
	};
	module.exports.IoIosBoat.displayName = "IoIosBoat";
	module.exports.IoIosBody = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"256","cy":"80","rx":"48","ry":"48"}},{"tag":"path","attr":{"d":"M424 144H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h98.5c5.6 1 13.2 3.8 17.2 14.2 4.7 12.1 2.4 33.6-.5 51.7l-3.8 21.4c0 .1 0 .2-.1.3l-30.4 172.2c-2.3 13 6.4 25.5 19.5 27.8 13.1 2.3 25.3-6.4 27.6-19.5l21-119.9v.2s6.2-32.5 18.5-32.5h1.1c12.5 0 18.5 32.5 18.5 32.5v-.1l21 119.9c2.3 13 14.7 21.7 27.7 19.4 13.1-2.3 21.7-14.8 19.4-27.8l-30.4-172.2c0-.1 0-.2-.1-.3l-3.8-21.4c-2.9-18.1-5.2-39.6-.5-51.7 4-10.4 11.6-13.2 17.2-14.2H424c13.3 0 24-10.7 24-24s-10.7-24-24-24z"}}]})(props);
	};
	module.exports.IoIosBody.displayName = "IoIosBody";
	module.exports.IoIosBonfire = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M270.9 350.6c-.7-8.2-7.6-14.6-15.9-14.6-7.6 0-14 5.4-15.6 12.5L223.8 427c-.5 2.3-.8 4.6-.8 7 0 17.7 14.3 30 32 30s32-12.3 32-30c0-2.9-.4-5.7-1.1-8.4l-15-75zM305.9 355zM388.9 386.3c-1.7-1.4-3.3-2.9-5.1-3.9l-59.6-43.5c-5.8-3.8-12-3.7-16.5.9-4.1 4.1-4.7 10.4-1.7 15.4l45 61.8c.9 1.5 2.2 2.8 3.4 4.2 7.8 9.1 25.1 9.6 34.6 0 9.4-9.8 9.3-27.2-.1-34.9zM372.5 335zM435.4 320h-59.5c-3.9 0-7.4 2.2-8.1 6.2-.6 3.6 1.3 7.1 4.7 8.8h.1l57.7 17.8c8.3 1.9 17.7-5.5 17.7-14.8 0-11.8-4.8-18-12.6-18zM139.2 335zM139.2 335c3.3-1.6 5.3-5.2 4.7-8.8-.7-4-3.9-6.2-8.1-6.2H76.3c-7.6 0-12.3 8.3-12.3 17.6s9.1 17.1 17.4 15.2l57.7-17.8h.1zM187.9 338.8l-59.6 43.4c-1.8 1.1-3.6 2.4-5.1 3.9-9.6 9.6-9.6 25.1 0 34.6 9.6 9.6 25.1 9.6 34.6 0 1.3-1.3 2.4-2.7 3.4-4.2l45-61.6c3-5 2.5-11.2-1.7-15.3-4.6-4.5-11.8-4.8-16.6-.8zM358.7 138.7c0-57.6-72.4-90.7-96-90.7 12 80.8-101.7 113-112 181.3-10.3 68.3 48 90.7 48 90.7 16.3-56.6 72.4-75.6 109.7-99.8 40.7-26.4 50.3-51.3 50.3-81.5zM358.7 259.6c5-14.7 1.9-49.3-3-63.4-9 17.5-26.3 32.4-47.2 46-8.6 5.6-20.9 10.8-29.8 15.9-18.7 10.5-34 20.6-46.3 34.4 11.3 16.4 31.3 27.7 46.3 27.7 36-.2 64-13.7 80-60.6z"}},{"tag":"path","attr":{"d":"M161.8 171.9c11.7-15.1 24.9-23.8 38.2-36.2 13.4-12.5 22.1-21.2 27.5-31.3-10.7-20.1-30.8-28.1-44.7-26.1 2.3 28.6-30 44-32 64.8-1.3 12.6 5.4 25 11 28.8z"}}]})(props);
	};
	module.exports.IoIosBonfire.displayName = "IoIosBonfire";
	module.exports.IoIosBook = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M146 64.1c54.1 0 100 27.9 100 82V446c0 2.2-3.1 2.7-3.8.7v-.1c-10.3-34.2-38.2-67.6-82.3-70.5-34.2-2.2-66.9 12.9-93.1 37.1-1.6 1.5-4.3 2.9-6.6 2.9h-4.5c-3.7 0-7.6-2.7-7.6-6.1V120.2C48 88.1 91.9 64.1 146 64.1zM366 64c-54.1 0-100 27.9-100 82v299.9c0 2.2 3.1 2.7 3.8.7v-.1c10.3-34.2 39.4-67.9 82.3-70.5 32.9-2 63.9 11 93.1 37.1 1.6 1.4 4.3 2.9 6.6 2.9h4.5c3.7 0 7.6-2.7 7.6-6.1V120c.1-32-43.8-56-97.9-56z"}}]})(props);
	};
	module.exports.IoIosBook.displayName = "IoIosBook";
	module.exports.IoIosBookmark = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 80v380c0 3.3 3.8 5.2 6.4 3.2l116.8-92c2.9-2.1 6.8-2.1 9.6 0l116.8 92c2.6 2 6.4.1 6.4-3.2V80c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.IoIosBookmark.displayName = "IoIosBookmark";
	module.exports.IoIosBookmarks = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 32v127.9l-22.9-14.5-9.1-6.4-9.1 6.4-22.9 14.5V32h-41.4c-22.5.2-40.6 18.8-40.6 41.4v313.2c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14V73.4c0-22.6-18.1-41.2-40.6-41.4H95.1C64.8 32 40 56.8 40 87.1v289.8c0 30.3 24.8 55.1 55.1 55.1l108-.1c4.2.1 8.3.6 12.2 1.4 15.3 3.1 26.8 16.6 26.6 32.2-.1 7.2 5.2 13.6 12.4 14.4 8.5.9 15.7-5.7 15.6-14.1-.2-15.8 11.4-29.4 26.9-32.5 3.8-.8 7.9-1.2 12-1.3l108 .1c30.3 0 55.1-24.8 55.1-55.1V87.1C472 56.8 446.3 32 416 32z"}}]})(props);
	};
	module.exports.IoIosBookmarks.displayName = "IoIosBookmarks";
	module.exports.IoIosBowtie = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.8 213.5C286 205 277 202.2 266 202.2v-.2c-6 0-14.3 1.3-22.6 2.9-11.9 2.3-19.7 7.1-19.7 7.1s3.6 27.3.1 58.5-7.9 42.5-7.9 42.5 5.3 12.1 40 15c3.9.3 7.6.5 11 .5 24.5 0 36.4-7.3 36.4-7.3s3.3-5.4 4.3-22.1c1.9-32.2-7-68.5-16.8-85.6zM205.7 208.8c-22-40.2-86.2-96.8-121.3-96.8C57.9 112 32 180.5 32 256s23 144 51.5 144c33.4 0 110.5-80 110.5-80s5.7-12.6 9.9-33.6l1.8-10.4c.7-4.7 1.3-9.7 1.7-15 .3-3.5.5-6.8.6-9.9l.3-9.8c.7-16-2.6-32.5-2.6-32.5zM427.6 112c-36.4 0-96.4 56.5-118.3 96.8l-.8 1.4s1.4 2.5 1.9 3.4c3.4 6 6.7 14.3 9.4 24l2.9 11.7c2.2 10.2 3.7 21.2 4.2 32.2l.2 9c0 2.9-.1 5.7-.3 8.5-1 16.7-4.6 22.1-4.6 22.1 7.6 10.5 69 78.9 106.2 78.9 28.5 0 51.5-68.5 51.5-144s-25.8-144-52.3-144z"}}]})(props);
	};
	module.exports.IoIosBowtie.displayName = "IoIosBowtie";
	module.exports.IoIosBriefcase = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 448h352c17.7 0 32-14.3 32-32V224H48v192c0 17.7 14.3 32 32 32zM432 128h-8v-8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v8h-28V96c0-17.6-14.4-32-32-32H196c-17.6 0-32 14.4-32 32v32h-28v-8c0-4.4-3.6-8-8-8H96c-4.4 0-8 3.6-8 8v8h-8c-17.7 0-32 14.3-32 32v40h416v-40c0-17.7-14.3-32-32-32zm-112 0H192v-28c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v28z"}}]})(props);
	};
	module.exports.IoIosBriefcase.displayName = "IoIosBriefcase";
	module.exports.IoIosBrowsers = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 181.4V424c0 22.1 17.9 40 40 40h242.6c22.1 0 40-17.9 40-40V181.4c0-22.1-17.9-40-40-40H88c-22.1 0-40 17.9-40 40z"}},{"tag":"path","attr":{"d":"M141.4 88v28.4c0 2.2 1.8 4 4 4h198.2c26.4 0 48 21.6 48 48v198.2c0 2.2 1.8 4 4 4H424c22.1 0 40-17.9 40-40V88c0-22.1-17.9-40-40-40H181.4c-22.1 0-40 17.9-40 40z"}}]})(props);
	};
	module.exports.IoIosBrowsers.displayName = "IoIosBrowsers";
	module.exports.IoIosBrush = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.6 283.3c-51.9 0-83.9 45.7-83.9 95.1 0 21.3-10.9 37.1-31.4 46.4-2.2 1-3 3.8-1.7 5.8 16.7 24.6 63.3 33.3 95.3 33.3 8.4 0 15.9-.6 21.8-1.7 35.6-6.4 80.1-24.9 90.7-77 12.2-60.5-38.9-101.9-90.8-101.9z"}},{"tag":"path","attr":{"d":"M467.7 60.4C460 52.7 450.9 48 441.6 48c-6.3 0-12.7 2.2-18.8 7L257.7 200.3c-5.4 4.8-12.4 7.4-19.7 7.4h-.1-.1c-5.6 0-11.1 2.1-15.4 5.8l-53.6 43.8c-2.1 1.8-2.7 4.8-1.4 7.2.9 1.7 2.6 2.9 4.5 3.1 45.6 4.5 87 37 87.3 86.6 0 1.7.7 3.4 2 4.5 2.5 2.1 6 1.7 8-.6l45.1-52.2c3.5-4 5.8-9.1 6-14.5v-1.2c0-7.5 3-14.8 8-20.4l144.8-164.4c11.9-15.1 7.6-32.1-5.4-45z"}}]})(props);
	};
	module.exports.IoIosBrush.displayName = "IoIosBrush";
	module.exports.IoIosBug = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M374.6 127.3C345.4 88.5 303.1 64 256 64c-47.1 0-89.4 24.5-118.6 63.3 6.4 15.6 15.8 30 28.1 42.3 24.2 24.2 56.3 37.5 90.5 37.5s66.3-13.3 90.5-37.5c12.3-12.3 21.8-26.6 28.1-42.3z"}},{"tag":"path","attr":{"d":"M122 150s-3.8-1.6-5.9-3.3c-2.1-1.7-5-4.9-6.5-8.4 5.4-11.3 1.2-25-9.9-31.3-11.8-6.6-26.9-2.2-33.1 10-4.5 8.9-2.9 19.8 3.8 27.1 1.8 1.9 3.7 3.4 5.7 4.6 2.8 1.6 4.9 4 6.4 6.8 2.7 5.2 6.4 10.7 11.1 14.6 4.2 3.5 8.8 7.1 15.2 10.7-7.2 20.3-11.6 42.3-12.5 65.4-11 .2-18.6 2.1-25.5 4.1-4.2 1.2-8.2 3.4-11.8 5.9-1-.1-1.9-.2-2.9-.2-13.8 0-24.8 11.6-24 25.6.7 11.8 10.3 21.5 22.2 22.4 11 .8 20.6-5.9 24.3-15.5 2-5.3 6.7-9.2 12.4-9.9 1.9-.2 3.9-.4 6.2-.4 3.2 33 13.3 63.5 28.6 89.2-14.2 11-22.9 23-26.6 36.3 0 0-.8.4-1.9 1.4-1 .8-1.9 1.6-2.8 2.6-8.9 9.9-8.1 25 1.8 33.9 9.9 8.9 25 8.1 33.9-1.8 6.2-6.9 7.6-16.3 4.6-24.5-2.2-6-.7-12.7 3.9-17 1.6-1.5 3.5-3.1 5.7-4.9 27.1 31.7 59.4 52 99.7 54.4V232.9C190.8 230 144.4 195.3 122 150zM456 256.1c-1 0-2 .1-2.9.2-3.6-2.5-7.7-4.6-11.8-5.9-6.9-2-14.4-3.9-25.5-4.1-1-23.1-5.4-45.2-12.5-65.4 6.4-3.6 11-7.2 15.2-10.7 4.9-4.1 8.7-10 11.5-15.3 1.3-2.5 3.3-4.5 5.8-5.9 0 0 .1 0 .1-.1 11.6-6.5 15.7-21.1 9.2-32.7-6.5-11.6-21.1-15.7-32.7-9.2-11.1 6.2-15.3 19.9-9.9 31.3-1.6 3.4-3.4 5.7-6.5 8.4-2.3 2-5.9 4.3-5.9 4.3-22.4 45.3-68.8 79-122 81.9V448c40.3-2.4 72.6-22.8 99.7-54.4 2.1 1.7 3.9 3.2 5.4 4.6 4.8 4.4 6.4 11.3 4.2 17.5-3 8.1-1.5 17.5 4.7 24.3 8.9 9.9 24 10.7 33.9 1.8 9.9-8.9 10.7-24 1.8-33.9-.9-1-1.8-1.8-2.8-2.6-1.1-.9-1.9-1.4-1.9-1.4-3.7-13.3-12.4-25.3-26.6-36.3 15.3-25.7 25.4-56.2 28.6-89.2 2.1 0 4.1.2 5.9.4 5.9.7 10.7 4.7 12.9 10.2 3.7 9.4 13.2 15.9 24.1 15.1 11.8-.9 21.4-10.5 22.2-22.4.6-14-10.4-25.6-24.2-25.6z"}}]})(props);
	};
	module.exports.IoIosBug.displayName = "IoIosBug";
	module.exports.IoIosBuild = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.1 131.1l-44.9 45.1c-.9.9-2.3 1.3-3.5 1.1l-46.4-8.4c-1.6-.3-2.9-1.6-3.2-3.2l-8.3-46.4c-.2-1.3.2-2.6 1.1-3.5l44.8-45c3.5-3.5 3-9.3-1-12.1-10.1-7.2-22.1-10.7-31.8-10.7-.7 0-1.4 0-2 .1-12.5.7-39.3 7.7-60 29.7-20.1 21.2-41.1 60.6-22.5 104.5 2.2 5.3 4.7 12.3-2.7 19.7C253.1 209.4 61 390.3 61 390.3c-18 15.5-16.7 44.2-.1 60.9 8.5 8.4 20 12.8 31.3 12.8 11.1 0 21.9-4.2 29.6-13.1 0 0 179.4-191.1 188.2-199.8 4-3.9 7.7-5.1 11.1-5.1 3.3 0 6.3 1.2 8.6 2.4 9.9 5.1 21 7.4 32.4 7.4 26.8 0 55-12.4 72.2-29.6 24.4-24.4 28.9-48 29.6-60.1.6-9.9-2.2-22.6-10.7-34.2-2.9-3.8-8.6-4.2-12.1-.8zM102.5 429.3c-5.5 5.4-14.4 5.4-19.9 0-5.4-5.5-5.4-14.4 0-19.9 5.5-5.4 14.4-5.4 19.9 0 5.4 5.6 5.4 14.5 0 19.9z"}}]})(props);
	};
	module.exports.IoIosBuild.displayName = "IoIosBuild";
	module.exports.IoIosBulb = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404 188.9C404 111 333.9 48 256 48s-148 63.1-148 140.9c0 31 13.2 56.1 30.2 80.1h-.3c10.9 15 21.4 17.7 31.5 35 14.7 25.2 18.1 40.7 18.7 55.7.4 8.6 7.5 15.3 16 15.3h8.9c2.2 0 4-1.8 4-4v-94.5c0-5-1.2-9.8-3.4-14.3l-21-42c-3.5-7 1.6-15.2 9.4-15.2 4 0 7.7 2.3 9.4 5.9l25.3 51.4c2.2 4.4 3.3 9.2 3.3 14.1V371c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-94.6c0-4.9 1.1-9.7 3.3-14.1l25.4-51.6c1.7-3.4 5.2-5.6 9-5.6 7.5 0 12.4 7.9 9 14.6l-21.3 42.6c-2.2 4.5-3.4 9.4-3.4 14.3V371c0 2.2 1.8 4 4 4h10c8.5 0 15.5-6.6 16-15 .9-15.4 4.7-32.3 18.4-56 10.1-17.3 20.6-20 31.5-35h-.1c17-24 30.2-49.1 30.2-80.1zM238 464h36c7.7 0 14-6.3 14-14s-6.3-14-14-14h-36c-7.7 0-14 6.3-14 14s6.3 14 14 14zM218 420h76c7.7 0 14-6.3 14-14s-6.3-14-14-14h-76c-7.7 0-14 6.3-14 14s6.3 14 14 14z"}}]})(props);
	};
	module.exports.IoIosBulb.displayName = "IoIosBulb";
	module.exports.IoIosBus = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M109.6 416.7c-1.9-1.9-5.7-.5-5.6 2.2 1 21.5 1.4 29 5.5 29h55.1c4.4 0 3.3-11.5 3.3-22-34.3.1-46.9 2.3-58.3-9.2zM402.4 416.7c1.9-1.9 5.7-.5 5.6 2.2-1 21.5-1.4 29-5.5 29h-55.1c-4.4 0-3.3-11.5-3.3-22 34.3.1 46.9 2.3 58.3-9.2zM384 64H128c-17.6 0-32 14.4-32 32v276c0 22 18 40 40 40h240c22 0 40-18 40-40V96c0-17.6-14.4-32-32-32zM162 375.9c-14.8 1.2-27-11.1-25.9-25.9.9-11.6 10.3-21.1 22-22 14.8-1.2 27 11.1 25.9 25.9-1 11.7-10.4 21.1-22 22zm76-77.9h-97.8c-8.9 0-16.2-7.3-16.2-16.2V166.2c0-8.9 7.3-16.2 16.2-16.2H238c2.2 0 4 1.8 4 4v140c0 2.2-1.8 4-4 4zm115.9 77.9c-14.8 1.2-27-11.1-25.9-25.9.9-11.6 10.3-21.1 22-22 14.8-1.2 27 11.1 25.9 25.9-.9 11.7-10.3 21.1-22 22zM388 282c0 8.8-7.2 16-16 16h-98c-2.2 0-4-1.8-4-4V154c0-2.2 1.8-4 4-4h98c8.8 0 16 7.2 16 16v116zm-15-162H139c-8.8 0-15-6.3-15-14s6.2-14 15-14h234c8.8 0 15 6.3 15 14s-6.2 14-15 14z"}}]})(props);
	};
	module.exports.IoIosBus.displayName = "IoIosBus";
	module.exports.IoIosBusiness = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M146 80h220c9.9 0 18-8.1 18-18s-8.1-18-18-18H146c-9.9 0-18 8.1-18 18s8.1 18 18 18zM398 100H114c-9.9 0-18 8.1-18 18 0 9.3 6.9 17.1 16 18v300c0 13.2 10.8 24 24 24h88c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h88c13.2 0 24-10.8 24-24V136c9.1-.9 16-8.7 16-18 0-9.9-8.1-18-18-18zM192 364c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm80 192c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm80 192c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.IoIosBusiness.displayName = "IoIosBusiness";
	module.exports.IoIosCafe = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.7 404H110.1c-7.6 0-14.1 5.8-14.4 13.4-.4 8 6 14.6 14 14.6h259.6c7.6 0 14.1-5.8 14.4-13.4.3-8-6.1-14.6-14-14.6zM399.2 118.5c.1-10.8-4.2-20.9-12.2-28.4-7.2-6.6-16.7-10.1-26.5-10.1H86.8c-9.9 0-19.7 3.6-26.9 10.4-8.1 7.7-12.4 18.2-11.9 29.3C50.4 172 58.3 218 71.8 256.3c11 31.6 25.8 58.1 43.9 78.9 31.8 36.6 68.8 48.8 77.9 48.8h60.1c5.5 0 25-7.2 44.2-19.5 22.4-14.4 42.4-36.7 58.1-64.6 2 .1 4 .2 5.9.2 27.2 0 52.8-9.7 72.1-27.4 19.4-17.8 30.1-41.4 30.1-66.6-.1-38.9-25.9-73.5-64.9-87.6zm-29.7 153.1c14.2-34.5 23.6-76 27.8-123.4 0 0 0-.1.1 0 10.3 5 19.1 12.2 25.8 20.9 8.4 10.9 12.8 23.7 12.8 37 0 34-29.2 62.1-66.5 65.5z"}}]})(props);
	};
	module.exports.IoIosCafe.displayName = "IoIosCafe";
	module.exports.IoIosCalculator = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M372 48H140c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h232c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zm-12 272v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm-80 160c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm-80 160c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm-48-80v-48c0-8.8 7.2-16 16-16h176c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.IoIosCalculator.displayName = "IoIosCalculator";
	module.exports.IoIosCalendar = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 96h-40v24c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96H160v24c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96H88c-22 0-40 18-40 40v272c0 22 18 40 40 40h336c22 0 40-18 40-40V136c0-22-18-40-40-40zm8 300c0 11-9 20-20 20H100c-11 0-20-9-20-20V216c0-4.4 3.6-8 8-8h336c4.4 0 8 3.6 8 8v180zM160 72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h32V72zM384 72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h32V72z"}}]})(props);
	};
	module.exports.IoIosCalendar.displayName = "IoIosCalendar";
	module.exports.IoIosCall = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436.9 364.8c-14.7-14.7-50-36.8-67.4-45.1-20.2-9.7-27.6-9.5-41.9.8-11.9 8.6-19.6 16.6-33.3 13.6-13.7-2.9-40.7-23.4-66.9-49.5-26.2-26.2-46.6-53.2-49.5-66.9-2.9-13.8 5.1-21.4 13.6-33.3 10.3-14.3 10.6-21.7.8-41.9C184 125 162 89.8 147.2 75.1c-14.7-14.7-18-11.5-26.1-8.6 0 0-12 4.8-23.9 12.7-14.7 9.8-22.9 18-28.7 30.3-5.7 12.3-12.3 35.2 21.3 95 27.1 48.3 53.7 84.9 93.2 124.3l.1.1.1.1c39.5 39.5 76 66.1 124.3 93.2 59.8 33.6 82.7 27 95 21.3 12.3-5.7 20.5-13.9 30.3-28.7 7.9-11.9 12.7-23.9 12.7-23.9 2.9-8.1 6.2-11.4-8.6-26.1z"}}]})(props);
	};
	module.exports.IoIosCall.displayName = "IoIosCall";
	module.exports.IoIosCamera = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"275","r":"57.5"}},{"tag":"path","attr":{"d":"M417.5 160H363c-4.6 0-8.9-2-12-5.4-28.4-31.8-39.1-42.6-50.7-42.6h-85.5c-11.7 0-23.2 10.8-51.7 42.7-3 3.4-7.4 5.3-11.9 5.3h-4.1v-8c0-4.4-3.6-8-8-8h-26c-4.4 0-8 3.6-8 8v8h-7.5C79.9 160 64 173.2 64 190.7v176c0 17.5 15.9 33.3 33.5 33.3h320c17.6 0 30.5-15.8 30.5-33.3v-176c0-17.5-12.9-30.7-30.5-30.7zM260 360.4c-50.3 2.3-91.7-39.1-89.4-89.4 2-43.9 37.5-79.4 81.4-81.4 50.3-2.3 91.7 39.1 89.4 89.4-2 43.9-37.5 79.4-81.4 81.4zM352 218c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13z"}}]})(props);
	};
	module.exports.IoIosCamera.displayName = "IoIosCamera";
	module.exports.IoIosCar = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 196.2c-13.8-30.8-49-92.2-100-92.2H196c-51 0-84.8 59.4-100 92.2-24 23-48 45.7-48 84.8v76c0 3.7 2.6 7 6.2 7.8C69.1 368.2 116.4 375 256 375s186.9-6.8 201.8-10.2c3.6-.8 6.2-4.1 6.2-7.8v-76c0-39-22.3-63.1-48-84.8zM190 128h132c40.5 0 62 60 62 70H128c0-10 27-70 62-70zm-78 203.7c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32c0 17.6-14.3 32-32 32zM328 300c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16s7.2-16 16-16h112c8.8 0 16 7.2 16 16zm72 32c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM160 384c-47.9 0-96-5-96-5 0 17-.3 29 6 29h85c6.3 0 5-13.2 5-24zM352 384c48 0 96-5 96-5 0 16 2 29-5 29h-86c-6.7 0-5-13.5-5-24z"}}]})(props);
	};
	module.exports.IoIosCar.displayName = "IoIosCar";
	module.exports.IoIosCard = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128c0-17.6-14.4-32-32-32H64c-17.6 0-32 14.4-32 32v48h448v-48zM32 384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V224H32v160zm142-48h164c7.7 0 14 6.3 14 14s-6.3 14-14 14H174c-7.7 0-14-6.3-14-14s6.3-14 14-14zm-72 0h12c7.7 0 14 6.3 14 14s-6.3 14-14 14h-12c-7.7 0-14-6.3-14-14s6.3-14 14-14z"}}]})(props);
	};
	module.exports.IoIosCard.displayName = "IoIosCard";
	module.exports.IoIosCart = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"transform":"rotate(-1.057 159.995 423.97) scale(.99997)","cx":"160","cy":"424","rx":"24","ry":"24"}},{"tag":"ellipse","attr":{"transform":"matrix(.02382 -.9997 .9997 .02382 -48.51 798.282)","cx":"384.5","cy":"424","rx":"24","ry":"24"}},{"tag":"path","attr":{"d":"M463.8 132.2c-.7-2.4-2.8-4-5.2-4.2L132.9 96.5c-2.8-.3-6.2-2.1-7.5-4.7-3.8-7.1-6.2-11.1-12.2-18.6-7.7-9.4-22.2-9.1-48.8-9.3-9-.1-16.3 5.2-16.3 14.1 0 8.7 6.9 14.1 15.6 14.1s21.3.5 26 1.9c4.7 1.4 8.5 9.1 9.9 15.8 0 .1 0 .2.1.3.2 1.2 2 10.2 2 10.3l40 211.6c2.4 14.5 7.3 26.5 14.5 35.7 8.4 10.8 19.5 16.2 32.9 16.2h236.6c7.6 0 14.1-5.8 14.4-13.4.4-8-6-14.6-14-14.6H188.9c-2 0-4.9 0-8.3-2.8-3.5-3-8.3-9.9-11.5-26l-4.3-23.7c0-.3.1-.5.4-.6l277.7-47c2.6-.4 4.6-2.5 4.9-5.2l16-115.8c.2-.8.2-1.7 0-2.6z"}}]})(props);
	};
	module.exports.IoIosCart.displayName = "IoIosCart";
	module.exports.IoIosCash = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466 355.9H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h420c7.7 0 14-6.3 14-14s-6.3-14-14-14zM466 403.9H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h420c7.7 0 14-6.3 14-14s-6.3-14-14-14zM444.9 80.1H67.1C47.8 80.1 32 95.9 32 115.2V293c0 19.3 15.8 35.1 35.1 35.1h377.8c19.3 0 35.1-15.8 35.1-35.1V115.2c0-19.3-15.8-35.1-35.1-35.1zM114 296.1H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-156H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm142 144c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm178 12h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-156h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}},{"tag":"circle","attr":{"cx":"256","cy":"206","r":"53"}}]})(props);
	};
	module.exports.IoIosCash.displayName = "IoIosCash";
	module.exports.IoIosCellular = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408.4 51.8c-2.6-2.5-6.1-3.8-9.7-3.8-3.7 0-7.2 1.4-9.9 3.9-2.7 2.6-4.1 6-4.1 9.6 0 3.6 1.5 7 4.2 9.6 30.4 28.5 47.1 66.5 47.1 107.1 0 40.5-16.7 78.5-47.1 107.1-2.7 2.5-4.2 5.9-4.2 9.6 0 3.6 1.4 7 4.1 9.6 2.6 2.5 6.1 3.9 9.9 3.9 3.7 0 7.1-1.4 9.7-3.8C444.3 271 464 226.1 464 178.2v-.1c0-47.9-19.8-92.7-55.6-126.3z"}},{"tag":"path","attr":{"d":"M351 96.8c-2.4-2.3-5.6-3.5-9-3.5-3.3 0-6.5 1.2-8.9 3.4-2.5 2.3-3.9 5.4-3.9 8.7 0 3.3 1.3 6.4 3.8 8.7 18 17 27.8 39.8 27.8 64 0 24.2-9.9 47-27.8 64-2.5 2.3-3.8 5.4-3.8 8.7 0 3.3 1.4 6.4 3.9 8.7 2.4 2.2 5.5 3.4 8.9 3.4 3.4 0 6.6-1.3 9-3.5 22.8-21.7 35.4-50.5 35.4-81.3v-.1c0-30.7-12.6-59.5-35.4-81.2zM123.1 71.1c2.7-2.5 4.2-5.9 4.2-9.6 0-3.6-1.4-7-4.1-9.6-2.6-2.5-6.1-3.9-9.9-3.9-3.7 0-7.1 1.4-9.7 3.8C67.7 85.4 48 130.3 48 178.2v.2c0 47.8 19.8 92.6 55.6 126.2 2.6 2.5 6.1 3.8 9.7 3.8 3.7 0 7.2-1.4 9.9-3.9 2.7-2.6 4.1-6 4.1-9.6 0-3.6-1.5-7-4.2-9.6C92.7 256.8 76 218.8 76 178.2c-.1-40.6 16.7-78.6 47.1-107.1z"}},{"tag":"path","attr":{"d":"M179 114.1c2.5-2.3 3.8-5.4 3.8-8.7 0-3.3-1.4-6.4-3.9-8.7-2.4-2.2-5.5-3.4-8.9-3.4-3.4 0-6.6 1.3-9 3.5-22.8 21.7-35.4 50.5-35.4 81.3v.1c0 30.8 12.6 59.6 35.4 81.2 2.4 2.3 5.6 3.5 9 3.5 3.3 0 6.5-1.2 8.9-3.4 2.5-2.3 3.9-5.4 3.9-8.7 0-3.3-1.3-6.4-3.8-8.7-18-17-27.8-39.8-27.8-64-.1-24.2 9.8-46.9 27.8-64zM256 123.2c-26.5 0-48 21.5-48 48 0 21.6 14.3 39.9 34 45.9v233c0 7.7 6.3 13.9 14 13.9s14-6.2 14-13.9v-233c19.7-6 34-24.3 34-45.9 0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.IoIosCellular.displayName = "IoIosCellular";
	module.exports.IoIosChatboxes = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M425.9 170.4H204.3c-21 0-38.1 17.1-38.1 38.1v154.3c0 21 17.1 38 38.1 38h126.8c2.8 0 5.6 1.2 7.6 3.2l63 58.1c3.5 3.4 9.3 2 9.3-2.9v-50.6c0-6 3.8-7.9 9.8-7.9h1c21 0 42.1-16.9 42.1-38V208.5c.1-21.1-17-38.1-38-38.1z"}},{"tag":"path","attr":{"d":"M174.4 145.9h177.4V80.6c0-18-14.6-32.6-32.6-32.6H80.6C62.6 48 48 62.6 48 80.6v165.2c0 18 14.6 32.6 32.6 32.6h61.1v-99.9c.1-18 14.7-32.6 32.7-32.6z"}}]})(props);
	};
	module.exports.IoIosChatboxes.displayName = "IoIosChatboxes";
	module.exports.IoIosChatbubbles = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M431 320.6c0-4.4 1.2-8.6 3.3-12.2.6-1.1 1.4-2.1 2.1-3.1 17.4-26 27.6-57.1 27.6-90.3.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9-2.4 11.1-3.7 22.4-3.7 34.2 0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7 11.3-3.1 22.5-7.2 25.4-8.3 2.9-1.1 6.1-1.7 9.3-1.7 3.6 0 7 .7 10.1 2l56.7 20.1s2.4 1 3.9 1c4.4 0 8-3.5 8-8 0-1-.5-2.7-.5-2.7L431 320.6z"}},{"tag":"path","attr":{"d":"M318.5 392.5c-3.6 1-8.2 2.1-13.2 3.2-10.5 2.2-23.9 4.5-34 4.5-96.2 0-171-76.8-171-169.1 0-6.6.7-15 1.5-21.4.6-4.3 1.3-8.6 2.3-12.8 1-4.5 2.2-9 3.5-13.4l-8 7.1C66.8 219.2 48 260 48 302.5c0 29.3 8.5 57.5 24.8 82 2.3 3.5 3.6 6.2 3.2 8-.4 1.8-11.9 62-11.9 62-.6 2.9.5 5.8 2.7 7.7 1.5 1.2 3.3 1.8 5.1 1.8 1 0 2-.2 2.9-.6l56.1-22.1c1.8-.7 3.7-1.1 5.7-1.1 0 0 2.4-.2 6.3 1.3 18.9 7.4 39.8 12 60.7 12 46.6 0 90.4-20.1 120.1-55.1 0 0 3.2-4.4 6.9-9.6-3.7 1.3-7.9 2.6-12.1 3.7z"}}]})(props);
	};
	module.exports.IoIosChatbubbles.displayName = "IoIosChatbubbles";
	module.exports.IoIosCheckboxOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H96c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm4 348c0 4.4-3.6 8-8 8H100c-4.4 0-8-3.6-8-8V100c0-4.4 3.6-8 8-8h312c4.4 0 8 3.6 8 8v312z"}},{"tag":"path","attr":{"d":"M363.6 192.9L346 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"}}]})(props);
	};
	module.exports.IoIosCheckboxOutline.displayName = "IoIosCheckboxOutline";
	module.exports.IoIosCheckbox = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H96c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-52.5 134.5L229.8 332.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"}}]})(props);
	};
	module.exports.IoIosCheckbox.displayName = "IoIosCheckbox";
	module.exports.IoIosCheckmarkCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosCheckmarkCircleOutline.displayName = "IoIosCheckmarkCircleOutline";
	module.exports.IoIosCheckmarkCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm106.5 150.5L228.8 332.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"}}]})(props);
	};
	module.exports.IoIosCheckmarkCircle.displayName = "IoIosCheckmarkCircle";
	module.exports.IoIosCheckmark = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"}}]})(props);
	};
	module.exports.IoIosCheckmark.displayName = "IoIosCheckmark";
	module.exports.IoIosClipboard = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M140.5 160v240c0 8.8 7.2 16 16 16h200c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16h-200c-8.8 0-16 7.2-16 16zM321.5 81h-17c0-5.6-1-11-2.7-16-2.1-6-5.3-11.4-9.4-16-8.8-9.9-21.6-17-35.9-17s-27.1 7.1-35.9 17c-4.1 4.6-7.3 10-9.4 16-1.7 5-2.7 10.4-2.7 16H194c-9.6 0-17.5 7.9-17.5 17.5V114c0 1.1.9 2 2 2h156c1.1 0 2-.9 2-2V96c0-8.3-6.7-15-15-15zm-62.9 15.5c-10.5 1.3-19.3-7.5-17.9-17.9.9-7.1 6.7-12.9 13.8-13.8 10.5-1.3 19.3 7.5 17.9 17.9-.9 7.2-6.7 12.9-13.8 13.8z"}},{"tag":"path","attr":{"d":"M400 48h-75.2c-1.7 0-2.6 1.9-1.6 3.2 2.9 3.9 5.3 8.1 7 12.8.3.8 1 1.3 1.9 1.3h.5c18.7 0 26.9 14.9 27.5 33.5V114c0 1.1.9 2 2 2h20.3c8.8 0 16 7.2 16 16v297.4c0 8.8-7.2 16-16 16h-253c-8.8 0-16-7.2-16-16V132c0-8.8 7.2-16 16-16h21.3c1.1 0 2-.9 2-2v-8.8c0-19.1 5.6-36.7 27.6-36.7h.3c.9 0 1.8-.6 1.9-1.6 1.5-6.9 4.1-11.7 7.2-15.8 1-1.3.1-3.2-1.6-3.2l-76.3-.1C94.3 47.9 80 62.1 80 79.7V424c0 41.7 14.3 56 32 56h288.5c17.4 0 31.5-14.1 31.5-31.5V80c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.IoIosClipboard.displayName = "IoIosClipboard";
	module.exports.IoIosClock = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0-81.3 81.2-81.2 212.9 0 294.2 81.2 81.2 212.9 81.2 294.2 0 81.2-81.2 81.2-213 0-294.2zM89.6 263.8c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3zm26.2 82.2c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm2.3-171.5c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zM179.6 404c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zm-2.3-287.5c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm35.4 76.3c-2.3-3.8-1-8.7 2.7-11 3.8-2.3 8.7-1 11 2.7l33.7 62.3c2.5 4.7 3.9 9.9 3.9 15.2v122c0 5-3 8-8 8s-8-3-8-8V262c0-2.7-.7-5.3-1.9-7.6l-33.4-61.6zm44.9 239c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3zm0-336c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3zm87.7 311.7c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm2.3-294.5c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zm61.5 229.5c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zM406.8 178c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm18.8 85.8c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3z"}}]})(props);
	};
	module.exports.IoIosClock.displayName = "IoIosClock";
	module.exports.IoIosCloseCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M331.3 308.7L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-15.6-7.1-22.6 0-7.1 7.1-6 16.6 0 22.6l52.7 52.7-52.7 52.7c-6.7 6.7-6.4 16.3 0 22.6 6.4 6.4 16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0 6.3-6.2 6.3-16.4 0-22.6z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosCloseCircleOutline.displayName = "IoIosCloseCircleOutline";
	module.exports.IoIosCloseCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm52.7 283.3L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3 6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z"}}]})(props);
	};
	module.exports.IoIosCloseCircle.displayName = "IoIosCloseCircle";
	module.exports.IoIosClose = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"}}]})(props);
	};
	module.exports.IoIosClose.displayName = "IoIosClose";
	module.exports.IoIosCloudCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm82.6 272H173.4c-25.1 0-45.4-21.4-45.4-47.2 0-21 13.2-39.8 33.2-46.2.3-20 16.2-36.1 35.7-36.1 5.3 0 10.4 1.2 14.9 3.4 13.1-20.5 36.9-33.8 62.5-33.8 37.7 0 67.5 29.3 71.4 66.9 21.7 3.5 38.3 22.7 38.3 45.9 0 25.7-20.3 47.1-45.4 47.1z"}}]})(props);
	};
	module.exports.IoIosCloudCircle.displayName = "IoIosCloudCircle";
	module.exports.IoIosCloudDone = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 229.8C429 154.6 365.4 96 288 96c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 241.5 0 280.5 0 321.5 0 371.7 40.7 416 90.9 416h330.3c50.2 0 90.9-44.3 90.9-94.5-.1-44.7-32.4-84.1-75-91.7zm-74.6-17.3L228.8 346.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"}}]})(props);
	};
	module.exports.IoIosCloudDone.displayName = "IoIosCloudDone";
	module.exports.IoIosCloudDownload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 165.8C429 90.6 365.4 32 288 32c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 177.5 0 216.5 0 257.5 0 307.7 40.7 352 90.9 352H243V211c0-7.2 5.8-13 13-13s13 5.8 13 13v141h152.1c50.2 0 90.9-44.3 90.9-94.5 0-44.7-32.3-84.1-74.9-91.7zM243 435.9l-47.9-47.2c-5.1-5-13.3-5-18.4.1-5 5.1-5 13.3.1 18.4l70 69c2.5 2.4 5.8 3.7 9.1 3.7 1.7 0 3.4-.3 5-1 1.5-.6 2.9-1.6 4.1-2.7l70-69c5.1-5 5.2-13.3.1-18.4-5-5.1-13.3-5.2-18.4-.1L269 435.9V352h-26v83.9z"}}]})(props);
	};
	module.exports.IoIosCloudDownload.displayName = "IoIosCloudDownload";
	module.exports.IoIosCloudOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 124c30.3 0 59.3 11.2 81.8 31.5 22.3 20.1 36.3 47.6 39.5 77.3l1.2 11.1c.6 5.8 5 10.5 10.7 11.5l11 2c14 2.5 27 10.4 36.7 22.1 9.8 12 15.2 26.9 15.2 42.1 0 17-6.9 34.1-18.9 46.8C453 381 437.4 388 421.1 388H90.9c-16.3 0-31.9-7-43.9-19.7s-18.9-29.7-18.9-46.8c0-14.4 4.6-28.9 13.1-40.9 8.6-12.2 20.2-20.9 33.7-25.1l10.3-3.3c5.3-1.7 9-6.6 9.1-12.2l.2-10.8c.2-11.8 5.1-23.6 13.5-32.4 8.3-8.7 18.9-13.4 29.9-13.4 5.6 0 11.1 1.1 16.3 3.2l11.1 4.5c5.7 2.3 12.2.4 15.7-4.7l6.8-9.8C210.4 143.7 248 124 288 124m0-28c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 241.5 0 280.5 0 321.5 0 371.7 40.7 416 90.9 416h330.3c50.2 0 90.9-44.3 90.9-94.5 0-44.7-32.3-84.1-74.9-91.7C429 154.6 365.4 96 288 96z"}}]})(props);
	};
	module.exports.IoIosCloudOutline.displayName = "IoIosCloudOutline";
	module.exports.IoIosCloudUpload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 165.8C429 90.6 365.4 32 288 32c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 177.5 0 216.5 0 257.5 0 307.7 40.7 352 90.9 352H243V210.1l-47.9 47.2c-5.1 5-13.3 5-18.4-.1-5-5.1-5-13.3.1-18.4l70-69c1.2-1.1 2.5-2.1 4.1-2.7 1.6-.7 3.3-1 5-1 3.4 0 6.6 1.3 9.1 3.7l70 69c5.1 5 5.2 13.3.1 18.4-5 5.1-13.3 5.2-18.4.1L269 210.1V352h152.1c50.2 0 90.9-44.3 90.9-94.5 0-44.7-32.3-84.1-74.9-91.7zM243 467c0 7.2 5.8 13 13 13s13-5.8 13-13V352h-26v115z"}}]})(props);
	};
	module.exports.IoIosCloudUpload.displayName = "IoIosCloudUpload";
	module.exports.IoIosCloud = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 229.8C429 154.6 365.4 96 288 96c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 241.5 0 280.5 0 321.5 0 371.7 40.7 416 90.9 416h330.3c50.2 0 90.9-44.3 90.9-94.5-.1-44.7-32.4-84.1-75-91.7z"}}]})(props);
	};
	module.exports.IoIosCloud.displayName = "IoIosCloud";
	module.exports.IoIosCloudyNight = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.8 294.8c-.5 0-1.1-.1-1.6-.1-2.6 0-5.2 0-7.8.3-9.3-40.8-45.9-71.5-89.7-71.5-50.8 0-91.9 40.9-91.9 91.4 0 3.1.2 6.1.5 9.1-31 2.7-55.3 30.1-55.3 61.6C32 419 58.8 448 92.3 448h185.5c41.9 0 75.8-34.7 75.8-76.3 0-41.6-33.9-76.9-75.8-76.9z"}},{"tag":"path","attr":{"d":"M452.1 305.4c-2.5.1-5 .2-7.6.2-41.7 0-80.8-15.7-110.3-44.3-29.5-28.5-45.7-66.5-45.7-106.8 0-23 5.3-45.2 15.2-65.3L315.4 70c1.7-2.9-.8-6.5-4.1-6-7.6 1.2-15.7 4-23.2 6.3-59.5 18.2-104.4 68.1-113.7 129.3 1.4-.1 2.9-.1 4.3-.1 26.5 0 52.4 9.2 73 25.9 15.1 12.2 26.9 28 34.2 45.7 23.7 2 45.7 12.4 62.7 29.8 18.7 19.1 29 44.2 29 70.7 0 2.3-.1 4.6-.2 6.8 34.2-8.1 64.3-26.6 86.4-51.8 4.8-5.5 11.3-12.8 15.3-18.5 2-2.8-.3-6.7-3.8-6.3-6.8 1-15.9 3.2-23.2 3.6z"}}]})(props);
	};
	module.exports.IoIosCloudyNight.displayName = "IoIosCloudyNight";
	module.exports.IoIosCloudy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M236 96c-70 0-127.8 59.7-127.8 130.8 0 4.3.3 8.6.8 12.8-43.2 3.9-77 44-77 88.4 0 47 37.9 88 84.6 88h257.8c58.3 0 105.6-49.4 105.6-108s-47.3-108.8-105.6-108.8c-2.3 0-4.8-.2-7.2-.2-2.1 0-4.2 0-6.1.1C349.3 145.6 306 96 236 96z"}}]})(props);
	};
	module.exports.IoIosCloudy.displayName = "IoIosCloudy";
	module.exports.IoIosCodeDownload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L332 142.7zM106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256z"}},{"tag":"path","attr":{"d":"M332.8 267.2c.1-3.9-1.4-7.6-4.2-10.4l-.1-.1c-2.7-2.7-6.2-4.2-10-4.2-3.5 0-6.8 1.3-9.4 3.6l-38.9 34.6V184.6c0-7.8-6.4-14.2-14.2-14.2-7.8 0-14.2 6.4-14.2 14.2v106.2l-38.9-34.6c-2.6-2.3-6-3.6-9.4-3.6-3.8 0-7.4 1.5-10.1 4.2l-.1.1c-2.8 2.8-4.2 6.4-4.2 10.4.1 3.9 1.7 7.5 4.6 10.2l62.8 57.7c2.6 2.4 6 3.7 9.5 3.7s6.9-1.3 9.5-3.7l62.8-57.7c2.8-2.8 4.5-6.4 4.5-10.3z"}}]})(props);
	};
	module.exports.IoIosCodeDownload.displayName = "IoIosCodeDownload";
	module.exports.IoIosCodeWorking = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M446.1 251.6L332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3-.1-1.7-.8-3.2-2-4.4zM106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"22"}},{"tag":"circle","attr":{"cx":"192","cy":"256","r":"22"}},{"tag":"circle","attr":{"cx":"320","cy":"256","r":"22"}}]})(props);
	};
	module.exports.IoIosCodeWorking.displayName = "IoIosCodeWorking";
	module.exports.IoIosCode = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L332 142.7zM204 160.2c0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3z"}}]})(props);
	};
	module.exports.IoIosCode.displayName = "IoIosCode";
	module.exports.IoIosCog = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.9 242.2l-26.1-4.2c-3.5-.6-6.1-3.3-6.6-6.8-.5-3.2-1-6.4-1.7-9.5-.7-3.4.9-6.9 3.9-8.6l23.1-12.8c3.6-1.8 5.3-6.1 3.9-9.9l-4-11c-1.4-3.8-5.4-6-9.4-5l-25.9 5c-3.4.7-6.9-1-8.6-4.1-1.5-2.8-3.1-5.6-4.8-8.4-1.8-3-1.6-6.8.7-9.5l17.3-19.9c2.8-3 2.9-7.5.3-10.6l-7.5-9c-2.6-3.1-7.1-3.8-10.5-1.5L378.3 130c-3 1.8-6.8 1.4-9.4-.9-2.4-2.1-4.9-4.2-7.4-6.2-2.7-2.2-3.8-5.9-2.5-9.1l9.4-24.7c1.6-3.7.2-8.1-3.3-10.1l-10.2-5.9c-3.5-2-8-1.1-10.4 2.2l-16.6 20.8c-2 2.5-4.9 3.8-8.5 2.5 0 0-5.6-2.3-9.8-3.7-3.3-1.1-5.6-4.2-5.5-7.7l.4-26.4c.2-4.1-2.6-7.7-6.6-8.4l-11.6-2c-4-.7-7.9 1.7-9.1 5.6l-8.6 25c-1.1 3.3-4.3 5.5-7.8 5.4-1.6 0-3.3-.1-4.9-.1s-3.3 0-4.9.1c-3.5.1-6.6-2.1-7.8-5.4l-8.6-25c-1.2-3.9-5.1-6.3-9.1-5.6l-11.6 2c-4 .7-6.8 4.3-6.6 8.4l.4 26.4c.1 3.5-2.1 6.4-5.5 7.7-2.3.9-7.3 2.8-9.7 3.7-2.8 1-6.1.2-8.8-2.9l-16.5-20.3c-2.4-3.3-6.9-4.2-10.4-2.2l-10.2 5.9c-3.5 2-5 6.4-3.3 10.1l9.4 24.7c1.2 3.3.2 7-2.5 9.1-2.5 2-5 4.1-7.4 6.2-2.6 2.3-6.4 2.7-9.4.9L111 116.3c-3.4-2.2-7.9-1.6-10.5 1.5l-7.5 9c-2.6 3.1-2.5 7.7.3 10.6l17.3 19.9c2.3 2.6 2.6 6.5.7 9.5-1.7 2.7-3.3 5.5-4.8 8.4-1.7 3.1-5.1 4.7-8.6 4.1l-25.9-5c-4-.9-8 1.2-9.4 5l-4 11c-1.4 3.8.3 8.1 3.9 9.9L85.6 213c3.1 1.7 4.6 5.2 3.9 8.6-.6 3.2-1.2 6.3-1.7 9.5-.5 3.5-3.2 6.2-6.6 6.8l-26.1 4.2c-4 .5-7.1 3.9-7.1 7.9v11.7c0 4.1 3 7.5 7.1 7.9l26.1 4.2c3.5.6 6.1 3.3 6.6 6.8.5 3.2 1 6.4 1.7 9.5.7 3.4-.9 6.9-3.9 8.6l-23.1 12.8c-3.6 1.8-5.3 6.1-3.9 9.9l4 11c1.4 3.8 5.4 6 9.4 5l25.9-5c3.4-.7 6.9 1 8.6 4.1 1.5 2.8 3.1 5.6 4.8 8.4 1.8 3 1.6 6.8-.7 9.5l-17.3 19.9c-2.8 3-2.9 7.5-.3 10.6l7.5 9c2.6 3.1 7.1 3.8 10.5 1.5l22.7-13.6c3-1.8 6.8-1.4 9.4.9 2.4 2.1 4.9 4.2 7.4 6.2 2.7 2.2 3.8 5.9 2.5 9.1l-9.4 24.7c-1.6 3.7-.2 8.1 3.3 10.1l10.2 5.9c3.5 2 8 1.1 10.4-2.2l16.8-20.6c2.1-2.6 5.5-3.7 8.2-2.6 3.4 1.4 5.7 2.2 9.9 3.6 3.3 1.1 5.6 4.2 5.5 7.7l-.4 26.4c-.2 4.1 2.6 7.7 6.6 8.4l11.6 2c4 .7 7.9-1.7 9.1-5.6l8.6-25c1.1-3.3 4.3-5.5 7.8-5.4 1.6 0 3.3.1 4.9.1s3.3 0 4.9-.1c3.5-.1 6.6 2.1 7.8 5.4l8.6 25c1.2 3.9 5.1 6.3 9.1 5.6l11.6-2c4-.7 6.8-4.3 6.6-8.4l-.4-26.4c-.1-3.5 2.2-6.6 5.5-7.7 4.2-1.4 7-2.5 9.6-3.5 2.6-.9 5.8-1 8.3 2.1l17 20.9c2.4 3.3 6.9 4.2 10.4 2.2l10.2-5.9c3.5-2 5-6.4 3.3-10.1l-9.4-24.7c-1.2-3.3-.2-7 2.5-9.1 2.5-2 5-4.1 7.4-6.2 2.6-2.3 6.4-2.7 9.4-.9l22.7 13.6c3.4 2.2 7.9 1.6 10.5-1.5l7.5-9c2.6-3.1 2.5-7.7-.3-10.6l-17.3-19.9c-2.3-2.6-2.6-6.5-.7-9.5 1.7-2.7 3.3-5.5 4.8-8.4 1.7-3.1 5.1-4.7 8.6-4.1l25.9 5c4 .9 8-1.2 9.4-5l4-11c1.4-3.8-.3-8.1-3.9-9.9l-23.1-12.8c-3.1-1.7-4.6-5.2-3.9-8.6.6-3.2 1.2-6.3 1.7-9.5.5-3.5 3.2-6.2 6.6-6.8l26.1-4.2c4-.5 7.1-3.9 7.1-7.9v-11.7c-.2-3.8-3.2-7.3-7.3-7.7zM181.8 356.9c-5.2 9-17.4 10.7-25 3.6C129.2 334.2 112 297.1 112 256c0-40.9 17.1-77.9 44.5-104.1 7.5-7.2 19.8-5.5 25 3.5l56 96.6c1.4 2.5 1.4 5.5 0 8l-55.7 96.9zM396 289.7C380.9 353 323.9 400 256 400c-14.1 0-27.8-2-40.6-5.8-9.9-2.9-14.5-14.4-9.3-23.3l55.7-96.9c1.4-2.5 4.1-4 6.9-4h111.7c10.4 0 18 9.6 15.6 19.7zM380.5 242H268.7c-2.9 0-5.5-1.5-6.9-4l-56.1-96.7c-5.2-8.9-.7-20.4 9.2-23.4 13-3.9 26.8-5.9 41.1-5.9 67.9 0 124.9 47 140 110.3 2.4 10.1-5.2 19.7-15.5 19.7z"}}]})(props);
	};
	module.exports.IoIosCog.displayName = "IoIosCog";
	module.exports.IoIosColorFill = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M231.5 118.3c.1 0 .1-.1 0 0L175.3 62c-9.3-9.3-21.6-14-33.9-14-12.3 0-24.6 4.7-33.9 14-18.7 18.7-18.7 49.2 0 67.9l49.3 49.3-84.5 84c-11.1 11.1-11 29.2.3 40l131.2 126c10.9 10.4 28 10.4 38.9-.1 37.8-36.6 118.3-114.5 126.7-122.9 5.8-5.8 18.2-7.1 28.7-7.1h.3c5.9 0 8.8-7.1 4.6-11.2L231.5 118.3zm-103.9-7.9c-7.2-7.2-8.3-18.8-2-26.8 3.8-4.9 9.6-7.6 15.8-7.6 5.4 0 10.4 2.1 14.1 5.8l49.3 49.3-28.3 28.3-48.9-49zM403 339.5c-1.6-1.9-4.5-1.9-6.1 0-10.5 12.2-45 53.9-45 76.4 0 26.6 21.5 48.1 48 48.1s48-21.6 48-48.1c.1-22.6-34.3-64.2-44.9-76.4z"}}]})(props);
	};
	module.exports.IoIosColorFill.displayName = "IoIosColorFill";
	module.exports.IoIosColorFilter = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442 248.9c-15.7-20.6-37.7-35.9-62.1-43.6 1-6.3 1.4-12.7 1.4-19.1 0-33.7-13-65.4-36.7-89.2C321 73.1 289.5 60 256 60s-65 13.1-88.6 37c-23.7 23.8-36.7 55.5-36.7 89.2 0 6.4.5 12.8 1.4 19.1-24.5 7.7-46.4 23.1-62.1 43.6-17 22.2-26 48.8-26 76.9 0 33.7 13 65.4 36.7 89.2 23.7 23.8 55.2 37 88.6 37 32.6 0 63.2-12.4 86.7-35 23.4 22.6 54.1 35 86.7 35 33.5 0 65-13.1 88.6-37 23.7-23.8 36.7-55.5 36.7-89.2 0-28.1-9-54.7-26-76.9zM256 85.5c55.1 0 100 45.2 100 100.7 0 4.7-.3 9.4-1 14.1-4.1-.4-8.2-.6-12.4-.6-32.6 0-63.2 12.4-86.7 35-23.4-22.6-54.1-35-86.7-35-4.1 0-8.3.2-12.4.6-.6-4.6-1-9.4-1-14.1.2-55.6 45.1-100.7 100.2-100.7zm0 201.4c-1.8 0-3.7-.1-5.5-.2 1.6-3.8 3.4-7.5 5.5-11.1 2.1 3.6 3.9 7.3 5.5 11.1-1.8.2-3.7.2-5.5.2zm-46.6 131.2c-12.7 5.6-26.1 8.4-40.1 8.4-55.1 0-100-45.2-100-100.7 0-22.3 7.1-43.5 20.6-61.2 12.3-16.1 29.4-28.3 48.5-34.6 6.6 17.9 17.3 34.3 31.2 47.6 13.9 13.4 30.9 23.4 49.2 29.1-1 6.3-1.4 12.7-1.4 19.1 0 25.8 7.7 50.6 22.2 71.7-8.8 8.7-19 15.6-30.2 20.6zM225.1 282c-27.6-9-50-29.8-61.3-56.7 1.8-.1 3.7-.2 5.5-.2 13.9 0 27.4 2.8 40.1 8.4 11.2 5 21.4 11.9 30.1 20.6-5.9 8.7-10.8 18-14.4 27.9zm30.9 94c-8.7-15.2-13.3-32.5-13.3-50.2 0-4.7.3-9.4 1-14.1a128.658 128.658 0 0 0 24.8 0c.6 4.6 1 9.4 1 14.1-.2 17.7-4.8 35-13.5 50.2zm46.6-142.5c12.7-5.6 26.1-8.4 40.1-8.4 1.8 0 3.7.1 5.5.2-11.3 26.9-33.7 47.7-61.3 56.7-3.6-9.8-8.5-19.2-14.4-27.9 8.7-8.7 18.9-15.6 30.1-20.6zm40.1 193c-13.9 0-27.4-2.8-40.1-8.4-11.2-5-21.4-11.9-30.1-20.6 14.5-21.1 22.2-45.8 22.2-71.7 0-6.4-.5-12.8-1.4-19.1 18.3-5.7 35.2-15.7 49.2-29.1 13.8-13.3 24.5-29.6 31.2-47.6 19.1 6.3 36.2 18.4 48.5 34.6 13.5 17.7 20.6 38.9 20.6 61.2-.1 55.6-45 100.7-100.1 100.7z"}}]})(props);
	};
	module.exports.IoIosColorFilter.displayName = "IoIosColorFilter";
	module.exports.IoIosColorPalette = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430.1 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 12-36.6.1-47.7zM120 216c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm40 126c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-161c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm72 219c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm24-208c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.IoIosColorPalette.displayName = "IoIosColorPalette";
	module.exports.IoIosColorWand = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M445.7 405.6L201.3 160.4c-3.1-3.1-8.2-3.1-11.3 0l-28.7 28.8c-3.1 3.1-3.1 8.2 0 11.3l244.4 245.2c3.1 3.1 8.2 3.1 11.3 0l28.6-28.8c3.2-3.1 3.2-8.2.1-11.3zm-25.5 14.3l-.1.1c-3.1 3.1-8.2 3.1-11.3 0L218.9 229.5c-3.1-3.1-3.1-8.2 0-11.3l.1-.1c3.1-3.1 8.2-3.1 11.3 0l189.9 190.5c3.1 3.1 3.1 8.2 0 11.3zM192.8 120.1c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12s-12 5.4-12 12v32.1c0 6.6 5.4 12 12 12zM192.8 263.3c-6.6 0-12 5.4-12 12v32.1c0 6.6 5.4 12 12 12s12-5.4 12-12v-32.1c0-6.6-5.4-12-12-12zM270.7 190.2c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12s-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12zM119.9 190.2c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12s5.4 12 12 12h32c6.5 0 11.9-5.4 11.9-12zM124.8 141c2.3 2.3 5.3 3.5 8.5 3.5s6.2-1.3 8.5-3.5c4.7-4.7 4.7-12.3 0-17l-20.9-21c-2.3-2.3-5.3-3.5-8.5-3.5s-6.2 1.3-8.5 3.5c-4.7 4.7-4.7 12.3 0 17l20.9 21zM133.3 239.9c-3.2 0-6.2 1.3-8.5 3.5l-20.9 21c-2.3 2.3-3.5 5.3-3.5 8.5s1.2 6.2 3.5 8.5 5.3 3.5 8.5 3.5 6.2-1.3 8.5-3.5l20.9-21c4.7-4.7 4.7-12.3 0-17-2.3-2.2-5.3-3.5-8.5-3.5zM252.4 144.5c3.2 0 6.2-1.3 8.5-3.5l20.9-21c4.7-4.7 4.7-12.3 0-17-2.3-2.3-5.3-3.5-8.5-3.5s-6.2 1.3-8.5 3.5l-20.9 21c-2.3 2.3-3.5 5.3-3.5 8.5s1.2 6.2 3.5 8.5c2.3 2.2 5.3 3.5 8.5 3.5z"}}]})(props);
	};
	module.exports.IoIosColorWand.displayName = "IoIosColorWand";
	module.exports.IoIosCompass = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280.5 280.5l-49-49c-.9-.9-2.5-.7-3.2.4l-49.5 98.5c-1.1 1.8 1 3.9 2.8 2.8l98.5-49.5c1.1-.7 1.3-2.3.4-3.2z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm40.6 249.3L137 377.8c-1.8 1.1-3.9-1-2.8-2.8l80.6-159.6c.2-.3.4-.5.7-.7L375 134.2c1.8-1.1 3.9 1 2.8 2.8l-80.6 159.6c-.1.3-.3.5-.6.7z"}}]})(props);
	};
	module.exports.IoIosCompass.displayName = "IoIosCompass";
	module.exports.IoIosConstruct = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380 64.4zM275.1 57.6c-9.4-5.9-23.3-9.6-37.9-9.6-14.3 0-30.3 2.5-46.7 9.2-46.5 19-74 45.4-81.1 52.4-7 7-16.8 18-22.9 26.6-6.1 8.7 1.9 21-6.1 29s-24.7 0-24.7 0c-1.4 0-2.9.5-3.9 1.6l-34.1 33.9c-2.2 2.1-2.2 5.7 0 7.8l63.5 63.1c1.1 1.1 2.5 1.6 3.9 1.6s2.9-.5 3.9-1.6l33.2-34.8c2.2-2.1 2.2-5.7 0-7.8 0 0-5.3-5.2-12.1-12s.8-19.3 5.3-23.4c4.5-4.1 11.6-6.8 21.1-6.8 4.3 0 7.4.7 11.4 1.8 12.2 3.4 25.8 15.9 50.9 40.8l-3.9 6.5c-2.3 3.8-.9 8.3 1.3 10.4 0 0-5-4.9 13.1 13.1l50-47.2c-19.1-18.9-14.5-14.1-14.5-14.1-1.4-1.4-3.8-2.3-6.3-2.3-1.4 0-2.9.3-4.2 1l-5.6 3c-28-27.8-35.3-40.2-34.3-61.7 1.1-22.4 12.3-37.1 30.5-52.7 24.7-21.1 60.6-15.2 60.6-15.2 8-.1-4.2-8.6-10.4-12.6zM462.5 399.9s-68.9-57.2-130.2-115.7l-47.7 50.6c58.5 60.6 114.9 127.6 114.9 127.6 1.1 1.1 2.5 1.6 3.9 1.6s2.9-.5 3.9-1.6l55.1-54.7c2.2-2.1 2.2-5.7.1-7.8z"}},{"tag":"path","attr":{"d":"M479.2 125.3l-52.4 52.6-51.1-9.3-9.2-51.1 52.4-52.6c-11.1-11.1-26.8-16.6-39-16.6-.7 0-1.4 0-2 .1-12.5.6-39.2 7.7-59.9 29.7-20 21.1-41.1 60.6-22.4 104.3 2.2 5.3 4.7 12.2-2.7 19.7-1.5 1.4-9.9 9.4-22.5 21.3-3.6 3.4-7.4 7-11.6 11-8 7.6-17.1 16.2-26.8 25.2-3.8 3.6-7.7 7.2-11.6 11-57 53.8-126.9 119.5-126.9 119.5-18 15.5-16.7 44.1-.1 60.8 8.5 8.4 20 12.8 31.3 12.8 11 0 21.9-4.2 29.5-13.1 0 0 65.5-69.8 119.3-126.9 3.7-4 7.4-7.8 11-11.7 9.3-9.9 18-19.1 25.8-27.3 3.9-4.2 7.6-8.1 11-11.6 11.5-12.2 19.3-20.4 21-22 4-3.9 7.7-5.1 11.1-5.1 3.3 0 6.2 1.2 8.6 2.4 9.9 5.1 21 7.3 32.4 7.3 26.7 0 55-12.4 72.1-29.5 24.4-24.4 28.8-47.9 29.6-60 .6-11.8-3.6-27.6-16.9-40.9zM137.4 426.1c-5.5 5.4-14.4 5.4-19.8 0-5.4-5.5-5.4-14.4 0-19.8 5.5-5.4 14.4-5.4 19.8 0 5.4 5.5 5.4 14.4 0 19.8z"}}]})(props);
	};
	module.exports.IoIosConstruct.displayName = "IoIosConstruct";
	module.exports.IoIosContact = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C148.5 48 60.1 129.5 49.2 234.1c-.8 7.2-1.2 14.5-1.2 21.9 0 7.4.4 14.7 1.2 21.9C60.1 382.5 148.5 464 256 464c114.9 0 208-93.1 208-208S370.9 48 256 48zm135.8 326.1c-22.7-8.6-59.5-21.2-82.4-28-2.4-.7-2.7-.9-2.7-10.7 0-8.1 3.3-16.3 6.6-23.3 3.6-7.5 7.7-20.2 9.2-31.6 4.2-4.9 10-14.5 13.6-32.9 3.2-16.2 1.7-22.1-.4-27.6-.2-.6-.5-1.2-.6-1.7-.8-3.8.3-23.5 3.1-38.8 1.9-10.5-.5-32.8-14.9-51.3-9.1-11.7-26.6-26-58.5-28h-17.5c-31.4 2-48.8 16.3-58 28-14.5 18.5-16.9 40.8-15 51.3 2.8 15.3 3.9 35 3.1 38.8-.2.7-.4 1.2-.6 1.8-2.1 5.5-3.7 11.4-.4 27.6 3.7 18.4 9.4 28 13.6 32.9 1.5 11.4 5.7 24 9.2 31.6 2.6 5.5 3.8 13 3.8 23.6 0 9.9-.4 10-2.6 10.7-23.7 7-58.9 19.4-80 27.8C91.6 341.4 76 299.9 76 256c0-48.1 18.7-93.3 52.7-127.3S207.9 76 256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256c0 43.9-15.6 85.4-44.2 118.1z"}}]})(props);
	};
	module.exports.IoIosContact.displayName = "IoIosContact";
	module.exports.IoIosContacts = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm143.3 263.9c-8.1-2.6-23.7-3.4-29.5-10.4-2.9-3.5-1-16.6-1-16.6 25.2-1.4 31-6.1 31-6.1 3.9-2.3 2.1-2.7.1-6.1-10.9-18.3-6-41.5-6.5-61.6-.4-16.7-4.8-35-20-44.4-7.6-4.7-19.7-6.9-31.4-6.9-9.5 0-18.7 1.4-25.3 4.1-42.4 17-17.4 73.2-31.9 105.4-2.5 5.4-6.1 7.3.2 10.5 0 0 7.5 4.4 28.9 6.3 0 0 .3 12.6 0 13.9-1.1 4.9-11.8 8.3-15.8 9.4-2.7.7-8.7 2.5-16.4 5.7-3.7 1.5-3.1 6.9.8 7.6 3.9.7 8.1 1.7 11.5 2.9 0 0 26.4 6 46 25 13.2 12.7 18.1 27.6 20 44.6.5 4.5-1.7 8.9-5.5 11.5l-5.7 3.6c-1.9 1.1-4.2-.2-4.3-2.4 0-29.5-17.8-55.5-45.8-65.2-13.5-4.7-28.1-5-41.6-9.7-4.1-1.4-12.2-3.1-13.9-7.8-1.6-4.6-1.6-10-1.9-14.8-.2-3.8-.3-7.6-.3-11.4 0-2.5 6.4-7.8 7.8-10.1 5.4-9 5.9-21.1 6.9-31.3 8.7 2.4 9.8-13.7 11.3-18.6 1.1-3.4 5-20.9-2.6-23.6 2.5-4.4 3.5-9.8 4.2-14.7 2-12.8 2.8-26.8-1.1-39.3-8.1-26-33-40.6-59.3-41.4-26.7-.9-53.5 11.9-63.5 37.8-4.8 12.6-4.4 26.3-2.8 39.5.7 6 1.7 12.7 4.7 18.1-6.4 2.8-4.5 17.7-3.4 21.3 1.6 5.1 3 23.4 12.1 20.9.8 8.1 1.7 16.4 3.9 24.3 1.5 5.3 4.6 9.8 8.2 13.9 1.8 2 2.7 2.2 2.6 4.8-.1 7.8.1 16.2-1.9 23.8s-18.7 10.8-25.4 12.2c-14.8 3-28.6 4.7-41.4 11.5C84.8 320.6 76 289 76 256c0-47.9 19.2-94 53.2-127.7C162.7 95 207.1 76.4 254.3 76c47.6-.4 93.7 18.1 127.8 51.5 34.8 34.1 54 79.9 54 128.5 0 24.9-5 48.9-14.5 71.1-5.6-7-13.4-12.3-22.3-15.2z"}}]})(props);
	};
	module.exports.IoIosContacts.displayName = "IoIosContacts";
	module.exports.IoIosContract = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184.3 204.8h-77.7c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h112.2c7.7 0 13.9-6.2 13.9-13.9V106.6c0-7.7-6.2-13.9-13.9-13.9h-.2c-7.7 0-13.9 6.2-13.9 13.9v77.7L87.7 68c-2.6-2.6-6.1-4-9.8-4-3.7 0-7.2 1.4-9.8 4.1-5.4 5.4-5.4 14.2 0 19.6l116.2 117.1zM293.1 232.8h112.2c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9h-77.7L444 87.7c5.4-5.4 5.4-14.2 0-19.6-2.6-2.6-6.1-4.1-9.8-4.1-3.7 0-7.2 1.4-9.8 4L307.3 184.3v-77.7c0-7.7-6.2-13.9-13.9-13.9h-.2c-7.7 0-13.9 6.2-13.9 13.9v112.2c0 7.7 6.2 14 13.8 14zM77.9 448c3.7 0 7.2-1.4 9.8-4l117.1-116.3v77.7c0 7.7 6.2 13.9 13.9 13.9h.2c7.7 0 13.9-6.2 13.9-13.9V293.1c0-7.7-6.2-13.9-13.9-13.9H106.6c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h77.7L68 424.3c-5.4 5.4-5.4 14.2 0 19.6 2.7 2.7 6.2 4.1 9.9 4.1zM293.1 419.2h.2c7.7 0 13.9-6.2 13.9-13.9v-77.7L424.3 444c2.6 2.6 6.1 4 9.8 4 3.7 0 7.2-1.4 9.8-4.1 5.4-5.4 5.4-14.2 0-19.6L327.7 307.2h77.7c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9H293.1c-7.7 0-13.9 6.2-13.9 13.9v112.2c.1 7.7 6.3 13.9 13.9 13.9z"}}]})(props);
	};
	module.exports.IoIosContract.displayName = "IoIosContract";
	module.exports.IoIosContrast = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm127.3 335.3c-34 34-79.2 52.7-127.3 52.7V76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3z"}}]})(props);
	};
	module.exports.IoIosContrast.displayName = "IoIosContrast";
	module.exports.IoIosCopy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 115h90c3.3 0 6-2.7 6-6 0-8.2-3.7-16-10-21.3l-77.1-64.2c-4.9-4.1-14.2-7.4-20.6-7.4-4.1 0-7.4 3.3-7.4 7.4V96c.1 10.5 8.6 19 19.1 19z"}},{"tag":"path","attr":{"d":"M307 96V16H176c-17.6 0-32 14.4-32 32v336c0 17.6 14.4 32 32 32h240c17.6 0 32-14.4 32-32V141h-96c-24.8 0-45-20.2-45-45z"}},{"tag":"path","attr":{"d":"M116 412V80H96c-17.6 0-32 14.4-32 32v352c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32v-20H148c-17.6 0-32-14.4-32-32z"}}]})(props);
	};
	module.exports.IoIosCopy.displayName = "IoIosCopy";
	module.exports.IoIosCreate = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404.3 86l-202 202c-1.5 1.5-2.3 3.5-2.3 5.6v26.5c0 4.4 3.6 7.9 7.9 7.9h26.3c2.1 0 4.2-.8 5.7-2.3l202.1-202c3.1-3.1 3.1-8.1 0-11.2L415.5 86c-3.1-3.1-8.1-3.1-11.2 0zM475.6 67l-14.4-14.4-.2-.2c-3.1-2.7-7.2-4.4-11.5-4.4-4.4 0-8.5 1.7-11.6 4.5l-11.3 11.4c-1.5 1.6-1.5 4.1 0 5.6L437 79.9l21.7 21.7c1.6 1.6 4.1 1.6 5.7 0l11.3-11.3c2.8-3.1 4.4-7.1 4.4-11.6-.1-4.4-1.7-8.6-4.5-11.7z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M250 342c-3 3-7.1 4.7-11.3 4.7H197.3c-8.8 0-16-7.2-16-16V289.2c0-4.2 1.7-8.3 4.7-11.3l.8-.8 147.6-147.6c2.5-2.5.7-6.8-2.8-6.8H90.7C58.3 122.7 32 149 32 181.4v224c0 32.4 26.3 58.7 58.7 58.7h256c32.4 0 58.7-26.3 58.7-58.7v-209c0-3.6-4.3-5.3-6.8-2.8L250.8 341.2l-.8.8z"}}]}]})(props);
	};
	module.exports.IoIosCreate.displayName = "IoIosCreate";
	module.exports.IoIosCrop = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M142 64c-7.7 0-14 6.3-14 14v20c0 7.7 6.3 14 14 14s14-6.3 14-14V78c0-7.7-6.3-14-14-14zM156 342V190c0-7.7-6.3-14-14-14s-14 6.3-14 14v166c0 15.5 12.5 28 28 28h166c7.7 0 14-6.3 14-14s-6.3-14-14-14H170c-7.7 0-14-6.3-14-14zM434 356h-20c-7.7 0-14 6.3-14 14s6.3 14 14 14h20c7.7 0 14-6.3 14-14s-6.3-14-14-14z"}},{"tag":"path","attr":{"d":"M64 142c0 7.7 6.3 14 14 14h264c7.7 0 14 6.3 14 14v264c0 7.7 6.3 14 14 14s14-6.3 14-14V156c0-15.5-12.5-28-28-28H78c-7.7 0-14 6.3-14 14z"}}]})(props);
	};
	module.exports.IoIosCrop.displayName = "IoIosCrop";
	module.exports.IoIosCube = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.8 129.5L261.7 49.2c-3.6-1.6-7.7-1.6-11.3 0L71.2 129.5c-6 2.7-6.2 11.8-.4 14.8l178.7 94.1c4.1 2.2 8.9 2.2 13 0l178.7-94.1c5.8-3 5.6-12.1-.4-14.8zM280.2 462.9l180.1-95.3c2.2-1.4 3.6-4 3.6-6.8V175.9c0-5.9-5.8-9.7-10.7-7.1l-180.1 92.8c-2.6 1.3-4.2 4.1-4.2 7.1V456c.1 6.2 6.4 10 11.3 6.9zM48 175.9v184.8c0 2.8 1.4 5.4 3.6 6.8l180.1 95.3c5 3.2 11.2-.6 11.2-6.8V268.7c0-3-1.6-5.8-4.2-7.1l-180-92.8c-4.9-2.6-10.7 1.3-10.7 7.1z"}}]})(props);
	};
	module.exports.IoIosCube.displayName = "IoIosCube";
	module.exports.IoIosCut = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M308 277.2c25.5-33 80.5-111.5 90.2-135.4 7.2-17.6 10.6-32.8 10.4-46.2-.2-17.9-6-29.3-18.3-40.6-5.2-4.8-13.5-6.9-20-6.9L255.9 201.7l-10 13.4-2.9 3.9-.1.1-14.5 19.7c-.1.1-.2.3-.3.4-.5.8-7.5 10.9-15.2 22.7-3 4.6-6.1 9.5-9 14.1-3.5 5.6-6.6 11-8.8 15.2-3.6 7.1-7.3 14.4-10.7 21.5-3.7 7.5-7.2 14.6-10.4 20.7-10.2-7.3-22-11.1-34.3-11.1-17.5 0-33.7 7.7-45.8 21.6C82.4 357.1 76 374.6 76 393.1c0 18.5 6.4 36 17.9 49.3 12.1 13.9 28.4 21.6 45.8 21.6 14.4 0 28-5.2 39.2-15 10.5-9.1 18-21.3 21.8-35.4 1-3.1 11.6-34.7 26.1-57.3 9.2-14.4 22.2-23.4 29.6-27.8l13.5-9.7c0 .1 12.7-8.7 38.1-41.6zM139.9 421.1c-13.3 0-24-12.6-24-28s10.7-28 24-28 24 12.6 24 28c0 15.5-10.8 28-24 28zm116.2-132.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}},{"tag":"path","attr":{"d":"M191.5 260.4c.7 1 1.6 1.9 2.5 2.7 1.7-2.8 3.6-5.7 5.4-8.6l46.5-65.8L140.9 48c-8.9 0-14.4.9-18.5 3.9-11.9 8.9-19.1 25.6-19.3 43.6-.2 13.5 3.3 28.6 10.4 46.2 8.6 21 42.6 70.2 78 118.7zM372 322.3c-12.3 0-24.1 3.8-34.3 11.1-3.2-6.1-6.7-13.2-10.4-20.7-3.4-6.9-6.9-14-10.4-20.8L306 305.8l-36.4 33.1c5.2 4.6 10.7 10.4 15.3 17.5 14.5 22.6 25 54.2 26 57.3 3.8 14.1 11.3 26.3 21.8 35.4 11.3 9.8 24.9 15 39.2 15 35.3 0 64-31.8 64-70.9s-28.6-70.9-63.9-70.9zm.1 98.8c-13.3 0-24-12.6-24-28s10.7-28 24-28 24 12.6 24 28c0 15.5-10.7 28-24 28z"}}]})(props);
	};
	module.exports.IoIosCut.displayName = "IoIosCut";
	module.exports.IoIosDesktop = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 442.2c-.3-2.2-2-3.9-4.2-4.3l-22.3-1.9c-11.8-3.1-20.5-16.2-22.3-28.3L302 400h-92l-1.2 7.6c-1.9 12.1-10.5 25.2-22.3 28.3l-22.3 1.9c-2.1.5-3.9 2.2-4.2 4.3-.4 3.1 2 5.8 5.1 5.8h181.8c3 .1 5.5-2.6 5.1-5.7zM472.9 71c-4.5-4.5-10.7-7-17-7H56.2c-6.4 0-12.5 2.5-17 7S32 81.7 32 88v272c0 6.4 2.7 12.5 7.2 17s10.5 7 16.8 7h400c6.4 0 12.3-2.5 16.8-7s7.2-10.7 7.2-17V88c.1-6.3-2.6-12.5-7.1-17zM256 360c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm203.9-40H52.2c-2.2 0-4-1.8-4-4V92c0-6.6 5.4-12 12-12h391.7c6.6 0 12 5.4 12 12v224c0 2.2-1.8 4-4 4z"}}]})(props);
	};
	module.exports.IoIosDesktop.displayName = "IoIosDesktop";
	module.exports.IoIosDisc = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 165.8c-49.9 0-90.3 40.4-90.3 90.3s40.4 90.2 90.3 90.2 90.3-40.4 90.3-90.2c0-49.9-40.4-90.3-90.3-90.3zm0 130.6c-22.3 0-40.4-18.1-40.4-40.4s18.1-40.4 40.4-40.4 40.4 18.1 40.4 40.4-18.1 40.4-40.4 40.4z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 322c-63 0-114-51.1-114-114 0-63 51.1-114 114-114s114 51 114 114-51 114-114 114z"}}]})(props);
	};
	module.exports.IoIosDisc.displayName = "IoIosDisc";
	module.exports.IoIosDocument = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M312 155h91c2.8 0 5-2.2 5-5 0-8.9-3.9-17.3-10.7-22.9L321 63.5c-5.8-4.8-13-7.4-20.6-7.4-4.1 0-7.4 3.3-7.4 7.4V136c0 10.5 8.5 19 19 19z"}},{"tag":"path","attr":{"d":"M267 136V56H136c-17.6 0-32 14.4-32 32v336c0 17.6 14.4 32 32 32h240c17.6 0 32-14.4 32-32V181h-96c-24.8 0-45-20.2-45-45z"}}]})(props);
	};
	module.exports.IoIosDocument.displayName = "IoIosDocument";
	module.exports.IoIosDoneAll = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M317.5 210.3c1.7-1.8 1.8-4.7 0-6.5l-19.8-21c-.8-.9-2-1.4-3.2-1.4-1.2 0-2.4.5-3.2 1.4l-66.5 69.1 26.4 27.1 66.3-68.7zM123.8 253.1c-.9-.9-2-1.4-3.2-1.4-1.2 0-2.3.5-3.2 1.4l-20.1 20.7c-1.8 1.8-1.8 4.8 0 6.6l63.2 65c4 4.2 9 6.6 13.2 6.6 6 0 11.1-4.5 13.1-6.4l.1-.1 13.4-13.8-76.5-78.6z"}},{"tag":"path","attr":{"d":"M414.7 182.4l-19.8-21c-.8-.9-2-1.4-3.2-1.4-1.2 0-2.4.5-3.2 1.4L250.7 304.1l-50.1-51.6c-.9-.9-2-1.4-3.2-1.4-1.2 0-2.3.5-3.2 1.4l-20.1 20.7c-1.8 1.8-1.8 4.8 0 6.6l63.2 65c4 4.2 9 6.6 13.2 6.6 6 0 11.1-4.5 13.1-6.4l.1-.1 151-156.1c1.7-1.7 1.7-4.6 0-6.4z"}}]})(props);
	};
	module.exports.IoIosDoneAll.displayName = "IoIosDoneAll";
	module.exports.IoIosDownload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 144H269v179.9l47.9-47.2c5.1-5 13.3-5 18.4.1 5 5.1 5 13.3-.1 18.4l-70 69c-2.5 2.4-5.8 3.7-9.1 3.7-1.7 0-3.4-.3-5-1-1.5-.6-2.9-1.6-4.1-2.7l-70-69c-5.1-5-5.2-13.3-.1-18.4 5-5.1 13.3-5.2 18.4-.1l47.9 47.2V144H136c-22 0-40 18-40 40v240c0 22 18 40 40 40h240c22 0 40-18 40-40V184c0-22-18-40-40-40zM269 61c0-7.2-5.8-13-13-13s-13 5.8-13 13v83h26V61z"}}]})(props);
	};
	module.exports.IoIosDownload.displayName = "IoIosDownload";
	module.exports.IoIosEasel = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434 461.5l-26.6-69.1c-2.1-5.1-7-8.4-12.4-8.4-4.5 0-8.6 2.2-11.1 5.9s-3 8.4-1.4 12.5l26 69.1c2.1 5.1 7 8.5 12.5 8.5h.5c4.5 0 8.7-2.2 11.2-5.9 2.5-3.8 3-8.5 1.3-12.6zM117.6 384c-5.5 0-10.4 3.3-12.4 8.4l-26.6 69.1c-1.7 4.2-1.2 8.9 1.3 12.6 2.5 3.7 6.7 5.9 11.2 5.9h.5c5.5 0 10.4-3.3 12.5-8.5l26-69.1c1.7-4.1 1.2-8.8-1.4-12.5-2.4-3.7-6.6-5.9-11.1-5.9zM256.6 384h-1.1c-7.4 0-13.4 6-13.4 13.4v36.1c0 7.4 6 14.4 13.4 14.4h1.1c7.4 0 13.4-7 13.4-14.4v-36.1c0-7.4-6-13.4-13.4-13.4z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M424 128H88c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8z"}},{"tag":"path","attr":{"d":"M448 80H63.9C46.3 80 32 94.3 32 111.9v224.2c0 17.6 14.3 31.9 31.9 31.9H448c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32zm4 244c0 8.8-7.2 16-16 16H76c-8.8 0-16-7.2-16-16V124c0-8.8 7.2-16 16-16h364.6c3 0 5.9 1.2 8 3.3 2.1 2.1 3.3 5 3.3 8V324z"}}]},{"tag":"path","attr":{"d":"M256 32c-13.4-.2-24.4 12.2-24.4 25.6h48.7c.1-13.4-10.9-25.8-24.3-25.6z"}}]})(props);
	};
	module.exports.IoIosEasel.displayName = "IoIosEasel";
	module.exports.IoIosEgg = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C192 32 96 165.2 96 288.9 96 412.6 160 480 256 480s160-67.4 160-191.1C416 165.2 320 32 256 32z"}}]})(props);
	};
	module.exports.IoIosEgg.displayName = "IoIosEgg";
	module.exports.IoIosExit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 136v107h179.9l-47.2-47.9c-5-5.1-5-13.3.1-18.4 5.1-5 13.3-5 18.4.1l69 70c2.4 2.5 3.7 5.8 3.7 9.1 0 1.7-.3 3.4-1 5-.6 1.5-1.6 2.9-2.7 4.1l-69 70c-5 5.1-13.3 5.2-18.4.1-5.1-5-5.2-13.3-.1-18.4l47.2-47.9H144v107c0 22 18 40 40 40h240c22 0 40-18 40-40V136c0-22-18-40-40-40H184c-22 0-40 18-40 40zM61 243c-7.2 0-13 5.8-13 13s5.8 13 13 13h83v-26H61z"}}]})(props);
	};
	module.exports.IoIosExit.displayName = "IoIosExit";
	module.exports.IoIosExpand = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112.4 92h77.7c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9H77.9C70.2 64 64 70.2 64 77.9v112.2c0 7.7 6.2 13.9 13.9 13.9h.2c7.7 0 13.9-6.2 13.9-13.9v-77.7l117.1 116.3c2.6 2.6 6.1 4 9.8 4 3.7 0 7.2-1.4 9.8-4.1 5.4-5.4 5.4-14.2 0-19.6L112.4 92zM434.1 64H321.9c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h77.7L283.3 209.1c-5.4 5.4-5.4 14.2 0 19.6 2.6 2.6 6.1 4.1 9.8 4.1 3.7 0 7.2-1.4 9.8-4L420 112.4v77.7c0 7.7 6.2 13.9 13.9 13.9h.2c7.7 0 13.9-6.2 13.9-13.9V77.9c0-7.7-6.2-13.9-13.9-13.9zM218.9 279.2c-3.7 0-7.2 1.4-9.8 4L92 399.6v-77.7c0-7.7-6.2-13.9-13.9-13.9h-.2c-7.7 0-13.9 6.2-13.9 13.9v112.2c0 7.7 6.2 13.9 13.9 13.9h112.2c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9h-77.7l116.3-117.1c5.4-5.4 5.4-14.2 0-19.6-2.6-2.6-6.1-4.1-9.8-4.1zM434.1 308h-.2c-7.7 0-13.9 6.2-13.9 13.9v77.7L302.9 283.3c-2.6-2.6-6.1-4-9.8-4-3.7 0-7.2 1.4-9.8 4.1-5.4 5.4-5.4 14.2 0 19.6l116.3 117h-77.7c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h112.2c7.7 0 13.9-6.2 13.9-13.9V321.9c0-7.7-6.2-13.9-13.9-13.9z"}}]})(props);
	};
	module.exports.IoIosExpand.displayName = "IoIosExpand";
	module.exports.IoIosEyeOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M88.3 68.1c-5.6-5.5-14.6-5.5-20.1.1-5.5 5.5-5.5 14.5 0 20l355.5 355.7c3.7 3.7 9 4.9 13.7 3.6 2.4-.6 4.6-1.9 6.4-3.7 5.5-5.5 5.5-14.5 0-20L88.3 68.1zM260.2 345.9c-53 2.4-96.6-41.2-94.1-94.1.6-12.2 3.6-23.8 8.6-34.3L121.3 164c-27.7 21.4-55.4 48.9-85.1 81.3-5.5 6.1-5.6 15.2-.1 21.3C101 338.3 158.2 400 255.8 400c29.7 0 57.1-7.4 82.3-19.2l-43.5-43.5c-10.6 5-22.2 8-34.4 8.6zM475.8 266c5.3-5.8 5.6-14.6.5-20.7C424 181.8 351.5 112 255.8 112c-29.1 0-56 6.6-82 19l43.7 43.7c10.5-5 22.1-8.1 34.3-8.6 53-2.4 96.6 41.2 94.1 94.1-.6 12.2-3.6 23.8-8.6 34.3l53.5 53.5c33-25.3 61.3-55.9 85-82z"}},{"tag":"path","attr":{"d":"M192.2 260.9c2.4 31.3 27.6 56.5 58.9 58.9 8.2.6 16.1-.3 23.4-2.6l-79.8-79.8c-2.2 7.4-3.1 15.3-2.5 23.5zM320 256c0-1.3-.1-2.6-.1-3.9-5.6 2.5-11.7 3.9-18.2 3.9-1.1 0-2.1 0-3.1-.1l18.6 18.7c1.8-5.9 2.8-12.2 2.8-18.6zM256 209c0-6 1.1-11.7 3.1-16.9-1 0-2-.1-3.1-.1-6.4 0-12.6 1-18.5 2.8l18.7 18.7c-.1-1.5-.2-3-.2-4.5z"}}]})(props);
	};
	module.exports.IoIosEyeOff.displayName = "IoIosEyeOff";
	module.exports.IoIosEye = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.8 112c-80.4 0-143.8 50.6-219.6 133.3-5.5 6.1-5.6 15.2-.1 21.3C101 338.3 158.2 400 255.8 400c96.4 0 168.7-77.7 220.1-134 5.3-5.8 5.6-14.6.5-20.7C424 181.8 351.5 112 255.8 112zm4.4 233.9c-53 2.4-96.6-41.2-94.1-94.1 2.1-46.2 39.5-83.6 85.7-85.7 53-2.4 96.6 41.2 94.1 94.1-2.1 46.2-39.5 83.6-85.7 85.7z"}},{"tag":"path","attr":{"d":"M256 209c0-6 1.1-11.7 3.1-16.9-1 0-2-.1-3.1-.1-36.9 0-66.6 31.4-63.8 68.9 2.4 31.3 27.6 56.5 58.9 58.9 37.5 2.8 68.9-26.9 68.9-63.8 0-1.3-.1-2.6-.1-3.9-5.6 2.5-11.7 3.9-18.2 3.9-25.2 0-45.7-21.1-45.7-47z"}}]})(props);
	};
	module.exports.IoIosEye.displayName = "IoIosEye";
	module.exports.IoIosFastforward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.1 249.3L268 129.1c-5.4-3.1-12.3.6-12.3 6.7V251L44.3 129.1c-5.4-3.1-12.3.6-12.3 6.7v240.3c0 6.1 6.9 9.8 12.3 6.7L255.6 261v115.2c0 6.1 6.9 9.8 12.3 6.7L476 262.7c5.3-3 5.3-10.4.1-13.4z"}}]})(props);
	};
	module.exports.IoIosFastforward.displayName = "IoIosFastforward";
	module.exports.IoIosFemale = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.6 464c3.6 0 7.1-1.4 9.6-4l44.8-44.8 37 37c2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4 5.3-5.3 5.3-13.9 0-19.2l-37-37 50-50c30.6 26 69.3 40.3 109.6 40.3 22.8 0 45-4.5 65.8-13.3 20.1-8.5 38.2-20.7 53.8-36.2 15.5-15.5 27.7-33.6 36.2-53.8 8.8-20.9 13.3-43 13.3-65.8s-4.5-45-13.3-65.8c-8.5-20.1-20.7-38.2-36.2-53.8-15.5-15.5-33.6-27.7-53.8-36.2-20.9-8.8-43-13.3-65.8-13.3-22.8 0-45 4.5-65.8 13.3-20.1 8.5-38.2 20.7-53.8 36.2-15.5 15.5-27.7 33.6-36.2 53.8-8.8 20.9-13.3 43-13.3 65.8 0 40.3 14.3 79 40.3 109.6l-50 50-37-37c-2.6-2.6-6-4-9.6-4-3.6 0-7.1 1.4-9.6 4-5.3 5.3-5.3 13.9 0 19.2l37 37L52 440.8c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4zm132.9-347.2C221.3 90 257 75.2 294.9 75.2c37.9 0 73.5 14.8 100.3 41.6 26.8 26.8 41.6 62.4 41.6 100.3s-14.8 73.5-41.6 100.3c-26.8 26.8-62.4 41.6-100.3 41.6s-73.5-14.8-100.3-41.6C167.7 290.7 153 255 153 217.1s14.7-73.5 41.5-100.3z"}}]})(props);
	};
	module.exports.IoIosFemale.displayName = "IoIosFemale";
	module.exports.IoIosFiling = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 64H88c-22 0-40 18-40 40v304c0 22 18 40 40 40h336c22 0 40-18 40-40V104c0-22-18-40-40-40zm12 176c0 8.8-7.2 16-16 16h-86.8c-6.8 0-12.8 4.2-15.1 10.6C314 278.2 303.8 288 292 288h-72c-11.9 0-22.1-9.8-26.1-21.4-2.2-6.4-8.3-10.6-15.1-10.6H92c-8.8 0-16-7.2-16-16V108c0-8.8 7.2-16 16-16h328c8.8 0 16 7.2 16 16v132z"}},{"tag":"path","attr":{"d":"M386 156H126c-7.7 0-14-6.3-14-14s6.3-14 14-14h260c7.7 0 14 6.3 14 14s-6.3 14-14 14zM386 220H126c-7.7 0-14-6.3-14-14s6.3-14 14-14h260c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosFiling.displayName = "IoIosFiling";
	module.exports.IoIosFilm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.9 80H64.1C46.5 80 32 94.5 32 112.1v287.7c0 17.7 14.5 32.1 32.1 32.1h383.7c17.7 0 32.1-14.5 32.1-32.1V112.1c.1-17.6-14.4-32.1-32-32.1zM120 400c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm232 108H160c-6.6 0-12-5.4-12-12s5.4-12 12-12h192c6.6 0 12 5.4 12 12s-5.4 12-12 12zm104 132c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48z"}}]})(props);
	};
	module.exports.IoIosFilm.displayName = "IoIosFilm";
	module.exports.IoIosFingerPrint = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.8 182c-8.6-24.4-20.3-44.9-33-57.5-2.6-2.6-6-4-9.7-4-3.7 0-7.1 1.4-9.7 4-5.3 5.3-5.3 14 0 19.4 9.9 9.9 19.6 27.4 26.8 48.1 7.3 21.2 11.4 43.6 11.4 63.1 0 3-.1 7.6-.2 10.1-.2 3.7 1.1 7.1 3.6 9.8 2.5 2.7 5.8 4.3 9.5 4.4h.6c7.3 0 13.3-5.7 13.7-13.1.1-3.1.2-8.1.2-11.3 0-22.8-4.7-48.8-13.2-73zM143 110.6c2.9 0 5.6-.9 8-2.6 29.9-21.4 66.2-32.7 105-32.7 40.8 0 80.1 14.8 113.7 42.8 2.5 2 5.6 3.2 8.8 3.2 4.1 0 7.9-1.8 10.5-4.9 4.8-5.8 4-14.4-1.7-19.3C348.6 65 303.3 48 256 48c-44.6 0-86.4 13.1-121 37.8-3 2.1-4.9 5.3-5.5 8.9-.6 3.6.2 7.2 2.4 10.2 2.5 3.6 6.7 5.7 11.1 5.7zM75.4 255c0-43.7 15.8-85.8 44.5-118.7 2.4-2.8 3.6-6.3 3.3-9.9-.2-3.6-1.9-7-4.7-9.4-2.5-2.2-5.7-3.4-9-3.4-4 0-7.7 1.7-10.3 4.7C66.2 156.2 48 204.7 48 255c0 32.8 5.9 58.8 15.4 90.2 1.8 5.8 7 9.7 13.1 9.7 1.3 0 2.7-.2 4-.6 3.5-1.1 6.4-3.4 8.1-6.6 1.7-3.2 2.1-6.9 1-10.4-8.8-29-14.2-52.8-14.2-82.3z"}},{"tag":"path","attr":{"d":"M355.7 129.8C328.4 106.1 295 93.6 259 93.6c-48.3 0-91.4 17.8-121.5 50.1-28.7 30.8-42.8 71.7-39.7 115.1 2.3 32.7 6 50.7 9.3 66.6 4.3 21.1 7.7 37.8 5.1 84.1-.4 6.7 3.7 12.7 10 14.6 1.2.4 2.3.5 3.6.5 7.2 0 13.2-5.7 13.7-12.9 2.9-50.4-.8-68.7-5.5-91.9-3.1-15.1-6.6-32.2-8.8-63.1-2.6-35.7 9-69.3 32.4-94.5 24.8-26.7 60.9-41.4 101.4-41.4 29.3 0 56.5 10.2 78.7 29.5 22.3 19.3 39.2 47.4 49 81.1 11.4 39.3 14.5 89.3 9.1 144.5-.7 7.5 4.8 14.2 12.3 15 .4 0 .9.1 1.3.1 7.1 0 12.9-5.3 13.6-12.4 5.8-58.7 2.3-112.2-10.1-154.8-11.1-38.6-30.9-71.2-57.2-94z"}},{"tag":"path","attr":{"d":"M373.5 267.5c-5.9-37.5-19.9-68.8-40.6-90.6-20.8-22-47.4-33.7-76.9-33.7-19 0-37.7 4.1-54.1 12-3.7 1.8-6.4 5.1-7.4 9.1-1 4.1-.1 8.3 2.5 11.6 2.6 3.4 6.5 5.3 10.8 5.3 2.1 0 4-.5 5.9-1.3 12.6-6 27.2-9.2 42.2-9.2 22.4 0 42.5 9.2 58.3 26.6 16.1 17.8 27.3 43.6 32.1 74.6 4.7 29.6 7 53.5 7.1 73.1.2 39.7-4.8 72.7-4.8 73.1-.6 3.6.3 7.2 2.5 10.2 2.2 3 5.3 4.9 8.9 5.5.7.1 1.4.2 2.1.2 6.8 0 12.5-4.9 13.5-11.6.2-1.4 5.4-35.2 5.2-77.5 0-21.3-2.4-46.5-7.3-77.4zM185.3 203.5c4-5.8 2.9-13.6-2.5-18.2-2.5-2.1-5.6-3.2-8.8-3.2-4.5 0-8.7 2.2-11.3 5.9-14.7 21.5-19.7 49.1-14.4 79.8 8.9 51.3 16.9 111.1 9.4 165-.5 3.8.5 7.7 2.9 10.7 2.3 3 5.7 4.8 9.4 5.1.4 0 .8.1 1.2.1 6.8 0 12.6-5.1 13.5-11.8 8.2-57.7-.2-120.2-9.5-173.8-4.1-23.8-.7-43.9 10.1-59.6zM317.5 388h-.5c-7.6.3-13.5 6.6-13.2 14.2 0 .2.6 17.9-2.6 34.7-1.3 6.9 2.6 13.7 9.1 15.8 1.4.4 2.8.7 4.3.7 6.6 0 12.2-4.7 13.4-11.1 3.8-20.1 3.1-40.2 3.1-41.1-.2-7.5-6.2-13.2-13.6-13.2z"}},{"tag":"path","attr":{"d":"M294.6 205.9c-11.2-10.5-25.2-16.1-40.5-16.1-19.8 0-36.7 7.3-47.6 20.5-8.3 10.1-17 28.8-10.9 60 12.3 62.5 15 121.6 8.1 175.6-1 7.5 4.4 14.4 11.8 15.3.6.1 1.2.1 1.7.1 6.9 0 12.7-5.1 13.6-12 7.3-57 4.5-119-8.3-184.4-3.2-16.4-1.4-29.3 5.1-37.3 5.6-6.8 15-10.5 26.4-10.5 25 0 35.1 27.6 38.3 39.4 6.9 25.7 10.9 63 11.5 107.7.1 7.4 6.2 13.5 13.7 13.5h.2c3.6-.1 7-1.5 9.6-4.1 2.5-2.6 3.9-6.1 3.9-9.7-.7-47-5-86.5-12.5-114.4-4.9-18.5-13.1-33.2-24.1-43.6z"}},{"tag":"path","attr":{"d":"M265.2 245.9c-2.1-5.1-7.1-8.5-12.7-8.5-1.8 0-3.6.4-5.2 1-7 2.9-10.3 10.9-7.4 17.9 6.6 16 11.8 46.2 14.1 82.8 2.4 36.9 1.7 76.9-2 109.6-.4 3.6.6 7.2 2.9 10.1 2.3 2.9 5.5 4.6 9.2 5 .5.1 1 .1 1.5.1 7 0 12.8-5.2 13.6-12.2 3.9-35.5 4.6-76.6 2-115.8-2.5-39.3-8.2-71.3-16-90z"}}]})(props);
	};
	module.exports.IoIosFingerPrint.displayName = "IoIosFingerPrint";
	module.exports.IoIosFitness = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 280H160c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h192c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8zM378 362V150c0-12.1 9.9-22 22-22s22 9.9 22 22v212c0 12.1-9.9 22-22 22s-22-9.9-22-22zM460 192h-12c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h12c11 0 20-9 20-20v-88c0-11-9-20-20-20zM134 362V150c0-12.1-9.9-22-22-22s-22 9.9-22 22v212c0 12.1 9.9 22 22 22s22-9.9 22-22zM64 192H52c-11 0-20 9-20 20v88c0 11 9 20 20 20h12c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8z"}}]})(props);
	};
	module.exports.IoIosFitness.displayName = "IoIosFitness";
	module.exports.IoIosFlag = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.7 80.8c-3.1.5-6.4 1-9.9 1.4-13.2 1.7-42.8 5.2-60.6 5.2-27.7 0-52.8-6.8-78.2-12.2-25.8-5.5-52.4-11.2-80.6-11.2-56.2 0-75.3 12.1-77.3 13.4L96 80.3v353.3c0 7.2 5.2 13.4 12.3 14.3 8.5 1 15.7-5.6 15.7-13.9V279.6c0-3.8 2.7-7.1 6.4-7.9 10.5-2.1 25.8-3.9 47-3.9 26.2 0 50.7 10 76.6 15.5 26.4 5.6 48.6 11.5 83.4 11.5s71.8-6.6 71.8-6.6c3.9-.6 6.9-3.9 6.9-7.9V88.7c-.1-4.9-4.5-8.7-9.4-7.9z"}}]})(props);
	};
	module.exports.IoIosFlag.displayName = "IoIosFlag";
	module.exports.IoIosFlame = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M220.1 48C249.1 182.6 111 179.9 112 315.4c.8 111 118.4 148.6 144.5 148.6 26.1 0 134.8-23.6 143.1-148.6 7.1-106.4-81.7-208-179.5-267.4zm74.3 354.7c-10.2 38.9-66 39-76.4.1-1.5-5.6-2.4-11.5-2.4-17.5 0-41 40.6-88.3 40.6-88.3s40.4 47.3 40.4 88.3c.1 6-.7 11.8-2.2 17.4z"}}]})(props);
	};
	module.exports.IoIosFlame.displayName = "IoIosFlame";
	module.exports.IoIosFlashOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.1 442.7L154.5 55c-4-6.7-12.7-9-19.5-5.1-6.8 3.9-9.1 12.6-5.1 19.3L357.5 457c2.6 4.5 7.4 7 12.3 7 2.4 0 4.9-.6 7.2-1.9 6.7-4 9-12.6 5.1-19.4zM324.6 313.3l57.9-75.8c3.8-5.6.2-13.4-6.3-13.4h-104l52.4 89.2zM320.4 37.1c.9-4.5-4.6-7.1-7.2-3.4L227 146.9l42.4 72.3 51-182.1zM187.4 198.7l-57.9 75.8c-3.8 5.6-.2 13.4 6.3 13.4h103.9l-52.3-89.2zM191.6 474.9c-.9 4.5 4.6 7.1 7.2 3.4L285 365.1l-42.4-72.3-51 182.1z"}}]})(props);
	};
	module.exports.IoIosFlashOff.displayName = "IoIosFlashOff";
	module.exports.IoIosFlash = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.2 224H268l52.4-186.9c.9-4.5-4.6-7.1-7.2-3.4L129.5 274.6c-3.8 5.6-.2 13.4 6.3 13.4H244l-52.4 186.9c-.9 4.5 4.6 7.1 7.2 3.4l183.7-240.8c3.7-5.7.2-13.5-6.3-13.5z"}}]})(props);
	};
	module.exports.IoIosFlash.displayName = "IoIosFlash";
	module.exports.IoIosFlashlight = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M317 32H195c-17.6 0-24 14.4-24 32h170c0-17.6-6.4-32-24-32zM196.1 147.5c7.6 8.8 11.9 20 11.9 31.7v265.9c0 21.9 17.9 34.9 39.9 34.9h16.3c21.9 0 39.9-12.9 39.9-34.9V179.2c0-11.7 4.3-22.8 11.9-31.7 15.4-17.9 25-34.5 25-67.5H171c0 35 9.6 49.6 25.1 67.5zm31.9 90.8c0-15.6 12.6-28.3 28-28.3s28 12.7 28 28.3v35.4c0 15.6-12.6 28.3-28 28.3s-28-12.7-28-28.3v-35.4z"}},{"tag":"circle","attr":{"cx":"256","cy":"273","r":"20"}}]})(props);
	};
	module.exports.IoIosFlashlight.displayName = "IoIosFlashlight";
	module.exports.IoIosFlask = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.4 354.4L320.7 159.9c-.4-.6-.6-1.3-.6-2.1V80c0-2.2 1.8-4 4-4 6.6 0 12-5.4 12-12v-4c0-6.6-5.4-12-12-12H187.8c-6.6 0-12 5.4-12 12v4c0 6.6 5.4 12 12 12 2.2 0 4 1.8 4 4v77.9c0 .7-.2 1.4-.6 2L75.7 354.4c-8.4 15.8-12.5 31.4-12.1 45.6 1.1 36.5 28.8 64 65.2 64h256.6c36.4 0 62.3-27.6 63.2-64 .2-14.2-2.7-29.7-11.2-45.6zM161.8 288c-6.2 0-10.1-6.8-6.9-12.1l60.5-101.7c2.9-4.9 4.5-10.6 4.5-16.3V80c0-1.4-.1-2.7-.2-4h72.7c-.2 1.3-.2 2.6-.2 4v77.9c0 5.8 1.6 11.5 4.6 16.4l60.4 101.6c3.2 5.3-.7 12.1-6.9 12.1H161.8z"}}]})(props);
	};
	module.exports.IoIosFlask.displayName = "IoIosFlask";
	module.exports.IoIosFlower = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M385.1 230.2c-26.7 0-60.1 6.9-86.3 13.5-.9-3.2-2.1-6.2-3.7-9.1 23.2-13.8 51.7-32.5 70.5-51.4 36.7-36.7 48.3-63.6 37.6-74.3-2.6-2.6-6-3.8-10.3-3.8-13.8 0-36 13.4-64 41.4-18.8 18.8-37.6 47.2-51.4 70.4-2.8-1.6-5.9-2.8-9.1-3.8 6.7-26.2 13.5-59.5 13.5-86.1 0-51.9-10.8-79.1-26-79.1s-26 27.2-26 79.1c0 26.6 6.8 60 13.5 86.1-3.2.9-6.2 2.2-9.1 3.8-13.8-23.2-32.5-51.6-51.4-70.4-28-28-50.3-41.4-64-41.4-4.3 0-7.7 1.3-10.3 3.8-10.8 10.8.8 37.6 37.6 74.3 18.9 18.9 47.3 37.6 70.5 51.4-1.5 2.8-2.8 5.9-3.7 9.1-26.2-6.7-59.6-13.5-86.3-13.5-51.8 0-78.7 10.6-78.7 25.8s26.9 26.2 78.9 26.2c26.7 0 60.2-6.9 86.4-13.6.9 3.1 2.2 6.2 3.8 9-23.3 13.8-51.8 32.6-70.7 51.5-36.7 36.7-48.3 63.6-37.6 74.3 2.6 2.6 6 3.8 10.3 3.8 13.8 0 36-13.4 64-41.4 18.9-18.9 37.8-47.5 51.6-70.8 2.8 1.5 5.8 2.8 9 3.7-6.7 26.2-13.6 59.8-13.6 86.5 0 51.9 10.8 78.6 26 78.6s26-26.7 26-78.6c0-26.8-6.9-60.3-13.6-86.5 3.1-.9 6.1-2.1 9-3.7 13.8 23.3 32.6 51.9 51.6 70.8 28 28 50.3 41.4 64 41.4 4.3 0 7.7-1.3 10.3-3.8 10.8-10.8-.8-37.6-37.6-74.3-18.9-18.9-47.5-37.7-70.7-51.5 1.6-2.8 2.8-5.8 3.8-9 26.2 6.7 59.7 13.6 86.4 13.6 51.9 0 78.9-10.8 78.9-26-.2-15.2-27.1-26-79.1-26z"}},{"tag":"path","attr":{"d":"M318.4 376.4c-8.5-8.5-16.9-18.7-24.8-29.5 2 13.2 3.3 26.4 3.3 38.4 0 11.7-.5 22.5-1.6 32.1 12.3 21.8 24.3 32.7 34 32.7 1.6 0 3.2-.3 4.7-.9 11-4.5 13.3-23.3 4.5-54.3-6.4-5.3-13.1-11.5-20.1-18.5zM193.8 136.1c8.4 8.4 16.7 18.5 24.6 29.2-2-13.2-3.2-26.3-3.2-38.2 0-11.7.5-22.5 1.6-32.1-12.3-21.8-24.3-32.7-34-32.7-1.6 0-3.2.3-4.7.9-11 4.5-13.3 23.3-4.5 54.3 6.4 5.4 13.2 11.6 20.2 18.6zM135.8 318.6c8.5-8.5 18.7-16.9 29.5-24.8-13.2 2-26.4 3.3-38.4 3.3-11.7 0-22.5-.5-32.1-1.6-25.5 14.4-36.1 28.2-31.8 38.7 2.6 6.4 10.1 9.9 22.1 9.9 8.5 0 19.3-1.7 32.2-5.4 5.4-6.4 11.5-13.1 18.5-20.1zM376.2 193.8c-8.5 8.5-18.7 16.9-29.5 24.8 13.2-2 26.4-3.3 38.4-3.3 11.7 0 22.5.5 32.1 1.6 25.5-14.4 36.1-28.2 31.8-38.7-2.6-6.4-10.1-9.9-22.1-9.9-8.5 0-19.3 1.7-32.2 5.4-5.4 6.5-11.5 13.2-18.5 20.1zM193.6 376.4c-8.3 8.3-16.3 15.6-23.8 21.6-7.8 28.2-5.5 45.4 4.9 49.9 1.6.7 3.2 1 4.9 1 10.3 0 23.2-12 36.7-36.2-.7-8.4-1.1-17.5-1.1-27.3 0-12 1.3-25.2 3.3-38.4-8 10.7-16.4 20.9-24.9 29.4zM318.4 136.2c8.3-8.3 16.2-15.5 23.7-21.5 7.9-28.4 5.7-45.8-4.8-50.2-1.6-.7-3.2-1-4.9-1-10.3 0-23.2 12-36.7 36.2.7 8.4 1.1 17.5 1.1 27.3 0 12.1-1.3 25.3-3.3 38.7 8-10.7 16.4-21 24.9-29.5zM99.6 216.5c8.4-.7 17.5-1.1 27.3-1.1 12 0 25.1 1.3 38.3 3.3-10.7-7.9-20.9-16.3-29.4-24.8-8.3-8.3-15.6-16.3-21.7-23.9-11.3-3.1-20.9-4.6-28.6-4.6-11.4 0-18.6 3.3-21.2 9.5-4.6 10.9 7.1 25.9 35.3 41.6zM412.4 296c-8.4.7-17.5 1.1-27.3 1.1-12 0-25.2-1.3-38.4-3.3 10.8 7.9 21 16.4 29.5 24.8 8.3 8.3 15.5 16.3 21.6 23.8 11.4 3.2 20.9 4.7 28.6 4.7 11.4 0 18.6-3.3 21.2-9.5 4.7-11-7-25.9-35.2-41.6z"}}]})(props);
	};
	module.exports.IoIosFlower.displayName = "IoIosFlower";
	module.exports.IoIosFolderOpen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 119c0-13.3-9.4-23-22.8-23H230.9c-2.8 0-4.3-.6-6.1-2.4l-22.5-22.5-.2-.2c-4.9-4.6-8.9-6.9-17.3-6.9H88.7C74.9 64 64 74.3 64 87v73h384v-41zM64 188h-8.3c-12.8 0-25.3 5.1-23.5 24.3C34 231.5 55.7 423 55.7 423c2.7 17.8 11.7 25 25 25h352.5c12.7 0 21-7.8 23-25 0 0 22.2-184.9 23.6-205.5 1.4-20.5-8.9-29.5-23.6-29.5H64z"}}]})(props);
	};
	module.exports.IoIosFolderOpen.displayName = "IoIosFolderOpen";
	module.exports.IoIosFolder = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 119c0-13.3-9.4-23-22.8-23H198.9c-2.8 0-4.3-.6-6.1-2.4l-22.5-22.5-.2-.2c-4.9-4.6-8.9-6.9-17.3-6.9H56.7C42.9 64 32 74.3 32 87v73.7c0 1.6 1.7 1.5 3 .7s5-1.4 7-1.4h428c2 0 5.7.6 7 1.4 1.3.8 3 .9 3-.7V119zM32 416.4c0 17.5 14.2 31.6 31.6 31.6H448c17.6 0 32-14.4 32-32V204c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v212.4z"}}]})(props);
	};
	module.exports.IoIosFolder.displayName = "IoIosFolder";
	module.exports.IoIosFootball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256c0 114.7 93.3 208 208 208 114.9 0 208-93.1 208-208 0-114.7-93.3-208-208-208zm127.3 80.7c8.5 8.5 16.1 17.7 22.6 27.5.7 1 .9 2.4.4 3.5L391.9 201c-.4 1-1.1 1.9-2.1 2.3l-57.5 26.2c-1.4.6-3 .4-4.2-.6l-56.6-47.6a4.1 4.1 0 0 1-1.4-3.1v-63.1c0-1.3.7-2.6 1.8-3.3l38.4-26.1c1-.7 2.3-.9 3.5-.5 25.8 8.9 49.6 23.6 69.5 43.5zm-73.9 297.6c-.4 1.2-1.4 2.1-2.6 2.4-16.3 4.8-33.4 7.2-50.8 7.2-17.5 0-34.5-2.5-50.8-7.2-1.2-.4-2.2-1.3-2.6-2.4l-16.4-43c-.4-1.1-.3-2.3.2-3.3l22.3-42.3c.7-1.3 2.1-2.1 3.5-2.1h87.5c1.5 0 2.8.8 3.5 2.1l22.3 42.3c.5 1 .6 2.2.2 3.3l-16.3 43zm-67.4-311v63.1c0 1.2-.5 2.3-1.4 3.1L183.9 229c-1.2 1-2.8 1.2-4.2.6l-57.5-26.2c-1-.5-1.8-1.3-2.1-2.3l-14.4-41.2c-.4-1.2-.3-2.5.4-3.5 6.5-9.8 14.1-19 22.6-27.5 19.9-19.9 43.7-34.6 69.6-43.3 1.2-.4 2.5-.2 3.5.5l38.4 26.1c1.1.5 1.8 1.7 1.8 3.1zM77.7 264.1l36.1-31.2c1.2-1 2.9-1.3 4.3-.6l52.4 23.8c1.1.5 1.9 1.5 2.2 2.7l14.6 57.3c.2 1 .1 2-.3 2.9l-23.2 43.9c-.7 1.3-2.1 2.2-3.6 2.1l-46-.6c-1.2 0-2.4-.6-3.2-1.6-20.5-27.7-32.5-60.6-34.7-95.4 0-1.3.5-2.5 1.4-3.3zm270.4 98.7L325 319c-.5-.9-.6-1.9-.3-2.9l14.6-57.3c.3-1.2 1.1-2.2 2.2-2.7l52.4-23.8c1.4-.6 3.1-.4 4.3.6l36.1 31.2c.9.8 1.5 2 1.4 3.3-2.1 34.8-14.2 67.6-34.7 95.4-.7 1-1.9 1.6-3.2 1.6l-46.1.6c-1.5-.1-2.9-.9-3.6-2.2z"}}]})(props);
	};
	module.exports.IoIosFootball.displayName = "IoIosFootball";
	module.exports.IoIosFunnel = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 87.2c0 5.8 2 11.4 5.6 15.7l152.2 179.8c3.6 4.3 5.6 9.9 5.6 15.7v107c0 10 5.9 18.8 14.6 22l55 19.8c9.6 3.5 19.6-4.3 19.6-15.3V298.3c0-5.8 2-11.4 5.6-15.7l152.2-179.8c3.6-4.3 5.6-9.9 5.6-15.7 0-12.8-9.6-23.2-21.4-23.2H69.4C57.6 64 48 74.4 48 87.2z"}}]})(props);
	};
	module.exports.IoIosFunnel.displayName = "IoIosFunnel";
	module.exports.IoIosGift = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 136h-84.3c12.4-11 20.3-26.6 20.3-44 0-33.1-28.3-60-63.1-60-20.6 0-37.9 9.7-48.9 27.4C245 41.7 227.7 32 207.1 32 172.3 32 144 58.9 144 92c0 17.4 7.8 33 20.3 44H80c-17.7 0-32 14.3-32 32v20c0 2.2 1.8 4 4 4h408c2.2 0 4-1.8 4-4v-20c0-17.7-14.3-32-32-32zM304.9 60c18.6 0 33.7 14.3 33.7 32s-15.1 32-33.7 32h-33.7c0-48 15.1-64 33.7-64zm-97.8 0c18.6 0 33.7 16 33.7 64h-33.7c-18.6 0-33.7-14.3-33.7-32s15.1-32 33.7-32zM64 226v222c0 17.6 14.4 32 32 32h146V218H72c-4.4 0-8 3.6-8 8zM440 218H270v262h146c17.6 0 32-14.4 32-32V226c0-4.4-3.6-8-8-8z"}}]})(props);
	};
	module.exports.IoIosGift.displayName = "IoIosGift";
	module.exports.IoIosGitBranch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96c-38.6 0-70 31.4-70 70 0 33.4 23.7 61.9 55.9 68.5-1.2 19.1-10.3 29.3-27 42.2-20.4 15.7-46.7 20-65.3 23.4-40.7 7.4-62.9 27-72.5 40V170.8c15-2.8 28.7-10.5 39-21.9 11.6-12.9 18-29.5 18-46.9 0-38.6-31.4-70-70-70s-70 31.4-70 70c0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3v171.3c-14.5 3.2-27.8 11-37.7 22.3C96.2 376.7 90 393 90 410c0 38.6 31.4 70 70 70s70-31.4 70-70c0-23.4-11.6-44.9-30.7-57.9 8.6-9.7 24.5-19.6 51.1-24.4 21.6-3.9 52.6-9.6 77.4-28.8 23.6-18.2 36.7-36.5 38-64.3 32.3-6.5 56.1-35.1 56.1-68.6.1-38.6-31.3-70-69.9-70zm-234 6c0-23.2 18.8-42 42-42s42 18.8 42 42-18.8 42-42 42-42-18.8-42-42zm84 308c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm150-202c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitBranch.displayName = "IoIosGitBranch";
	module.exports.IoIosGitCommit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466 242h-76.7c-3.3-31.9-17.8-61.3-41.3-83.5-25-23.5-57.7-36.5-92-36.5s-67 13-91.9 36.5c-23.5 22.2-38 51.6-41.3 83.5H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h76.7c3.3 31.9 17.8 61.3 41.3 83.5 25 23.5 57.7 36.5 92 36.5s67-13 91.9-36.5c23.5-22.2 38-51.6 41.3-83.5H466c7.7 0 14-6.3 14-14s-6.3-14-14-14zm-135 89c-20 20-46.6 31-75 31-28.3 0-54.9-11-75-31-20-20-31-46.6-31-75s11-54.9 31-75c20-20 46.6-31 75-31 28.3 0 54.9 11 75 31 20 20 31 46.6 31 75s-11 54.9-31 75z"}}]})(props);
	};
	module.exports.IoIosGitCommit.displayName = "IoIosGitCommit";
	module.exports.IoIosGitCompare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.9 328.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-2.6 2.6-4.1 6.1-4.1 9.9 0 3.7 1.4 7.3 4.1 9.9l.1.1 41.1 40.1H166c-20.4 0-33.6-7.5-41.6-23.5-8.4-17-9.4-41.5-9.4-58.5V170.8c15-2.8 28.7-10.5 39-21.9 11.6-12.9 18-29.5 18-46.9 0-38.6-31.4-70-70-70s-70 31.4-70 70c0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3V306c0 14.7 0 42.1 9.4 65.3 11.9 29.3 36 44.7 69.6 44.7h89.7L216 456.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l57.6-57.4c4.2-4.2 6.5-9.8 6.5-15.7 0-5.9-2.3-11.3-6.5-15.5l-59.5-59.2zM102 144c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM425 341.6V206c0-14.7 0-42.1-9.4-65.3-11.9-29.2-36-44.7-69.6-44.7h-89.7L296 55.8c5.4-5.4 5.4-14.3 0-19.8l-.1-.1c-2.7-2.5-6.2-3.9-9.8-3.9-3.8 0-7.3 1.4-9.9 4.1l-57.6 57.4c-4.2 4.2-6.5 9.8-6.5 15.7 0 5.9 2.3 11.3 6.5 15.5l59.6 59.4c2.6 2.6 6.1 4.1 9.9 4.1 3.7 0 7.3-1.4 9.9-4.1 2.6-2.6 4.1-6.1 4.1-9.9 0-3.7-1.4-7.3-4.1-9.9l-.1-.1-41.2-40.2H346c20.4 0 33.6 7.5 41.6 23.5 8.4 17 9.4 41.5 9.4 58.5v135.2c-15 2.8-28.7 10.5-39 21.9-11.6 12.9-18 29.5-18 46.9 0 38.6 31.4 70 70 70s70-31.4 70-70c0-17-6.2-33.3-17.3-46.1-9.9-11.3-23.2-19.1-37.7-22.3zM410 452c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitCompare.displayName = "IoIosGitCompare";
	module.exports.IoIosGitMerge = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378 218c-33.5 0-62.1 23.8-68.6 56.1-10.3-.5-18.4-2.7-39.2-10.8-30.5-11.9-71.8-33.2-111.5-95.8 27.1-10.1 45.4-36 45.4-65.5 0-38.6-31.4-70-70-70s-70 31.4-70 70c0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3v171.3c-14.5 3.2-27.8 11-37.7 22.3C70.2 376.7 64 393 64 410c0 38.6 31.4 70 70 70s70-31.4 70-70c0-17.4-6.4-34-18-46.9-10.3-11.4-24-19.1-39-21.9V200.3c40.8 56.8 82 77 113 89.1 25.2 9.8 37.1 12.3 49.5 12.8 6.6 32.2 35.2 55.8 68.5 55.8 38.6 0 70-31.4 70-70s-31.4-70-70-70zM176 410c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm-42-266c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zm244 186c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitMerge.displayName = "IoIosGitMerge";
	module.exports.IoIosGitNetwork = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M377.4 32c-38.9 0-70.6 31.7-70.6 70.7 0 17.1 6.2 33.7 17.5 46.6 10 11.5 23.5 19.4 38.2 22.5v43.1L256 270.3l-106.4-55.4v-43.1c32.2-6.9 55.7-35.6 55.7-69.1 0-39-31.7-70.7-70.6-70.7S64 63.7 64 102.7c0 17.1 6.2 33.7 17.5 46.6 10 11.5 23.5 19.4 38.2 22.5v57.4c0 2.7 1.5 5.1 3.9 6.3l117.5 60.8v43.9c-32.2 6.9-55.7 35.6-55.7 69.1 0 39 31.7 70.7 70.6 70.7s70.6-31.7 70.6-70.7c0-17.1-6.2-33.7-17.5-46.6-10-11.5-23.5-19.4-38.2-22.5v-43.9l117.5-60.8c2.4-1.2 3.9-3.6 3.9-6.3v-57.4c32.2-6.9 55.7-35.6 55.7-69.1 0-39-31.7-70.7-70.6-70.7zM93.8 102.7c0-22.5 18.3-40.8 40.8-40.8s40.8 18.3 40.8 40.8c0 22.5-18.3 40.8-40.8 40.8s-40.8-18.3-40.8-40.8zm203 306.6c0 22.5-18.3 40.8-40.8 40.8s-40.8-18.3-40.8-40.8c0-22.5 18.3-40.8 40.8-40.8s40.8 18.3 40.8 40.8zm80.6-265.7c-22.5 0-40.8-18.3-40.8-40.8 0-22.5 18.3-40.8 40.8-40.8 22.5 0 40.8 18.3 40.8 40.8 0 22.4-18.3 40.8-40.8 40.8z"}}]})(props);
	};
	module.exports.IoIosGitNetwork.displayName = "IoIosGitNetwork";
	module.exports.IoIosGitPullRequest = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393 341.6V206c0-14.7 0-42.1-9.4-65.3-11.9-29.2-36-44.7-69.6-44.7h-77.7L276 55.8c5.4-5.4 5.4-14.3 0-19.8l-.1-.1c-2.7-2.5-6.2-3.9-9.8-3.9-3.8 0-7.3 1.4-9.9 4.1l-54.8 54.6C192.9 61.5 165.9 40 134 40c-38.6 0-70 31.4-70 70 0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3v163.3c-14.5 3.2-27.8 11-37.7 22.3C70.2 376.7 64 393 64 410c0 38.6 31.4 70 70 70s70-31.4 70-70c0-17.4-6.4-34-18-46.9-10.3-11.4-24-19.1-39-21.9V178.8c15-2.8 28.7-10.5 39-21.9 7.6-8.4 12.9-18.4 15.7-29.1l56.4 56.2c2.6 2.6 6.1 4.1 9.9 4.1 3.7 0 7.3-1.4 9.9-4.1 2.6-2.6 4.1-6.1 4.1-9.9 0-3.7-1.4-7.3-4.1-9.9l-.1-.1-41.1-40.1H314c20.4 0 33.6 7.5 41.6 23.5 8.4 17 9.4 41.5 9.4 58.5v135.2c-15 2.8-28.7 10.5-39 21.9-11.6 12.9-18 29.5-18 46.9 0 38.6 31.4 70 70 70s70-31.4 70-70c0-17-6.2-33.3-17.3-46.1-9.9-11.3-23.2-19.1-37.7-22.3zM176 410c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm-42-258c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zm244 300c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitPullRequest.displayName = "IoIosGitPullRequest";
	module.exports.IoIosGlasses = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.5 240.9h-6.2c-3.3-21.1-13.3-40.5-28.5-55.2-17.3-16.6-39.8-25.8-63.4-25.8-20.5 0-40 6.7-56.2 19.4-13.8 10.8-24.2 25.1-30.5 41.7-7-4.6-15.4-7.3-23.7-7.3-8.3 0-16.7 2.6-23.7 7.3-6.2-16.6-16.6-30.9-30.5-41.7-16.2-12.7-35.7-19.4-56.2-19.4-23.6 0-46.1 9.1-63.4 25.6C67 200.4 57 219.9 53.7 241h-6.2c-8 0-14.5 6.7-14.5 15s6.5 15 14.5 15h6.2c3.3 21.2 13.3 40.6 28.5 55.3 17.3 16.6 39.8 25.8 63.4 25.8 51.3 0 93.1-43 93.1-95.9v-.2c0-5.9 6.9-14.9 17.3-14.9s17.3 9 17.3 14.9v.1c0 52.9 41.8 95.9 93.1 95.9 23.7 0 46.2-9.1 63.4-25.8 15.2-14.7 25.2-34.2 28.5-55.4h6.2c8 0 14.5-6.7 14.5-15 0-8.1-6.5-14.9-14.5-14.9z"}}]})(props);
	};
	module.exports.IoIosGlasses.displayName = "IoIosGlasses";
	module.exports.IoIosGlobe = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48h-.7c-55.4.2-107.4 21.9-146.6 61.1C69.6 148.4 48 200.5 48 256s21.6 107.6 60.8 146.9c39.1 39.2 91.2 60.9 146.6 61.1h.7c114.7 0 208-93.3 208-208S370.7 48 256 48zm180.2 194h-77.6c-.9-26.7-4.2-52.2-9.8-76.2 17.1-5.5 33.7-12.5 49.7-21 22 28.2 35 61.6 37.7 97.2zM242 242h-61.8c.8-24.5 3.8-47.7 8.8-69.1 17.4 3.9 35.1 6.3 53 7.1v62zm0 28v61.9c-17.8.8-35.6 3.2-53 7.1-5-21.4-8-44.6-8.8-69H242zm28 0h61.3c-.8 24.4-3.8 47.6-8.8 68.9-17.2-3.9-34.8-6.2-52.5-7V270zm0-28v-62c17.8-.8 35.4-3.2 52.5-7 5 21.4 8 44.5 8.8 69H270zm109.4-117.9c-12.3 6.1-25 11.3-38 15.5-7.1-21.4-16.1-39.9-26.5-54.5 24 8.3 45.9 21.6 64.5 39zM315 146.8c-14.7 3.2-29.8 5.2-45 6V79.4c17 9.2 33.6 33.9 45 67.4zM242 79v73.7c-15.4-.8-30.6-2.8-45.5-6.1 11.6-33.8 28.4-58.5 45.5-67.6zm-45.6 6.4c-10.3 14.5-19.2 32.9-26.3 54.1-12.8-4.2-25.4-9.4-37.5-15.4 18.4-17.3 40.1-30.5 63.8-38.7zm-82.9 59.5c15.8 8.4 32.3 15.4 49.2 20.8-5.7 23.9-9 49.5-9.8 76.2h-77c2.6-35.4 15.6-68.8 37.6-97zM75.8 270h77c.9 26.7 4.2 52.3 9.8 76.2-16.9 5.5-33.4 12.5-49.2 20.8-21.9-28.1-34.9-61.5-37.6-97zm56.7 117.9c12.1-6 24.7-11.2 37.6-15.4 7.1 21.3 16 39.6 26.3 54.2-23.7-8.4-45.4-21.5-63.9-38.8zm64-22.6c14.9-3.3 30.2-5.3 45.5-6.1V433c-17.2-9.1-33.9-33.9-45.5-67.7zm73.5 67.3v-73.5c15.2.8 30.3 2.8 45 6-11.4 33.6-28 58.3-45 67.5zm45-5.7c10.4-14.6 19.4-33.1 26.5-54.5 13 4.2 25.8 9.5 38 15.6-18.6 17.3-40.6 30.6-64.5 38.9zm83.5-59.8c-16-8.5-32.6-15.5-49.7-21 5.6-23.9 8.9-49.4 9.8-76.1h77.6c-2.7 35.5-15.6 68.9-37.7 97.1z"}}]})(props);
	};
	module.exports.IoIosGlobe.displayName = "IoIosGlobe";
	module.exports.IoIosGrid = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M206 308h100c1.1 0 2-.9 2-2V206c0-1.1-.9-2-2-2H206c-1.1 0-2 .9-2 2v100c0 1.1.9 2 2 2z"}},{"tag":"path","attr":{"d":"M64 96v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm330 108h-56c-1.1 0-2 .9-2 2v100c0 1.1.9 2 2 2h56c7.7 0 14 6.3 14 14s-6.3 14-14 14h-56c-1.1 0-2 .9-2 2v56c0 7.7-6.3 14-14 14s-14-6.3-14-14v-56c0-1.1-.9-2-2-2H206c-1.1 0-2 .9-2 2v56c0 7.7-6.3 14-14 14s-14-6.3-14-14v-56c0-1.1-.9-2-2-2h-56c-7.7 0-14-6.3-14-14s6.3-14 14-14h56c1.1 0 2-.9 2-2V206c0-1.1-.9-2-2-2h-56c-7.7 0-14-6.3-14-14s6.3-14 14-14h56c1.1 0 2-.9 2-2v-56c0-7.7 6.3-14 14-14s14 6.3 14 14v56c0 1.1.9 2 2 2h100c1.1 0 2-.9 2-2v-56c0-7.7 6.3-14 14-14s14 6.3 14 14v56c0 1.1.9 2 2 2h56c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosGrid.displayName = "IoIosGrid";
	module.exports.IoIosHammer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.6 246.9c-1.1-2-2.5-3.9-4.1-5.5l-18.4-18.2c-1.9-1.9-4.1-3.5-6.6-4.6-8.2-3.6-17.4-1.7-23.4 4.3-6.4 6.3-18.1 17.8-39.2 38.7-40.4 40-98.1 89.6-132 118.2-7.2 6.1-7.7 17-1.1 23.7L92 443.2c6.7 6.7 17.6 6.3 23.8-.9 29.4-34.6 79.5-92.3 119.4-131.8 20.5-20.2 32-31.8 38.5-38.2 6.5-6.6 8.3-16.7 3.9-25.4zM462.4 218.1l-34.5-34.2c-1.1-1.1-2.5-1.6-4-1.6-1.4 0-2.9.5-4 1.6-2.5 2.5-6.1 3.8-9.6 3.3-4.5-.5-9.3-1.9-12.4-4.9-7-6.9 1.1-20.5-5.1-29.2-6.2-8.7-16.1-19.8-23.2-26.9-7.1-7-35-33.7-82-52.9-16.6-6.8-32.8-9.3-47.3-9.3-26.5 0-47.4 8.5-54.8 15.3-5.5 5.1-11.2 14.1-3.1 14.1.7 0 1.5-.1 2.4-.2 4.5-.7 13.3-1.5 23.4-1.5 15.7 0 34.5 2.1 44.6 10.1 16.3 13.1 29.8 30.6 30.9 53.2.8 16.8-3.4 28.2-18.7 45.5-2.8 3.2-2.6 8 .4 10.9l19.2 19.2c3.1 3.1 8.1 3.1 11.2.1 14-13.6 22.1-20.2 31.3-22.7 4-1.1 8.4-1.6 12.8-1.6 9.7 0 19.2 2.2 23.6 4.6 1.1.6 2.1 1.4 3.1 2.4 6.5 6.6 6.1 17.4-.5 23.9l-2 1.9c-2.2 2.2-2.2 5.7 0 7.9l34.5 34.2c1.1 1.1 2.5 1.6 4 1.6 1.4 0 2.9-.5 4-1.6l55.8-55.2c2.1-2.3 2.1-5.8 0-8z"}}]})(props);
	};
	module.exports.IoIosHammer.displayName = "IoIosHammer";
	module.exports.IoIosHand = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394.9 117.3c-11.6 0-21.1 9.3-21.1 20.6v109.4c0 4.8-4 8.7-8.9 8.7s-8.9-3.9-8.9-8.7V85.9c0-11.3-9.5-20.6-21.1-20.6-11.6 0-21.1 9.3-21.1 20.6v126.8c0 4.8-4 8.7-8.9 8.7s-8.9-3.9-8.9-8.7V68.6c0-11.3-9.5-20.6-21.1-20.6-11.6 0-21.1 9.3-21.1 20.6V230c0 4.8-4 8.7-8.9 8.7s-8.9-3.9-8.9-8.7V103.2c0-11.3-9.5-20.6-21.1-20.6-11.6 0-21.1 9.3-21.1 20.6v218.3L166 297.9c-26.1-22.7-48.2-32.4-66.2-15.7-12.1 11.8 6.9 30.9 26.8 53.2 19.2 21.5 70 91.9 113.3 117.3 0 0 16.7 11.4 40.6 11.4h57.2c46.1 0 78.4-37.9 78.4-93.2v-233c-.1-11.3-9.6-20.6-21.2-20.6z"}}]})(props);
	};
	module.exports.IoIosHand.displayName = "IoIosHand";
	module.exports.IoIosHappy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm72 152c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm72 169c-44.7 0-82.3-29.9-94.2-70.7-1.5-5.1 2.3-10.3 7.7-10.3h172.9c5.3 0 9.2 5.1 7.7 10.3-11.8 40.8-49.4 70.7-94.1 70.7z"}}]})(props);
	};
	module.exports.IoIosHappy.displayName = "IoIosHappy";
	module.exports.IoIosHeadset = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 123.8c-24.3 0-46.9 10.1-63.9 28.4-17 18.3-26.1 33.2-26.1 59.6 0 7.7 5.9 14 13.2 14 7.3 0 13.2-6.3 13.2-14 0-17.3 6.6-32.4 19-43.5 11.8-10.6 27.7-16.5 44.7-16.5s32.9 5.8 44.7 16.5c12.4 11.2 19 26.2 19 43.5 0 7.7 5.9 14 13.2 14 7.3 0 13.2-6.3 13.2-14 0-26.4-9.2-41.3-26.1-59.6-17.2-18.4-39.8-28.4-64.1-28.4z"}},{"tag":"path","attr":{"d":"M457.1 278.9C442.3 264.1 422.8 256 402 256h-8c-2.2 0-4-1.8-4-4v-37.8c0-35.7-14-69.3-39.4-94.7C325.3 94 291.7 80 256 80c-35.7 0-69.3 14-94.6 39.4-25.4 25.4-39.4 59-39.4 94.7V252c0 2.2-1.8 4-4 4h-8c-20.8 0-40.3 8.1-55.1 22.9C40.1 293.7 32 313.2 32 334v11.8c0 20.8 8.1 40.4 22.9 55.2 14.8 14.8 34.4 23 55.1 23h5.6c4 0 8 1.4 10.9 4.1 2.5 2.3 5.9 3.8 9.5 3.8 7.7 0 14-6.3 14-14.1V214.1c0-28.2 11.1-54.8 31.2-74.9 20.1-20.1 46.7-31.2 74.8-31.2 28.2 0 54.8 11.1 74.8 31.2 20.1 20.1 31.2 46.7 31.2 74.9v203.8c0 7.8 6.3 14.1 14 14.1 3.6 0 7-1.5 9.5-3.8 2.9-2.7 6.9-4.1 10.9-4.1h5.6c20.7 0 40.3-8.2 55.1-23 14.8-14.8 22.9-34.4 22.9-55.2V334c0-20.8-8.1-40.3-22.9-55.1z"}}]})(props);
	};
	module.exports.IoIosHeadset.displayName = "IoIosHeadset";
	module.exports.IoIosHeartDislike = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M423.8 426.8L56.3 65.1c-5.6-5.5-14.6-5.5-20.1.1-5.5 5.5-5.5 14.5 0 20l367.5 361.7c3.7 3.7 9 4.9 13.7 3.6 2.4-.6 4.6-1.9 6.4-3.7 5.6-5.5 5.6-14.5 0-20zM64 169c0 37 15.2 89.5 46.8 132.7C171 384 272 456 272 456s29.3-20.3 65.7-51.6L68 139c-2.6 9.6-4 19.6-4 30zM434.2 301.7C465.8 258.5 480 206 480 169c0-62.1-50.1-112.4-112-113h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-29.2.3-55.8 11.6-75.7 30l281.9 277.4c19.3-19.1 36.2-40 52-61.7z"}}]})(props);
	};
	module.exports.IoIosHeartDislike.displayName = "IoIosHeartDislike";
	module.exports.IoIosHeartEmpty = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 56h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-61.9.6-112 50.9-112 113 0 37 16.2 89.5 47.8 132.7C156 384 256 456 256 456s100-72 160.2-154.3C447.8 258.5 464 206 464 169c0-62.1-50.1-112.4-112-113zm41.6 229.2C351 343.5 286.1 397.3 256 420.8c-30.1-23.5-95-77.4-137.6-135.7C89.1 245.1 76 198 76 169c0-22.6 8.8-43.8 24.6-59.8 15.9-16 37-24.9 59.6-25.1H161.1c14.3 0 28.5 3.7 41.1 10.8 12.2 6.9 22.8 16.7 30.4 28.5 5.2 7.9 14 12.7 23.5 12.7s18.3-4.8 23.5-12.7c7.7-11.8 18.2-21.6 30.4-28.5 12.6-7.1 26.8-10.8 41.1-10.8h.9c22.5.2 43.7 9.1 59.6 25.1 15.9 16 24.6 37.3 24.6 59.8-.2 29-13.3 76.1-42.6 116.2z"}}]})(props);
	};
	module.exports.IoIosHeartEmpty.displayName = "IoIosHeartEmpty";
	module.exports.IoIosHeartHalf = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 56h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-61.9.6-112 50.9-112 113 0 37 16.2 89.5 47.8 132.7C156 384 256 456 256 456s100-72 160.2-154.3C447.8 258.5 464 206 464 169c0-62.1-50.1-112.4-112-113zm41.6 229.2C356.4 336 302.2 383.6 269 410.5c-5.2 4.2-13 .5-13-6.2V198.6c0-26.8 8.5-52.7 23.3-75 .1-.1.1-.2.2-.2 7.7-11.8 18.2-21.6 30.4-28.5 12.6-7.1 26.8-10.8 41.1-10.8h.9c22.5.2 43.7 9.1 59.6 25.1 15.9 16 24.6 37.3 24.6 59.8-.1 29-13.2 76.1-42.5 116.2z"}}]})(props);
	};
	module.exports.IoIosHeartHalf.displayName = "IoIosHeartHalf";
	module.exports.IoIosHeart = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 56h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-61.9.6-112 50.9-112 113 0 37 16.2 89.5 47.8 132.7C156 384 256 456 256 456s100-72 160.2-154.3C447.8 258.5 464 206 464 169c0-62.1-50.1-112.4-112-113z"}}]})(props);
	};
	module.exports.IoIosHeart.displayName = "IoIosHeart";
	module.exports.IoIosHelpBuoy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm54.6 36.4c27.1 8.6 52 23.6 72.7 44.3 20.7 20.7 35.7 45.6 44.3 72.7l-88.8 6c-8.2-14-19.9-25.7-33.9-34l5.7-89zm-181.9 44.3c20.7-20.7 45.5-35.7 72.7-44.3l5.7 89c-13.9 8.3-25.6 20-33.9 33.9l-88.9-5.9c8.7-27.1 23.7-52 44.4-72.7zm72.7 298.9c-27.1-8.6-52-23.6-72.7-44.3-20.7-20.7-35.7-45.6-44.3-72.7l89-5.7c8.2 13.9 19.9 25.5 33.8 33.8l-5.8 88.9zM256 324c-37.5 0-68-30.5-68-68s30.5-68 68-68 68 30.5 68 68-30.5 68-68 68zm127.3 59.3c-20.7 20.7-45.6 35.7-72.7 44.3l-5.9-88.9c14.1-8.3 25.8-20.1 34.1-34.2l88.8 6c-8.6 27.2-23.6 52.1-44.3 72.8z"}}]})(props);
	};
	module.exports.IoIosHelpBuoy.displayName = "IoIosHelpBuoy";
	module.exports.IoIosHelpCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M256.7 160c37.5 0 63.3 20.8 63.3 50.7 0 19.8-9.6 33.5-28.1 44.4-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-54.9 64.7-54.9zm-26.3 171.4c0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6s-9.6 20.6-21.5 20.6-21.4-9-21.4-20.6z"}}]})(props);
	};
	module.exports.IoIosHelpCircleOutline.displayName = "IoIosHelpCircleOutline";
	module.exports.IoIosHelpCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-4.3 304c-11.8 0-21.4-9-21.4-20.6 0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6 0 11.6-9.5 20.6-21.5 20.6zm40.2-96.9c-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-55 64.7-55 37.5 0 63.3 20.8 63.3 50.7 0 19.9-9.6 33.6-28.1 44.5z"}}]})(props);
	};
	module.exports.IoIosHelpCircle.displayName = "IoIosHelpCircle";
	module.exports.IoIosHelp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.7 160c37.5 0 63.3 20.8 63.3 50.7 0 19.8-9.6 33.5-28.1 44.4-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-54.9 64.7-54.9zm-26.3 171.4c0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6s-9.6 20.6-21.5 20.6-21.4-9-21.4-20.6z"}}]})(props);
	};
	module.exports.IoIosHelp.displayName = "IoIosHelp";
	module.exports.IoIosHome = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.5 104.1c-1.5-1.2-3.5-1.2-5 0l-156 124.8c-.9.8-1.5 1.9-1.5 3.1v230c0 1.1.9 2 2 2h108c1.1 0 2-.9 2-2V322c0-1.1.9-2 2-2h92c1.1 0 2 .9 2 2v140c0 1.1.9 2 2 2h108c1.1 0 2-.9 2-2V232c0-1.2-.6-2.4-1.5-3.1l-156-124.8z"}},{"tag":"path","attr":{"d":"M458.7 204.2l-189-151.4C265.9 49.7 261 48 256 48s-9.9 1.7-13.7 4.8L160 119.7V77.5c0-1.1-.9-2-2-2H98c-1.1 0-2 .9-2 2v92.2l-42.7 35.1c-3.1 2.5-5.1 6.2-5.3 10.2-.2 4 1.3 7.9 4.1 10.7 2.6 2.6 6.1 4.1 9.9 4.1 3.2 0 6.3-1.1 8.8-3.1l183.9-148c.5-.4.9-.4 1.3-.4s.8.1 1.3.4l183.9 147.4c2.5 2 5.6 3.1 8.8 3.1 3.7 0 7.2-1.4 9.9-4.1 2.9-2.8 4.4-6.7 4.2-10.7-.3-4-2.2-7.7-5.4-10.2z"}}]})(props);
	};
	module.exports.IoIosHome.displayName = "IoIosHome";
	module.exports.IoIosHourglass = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.6 434h-5.1c-6.5 0-12-.9-12.7-7.4v-.1C383.2 290.6 297.6 288 297.6 256s85.7-34.6 100.2-170.5v-.1c.7-6.5 6.2-7.4 12.7-7.4h5.1c7.5 0 14-5.8 14.4-13.3.4-8-6-14.7-14-14.7H96.4c-7.5 0-14 5.8-14.4 13.3-.4 8 6 14.7 14 14.7h5.5c6.5 0 12 .9 12.7 7.4v.1C128.8 221.4 214.4 224 214.4 256s-85.7 34.6-100.2 170.5v.1c-.7 6.5-6.2 7.4-12.7 7.4h-5.1c-7.5 0-14 5.8-14.4 13.3-.4 8 6 14.7 14 14.7h320c8 0 14.4-6.6 14-14.7-.4-7.5-6.9-13.3-14.4-13.3zm-252.3-34.2c28.7-79.8 79.6-70.1 79.6-101.6v-55.6c0-19.4-36.8-32.9-59.8-64.4-3.8-5.2 0-12.4 6.5-12.4h132.9c6.5 0 10.4 7 6.7 12.2-22.6 31.6-60.1 45.2-60.1 64.6v55.6c0 31.2 48.9 22.7 79.8 101.6 2.8 7.1.7 16-6.9 16H170.2c-7.7 0-9.5-8.8-6.9-16z"}}]})(props);
	};
	module.exports.IoIosHourglass.displayName = "IoIosHourglass";
	module.exports.IoIosIceCream = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M220.8 406.1l4.8 14.8c.4 1.2 1.9 1.8 3 1.1l6.8-4.2c2.5-1.6 2.5-5.2 0-6.8l-11.5-7.2c-1.7-1-3.6.5-3.1 2.3zM286.6 421l4.9-15.2c.6-1.8-1.4-3.3-3-2.3l-11.9 7.4a4.02 4.02 0 0 0 0 6.8l7 4.4c1.2.7 2.6.1 3-1.1zM188.6 242.2c-3.9 3.5-9.6 6.4-15.7 8.5-1 .4-1.6 1.5-1.2 2.5l9.3 28.9 3.8 11.8c.4 1.2 1.9 1.8 3 1.1l7-4.3 36.6-22.5c3-1.9 2.3-6.5-1.2-7.3-14.3-3.3-26.5-9.8-36.2-18.5-1.6-1.4-3.9-1.5-5.4-.2zM192.6 310.8l-2 1.2 14.6 45.3c.4 1.2 1.9 1.8 3 1.1l27.2-16.9c2.5-1.6 2.5-5.2 0-6.8l-38.5-23.9c-1.4-.8-3-.8-4.3 0zM258.1 348.9c-1.3-.8-2.9-.8-4.2 0L212 374.5l-.1.1c-1 .8-1 2.4 0 3.2l.7.5 41.3 25.3c1.3.8 2.9.8 4.2 0l41.7-25.5.4-.3c1-.8 1-2.2 0-3l-42.1-25.9zM296.7 296.6l-38.5-23.9c-1.3-.8-2.9-.8-4.2 0l-38.5 23.9a4.02 4.02 0 0 0 0 6.8l38.5 23.9c1.3.8 2.9.8 4.2 0l38.5-23.9c2.5-1.5 2.5-5.2 0-6.8zM318.1 242.3c-9.7 8.7-22 15.1-36.2 18.5-3.5.8-4.2 5.4-1.2 7.3l36.6 22.5 7.4 4.6c1.1.7 2.6.2 3-1.1l4-12.4 9.8-30.3c-6.9-2.1-13.6-5.3-18-9.2-1.6-1.3-3.9-1.2-5.4.1zM232.4 442l1.6 5s7.5 19 22 19c15 0 22.2-19 22.2-19l1.6-4.8c.6-1.7-.1-3.7-1.7-4.6l-20-12.4c-1.3-.8-2.9-.8-4.2 0l-19.8 12.3c-1.6.8-2.3 2.7-1.7 4.5zM276.7 341.5l27.5 17.1c1.1.7 2.6.2 3-1.1l14.2-43.8c.3-.9-.1-1.8-.8-2.3l-1-.6c-1.3-.8-2.9-.8-4.2 0l-38.5 23.9c-2.8 1.6-2.8 5.3-.2 6.8z"}},{"tag":"path","attr":{"d":"M376.1 168.2c-6.2 5.4-13.2 8.7-18 10.5-1.8.7-3.5-1.4-2.3-3l4-5.7c6.1-8.7 8.5-19.4 6.8-29.8C357.9 86.8 311.7 46 256 46c-55.7 0-101.9 41.2-110.6 94.7-1.7 10.5.8 21.2 6.9 29.8l4 5.6c1.2 1.6-.5 3.8-2.4 3-5.4-2.1-13.5-6.2-20.1-12.8-1.4-1.4-3.6-1.5-5.2-.4-10.2 7.3-16.8 19.1-16.8 32.5 0 22.1 17.9 40 40 40 11.3 0 28-4.7 36.6-12.3 1.5-1.3 3.8-1.3 5.3.1 15.2 13.4 36.6 20.2 62.1 20.2s47-6.8 62.1-20.2c1.5-1.3 3.8-1.4 5.3-.1 8.5 7.6 25.3 12.3 36.6 12.3 22.1 0 40-18 40-40.1 0-11.9-5.2-22.6-13.5-30-2.7-2.6-7.2-2.7-10.2-.1z"}}]})(props);
	};
	module.exports.IoIosIceCream.displayName = "IoIosIceCream";
	module.exports.IoIosImage = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112.6 312.3h190.7c4.5 0 7.1-5.1 4.5-8.8l-95.4-153.4c-2.2-3.2-6.9-3.2-9.1 0L108 303.5c-2.6 3.7.1 8.8 4.6 8.8zM306.7 254.3l35 55.7c1 1.5 2.7 2.4 4.5 2.4h53.2c4.5 0 7.1-5.1 4.5-8.8l-61.6-87.7c-2.2-3.2-6.9-3.2-9.1 0L306.6 248c-1.2 1.8-1.2 4.3.1 6.3zM351.1 167.9c13.1-1.3 23.7-11.9 25-25 1.8-17.7-13-32.5-30.7-30.7-13.1 1.3-23.7 11.9-25 25-1.7 17.7 13 32.5 30.7 30.7z"}},{"tag":"path","attr":{"d":"M432 48H80c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zm-2.7 280c0 4.4-3.6 8-8 8H90.7c-4.4 0-8-3.6-8-8V90.7c0-4.4 3.6-8 8-8h330.7c4.4 0 8 3.6 8 8V328z"}}]})(props);
	};
	module.exports.IoIosImage.displayName = "IoIosImage";
	module.exports.IoIosImages = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M262.3 199.2c-1.6-2.8-5.6-3.2-7.7-.7l-91.9 122.2c-2.5 2.9-.6 7.4 3.2 7.7l161.1 14c3.8.3 6.4-3.8 4.5-7.1l-69.2-136.1zM367.2 264.1c-1.6-2.8-5.6-3.2-7.7-.7l-24.8 25.1a4.68 4.68 0 0 0-.5 5.4l25.4 49.5c.8 1.3 2.1 2.2 3.7 2.3l44.9 3.9c3.8.3 6.4-3.8 4.5-7.1l-45.5-78.4zM378.1 224.4c11.2-.1 20.9-8.3 23-19.2 2.8-14.8-8.6-28.3-23.7-28.1-11.2.1-20.9 8.3-23 19.2-2.8 14.8 8.6 28.3 23.7 28.1z"}},{"tag":"path","attr":{"d":"M455.2 129.3l-65.8-5.7-6.1-67c-1.3-14.9-14.5-25.9-29.5-24.5L56.7 58.9c-14.9 1.3-25.9 14.5-24.6 29.4l26.8 296.5c1.3 14.9 14.5 25.9 29.5 24.5l15.7-1.4-1.5 16.7c-1.3 14.9 9.7 28 24.7 29.3l297.3 25.9c14.9 1.3 28.1-9.7 29.4-24.6l26-296.6c1.2-14.8-9.8-28-24.8-29.3zM87.6 300.7c-3.7.3-7-2.4-7.4-6.1l-18-200c-.3-3.7 2.4-7 6.1-7.3l279.2-25.1c3.7-.3 7 2.4 7.4 6.1l4.8 52.8L158 103.4c-14.9-1.3-28.1 9.7-29.4 24.6l-14.9 170.3-26.1 2.4zm362.2-135.6l-17.5 200c-.3 3.7-3.6 6.5-7.3 6.2l-18.6-1.6L145.7 347c-3.7-.3-6.5-3.6-6.2-7.3l3.8-43.9L157 139.7c.3-3.7 3.6-6.5 7.3-6.2l198 17.3 29.7 2.6 51.6 4.5c3.8.2 6.6 3.5 6.2 7.2z"}}]})(props);
	};
	module.exports.IoIosImages.displayName = "IoIosImages";
	module.exports.IoIosInfinite = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.8 182.4c-20-19.6-46.8-30.4-75.2-30.4-28.5 0-55.2 10.8-75.2 30.4l-31.2 30c-1.6 1.6-1.6 4.2 0 5.7l19.4 19.1c1.5 1.5 4 1.5 5.6 0l31-30.1c13.5-13.1 31.3-20.3 50.3-20.3 19 0 36.8 7.2 50.3 20.3 13.4 13.1 20.7 30.5 20.7 49 0 18.4-7.4 35.8-20.7 48.7-13.5 13.1-31.3 20.3-50.3 20.3-19 0-36.8-7.2-50.3-20.3L205.6 182.4c-20.2-19.6-46.9-30.4-75.2-30.4-28.5 0-55.2 10.8-75.2 30.4C35.1 202 24 228.1 24 256c0 27.8 11.1 54 31.2 73.6 20 19.6 46.8 30.4 75.2 30.4 28.5 0 55.2-10.8 75.2-30.4l31-30c1.6-1.6 1.6-4.2 0-5.7L217.2 275c-1.5-1.5-4-1.5-5.6 0l-31 29.9c-13.5 13.1-31.3 20.3-50.3 20.3-19 0-36.8-7.2-50.3-20.3-13.4-13.1-20.7-30.5-20.7-49 0-18.4 7.4-35.7 20.7-48.7 13.5-13.1 31.3-20.3 50.3-20.3 19 0 36.8 7.2 50.3 20.3l125.5 122.5c20.2 19.6 46.9 30.4 75.2 30.4 28.5 0 55.2-10.8 75.2-30.4 20.2-19.6 31.3-45.7 31.3-73.6.2-27.9-10.9-54.1-31-73.7z"}}]})(props);
	};
	module.exports.IoIosInfinite.displayName = "IoIosInfinite";
	module.exports.IoIosInformationCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M235.4 172.2c0-11.4 9.3-19.9 20.5-19.9 11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20c-11.2 0-20.5-8.6-20.5-20zm1.4 35.7H275V352h-38.2V207.9z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosInformationCircleOutline.displayName = "IoIosInformationCircleOutline";
	module.exports.IoIosInformationCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm19 304h-38.2V207.9H275V352zm-19.1-159.8c-11.3 0-20.5-8.6-20.5-20s9.3-19.9 20.5-19.9c11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20z"}}]})(props);
	};
	module.exports.IoIosInformationCircle.displayName = "IoIosInformationCircle";
	module.exports.IoIosInformation = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M235.4 176c0-11.4 9.3-19.9 20.5-19.9 11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20c-11.2.1-20.5-8.6-20.5-20zm1.4 35.8H275v144.1h-38.2V211.8z"}}]})(props);
	};
	module.exports.IoIosInformation.displayName = "IoIosInformation";
	module.exports.IoIosJet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 48s-19.8 1.4-53.1 27.2c-15.5 12-162.2 120.6-162.2 120.6L89 187.9l-41 36.5 102 51.2-8 10.1-81.6 4.1-6.7 33.6 60.6 47.2-26.7 53.6 53.7-26.5 47.3 60.6 33.6-6.7 4.1-81.6 10.1-7.9L287.6 464l36.5-40.9-7.9-159.7s108.6-146.7 120.6-162C462.7 67.8 464 48 464 48z"}}]})(props);
	};
	module.exports.IoIosJet.displayName = "IoIosJet";
	module.exports.IoIosJournal = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M92.1 32C76.6 32 64 44.6 64 60.1V452c0 15.5 12.6 28.1 28.1 28.1H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H112.5c-8.2 0-15.4-6-16.4-14.1-1.1-9.7 6.5-18 15.9-18h208V32H92.1z"}},{"tag":"path","attr":{"d":"M432 416c8.8 0 16-7.2 16-16V60.1c0-15.5-12.6-28.1-28.1-28.1H368v384h64z"}}]})(props);
	};
	module.exports.IoIosJournal.displayName = "IoIosJournal";
	module.exports.IoIosKey = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M344.8 218.1c-13 0-25.6 0-37.4 4.1-50.6-43.1-184.3-156.9-194.5-167.5-4.7-4.9-9.9-6.7-15-6.7-8.5 0-16.7 5.2-21.3 9.6-6.9 6.6-33 34.8-28 40 15 15.4 19 18.5 25.2 24.8 9.3 9.5 28.3-1 36 2.3 7.6 3.3 9.2 6.8 10.4 12.5s-2.9 15.8-3 23.7c-.1 8.3 3.4 12.8 9.2 19 4.6 5 8.9 8.6 15.6 8.7 9 .2 20.9-12.8 30.4-3.1s-6.2 23.7-5 34 15.5 22.8 21.6 24.1c6.1 1.3 21.8-11.7 30.7-9.7 3 .7 10 6.8 11 11.4s-6.9 25-5.9 29.6c1.2 5.6 7.1 12.1 10.4 17.4-6.7 15.5-9.4 29.6-9.4 47.7 0 68.5 53.4 124 119.2 124s119-55.5 119-124-53.4-121.9-119.2-121.9zM368 400c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.IoIosKey.displayName = "IoIosKey";
	module.exports.IoIosKeypad = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394.6 341.2c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM256 341.2c-29.5 0-53.4 23.9-53.4 53.4S226.5 448 256 448s53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM117.4 341.2c-29.5 0-53.4 23.9-53.4 53.4S87.9 448 117.4 448s53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM394.6 202.6c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4S448 285.5 448 256s-23.9-53.4-53.4-53.4zM256 202.6c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM117.4 202.6C87.9 202.6 64 226.5 64 256s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM394.6 64c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4S424.1 64 394.6 64zM256 64c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4S285.5 64 256 64zM117.4 64C87.9 64 64 87.9 64 117.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4S146.9 64 117.4 64z"}}]})(props);
	};
	module.exports.IoIosKeypad.displayName = "IoIosKeypad";
	module.exports.IoIosLaptop = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 367.5V129.1c0-9.4-7.9-17.1-17.2-17.1H81.2c-9.3 0-17.2 7.6-17.2 17.1v238.4H15.9c0 9.9 9.9 18.8 18.9 22.7C45.7 394.8 64 400 84 400h344c20 0 38.2-4.5 48.3-8.8 9.5-4 19.8-13.4 19.8-23.7H448zM256 120c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zM82 136.2h348c1.1 0 2 .9 2 2v211.3c0 1.1-.9 2-2 2H82c-1.1 0-2-.9-2-2V138.2c0-1.2.9-2 2-2zm216.3 239.3h-84.6c-5.2 0-9.7-6-9.7-7.5h104c0 1.5-3 7.5-9.7 7.5z"}}]})(props);
	};
	module.exports.IoIosLaptop.displayName = "IoIosLaptop";
	module.exports.IoIosLeaf = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.9 378.7c-51.8-8-55.7-11.7-55.7-11.7 15.6-74-22.4-151.1-76.3-195.6C250.1 112.2 141 155.2 56 65.2c-19.8-21-8.3 235.5 98.1 332.7 77.8 71 169.4 49.2 194.5 37.6 22.8-10.6 38.7-33.9 38.7-33.9 41.5 13 62 14.2 62 14.2 14.6 1.8 22-34.4 4.6-37.1zm-91.8 7.4c-77.7-23.3-145.3-81-189.1-126.2-3.6-3.7 1.6-9.2 5.5-6 43.1 35.5 108.9 80 193.3 107.9.2 8.1-4.5 19.7-9.7 24.3z"}}]})(props);
	};
	module.exports.IoIosLeaf.displayName = "IoIosLeaf";
	module.exports.IoIosLink = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280 341.1l-1.2.1c-3.6.4-7 2-9.6 4.5l-64.6 64.6c-13.7 13.7-32 21.2-51.5 21.2s-37.8-7.5-51.5-21.2c-13.7-13.7-21.2-32-21.2-51.5s7.5-37.8 21.2-51.5l68.6-68.6c3.5-3.5 7.3-6.6 11.4-9.3 4.6-3 9.6-5.6 14.8-7.5 4.8-1.8 9.9-3 15-3.7 3.4-.5 6.9-.7 10.2-.7 1.4 0 2.8.1 4.6.2 17.7 1.1 34.4 8.6 46.8 21 7.7 7.7 13.6 17.1 17.1 27.3 2.8 8 11.2 12.5 19.3 10.1.1 0 .2-.1.3-.1.1 0 .2 0 .2-.1 8.1-2.5 12.8-11 10.5-19.1-4.4-15.6-12.2-28.7-24.6-41-15.6-15.6-35.9-25.8-57.6-29.3-1.9-.3-3.8-.6-5.7-.8-3.7-.4-7.4-.6-11.1-.6-2.6 0-5.2.1-7.7.3-5.4.4-10.8 1.2-16.2 2.5-1.1.2-2.1.5-3.2.8-6.7 1.8-13.3 4.2-19.5 7.3-10.3 5.1-19.6 11.7-27.7 19.9l-68.6 68.6C58.9 304.4 48 330.8 48 359c0 28.2 10.9 54.6 30.7 74.4C98.5 453.1 124.9 464 153 464c28.2 0 54.6-10.9 74.4-30.7l65.3-65.3c10.4-10.5 2-28.3-12.7-26.9z"}},{"tag":"path","attr":{"d":"M433.3 78.7C413.5 58.9 387.1 48 359 48s-54.6 10.9-74.4 30.7l-63.7 63.7c-9.7 9.7-3.6 26.3 10.1 27.4 4.7.4 9.3-1.3 12.7-4.6l63.8-63.6c13.7-13.7 32-21.2 51.5-21.2s37.8 7.5 51.5 21.2c13.7 13.7 21.2 32 21.2 51.5s-7.5 37.8-21.2 51.5l-68.6 68.6c-3.5 3.5-7.3 6.6-11.4 9.3-4.6 3-9.6 5.6-14.8 7.5-4.8 1.8-9.9 3-15 3.7-3.4.5-6.9.7-10.2.7-1.4 0-2.9-.1-4.6-.2-17.7-1.1-34.4-8.6-46.8-21-7.3-7.3-12.8-16-16.4-25.5-2.9-7.7-11.1-11.9-19.1-9.8-8.9 2.3-14.1 11.7-11.3 20.5 4.5 14 12.1 25.9 23.7 37.5l.2.2c16.9 16.9 39.4 27.6 63.3 30.1 3.7.4 7.4.6 11.1.6 2.6 0 5.2-.1 7.8-.3 6.5-.5 13-1.6 19.3-3.2 6.7-1.8 13.3-4.2 19.5-7.3 10.3-5.1 19.6-11.7 27.7-19.9l68.6-68.6c19.8-19.8 30.7-46.2 30.7-74.4s-11.1-54.6-30.9-74.4z"}}]})(props);
	};
	module.exports.IoIosLink.displayName = "IoIosLink";
	module.exports.IoIosListBox = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 82.7v346.7c0 19.1 15.5 34.7 34.7 34.7h346.7c19.1 0 34.7-15.5 34.7-34.7V82.7c0-19.1-15.5-34.7-34.7-34.7H82.7C63.5 48 48 63.5 48 82.7zm89.3 297.1c-13.1 1.7-24.1-9.3-22.4-22.4 1.1-8.9 8.3-16.1 17.2-17.2 13.1-1.7 24.1 9.3 22.4 22.4-1.1 8.9-8.3 16.1-17.2 17.2zm0-104c-13.1 1.7-24.1-9.3-22.4-22.4 1.1-8.9 8.3-16.1 17.2-17.2 13.1-1.7 24.1 9.3 22.4 22.4-1.1 8.9-8.3 16.1-17.2 17.2zm0-104c-13.1 1.7-24.1-9.3-22.4-22.4 1.1-8.9 8.3-16.1 17.2-17.2 13.1-1.7 24.1 9.3 22.4 22.4-1.1 8.9-8.3 16.1-17.2 17.2zM384.7 374h-180c-7.7 0-14-6.3-14-14s6.3-14 14-14h180c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-104h-180c-7.7 0-14-6.3-14-14s6.3-14 14-14h180c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-104h-180c-7.7 0-14-6.3-14-14s6.3-14 14-14h180c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosListBox.displayName = "IoIosListBox";
	module.exports.IoIosList = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"92","cy":"256","r":"28"}},{"tag":"circle","attr":{"cx":"92","cy":"132","r":"28"}},{"tag":"circle","attr":{"cx":"92","cy":"380","r":"28"}},{"tag":"path","attr":{"d":"M432 240H191.5c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16zM432 364H191.5c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16zM191.5 148H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.5c-8.8 0-16 7.2-16 16s7.2 16 16 16z"}}]})(props);
	};
	module.exports.IoIosList.displayName = "IoIosList";
	module.exports.IoIosLocate = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M395.3 259c-.3-1.2-.4-2.4-.3-3.6 0-.8.2-1.6.3-2.4-.4.9-.6 2-.6 3 .1 1.1.3 2.1.6 3z"}},{"tag":"path","attr":{"d":"M459.4 270H409c-6.7 0-12.3-4.7-13.7-11-.3-.9-.5-1.9-.5-3s.2-2.1.6-3c1.4-6.4 7.3-11 14.1-11h49.9c2.4 0 4.2-2 4-4.4-8.8-100.3-88.7-180.2-189-189-2.3-.2-4.4 1.6-4.4 4V103c0 7.9-6.6 14.3-14.6 14-7.6-.3-13.4-6.9-13.4-14.4v-50c0-2.4-2-4.2-4.4-4-100.3 8.8-180.2 88.7-189 189-.2 2.3 1.6 4.4 4 4.4H103c7.9 0 14.3 6.6 14 14.6-.3 7.6-6.9 13.4-14.4 13.4h-50c-2.4 0-4.2 2-4 4.4 8.8 100.3 88.7 180.2 189 189 2.3.2 4.4-1.6 4.4-4V409c0-7.9 6.6-14.3 14.6-14 7.6.3 13.4 6.9 13.4 14.4v49.9c0 2.4 2 4.2 4.4 4 100.3-8.8 180.2-88.7 189-189 .2-2.3-1.7-4.3-4-4.3zM256 326c-38.7 0-70-31.3-70-70s31.3-70 70-70 70 31.3 70 70-31.3 70-70 70z"}}]})(props);
	};
	module.exports.IoIosLocate.displayName = "IoIosLocate";
	module.exports.IoIosLock = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 192h-24v-46.7c0-52.7-42-96.5-94.7-97.3-53.4-.7-97.3 42.8-97.3 96v48h-24c-22 0-40 18-40 40v192c0 22 18 40 40 40h240c22 0 40-18 40-40V232c0-22-18-40-40-40zM270 316.8v68.8c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14v-69.2c-11.5-5.6-19.1-17.8-17.9-31.7 1.4-15.5 14.1-27.9 29.6-29 18.7-1.3 34.3 13.5 34.3 31.9 0 12.7-7.3 23.6-18 28.8zM324 192H188v-48c0-18.1 7.1-35.1 20-48s29.9-20 48-20 35.1 7.1 48 20 20 29.9 20 48v48z"}}]})(props);
	};
	module.exports.IoIosLock.displayName = "IoIosLock";
	module.exports.IoIosLogIn = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417 80H137c-25.4 0-46 20.6-46 46 0 7.7 6.3 14 14 14s14-6.3 14-14c0-9.9 8.1-18 18-18h280c9.9 0 18 8.1 18 18v260c0 9.9-8.1 18-18 18H137c-9.9 0-18-8.1-18-18 0-7.7-6.3-14-14-14s-14 6.3-14 14c0 25.4 20.6 46 46 46h280c25.4 0 46-20.6 46-46V126c0-25.4-20.6-46-46-46z"}},{"tag":"path","attr":{"d":"M224 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.6-84.4c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H63c-7.7 0-14 6.3-14 14s6.3 14 14 14h224.6L224 334.2z"}}]})(props);
	};
	module.exports.IoIosLogIn.displayName = "IoIosLogIn";
	module.exports.IoIosLogOut = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M312 372c-7.7 0-14 6.3-14 14 0 9.9-8.1 18-18 18H94c-9.9 0-18-8.1-18-18V126c0-9.9 8.1-18 18-18h186c9.9 0 18 8.1 18 18 0 7.7 6.3 14 14 14s14-6.3 14-14c0-25.4-20.6-46-46-46H94c-25.4 0-46 20.6-46 46v260c0 25.4 20.6 46 46 46h186c25.4 0 46-20.6 46-46 0-7.7-6.3-14-14-14z"}},{"tag":"path","attr":{"d":"M372.9 158.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H162c-7.7 0-14 6.3-14 14s6.3 14 14 14h256.6L355 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.5-84.2z"}}]})(props);
	};
	module.exports.IoIosLogOut.displayName = "IoIosLogOut";
	module.exports.IoIosMagnet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.2 261.9L289.6 89.3C263 62.7 227.4 48 189.5 48c-38 0-73.5 14.7-100.2 41.3C62.7 116 48 151.5 48 189.5S62.7 263 89.3 289.6l172.6 172.6c1.1 1.1 2.7 1.8 4.3 1.8 1.6 0 3.1-.6 4.3-1.8l57.5-57.5c2.4-2.4 2.4-6.2 0-8.5L165.2 233.3c-13-13-21.2-27.8-22.9-41.7-1.8-13.6 2.7-25.8 13.1-36.3 9.9-9.9 22.4-14.3 36-12.6 14.3 1.7 29.2 9.7 42 22.5L396.2 328c2.4 2.4 6.2 2.4 8.5 0l57.5-57.5c2.4-2.4 2.4-6.2 0-8.6zM275.8 380.2l20.2 20.2-29.8 29.8-20.3-20.2 29.9-29.8zM400.4 296l-20.2-20.2L410 246l20.2 20.2-29.8 29.8z"}}]})(props);
	};
	module.exports.IoIosMagnet.displayName = "IoIosMagnet";
	module.exports.IoIosMailOpen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.5 209.8c-4-4-158.3-161.4-158.3-161.4C284.8 37.8 270.9 32 256 32c-14.9 0-28.8 5.8-39.2 16.5 0 0-153.6 156.5-158.3 161.4C53.9 214.7 48 224.7 48 236v212c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V235c0-11.7-6.6-21.1-10.5-25.2zm-19.4 42.3L353 336.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-151-161.2c-1.6-1.7-4.3-1.7-5.8 0L102.2 438.2c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L77.7 252c-9.7-9.9-2.4-35.8 16.1-35.8h324.4c16.5-.1 25.6 26.1 15.9 35.9z"}}]})(props);
	};
	module.exports.IoIosMailOpen.displayName = "IoIosMailOpen";
	module.exports.IoIosMailUnread = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"416","cy":"152","r":"48"}},{"tag":"path","attr":{"d":"M416 218.5c-5.4 0-10.6-.7-15.6-1.9L353 264.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-75-79.9c-.8-.8-2.1-.8-2.9 0L313.7 305c-15.3 15.5-35.6 24.1-57.4 24.2-22.1.1-43.1-9.2-58.6-24.9l-17.6-17.9c-.8-.8-2.1-.8-2.9 0l-75 79.9c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L51.4 155.3c-1.3-1.3-3.4-.4-3.4 1.4V376c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V198c-12.1 12.6-29.1 20.5-48 20.5z"}},{"tag":"path","attr":{"d":"M349.5 152c0-11.6 3-22.5 8.2-32H79.9c-7.5 0-14.4 2.6-19.8 7L217 286.7c10.4 10.6 24.3 16.4 39.1 16.4s28.7-5.8 39.1-16.4l80.5-81.9c-16-12.2-26.2-31.3-26.2-52.8z"}}]})(props);
	};
	module.exports.IoIosMailUnread.displayName = "IoIosMailUnread";
	module.exports.IoIosMail = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460.6 147.3L353 256.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-75-79.9c-.8-.8-2.1-.8-2.9 0L313.7 297c-15.3 15.5-35.6 24.1-57.4 24.2-22.1.1-43.1-9.2-58.6-24.9l-17.6-17.9c-.8-.8-2.1-.8-2.9 0l-75 79.9c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L51.4 147.3c-1.3-1.3-3.4-.4-3.4 1.4V368c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V148.7c0-1.8-2.2-2.6-3.4-1.4z"}},{"tag":"path","attr":{"d":"M256 295.1c14.8 0 28.7-5.8 39.1-16.4L452 119c-5.5-4.4-12.3-7-19.8-7H79.9c-7.5 0-14.4 2.6-19.8 7L217 278.7c10.3 10.5 24.2 16.4 39 16.4z"}}]})(props);
	};
	module.exports.IoIosMail.displayName = "IoIosMail";
	module.exports.IoIosMale = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.4 48H341.5c-7.5 0-13.6 6.1-13.6 13.6s6.1 13.6 13.6 13.6h75.4L326.7 166c-30.6-26-69.3-40.3-109.6-40.3-22.8 0-45 4.5-65.8 13.3-20.1 8.5-38.2 20.7-53.8 36.2C82 190.8 69.8 208.9 61.3 229 52.5 249.9 48 272 48 294.9s4.5 45 13.3 65.8c8.5 20.1 20.7 38.2 36.2 53.8 15.5 15.5 33.6 27.7 53.8 36.2 20.9 8.8 43 13.3 65.8 13.3 22.8 0 45-4.5 65.8-13.3 20.1-8.5 38.2-20.7 53.8-36.2 15.5-15.5 27.7-33.6 36.2-53.8 8.8-20.9 13.3-43 13.3-65.8 0-40.3-14.3-79-40.3-109.6L436.7 95v75.4c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V61.6c.1-7.5-6-13.6-13.5-13.6zM359 294.9c0 37.9-14.8 73.5-41.6 100.3-26.8 26.8-62.4 41.6-100.3 41.6s-73.5-14.8-100.3-41.6C90 368.4 75.2 332.8 75.2 294.9s14.8-73.5 41.6-100.3c26.8-26.8 62.4-41.6 100.3-41.6s73.5 14.8 100.3 41.6C344.3 221.3 359 257 359 294.9z"}}]})(props);
	};
	module.exports.IoIosMale.displayName = "IoIosMale";
	module.exports.IoIosMan = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.7 106.6h-.2c-25 0-45.5-20.3-45.5-45.3 0-25 20.4-45.3 45.5-45.3S301 36.3 301 61.3c0 12.1-4.7 23.5-13.3 32-8.5 8.6-19.9 13.3-32 13.3zM221.2 496c-14.4 0-27-10.5-27-30.4l1-277.6h-10v105c0 9.3-3 15.1-6.4 18.3-4.3 4.1-9.1 6.4-15.2 6.4-6.2 0-10.9-2.3-15.2-6.4-3.4-3.2-6.4-8.9-6.4-18.3V171.4c0-13.8 4.4-27.8 13.8-38.4 10.4-11.6 23.6-18 39-18h122.3c15.4 0 28.6 6.4 39 18.1 9.4 10.6 13.8 24.5 13.8 38.3V293c0 7.3-1.7 13.8-6.6 18.3-4.4 4-9.3 6.2-15.5 6.2s-11.1-2.2-15.5-6.2c-4.9-4.5-6.6-11-6.6-18.3V188h-9v277.6c0 19.7-13.4 30.4-27.8 30.4-13.4 0-26.3-9.3-27.4-29.8V325h-12v140.9c-.7 19.7-13.8 30.1-28.3 30.1z"}}]})(props);
	};
	module.exports.IoIosMan.displayName = "IoIosMan";
	module.exports.IoIosMap = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 72.5v316.3c0 2.8 1.3 5.5 3.5 7l69.8 50.2c5.2 3.7 12.1-.3 12.1-7V122.7c0-2.8-1.3-5.5-3.5-7L76.1 65.4c-5.2-3.7-12.1.3-12.1 7.1zM168.7 123.3v316.3c0 6.7 6.9 10.8 12.1 7l62-36.7c2.2-1.6 3.5-4.2 3.5-7V86.6c0-6.7-6.9-10.8-12.1-7l-62 36.7c-2.2 1.5-3.5 4.1-3.5 7zM435.9 65.5l-69.8 50.7c-2.2 1.6-3.5 4.2-3.5 7v316.2c0 6.8 6.9 10.8 12.1 7l69.8-50.7c2.2-1.6 3.5-4.2 3.5-7V72.5c0-6.7-6.9-10.7-12.1-7zM265.7 85.6v316.2c0 2.8 1.3 5.5 3.5 7l62 37c5.2 3.8 12.1-.3 12.1-7V122.6c0-2.8-1.3-5.5-3.5-7l-62-37c-5.2-3.7-12.1.3-12.1 7z"}}]})(props);
	};
	module.exports.IoIosMap.displayName = "IoIosMap";
	module.exports.IoIosMedal = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M50 124c-1.1 0-2 .9-2 2v59.9c0 14.4 9.6 27 23.4 30.8l104 29.4c1.3.4 2.5-.6 2.5-1.9V126c0-1.1-.9-2-2-2H50zM204 126v126.2c0 .9.6 1.7 1.5 1.9l50 13.9c.4.1.7.1 1.1 0l56-15.6c.9-.2 1.5-1 1.5-1.9V126c0-1.1-.9-2-2-2H206c-1.1 0-2 .9-2 2zM334 126v119.2c0 1.3 1.3 2.3 2.6 1.9l104-30.4c13.8-3.9 23.4-16.5 23.4-30.8V126c0-1.1-.9-2-2-2H336c-1.1 0-2 .9-2 2zM48 64v38c0 1.1.9 2 2 2h412c1.1 0 2-.9 2-2V64c0-17.7-14.3-32-32-32H80c-17.7 0-32 14.3-32 32z"}},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"256","cy":"352","r":"56"}},{"tag":"path","attr":{"d":"M351.3 266.6l-51.5 13.8c24 14.8 40.1 41.3 40.1 71.6 0 46.3-37.7 84-84 84s-84-37.7-84-84c0-30.4 16.2-57 40.4-71.8L161 266.1c-20.5 22.7-33 52.8-33 85.9 0 70.7 57.3 128 128 128s128-57.3 128-128c0-32.8-12.4-62.7-32.7-85.4z"}},{"tag":"path","attr":{"d":"M256 296c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56z"}}]}]})(props);
	};
	module.exports.IoIosMedal.displayName = "IoIosMedal";
	module.exports.IoIosMedical = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430.3 174.3l-16.5-28.6c-4.3-7.4-13.8-10-21.2-5.7L294 197c-2.7 1.5-6-.4-6-3.5v-114c0-8.6-6.9-15.5-15.5-15.5h-33c-8.6 0-15.5 6.9-15.5 15.5v114.1c0 3.1-3.3 5-6 3.5l-98.6-57c-7.4-4.3-16.9-1.7-21.2 5.7l-16.5 28.6c-4.3 7.4-1.7 16.9 5.7 21.1l98.7 57.1c2.7 1.5 2.7 5.4 0 6.9l-98.7 57.1c-7.4 4.3-9.9 13.7-5.7 21.1l16.5 28.6c4.3 7.4 13.8 10 21.2 5.7l98.6-57c2.7-1.5 6 .4 6 3.5v114.1c0 8.6 6.9 15.5 15.5 15.5h33c8.6 0 15.5-6.9 15.5-15.5V318.4c0-3.1 3.4-5 6-3.5l98.6 57c7.4 4.3 16.9 1.7 21.2-5.7l16.5-28.6c4.3-7.4 1.7-16.9-5.7-21.1l-98.7-57.1c-2.7-1.5-2.7-5.4 0-6.9l98.7-57.1c7.4-4.2 9.9-13.7 5.7-21.1z"}}]})(props);
	};
	module.exports.IoIosMedical.displayName = "IoIosMedical";
	module.exports.IoIosMedkit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 128h-84V96c0-17.6-14.4-32-32-32H196c-17.6 0-32 14.4-32 32v32H80c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32zm-240-28c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v28H192v-28zm128 204h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosMedkit.displayName = "IoIosMedkit";
	module.exports.IoIosMegaphone = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M90.1 187c0-33.4 17.1-62.8 43.5-78.9 2.8-1.7 1.6-6-1.7-6-38.2 0-68.5 30.4-74.1 69.8-5.6.9-9.9 7.3-9.9 14.9 0 8 4.7 14.3 10.8 14.8 6.7 33.8 33.8 55.4 61.2 64.5 4.3.9 7.1-4.5 3.8-7.5-19.6-17.7-33.6-44.3-33.6-71.6z"}},{"tag":"path","attr":{"d":"M450.2 102.8c-1-2.7-2.1-5.2-3.2-7.7-6-13.4-13.4-24.2-21.7-32.2-10.5-9.7-21.4-14.9-34.8-14.9-13.5 0-21.5 5.2-25.8 7.8-43.1 25.9-112.3 46-154 46s-39.4.2-39.4.2c-31.6 14-54.8 46.9-54.8 85 0 34.2 17.8 64.2 44.4 80 12.1 10.1 23.6 8.8 21.1 22.2-2.5 13.4-22.5 97.5-25 115s-2.9 27.5 4 36c7 8.5 49.5 23.8 68 23.8s13.8-8.7 13.8-43.8-9.3-131.7 16.5-131.7c48.3 0 73.5 17.3 111.3 31.7 9 3.4 14.1 4.7 20.1 4.7 6 0 18.7-1.9 34.7-18.2 9.2-9.4 15.7-18.8 21.7-32.2 1.1-2.6 2.2-5.2 3.3-8 8.9-23.2 13.7-51.9 13.7-81.9-.1-29.8-4.9-58.6-13.9-81.8zm-26.6 157c-6.4 15.7-17.6 28.2-26.9 28.2-9.3 0-17.8-12.5-24.2-28.2-7.5-18.3-12.3-45-12.3-74.7 0-29.8 4.8-56.6 12.3-74.9 6.4-15.6 14.9-25 24.1-25 9.3 0 20.3 9.5 26.8 25 7.6 18.3 14.5 45.1 14.5 74.9.1 29.7-6.8 56.4-14.3 74.7z"}}]})(props);
	};
	module.exports.IoIosMegaphone.displayName = "IoIosMegaphone";
	module.exports.IoIosMenu = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 176H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zM432 272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zM432 368H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosMenu.displayName = "IoIosMenu";
	module.exports.IoIosMicOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.8 464c-4.9 0-9.7-2.5-12.3-7L129.9 69.3c-4-6.7-1.7-15.4 5.1-19.3 6.8-3.9 15.5-1.7 19.5 5.1l227.6 387.7c4 6.7 1.7 15.4-5.1 19.3-2.3 1.3-4.8 1.9-7.2 1.9zM320 272V112c0-35.2-28.8-64-64-64-28.4 0-52.6 18.8-60.9 44.5L315 296.8c3.2-7.6 5-16 5-24.8zM192 272c0 35.2 28.8 64 64 64 3.9 0 7.6-.4 11.3-1L192 206.6V272zM366 275v-69c0-7.7-6.3-14-14-14s-14 6.3-14 14v69c0 15.2-4.2 29.4-11.4 41.6l15.6 26.6c14.9-18.7 23.8-42.4 23.8-68.2z"}},{"tag":"path","attr":{"d":"M256 357c-45.2 0-82-36.8-82-82v-69c0-7.7-6.3-14-14-14s-14 6.3-14 14v69c0 55.9 41.9 102.2 96 109.1V436h-36c-7.7 0-14 6.3-14 14s6.3 14 14 14h100c7.7 0 14-6.3 14-14s-6.3-14-14-14h-36v-51.9c7.9-1 15.6-2.9 22.9-5.5l-14.5-24.8c-7.1 2.1-14.6 3.2-22.4 3.2z"}}]})(props);
	};
	module.exports.IoIosMicOff.displayName = "IoIosMicOff";
	module.exports.IoIosMic = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 336c35.2 0 64-28.8 64-64V112c0-35.2-28.8-64-64-64s-64 28.8-64 64v160c0 35.2 28.8 64 64 64z"}},{"tag":"path","attr":{"d":"M352 192c-7.7 0-14 6.3-14 14v69c0 45.2-36.8 82-82 82s-82-36.8-82-82v-69c0-7.7-6.3-14-14-14s-14 6.3-14 14v69c0 55.9 41.9 102.2 96 109.1V436h-36c-7.7 0-14 6.3-14 14s6.3 14 14 14h100c7.7 0 14-6.3 14-14s-6.3-14-14-14h-36v-51.9c54.1-6.9 96-53.2 96-109.1v-69c0-7.7-6.3-14-14-14z"}}]})(props);
	};
	module.exports.IoIosMic.displayName = "IoIosMic";
	module.exports.IoIosMicrophone = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M315 204h72.6c6.6 0 12.3-5.2 12.4-11.8.1-6.7-5.3-12.2-12-12.2h-73c-6.7 0-12.1-5.5-12-12.2.1-6.6 5.8-11.8 12.4-11.8h76.5c4.5 0 8.2-3.7 8-8.2-1.7-47.5-31.2-88.1-72.7-106-5.3-2.3-11.2 1.6-11.2 7.3v35.5c0 6.6-5.2 12.3-11.8 12.4-6.7.1-12.2-5.3-12.2-12V44c0-6.6-5.4-12-12-12s-12 5.4-12 12v56.6c0 6.6-5.2 12.3-11.8 12.4-6.7.1-12.2-5.3-12.2-12V44c0-6.6-5.4-12-12-12s-12 5.4-12 12v40.6c0 6.6-5.2 12.3-11.8 12.4-6.7.1-12.2-5.3-12.2-12V49.1c0-5.8-5.9-9.6-11.2-7.3-41.5 17.9-71.1 58.6-72.7 106-.2 4.5 3.5 8.2 8 8.2h76.5c6.6 0 12.3 5.2 12.4 11.8.1 6.7-5.3 12.2-12 12.2h-72.6c-6.6 0-12.3 5.2-12.4 11.8-.1 6.7 5.3 12.2 12 12.2h72.6c6.6 0 12.3 5.2 12.4 11.8.1 6.7-5.3 12.2-12 12.2h-72.6c-6.6 0-12.3 5.2-12.4 11.8-.1 6.7 5.3 12.2 12 12.2h72.6c6.6 0 12.3 5.2 12.4 11.8.1 6.7-5.3 12.2-12 12.2h-76.9c-4.5 0-8.2 3.7-8 8.2.5 13.6 3.3 26.7 7.9 38.8 1.2 3.1 4.2 5 7.4 5h257.1c3.3 0 6.3-2 7.4-5 4.7-12.1 7.5-25.2 7.9-38.8.2-4.5-3.5-8.2-8-8.2h-76.5c-6.6 0-12.3-5.2-12.4-11.8-.1-6.7 5.3-12.2 12-12.2h72.6c6.6 0 12.3-5.2 12.4-11.8.1-6.7-5.3-12.2-12-12.2h-72.6c-6.6 0-12.3-5.2-12.4-11.8 0-6.7 5.4-12.2 12.1-12.2zM141.5 358.6c19 22 45.2 37.2 75.4 40.8 4 .5 7.1 3.9 7.1 7.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.7c0-4.1 3.1-7.5 7.1-7.9 30.3-3.5 56.4-18.7 75.4-40.8 2.2-2.6.3-6.6-3.1-6.6H144.5c-3.4 0-5.2 4-3 6.6z"}}]})(props);
	};
	module.exports.IoIosMicrophone.displayName = "IoIosMicrophone";
	module.exports.IoIosMoon = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M401.4 354.2c-2.9.1-5.8.2-8.7.2-47.9 0-93-18.9-126.8-53.4-33.9-34.4-52.5-80.1-52.5-128.8 0-27.7 6.1-54.5 17.5-78.7 3.1-6.6 9.3-16.6 13.6-23.4 1.9-2.9-.5-6.7-3.9-6.1-6 .9-15.2 2.9-27.7 6.8C135.1 95.5 80 168.7 80 255c0 106.6 85.1 193 190.1 193 58 0 110-26.4 144.9-68.1 6-7.2 11.5-13.8 16.4-21.8 1.8-3-.7-6.7-4.1-6.1-8.5 1.7-17.1 1.8-25.9 2.2z"}}]})(props);
	};
	module.exports.IoIosMoon.displayName = "IoIosMoon";
	module.exports.IoIosMore = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.8 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38zM102 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38zM410 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z"}}]})(props);
	};
	module.exports.IoIosMore.displayName = "IoIosMore";
	module.exports.IoIosMove = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475.9 246.2l-79.4-79.4c-5.4-5.4-14.2-5.4-19.6 0l-.2.2c-5.4 5.4-5.4 14.2 0 19.6l54.9 54.9-161.8.5.5-161.8 54.9 54.9c5.4 5.4 14.2 5.4 19.6 0l.2-.2c5.4-5.4 5.4-14.2 0-19.6l-79.4-79.4c-5.4-5.4-14.2-5.4-19.6 0l-79.4 79.4c-5.4 5.4-5.4 14.2 0 19.6l.2.2c5.4 5.4 14.2 5.4 19.6 0l54.9-54.9.5 161.8-161.8-.5 54.9-54.9c5.4-5.4 5.4-14.2 0-19.6l-.2-.2c-5.4-5.4-14.2-5.4-19.6 0l-79.4 79.4c-5.4 5.4-5.4 14.2 0 19.6l79.4 79.4c5.4 5.4 14.2 5.4 19.6 0l.2-.2c5.4-5.4 5.4-14.2 0-19.6L80 270.5l161.8-.5-.5 161.8-54.9-54.9c-5.4-5.4-14.2-5.4-19.6 0l-.2.2c-5.4 5.4-5.4 14.2 0 19.6l79.4 79.4c5.4 5.4 14.2 5.4 19.6 0l79.4-79.4c5.4-5.4 5.4-14.2 0-19.6l-.2-.2c-5.4-5.4-14.2-5.4-19.6 0l-54.9 54.9-.5-161.8 161.8.5-54.9 54.9c-5.4 5.4-5.4 14.2 0 19.6l.2.2c5.4 5.4 14.2 5.4 19.6 0l79.4-79.4c5.5-5.4 5.5-14.2 0-19.6z"}}]})(props);
	};
	module.exports.IoIosMove.displayName = "IoIosMove";
	module.exports.IoIosMusicalNote = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M364.3 48.2c-4.7.9-118 24.1-122.2 24.9-4.2.8-8.1 3.6-8.1 8v255.1c0 1.6-.1 7.2-2.4 11.7-3.1 5.9-8.5 10.2-16.1 12.7-3.3 1.1-7.8 2.1-13.1 3.3-24.1 5.4-64.4 14.6-64.4 51.8 0 30.1 21.7 44.5 35 47.1 5 1 11 1 13.8 1 8.2 0 36-3.3 51.2-13.2 11-7.2 24.1-21.4 24.1-47.8V173.1c0-3.8 2.7-7.1 6.4-7.8l92.8-19c7.4-1.5 12.8-8.1 12.8-15.7V55.8c-.1-4.3-3.8-8.8-9.8-7.6z"}}]})(props);
	};
	module.exports.IoIosMusicalNote.displayName = "IoIosMusicalNote";
	module.exports.IoIosMusicalNotes = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.3 48.2c-4.7.9-202 39.2-206.2 40-4.2.8-8.1 3.6-8.1 8v240.1c0 1.6-.1 7.2-2.4 11.7-3.1 5.9-8.5 10.2-16.1 12.7-3.3 1.1-7.8 2.1-13.1 3.3-24.1 5.4-64.4 14.6-64.4 51.8 0 31.1 22.4 45.1 41.7 47.5 2.1.3 4.5.7 7.1.7 6.7 0 36-3.3 51.2-13.2 11-7.2 24.1-21.4 24.1-47.8V190.5c0-3.8 2.7-7.1 6.4-7.8l152-30.7c5-1 9.6 2.8 9.6 7.8v130.9c0 4.1-.2 8.9-2.5 13.4-3.1 5.9-8.5 10.2-16.2 12.7-3.3 1.1-8.8 2.1-14.1 3.3-24.1 5.4-64.4 14.5-64.4 51.7 0 33.7 25.4 47.2 41.8 48.3 6.5.4 11.2.3 19.4-.9s23.5-5.5 36.5-13c17.9-10.3 27.5-26.8 27.5-48.2V55.9c-.1-4.4-3.8-8.9-9.8-7.7z"}}]})(props);
	};
	module.exports.IoIosMusicalNotes.displayName = "IoIosMusicalNotes";
	module.exports.IoIosNavigate = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 336V256H128.3L352 160l-96 224z"}}]})(props);
	};
	module.exports.IoIosNavigate.displayName = "IoIosNavigate";
	module.exports.IoIosNotificationsOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 456c31.1 0 48.1-22 48.1-53h-96.3c0 31 17 53 48.2 53zM154.5 55c-2.5-4.3-7-6.8-11.6-7h.3-1.2c-2.3 0-4.7.7-6.9 1.9-6.8 3.9-9.1 12.6-5.1 19.3L357.5 457c2.6 4.5 7.4 7 12.3 7 2.4 0 4.9-.6 7.2-1.9 6.8-3.9 9.1-12.6 5.1-19.3L154.5 55zM296.1 384L159 150.5c-8.2 20.2-13.3 46-13.3 78.6 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h180.2zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.4-11-24.7-24.4-24.6-13.4-.2-24.4 11.2-24.4 24.6v2.9c0 3.7-2.6 5-6.2 5.9-8.7 2-17.5 5.5-25.9 10.8L366.1 384H396c16.5 0 25.9-18.8 16-31.8z"}}]})(props);
	};
	module.exports.IoIosNotificationsOff.displayName = "IoIosNotificationsOff";
	module.exports.IoIosNotificationsOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M289.7 403c-6.1 0-11.4 4.2-12.7 10.2-1 4.5-2.7 8.2-5 10.9-1.3 1.5-5.1 5.9-16.1 5.9-11 0-14.8-4.5-16.1-5.9-2.3-2.7-4-6.4-5-10.9-1.3-6-6.6-10.2-12.7-10.2-8.4 0-14.5 7.8-12.7 15.9 5 22.3 21 37.1 46.5 37.1s41.5-14.7 46.5-37.1c1.8-8.1-4.4-15.9-12.7-15.9zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.3-10.8-24.6-24-24.6h-.6c-13.2 0-24 11.3-24 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.1 0 25.4-18.8 15.6-31.8zm-39 5.8H139.8c-3.8 0-5.8-4.4-3.3-7.3 7-8 14.7-18.5 21-33.4 9.6-22.6 14.3-51.5 14.3-88.2 0-37.3 7-66.5 20.9-86.8 12.4-18.2 27.9-25.1 38.7-27.6 8.4-2 14.4-5.8 18.6-10.5 3.2-3.6 8.7-3.8 11.9-.2 5.1 5.7 12 9.1 18.8 10.7 10.8 2.5 26.3 9.4 38.7 27.6 13.9 20.3 20.9 49.5 20.9 86.8 0 36.7 4.7 65.6 14.3 88.2 6.5 15.2 14.4 25.9 21.5 33.9 2.2 2.7.4 6.8-3.1 6.8z"}}]})(props);
	};
	module.exports.IoIosNotificationsOutline.displayName = "IoIosNotificationsOutline";
	module.exports.IoIosNotifications = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 456c31.1 0 48.1-22 48.1-53h-96.3c0 31 17 53 48.2 53zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.4-11-24.7-24.4-24.6-13.4-.2-24.4 11.2-24.4 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.3 0 25.7-18.8 15.8-31.8z"}}]})(props);
	};
	module.exports.IoIosNotifications.displayName = "IoIosNotifications";
	module.exports.IoIosNuclear = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-88.5 364.8l49.2-85.8c1.1-1.9.5-4.2-1.3-5.4-20.2-12.9-34-35-35.2-60.3-.1-2.1-1.8-3.8-4-3.8H76V256c0-48.1 18.7-93.3 52.7-127.3 10.8-10.8 22.7-20 35.4-27.6l50.5 87.9c1.1 1.9 3.5 2.5 5.4 1.5 10.7-5.8 22.9-9 35.9-9 12.5 0 24.4 3.1 34.8 8.5 1.9 1 4.2.3 5.3-1.5l51.1-87.7c13 7.7 25.1 17 36.1 28 34 34 52.7 79.2 52.7 127.3v1.5h-100c-2.1 0-3.9 1.7-4 3.8-1.3 25.4-15 47.5-35.2 60.3-1.8 1.2-2.4 3.5-1.3 5.4l49.2 85.8c-26.7 15.1-57 23.2-88.5 23.2-31.6-.1-61.9-8.2-88.6-23.3z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"56"}}]})(props);
	};
	module.exports.IoIosNuclear.displayName = "IoIosNuclear";
	module.exports.IoIosNutrition = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M359.1 231.9h-.1c-.1-.1-.3-.4-.4-.6l-78.9-79.6c-5.8-6-14.2-10.2-23.6-10.2-11.8 0-22.2 6.2-27.7 16.3 0 0-3.4 5.1-12.6 19.8-1.6 2.6-1.6 6 .1 8.6l26.8 41.2c2.9 3.8 3.3 8 1.4 9.9l-.1.1c-2.3 2.3-5.9 1.5-9.8-1.4l-32.3-20.5c-3.8-2.4-8.7-1.2-11.1 2.5-21.9 35.1-46.8 74.7-71.2 114-1.6 2.5-1.6 5.7-.1 8.3l14.1 24.1c2.9 3.8 3.3 8 1.4 9.9l-.1.1c-2.3 2.3-5.9 1.5-9.8-1.4l-16.6-8.4c-3.7-1.9-8.2-.6-10.4 2.9-17.7 28.3-28 44.7-29.1 46.5-3 5.1-5 11.2-5 17.8 0 17.8 14.2 32.2 31.9 32.2 7.8 0 14.4-3.4 20.6-7.6L221 378.8c3.4-2.5 4.2-7.2 2-10.7L202.5 336c-2.9-3.8-3.3-8-1.4-9.9l.1-.1c2.3-2.3 5.9-1.5 9.8 1.4l37.4 25.6c2.8 1.9 6.5 1.9 9.3-.2 53-39.1 97.5-72.2 97.5-72.2 7.9-6 13-15.4 13-26 0-8.7-3.1-16.8-9.1-22.7zM446.9 131.2l-11.2-17.9c-2.2-3.8-7.1-5.1-10.9-2.9L365.4 147l47.3-78.9c2.2-3.8.9-8.8-2.9-11l-17.7-8c-3.9-2.3-8.8-.9-11 3l-57.6 108.3 28.6 28.8 91.8-46.8c3.9-2.2 5.3-7.2 3-11.2z"}}]})(props);
	};
	module.exports.IoIosNutrition.displayName = "IoIosNutrition";
	module.exports.IoIosOpen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M227.8 300.2c-5.1-5.1-5.1-13.3 0-18.4l133.7-133.7c-5.3-2.6-11.2-4.1-17.5-4.1H88c-22 0-40 18-40 40v224c0 22 18 40 40 40h256c22 0 40-18 40-40V184c0-6.3-1.5-12.2-4.1-17.5L246.2 300.2c-5.1 5.1-13.3 5.1-18.4 0z"}},{"tag":"path","attr":{"d":"M459.5 68.5C457 66 453 64 449 64h-97c-7.2-.1-13.1 5.7-13.1 12.9-.1 7.2 5.7 13.1 12.9 13.1l67.3.5-57.6 57.6c8 3.9 14.5 10.4 18.4 18.4l57.6-57.6.5 67.3c.1 7.2 5.9 13 13.1 12.9 7.2-.1 13-5.9 12.9-13.1V78c0-3.5-2-7-4.5-9.5z"}}]})(props);
	};
	module.exports.IoIosOpen.displayName = "IoIosOpen";
	module.exports.IoIosOptions = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M299.3 376c6.2-14.1 20.3-24 36.7-24s30.5 9.9 36.7 24H448c8.8 0 16 7.2 16 16s-7.2 16-16 16h-75.3c-6.2 14.1-20.3 24-36.7 24s-30.5-9.9-36.7-24H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h235.3zM139.3 240c6.2-14.1 20.3-24 36.7-24s30.5 9.9 36.7 24H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H212.7c-6.2 14.1-20.3 24-36.7 24s-30.5-9.9-36.7-24H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h75.3zM299.3 104c6.2-14.1 20.3-24 36.7-24s30.5 9.9 36.7 24H448c8.8 0 16 7.2 16 16s-7.2 16-16 16h-75.3c-6.2 14.1-20.3 24-36.7 24s-30.5-9.9-36.7-24H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h235.3z"}}]})(props);
	};
	module.exports.IoIosOptions.displayName = "IoIosOptions";
	module.exports.IoIosOutlet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M359 78H153c-2.8 0-5.6.8-8 2.3C86.7 116.9 48 182 48 256c0 73.9 38.7 138.1 97 175.6 2.4 1.6 5.2 2.4 8.1 2.4h205.8c2.9 0 5.7-.8 8.1-2.4 58.3-37.5 97-101.7 97-175.6 0-74-38.7-139.1-97-175.7-2.4-1.5-5.2-2.3-8-2.3zM192.9 270.8h-22.3c-2.1 0-3.7-1.7-3.7-3.7V155.9c0-2 1.7-3.7 3.7-3.7h22.3c2.1 0 3.7 1.7 3.7 3.7v111.2c0 2.1-1.7 3.7-3.7 3.7zM282 389.5h-52c-2.1 0-3.7-1.7-3.7-3.7v-40.2c0-16.5 13.6-30.5 30.1-30.3 16.2.2 29.3 13.5 29.3 29.7v40.8c0 2-1.6 3.7-3.7 3.7zM341.4 256h-22.3c-2.1 0-3.7-1.7-3.7-3.7v-81.6c0-2 1.7-3.7 3.7-3.7h22.3c2.1 0 3.7 1.7 3.7 3.7v81.6c0 2-1.6 3.7-3.7 3.7z"}}]})(props);
	};
	module.exports.IoIosOutlet.displayName = "IoIosOutlet";
	module.exports.IoIosPaperPlane = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M452.1 49L52.3 265.3c-6 3.3-5.6 12.1.6 14.9l68.2 25.7c4 1.5 7.2 4.5 9 8.4l53 109.1c1 4.8 9.9 6.1 10 1.2l-8.1-90.2c.5-6.7 3-13 7.3-18.2l207.3-203.1c1.2-1.2 2.9-1.6 4.5-1.3 3.4.8 4.8 4.9 2.6 7.6L228 338c-4 6-6 11-7 18l-10.7 77.9c.9 6.8 6.2 9.4 10.5 3.3l38.5-45.2c2.6-3.7 7.7-4.5 11.3-1.9l99.2 72.3c4.7 3.5 11.4.9 12.6-4.9L463.8 58c1.5-6.8-5.6-12.3-11.7-9z"}}]})(props);
	};
	module.exports.IoIosPaperPlane.displayName = "IoIosPaperPlane";
	module.exports.IoIosPaper = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M124 80v322c0 7.7-6.3 14-14 14s-14-6.3-14-14V112H80c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h353.1c17 0 30.9-13.8 30.9-30.9V80c0-17.7-14.3-32-32-32l-278 2c-17.7 0-30 12.3-30 30zm66 32h84c7.7 0 14 6.3 14 14s-6.3 14-14 14h-84c-7.7 0-14-6.3-14-14s6.3-14 14-14zm0 160h148c7.7 0 14 6.3 14 14s-6.3 14-14 14H190c-7.7 0-14-6.3-14-14s6.3-14 14-14zm196 108H190c-7.7 0-14-6.3-14-14s6.3-14 14-14h196c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-160H190c-7.7 0-14-6.3-14-14s6.3-14 14-14h196c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosPaper.displayName = "IoIosPaper";
	module.exports.IoIosPartlySunny = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.2 64h-.3c-8.7 0-15.8 7.1-15.8 15.8v30.3c0 8.7 7.1 15.8 15.8 15.8h.3c8.7 0 15.8-7.1 15.8-15.8V79.8c0-8.7-7.1-15.8-15.8-15.8zM79 216.2v-.3c0-8.7-7.1-15.8-15.8-15.8H31.8c-8.7 0-15.8 7.1-15.8 15.8v.3c0 8.7 7.1 15.8 15.8 15.8h31.3c8.8 0 15.9-7.1 15.9-15.8zM79.7 149c3 3 7 4.7 11.2 4.7 4.2 0 8.2-1.7 11.2-4.7 6.1-6.2 6.1-16.2 0-22.3l-20.3-20.5c-3-3-7-4.7-11.2-4.7-4.2 0-8.2 1.7-11.2 4.7-6.1 6.2-6.1 16.2 0 22.3L79.7 149zM271 105.2c-3-3-7-4.7-11.2-4.7-4.2 0-8.2 1.7-11.2 4.7l-20.3 20.4c-6.1 6.2-6.1 16.2 0 22.3l.3.3h.1c2.9 2.8 6.8 4.3 10.8 4.3 4.2 0 8.2-1.7 11.2-4.7l20.3-20.4c6.1-6 6.1-16 0-22.2zM92.9 273.3c-4.2 0-8.2 1.7-11.2 4.7l-20.3 20.5c-6.1 6.2-6.1 16.2 0 22.3 3 3 7 4.7 11.2 4.7 4.2 0 8.2-1.7 11.2-4.7l20.3-20.5c6.1-6.2 6.1-16.2 0-22.3-3-3-7-4.7-11.2-4.7zM403.3 259.2h-2.4c-3.1 0-6.1 0-9 .4-11.3-50.3-56.1-88.2-109.7-88.2-14.6 0-28.6 2.8-41.4 7.9-5.1 2-10 4.4-14.7 7.1-32 18.5-54.1 52.4-56.2 91.6-.1 2.1-.2 4.1-.2 6.2 0 3.4.2 6.8.5 10.1 0 .4.1.8.1 1.1-37.9 3.4-67.6 37.1-67.6 76 0 41.1 33.3 76.7 74.3 76.7h226.4c51.2 0 92.7-43.4 92.7-94.8-.1-51.4-41.6-94.1-92.8-94.1z"}},{"tag":"path","attr":{"d":"M150.7 283.6v-.3c-.3-3.4-.5-6.8-.5-10.2 0-2.1.1-4.2.2-6.3 2.2-39.9 24.6-74.3 57.2-93.1 4.8-2.8 9.8-5.2 14.9-7.2h.1c-13.4-17-34.2-28-57.6-28-40.5 0-73.3 32.8-73.3 73.3 0 35.5 25.3 65.1 59 71.8z"}}]})(props);
	};
	module.exports.IoIosPartlySunny.displayName = "IoIosPartlySunny";
	module.exports.IoIosPause = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M199.9 416h-63.8c-4.5 0-8.1-3.6-8.1-8V104c0-4.4 3.6-8 8.1-8h63.8c4.5 0 8.1 3.6 8.1 8v304c0 4.4-3.6 8-8.1 8zM375.9 416h-63.8c-4.5 0-8.1-3.6-8.1-8V104c0-4.4 3.6-8 8.1-8h63.8c4.5 0 8.1 3.6 8.1 8v304c0 4.4-3.6 8-8.1 8z"}}]})(props);
	};
	module.exports.IoIosPause.displayName = "IoIosPause";
	module.exports.IoIosPaw = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M324.3 80.3c-1.2-.2-2.4-.3-3.6-.3v.4-.3h-.4c-22 0-42.9 25.9-47.8 60.3-5.3 36.6 9.4 69 32.7 72.4 1.3.2 2.7.3 4 .3 22 0 42.9-25.9 47.8-60.3 5.3-36.7-9.4-69.1-32.7-72.5zM320.6 80zM442.3 169.4c-3.5-1.4-7.1-2.1-10.9-2.1h-.4c-19.7.3-41.8 19.2-53.4 47.8-13.9 34.2-7.5 69.2 14.4 78.2 3.5 1.4 7.1 2.1 10.9 2.1 19.8 0 42.2-19 53.9-47.8 13.8-34.2 7.3-69.2-14.5-78.2zM327.6 295.4c-27.8-43.6-39.8-60-71.6-60s-43.9 16.5-71.7 60c-23.8 37.2-71.9 40.3-83.9 71.9-2.4 5.6-3.6 11.7-3.6 18.2 0 25.7 20.8 46.5 46.4 46.5 31.8 0 75.1-24 112.9-24s80.9 24 112.7 24c25.6 0 46.3-20.8 46.3-46.5 0-6.5-1.3-12.6-3.7-18.2-12-31.7-60-34.7-83.8-71.9zM202.8 213c1.3 0 2.7-.1 4-.3 23.4-3.4 38-35.8 32.7-72.4-5-34.5-25.9-60.3-47.8-60.3-1.3 0-2.7.1-4 .3-23.4 3.4-38 35.8-32.7 72.4 5 34.4 25.9 60.3 47.8 60.3zM120.1 293.3c21.9-9 28.3-44 14.4-78.2-11.7-28.8-34.1-47.8-53.9-47.8-3.8 0-7.4.7-10.9 2.1-21.9 9-28.3 44-14.4 78.2 11.7 28.8 34.1 47.8 53.9 47.8 3.8 0 7.4-.7 10.9-2.1z"}}]})(props);
	};
	module.exports.IoIosPaw.displayName = "IoIosPaw";
	module.exports.IoIosPeople = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.1 334.7c-11.2-4-29.5-4.2-37.6-7.3-5.6-2.2-14.5-4.6-17.4-8.1-2.9-3.5-2.9-28.5-2.9-28.5s7-6.6 9.9-14c2.9-7.3 4.8-27.5 4.8-27.5s6.6 2.8 9.2-10.4c2.2-11.4 6.4-17.4 5.3-25.8-1.2-8.4-5.8-6.4-5.8-6.4s5.8-8.5 5.8-37.4c0-29.8-22.5-59.1-64.6-59.1-42 0-64.7 29.4-64.7 59.1 0 28.9 5.7 37.4 5.7 37.4s-4.7-2-5.8 6.4c-1.2 8.4 3 14.4 5.3 25.8 2.6 13.3 9.2 10.4 9.2 10.4s1.9 20.1 4.8 27.5c2.9 7.4 9.9 14 9.9 14s0 25-2.9 28.5-11.8 5.9-17.4 8c-8 3.1-26.3 3.5-37.6 7.5-11.2 4-45.8 22.2-45.8 67.2h278.3c.1-45.1-34.5-63.3-45.7-67.3z"}},{"tag":"path","attr":{"d":"M140 286s23.9-.8 33.4-9.3c-15.5-23.5-7.1-50.9-10.3-76.5-3.2-25.5-17.7-40.8-46.7-40.8h-.4c-28 0-43.1 15.2-46.3 40.8-3.2 25.5 5.7 56-10.2 76.5C69 285.3 93 285 93 285s1 14.4-1 16.8c-2 2.4-7.9 4.7-12 5.5-8.8 1.9-18.1 4.5-25.9 7.2-7.8 2.7-22.6 17.2-22.6 37.2h80.3c2.2-8 17.3-22.3 32-29.8 9-4.6 17.9-4.3 24.7-5.2 0 0 3.8-6-8.7-8.3 0 0-17.2-4.3-19.2-6.7-1.9-2.2-.6-15.7-.6-15.7zM372 286s-23.9-.8-33.4-9.3c15.5-23.5 7.1-50.9 10.3-76.5 3.2-25.5 17.7-40.8 46.7-40.8h.4c28 0 43.1 15.2 46.3 40.8 3.2 25.5-5.7 56 10.2 76.5-9.5 8.6-33.5 8.3-33.5 8.3s-1 14.4 1 16.8c2 2.4 7.9 4.7 12 5.5 8.8 1.9 18.1 4.5 25.9 7.2 7.8 2.7 22.6 17.2 22.6 37.2h-80.3c-2.2-8-17.3-22.3-32-29.8-9-4.6-17.9-4.3-24.7-5.2 0 0-3.8-6 8.7-8.3 0 0 17.2-4.3 19.2-6.7 1.9-2.2.6-15.7.6-15.7z"}}]})(props);
	};
	module.exports.IoIosPeople.displayName = "IoIosPeople";
	module.exports.IoIosPersonAdd = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M385.3 386c-15.6-5.5-37.8-6.8-52.1-10-8.2-1.8-20.1-6.3-24.1-11.1-3.5-4.2-2.1-38.4-1.7-47.2.1-1.3.5-2.6 1.1-3.8 2.2-3.6 7.2-12.2 10.3-20 3-7.6 6.2-25 7.6-33.3.4-2.4 1.9-4.5 4-5.6 2.6-1.5 6.1-4.9 7.8-13.4 3.1-15.7 8-21.8 7.4-33.5-.3-5.2-1.7-8-3.2-9.5-2-1.9-2.7-4.8-2-7.4 1.9-7.6 4.7-22.6 5.2-45.6.9-41.1-31.3-81.6-89.5-81.6-59.1 0-90.5 40.5-89.6 81.6.5 23 3.3 38 5.1 45.6.6 2.7-.1 5.5-2 7.4-1.5 1.5-3 4.3-3.2 9.5-.6 11.7 4.3 17.8 7.4 33.5 1.7 8.4 5.2 11.9 7.8 13.4 2.1 1.2 3.6 3.2 4 5.6 1.4 8.3 4.6 25.7 7.6 33.3 3.1 7.8 8.2 16.5 10.3 20 .7 1.1 1.1 2.4 1.1 3.8.4 8.8 1.8 43.1-1.7 47.2-4 4.8-15.9 9.3-24.1 11.1-14.3 3.2-36.5 4.5-52.1 10-14.2 5-55.3 20.5-62.5 52.3-1.1 5 2.7 9.7 7.9 9.7H440c5.1 0 8.9-4.7 7.8-9.7-7.2-31.8-48.3-47.3-62.5-52.3z"}},{"tag":"path","attr":{"d":"M437.5 293.5h-27v-27c0-5.8-4.7-10.5-10.5-10.5s-10.5 4.7-10.5 10.5v27h-27c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5h27v27c0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5v-27h27c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5z"}}]})(props);
	};
	module.exports.IoIosPersonAdd.displayName = "IoIosPersonAdd";
	module.exports.IoIosPerson = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.8 438.3c-7.2-31.8-48.3-47.3-62.5-52.3-15.6-5.5-37.8-6.8-52.1-10-8.2-1.8-20.1-6.3-24.1-11.1s-1.6-49.3-1.6-49.3 7.4-11.5 11.4-21.7c4-10.1 8.4-37.9 8.4-37.9s8.2 0 11.1-14.4c3.1-15.7 8-21.8 7.4-33.5-.6-11.5-6.9-11.2-6.9-11.2s6.1-16.7 6.8-51.3c.9-41.1-31.3-81.6-89.6-81.6-59.1 0-90.6 40.5-89.7 81.6.8 34.6 6.7 51.3 6.7 51.3s-6.3-.3-6.9 11.2c-.6 11.7 4.3 17.8 7.4 33.5 2.8 14.4 11.1 14.4 11.1 14.4s4.4 27.8 8.4 37.9c4 10.2 11.4 21.7 11.4 21.7s2.4 44.5-1.6 49.3c-4 4.8-15.9 9.3-24.1 11.1-14.3 3.2-36.5 4.5-52.1 10-14.2 5-55.3 20.5-62.5 52.3-1.1 5 2.7 9.7 7.9 9.7H440c5.1 0 8.9-4.7 7.8-9.7z"}}]})(props);
	};
	module.exports.IoIosPerson.displayName = "IoIosPerson";
	module.exports.IoIosPhoneLandscape = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 176.3v158.5c0 18.3 14.6 33.1 32.9 33.1h381c18.4 0 34.1-14.8 34.1-33.1V176.3c0-18.3-15.7-32.3-34.1-32.3h-381C46.6 144 32 158 32 176.3zM55 271v-30c0-2.2 1.8-4 4-4s4 1.8 4 4v30c0 2.2-1.8 4-4 4s-4-1.8-4-4zm414-15.5c0 9.6-7.8 17.4-17.4 17.4-9.6 0-17.4-7.8-17.4-17.4 0-9.6 7.8-17.4 17.4-17.4 9.6 0 17.4 7.8 17.4 17.4zM424 160v192H83V160h341z"}},{"tag":"path","attr":{"d":"M441.6 255.5c0 5.5 4.5 10 9.9 10 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.4.1-9.9 4.5-9.9 10z"}}]})(props);
	};
	module.exports.IoIosPhoneLandscape.displayName = "IoIosPhoneLandscape";
	module.exports.IoIosPhonePortrait = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M335.7 32H177.1C158.8 32 144 46.6 144 64.9v381c0 18.4 14.8 34.1 33.1 34.1h158.5c18.3 0 32.3-15.7 32.3-34.1v-381C368 46.6 354 32 335.7 32zM241 55h30c2.2 0 4 1.8 4 4s-1.8 4-4 4h-30c-2.2 0-4-1.8-4-4s1.8-4 4-4zm15.5 410c-9.6 0-17.4-7.8-17.4-17.4 0-9.6 7.8-17.4 17.4-17.4 9.6 0 17.4 7.8 17.4 17.4 0 9.6-7.8 17.4-17.4 17.4zm93.5-49H162c-1.1 0-2-.9-2-2V85c0-1.1.9-2 2-2h188c1.1 0 2 .9 2 2v329c0 1.1-.9 2-2 2z"}}]})(props);
	};
	module.exports.IoIosPhonePortrait.displayName = "IoIosPhonePortrait";
	module.exports.IoIosPhotos = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 144H128c-17.6 0-32 14.4-32 32v240c0 17.6 14.4 32 32 32h336c17.6 0 32-14.4 32-32V176c0-17.6-14.4-32-32-32z"}},{"tag":"path","attr":{"d":"M100 116h332V96c0-17.6-14.4-32-32-32H48c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h20V148c0-17.6 14.4-32 32-32z"}}]})(props);
	};
	module.exports.IoIosPhotos.displayName = "IoIosPhotos";
	module.exports.IoIosPie = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M276 68.1v219c0 3.7-2.5 6.8-6 7.7L81.1 343.4c-2.3.6-3.6 3.1-2.7 5.4C109.1 426 184.9 480.6 273.2 480c114.6-.7 206.8-93.5 206.8-208 0-112.1-88.6-203.5-199.8-207.8-2.3-.1-4.2 1.7-4.2 3.9z"}},{"tag":"path","attr":{"d":"M32 239.3s.2 48.8 15.2 81.1c.8 1.8 2.8 2.7 4.6 2.2l193.8-49.7c3.5-.9 6.4-4.6 6.4-8.2V36c0-2.2-1.8-4-4-4C91 33.9 32 149 32 239.3z"}}]})(props);
	};
	module.exports.IoIosPie.displayName = "IoIosPie";
	module.exports.IoIosPin = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-79.5 0-144 59.9-144 133.7 0 104 144 282.3 144 282.3s144-178.3 144-282.3C400 107.9 335.5 48 256 48zm0 190.9c-25.9 0-46.9-21-46.9-46.9s21-46.9 46.9-46.9 46.9 21 46.9 46.9-21 46.9-46.9 46.9z"}}]})(props);
	};
	module.exports.IoIosPin.displayName = "IoIosPin";
	module.exports.IoIosPint = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M372 175.2c0-19.5-1-81.7-19.3-115.6-4.5-8.2-9.5-11.6-28.7-11.6H188c-19.3 0-24.2 3.4-28.7 11.6-18.3 33.9-19.3 96.5-19.3 116 0 91 36 93.1 36 167.8 0 36.7-16 66.7-16 92.7 0 25.1 6 27.8 29 27.8h134c23 0 29-2.9 29-27.9 0-26-16-55.7-16-92.4 0-74.7 36-77.4 36-168.4zM188 76h136c2.4 0 4.3.1 5.7.2 5.4 11.6 9.4 29.3 11.8 50.8h-171c2.4-21.6 6.5-39.3 11.8-50.8 1.4-.1 3.3-.2 5.7-.2z"}}]})(props);
	};
	module.exports.IoIosPint.displayName = "IoIosPint";
	module.exports.IoIosPizza = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M446.6 109.8c-2.7-7.3-14.2-14-25-18.7-27-11.6-73.5-27.1-164.9-27.1-94 0-137.5 14.5-165 27.1-12.3 5.7-24.2 12.5-26.7 19.5-2.9 8 .8 15.3 4.1 21.8l1.5 3c3.1 6.4 12.9 12.8 22.8 13.8L251.3 445c1 1.9 3.1 3.1 5.3 3.1 2.2 0 4.3-1.2 5.3-3.1l157.6-295.1c5.6-.6 17.2-2.6 23.1-14.3 3.9-7.7 7.4-16.7 4-25.8zm-266 112.8c-1.2 3.5-2.9 6.6-5.1 9.5-1.8 2.3-5.3 2-6.7-.6-8.8-16.6-17.3-32.4-24.8-46.5-1.4-2.6.5-5.8 3.4-5.9h1c3.7 0 7.3.6 10.9 1.7 8.6 2.8 15.5 8.7 19.6 16.6 3.9 7.9 4.6 16.8 1.7 25.2zm116.6 97.5c-.8 1.4-2.3 2.3-3.9 2.1-17-1.8-30.2-15.8-30.2-32.8 0-18.2 15.2-33 33.9-33 9.9 0 19 4 25.3 11 1.1 1.2 1.3 3.1.5 4.5l-25.6 48.2zm35.2-176.8c-5.7 4.1-12.4 6.3-19.5 6.3-1.6 0-3.3-.1-4.9-.3-8.7-1.2-16.3-5.7-21.5-12.5-2-2.6-3.6-5.5-4.6-8.4-1-2.7 1.2-5.5 4-5.3 18.3 1 35.3 2.9 51.4 5.9 3.1.6 4.5 4.1 2.7 6.7-2 2.8-4.6 5.4-7.6 7.6z"}}]})(props);
	};
	module.exports.IoIosPizza.displayName = "IoIosPizza";
	module.exports.IoIosPlanet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.5 352.3c-1.9-5.5-5.6-11.5-11.4-18.3-10.2-12-30.8-29.3-54.8-47.2-2.6-2-6.4-.8-7.5 2.3l-4.7 13.4c-.7 2 0 4.3 1.7 5.5 15.9 11.6 35.9 27.9 41.8 35.9 2 2.8-.5 6.6-3.9 5.8-10-2.3-29-7.3-44.2-12.8-8.6-3.1-17.7-6.7-27.2-10.6 16-20.8 24.7-46.3 24.7-72.6 0-32.8-13.2-63.6-37.1-86.4-22.9-21.9-53.8-34.1-85.7-33.7-25.7.3-50.1 8.4-70.7 23.5-18.3 13.4-32.2 31.3-40.6 52-8.3-6-16.1-11.9-23.2-17.6-13.7-10.9-28.4-22-38.7-34.7-2.2-2.8.9-6.7 4.4-5.9 11.3 2.6 35.4 10.9 56.4 18.9 1.5.6 3.2.3 4.5-.8l11.1-10.1c2.4-2.1 1.7-6-1.3-7.2C121 137.4 89.2 128 73.2 128c-11.5 0-19.3 3.5-23.3 10.4-7.6 13.3 7.1 35.2 45.1 66.8 34.1 28.5 82.6 61.8 136.5 92 87.5 49.1 171.1 81 208 81 11.2 0 18.7-3.1 22.1-9.1 2.8-4.7 3.1-10.4.9-16.8zM312 354c-29.1-12.8-59.3-26-92.6-44.8-30.1-16.9-59.4-36.5-84.4-53.6-1-.7-2.2-1.1-3.4-1.1-.9 0-1.9.2-2.8.7-2 1-3.3 3-3.3 5.2 0 1.2-.1 2.4-.1 3.5 0 32.1 12.6 62.3 35.5 84.9 22.9 22.7 53.4 35.2 85.8 35.2 23.6 0 46.5-6.7 66.2-19.5 1.9-1.2 2.9-3.3 2.7-5.5-.1-2.2-1.5-4.1-3.6-5z"}}]})(props);
	};
	module.exports.IoIosPlanet.displayName = "IoIosPlanet";
	module.exports.IoIosPlayCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm83.8 211.9l-137.2 83c-2.9 1.8-6.7-.4-6.7-3.9V173c0-3.5 3.7-5.7 6.7-3.9l137.2 83c2.9 1.7 2.9 6.1 0 7.8z"}}]})(props);
	};
	module.exports.IoIosPlayCircle.displayName = "IoIosPlayCircle";
	module.exports.IoIosPlay = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 104.3v303.4c0 6.4 6.5 10.4 11.7 7.2l240.5-151.7c5.1-3.2 5.1-11.1 0-14.3L139.7 97.2c-5.2-3.3-11.7.7-11.7 7.1z"}}]})(props);
	};
	module.exports.IoIosPlay.displayName = "IoIosPlay";
	module.exports.IoIosPodium = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 199.9v208.2c0 4.4 3.5 7.9 7.9 7.9h96.2c4.4 0 7.9-3.5 7.9-7.9V199.9c0-4.4-3.5-7.9-7.9-7.9H71.9c-4.4 0-7.9 3.5-7.9 7.9zM199.9 96c-4.4 0-7.9 3.5-7.9 7.9V416h120.1c4.4 0 7.9-3.5 7.9-7.9V103.9c0-4.4-3.5-7.9-7.9-7.9H199.9zM440.1 256h-96.2c-4.4 0-7.9 3.5-7.9 7.9v144.2c0 4.4 3.5 7.9 7.9 7.9h96.2c4.4 0 7.9-3.5 7.9-7.9V263.9c0-4.4-3.5-7.9-7.9-7.9z"}}]})(props);
	};
	module.exports.IoIosPodium.displayName = "IoIosPodium";
	module.exports.IoIosPower = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.4 111.7c-3.3-2.8-7.5-4.3-11.8-4.3-5.3 0-10.4 2.3-13.8 6.4-3.2 3.7-4.7 8.4-4.3 13.3.4 4.8 2.7 9.3 6.4 12.4 34.8 29.5 54.8 72.3 54.8 117.4 0 85.4-69.8 154.8-155.6 154.8s-155.6-69.5-155.6-154.8c0-45.2 20-88 54.8-117.4 3.7-3.1 6-7.5 6.4-12.4.4-4.8-1.1-9.6-4.3-13.3-3.5-4-8.5-6.4-13.8-6.4-4.3 0-8.5 1.5-11.8 4.3C88.7 148.1 64 201 64 256.8 64 362.2 150.1 448 256 448s192-85.8 192-191.2c0-55.8-24.7-108.7-67.6-145.1z"}},{"tag":"path","attr":{"d":"M256.9 274.5c10.2 0 18.5-8.3 18.5-18.5V82.5c0-10.2-8.3-18.5-18.5-18.5s-18.5 8.3-18.5 18.5V256c0 10.2 8.3 18.5 18.5 18.5z"}}]})(props);
	};
	module.exports.IoIosPower.displayName = "IoIosPower";
	module.exports.IoIosPricetag = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.2 48H312.3c-3.8 0-7.5 1.5-10.2 4.2L56.4 297.9c-11.2 11.2-11.2 29.5 0 40.7l117 117c11.2 11.2 29.5 11.2 40.7 0L459.7 210c2.7-2.7 4.2-6.4 4.2-10.2v-123C464 60.9 451.1 48 435.2 48zm-47.7 111.8c-20.4 2.2-37.4-14.9-35.3-35.3 1.6-14.8 13.5-26.8 28.3-28.3 20.4-2.2 37.4 14.9 35.3 35.3-1.6 14.8-13.5 26.7-28.3 28.3z"}}]})(props);
	};
	module.exports.IoIosPricetag.displayName = "IoIosPricetag";
	module.exports.IoIosPricetags = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.3 32H285.1c-3.7 0-7.2 1.5-9.8 4.1L40.1 272.2c-10.8 10.8-10.8 28.4 0 39.2l111.5 112.5C162.4 434.7 179 440 195 426l231.9-232.3c2.6-2.6 4.1-6.1 4.1-9.8V59.7c0-15.3-12.4-27.7-27.7-27.7zm-45.9 107.5c-19.6 2.1-36-14.4-33.9-33.9 1.5-14.3 13-25.7 27.3-27.3 19.6-2.1 36 14.4 33.9 33.9-1.5 14.3-13 25.8-27.3 27.3z"}},{"tag":"path","attr":{"d":"M456 80.3V194c0 3.7-1.5 7.2-4.1 9.8L192.7 463l8.8 8.8c10.8 10.8 28.4 10.8 39.2 0l235.2-236.2c2.6-2.6 4.1-6.1 4.1-9.8V107.7c0-14-10.5-25.6-24-27.4z"}}]})(props);
	};
	module.exports.IoIosPricetags.displayName = "IoIosPricetags";
	module.exports.IoIosPrint = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 248v200c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM384 48H128c-8.8 0-16 7.2-16 16v20c0 2.2 1.8 4 4 4h280c2.2 0 4-1.8 4-4V64c0-8.8-7.2-16-16-16z"}},{"tag":"path","attr":{"d":"M432.5 112h-352C62.9 112 48 125.8 48 143.3v174.4c0 17.5 14.9 32.3 32.5 32.3H96c4.4 0 8-3.6 8-8V236c0-15.5 12.5-28 28-28h248c15.5 0 28 12.5 28 28v106c0 4.4 3.6 8 8 8h16.5c17.6 0 31.5-14.8 31.5-32.3V143.3c0-17.5-13.9-31.3-31.5-31.3z"}}]})(props);
	};
	module.exports.IoIosPrint.displayName = "IoIosPrint";
	module.exports.IoIosPulse = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.6 272.1c-22.4-1.2-41.6 13.2-48.2 32.9h-38.9l-28.4-85.4c-2.2-6.6-8.3-11-15.2-11h-.3c-7 .1-13.1 4.8-15 11.6l-44.5 155.3-52.3-314.1c-1.2-7.5-7.6-13.1-15.2-13.4-7.6-.3-14.3 4.8-16.2 12.1l-53 244.9H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h72c7.3 0 13.8-5 15.5-12.1l37.4-182.2 51.3 307.9c1.2 7.4 7.4 12.9 14.9 13.3h.9c7.1 0 13.4-4.7 15.4-11.6l49.7-173.6 15.7 47.3c2.2 6.5 8.3 11 15.2 11h51.1c6.9 18 24.4 31 44.9 31 27 0 48.8-22.3 48-49.5-.8-24.8-20.7-45.1-45.4-46.4z"}}]})(props);
	};
	module.exports.IoIosPulse.displayName = "IoIosPulse";
	module.exports.IoIosQrScanner = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M174 64h-58.8C78.1 64 48 94.1 48 131.2V190c0 7.7 6.3 14 14 14s14-6.3 14-14v-59.8c0-9.1 4.3-18.7 11.7-26.2 7.5-7.6 17.2-12 26.5-12H174c7.7 0 14-6.3 14-14s-6.3-14-14-14zM397.8 64H338c-7.7 0-14 6.3-14 14s6.3 14 14 14h59.8c9.3 0 19 4.4 26.5 12 7.4 7.5 11.7 17.1 11.7 26.2V190c0 7.7 6.3 14 14 14s14-6.3 14-14v-59.8c0-36.5-29.7-66.2-66.2-66.2zM174 420h-59.8c-9.3 0-19-4.4-26.5-12-7.4-7.5-11.7-17.1-11.7-26.2V322c0-7.7-6.3-14-14-14s-14 6.3-14 14v59.8c0 36.5 29.7 66.2 66.2 66.2H174c7.7 0 14-6.3 14-14s-6.3-14-14-14zM450 308c-7.7 0-14 6.3-14 14v59.8c0 9.1-4.3 18.7-11.7 26.2-7.5 7.6-17.2 12-26.5 12H338c-7.7 0-14 6.3-14 14s6.3 14 14 14h58.8c37 0 67.2-30.1 67.2-67.2V322c0-7.7-6.3-14-14-14z"}}]})(props);
	};
	module.exports.IoIosQrScanner.displayName = "IoIosQrScanner";
	module.exports.IoIosQuote = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M209 96h-65c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h38.7c4.6 0 8.3 3.9 8 8.6-2.3 35.5-18.8 60.2-31.3 74.1-4.7 5.2-1 13.4 5.9 13.4h39.9c2.5 0 4.8-1.1 6.3-3.1 7.4-9.6 28.5-41.6 28.5-93.9v-192c0-17.8-13.3-31.1-31-31.1zM385 96h-65c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h38.7c4.6 0 8.3 3.9 8 8.6-2.3 35.5-18.8 60.2-31.3 74.1-4.7 5.2-1 13.4 5.9 13.4h39.9c2.5 0 4.8-1.1 6.3-3.1 7.4-9.6 28.5-41.6 28.5-93.9v-192c0-17.8-13.3-31.1-31-31.1z"}}]})(props);
	};
	module.exports.IoIosQuote.displayName = "IoIosQuote";
	module.exports.IoIosRadioButtonOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosRadioButtonOff.displayName = "IoIosRadioButtonOff";
	module.exports.IoIosRadioButtonOn = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M363.5 148.5C334.8 119.8 296.6 104 256 104c-40.6 0-78.8 15.8-107.5 44.5C119.8 177.2 104 215.4 104 256s15.8 78.8 44.5 107.5C177.2 392.2 215.4 408 256 408c40.6 0 78.8-15.8 107.5-44.5C392.2 334.8 408 296.6 408 256s-15.8-78.8-44.5-107.5z"}}]})(props);
	};
	module.exports.IoIosRadioButtonOn.displayName = "IoIosRadioButtonOn";
	module.exports.IoIosRadio = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M60 256c0-51 18.6-97.9 54-135.6 5.3-5.7 5.2-14.8-.4-20.3-2.6-2.6-6.1-4.1-9.7-4.1-3.8 0-7.4 1.6-10.1 4.4C53.3 143.7 32 197.4 32 256c0 58.5 21.3 112.3 61.7 155.5 2.7 2.9 6.3 4.5 10.2 4.5 3.6 0 7.1-1.4 9.7-3.9 2.7-2.6 4.3-6.2 4.4-10 .1-3.9-1.3-7.6-4-10.3C78.6 353.9 60 307 60 256zM418.2 100.4c-2.6-2.8-6.2-4.4-10-4.4-3.6 0-7.1 1.4-9.7 3.9-2.7 2.6-4.3 6.2-4.4 10-.1 3.9 1.3 7.6 4 10.3 35.3 37.8 54 84.7 54 135.7s-18.6 97.9-54 135.7c-5.3 5.6-5.2 14.7.3 20.2 2.5 2.6 6 4 9.7 4 3.9 0 7.6-1.6 10.2-4.6 40.4-43 61.7-96.7 61.7-155.2 0-58.5-21.3-112.4-61.8-155.6z"}},{"tag":"path","attr":{"d":"M159.2 347.7c-24.1-24.3-37.3-56.6-37.3-90.9 0-35 13.8-67.9 38.8-92.4 5.5-5.3 5.6-14.2.2-19.8-2.6-2.7-6.2-4.2-10-4.2-3.7 0-7.2 1.4-9.8 4C110.7 174.2 94 214.1 94 256.8c0 41.6 16.1 80.9 45.3 110.6 2.7 2.7 6.2 4.2 9.9 4.2s7.2-1.5 9.8-4.2c2.6-2.6 4.1-6.1 4.1-9.8.2-3.7-1.2-7.2-3.9-9.9zM371 144.5c-2.6-2.6-6-4-9.8-4-3.8 0-7.3 1.5-10 4.1-5.4 5.4-5.4 14.3.1 19.8 25 24.5 38.7 56.5 38.7 91.5 0 34.2-13.1 67.4-37.1 91.8-5.4 5.4-5.3 14.3.1 19.7 2.6 2.6 6.2 4.1 9.8 4.1 3.8 0 7.4-1.5 9.9-4.1C402 337.7 418 297.6 418 256c0-42.5-16.7-81.5-47-111.5z"}},{"tag":"path","attr":{"d":"M207.1 183.4c-2.6-2.7-6.2-4.2-10-4.2-3.7 0-7.2 1.4-9.8 4.1-19.8 19.5-30.8 45.6-30.8 73.3 0 27.1 10.5 52.7 29.5 72.1 2.7 2.7 6.2 4.2 10 4.2 3.7 0 7.2-1.4 9.8-4 2.7-2.6 4.2-6.1 4.2-9.9 0-3.8-1.4-7.3-4.1-10-13.8-14-21.4-32.6-21.4-52.5 0-20.3 8-39.2 22.4-53.4 5.4-5.2 5.5-14.1.2-19.7zM325.7 183.2c-2.6-2.6-6-4-9.8-4-3.8 0-7.3 1.5-10 4.1-5.4 5.4-5.4 14.3.1 19.8 14.5 14.3 22.4 33.3 22.4 53.5 0 19.8-7.6 38.5-21.5 52.5-2.6 2.6-4.1 6.2-4 9.9 0 3.7 1.5 7.2 4.1 9.8 2.6 2.6 6.2 4.1 9.8 4.1 3.7 0 7.3-1.5 9.9-4.2 19.1-19.4 29.6-45 29.6-72.1.1-27.8-10.8-53.8-30.6-73.4zM256 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17.1-38-38-38z"}}]})(props);
	};
	module.exports.IoIosRadio.displayName = "IoIosRadio";
	module.exports.IoIosRainy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M433.9 175.6c-19-17.6-44.6-27.3-72.1-27.3h-5.6c-6.5-23.5-19.4-43.5-37.6-58.2C297.3 73 269.5 64 238.1 64c-32.7 0-63.2 11.7-86 32.9-22.8 21.2-35.5 50-36.1 81.4-17.5 4-33.6 13.7-46 27.9-14.2 16.2-22 36.6-22 57.4 0 44.6 34.9 82.6 77.4 86L101.2 382c-2.4 3.2-3.3 7.2-2.7 11.1.6 3.9 2.8 7.3 6 9.6 2.5 1.8 5.5 2.7 8.6 2.7 5.2 0 9.8-2.1 12.5-5.8l37.1-50h35.1l-55.3 75.1c-2.3 3.2-3.4 6.9-2.9 10.6.5 3.9 2.6 7.4 5.9 9.8 3.5 2.5 7.5 2.8 9 2.8 7.2 0 11.2-3.5 13.4-6.4l67.4-91.8H270L246 382c-2.4 3.3-3.4 7.2-2.7 11.1.6 3.9 2.8 7.3 6 9.6 2.5 1.8 5.5 2.7 8.6 2.7 5.2 0 9.8-2.1 12.5-5.8l37-50h35.1l-55.3 75.1c-2.3 3.2-3.4 7-2.9 10.6.5 3.8 2.6 7.2 5.9 9.6 2.6 1.9 5.9 3 8.9 3 5.1 0 9.7-2.2 12.5-6l69.7-95.1c22.4-4.5 43-16.6 58.1-34.5 15.9-18.8 24.7-42.6 24.7-67.1-.1-26.8-10.8-51.6-30.2-69.6z"}}]})(props);
	};
	module.exports.IoIosRainy.displayName = "IoIosRainy";
	module.exports.IoIosRecording = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M386.2 146h-.1c-60.6 0-109.8 49.2-109.8 110.1 0 30.5 12.3 58 32.3 77.9H203.5c19.9-19.9 32.3-47.5 32.3-77.9 0-60.8-49.2-110.1-109.8-110.1h-.1-.1C65.2 146 16 195.2 16 256s49.2 110 109.8 110h260.4c60.6 0 109.8-49.2 109.8-110s-49.2-110-109.8-110zM464 256c0 43.1-34.9 78.2-77.9 78.2s-77.9-35.1-77.9-78.2 34.9-78.2 77.9-78.2S464 212.9 464 256zm-338.1 78.2C83 334.2 48 299.1 48 256s34.9-78.2 77.9-78.2 77.9 35.1 77.9 78.2-34.9 78.2-77.9 78.2z"}}]})(props);
	};
	module.exports.IoIosRecording.displayName = "IoIosRecording";
	module.exports.IoIosRedo = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 432h2.9c1.8 0 3.5-1.1 4.1-2.8 2.2-5.7 8.3-19.8 21.4-39.7 21.5-32.7 58.4-67.4 94.5-83.5 27.6-12.4 53-21.5 97.1-23.2 2.3-.1 4.2 1.7 4.2 4v81.6c0 3.2 3.6 5.1 6.2 3.4l215.9-142.2c2.4-1.6 2.4-5.1 0-6.7l-216-142.2c-2.7-1.8-6.2.1-6.2 3.4v82.6c0 2.2-1.7 3.9-3.8 4-71.6 3.8-123.1 24.8-163.4 65.5-61 61.6-56.8 139.1-56.8 158.7 0 10.3-.1 25.3-.1 37.1z"}}]})(props);
	};
	module.exports.IoIosRedo.displayName = "IoIosRedo";
	module.exports.IoIosRefreshCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 336.1c-70.7 0-128-57.3-128-128.1s57.3-128.1 128-128.1v-37c0-6.4 7.1-10.2 12.4-6.7l72.9 52.6c4.9 3.3 4.7 10.6-.4 13.6L268 196.7c-5.3 3.1-12-.8-12-6.9v-41.9c-60.3 0-109.2 49.7-108.1 110.2 1.1 59.1 50.3 106.7 109.5 106 55.9-.7 101.8-43.7 106.3-99 .4-5.2 4.7-9.1 9.9-9.1 5.8 0 10.4 4.9 9.9 10.7-5.4 66-60.4 117.4-127.5 117.4z"}}]})(props);
	};
	module.exports.IoIosRefreshCircle.displayName = "IoIosRefreshCircle";
	module.exports.IoIosRefresh = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M433 288.8c-7.7 0-14.3 5.9-14.9 13.6-6.9 83.1-76.8 147.9-161.8 147.9-89.5 0-162.4-72.4-162.4-161.4 0-87.6 70.6-159.2 158.2-161.4 2.3-.1 4.1 1.7 4.1 4v50.3c0 12.6 13.9 20.2 24.6 13.5L377 128c10-6.3 10-20.8 0-27.1l-96.1-66.4c-10.7-6.7-24.6.9-24.6 13.5v45.7c0 2.2-1.7 4-3.9 4C148 99.8 64 184.6 64 288.9 64 394.5 150.1 480 256.3 480c100.8 0 183.4-76.7 191.6-175.1.8-8.7-6.2-16.1-14.9-16.1z"}}]})(props);
	};
	module.exports.IoIosRefresh.displayName = "IoIosRefresh";
	module.exports.IoIosRemoveCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M346.5 240h-181c-8.8 0-16 6-16 16s7.5 16 16 16h181c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosRemoveCircleOutline.displayName = "IoIosRemoveCircleOutline";
	module.exports.IoIosRemoveCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm90.5 224h-181c-8.5 0-16-6-16-16s7.2-16 16-16h181c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosRemoveCircle.displayName = "IoIosRemoveCircle";
	module.exports.IoIosRemove = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.5 240h-225c-8.8 0-16 7.2-16 16 0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7h225c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}}]})(props);
	};
	module.exports.IoIosRemove.displayName = "IoIosRemove";
	module.exports.IoIosReorder = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 304h352v16H80zM80 248h352v16H80zM80 192h352v16H80z"}}]})(props);
	};
	module.exports.IoIosReorder.displayName = "IoIosReorder";
	module.exports.IoIosRepeat = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336.6 157.5L303 124.1c-3.5-3.5-8.5-4.9-13.6-3.6-1.2.3-2.4.8-3.5 1.5-4.7 2.9-7.2 7.8-6.8 13.1.2 3.4 1.9 6.6 4.3 9.1l16 15.9H142c-20.8 0-40.3 8.1-55.1 22.9C72.1 197.7 64 217.2 64 238v16c0 7.7 6.3 14 14 14s14-6.3 14-14v-16c0-13.3 5.2-25.8 14.7-35.3 9.5-9.5 22-14.7 35.3-14.7h155.4l-16 15.9c-2.4 2.4-4 5.4-4.3 8.7-.4 4.2 1.1 8.3 4.1 11.3 2.6 2.6 6.2 4.1 9.9 4.1s7.2-1.4 9.9-4.1l35.6-35.4c4.2-4.1 6.5-9.7 6.5-15.5-.1-5.9-2.4-11.4-6.5-15.5zM434 244c-7.7 0-14 6.3-14 14v16c0 13.3-5.2 25.8-14.7 35.3-9.5 9.5-22 14.7-35.3 14.7H214.6l16-15.9c2.4-2.4 4-5.4 4.3-8.8.4-4.2-1.1-8.3-4.1-11.3-2.6-2.6-6.2-4.1-9.9-4.1s-7.2 1.4-9.9 4.1l-35.6 35.4c-4.2 4.1-6.5 9.7-6.5 15.5 0 5.9 2.3 11.4 6.5 15.5l33.6 33.4c3.5 3.5 8.5 4.9 13.6 3.6 1.2-.3 2.4-.8 3.5-1.5 4.7-2.9 7.2-7.8 6.8-13.1-.2-3.4-1.9-6.6-4.3-9.1l-16-15.9H370c43 0 78-35 78-78v-16c0-7.5-6.3-13.8-14-13.8z"}}]})(props);
	};
	module.exports.IoIosRepeat.displayName = "IoIosRepeat";
	module.exports.IoIosResize = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.3 80H307.8c-7.5 0-13.7 6.1-13.7 13.7v.2c0 7.5 6.1 13.7 13.7 13.7h76.5L107.6 384.3v-76.5c0-7.5-6.1-13.7-13.7-13.7h-.2c-7.5 0-13.7 6.1-13.7 13.7v110.5c0 7.5 6.1 13.7 13.7 13.7h110.5c7.5 0 13.7-6.1 13.7-13.7v-.2c0-7.5-6.1-13.7-13.7-13.7h-76.5l276.7-276.7v76.5c0 7.5 6.1 13.7 13.7 13.7h.2c7.5 0 13.7-6.1 13.7-13.7V93.7c0-7.6-6.1-13.7-13.7-13.7z"}}]})(props);
	};
	module.exports.IoIosResize.displayName = "IoIosResize";
	module.exports.IoIosRestaurant = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 64c-24.8 0-48 77.3-48 160 0 57 32 80 32 80v128c0 8.8 7.2 16 16 16s16-7.2 16-16V75c0-11-11-11-16-11zM288 64l10 104c0 4.4-3.6 8-8 8s-8-3.6-8-8l-6-104h-8l-6 104c0 4.4-3.6 8-8 8s-8-3.6-8-8l10-104h-8s-24 107.2-24 128 13.4 38.6 32 45.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V237.2c18.6-6.6 32-24.2 32-45.2S296 64 296 64h-8zM160 64c-26.5 0-48 64-48 128 0 20.8 13.4 38.6 32 45.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V237.2c18.6-6.6 32-24.2 32-45.2 0-64-21.5-128-48-128z"}}]})(props);
	};
	module.exports.IoIosRestaurant.displayName = "IoIosRestaurant";
	module.exports.IoIosReturnLeft = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M70.5 265.4l59.6-59.4c2.6-2.6 6.1-4.1 9.9-4.1 3.7 0 7.3 1.4 9.9 4.1 2.6 2.6 4.1 6.1 4.1 9.9s-1.5 7.3-4.1 9.9l-.1.1-41.1 40.1H370c13.2 0 25.8-5.2 35.3-14.7 9.5-9.4 14.7-21.9 14.7-35.3v-48c0-7.7 6.3-14 14-14s14 6.3 14 14v48c0 20.8-8.1 40.3-22.9 55.1-14.8 14.8-34.3 22.9-55.1 22.9H108.3l39.6 40.2c2.6 2.6 4.1 6.1 4.1 9.9 0 3.7-1.4 7.3-4.1 9.9l-.1.1c-2.7 2.5-6.2 3.9-9.8 3.9-3.9 0-7.3-1.4-9.9-4.1l-57.6-57.4c-4.2-4.2-6.5-9.8-6.5-15.7 0-5.8 2.3-11.3 6.5-15.4z"}}]})(props);
	};
	module.exports.IoIosReturnLeft.displayName = "IoIosReturnLeft";
	module.exports.IoIosReturnRight = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.5 265.4L381.9 206c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-2.6 2.6-4.1 6.1-4.1 9.9s1.5 7.3 4.1 9.9l.1.1 41.1 40.1H142c-13.2 0-25.8-5.2-35.3-14.7-9.5-9.5-14.7-22-14.7-35.3v-48c0-7.7-6.3-14-14-14s-14 6.3-14 14v48c0 20.8 8.1 40.3 22.9 55.1 14.8 14.8 34.3 22.9 55.1 22.9h261.7L364 334.2c-2.6 2.6-4.1 6.1-4.1 9.9 0 3.7 1.4 7.3 4.1 9.9l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.9 0 7.3-1.4 9.9-4.1l57.6-57.4c4.2-4.2 6.5-9.8 6.5-15.7.1-5.8-2.2-11.3-6.4-15.4z"}}]})(props);
	};
	module.exports.IoIosReturnRight.displayName = "IoIosReturnRight";
	module.exports.IoIosReverseCamera = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.5 160H363c-4.6 0-8.9-2-12-5.4-28.4-31.8-39.1-42.6-50.7-42.6h-85.5c-11.7 0-23.2 10.8-51.7 42.7-3 3.4-7.4 5.3-11.9 5.3h-4.1v-8c0-4.4-3.6-8-8-8h-26c-4.4 0-8 3.6-8 8v8h-7.5C79.9 160 64 173.2 64 190.7v176c0 17.5 15.9 33.3 33.5 33.3h320c17.6 0 30.5-15.8 30.5-33.3v-176c0-17.5-12.9-30.7-30.5-30.7zM308.3 340.5c-.8 2.5-2.6 4.6-4.8 6.1-14.1 9.7-30.5 14.8-47.5 14.8-21 0-41.2-8.1-57.1-22.7-14.6-13.5-24.1-31.2-27-50.2h-20.4c-3.2 0-6-2.8-5.6-6.6.1-.7.3-1.3.7-1.8l31.5-42.3c1.1-1.4 2.7-2.2 4.4-2.2 1.7 0 3.3.8 4.4 2.2l32.2 41.8c2 2.6 1.5 6.4-1.8 8.5-.6.4-1.2.5-1.9.5h-20.8c2.7 12.8 9.7 24.8 19.9 34 11.6 10.6 26.3 16.4 41.4 16.4 12.3 0 24.4-4 35.1-11.5 1.9-1.3 4.2-2.1 6.5-2.1 3.2 0 6.2 1.3 8.3 3.7 2.9 3 3.9 7.3 2.5 11.4zm56.6-67.5l-31.2 42.9c-1.8 2.5-5.5 3.2-8.3.8-.2-.2-.4-.4-.5-.6L292.5 273c-2-2.6-1.4-6.5 1.9-8.5.6-.3 1.2-.5 1.9-.5h21c-2.7-13.6-9.7-26.1-19.9-35.6-11.5-10.7-26.2-16.6-41.3-16.6-12.5 0-24.6 3.9-35.2 11.3-1.9 1.3-4.1 2-6.4 2-3.1 0-6.1-1.3-8.2-3.6-2.8-3-3.8-7.4-2.5-11.5.8-2.5 2.6-4.6 4.7-6 14.1-9.7 30.6-14.8 47.6-14.8 21.7 0 42.2 7.9 57.8 22.3 13.3 12.3 23.2 32.1 26.2 52.4h21.1c.6 0 1.3.2 1.8.5 3.2 2.1 3.8 6 1.9 8.6z"}}]})(props);
	};
	module.exports.IoIosReverseCamera.displayName = "IoIosReverseCamera";
	module.exports.IoIosRewind = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M35.9 249.3L244 129.1c5.4-3.1 12.3.6 12.3 6.7V251l211.3-121.9c5.4-3.1 12.3.6 12.3 6.7v240.3c0 6.1-6.9 9.8-12.3 6.7L256.4 261v115.2c0 6.1-6.9 9.8-12.3 6.7L35.9 262.7c-5.2-3-5.2-10.4 0-13.4z"}}]})(props);
	};
	module.exports.IoIosRewind.displayName = "IoIosRewind";
	module.exports.IoIosRibbon = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M254.9 293.4c73 .6 132.3-58.7 131.7-131.8-.6-69.9-59.7-129-129.5-129.6-73-.6-132.3 58.7-131.7 131.8.6 69.9 59.7 129 129.5 129.6zm-3.7-204.1c44.3-2.8 80.9 33.8 78.1 78.2-2.3 36.6-31.9 66.2-68.5 68.6-44.3 2.8-80.9-33.8-78.1-78.2 2.3-36.6 31.9-66.2 68.5-68.6z"}},{"tag":"path","attr":{"d":"M256 308.4c-42.8 0-81.4-18.1-108.5-47-1.9-2-5.2-1.7-6.6.7L65.1 394.8c-3.1 5.5.8 12.3 7.2 12.3h80.1c2.9 0 5.6 1.5 7.1 4l39 64.9c3.4 5.7 11.8 5.2 14.6-.8l43-94.6 31.3-68.9c1.4-3-1.2-6.3-4.5-5.7-8.8 1.5-17.7 2.4-26.9 2.4zM364.5 261.3c-14.6 15.5-32.4 28-52.5 36.1-1 .4-1.8 1.1-2.2 2.1l-44.7 97.7c-.5 1.1-.5 2.3 0 3.4l33.9 74.5c2.7 6 11.2 6.5 14.6.8l39-64.9c1.5-2.5 4.2-4 7.1-4h80.1c6.3 0 10.3-6.8 7.2-12.3l-75.8-132.8c-1.5-2.2-4.8-2.6-6.7-.6z"}}]})(props);
	};
	module.exports.IoIosRibbon.displayName = "IoIosRibbon";
	module.exports.IoIosRocket = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.8 53.6c-.4-1.7-1.6-3-3.3-3.4-54.4-13.3-180.1 34.1-248.2 102.2-13.3 13.3-24.2 26.4-33.1 39.1-21-1.9-42-.3-59.9 7.5-50.5 22.2-65.2 80.2-69.3 105.1-1 5.9 3.9 11 9.8 10.4l81.1-8.9c.1 7.8.6 14 1.1 18.3.4 4.2 2.3 8.1 5.3 11.1l31.4 31.4c3 3 6.9 4.9 11.1 5.3 4.3.5 10.5 1 18.2 1.1l-8.9 81c-.6 5.9 4.5 10.8 10.4 9.8 24.9-4 83-18.7 105.1-69.2 7.8-17.9 9.4-38.8 7.6-59.7 12.7-8.9 25.9-19.8 39.2-33.1 68.4-68 115.5-190.9 102.4-248zM298.6 213.5c-16.7-16.7-16.7-43.7 0-60.4 16.7-16.7 43.7-16.7 60.4 0 16.7 16.7 16.7 43.7 0 60.4-16.7 16.7-43.7 16.7-60.4 0z"}},{"tag":"path","attr":{"d":"M174.5 380.5c-4.2 4.2-11.7 6.6-19.8 8-18.2 3.1-34.1-12.8-31-31 1.4-8.1 3.7-15.6 7.9-19.7l.1-.1c2.3-2.3.4-6.1-2.8-5.7-9.8 1.2-19.4 5.6-26.9 13.1-18 18-19.7 84.8-19.7 84.8s66.9-1.7 84.9-19.7c7.6-7.6 11.9-17.1 13.1-26.9.3-3.2-3.6-5.1-5.8-2.8z"}}]})(props);
	};
	module.exports.IoIosRocket.displayName = "IoIosRocket";
	module.exports.IoIosRose = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 141.1c-18.9 3.9-36.8 8.2-53.7 12.8-40.5 11-75.5 24.9-105.4 38.2-19.3 8.6-26.2 12.4-51.5 25.9C147 248.9 112 289 112 349c0 67.8 55.6 115 144 115s144-51.2 144-119c0-67.7-61-114.7 16-203.9zM135.4 241.8c12.8-10.5 31.2-23.9 56.1-38.4 6.4-3.8 13.3-7.6 20.6-11.4 11.6-6.1 23.5-11.9 35.8-17.4-9.1-10.1-22.1-19.1-36.6-27C162.6 121.1 96 107.4 96 107.4c41.5 43.7 44.6 96.5 39.4 134.4zM352 77.7s-73.8-.9-125.8 55c0 0 27.7 17.3 42.7 32.3 37.2-15.6 82.3-28.6 115.2-36-6.5-21.7-32.1-51.3-32.1-51.3zM239.7 97C210.3 59.5 176 48 176 48c-15.3 20.8-24.3 38-29 51.7 21.1 5.9 36.5 12.3 62.4 24.7 9.5-10.6 18.1-19.1 30.3-27.4z"}}]})(props);
	};
	module.exports.IoIosRose.displayName = "IoIosRose";
	module.exports.IoIosSad = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256c0 114.7 93.3 208 208 208 114.9 0 208-93.1 208-208 0-114.7-93.3-208-208-208zm-73.9 152.1c14.8-1.2 27 11.1 25.9 25.9-.9 11.6-10.3 21.1-22 22-14.8 1.2-27-11.1-25.9-25.9.9-11.7 10.3-21.1 22-22zm-.7 151.9c-11.5 0-19.3-11.8-14.7-22.4 15-34.5 49.2-58.6 89.3-58.6s74.2 24.1 89.3 58.6c4.6 10.6-3.1 22.4-14.7 22.4 0 0-34.7-4-73.1-4-38.5 0-76.1 4-76.1 4zm148.5-104.1c-14.8 1.2-27-11.1-25.9-25.9.9-11.6 10.3-21.1 22-22 14.8-1.2 27 11.1 25.9 25.9-.9 11.7-10.3 21.1-22 22z"}}]})(props);
	};
	module.exports.IoIosSad.displayName = "IoIosSad";
	module.exports.IoIosSave = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 64h-16c-4.4 0-8 3.6-8 8v72c0 4.4 7.6 8 12 8h12c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8z"}},{"tag":"path","attr":{"d":"M433.9 130.1L382 78.2c-9-9-21.3-14.2-34.1-14.2h-28c-8.8 0-16 7.3-16 16.2v80c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16v-80c0-8.8-7.2-16.2-16-16.2H96c-17.6 0-32 14.4-32 32v320c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V164c0-12.7-5.1-24.9-14.1-33.9zM322 400.1c0 8.8-8 16-17.8 16H143.8c-9.8 0-17.8-7.2-17.8-16v-96c0-8.8 8-16 17.8-16h160.4c9.8 0 17.8 7.2 17.8 16v96z"}}]})(props);
	};
	module.exports.IoIosSave.displayName = "IoIosSave";
	module.exports.IoIosSchool = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96.9 270.3V363c0 2.9 1.5 5.5 4 7l132 75.9c5.3 3.1 12-.8 12-7v-93.8c0-2.9-1.5-5.5-4-7l-132-74.9c-5.4-2.9-12 1-12 7.1zM280.9 445.9L413 370c2.5-1.4 4-4.1 4-7v-93.7c0-6.2-6.6-10-12-7l-132 75.9c-2.5 1.4-4 4.1-4 7V439c-.1 6.1 6.6 10 11.9 6.9z"}},{"tag":"path","attr":{"d":"M249 65.1L37 188.9c-5.4 3.1-5.4 10.8 0 13.9l212 117.8c4.9 2.8 11 2.8 15.9 0L453 212.9c5.3-3.1 7 .8 7 7v153.4c0 6.8 3.9 10 11 10 4.4 0 10-3.2 10-10V201.5c0-2.9-1.5-5.5-4-7L264.9 65.1c-4.9-2.8-11-2.8-15.9 0z"}}]})(props);
	};
	module.exports.IoIosSchool.displayName = "IoIosSchool";
	module.exports.IoIosSearch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.5 420.2L336.7 312.4c20.9-26.2 33.5-59.4 33.5-95.5 0-84.5-68.5-153-153.1-153S64 132.5 64 217s68.5 153 153.1 153c36.6 0 70.1-12.8 96.5-34.2l106.1 107.1c3.2 3.4 7.6 5.1 11.9 5.1 4.1 0 8.2-1.5 11.3-4.5 6.6-6.3 6.8-16.7.6-23.3zm-226.4-83.1c-32.1 0-62.3-12.5-85-35.2-22.7-22.7-35.2-52.9-35.2-84.9 0-32.1 12.5-62.3 35.2-84.9 22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2c22.7 22.7 35.2 52.9 35.2 84.9 0 32.1-12.5 62.3-35.2 84.9-22.7 22.7-52.9 35.2-85 35.2z"}}]})(props);
	};
	module.exports.IoIosSearch.displayName = "IoIosSearch";
	module.exports.IoIosSend = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.9 64.9l-367.1 160c-6.5 3.1-6.3 12.4.3 15.3l99.3 56.1c5.9 3.3 13.2 2.6 18.3-1.8l195.8-168.8c1.3-1.1 4.4-3.2 5.6-2 1.3 1.3-.7 4.3-1.8 5.6L216.9 320.1c-4.7 5.3-5.4 13.1-1.6 19.1l64.9 104.1c3.2 6.3 12.3 6.2 15.2-.2L447.2 76c3.3-7.2-4.2-14.5-11.3-11.1z"}}]})(props);
	};
	module.exports.IoIosSend.displayName = "IoIosSend";
	module.exports.IoIosSettings = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416.3 256c0-21 13.1-38.9 31.7-46.1-4.9-20.5-13-39.7-23.7-57.1-6.4 2.8-13.2 4.3-20.1 4.3-12.6 0-25.2-4.8-34.9-14.4-14.9-14.9-18.2-36.8-10.2-55-17.3-10.7-36.6-18.8-57-23.7C295 82.5 277 95.7 256 95.7S217 82.5 209.9 64c-20.5 4.9-39.7 13-57.1 23.7 8.1 18.1 4.7 40.1-10.2 55-9.6 9.6-22.3 14.4-34.9 14.4-6.9 0-13.7-1.4-20.1-4.3C77 170.3 68.9 189.5 64 210c18.5 7.1 31.7 25 31.7 46.1 0 21-13.1 38.9-31.6 46.1 4.9 20.5 13 39.7 23.7 57.1 6.4-2.8 13.2-4.2 20-4.2 12.6 0 25.2 4.8 34.9 14.4 14.8 14.8 18.2 36.8 10.2 54.9 17.4 10.7 36.7 18.8 57.1 23.7 7.1-18.5 25-31.6 46-31.6s38.9 13.1 46 31.6c20.5-4.9 39.7-13 57.1-23.7-8-18.1-4.6-40 10.2-54.9 9.6-9.6 22.2-14.4 34.9-14.4 6.8 0 13.7 1.4 20 4.2 10.7-17.4 18.8-36.7 23.7-57.1-18.4-7.2-31.6-25.1-31.6-46.2zm-159.4 79.9c-44.3 0-80-35.9-80-80s35.7-80 80-80 80 35.9 80 80-35.7 80-80 80z"}}]})(props);
	};
	module.exports.IoIosSettings.displayName = "IoIosSettings";
	module.exports.IoIosShareAlt = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444.7 230.4l-141.1-132c-1.7-1.6-3.3-2.5-5.6-2.4-4.4.2-10 3.3-10 8v66.2c0 2-1.6 3.8-3.6 4.1C144.1 195.8 85 300.8 64.1 409.8c-.8 4.3 5 8.3 7.7 4.9 51.2-64.5 113.5-106.6 212-107.4 2.2 0 4.2 2.6 4.2 4.8v65c0 7 9.3 10.1 14.5 5.3l142.1-134.3c2.6-2.4 3.4-5.2 3.5-8.4-.1-3.2-.9-6.9-3.4-9.3z"}}]})(props);
	};
	module.exports.IoIosShareAlt.displayName = "IoIosShareAlt";
	module.exports.IoIosShare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 176H269v146.6c0 7-5.4 13-12.4 13.4-7.5.4-13.6-5.6-13.6-13V176H136c-22 0-40 18-40 40v208c0 22 18 40 40 40h240c22 0 40-18 40-40V216c0-22-18-40-40-40zM269 92.1l47.9 47.2c5.1 5 13.3 5 18.4-.1 5-5.1 5-13.3-.1-18.4l-70-69c-2.5-2.4-5.8-3.7-9.1-3.7-1.7 0-3.4.3-5 1-1.5.6-2.9 1.6-4.1 2.7l-70 69c-5.1 5-5.2 13.3-.1 18.4 5 5.1 13.3 5.2 18.4.1L243 92.1V176h26V92.1z"}}]})(props);
	};
	module.exports.IoIosShare.displayName = "IoIosShare";
	module.exports.IoIosShirt = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.8 181.7c1.3-1.6 1.2-3.8-.2-5.3-11.5-12.1-61.3-63.7-89.1-83.7C352 78 332 64 310 64s-22 8-54 8-32-8-54-8-42 14-62.5 28.7c-27.8 20-77.6 71.6-89.1 83.7-1.4 1.5-1.5 3.7-.2 5.3l61.7 64c2.4 2.9 7.1 1.2 7.1-2.5v-44.9c0-4.5 3.2-8.5 7.6-9.2 5.6-.9 10.4 3.5 10.4 8.9v242c0 4.4 3.6 8 8 8h222c4.4 0 8-3.6 8-8V198.3c0-4.5 3.2-8.5 7.6-9.2 5.6-.9 10.4 3.5 10.4 8.9v45.2c0 3.8 4.7 5.4 7.1 2.5l61.7-64zM256 143c-30 0-54-12.7-54-36 0-30 24-10.7 54-10.7 29.8 0 54-19.3 54 10.7 0 23.3-24.2 36-54 36z"}}]})(props);
	};
	module.exports.IoIosShirt.displayName = "IoIosShirt";
	module.exports.IoIosShuffle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.9 288.1c-2.6-2.6-6.2-4.1-9.9-4.1s-7.2 1.4-9.9 4.1c-2.7 2.6-4.1 6.2-4.1 9.9s1.5 7.2 4.1 9.9l16.3 16.2h-75.5l-124-155-.1-.1c-2.6-3.1-6.7-5-10.8-5H78c-7.7 0-14 6.3-14 14s6.3 14 14 14h107.4l52.5 66-52.5 66H78c-7.7 0-14 6.3-14 14s6.3 14 14 14h114c4.1 0 8-1.8 10.7-5l.1-.1 53.2-66.8 53.2 66.8.1.1c2.7 3.2 6.6 5 10.7 5h84.4l-16.3 16.2c-2.7 2.6-4.1 6.1-4.1 9.9 0 3.7 1.5 7.2 4.1 9.9 2.6 2.6 6.2 4.1 9.9 4.1s7.2-1.4 9.9-4.1l33.6-33.4c4.2-4.1 6.5-9.6 6.5-15.5s-2.3-11.4-6.5-15.5l-35.6-35.5z"}},{"tag":"path","attr":{"d":"M279.4 235.4c1.1 1.4 2.8 2.1 4.6 2.1h.1c1.8 0 3.5-.8 4.6-2.2l37.9-47.3h75.8l-16.3 16.2c-2.7 2.6-4.1 6.1-4.1 9.9 0 3.7 1.5 7.2 4.1 9.9 2.6 2.6 6.2 4.1 9.9 4.1s7.2-1.4 9.9-4.1l35.6-35.4c4.2-4.1 6.5-9.7 6.5-15.5 0-5.9-2.3-11.4-6.5-15.5l-33.6-33.4c-2.6-2.6-6.2-4.1-9.9-4.1s-7.2 1.4-9.9 4.1c-2.7 2.6-4.1 6.2-4.1 9.9s1.5 7.2 4.1 9.9l16.3 16.2H320c-4.1 0-8 1.8-10.7 5l-.1.1-40.3 50.2c-1.8 2.2-1.8 5.4.1 7.6l10.4 12.3z"}}]})(props);
	};
	module.exports.IoIosShuffle.displayName = "IoIosShuffle";
	module.exports.IoIosSkipBackward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M175 100v137.8L403.9 98.1c5.3-3.1 12.1.7 12.1 6.9v302c0 6.2-6.7 10-12.1 6.9L175 274.2V412c0 2.2-1.8 4-4 4h-71c-2.2 0-4-1.8-4-4V100c0-2.2 1.8-4 4-4h71c2.2 0 4 1.8 4 4z"}}]})(props);
	};
	module.exports.IoIosSkipBackward.displayName = "IoIosSkipBackward";
	module.exports.IoIosSkipForward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337 100v137.8L108.1 98.1C102.7 95 96 98.8 96 105v302c0 6.2 6.7 10 12.1 6.9L337 274.2V412c0 2.2 1.8 4 4 4h71c2.2 0 4-1.8 4-4V100c0-2.2-1.8-4-4-4h-71c-2.2 0-4 1.8-4 4z"}}]})(props);
	};
	module.exports.IoIosSkipForward.displayName = "IoIosSkipForward";
	module.exports.IoIosSnow = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.5 345.8L408.1 327c11.8-12.3 26-18.2 26.2-18.3 7.5-3 11.4-11.4 8.9-19.1-1.9-5.9-7.4-9.8-13.5-9.8-1.9 0-3.7.4-5.5 1.1-1 .4-24.4 10-41.9 31.2l-96.3-56 96.3-56c17.5 21.2 40.8 30.8 41.9 31.2 1.8.7 3.6 1.1 5.5 1.1 6.1 0 11.6-4 13.5-9.8 2.5-7.7-1.4-16.1-8.9-19.1-.1-.1-14.3-6-26.2-18.3l32.4-18.8c7.2-4.2 9.6-13.4 5.5-20.6-2.7-4.7-7.7-7.6-13.1-7.6-2.6 0-5.3.7-7.6 2L393.1 159c-4.5-16.2-2.7-31.4-2.6-32 1.1-8.1-4.1-15.6-12-17.3-1-.2-2-.3-3-.3-7.1 0-13 5.2-14.1 12.4-.2 1.1-3.6 26 6.1 52.2l-96 56v-99.2c26.9-4.7 46.8-20.2 47.7-20.9 3.1-2.5 5.1-6 5.4-10 .3-4-.9-7.8-3.6-10.8-2.9-3.2-7-5.1-11.4-5.1-3.4 0-6.8 1.2-9.5 3.3-.1.1-12.2 9.4-28.6 13.6V63.1c0-8.2-7.1-15.1-15.5-15.1s-15.5 6.9-15.5 15.1v37.5c-16.3-4.2-28.4-13.5-28.6-13.6-2.7-2.1-6-3.3-9.5-3.3-4.4 0-8.5 1.9-11.4 5.1-2.7 3-4 7-3.6 10.9.3 3.9 2.3 7.4 5.4 9.9.9.7 20.8 16.2 47.7 20.9v99.2l-96-56c9.6-26 6.2-51.1 6-52.2-1-7.2-6.9-12.4-14-12.4-1 0-2 .1-3 .3-7.9 1.6-13.2 9.3-12 17.3 0 .2 2 15.5-2.6 31.9L86.6 140c-2.3-1.3-4.9-2-7.6-2-5.4 0-10.4 2.9-13.1 7.6-4.1 7.2-1.7 16.5 5.5 20.6l32.4 18.8c-11.7 12.1-25.7 18.1-26.2 18.3-7.5 3-11.4 11.4-8.9 19.1 1.9 5.9 7.4 9.8 13.5 9.8 1.9 0 3.7-.4 5.5-1.1 1-.4 24.4-10 41.9-31.2l96.3 56-96.3 56c-17.5-21.2-40.8-30.8-41.9-31.2-1.8-.7-3.6-1.1-5.5-1.1-6.1 0-11.6 4-13.5 9.8-2.5 7.7 1.4 16 8.9 19.1.5.2 14.5 6.2 26.2 18.3l-32.4 18.8c-7.2 4.2-9.6 13.4-5.5 20.6 2.7 4.7 7.7 7.6 13.1 7.6 2.6 0 5.3-.7 7.6-2l32.3-18.8c4.6 16.5 2.6 31.8 2.6 32-1.2 8 4.1 15.7 12 17.3 1 .2 2 .3 3 .3 7.1 0 13-5.2 14.1-12.4.2-1.1 3.6-26-6.1-52.2l96-56v99.2c-26.9 4.7-46.8 20.2-47.7 20.9-3.1 2.5-5.1 6-5.4 10-.3 4 .9 7.8 3.6 10.8 2.9 3.2 7 5.1 11.4 5.1 3.4 0 6.8-1.2 9.5-3.3.1-.1 12.3-9.4 28.6-13.6v37.5c0 8.2 7.1 15.1 15.5 15.1s15.5-6.9 15.5-15.1v-37.5c16.3 4.2 28.4 13.5 28.6 13.6 2.7 2.1 6.1 3.3 9.5 3.3 4.4 0 8.5-1.9 11.4-5.1 2.7-3 4-7 3.6-10.9-.3-3.9-2.3-7.4-5.4-9.9-.9-.7-20.8-16.2-47.7-20.9V282l96 56c-9.6 26-6.2 51.1-6 52.2 1 7.2 6.9 12.4 14 12.4 1 0 2-.1 3-.3 7.9-1.6 13.1-9.2 12-17.3-.1-.5-1.9-15.7 2.6-32l32.2 18.8c2.3 1.3 4.9 2 7.6 2 5.4 0 10.4-2.9 13.1-7.6 4.1-6.9 1.7-16.2-5.5-20.4z"}}]})(props);
	};
	module.exports.IoIosSnow.displayName = "IoIosSnow";
	module.exports.IoIosSpeedometer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosSpeedometer.displayName = "IoIosSpeedometer";
	module.exports.IoIosSquareOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 96H124c-15.4 0-28 12.6-28 28v264c0 15.4 12.6 28 28 28h264c15.4 0 28-12.6 28-28V124c0-15.4-12.6-28-28-28zm0 284c0 4.4-3.6 8-8 8H132c-4.4 0-8-3.6-8-8V132c0-4.4 3.6-8 8-8h248c4.4 0 8 3.6 8 8v248z"}}]})(props);
	};
	module.exports.IoIosSquareOutline.displayName = "IoIosSquareOutline";
	module.exports.IoIosSquare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 416H124c-15.4 0-28-12.6-28-28V124c0-15.4 12.6-28 28-28h264c15.4 0 28 12.6 28 28v264c0 15.4-12.6 28-28 28z"}}]})(props);
	};
	module.exports.IoIosSquare.displayName = "IoIosSquare";
	module.exports.IoIosStarHalf = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463 192H315.9L271.2 58.6C269 52.1 262.9 48 256 48s-13 4.1-15.2 10.6L196.1 192H48c-8.8 0-16 7.2-16 16 0 .9.1 1.9.3 2.7.2 3.5 1.8 7.4 6.7 11.3l120.9 85.2-46.4 134.9c-2.3 6.5 0 13.8 5.5 18 2.9 2.1 5.6 3.9 9 3.9 3.3 0 7.2-1.7 10-3.6l118-84.1 118 84.1c2.8 2 6.7 3.6 10 3.6 3.4 0 6.1-1.7 8.9-3.9 5.6-4.2 7.8-11.4 5.5-18L352 307.2l119.9-86 2.9-2.5c2.6-2.8 5.2-6.6 5.2-10.7 0-8.8-8.2-16-17-16zm-47.4 35.2l-79.8 57.3c-10 7.2-14.2 20.2-10.2 31.8l30.1 87.7c1.3 3.7-2.9 6.8-6.1 4.6l-77.4-55.2-.1-.1c-10-7-16.1-18.3-16.1-30.5V113.3c0-2.2 3.1-2.7 3.8-.6l29.6 88.2c3.8 11.4 14.5 19.1 26.5 19.1h97.3c3.9 0 5.5 5 2.4 7.2z"}}]})(props);
	};
	module.exports.IoIosStarHalf.displayName = "IoIosStarHalf";
	module.exports.IoIosStarOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463 192H315.9L271.2 58.6C269 52.1 262.9 48 256 48s-13 4.1-15.2 10.6L196.1 192H48c-8.8 0-16 7.2-16 16 0 .9.1 1.9.3 2.7.2 3.5 1.8 7.4 6.7 11.3l120.9 85.2-46.4 134.9c-2.3 6.5 0 13.8 5.5 18 2.9 2.1 5.6 3.9 9 3.9 3.3 0 7.2-1.7 10-3.6l118-84.1 118 84.1c2.8 2 6.7 3.6 10 3.6 3.4 0 6.1-1.7 8.9-3.9 5.6-4.2 7.8-11.4 5.5-18L352 307.2l119.9-86 2.9-2.5c2.6-2.8 5.2-6.6 5.2-10.7 0-8.8-8.2-16-17-16zm-127.2 92.5c-10 7.2-14.2 20.2-10.2 31.8l30.1 87.7c1.3 3.7-2.9 6.8-6.1 4.6l-77.4-55.2c-4.9-3.5-10.6-5.2-16.3-5.2-5.7 0-11.4 1.7-16.2 5.2l-77.4 55.1c-3.2 2.3-7.4-.9-6.1-4.6l30.1-87.7c4-11.8-.2-24.8-10.3-32l-81-57.1c-3.2-2.2-1.6-7.3 2.3-7.3H196c12 0 22.7-7.7 26.5-19.1l29.6-88.2c1.2-3.6 6.4-3.6 7.6 0l29.6 88.2c3.8 11.4 14.5 19.1 26.5 19.1h97.3c3.9 0 5.5 5 2.3 7.2l-79.6 57.5z"}}]})(props);
	};
	module.exports.IoIosStarOutline.displayName = "IoIosStarOutline";
	module.exports.IoIosStar = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463 192H315.9L271.2 58.6C269 52.1 262.9 48 256 48s-13 4.1-15.2 10.6L196.1 192H48c-8.8 0-16 7.2-16 16 0 .9.1 1.9.3 2.7.2 3.5 1.8 7.4 6.7 11.3l120.9 85.2-46.4 134.9c-2.3 6.5 0 13.8 5.5 18 2.9 2.1 5.6 3.9 9 3.9 3.3 0 7.2-1.7 10-3.6l118-84.1 118 84.1c2.8 2 6.7 3.6 10 3.6 3.4 0 6.1-1.7 8.9-3.9 5.6-4.2 7.8-11.4 5.5-18L352 307.2l119.9-86 2.9-2.5c2.6-2.8 5.2-6.6 5.2-10.7 0-8.8-8.2-16-17-16z"}}]})(props);
	};
	module.exports.IoIosStar.displayName = "IoIosStar";
	module.exports.IoIosStats = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 448h48c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v368c0 4.4 3.6 8 8 8zM88 448h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zM280.1 448h47.8c4.5 0 8.1-3.6 8.1-8.1V232.1c0-4.5-3.6-8.1-8.1-8.1h-47.8c-4.5 0-8.1 3.6-8.1 8.1v207.8c0 4.5 3.6 8.1 8.1 8.1zM368 136.1v303.8c0 4.5 3.6 8.1 8.1 8.1h47.8c4.5 0 8.1-3.6 8.1-8.1V136.1c0-4.5-3.6-8.1-8.1-8.1h-47.8c-4.5 0-8.1 3.6-8.1 8.1z"}}]})(props);
	};
	module.exports.IoIosStats.displayName = "IoIosStats";
	module.exports.IoIosStopwatch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.9 143.7c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L413 95.6c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l25.5 25.5zM84.8 143.7c3.1 3.1 8.2 3.1 11.3 0l25.5-25.5c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0L73.5 121c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.4z"}},{"tag":"path","attr":{"d":"M280 81.5V64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.5C137.3 93.3 64 174.1 64 272c0 106 86 192 192 192s192-86 192-192c0-97.9-73.3-178.7-168-190.5zm-10 219.3V320c0 7.7-6.3 14-14 14s-14-6.3-14-14v-19.2c-10.7-5.2-18-16.1-18-28.8s7.3-23.6 18-28.8V144c0-7.7 6.3-14 14-14s14 6.3 14 14v99.2c10.7 5.2 18 16.1 18 28.8s-7.3 23.6-18 28.8z"}}]})(props);
	};
	module.exports.IoIosStopwatch.displayName = "IoIosStopwatch";
	module.exports.IoIosSubway = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 32H160c-35.2 0-64 28.8-64 64v232c0 35.2 28.8 64 64 64h192c35.2 0 64-28.8 64-64V96c0-35.2-28.8-64-64-64zM200 56h112c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-32 304c-15.5 0-28-12.5-28-28s12.5-28 28-28 28 12.5 28 28-12.5 28-28 28zm176 0c-15.5 0-28-12.5-28-28s12.5-28 28-28 28 12.5 28 28-12.5 28-28 28zm40-152c0 8.8-7.2 16-16 16H144.2c-8.8 0-16.2-7.2-16.2-16v-95.8c0-8.8 7.4-16.2 16.2-16.2H368c8.8 0 16 7.4 16 16.2V208zM393.7 455.9l-50-48c-5.6-5.4-14.4-5.2-19.8.4-5.4 5.6-5.2 14.4.4 19.8l6.1 5.9H181.5l6.1-5.9c5.6-5.4 5.8-14.2.4-19.8-5.4-5.6-14.2-5.8-19.8-.4l-50 48c-5.6 5.4-5.8 14.2-.4 19.8 2.7 2.9 6.4 4.3 10.1 4.3 3.5 0 7-1.3 9.7-3.9l14.7-14.1h207.2l14.7 14.1c2.7 2.6 6.2 3.9 9.7 3.9 3.7 0 7.4-1.4 10.1-4.3 5.5-5.6 5.3-14.4-.3-19.8z"}}]})(props);
	};
	module.exports.IoIosSubway.displayName = "IoIosSubway";
	module.exports.IoIosSunny = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 387c-8.5 0-15.4 6.9-15.4 15.4v46.2c0 8.5 6.9 15.4 15.4 15.4s15.4-6.9 15.4-15.4v-46.2c0-8.5-6.9-15.4-15.4-15.4zM256 48c-8.5 0-15.4 6.9-15.4 15.4v46.2c0 8.5 6.9 15.4 15.4 15.4s15.4-6.9 15.4-15.4V63.4c0-8.5-6.9-15.4-15.4-15.4zM125 256c0-8.5-6.9-15.4-15.4-15.4H63.4c-8.5 0-15.4 6.9-15.4 15.4s6.9 15.4 15.4 15.4h46.2c8.5 0 15.4-6.9 15.4-15.4zM448.6 240.6h-46.2c-8.5 0-15.4 6.9-15.4 15.4s6.9 15.4 15.4 15.4h46.2c8.5 0 15.4-6.9 15.4-15.4s-6.9-15.4-15.4-15.4zM152.5 344.1c-4.1 0-8 1.6-10.9 4.5l-32.7 32.7c-2.9 2.9-4.5 6.8-4.5 10.9s1.6 8 4.5 10.9c2.9 2.9 6.8 4.5 10.9 4.5 4.1 0 8-1.6 10.9-4.5l32.7-32.7c6-6 6-15.8 0-21.8-2.9-2.9-6.8-4.5-10.9-4.5zM359.5 167.9c4.1 0 8-1.6 10.9-4.5l32.7-32.7c2.9-2.9 4.5-6.8 4.5-10.9s-1.6-8-4.5-10.9c-2.9-2.9-6.8-4.5-10.9-4.5-4.1 0-8 1.6-10.9 4.5l-32.7 32.7c-2.9 2.9-4.5 6.8-4.5 10.9s1.6 8 4.5 10.9c2.9 2.9 6.8 4.5 10.9 4.5zM130.7 108.9c-2.9-2.9-6.8-4.5-10.9-4.5-4.1 0-8 1.6-10.9 4.5-2.9 2.9-4.5 6.8-4.5 10.9 0 4.1 1.6 8 4.5 10.9l32.7 32.7c2.9 2.9 6.8 4.5 10.9 4.5 4.1 0 8-1.6 10.9-4.5 2.9-2.9 4.5-6.8 4.5-10.9s-1.6-8-4.5-10.9l-32.7-32.7zM370.4 348.6c-2.9-2.9-6.8-4.5-10.9-4.5-4.1 0-8 1.6-10.9 4.5-6 6-6 15.8 0 21.8l32.7 32.7c2.9 2.9 6.8 4.5 10.9 4.5 4.1 0 8-1.6 10.9-4.5 2.9-2.9 4.5-6.8 4.5-10.9s-1.6-8-4.5-10.9l-32.7-32.7zM256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96z"}}]})(props);
	};
	module.exports.IoIosSunny.displayName = "IoIosSunny";
	module.exports.IoIosSwap = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388.9 266.3c-5.1-5-5.2-13.3-.1-18.4L436 200H211c-7.2 0-13-5.8-13-13s5.8-13 13-13h224.9l-47.2-47.9c-5-5.1-5-13.3.1-18.4 5.1-5 13.3-5 18.4.1l69 70c1.1 1.2 2.1 2.5 2.7 4.1.7 1.6 1 3.3 1 5 0 3.4-1.3 6.6-3.7 9.1l-69 70c-5 5.2-13.2 5.3-18.3.3zM123.1 404.3c5.1-5 5.2-13.3.1-18.4L76.1 338H301c7.2 0 13-5.8 13-13s-5.8-13-13-13H76.1l47.2-47.9c5-5.1 5-13.3-.1-18.4-5.1-5-13.3-5-18.4.1l-69 70c-1.1 1.2-2.1 2.5-2.7 4.1-.7 1.6-1 3.3-1 5 0 3.4 1.3 6.6 3.7 9.1l69 70c5 5.2 13.2 5.3 18.3.3z"}}]})(props);
	};
	module.exports.IoIosSwap.displayName = "IoIosSwap";
	module.exports.IoIosSwitch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"144","cy":"368","r":"42"}},{"tag":"path","attr":{"d":"M367.5 272h-223C91.2 272 48 315.2 48 368.5S91.2 464 144.5 464h223c53.3 0 96.5-42.2 96.5-95.5S420.8 272 367.5 272zM144 432c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}},{"tag":"circle","attr":{"cx":"368","cy":"144","r":"42"}},{"tag":"path","attr":{"d":"M144.5 240h223c53.3 0 96.5-42.2 96.5-95.5S420.8 48 367.5 48h-223C91.2 48 48 91.2 48 144.5S91.2 240 144.5 240zM368 80c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64z"}}]})(props);
	};
	module.exports.IoIosSwitch.displayName = "IoIosSwitch";
	module.exports.IoIosSync = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M492 257.1c-2.6-2.6-6-4-9.6-4-3.6 0-7 1.4-9.6 4l-13 13c4.3-61.8-19.5-122.5-65.3-165C356.9 70.2 307.7 51 256.1 51c-26.7 0-52.8 5.1-77.4 15.1-25.5 10.4-48.3 25.6-67.7 45.3-13.2 13.4-24.6 28.5-33.6 44.8-1.9 3.4-2.3 7.4-1.2 11.1 1.1 3.7 3.8 6.8 7.2 8.5 2 1 4.2 1.5 6.4 1.5 5.2 0 9.9-2.8 12.4-7.3 7.9-14.3 17.8-27.5 29.4-39.1 16.8-16.8 36.3-29.8 58.1-38.7 21.1-8.6 43.4-12.9 66.2-12.9 22.9 0 45.2 4.3 66.3 12.9 21.8 8.9 41.4 21.9 58.2 38.8 20.3 20.4 35.4 45.6 43.8 73 7 22.9 9.2 47.3 6.6 71.2l-18.9-18.5c-2.5-2.4-5.8-3.8-9.3-3.8-3.5 0-6.9 1.4-9.4 3.9-5.2 5.2-5.2 13.6 0 18.8l42.8 42.9c1.9 1.9 4.4 2.9 7 2.9 2.6 0 5.1-1 7-2.9l42.1-42.2c5.2-5.3 5.2-13.9-.1-19.2zM428.6 335.9c-2-1-4.2-1.5-6.4-1.5-5.2 0-9.9 2.8-12.4 7.3-7.9 14.3-17.8 27.5-29.4 39.1-16.8 16.8-36.3 29.9-58.2 38.7-21.1 8.6-43.4 12.9-66.3 12.9s-45.2-4.3-66.2-12.9c-21.8-8.9-41.4-21.9-58.2-38.7-37.6-37.8-56-90.9-50.3-143.9l18.4 18.5c2.4 2.4 5.6 3.7 9 3.7 3.4 0 6.6-1.3 9-3.7l1.3-1.3c4.9-4.9 4.9-13 0-17.9l-42.9-43c-1.9-1.9-4.4-2.9-7-2.9-2.6 0-5.1 1-7 2.9l-42 42.3c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4 3.6 0 7-1.4 9.6-4l13-13.1c-1.8 25.8 1.3 52 9 76.5 9.9 31.4 26.8 59.3 50.3 82.8 19.5 19.6 42.2 34.7 67.6 45.1 24.5 10 50.4 15 76.9 15 26.5 0 52.4-5.1 76.9-15 25.4-10.3 48.1-25.5 67.6-45.1 13.5-13.5 25-28.8 34.2-45.4 1.9-3.4 2.3-7.4 1.2-11.1-1.2-3.7-3.8-6.8-7.3-8.5z"}}]})(props);
	};
	module.exports.IoIosSync.displayName = "IoIosSync";
	module.exports.IoIosTabletLandscape = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M39 103c-4.5 4.5-7 10.6-7 16.9V392c0 6.4 2.5 12.4 7 16.9 4.5 4.5 10.6 7 16.9 7H456c6.4 0 12.4-2.5 16.9-7 4.5-4.5 7-10.6 7-16.9V119.9c0-6.4-2.5-12.4-7-16.9-4.5-4.5-10.6-7-16.9-7H55.9c-6.3 0-12.4 2.5-16.9 7zm9.7 153.4c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7c-3.8 0-7-3.2-7-7zM470 256c0 7.7-6.5 14-14.1 14-7.5 0-14-6.2-14-14 0-7.7 6.4-14.1 14-14.1 7.6.1 14.1 6.4 14.1 14.1zm-38-144v288H80V112h352z"}}]})(props);
	};
	module.exports.IoIosTabletLandscape.displayName = "IoIosTabletLandscape";
	module.exports.IoIosTabletPortrait = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409 39c-4.5-4.5-10.6-7-16.9-7H119.9c-6.4 0-12.4 2.5-16.9 7-4.5 4.5-7 10.6-7 16.9V456c0 6.4 2.5 12.4 7 16.9 4.5 4.5 10.6 7 16.9 7H392c6.4 0 12.4-2.5 16.9-7 4.5-4.5 7-10.6 7-16.9V55.9c.1-6.3-2.4-12.4-6.9-16.9zm-153.4 9.7c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7c0-3.8 3.2-7 7-7zM256 470c-7.7 0-14-6.5-14-14.1 0-7.5 6.2-14 14-14 7.7 0 14.1 6.4 14.1 14-.1 7.6-6.4 14.1-14.1 14.1zm144-38H112V80h288v352z"}}]})(props);
	};
	module.exports.IoIosTabletPortrait.displayName = "IoIosTabletPortrait";
	module.exports.IoIosTennisball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M250.4 464c1-7.9 1.6-15.9 1.6-23.9 0-48.1-18.7-94.3-52.7-128.3S119 260 70.9 260c-7.7 0-15.4.5-22.9 1.4 2.8 110.3 92.3 199.3 202.4 202.6z"}},{"tag":"path","attr":{"d":"M230 74c0-8.3.5-16.4 1.4-24.5-95.3 11.7-171.7 89-182.2 184.7 7.2-.7 14.4-1.1 21.8-1.1 114.9 0 207.1 92.2 207.1 207 0 7.7-.4 15.3-1.3 22.8 96.6-10.1 174.6-86.2 185.8-182.4-8.4 1-16.9.6-25.5.6C322.1 281 230 188.9 230 74z"}},{"tag":"path","attr":{"d":"M308.7 202.3c34 34 80.2 52.7 128.3 52.7 9.1 0 18.1-.7 27-2-2.2-112-93.9-203.5-206.1-205-1.2 8.5-1.9 17.2-1.9 26 0 48.1 18.7 94.3 52.7 128.3zM232 49.3z"}}]})(props);
	};
	module.exports.IoIosTennisball.displayName = "IoIosTennisball";
	module.exports.IoIosText = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C141.1 64 48 139.2 48 232c0 64.9 45.6 121.2 112.3 149.2-5.2 25.8-21 47-33.5 60.5-2.3 2.5.2 6.5 3.6 6.3 11.5-.8 32.9-4.4 51-12.7 21.5-9.9 40.3-30.1 46.3-36.9 9.3 1 18.8 1.6 28.5 1.6 114.9 0 208-75.2 208-168C464 139.2 370.9 64 256 64z"}}]})(props);
	};
	module.exports.IoIosText.displayName = "IoIosText";
	module.exports.IoIosThermometer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M309.8 304.6c-4.3-3-6.9-7.9-6.9-13.1v-213c0-25.7-21-46.5-47-46.5s-47 20.8-47 46.5v213c0 5.2-2.6 10.2-6.9 13.1-25.2 17.3-42 46.4-42 79.3 0 53 43 96 96 96s96-43 96-96c0-32.9-17-62.1-42.2-79.3zM256.1 445c-32 0-58.1-26.3-58.1-58.8 0-25.4 15.4-47.1 37.9-55.3 3.2-1.2 5.4-4.1 5.4-7.5V180.2c0-8 6.5-14.5 14.5-14.5s14.5 6.5 14.5 14.5v143.2c0 3.4 2.1 6.3 5.3 7.5 21.9 8.2 38.4 29.9 38.4 55.2 0 32.5-25.8 58.9-57.9 58.9z"}}]})(props);
	};
	module.exports.IoIosThermometer.displayName = "IoIosThermometer";
	module.exports.IoIosThumbsDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80.7 123.2c-7.5 6.3-16.7 16.1-16.7 31.4 0 13.7 5.7 22.8 10.9 29.1.6 1.2 1.1 2.3 1.6 3.4l.2 1.1c.7 3.5 0 7.1-2 10-3.4 5-5.8 12.3-5.8 25.7 0 11.6 4.8 18.4 9.7 23.2 4.4 4.3 6.1 12.5 4.1 18.3-4.8 13.9-.2 28.4 8.2 37.8 10.5 11.8 20.3 13.2 46.4 11.7 18-1.1 55.5-6.9 80.2-10.8 10.1-1.6 18.9-3 21.6-3.2 12.7-1.3 15.2 0 16.4 4.9.5 2.1-1.9 6.9-4.9 13-4 8.1-9.5 19.2-14.5 35.8-10.1 33.2-9 69.2 2.7 90.2 5.5 9.9 14.8 19.1 26.3 19.1s23.3-2.4 27.9-7.9c3.4-4 2.3-11.6 6.2-26.8 3.1-12.4 7-30.9 12-42 7.5-16.6 39.7-45.1 57-60.4 4.1-3.6 7.6-6.7 10.1-9.1 8.7-8.1 17.6-21.1 25.5-32.7 5.4-7.8 10.4-15.2 13.7-18.5 7.1-7.1 16.6-10.9 22.3-10.9 4.4 0 8-3.6 8-8V88.1c0-4.6-3.7-8.3-8.3-8.3C404 79.8 389 74 373.1 68c-12.2-4.7-24.9-9.5-46.4-12.1-32.4-4-74.2-8.1-112.6-8.1-20.4 0-39.9 2-56.6 3.9-31 3.6-64.2 10.8-75.2 37-4.1 9.7-2.2 17.6.5 23.7.4.8.7 1.7.8 2.6.6 3.3-.6 6.3-2.9 8.2z"}}]})(props);
	};
	module.exports.IoIosThumbsDown.displayName = "IoIosThumbsDown";
	module.exports.IoIosThumbsUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M431.3 388.8c7.5-6.3 16.7-16.1 16.7-31.4 0-13.7-5.7-22.8-10.9-29.1-.6-1.2-1.1-2.3-1.6-3.4l-.2-1.1c-.7-3.5 0-7.1 2-10 3.4-5 5.8-12.3 5.8-25.7 0-11.6-4.8-18.4-9.7-23.2-4.4-4.3-6.1-12.5-4.1-18.3 4.8-13.9.2-28.4-8.2-37.8-10.5-11.8-20.3-13.2-46.4-11.7-18 1.1-55.5 6.9-80.2 10.8-10.1 1.6-18.9 3-21.6 3.2-12.7 1.3-15.2 0-16.4-4.9-.5-2.1 1.9-6.9 4.9-13 4-8.1 9.5-19.2 14.5-35.8 10.1-33.2 9-69.2-2.7-90.2-5.5-9.9-14.8-19.1-26.3-19.1S223.6 50.5 219 56c-3.4 4-2.3 11.6-6.2 26.8-3.1 12.4-7 30.9-12 42-7.5 16.6-39.7 45.1-57 60.4-4.1 3.6-7.6 6.7-10.1 9.1-8.7 8.1-17.6 21.1-25.5 32.7-5.4 7.8-10.4 15.2-13.7 18.5-7.1 7.1-16.6 10.9-22.3 10.9-4.4 0-8 3.6-8 8v159.5c0 4.6 3.7 8.3 8.3 8.3 35.5 0 50.5 5.8 66.4 11.8 12.2 4.7 24.9 9.5 46.4 12.1 32.4 4 74.2 8.1 112.6 8.1 20.4 0 39.9-2 56.6-3.9 31-3.6 64.2-10.8 75.2-37 4.1-9.7 2.2-17.6-.5-23.7-.4-.8-.7-1.7-.8-2.6-.6-3.3.6-6.3 2.9-8.2z"}}]})(props);
	};
	module.exports.IoIosThumbsUp.displayName = "IoIosThumbsUp";
	module.exports.IoIosThunderstorm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M374.4 141.9l-13.3-.1C349.4 88.2 306 48 236 48S108.2 98.4 108.2 169.5l.3 4.8C66.3 179.9 32 219.6 32 264c0 47 37.9 88 84.7 88H236l13.8-50.6H183c-2.6 0-4.5-2.4-3.9-4.9l23.2-113c.4-1.8 2-3.1 3.9-3.1h86.1c2.7 0 4.6 2.6 3.8 5.2l-22.5 74.9h60.1c3.1 0 5.1 3.5 3.4 6.1L283.4 352H367c72 0 113-52 113-110 0-58.6-47.3-100.1-105.6-100.1zM206.8 458.9c-1.2 4.4 4.8 7 7.2 3.2L283.4 352H236l-29.2 106.9z"}}]})(props);
	};
	module.exports.IoIosThunderstorm.displayName = "IoIosThunderstorm";
	module.exports.IoIosTime = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm14 226c0 7.7-6.3 14-14 14h-96c-7.7 0-14-6.3-14-14s6.3-14 14-14h82V128c0-7.7 6.3-14 14-14s14 6.3 14 14v146z"}}]})(props);
	};
	module.exports.IoIosTime.displayName = "IoIosTime";
	module.exports.IoIosTimer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 456c-110.3 0-200-89.7-200-200 0-54.8 21.7-105.9 61.2-144 6.4-6.2 16.6-6 22.7.4 6.2 6.4 6 16.6-.4 22.7-33.1 32-51.3 74.9-51.3 120.9 0 92.5 75.3 167.8 167.8 167.8S423.8 348.5 423.8 256c0-87.1-66.7-159-151.8-167.1v62.6c0 8.9-7.2 16.1-16.1 16.1s-16.1-7.2-16.1-16.1V72.1c0-8.9 7.2-16.1 16.1-16.1 110.3 0 200 89.7 200 200S366.3 456 256 456z"}},{"tag":"path","attr":{"d":"M175.9 161.9l99.5 71.5c13.5 9.7 16.7 28.5 7 42s-28.5 16.7-42 7c-2.8-2-5.2-4.4-7-7l-71.5-99.5c-3.2-4.5-2.2-10.8 2.3-14 3.6-2.6 8.3-2.4 11.7 0z"}}]})(props);
	};
	module.exports.IoIosTimer.displayName = "IoIosTimer";
	module.exports.IoIosToday = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 32H124c-33.1 0-60 26.9-60 60v328c0 33.1 26.9 60 60 60h264c33.1 0 60-26.9 60-60V92c0-33.1-26.9-60-60-60zm32 388c0 17.6-14.4 32-32 32H124c-17.6 0-32-14.4-32-32V92c0-17.6 14.4-32 32-32h264c17.6 0 32 14.4 32 32v328z"}},{"tag":"path","attr":{"d":"M360 176H152c-13.2 0-24 10.8-24 24v192c0 13.2 10.8 24 24 24h208c13.2 0 24-10.8 24-24V200c0-13.2-10.8-24-24-24zM142 124h100c7.7 0 14-6.3 14-14s-6.3-14-14-14H142c-7.7 0-14 6.3-14 14s6.3 14 14 14z"}}]})(props);
	};
	module.exports.IoIosToday.displayName = "IoIosToday";
	module.exports.IoIosTrain = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.7 455.9l-50-48c-5.6-5.4-14.4-5.2-19.8.4-5.4 5.6-5.2 14.4.4 19.8l6.1 5.9H181.5l6.1-5.9c5.6-5.4 5.8-14.2.4-19.8-5.4-5.6-14.2-5.8-19.8-.4l-50 48c-5.6 5.4-5.8 14.2-.4 19.8 2.7 2.9 6.4 4.3 10.1 4.3 3.5 0 7-1.3 9.7-3.9l14.7-14.1h207.2l14.7 14.1c2.7 2.6 6.2 3.9 9.7 3.9 3.7 0 7.4-1.4 10.1-4.3 5.5-5.6 5.3-14.4-.3-19.8z"}},{"tag":"path","attr":{"d":"M337 48h-17c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16h-15c-35.3 0-65 27.7-65 63v236c0 35.3 144 65 144 65s144-29.7 144-65V111c0-35.3-27.7-63-63-63zm-81 304c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm96-160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v64z"}},{"tag":"circle","attr":{"cx":"256","cy":"304","r":"30.5"}}]})(props);
	};
	module.exports.IoIosTrain.displayName = "IoIosTrain";
	module.exports.IoIosTransgender = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.4 168.5c7.5 0 13.6-6.1 13.6-13.6V61.6c0-7.5-6.1-13.6-13.6-13.6h-93.3c-7.5 0-13.6 6.1-13.6 13.6s6.1 13.6 13.6 13.6H417l-75 75.4c-25.7-16.3-55.4-24.8-86-24.8-30.7 0-60.3 8.6-86 24.8l-19-19.1 28.2-28.2c5.3-5.3 5.3-13.9 0-19.2-2.6-2.6-6-4-9.6-4-3.6 0-7.1 1.4-9.6 4l-28.1 28.1-36.8-37H155c7.5 0 13.6-6.1 13.6-13.6S162.5 48 155 48H61.6C54.1 48 48 54.1 48 61.6v93.3c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V95.1l36.9 36.7-30 30c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4l30.1-30.1 16.5 16.4c-33.9 30.6-53.3 73.9-53.3 119.8 0 43.1 16.8 83.6 47.3 114.1 30.5 30.5 71 47.3 114.1 47.3 45.9 0 89.2-19.4 119.9-53.3l16.4 16.4-29.3 29.2c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4l29.3-29.3 29.3 29.3c2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4 5.3-5.3 5.3-13.9 0-19.2l-29.3-29.3 29.3-29.3c5.3-5.3 5.3-13.9 0-19.2-2.6-2.6-6-4-9.6-4-3.6 0-7.1 1.4-9.6 4l-29.3 29.3-19-19c16.3-25.8 24.9-55.4 24.9-86.1 0-45.9-19.3-89.2-53.3-119.8l72.7-72.2v59.9c0 7.3 6.1 13.4 13.6 13.4zm-60.3 118.6c0 35.8-14 69.5-39.3 94.8-25.3 25.3-59 39.3-94.8 39.3s-69.5-14-94.8-39.3c-25.3-25.3-39.3-59-39.3-94.8s14-69.5 39.3-94.8c25.3-25.3 59-39.3 94.8-39.3s69.5 14 94.8 39.3c25.4 25.3 39.3 59 39.3 94.8z"}}]})(props);
	};
	module.exports.IoIosTransgender.displayName = "IoIosTransgender";
	module.exports.IoIosTrash = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M133.1 128l23.6 290.7c0 16.2 13.1 29.3 29.3 29.3h141c16.2 0 29.3-13.1 29.3-29.3L379.6 128H133.1zm61.6 265L188 160h18.5l6.9 233h-18.7zm70.3 0h-18V160h18v233zm52.3 0h-18.6l6.8-233H324l-6.7 233zM364 92h-36l-26.3-23c-3.7-3.2-8.4-5-13.2-5h-64.8c-4.9 0-9.7 1.8-13.4 5L184 92h-36c-17.6 0-30 8.4-30 26h276c0-17.6-12.4-26-30-26z"}}]})(props);
	};
	module.exports.IoIosTrash.displayName = "IoIosTrash";
	module.exports.IoIosTrendingDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 369.2V251.1c0-8.1-6.8-14.8-15.1-14.8s-15.1 6.6-15.1 14.8v81.7L300.5 181c-2.8-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3l-85.9 84.1L57.5 132.3c-2.9-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3-2.8 2.7-4.2 6.2-4.2 10.2 0 5.4 2.3 8.8 4.2 10.7l146.3 143.2c2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3l85.9-84.1 138 142.2H344c-8.3 0-15.1 6.6-15.1 14.8 0 8.1 6.8 14.8 15.1 14.8h120.8c8.4-.1 15.2-6.7 15.2-14.9z"}}]})(props);
	};
	module.exports.IoIosTrendingDown.displayName = "IoIosTrendingDown";
	module.exports.IoIosTrendingUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.9 128H344.1c-8.3 0-15.1 6.6-15.1 14.8s6.8 14.8 15.1 14.8h83.7l-138 142.2-85.9-84.1c-2.9-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3L36.2 358.8c-1.9 1.9-4.2 5.2-4.2 10.7 0 4.1 1.4 7.5 4.2 10.2 2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3L193.2 247l85.9 84.1c2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3l149.4-151.9v81.7c0 8.1 6.8 14.8 15.1 14.8s15.1-6.6 15.1-14.8V142.8c-.1-8.2-6.9-14.8-15.2-14.8z"}}]})(props);
	};
	module.exports.IoIosTrendingUp.displayName = "IoIosTrendingUp";
	module.exports.IoIosTrophy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450 100h-66V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v20H62c-7.7 0-14 6.3-14 14 0 41.3 7.8 66 22.6 90.4 13.6 22.4 32.9 36.2 56.3 40.3 2.8.5 5.1 2.3 6.2 4.9 6.2 15.4 20.2 34.8 51.1 52.2 20.2 11.4 36.9 18.3 51.7 21.6 3.6.8 6.2 4.1 6.2 7.8V412c0 4.4-3.6 8-8 8h-65.6c-7.5 0-14 5.8-14.4 13.3-.4 8 6 14.7 14 14.7h175.6c7.5 0 14-5.8 14.4-13.3.4-8-6-14.7-14-14.7h-66c-4.4 0-8-3.6-8-8v-80.7c0-3.7 2.6-7 6.2-7.8 14.7-3.3 31.5-10.3 51.7-21.6 30.9-17.4 44.9-36.8 51.1-52.2 1.1-2.6 3.4-4.5 6.2-4.9 23.4-4.1 42.7-17.9 56.3-40.3C456.2 180 464 155.3 464 114c0-7.7-6.3-14-14-14zM128 210.6c0 2.8-2.8 4.8-5.4 3.8-12.8-4.9-23.2-14.7-30.6-28.9-5.8-11-12.6-21.4-15.1-48.8-.4-4.7 3.3-8.7 8-8.7H120c4.4 0 8 3.6 8 8v74.6zm292-25.1c-7.4 14.2-17.8 24-30.6 28.9-2.6 1-5.4-1-5.4-3.8V136c0-4.4 3.6-8 8-8h35.1c4.7 0 8.4 4 8 8.7-2.5 27.4-9.4 37.8-15.1 48.8z"}}]})(props);
	};
	module.exports.IoIosTrophy.displayName = "IoIosTrophy";
	module.exports.IoIosTv = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M451.7 78H60.3C34.8 78 14 98.8 14 124.3v215.5c0 25.5 20.8 46.3 46.3 46.3h391.5c25.5 0 46.3-20.8 46.3-46.3V124.3C498 98.8 477.2 78 451.7 78zM470 339.7c0 10.1-8.2 18.3-18.3 18.3H60.3c-10.1 0-18.3-8.2-18.3-18.3V124.3c0-10.1 8.2-18.3 18.3-18.3h391.5c10.1 0 18.3 8.2 18.3 18.3v215.4z"}},{"tag":"path","attr":{"d":"M436 128H76c-6.6 0-12 5.4-12 12v184c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V140c0-6.6-5.4-12-12-12zM370 406H142c-7.7 0-14 6.3-14 14s6.3 14 14 14h228c7.7 0 14-6.3 14-14s-6.3-14-14-14z"}}]})(props);
	};
	module.exports.IoIosTv.displayName = "IoIosTv";
	module.exports.IoIosUmbrella = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.1 137.9c-34.9-41.6-81.3-67.3-131.2-72.6-2-9.9-10.2-17.3-19.9-17.3s-17.9 7.3-19.9 17.2c-50.6 5.2-97.4 30.3-132.1 71.2-35.8 42.2-55.6 85.5-55.8 143.7-.1.5-.2 1.2-.2 2.1.1 3.2 2.7 5.8 5.8 5.8h3.1c2.6 0 4.9-1.8 5.6-4.4 2.7-10.1 8.4-19.1 16-25.5 7.7-6.5 16.9-9.9 26.6-9.9 9.6 0 18.8 3.4 26.5 10 7.6 6.4 13.2 15.4 16 25.5.7 2.6 3 4.4 5.6 4.4h4.8c2.6 0 4.9-1.8 5.6-4.4 5.7-20.9 23.3-35.4 42.8-35.4 14.8 0 28.8 8.4 36.9 21.9V418c0 9.9-8 18-17.7 18s-17.6-8.1-17.6-18c0-7.7-6.1-14-13.7-14-7.5 0-13.6 6.3-13.6 14 0 25.4 20.2 46 44.9 46 24.8 0 44.9-20.6 44.9-46V270.8c8.2-14.2 21.9-22.6 36.9-22.6 9.6 0 18.7 3.4 26.4 9.9 7.5 6.4 13.1 15.4 15.9 25.5.7 2.6 3 4.4 5.6 4.4h4.8c2.6 0 4.9-1.8 5.6-4.4 2.7-10.1 8.4-19.2 16-25.6 7.7-6.5 16.9-10 26.6-10 9.7 0 19 3.4 26.7 10 7.6 6.4 13.2 15.5 15.9 25.6.7 2.6 3 4.4 5.6 4.4h1.5c1.6 0 3.1-.6 4.2-1.8s1.7-2.7 1.7-4.3c-.8-57.9-21-101.3-56.8-144z"}}]})(props);
	};
	module.exports.IoIosUmbrella.displayName = "IoIosUmbrella";
	module.exports.IoIosUndo = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.9 394.9c0-19.6 4.2-97.1-56.8-158.7-40.4-40.7-91.9-61.7-163.4-65.5-2.1-.1-3.8-1.9-3.8-4V84c0-3.2-3.5-5.1-6.2-3.4L33.8 222.8c-2.4 1.6-2.4 5.1 0 6.7l215.9 142.2c2.7 1.8 6.2-.1 6.2-3.4v-81.6c0-2.3 1.9-4.1 4.2-4 44.1 1.7 69.5 10.9 97.1 23.2 36.1 16.2 72.9 50.9 94.5 83.5 13.1 19.9 19.2 33.9 21.4 39.7.7 1.7 2.3 2.8 4.1 2.8h2.9c-.1-11.7-.2-26.7-.2-37z"}}]})(props);
	};
	module.exports.IoIosUndo.displayName = "IoIosUndo";
	module.exports.IoIosUnlock = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 192H188v-48c0-18.1 7.1-35.1 20-48s29.9-20 48-20 35.1 7.1 48 20 20 29.9 20 48c0 7.7 6.3 14 14 14s14-6.3 14-14c0-53.2-43.9-96.7-97.3-96-52.7.7-94.7 44.5-94.7 97.3V192h-24c-22 0-40 18-40 40v192c0 22 18 40 40 40h240c22 0 40-18 40-40V232c0-22-18-40-40-40zM270 316.8v68.8c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14v-69.2c-11.5-5.6-19.1-17.8-17.9-31.7 1.4-15.5 14.1-27.9 29.6-29 18.7-1.3 34.3 13.5 34.3 31.9 0 12.7-7.3 23.6-18 28.8z"}}]})(props);
	};
	module.exports.IoIosUnlock.displayName = "IoIosUnlock";
	module.exports.IoIosVideocam = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.6 153.6c-3.3 0-6.5.9-9.3 2.7l-86.5 54.6c-2.5 1.6-4 4.3-4 7.2v76c0 2.9 1.5 5.6 4 7.2l86.5 54.6c2.8 1.7 6 2.7 9.3 2.7h20.8c4.8 0 8.6-3.8 8.6-8.5v-188c0-4.7-3.9-8.5-8.6-8.5h-20.8zM273.5 384h-190C55.2 384 32 360.8 32 332.6V179.4c0-28.3 23.2-51.4 51.4-51.4h190c28.3 0 51.4 23.2 51.4 51.4v153.1c.1 28.3-23 51.5-51.3 51.5z"}}]})(props);
	};
	module.exports.IoIosVideocam.displayName = "IoIosVideocam";
	module.exports.IoIosVolumeHigh = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.4 145.5c-2.2-1.1-4.6-1.6-6.9-1.6-3.6 0-7.1 1.2-10 3.5L133.3 200H80.5c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h52.8l65.2 52.5c2.9 2.3 6.5 3.5 10 3.5 2.3 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V160c0-6.2-3.5-11.8-9.1-14.5zM447.5 256c0-59.3-23.2-114.8-65.4-156.5-4.7-4.7-12.3-4.6-17 .1-4.7 4.7-4.6 12.3.1 17 37.6 37.1 58.2 86.6 58.2 139.4 0 52.8-20.7 102.3-58.2 139.4-4.7 4.7-4.8 12.3-.1 17 2.3 2.4 5.4 3.6 8.5 3.6 3 0 6.1-1.2 8.4-3.5 42.3-41.6 65.5-97.2 65.5-156.5z"}},{"tag":"path","attr":{"d":"M384.9 256c0-43.5-16.6-84.3-46.8-114.9-4.7-4.7-12.3-4.8-17-.1-4.7 4.7-4.8 12.3-.1 17 25.7 26.1 39.9 60.9 39.9 98.1 0 37.2-14.2 72-39.9 98.1-4.7 4.7-4.6 12.3.1 17 2.3 2.3 5.4 3.5 8.4 3.5 3.1 0 6.2-1.2 8.5-3.6 30.2-30.8 46.9-71.6 46.9-115.1z"}},{"tag":"path","attr":{"d":"M287.5 182.5c-4.7-4.7-12.3-4.8-17-.1-4.7 4.7-4.8 12.3-.1 17 14.8 15 23 35.1 23 56.6 0 21.4-8.2 41.5-23 56.6-4.7 4.7-4.6 12.3.1 17 2.3 2.3 5.4 3.5 8.4 3.5 3.1 0 6.2-1.2 8.5-3.6 19.3-19.6 29.9-45.6 29.9-73.4.1-27.9-10.5-54-29.8-73.6z"}}]})(props);
	};
	module.exports.IoIosVolumeHigh.displayName = "IoIosVolumeHigh";
	module.exports.IoIosVolumeLow = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.9 145.6c-2.2-1.1-4.6-1.6-6.9-1.6-3.6 0-7.1 1.2-10 3.5L196.8 200H144c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h52.8l65.2 52.5c2.9 2.3 6.5 3.5 10 3.5 2.3 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V160c0-6.2-3.5-11.8-9.1-14.4zM354.4 182.6c-4.6-4.7-12.1-4.8-16.8-.1-4.7 4.7-4.7 12.3-.1 17 14.7 15 22.8 35.1 22.8 56.6 0 21.4-8.1 41.5-22.8 56.6-4.6 4.7-4.6 12.3.1 17 2.3 2.3 5.3 3.5 8.3 3.5 3.1 0 6.1-1.2 8.5-3.6C373.5 310 384 284 384 256.2h-.2c0-28-10.3-54.1-29.4-73.6z"}}]})(props);
	};
	module.exports.IoIosVolumeLow.displayName = "IoIosVolumeLow";
	module.exports.IoIosVolumeMute = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.9 145.6c-2.2-1.1-4.6-1.6-6.9-1.6-3.6 0-7.1 1.2-10 3.5L244.8 200H192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h52.8l65.2 52.5c2.9 2.3 6.5 3.5 10 3.5 2.3 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V160c0-6.2-3.5-11.8-9.1-14.4z"}}]})(props);
	};
	module.exports.IoIosVolumeMute.displayName = "IoIosVolumeMute";
	module.exports.IoIosVolumeOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M390.1 464c-4.9 0-9.7-2.5-12.3-7L149.7 69.3c-4-6.7-1.7-15.4 5.1-19.3 6.8-3.9 15.5-1.7 19.5 5.1l228.1 387.7c4 6.7 1.7 15.4-5.1 19.3-2.2 1.3-4.7 1.9-7.2 1.9zM133 200H80c-8.9 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h53l65.4 52.5c2.9 2.3 6.5 3.5 10.1 3.5 2.4 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V227.9L184 159.1 133 200zM448 256c0-59.3-23.3-114.9-65.5-156.5-4.7-4.7-12.3-4.6-17 .1-4.7 4.7-4.6 12.3.1 17C403.3 153.7 424 203.2 424 256c0 44.4-14.7 86.4-41.7 120.8l13 22C429.4 359.1 448 309 448 256z"}},{"tag":"path","attr":{"d":"M385.2 256c0-43.5-16.7-84.3-46.9-114.9-4.7-4.7-12.3-4.8-17-.1-4.7 4.7-4.8 12.3-.1 17 25.8 26.1 40 60.9 40 98.1 0 21.6-4.8 42.5-13.9 61.2l14.2 24.1c15.4-25.4 23.7-54.7 23.7-85.4zM317.6 256c0-27.8-10.7-53.9-30-73.4-4.7-4.7-12.3-4.8-17-.1-.6.6-1.1 1.2-1.6 1.9l48.1 81.8c.3-3.4.5-6.8.5-10.2z"}}]})(props);
	};
	module.exports.IoIosVolumeOff.displayName = "IoIosVolumeOff";
	module.exports.IoIosWalk = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.1 361.2l-67.8 48.9c-3.7 3.6-5.2 9.1-5.3 13.9-.1 4.8 1.2 8.8 4.7 12.5 3.6 3.9 8.8 6.2 13.6 6.2 4.5 0 12.5-4.9 16-8.4l69.7-51.6c3.6-3.5 5.7-8.4 5.7-13.5l9.1-52.5-45.7-46.7v91.2z"}},{"tag":"ellipse","attr":{"transform":"rotate(-80.781 274.673 69.329)","cx":"274.7","cy":"69.3","rx":"37.3","ry":"37.3"}},{"tag":"path","attr":{"d":"M350.7 459.2l-15.2-117.4c-.5-3.5-1.9-6.8-4.2-9.5l-57-68.8V143.9c0-11.3-6.3-15.9-18.3-15.9h-37c-2.8 0-5.2 1-7.7 2.3l-68 31.7c-10 5.3-15.3 15.4-15.3 28.7V256c0 10.3 8.2 18.7 18.3 18.7 10.1 0 18.3-8.4 18.3-18.7v-58.2c0-3 1.7-5.8 4.4-7.1l32.2-16.4v75.3c0 4.2 1.6 8.2 4.6 11.2l92.4 94.4c1.2 1.2 2 2.8 2.2 4.5l14.2 104.7c1.3 9.3 9.1 15.7 18.1 15.7h2c9.9-1.5 17.4-10.7 16-20.9z"}},{"tag":"path","attr":{"d":"M378.4 232.4l-95-96.2v52.6l69.2 70.1c7.2 7.3 18.7 7.2 25.9-.1 3.5-3.6 5.5-7.5 5.5-12.2 0-4.8-2-10.5-5.6-14.2z"}}]})(props);
	};
	module.exports.IoIosWalk.displayName = "IoIosWalk";
	module.exports.IoIosWallet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404 160H108c-33.1 0-60 26.9-60 60v168c0 33.1 26.9 60 60 60h296c33.1 0 60-26.9 60-60V220c0-33.1-26.9-60-60-60zM342.9 65L108 110.9c-18 4-44 22.1-44 44.1 0 0 15-19 49-19h287v-20.5c0-12.6-5-28.7-13.9-37.6-11.3-11.3-27.5-16.2-43.2-12.9z"}}]})(props);
	};
	module.exports.IoIosWallet.displayName = "IoIosWallet";
	module.exports.IoIosWarning = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M228.9 79.9L51.8 403.1C40.6 423.3 55.5 448 78.9 448h354.3c23.3 0 38.2-24.7 27.1-44.9L283.1 79.9c-11.7-21.2-42.5-21.2-54.2 0zM273.6 214L270 336h-28l-3.6-122h35.2zM256 402.4c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4 19.1 8.1 19.1 18.4-8.4 18.4-19.1 18.4z"}}]})(props);
	};
	module.exports.IoIosWarning.displayName = "IoIosWarning";
	module.exports.IoIosWatch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.3 161.3c-15-23.9-36.3-43.3-61.4-56.1-1.9-.9-3.9-1.4-6-1.4-5 0-9.5 2.8-11.8 7.2-1.6 3.1-1.9 6.7-.8 10 1.1 3.3 3.4 6.1 6.6 7.7 20.9 10.7 38.6 26.8 51.1 46.7 12.8 20.4 19.6 44 19.6 68v40.5c0 17.2-3.3 33.4-9.9 48-6.3 14-15.4 26.3-27 36.6-23.2 20.5-55.1 31.9-89.9 31.9-34.4 0-43.6-5.2-52.4-10.2-8.1-4.6-17.3-9.8-37.7-11-31.7-2-56.9-12.4-77.2-31.8-2.5-2.4-5.7-3.7-9.1-3.7-3.6 0-7 1.5-9.5 4.1-2.4 2.5-3.7 5.7-3.7 9.1 0 3.6 1.5 7 4.1 9.5 25 23.9 55.7 36.7 93.8 39.1 14.4.9 19.4 3.7 26.4 7.7 11.3 6.4 24.1 13.6 65.4 13.6 41.6 0 80-13.9 108.1-39.2 14.2-12.8 25.3-28 33-45.2 8-18 12.1-37.6 12.1-58.5v-40.5c-.1-29.1-8.3-57.5-23.8-82.1z"}},{"tag":"path","attr":{"d":"M284 383c8.7 1.4 17.2 2.1 25.4 2.1 16 0 31.2-2.7 45-8 13.9-5.4 26.5-13.4 37.5-23.9 5.3-5 5.4-13.4.4-18.6-2.5-2.6-5.9-4.1-9.5-4.1-3.4 0-6.7 1.3-9.1 3.7-17.1 16.3-38.8 24.6-64.5 24.6-6.8 0-13.8-.6-21-1.8-.7-.1-1.4-.2-2.1-.2-6.5 0-12 4.6-13 11-.1.7-.2 1.4-.2 2.1 0 6.6 4.7 12 11.1 13.1zm2.1-21.1h.1-.3.2zM222.9 421.7c-39.9 0-72.8-13.4-102.7-40.3-29.1-26.2-45.8-60.7-45.8-94.5v-43.6c0-24.1 6.8-47.6 19.6-68 12.5-19.9 30.2-36 51.1-46.7 3.1-1.6 5.5-4.3 6.6-7.7 1.1-3.3.8-6.9-.8-10.1-2.3-4.4-6.8-7.2-11.8-7.2-2.1 0-4.1.5-6 1.4-25.1 12.8-46.4 32.2-61.4 56.1-15.5 24.6-23.7 53-23.7 82v43.6c0 41.2 19.9 82.8 54.5 114 34.6 31.2 74 47.1 120.4 47.1 7.3 0 13.2-5.9 13.2-13.2-.1-7-6-12.9-13.2-12.9z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M348.4 115.1c.8-11.9 10.3-21.6 22.2-22.6 4.3-.4 8.4.4 12 2 2.6 1.1 5.1-1.6 3.9-4.1-2.7-5.7-6.6-10.9-11.5-15.1C366.6 68 355.9 64 344.8 64H167.2c-17.9 0-33.9 10.3-41.5 25.8-1.2 2.5 1.2 5.2 3.9 4.2 3.3-1.3 7-1.8 10.8-1.5 11.9 1 21.4 10.8 22.2 22.7.8 13.6-9.5 25-22.8 25.8-.9.1-1.8.7-2.1 1.5-.4 1.1-.1 2.3.8 3 8.1 6.2 18.1 9.7 28.7 9.7h177.6c10.9 0 21.2-3.6 29.4-10.2 1.7-1.3.7-4-1.4-4h-.1c-14 0-25.2-11.7-24.3-25.9zm-21.6-10.3c3.5 15.8-10.7 30-26.5 26.5-8.4-1.9-15.2-8.6-17-17-3.5-15.8 10.7-30 26.5-26.5 8.4 1.9 15.2 8.6 17 17z"}}]}]})(props);
	};
	module.exports.IoIosWatch.displayName = "IoIosWatch";
	module.exports.IoIosWater = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 146.4c-34.4-48.6-67.5-78.5-90.8-96.6-3.1-2.4-7.3-2.4-10.4-.1-23 17.1-56.1 48.4-90.5 96.5-37.3 52-63 108.4-64.2 170.9 0 1.2-.1 2.5-.1 3.7 0 18.4 3.9 35.9 10.9 52.1 4.1 9.3 9.2 18.1 15.2 26.3 28.5 39 77.8 64.8 133.8 64.8 88.4 0 160.1-64.1 160.1-143.2 0-63.7-27-122.2-64-174.4zm-86 264.3h-.5c-9.9 0-12-14.1-2.6-17.1 45.1-14.2 69.6-38.5 86.4-80.8 3.5-8.9 16.7-6.5 16.8 3.1v1.4c-.1 51.6-44.9 93.4-100.1 93.4z"}}]})(props);
	};
	module.exports.IoIosWater.displayName = "IoIosWater";
	module.exports.IoIosWifi = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96c-81.5 0-163 33.6-221.5 88.3-3.3 3-3.4 8.1-.3 11.4l26.7 27.9c3.1 3.3 8.3 3.4 11.6.3 23.3-21.6 49.9-38.8 79.3-51 33-13.8 68.1-20.7 104.3-20.7s71.3 7 104.3 20.7c29.4 12.3 56 29.4 79.3 51 3.3 3.1 8.5 3 11.6-.3l26.7-27.9c3.1-3.2 3-8.3-.3-11.4C419 129.6 337.5 96 256 96z"}},{"tag":"path","attr":{"d":"M113.2 277.5l28.6 28.3c3.1 3 8 3.2 11.2.3 28.3-25.1 64.6-38.9 102.9-38.9s74.6 13.7 102.9 38.9c3.2 2.9 8.1 2.7 11.2-.3l28.6-28.3c3.3-3.3 3.2-8.6-.3-11.7-37.5-33.9-87.6-54.6-142.5-54.6s-105 20.7-142.5 54.6c-3.3 3.1-3.4 8.4-.1 11.7zM256 324.2c-23.4 0-44.6 9.8-59.4 25.5-3 3.2-2.9 8.1.2 11.2l53.4 52.7c3.2 3.2 8.4 3.2 11.6 0l53.4-52.7c3.1-3.1 3.2-8 .2-11.2-14.8-15.6-36-25.5-59.4-25.5z"}}]})(props);
	};
	module.exports.IoIosWifi.displayName = "IoIosWifi";
	module.exports.IoIosWine = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M328.9 51.2c-2-5.5-7-9.2-12.9-9.2H196c-6 0-10.9 3.7-13 9.2-9.3 25-31 87.1-31 124.8v4.8c0 19.2 0 45.4 28.4 74.5 6.5 6.7 14.3 12.9 22.5 19.5 19.1 15.3 38.8 31.1 38.8 50.2v115c0 1.1-.9 2-2 2h-57.1c-7.9 0-14.3 6.3-14.3 14s6.4 14 14.3 14h146.8c7.9 0 14.3-6.3 14.3-14s-6.4-14-14.3-14h-57.1c-1.1 0-2-.9-2-2V325c0-19.1 19.7-34.9 38.8-50.2 8.2-6.6 15.9-12.8 22.5-19.5C360 226.2 360 200 360 180.8V176c0-37.5-21.7-99.8-31.1-124.8zm-1.4 102.1c-.2.3-.7.7-1.6.7H186.1c-.8 0-1.3-.5-1.6-.7-.2-.3-.6-.8-.4-1.7 5.1-26.1 14.8-59.6 21.6-80.2.3-.8 1.1-1.4 1.9-1.4h96.8c.9 0 1.7.6 1.9 1.4 6.7 20.7 16.4 54.1 21.6 80.2.2.8-.2 1.4-.4 1.7z"}}]})(props);
	};
	module.exports.IoIosWine.displayName = "IoIosWine";
	module.exports.IoIosWoman = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M286 496c-6.1 0-11.8-2.3-16-6.6-3.2-3.3-7.1-9.1-7.1-18.6V351.4H249v119.4c0 9.5-4 15.4-7.4 18.7-4.3 4.2-10.1 6.5-16.3 6.5-6.2 0-11.9-2.3-16.3-6.5-3.4-3.3-7.4-9.1-7.4-18.7V351.4h-43.9l44.5-170.6h-6.8L171 271.2c-4 13.1-13.7 17.8-21.4 17.8-6.6 0-12.9-3.2-17-8.7-4.8-6.4-6.1-14.9-3.6-23.9l29-104.1c4.2-15.2 20.7-38.2 48.7-39.3H305.1c28.4 1.2 44.1 26 48.5 38.9l.1.4 29 104.3c2.4 9 1 17.6-3.9 24-4.1 5.4-10.4 8.6-16.9 8.6-7.7 0-17.3-4.8-21.3-18.1v-.2l-24.3-90.1h-7.7l45.5 170.6H309v119.4c0 9.5-3.9 15.3-7.1 18.6-4.2 4.3-9.8 6.6-15.9 6.6zM255.9 106.4c-24.2 0-43.9-20.3-43.9-45.2S231.7 16 255.9 16s43.9 20.3 43.9 45.2-19.7 45.2-43.9 45.2z"}}]})(props);
	};
	module.exports.IoIosWoman.displayName = "IoIosWoman";
	module.exports.IoLogoAndroid = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 268.4V358c0 6.9 4.5 14 11.4 14H184v52c0 13.3 10.7 24 24 24s24-10.7 24-24v-52h49v52c0 7.5 3.4 14.2 8.8 18.6 3.9 3.4 9.1 5.4 14.7 5.4h.5c13.3 0 24-10.7 24-24v-52h27.6c7 0 11.4-7.1 11.4-13.9V192H144v76.4zM408 176c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24zM104 176c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M311.2 89.1l18.5-21.9c.4-.5-.2-1.6-1.3-2.5-1.1-.8-2.4-1-2.7-.4l-19.2 22.8c-13.6-5.4-30.2-8.8-50.6-8.8-20.5-.1-37.2 3.2-50.8 8.5l-19-22.4c-.4-.5-1.6-.4-2.7.4s-1.7 1.8-1.3 2.5l18.3 21.6c-48.2 20.9-55.4 72.2-56.4 87.2h223.6c-.9-15.1-8-65.7-56.4-87zm-104.4 49.8c-7.4 0-13.5-6-13.5-13.3 0-7.3 6-13.3 13.5-13.3 7.4 0 13.5 6 13.5 13.3 0 7.3-6 13.3-13.5 13.3zm98.4 0c-7.4 0-13.5-6-13.5-13.3 0-7.3 6-13.3 13.5-13.3 7.4 0 13.5 6 13.5 13.3 0 7.3-6.1 13.3-13.5 13.3z"}}]}]})(props);
	};
	module.exports.IoLogoAndroid.displayName = "IoLogoAndroid";
	module.exports.IoLogoAngular = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.573 256h84.846l-42.427-89.356z"}},{"tag":"path","attr":{"d":"M255.981 32L32 112l46.12 272L256 480l177.75-96L480 112 255.981 32zM344 352l-26.589-56H194.584L168 352h-40L256 72l128 280h-40z"}}]})(props);
	};
	module.exports.IoLogoAngular.displayName = "IoLogoAngular";
	module.exports.IoLogoApple = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M333.6 153.9c-33.6 0-47.8 16.5-71.2 16.5-24 0-42.3-16.4-71.4-16.4-28.5 0-58.9 17.9-78.2 48.4-27.1 43-22.5 124 21.4 193 15.7 24.7 36.7 52.4 64.2 52.7h.5c23.9 0 31-16.1 63.9-16.3h.5c32.4 0 38.9 16.2 62.7 16.2h.5c27.5-.3 49.6-31 65.3-55.6 11.3-17.7 15.5-26.6 24.2-46.6-63.5-24.8-73.7-117.4-10.9-152.9-19.2-24.7-46.1-39-71.5-39z"}},{"tag":"path","attr":{"d":"M326.2 64c-20 1.4-43.3 14.5-57 31.6-12.4 15.5-22.6 38.5-18.6 60.8h1.6c21.3 0 43.1-13.2 55.8-30.1 12.3-16.1 21.6-38.9 18.2-62.3z"}}]})(props);
	};
	module.exports.IoLogoApple.displayName = "IoLogoApple";
	module.exports.IoLogoBitbucket = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M452.9 64.2c-.7-.1-1.5-.2-2.2-.2H61.5c-7.4-.1-13.4 5.9-13.5 13.5 0 .8 0 1.6.2 2.4l56.6 352.5c.7 4.3 2.9 8.2 6.1 11.1 3.2 2.9 7.4 4.5 11.7 4.5H394c6.6.1 12.3-4.8 13.3-11.5L441 224H316l-16 96h-88l-22.3-126.9h256.2l18-113.1c1.1-7.5-3.8-14.6-11-15.8z"}}]})(props);
	};
	module.exports.IoLogoBitbucket.displayName = "IoLogoBitbucket";
	module.exports.IoLogoBitcoin = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.5 279.2c-5-11.5-12.7-21.6-28.1-30.1-8.2-4.5-16.1-7.8-25.4-10 5.4-2.5 10-5.4 16.3-11 7.5-6.6 13.1-15.7 15.6-23.3 2.6-7.5 4.1-18 3.5-28.2-1.1-16.8-4.4-33.1-13.2-44.8-8.8-11.7-21.2-20.7-37.6-27-12.6-4.8-25.5-7.8-45.5-8.9V32h-40v64h-32V32h-41v64H96v48h27.9c8.7 0 14.6.8 17.6 2.3 3.1 1.5 5.3 3.5 6.5 6 1.3 2.5 1.9 8.4 1.9 17.5V343c0 9-.6 14.8-1.9 17.4-1.3 2.6-2 4.9-5.1 6.3-3.1 1.4-3.2 1.3-11.8 1.3h-26.4L96 416h87v64h41v-64h32v64h40v-64.4c26-1.3 44.5-4.7 59.4-10.3 19.3-7.2 34.1-17.7 44.7-31.5 10.6-13.8 14.9-34.9 15.8-51.2.7-14.5-.9-33.2-5.4-43.4zM224 150h32v74h-32v-74zm0 212v-90h32v90h-32zm72-208.1c6 2.5 9.9 7.5 13.8 12.7 4.3 5.7 6.5 13.3 6.5 21.4 0 7.8-2.9 14.5-7.5 20.5-3.8 4.9-6.8 8.3-12.8 11.1v-65.7zm28.8 186.7c-7.8 6.9-12.3 10.1-22.1 13.8-2 .8-4.7 1.4-6.7 1.9v-82.8c5 .8 7.6 1.8 11.3 3.4 7.8 3.3 15.2 6.9 19.8 13.2 4.6 6.3 8 15.6 8 24.7 0 10.9-2.8 19.2-10.3 25.8z"}}]})(props);
	};
	module.exports.IoLogoBitcoin.displayName = "IoLogoBitcoin";
	module.exports.IoLogoBuffer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M70.7 164.5l169.2 81.7c4.4 2.1 10.3 3.2 16.1 3.2s11.7-1.1 16.1-3.2l169.2-81.7c8.9-4.3 8.9-11.3 0-15.6L272.1 67.2c-4.4-2.1-10.3-3.2-16.1-3.2s-11.7 1.1-16.1 3.2L70.7 148.9c-8.9 4.3-8.9 11.3 0 15.6z"}},{"tag":"path","attr":{"d":"M441.3 248.2s-30.9-14.9-35-16.9-5.2-1.9-9.5.1S272 291.6 272 291.6c-4.5 2.1-10.3 3.2-16.1 3.2s-11.7-1.1-16.1-3.2c0 0-117.3-56.6-122.8-59.3-6-2.9-7.7-2.9-13.1-.3l-33.4 16.1c-8.9 4.3-8.9 11.3 0 15.6l169.2 81.7c4.4 2.1 10.3 3.2 16.1 3.2s11.7-1.1 16.1-3.2l169.2-81.7c9.1-4.2 9.1-11.2.2-15.5z"}},{"tag":"path","attr":{"d":"M441.3 347.5s-30.9-14.9-35-16.9-5.2-1.9-9.5.1S272.1 391 272.1 391c-4.5 2.1-10.3 3.2-16.1 3.2s-11.7-1.1-16.1-3.2c0 0-117.3-56.6-122.8-59.3-6-2.9-7.7-2.9-13.1-.3l-33.4 16.1c-8.9 4.3-8.9 11.3 0 15.6l169.2 81.7c4.4 2.2 10.3 3.2 16.1 3.2s11.7-1.1 16.1-3.2l169.2-81.7c9-4.3 9-11.3.1-15.6z"}}]})(props);
	};
	module.exports.IoLogoBuffer.displayName = "IoLogoBuffer";
	module.exports.IoLogoChrome = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M188.8 255.925c0 36.946 30.243 67.178 67.2 67.178s67.199-30.231 67.199-67.178c0-36.945-30.242-67.179-67.199-67.179s-67.2 30.234-67.2 67.179z"}},{"tag":"path","attr":{"d":"M476.752 217.795c-.009.005-.016.038-.024.042-1.701-9.877-4.04-19.838-6.989-28.838h-.107c2.983 9 5.352 19 7.072 29h-.002c-1.719-10-4.088-20-7.07-29h-155.39c19.044 17 31.358 40.175 31.358 67.052 0 16.796-4.484 31.284-12.314 44.724L231.044 478.452s-.009.264-.014.264l-.01.284h.015l-.005-.262c8.203.92 16.531 1.262 24.97 1.262 6.842 0 13.609-.393 20.299-1.002a223.86 223.86 0 0 0 29.777-4.733C405.68 451.525 480 362.404 480 255.941c0-12.999-1.121-25.753-3.248-38.146z"}},{"tag":"path","attr":{"d":"M256 345.496c-33.601 0-61.601-17.91-77.285-44.785L76.006 123.047l-.137-.236a223.516 223.516 0 0 0-25.903 45.123C38.407 194.945 32 224.686 32 255.925c0 62.695 25.784 119.36 67.316 160.009 29.342 28.719 66.545 49.433 108.088 58.619l.029-.051 77.683-134.604c-8.959 3.358-19.031 5.598-29.116 5.598z"}},{"tag":"path","attr":{"d":"M91.292 104.575l77.35 133.25C176.483 197.513 212.315 166 256 166h205.172c-6.921-15-15.594-30.324-25.779-43.938.039.021.078.053.117.074C445.644 135.712 454.278 151 461.172 166h.172c-6.884-15-15.514-30.38-25.668-43.99-.115-.06-.229-.168-.342-.257C394.475 67.267 329.359 32 256 32c-26.372 0-51.673 4.569-75.172 12.936-34.615 12.327-65.303 32.917-89.687 59.406l.142.243.009-.01z"}}]})(props);
	};
	module.exports.IoLogoChrome.displayName = "IoLogoChrome";
	module.exports.IoLogoClosedCaptioning = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96v320h448V96H32zm406 159.8c0 23.4-1.4 41.2-3.3 70.2s-16.8 49.4-51.7 52.6c-34.9 3.2-83.8 3.5-127 3.4-42.9.1-92-.1-127-3.4-34.9-3.2-49.7-23.6-51.7-52.6S74 279.2 74 255.8c0-23.4.1-38.6 3.3-70.2s20.1-49.2 51.7-52.4 86-3.2 127-3.2 95.4 0 127 3.2c31.6 3.2 48.5 20.9 51.7 52.4 3.2 31.6 3.3 46.9 3.3 70.2z"}},{"tag":"path","attr":{"d":"M357.5 280.4v.7c0 16.3-10.1 25.9-23.6 25.9-13.5 0-22.6-10.8-23.9-25.9 0 0-1.2-7.9-1.2-23.9s1.4-26 1.4-26c2.4-17 10.7-25.9 24.2-25.9 13.4 0 24.1 11.6 24.1 29.2v.5h45.1c0-21.9-5.5-41.6-16.6-54-11-12.4-27.5-18.6-49.3-18.6-10.9 0-20.9 1.4-30 4.3-9.1 2.9-17 7.9-23.6 15.1-6.6 7.2-11.7 16.8-15.4 28.9-3.6 12.1-5.5 27.3-5.5 45.7 0 18 1.5 33 4.4 45.1 3 12.1 7.3 21.7 13.1 28.9 5.8 7.2 13.1 12.2 21.8 15 8.8 2.8 19.1 4.2 30.9 4.2 25 0 43-6.4 53.8-18.7 10.8-12.3 16.2-30.3 16.2-53.9h-46.1c.2 0 .2 2.5.2 3.4zM202.6 280.4v.7c0 16.3-10.1 25.9-23.6 25.9-13.5 0-22.6-10.8-23.9-25.9 0 0-1.2-7.9-1.2-23.9s1.4-26 1.4-26c2.4-17 10.7-25.9 24.2-25.9 13.4 0 24.1 11.6 24.1 29.2v.5h45.1c0-21.9-5.5-41.6-16.6-54-11-12.4-27.5-18.6-49.3-18.6-10.9 0-20.9 1.4-30 4.3-9.1 2.9-17 7.9-23.6 15.1-6.6 7.2-11.7 16.8-15.4 28.9-3.6 12.1-5.5 27.3-5.5 45.7 0 18 1.5 33 4.4 45.1 3 12.1 7.3 21.7 13.1 28.9 5.8 7.2 13.1 12.2 21.8 15 8.8 2.8 19.1 4.2 30.9 4.2 25 0 43-6.4 53.8-18.7 10.8-12.3 16.2-30.3 16.2-53.9h-46.1c.2 0 .2 2.5.2 3.4z"}}]})(props);
	};
	module.exports.IoLogoClosedCaptioning.displayName = "IoLogoClosedCaptioning";
	module.exports.IoLogoCodepen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M241.239 303.936c-15.322-10.357-30.742-20.569-46.062-30.93-2.03-1.373-3.43-1.472-5.502-.029l-38.871 26.154C181.966 319.905 244 361.317 244 361.317v-53.786c-.012-1.224-1.553-2.78-2.761-3.595zM195.092 240.666c15.454-10.16 30.851-20.409 46.109-30.86 1.486-1.018 2.775-3.509 2.799-5.334v-51.706s-62.033 41.124-93.262 61.942c13.7 9.159 26.671 17.913 39.787 26.443 1.02.662 3.396.284 4.567-.485zM269.838 209.354a4521.517 4521.517 0 0 0 47.627 31.815c.916.604 2.92.602 3.839 0l39.751-26.467L268 152.484v53.35c.01 1.201.805 2.821 1.838 3.52zM258.109 230.369c-1.21-.802-3.611-.528-4.743.168-4.817 2.962-9.463 6.203-14.164 9.355-8.248 5.53-25.356 17.023-25.356 17.023l38.842 25.865c1.748 1.157 4.436 1.22 6.26.111l39.014-25.993c.001 0-34.079-22.701-39.853-26.529zM141 237.116v39.609l29.622-19.838z"}},{"tag":"path","attr":{"d":"M256 32C132.288 32 32 132.288 32 256s100.288 224 224 224 224-100.288 224-224S379.712 32 256 32zm139 265.006c0 5.785-2.652 9.868-7.511 13.094a38019.909 38019.909 0 0 0-123.286 82.188c-5.854 3.918-11.174 3.754-16.984-.137-40.783-27.314-81.719-54.546-122.625-81.676-5.11-3.389-7.594-7.557-7.594-13.73v-79.729c0-6.141 2.521-10.332 7.624-13.716 40.906-27.13 81.939-54.363 122.724-81.676 5.818-3.896 11.094-4.007 16.938-.095a41090.004 41090.004 0 0 0 123.261 82.195c4.678 3.106 7.453 6.943 7.453 12.66v80.622z"}},{"tag":"path","attr":{"d":"M316.247 273.234a3826.352 3826.352 0 0 1-45.386 30.332c-2.412 1.588-2.888 3.318-2.861 6.189v51.346l93.039-62.004-38.527-25.882c-2.345-1.604-3.93-1.567-6.265.019zM370 276.676V237.06l-29.59 19.873z"}}]})(props);
	};
	module.exports.IoLogoCodepen.displayName = "IoLogoCodepen";
	module.exports.IoLogoCss3 = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.282 339.488zM64 32l34.946 403.219L255.767 480l157.259-44.85L448 32H64zm290.676 334.898l-98.607 28.125-98.458-28.248L150.864 289h48.253l3.433 39.562 53.586 15.163.132.273h.034l53.467-14.852L315.381 265H203l-4-50h120.646l4.396-51H140l-4-49h240.58l-21.904 251.898z"}}]})(props);
	};
	module.exports.IoLogoCss3.displayName = "IoLogoCss3";
	module.exports.IoLogoDesignernews = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.4 145L227 96l63.6 102.2z"}},{"tag":"path","attr":{"d":"M329 96v163h-36.4l-63.2-98.6 1.7 98.6H191V152l-37.3-29.3c1 1.2 2 2.4 2.9 3.7 10 13.9 15 30.5 15 50.5 0 49.2-30.6 82.1-76.9 82.1H32v.4L231.6 416H480V214.1L329 96z"}},{"tag":"path","attr":{"d":"M129.9 178.1c0-29-14.2-45.1-39.7-45.1H71v89h19c26 0 39.9-15.4 39.9-43.9z"}}]})(props);
	};
	module.exports.IoLogoDesignernews.displayName = "IoLogoDesignernews";
	module.exports.IoLogoDribbble = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150 64 64 150 64 256c0 106.1 86 192 192 192s192-85.9 192-192c0-106-86-192-192-192zm121.9 88.5c21.6 25.4 35.3 57.6 37.7 92.9-34.6-1.8-76-1.8-109.2 1.3-4.2-10.6-8.5-21-13.2-31 38.3-16.6 67.8-38.4 84.7-63.2zM256 96c38.8 0 74.4 13.8 102.1 36.8-17.4 22-44.7 41.1-78.7 55.6-18.6-34.4-40-64-62.8-87.3 12.7-3.2 25.8-5.1 39.4-5.1zm-72.4 17.5c23.1 23 44.8 52.3 63.8 86.6-36.1 11-77.5 17.3-121.7 17.3-8.4 0-16.6-.3-24.7-.8 11.5-45.1 42-82.5 82.6-103.1zM96.3 248.4c9.1.4 18.3.6 27.6.5 50.4-.6 97.3-8.5 137.6-21.4 3.8 7.9 7.4 16 10.8 24.3-5.5 1.3-10.4 2.7-14.3 4.3-55.1 23.1-98.5 60.4-122 105.5-24.8-28.2-40-65.1-40-105.6 0-2.6.1-5.1.3-7.6zM256 416c-37 0-71-12.6-98.1-33.7 21.3-42.2 59.3-77.1 107.2-98.8 4.5-2.1 10.5-3.8 17.4-5.3 5.7 15.8 10.8 32.2 15.3 49.2 6.9 26.5 11.8 52.7 14.8 78.1C295 412.2 276 416 256 416zm86.5-25.5c-3-25.7-7.9-52.1-14.9-78.9-3.4-13-7.3-25.6-11.5-37.9 31.4-2.6 69-2.2 98.9 0-5.4 49.1-33 91.3-72.5 116.8z"}}]})(props);
	};
	module.exports.IoLogoDribbble.displayName = "IoLogoDribbble";
	module.exports.IoLogoDropbox = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M177 77L64 150.9l78.1 62.7L256 143.1zM64 276.3l113 73.9 79-66.1-113.9-70.5zM256 284.1l79 66.1 113-73.9-78.1-62.7zM448 150.9L335 77l-79 66.1 113.9 70.5z"}},{"tag":"path","attr":{"d":"M256.2 298.3l-79.8 66-34.4-22.2V367l114 68 114-68v-24.9l-34.2 22.2z"}}]})(props);
	};
	module.exports.IoLogoDropbox.displayName = "IoLogoDropbox";
	module.exports.IoLogoEuro = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234 272v-48h131.094l7.149-48H234v-1.83c0-35.92 14.975-58.086 79.25-58.086 26.264 0 55.867 2.498 93.189 8.742L416 59.866C377.988 51.123 345.306 48 310.057 48 195.326 48 146 89.225 146 165.43V176H96v48h50v48H96v48h50v26.57C146 422.774 195.297 464 310.027 464c35.25 0 67.848-3.123 105.859-11.866l-9.619-64.96c-37.322 6.244-66.781 8.742-93.045 8.742-64.276 0-79.223-18.739-79.223-63.086V320h116.795l7.148-48H234z"}}]})(props);
	};
	module.exports.IoLogoEuro.displayName = "IoLogoEuro";
	module.exports.IoLogoFacebook = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.8 64H85.2C73.5 64 64 73.5 64 85.2v341.6c0 11.7 9.5 21.2 21.2 21.2H256V296h-45.9v-56H256v-41.4c0-49.6 34.4-76.6 78.7-76.6 21.2 0 44 1.6 49.3 2.3v51.8h-35.3c-24.1 0-28.7 11.4-28.7 28.2V240h57.4l-7.5 56H320v152h106.8c11.7 0 21.2-9.5 21.2-21.2V85.2c0-11.7-9.5-21.2-21.2-21.2z"}}]})(props);
	};
	module.exports.IoLogoFacebook.displayName = "IoLogoFacebook";
	module.exports.IoLogoFlickr = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 64H160c-52.8 0-96 43.2-96 96v192c0 52.8 43.2 96 96 96h192c52.8 0 96-43.2 96-96V160c0-52.8-43.2-96-96-96zM184 304c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
	};
	module.exports.IoLogoFlickr.displayName = "IoLogoFlickr";
	module.exports.IoLogoFoursquare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.764 32H138.541C105.666 32 96 56.798 96 72.414v379.64c0 17.591 9.425 24.117 14.718 26.267 5.299 2.155 19.916 3.971 28.673-6.168 0 0 112.469-130.895 114.4-132.834 2.921-2.93 2.921-2.93 5.844-2.93h72.767c30.574 0 35.49-21.869 38.684-34.752 2.659-10.789 32.489-163.962 42.452-212.559C421.143 51.993 411.745 32 376.764 32zm-5.678 269.637c2.659-10.789 32.489-163.962 42.452-212.559m-50.846 7.592l-9.999 51.734c-1.195 5.65-8.287 11.595-14.863 11.595h-95.917C231.473 160 224 166.138 224 176.602v13.448c0 10.473 7.519 17.894 17.965 17.894h81.848c7.374 0 14.61 8.109 13.016 16.005-1.602 7.908-9.086 46.569-9.984 50.89-.902 4.328-5.845 11.725-14.611 11.725h-64.269c-11.705 0-15.244 1.533-23.074 11.293-7.837 9.77-78.256 94.592-78.256 94.592-.713.822-1.41.584-1.41-.312V95.896c0-6.684 5.793-14.523 14.479-14.523h191.173c7.035-.001 13.611 6.631 11.815 15.297z"}}]})(props);
	};
	module.exports.IoLogoFoursquare.displayName = "IoLogoFoursquare";
	module.exports.IoLogoFreebsdDevil = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.6 115c-22.5-43.7-58-51-58-51s15.5 32 16 51c.4 16.1-5.5 28-27.2 33.5s-30.8-2-47.8-17.5-41.6-26.5-72.6-28c-40-2-77 9-77 9-20-25 20-80 20-80-74.5 29.5-93.7 83.3-96 113.7-1.9 24.1 8.5 40.8 8.5 40.8s-.5 27.8-5 42c-3.1 9.8-16.9 25-26 34.5-12.2 12.7-12.5 38.5 0 57s44 27.5 67 39.5 31.5 21 31.5 21 1 8.3.5 15.3-3.2 14-9 18.2c-5.5 3.9-15.5.5-20.5-2s-5-6.2-10.5-8-7.3-4-6.5-11 2-9-3.5-18.5-18.5-9.5-29.5-8-17.3 6.8-17.3 6.8l-16.3-10s8.5-15.6 5.2-35.6c-7.3-43.8-50-62.8-50-62.8L89 309.3s1.1-2.6 6.4-6.4 8.1-3.6 8.1-3.6 6.6 7.6 9.1 25.3c2.5 18-6.7 27.2-6.7 27.2l-28.3-18 1-14.5L39.8 309 56 345.7l15-4 24 22.7s-15.7 11.7-33 11.7c-11 0-22-6-22-6s-1.4-1-.8-5.5c.7-5 6.8-12.5 6.8-12.5H0s27.3 38.7 65 38.7c31 0 44.2-12.5 44.2-12.5L128 397s3 5.5 0 7-7 3.5-9 15 18 29 18 29c21.8 17.8 7 32 7 32h272c-9-13-22.5-18-32-32 0 0-44.8-58.4-1.8-90.4 57.4-42.7 42.8-69.4 41.2-101.4 0 0 31.8-6.6 59.3-33.6s38.9-70.8 19.9-107.6zM195 203c-16.9 4.5-22.5 35.5-22.5 35.5 1.5-63 57.5-93 65-89s-6.5 39-21 64c0 0-8-14.1-21.5-10.5zm37 15s18-56 37.5-59.5 41.5 21 41.5 62-26 65.4-42.8 69.2c-16.5 3.8-23 2-23 2s27.5-21.6 23.5-56.8c-2.8-24.7-31.4-24.2-36.7-16.9z"}}]})(props);
	};
	module.exports.IoLogoFreebsdDevil.displayName = "IoLogoFreebsdDevil";
	module.exports.IoLogoGameControllerA = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.3 146H142.7C81.5 146 32 191.5 32 255.4c0 64 49.5 110.6 110.7 110.6h226.5c61.2 0 110.7-46.6 110.7-110.6.1-63.9-49.4-109.4-110.6-109.4zM200 266.7c0 2.7-2.4 5.3-5.2 5.3H160v35.1c0 2.8-3.1 4.9-5.8 4.9h-21.4c-2.6 0-4.8-1.9-4.8-4.5V272H92.9c-2.8 0-4.9-3.1-4.9-5.8v-21.4c0-2.6 1.9-4.8 4.5-4.8H128v-34.8c0-2.8 1.9-5.2 4.6-5.2h22.1c2.7 0 5.3 2.4 5.3 5.2V240h34.8c2.8 0 5.2 1.9 5.2 4.6v22.1zm119.8 8.8c-10.7 0-19.5-8.6-19.5-19.2s8.7-19.2 19.5-19.2 19.5 8.6 19.5 19.2-8.8 19.2-19.5 19.2zm42.5 41.8c-10.7 0-19.5-8.5-19.5-19.1 0-10.6 8.7-19.2 19.5-19.2s19.5 8.5 19.5 19.2c0 10.6-8.7 19.1-19.5 19.1zm0-83.7c-10.7 0-19.5-8.6-19.5-19.1 0-10.6 8.7-19.2 19.5-19.2s19.5 8.6 19.5 19.2c0 10.5-8.7 19.1-19.5 19.1zm42.6 41.9c-10.7 0-19.4-8.6-19.4-19.2s8.7-19.2 19.4-19.2 19.5 8.6 19.5 19.2c-.1 10.6-8.8 19.2-19.5 19.2z"}}]})(props);
	};
	module.exports.IoLogoGameControllerA.displayName = "IoLogoGameControllerA";
	module.exports.IoLogoGameControllerB = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M135.1 204.6c-10.7 0-19.3 8.7-19.3 19.4s8.7 19.4 19.3 19.4c10.6 0 19.3-8.7 19.3-19.4s-8.6-19.4-19.3-19.4z"}},{"tag":"path","attr":{"d":"M466.3 248.9c-21.2-88.5-43.6-135.5-88.5-148.8-9.8-2.9-18.1-4-25.7-4-27.6 0-46.9 14.7-96.1 14.7-49.2 0-68.5-14.7-96.1-14.7-7.7 0-16 1.1-25.7 4-44.9 13.3-67.3 60.4-88.5 148.8-21.2 88.5-17.3 152.4 7.7 164.3 4.1 1.9 8.2 2.8 12.5 2.8 21.7 0 45.1-23.8 67.7-52 25.7-32.1 32.1-33 110.3-33h24.3c78.1 0 84.6.8 110.3 33 22.5 28.2 46 52 67.7 52 4.2 0 8.4-.9 12.5-2.8 24.9-12 28.7-75.9 7.6-164.3zm-331.1 14.7c-21.6 0-39.2-17.8-39.2-39.6s17.6-39.6 39.2-39.6c21.7 0 39.2 17.8 39.2 39.6.1 21.9-17.5 39.6-39.2 39.6zm172.9-19.5c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1zM352 288c-11.1 0-20.1-9-20.1-20 0-11.2 9-20.1 20.1-20.1 11.1 0 20.1 8.9 20.1 20.1 0 11-9 20-20.1 20zm0-87.8c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1zm43.9 43.9c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1z"}}]})(props);
	};
	module.exports.IoLogoGameControllerB.displayName = "IoLogoGameControllerB";
	module.exports.IoLogoGithub = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9 1.4.3 2.6.4 3.8.4 8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1-8.4 1.9-15.9 2.7-22.6 2.7-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1 10.5 0 20-3.4 25.6-6 2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8 0 0 1.6-.5 5-.5 8.1 0 26.4 3.1 56.6 24.1 17.9-5.1 37-7.6 56.1-7.7 19 .1 38.2 2.6 56.1 7.7 30.2-21 48.5-24.1 56.6-24.1 3.4 0 5 .5 5 .5 12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5 1.2 0 2.6-.1 4-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"}}]})(props);
	};
	module.exports.IoLogoGithub.displayName = "IoLogoGithub";
	module.exports.IoLogoGoogle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M457.6 224l-2.1-8.9H262V297h115.6c-12 57-67.7 87-113.2 87-33.1 0-68-13.9-91.1-36.3-23.7-23-38.8-56.9-38.8-91.8 0-34.5 15.5-69 38.1-91.7 22.5-22.6 56.6-35.4 90.5-35.4 38.8 0 66.6 20.6 77 30l58.2-57.9c-17.1-15-64-52.8-137.1-52.8-56.4 0-110.5 21.6-150 61C72.2 147.9 52 204 52 256s19.1 105.4 56.9 144.5c40.4 41.7 97.6 63.5 156.5 63.5 53.6 0 104.4-21 140.6-59.1 35.6-37.5 54-89.4 54-143.8 0-22.9-2.3-36.5-2.4-37.1z"}}]})(props);
	};
	module.exports.IoLogoGoogle.displayName = "IoLogoGoogle";
	module.exports.IoLogoGoogleplus = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M318.2 230.9l-1.6-7H160V288h90.7c-9.4 45-48.4 63.6-84.1 63.6-26 0-50.2-7.8-68.3-25.3-18.6-18.1-28.9-43.1-28.9-70.4 0-27.1 9.8-51.8 27.6-69.6 17.7-17.7 42-25.4 68.7-25.4 30.5 0 49.9 13.8 58.1 21.1l48-47.7C258.3 122.6 221.5 93 164.1 93c-44.3 0-86.7 16.8-117.7 47.8C15.9 171.3 0 215.2 0 256s15 82.6 44.6 113.3C76.3 402 121.2 419 167.5 419c42.1 0 81.9-16.5 110.3-46.3 28-29.4 42.4-70.1 42.4-112.7-.1-18-1.9-28.7-2-29.1zM512 224h-57v-57h-41v57h-57v41h57v57h41v-57h57z"}}]})(props);
	};
	module.exports.IoLogoGoogleplus.displayName = "IoLogoGoogleplus";
	module.exports.IoLogoHackernews = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 64v384h384V64H64zm214 215v72h-40v-72l-66-120h47.1l39.7 83.6 38-83.6H342l-64 120z"}}]})(props);
	};
	module.exports.IoLogoHackernews.displayName = "IoLogoHackernews";
	module.exports.IoLogoHtml5 = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32l34.936 403.213L255.769 480l157.245-44.854L448 32H64zm307.997 132h-184l3.991 51h176.008l-13.505 151.386-98.5 28.094-98.682-27.976L150.545 289h48.254l3.423 39.287 53.769 14.781 53.422-14.915L314.987 264H147.986l-12.571-149.589 240.789.016L371.997 164z"}}]})(props);
	};
	module.exports.IoLogoHtml5.displayName = "IoLogoHtml5";
	module.exports.IoLogoInstagram = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 96c21.2 0 41.3 8.4 56.5 23.5S416 154.8 416 176v160c0 21.2-8.4 41.3-23.5 56.5S357.2 416 336 416H176c-21.2 0-41.3-8.4-56.5-23.5S96 357.2 96 336V176c0-21.2 8.4-41.3 23.5-56.5S154.8 96 176 96h160m0-32H176c-61.6 0-112 50.4-112 112v160c0 61.6 50.4 112 112 112h160c61.6 0 112-50.4 112-112V176c0-61.6-50.4-112-112-112z"}},{"tag":"path","attr":{"d":"M360 176c-13.3 0-24-10.7-24-24s10.7-24 24-24c13.2 0 24 10.7 24 24s-10.8 24-24 24zM256 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64m0-32c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"}}]})(props);
	};
	module.exports.IoLogoInstagram.displayName = "IoLogoInstagram";
	module.exports.IoLogoIonic = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 161.2c-52.3 0-94.8 42.5-94.8 94.8s42.5 94.8 94.8 94.8 94.8-42.5 94.8-94.8-42.5-94.8-94.8-94.8z"}},{"tag":"circle","attr":{"cx":"392.1","cy":"126.4","r":"43.2"}},{"tag":"path","attr":{"d":"M445.3 169.8l-1.8-4-2.9 3.3c-7.1 8-16.1 14.2-26.1 17.9l-2.8 1 1.1 2.7c8.6 20.7 13 42.7 13 65.2 0 93.7-76.2 169.9-169.9 169.9S86.1 349.7 86.1 256 162.3 86.1 256 86.1c25.4 0 49.9 5.5 72.8 16.4l2.7 1.3 1.2-2.7c4.2-9.8 10.8-18.5 19.2-25.2l3.4-2.7-3.9-2C321.6 55.8 289.5 48 256 48 141.3 48 48 141.3 48 256s93.3 208 208 208 208-93.3 208-208c0-30-6.3-59-18.7-86.2z"}}]})(props);
	};
	module.exports.IoLogoIonic.displayName = "IoLogoIonic";
	module.exports.IoLogoIonitron = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M468.4 269.2c-2.7-34.2-12.2-59.2-32.9-57.3 6.4 14.6 12.2 48.1 8.7 72-1.4-25.9-6.3-50.2-17.2-72-32.1-64.6-100.6-107.4-177.5-103.1-85.9 4.8-155 66.7-172 146.8l-11.4 1.6c-17.2 2.4-26.9 34.9-21.7 72.5 5.3 37.7 23.5 66.2 40.7 63.8l15.8-2.2c34.7 56.3 98.5 92.3 169.3 88.4 85.3-4.7 154-65.9 171.7-145.2l7.4-.4c15.2-2.5 21.8-31.2 19.1-64.9zM90.3 264c10.7 8.2 25.4 28.3 29.1 55.1 3.9 27.7-4.8 54.1-13.4 64.3 6-14.8 8.1-37.3 4.7-61.9-3.3-24-11-44.7-20.4-57.5zm183.8 116.2c-8.5.5-15.8-6-16.3-14.5s6-15.7 14.6-16.2c8.5-.5 15.8 6 16.3 14.5s-6.1 15.7-14.6 16.2zm81-4.7c-8.5.5-15.8-6-16.3-14.5s6-15.7 14.6-16.2c8.5-.5 15.8 6 16.3 14.5.4 8.5-6.1 15.8-14.6 16.2zM165.5 70s0 .1 0 0c.1.1.1.2.1.2.1.2.2.3.3.5v.1c.4 1 1.1 1.9 2.3 2.7 2 1.5 5 2.4 8.6 3 3.4.5 7.5.7 11.9.5 1 0 1.9-.1 2.9-.2-.4-.4-.8-.9-1.2-1.3h-1.3c-4.3.1-8.2-.2-11.6-.9-3.5-.7-6.4-1.8-8.4-3.4-.6-.5-1-.9-1.4-1.4-.2-.7-.2-1.5 0-2.3.5-2.3 2.4-4.8 5.5-7.4 2.7-2.3 6.4-4.7 10.9-7 .9-.4 1.7-.9 2.6-1.3.1-.1.3-.1.5-.2-.8 3.3-.9 6.9-.2 10.5 2.3 11.9 11.6 20.3 23.2 20.6l4 24.3 12.7-2-4-24.3c10.8-4.6 16.3-16.1 14-28-.7-3.5-2-6.7-3.9-9.5-5.3-.8-15.6-.8-29.2 2.1 1.1-.3 2.1-.7 3.2-1 7.6-2.1 14.9-3.5 21.5-4.2.6-.1 1.2-.1 1.8-.2 1.2-.1 2.4-.2 3.5-.3h.6c4.1-.2 7.7-.1 10.8.3 2.4.3 4.4.8 6.1 1.4-.6.9-.9 2-.9 3.2 0 2.7 1.8 5 4.3 5.8-.6.9-1.3 1.9-2.1 2.8-.8.9-1.8 1.9-2.9 2.8-1.1.9-2.3 1.8-3.5 2.7l-6.5 3.8-.3 1.5c.1 0 .2-.1.2-.1l8.4-4.7c1.2-.8 2.4-1.6 3.4-2.4 1.2-.9 2.2-1.8 3.2-2.8.9-.9 1.7-1.9 2.4-2.8l.3-.6c3-.4 5.4-2.9 5.4-6 0-3.4-2.7-6.1-6.1-6.1-1 0-1.9.3-2.8.7-2-1.2-4.8-2.1-8.2-2.7-4.3-.8-9.6-1-15.5-.6-.7 0-1.4.1-2.1.2-.7.1-1.3.2-2 .2-5.3-3.5-11.9-5-18.7-3.7-7.9 1.5-14.2 6.5-17.8 13-1.3.5-2.6 1.1-3.8 1.7-.7.3-1.3.6-2 .9-5.9 2.9-10.6 6.1-13.9 9.1-3.1 2.9-4.9 5.7-5.3 8.3-.2 1.4 0 2.8.7 4 .1.1.2.3.3.5z"}}]})(props);
	};
	module.exports.IoLogoIonitron.displayName = "IoLogoIonitron";
	module.exports.IoLogoJavascript = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 88.001h-80v212.498c0 52.58-18.032 67.261-49.412 67.261-14.705 0-27.948-2.521-38.25-6.063L32 423.904C46.7 428.966 69.259 432 86.907 432 158.955 432 208 398.129 208 301.02V88.001zM382.463 80C305.02 80 256 123.998 256 182.154c0 50.083 37.751 81.44 92.641 101.665 39.7 14.158 55.392 26.808 55.392 47.539 0 22.756-18.139 37.425-52.448 37.425-31.863 0-60.789-10.64-80.394-21.255v-.021L256 410.727c18.639 10.638 53.441 21.255 91.167 21.255C437.854 431.98 480 383.43 480 326.284c0-48.55-26.958-79.9-85.278-102.163-43.139-17.191-61.27-26.795-61.27-48.542 0-17.2 15.688-32.869 48.043-32.869 31.846 0 53.744 10.707 66.505 17.291l19.125-64C447.125 87.22 420.188 80 382.463 80z"}}]})(props);
	};
	module.exports.IoLogoJavascript.displayName = "IoLogoJavascript";
	module.exports.IoLogoLinkedin = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.2 64H96.8C79.3 64 64 76.6 64 93.9V415c0 17.4 15.3 32.9 32.8 32.9h320.3c17.6 0 30.8-15.6 30.8-32.9V93.9C448 76.6 434.7 64 417.2 64zM183 384h-55V213h55v171zm-25.6-197h-.4c-17.6 0-29-13.1-29-29.5 0-16.7 11.7-29.5 29.7-29.5s29 12.7 29.4 29.5c0 16.4-11.4 29.5-29.7 29.5zM384 384h-55v-93.5c0-22.4-8-37.7-27.9-37.7-15.2 0-24.2 10.3-28.2 20.3-1.5 3.6-1.9 8.5-1.9 13.5V384h-55V213h55v23.8c8-11.4 20.5-27.8 49.6-27.8 36.1 0 63.4 23.8 63.4 75.1V384z"}}]})(props);
	};
	module.exports.IoLogoLinkedin.displayName = "IoLogoLinkedin";
	module.exports.IoLogoMarkdown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.659 96H64.341C46.504 96 32 110.484 32 128.308v255.349C32 401.493 46.504 416 64.341 416h383.318C465.496 416 480 401.493 480 383.656V128.308C480 110.484 465.496 96 447.659 96zM284.023 352h-56.048v-96l-42.04 53.878L143.913 256v96H87.869V160h56.044l42.022 67.98 42.04-67.98h56.048v192zm83.657 0l-69.635-96h42v-96h56.043v96h42.027l-70.453 96h.018z"}}]})(props);
	};
	module.exports.IoLogoMarkdown.displayName = "IoLogoMarkdown";
	module.exports.IoLogoModelS = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.6 208.4c-3.1-1.9-2.2-6.6 1.3-7.3l5.3-1.1c7.1 0 22.4-2.3 25.6-5.4 3.1-3.2 4.2-5.4 4.2-8.2s-1.7-7.7-4.8-11.1c-3-3.4-16-5.2-23.7-6.2s-8.7 0-10.7 1.2c-2 1.3-2.8 9.5-3.1 15-.1 1.2-.9 2.2-2.1 2.5l-.4.1c-3.3.7-6.6-1.1-7.8-4.3-4.6-13-10.7-32.5-19.4-48.4-11.5-20.8-23.5-27.4-28.5-29-4.9-1.5-9.4-2.6-43-6.1-33.8-3.6-63.1-4.1-80.5-4.1s-46.7.5-80.6 4.1c-33.6 3.4-38.1 4.5-43 6.1-5 1.6-17 8.2-28.5 29-9.4 17.1-15.7 38.3-20.4 51.3-.6 1.5-2.2 2.4-3.8 2.1-3.1-.7-5.4-3.3-5.6-6.5-.4-5-1.2-10.7-2.9-11.7-2-1.3-3-2.2-10.7-1.2s-20.6 2.8-23.7 6.2c-3 3.4-4.7 8.3-4.7 11.1s1.1 5.1 4.2 8.3c3.1 3.2 18.5 5.4 25.6 5.4l5.3 1.1c3.5.7 4.4 5.4 1.3 7.3-9.1 5.7-23.2 15.3-32.3 25.6 0 0-4.1 28.7-4.1 62.1 0 48 5.8 92.4 5.8 92.4 1.8.3 3.6.6 5.3.9 0 1.2.7 13.1 2 21.2.3 2 1.3 5.5 6.2 5.5h64.7c1.9 0 5.1-1.6 5.1-3.7l1-17c7.2.1 3.2.1 10.9 0 24.8-.3 15.6-7.5 27.1-7.3 11.3.2 55 3 96 3s84.7-2.8 96-3c11.5-.2 2.3 7.1 27.1 7.3 7.7.1 4.7.1 11.9 0l1 17c0 2.1 3.2 3.7 5.1 3.7h63.5c4.9 0 5.9-3.5 6.2-5.5 1.3-8.1 1.9-19.9 2-21.2l5.4-.9s5.8-44.3 5.8-92.4c0-33.5-4.1-62.1-4.1-62.1-9.3-10.5-23.4-20.1-32.5-25.8zm-320.2-53.6c2.2-5.1 5.9-11.6 10-17.2 5-6.7 12.4-11.2 20.6-12.5 16.7-2.7 52.6-7.3 101.9-7.3 49.3 0 85.2 4.6 101.9 7.3 8.2 1.3 15.6 5.8 20.6 12.5 4.2 5.6 7.9 12.1 10.1 17.2 3.9 9.2 10.4 30.7 9.4 33.2-1 2.5 1 3.7-12.2 2.6-13.1-1-90.6-2.1-129.7-2.1-39.2 0-116.7 1.1-129.7 2.1-13.2 1.1-11.3-.2-12.2-2.6s5.4-24 9.3-33.2zm8.4 116c-9.9 0-29.8-1-34.5-1.2-4.7-.1-8.8 3.8-11.2 3.8s-25.5-3.6-28-14.9c-1.7-7.5-1.1-15.2-.6-19.5.3-1.9 1.9-3.4 3.8-3.5 14.4-.5 29.2.5 55.3 7.9 17.3 4.9 29.8 12.6 36.9 17.8 2.8 2.1 1.8 6.5-1.7 7.2-6.1 1.1-14.4 2.4-20 2.4zm210.4 73c-12.7 1.7-58.5 2.2-86.2 2.2s-73.5-.5-86.2-2.2c-13.1-1.7-29.8-17.3-18.4-30.2 7.6-8.5 20.8-13.6 48.9-17.3 29.8-3.8 48.6-4.3 55.6-4.3s25.8.5 55.6 4.3c28.1 3.7 43.2 9.6 48.9 17.3 10.4 13.8-5.1 28.4-18.2 30.2zm111.7-85.2c-2.5 11.2-25.6 14.9-28 14.9s-6.5-3.9-11.2-3.8c-4.7.2-24.6 1.2-34.5 1.2-5.5 0-13.8-1.3-20-2.4-3.5-.6-4.5-5.1-1.7-7.2 7.1-5.2 19.6-12.9 36.9-17.8 26.1-7.4 40.8-8.4 55.3-7.9 2 .1 3.6 1.5 3.8 3.5.5 4.3 1.1 12-.6 19.5z"}}]})(props);
	};
	module.exports.IoLogoModelS.displayName = "IoLogoModelS";
	module.exports.IoLogoNoSmoking = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360 256h16v48h-16zM112 304h129.6l-48-48H112z"}},{"tag":"path","attr":{"d":"M364.5 60.1c-.4-.2-.7-.4-1-.6-10.9-6-22.5-10.7-34.4-14.8l-5.4-1.8C302.3 36.1 279.6 32 256 32 132.3 32 32 132.3 32 256c0 84.3 46.6 157.6 115.4 195.8.4.2.7.5 1.1.7 10.9 6 22.5 10.7 34.4 14.8l5.4 1.8c21.4 6.8 44 10.9 67.7 10.9 123.7 0 224-100.3 224-224 0-84.3-46.6-157.7-115.5-195.9zM256 426.4c-9.3 0-18.4-.9-27.2-2.4-9.8-1.6-19.3-4.1-28.5-7.3-1.9-.6-3.8-1.2-5.6-1.9-6.5-2.5-12.9-5.3-19-8.6-53.6-28.7-90.1-85.2-90.1-150.3 0-37.2 12.4-71.4 32.7-99.4l237.2 237.2c-28.1 20.3-62.3 32.7-99.5 32.7zm137.8-71L156.6 118.2c28-20.2 62.1-32.6 99.4-32.6 9.3 0 18.3.9 27.2 2.4 9.8 1.6 19.3 4.1 28.5 7.3 1.8.6 3.7 1.2 5.6 1.9 6.2 2.4 12.2 5 18 8.1 54.2 28.5 91.2 85.3 91.2 150.8-.1 37.2-12.5 71.3-32.7 99.3z"}},{"tag":"path","attr":{"d":"M352 256h-34l34 34zM384 256h16v48h-16zM360.1 212.7c-8.8-4.1-22-5.7-45.6-5.7h-3.6c-12.7.1-15.9-.1-20-6.1-2.8-4.2-1-14.8 3.7-21.9 1.6-2.4 1.8-5.6.4-8.2-1.4-2.6-4.1-4.2-7-4.3-.1 0-9.4-.1-18.3-3.9-10.6-4.5-15.6-12.1-15.6-23.1 0-25.8 21.8-27.7 22.8-27.7v-16c-12 0-38.8 11-38.8 43.7 0 17.5 9 31 25.7 38 4.2 1.7 8.4 2.9 12 3.6-3.3 9.8-3.6 20.9 1.7 28.7 9 13.3 20.3 13.2 33.3 13.1h3.5c26.3 0 34.6 2.3 38.9 4.3 5.7 2.6 6.8 7.5 6.6 15.7v1h16v-1c0-7.1.3-22.8-15.7-30.2z"}},{"tag":"path","attr":{"d":"M400 244c0-25.7-3-39.2-9.1-49.6C382.3 180 368.5 172 352 172h-17.4c2.9-8.3 5.4-19.8 3.5-30.9-3.2-18.8-19.1-30-43.1-30v16c21 0 26.1 9.1 27.4 16.7 2.5 14.5-6.8 32.1-6.9 32.3-1.4 2.5-1.3 5.5.1 7.9s4.1 3.9 6.9 3.9H352c10.9 0 19.4 4.9 25.1 14.6 3.1 5.3 6.9 13.5 6.9 41.4h16v.1z"}}]})(props);
	};
	module.exports.IoLogoNoSmoking.displayName = "IoLogoNoSmoking";
	module.exports.IoLogoNodejs = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.917 480a32.536 32.536 0 0 1-16.633-4.599l-52.985-32.44c-7.914-4.562-4.023-6.203-1.443-7.141 10.565-3.781 13.713-5.657 24.947-12.285 1.206-.667 2.747-.424 3.955.322l39.71 23.504c1.476.85 3.557.85 4.931 0l155.188-92.246c1.475-.877 2.415-2.646 2.415-4.441V163.869c0-1.85-.94-3.592-2.449-4.528l-155.12-94.672c-1.478-.894-3.421-.894-4.898 0L98.516 159.374c-1.544.903-2.516 2.698-2.516 4.495v186.805c0 1.813.972 3.513 2.481 4.389l39.929 23.972c23.61 12.204 37.59-.17 37.59-14.611V180.725c0-2.652 2.047-4.727 4.596-4.727h22.809c2.515 0 4.597 2.072 4.597 4.727v183.698c0 32.563-19.353 51.248-49.199 51.248-9.156 0-16.397 0-36.552-10.279l-41.584-24.781C70.371 374.459 64 362.965 64 350.656V161.191c0-12.316 6.371-23.784 16.665-29.917L239.35 36.41c10.027-5.88 23.374-5.88 33.332 0l158.65 94.864C441.63 137.423 448 148.899 448 161.191v189.465c0 12.309-6.37 23.75-16.668 29.953l-158.65 94.774a32.52 32.52 0 0 1-16.698 4.599l-.067.018z"}},{"tag":"path","attr":{"d":"M304.943 351.998c-64.61 0-84.006-31.61-84.006-59.271 0-2.629 2.048-4.729 4.562-4.729h20.521c2.282 0 4.227 1.7 4.562 4.016 3.084 21.602 16.748 31.15 54.324 31.15 33.399 0 47.091-10.346 47.091-28.684 0-10.592-3.463-18.424-55.407-23.697-43.427-4.441-70.288-14.373-70.288-50.295 0-33.135 26.996-52.49 72.234-52.49 46.128 0 76.462 14 79.173 50.829.102 1.337-.368 2.629-1.241 3.644-.871.965-2.078 1.527-3.353 1.527h-20.591c-2.146 0-4.024-1.562-4.459-3.713-4.401-16.953-16.97-23.402-49.563-23.402-36.486 0-40.746 12.753-40.746 22.607 0 11.963 5.031 15.441 54.294 22.172 48.761 6.663 71.933 16.117 71.933 51.552 0 35.781-28.808 58.783-79.075 58.783l.035.001z"}}]})(props);
	};
	module.exports.IoLogoNodejs.displayName = "IoLogoNodejs";
	module.exports.IoLogoNpm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M227.6 213.1H256v57.1h-28.4z"}},{"tag":"path","attr":{"d":"M0 156v171.4h142.2V356H256v-28.6h256V156H0zm142.2 142.9h-28.4v-85.7H85.3v85.7H28.4V184.6h113.8v114.3zm142.2 0h-56.9v28.6h-56.9V184.6h113.8v114.3zm199.2 0h-28.4v-85.7h-28.4v85.7h-28.4v-85.7H370v85.7h-56.9V184.6h170.7v114.3z"}}]})(props);
	};
	module.exports.IoLogoNpm.displayName = "IoLogoNpm";
	module.exports.IoLogoOctocat = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M178.4 287.5c-9.1 0-16.9 4.2-23.2 12.8-6.3 8.5-9.4 19-9.4 31.4 0 12.5 3.2 23 9.4 31.5 6.3 8.5 14 12.8 23.2 12.8 8.5 0 15.9-4.3 22.1-12.8 6.3-8.5 9.4-19 9.4-31.5 0-12.4-3.2-22.9-9.4-31.4-6.3-8.6-13.6-12.8-22.1-12.8zM334.7 287.5c-9 0-16.9 4.2-23.2 12.8-6.3 8.5-9.4 19-9.4 31.4 0 12.5 3.2 23 9.4 31.5 6.3 8.5 14.1 12.8 23.2 12.8 8.5 0 15.9-4.3 22.2-12.8 6.3-8.5 9.4-19 9.4-31.5 0-12.4-3.2-22.9-9.4-31.4-6.3-8.6-13.6-12.8-22.2-12.8z"}},{"tag":"path","attr":{"d":"M445.8 172c-.1 0 2.7-14.3.3-39.2-2.2-24.9-7.5-47.8-16.1-68.8 0 0-4.4.8-12.8 2.9s-22.1 6.3-40.9 14.8c-18.5 8.5-38 19.8-58.3 33.5-13.8-3.9-34.4-5.9-62-5.9-26.3 0-46.9 2-62 5.9-44.6-30.9-81.9-48-112.1-51.2-8.6 21-13.9 44-16 69-2.4 24.9.4 39.3.4 39.3C42 198.6 32 236.5 32 267.8c0 24.2.7 46.1 6.1 65.5 5.6 19.3 12.7 35.1 21.1 47.2 8.6 12.1 19 22.8 31.6 31.9 12.5 9.3 24 16 34.4 20.2 10.5 4.4 22.4 7.6 36 9.9 13.3 2.4 23.4 3.6 30.5 4 0 0 28 1.5 64.4 1.5s64.3-1.5 64.3-1.5c7-.4 17.1-1.6 30.5-4 13.5-2.3 25.5-5.6 35.9-9.9 10.4-4.3 21.9-10.9 34.5-20.2 12.5-9 22.9-19.7 31.5-31.9 8.4-12.1 15.5-27.9 21.1-47.2 5.5-19.4 6.1-41.4 6.1-65.6 0-30.3-10-68.7-34.2-95.7zm-65.4 233.6c-27.9 13.1-68.9 18.4-123.3 18.4H255c-54.4 0-95.4-5.2-122.8-18.4-27.5-13.1-41.3-40.1-41.3-80.7 0-24.3 8.6-44 25.5-59.1 7.4-6.5 16.4-11 27.6-13.7 11.1-2.6 21.4-2.8 31-2.5 9.4.4 22.6 2.2 39.3 3.5 16.8 1.3 29.3 3 41.8 3 11.7 0 27.2-2 52.1-4 25-2 43.5-3 55.5-1 12.3 2 23 6.2 32.1 14.7 17.7 15.8 26.6 35.5 26.6 59.1-.1 40.6-14.2 67.6-42 80.7z"}}]})(props);
	};
	module.exports.IoLogoOctocat.displayName = "IoLogoOctocat";
	module.exports.IoLogoPinterest = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.3 32 32 132.3 32 256c0 91.7 55.2 170.5 134.1 205.2-.6-15.6-.1-34.4 3.9-51.4 4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58 20.4 0 30.2 15.3 30.2 33.6 0 20.5-13.1 51.1-19.8 79.5-5.6 23.8 11.9 43.1 35.4 43.1 42.4 0 71-54.5 71-119.1 0-49.1-33.1-85.8-93.2-85.8-67.9 0-110.3 50.7-110.3 107.3 0 19.5 5.8 33.3 14.8 43.9 4.1 4.9 4.7 6.9 3.2 12.5-1.1 4.1-3.5 14-4.6 18-1.5 5.7-6.1 7.7-11.2 5.6-31.3-12.8-45.9-47-45.9-85.6 0-63.6 53.7-139.9 160.1-139.9 85.5 0 141.8 61.9 141.8 128.3 0 87.9-48.9 153.5-120.9 153.5-24.2 0-46.9-13.1-54.7-27.9 0 0-13 51.6-15.8 61.6-4.7 17.3-14 34.5-22.5 48 20.1 5.9 41.4 9.2 63.5 9.2 123.7 0 224-100.3 224-224C480 132.3 379.7 32 256 32z"}}]})(props);
	};
	module.exports.IoLogoPinterest.displayName = "IoLogoPinterest";
	module.exports.IoLogoPlaystation = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399.8 203c-.8-17.1-3.3-34.5-10.8-50.1-4.1-8.6-9.7-16.5-16.5-23.2-6.3-6.4-13.6-11.7-21.3-16.3-17.1-10.2-37.5-17-84.4-31S192 64 192 64v358.3l79.9 25.7s.1-198.8.1-299.5v-3.8c0-9.3 7.5-16.8 16.1-16.8h.5c8.5 0 15.5 7.5 15.5 16.8V278c11 5.3 29.2 9.3 41.8 9.1 8.3.2 16.7-1.7 24-5.7 7.6-4.1 13.9-10.4 18.4-17.8 5.1-8.3 8.2-17.8 9.9-27.3 1.9-10.8 2-22.1 1.6-33.3zM86.7 357.8c27.4-9.8 89.3-29.5 89.3-29.5v-47.2s-76.5 24.8-111.3 37.1c-8.6 3.1-17.3 5.9-25.7 9.5-9.8 4.1-19.4 8.7-28.1 14.8-3.8 2.6-7.2 5.9-9.2 10.1s-2.2 9.2-.5 13.6c2 5.1 5.8 9.3 10.1 12.6 7.8 5.9 17.1 9.5 26.4 12.2 28.4 9.4 58.4 14 88.4 13.3 14.5-.2 36-1.9 50-4.4v-42s-11 2.5-41.3 12.5c-4.6 1.5-9.2 3.3-14 4.3-7.1 1.6-14.4 2.1-21.6 2.2-6.5-.3-13.2-.7-19.3-3.1-2.2-1-4.6-2.2-5.5-4.6-.8-2 .3-4 1.7-5.4 2.8-2.9 6.8-4.5 10.6-6z"}},{"tag":"path","attr":{"d":"M512 345.9c-.1-6-3.7-11.2-7.9-15-7.1-6.3-15.9-10.3-24.7-13.5-5.5-1.9-9.3-3.3-14.7-5-25.2-8.2-51.9-11.2-78.3-11.3-8 .3-23.1.5-31 1.4-21.9 2.5-67.3 15.4-67.3 15.4v48.8s67.5-21.6 96.5-31.8c9.7-3.3 20.1-4.6 30.3-4.6 6.5.2 13.2.7 19.4 3.1 2.2.9 4.5 2.2 5.5 4.5.9 2.6-.9 5-2.9 6.5-4.7 3.8-10.7 5.3-16.2 7.4-41 14.5-132.7 44.7-132.7 44.7v47s117.2-39.6 170.8-58.8c8.9-3.3 17.9-6.1 26.4-10.4 7.9-4 15.8-8.6 21.8-15.3 3.1-3.6 5-8 5-13.1z"}}]})(props);
	};
	module.exports.IoLogoPlaystation.displayName = "IoLogoPlaystation";
	module.exports.IoLogoPolymer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392.3 96h-77.9L160.8 348.6 109.9 256l87.7-160h-77.9L32 256l87.7 160h77.9l153.7-252.6 50.8 92.6-87.7 160h77.9L480 256 392.3 96z"}}]})(props);
	};
	module.exports.IoLogoPolymer.displayName = "IoLogoPolymer";
	module.exports.IoLogoPython = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M193.46 249.056a65.316 65.316 0 0 1 11.586-1.041l-3.122-.015h103.823c4.503 0 8.806-.617 12.908-1.754 19.37-5.363 33.345-22.537 33.345-43.663v-87.224c0-24.832-21.15-43.484-46.289-47.606-15.931-2.624-39.258-3.827-55.089-3.749-15.829.086-30.981 1.404-44.277 3.749C167.143 74.576 160 88.928 160 115.359V144h96v16H128.82c-35.628 0-64.538 42.571-64.813 95.242-.002.253-.007.505-.007.758 0 9.523.94 18.72 2.685 27.404C74.648 323.07 99.451 352 128.82 352H144v-45.935c0-26.827 20.146-51.733 49.46-57.009zm10.196-122.054c-9.592 0-17.384-7.785-17.384-17.403 0-9.664 7.774-17.52 17.384-17.52 9.574 0 17.399 7.855 17.399 17.52.001 9.618-7.809 17.403-17.399 17.403z"}},{"tag":"path","attr":{"d":"M443.951 222.543C434.78 186.021 411.033 160 383.18 160H368v40.672c0 33.915-22.286 58.474-49.489 62.681a53.943 53.943 0 0 1-8.301.646H206.351a51.41 51.41 0 0 0-13.049 1.672C174.18 270.689 160 286.6 160 307.236v87.227c0 24.832 24.977 39.426 49.481 46.551 29.327 8.531 61.267 10.068 96.366 0C329.15 434.354 352 420.893 352 394.463V368h-96v-16h127.18c25.24 0 47.107-21.365 57.814-52.549C445.474 286.404 448 271.641 448 256c0-11.768-1.433-23.038-4.049-33.457zM307.867 382.82c9.59 0 17.381 7.785 17.381 17.4 0 9.65-7.791 17.521-17.381 17.521-9.577 0-17.399-7.871-17.399-17.521 0-9.63 7.806-17.4 17.399-17.4z"}}]})(props);
	};
	module.exports.IoLogoPython.displayName = "IoLogoPython";
	module.exports.IoLogoReddit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"322.3","cy":"288.4","r":"31.8"}},{"tag":"circle","attr":{"cx":"190.3","cy":"288.4","r":"31.8"}},{"tag":"path","attr":{"d":"M480.5 251c0-27.7-22.2-50.2-49.5-50.2-13 0-24.7 5-33.6 13.3-33.2-23.4-78.4-38.5-128.7-40.7L292 95.7l69.6 13.9c.2 24.7 20.1 44.7 44.5 44.7 24.6 0 44.5-20.2 44.5-45.1S430.7 64 406.1 64c-18.6 0-34.5 11.6-41.2 28l-85.2-17-29.4 98.2-7.1.2c-50.3 2.2-95.5 17.4-128.7 40.7-8.8-8.3-20.6-13.3-33.6-13.3-27.3 0-49.5 22.5-49.5 50.2 0 19.6 11 36.5 27.1 44.8-.8 4.9-1.2 9.8-1.2 14.8C57.5 386.4 146.4 448 256 448s198.5-61.6 198.5-137.5c0-5-.4-9.9-1.1-14.8 16.1-8.3 27.1-25.2 27.1-44.7zM406.1 81.9c14.8 0 26.8 12.2 26.8 27.2s-12 27.2-26.8 27.2-26.8-12.2-26.8-27.2 12-27.2 26.8-27.2zM49.2 251c0-17.8 14.3-32.2 31.8-32.2 7.2 0 13.9 2.5 19.2 6.6-17.3 15.2-30.1 33-37 52.4-8.4-5.9-14-15.7-14-26.8zm337.2 141.9C351.8 416.8 305.5 430 256 430s-95.8-13.2-130.4-37.1c-32.5-22.5-50.4-51.8-50.4-82.4 0-3.2.2-6.5.6-9.7.7-6 2.2-11.9 4.3-17.7 5.6-15.6 16-30.3 30.7-43.4 4.4-3.9 9.2-7.7 14.4-11.3.1-.1.3-.2.4-.3C160.2 204.2 206.5 191 256 191s95.8 13.2 130.4 37.1c.1.1.3.2.4.3 5.2 3.6 10 7.4 14.4 11.3 14.7 13.1 25.1 27.8 30.7 43.4 2.1 5.8 3.5 11.7 4.3 17.7.4 3.2.6 6.4.6 9.7 0 30.6-17.9 59.9-50.4 82.4zm62.4-115.2c-6.9-19.4-19.7-37.2-37-52.4 5.3-4.1 12-6.6 19.2-6.6 17.5 0 31.8 14.5 31.8 32.2 0 11.2-5.6 21-14 26.8z"}},{"tag":"path","attr":{"d":"M320.5 357.9c-.2.2-24.2 24.2-64.5 24.4-40.9-.2-64.4-24.2-64.6-24.4l-12.6 12.4c1.2 1.2 29.6 29.5 77.2 29.7 47.6-.2 75.9-28.5 77.1-29.7l-12.6-12.4z"}}]})(props);
	};
	module.exports.IoLogoReddit.displayName = "IoLogoReddit";
	module.exports.IoLogoRss = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M119.9 336.1c-30.8 0-55.9 25.1-55.9 55.8 0 30.8 25.1 55.6 55.9 55.6 30.9 0 55.9-24.9 55.9-55.6 0-30.7-25-55.8-55.9-55.8z"}},{"tag":"path","attr":{"d":"M64 192v79.9c48 0 94.1 14.2 128 48.1 33.9 33.9 48 79.9 48 128h80c0-139.9-116-256-256-256z"}},{"tag":"path","attr":{"d":"M64 64v79.9c171 0 303.9 133 303.9 304.1H448C448 236.3 276 64 64 64z"}}]})(props);
	};
	module.exports.IoLogoRss.displayName = "IoLogoRss";
	module.exports.IoLogoSass = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.784 329.108c-1.67-13.599-9.236-24.146-20.795-32.416 2.857 2.04 5.275 3.766-.055-.041-7.189-5.131-3.38-2.411-.047-.032-28.5-20.301-65.676-15.789-96.733-4.511-12.447-20.295-12.987-35.783-5.816-57.937.929-2.8.295-4.354-2.624-5.604-7.086-3.03-17.291-1.427-24.422.463-2.462.646-4.254 1.9-4.8 4.381-5.154 24.243-21.009 46.448-34.828 66.886-9.731-18.652-8.96-33.087-2.414-52.516.798-2.366.431-3.624-1.937-4.879-7.26-3.757-18.401-1.912-25.8.276-8.509 2.482-21.29 44.594-25.372 52.946-8.531 17.442-16.091 44.665-30.585 58.502-12.3-15.807 22.526-51.517 10.882-65.851-3.938-4.848-11.063-4.723-15.586-.616 1.085-7.608 1.648-12.609-.32-19.063-2.081-6.79-7.361-10.687-15.09-10.49-17.995.527-33.843 13.815-44.641 26.397-10.277 12.105-37.381 19.627-51.953 26.927-25.032-21.807-79.221-44.947-80.632-82.081-1.528-41.846 48.319-70.245 81.597-87.228 43.28-22.104 109.961-49.608 159.138-25.436 13.049 6.414 18.299 20.171 14.707 33.348-9.368 34.366-47.198 57.293-80.103 67.807-16.189 5.175-33.969 9.027-51.1 8.026-22.955-1.343-40.83-15.224-43.281-16.086-2.049-.389-1.888 2.261-1.347 3.664 23.816 62.433 144.417 16.681 175.956-15.371 15.189-15.421 24.413-30.365 28.351-53.894 4.616-27.583-15.634-44.842-31.004-51.957-77.918-36.072-185.636 11.168-244.553 59.327-25.568 20.901-57.552 54.11-42.874 88.946 15.93 37.805 64.736 57.19 96.503 80.312-25.704 12.773-57.862 25.983-74.518 49.933-9.524 13.729-12.903 28.359-5.811 43.966 12.572 27.568 58.285 15.622 77.573 3.471 17.67-11.13 29.563-26.07 34.7-45.228 4.455-16.609 3.541-33.866-3.856-49.512l28.585-14.458c-7.697 23.076-11.097 52.003 4.881 72.855 6.402 8.338 23.017 8.675 29.817.311 8.816-10.943 14.664-24.655 20.503-37.206-.682 9.373-1.856 19.996 1.377 28.165 3.71 9.373 12.126 11.291 20.792 5.343 26.52-18.203 43.398-68.652 56.463-98.062 3.552 12.829 7.473 24.548 13.957 36.376 1.602 2.903 1.407 4.774-.796 7.195-9.685 10.675-32.826 28.479-35.069 42.899-.524 3.371 1.713 6.599 5.686 7.37 15.573 3.108 32.838-2.531 45.482-11.078 13.188-8.922 17.446-21.087 14.245-35.515-4.576-20.771 10.993-43.98 25.801-61.03 2.719 12.908 6.816 25.331 14.143 36.606-13.075 11.483-32.58 27.764-29.779 46.939.988 6.865 7.135 11.301 14.514 9.736 15.783-3.324 29.416-10.113 39.37-22.146 9.023-10.855 5.792-22.701 1.856-34.635 23.872-6.815 48.022-8.177 71.831-.027 11.495 3.91 20.755 10.5 26.248 20.818 6.726 12.644 2.939 24.292-10.05 32.604-3.287 2.104-5.562 3.833-4.45 4.743 1.112.911 4.9 2.113 13.284-3.152 8.384-5.267 13.51-12.383 14.823-21.725a37.09 37.09 0 0 0-.024-7.755zm-398.838 25.259c-1.358 16.673-9.636 30.193-23.175 41.114-7.617 6.158-17.102 11.176-26.52 12.092-9.418.917-16.751-1.461-17.378-11.23-1.764-27.493 40.923-54.424 64.625-62.533 2.02 6.86 3.011 13.666 2.432 20.587l.016-.03zm103.102-72.453c-3.903 22.309-14.83 62.347-32.314 78.336-2.356 2.143-4.61 2.018-5.809-.771-10.345-24.059 3.671-73.669 33.082-81.328 3.457-.889 5.602.582 5.041 3.763zm70.311 81.768c8.422-8.962 16.834-17.916 25.269-26.927 1.043 10.021-17.571 29.964-25.269 26.927zm80.714-17.696c-2.348 1.273-7.621 2.515-7.827.835-1.482-12.085 11.816-24.874 20.067-30.867 4.453 11.343-.818 23.834-12.24 30.032z"}}]})(props);
	};
	module.exports.IoLogoSass.displayName = "IoLogoSass";
	module.exports.IoLogoSkype = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436.9 296.8c2.8-12.5 4.2-25.4 4.2-38.7 0-99.7-82-180.6-183.2-180.6-10.7 0-21.1.9-31.3 2.6C210.3 69.9 191 64 170.2 64 111.6 64 64 110.9 64 168.7c0 19.4 5.3 37.5 14.6 53-2.4 11.7-3.7 23.9-3.7 36.3 0 99.8 82 180.6 183.1 180.6 11.5 0 22.7-1 33.5-3 15 7.9 32.1 12.4 50.2 12.4 58.7 0 106.2-46.9 106.2-104.7.1-16.7-3.9-32.5-11-46.5zm-85 47.5c-8.5 11.8-21 21.2-37.2 27.8-16.1 6.6-35.3 9.9-57.3 9.9-26.3 0-48.3-4.6-65.6-13.6-12.3-6.6-22.4-15.4-30.2-26.4-7.8-11-11.7-22-11.7-32.6 0-6.6 2.6-12.3 7.6-17.1 5-4.6 11.5-7 19.1-7 6.3 0 11.7 1.8 16.1 5.5 4.2 3.5 7.8 8.7 10.7 15.5 3.3 7.3 6.8 13.5 10.6 18.4 3.6 4.7 8.7 8.6 15.3 11.7 6.7 3.1 15.6 4.7 26.6 4.7 15.1 0 27.5-3.2 36.8-9.5 9.2-6.1 13.6-13.5 13.6-22.5 0-7.1-2.3-12.7-7.1-17.1-5-4.6-11.5-8.2-19.6-10.6-8.3-2.6-19.6-5.3-33.6-8.2-19-4-35.1-8.8-48-14.2-13.1-5.5-23.7-13.2-31.5-22.7-7.9-9.7-11.8-21.9-11.8-36.2 0-13.7 4.2-25.9 12.4-36.5 8.2-10.5 20.1-18.7 35.6-24.3 15.2-5.6 33.3-8.4 53.7-8.4 16.4 0 30.7 1.9 42.7 5.5 12.1 3.7 22.2 8.7 30.3 14.9 8 6.2 14 12.8 17.8 19.7 3.8 7 5.7 13.9 5.7 20.6 0 6.4-2.5 12.3-7.5 17.4-5 5.1-11.3 7.8-18.8 7.8-6.8 0-12.1-1.6-15.8-4.8-3.4-3-7-7.6-10.9-14.3-4.6-8.5-10.1-15.3-16.4-20.1-6.2-4.6-16.4-7-30.6-7-13.1 0-23.8 2.6-31.7 7.7-7.6 4.9-11.3 10.6-11.3 17.3 0 4.1 1.2 7.5 3.7 10.5 2.6 3.1 6.2 5.9 10.9 8.2 4.8 2.4 9.8 4.3 14.7 5.6 5.1 1.4 13.6 3.5 25.3 6.1 14.9 3.1 28.5 6.7 40.5 10.4 12.2 3.9 22.7 8.6 31.3 14.1 8.8 5.6 15.7 12.9 20.7 21.5 4.9 8.6 7.4 19.4 7.4 31.8.4 15.1-3.9 28.7-12.5 40.5z"}}]})(props);
	};
	module.exports.IoLogoSkype.displayName = "IoLogoSkype";
	module.exports.IoLogoSlack = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.6 236.216l64.003-21.438 20.708 61.823-64.004 21.438z"}},{"tag":"path","attr":{"d":"M213.6 236.216l64.003-21.438 20.708 61.823-64.004 21.438z"}},{"tag":"path","attr":{"d":"M475.9 190C426.4 25 355-13.4 190 36.1S-13.4 157 36.1 322 157 525.4 322 475.9 525.4 355 475.9 190zm-83.3 107.1l-31.1 10.4 10.7 32.2c4.2 13-2.7 27.2-15.7 31.5-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9l-10.7-32.2-64.1 21.5L261 377c4.2 13-2.7 27.2-15.7 31.5-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9L203 360.4l-31 10.3c-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9-4.2-13 2.7-27.2 15.7-31.5l31.1-10.4-20.7-61.8-31.1 10.4c-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9-4.2-13 2.7-27.2 15.7-31.5l31.1-10.4-10.9-32.1c-4.2-13 2.7-27.2 15.7-31.5 13-4.2 27.2 2.7 31.5 15.7l10.7 32.2 64.1-21.5-10.7-32.2c-4.2-13 2.7-27.2 15.7-31.5 13-4.2 27.2 2.7 31.5 15.7l10.7 32.2 31.1-10.4c13-4.2 27.2 2.7 31.5 15.7 4.2 13-2.7 27.2-15.7 31.5l-31.1 10.4 20.7 61.8 31.1-10.4c13-4.2 27.2 2.7 31.5 15.7 4.2 13.2-2.7 27.4-15.8 31.7z"}}]})(props);
	};
	module.exports.IoLogoSlack.displayName = "IoLogoSlack";
	module.exports.IoLogoSnapchat = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M495.998 360.389l-.189-14.501-14.398-1.278c-15.413-1.396-43.8-7.219-54.301-16.9-16.281-15.011-35.688-36.199-35.688-51.893 0-1.014 0-2.546 4.15-5.186 4.985-3.174 12.589-5.584 19.297-7.71 5.217-1.654 10.144-3.217 14.394-5.236 9.236-4.39 18.498-15.978 17.471-28.807-1.215-15.166-14.424-27.046-30.072-27.046-4.021 0-8.068.76-12.027 2.259-8.027 3.041-13.743 4.41-17.705 4.962.747-9.319 1.791-20.12 3.211-30.67 5.111-37.948-5.281-73.509-29.264-101.042C335.498 48.208 297.376 32 256.283 32H256c-41.093 0-79.215 16.208-104.591 45.341-23.982 27.534-34.375 63.345-29.265 101.292 1.416 10.51 2.46 21.231 3.21 30.618-3.97-.559-9.686-1.998-17.703-5.034-3.965-1.502-8.017-2.295-12.043-2.295-15.641-.001-28.844 11.852-30.057 27.003-1.027 12.818 8.235 24.393 17.47 28.783 4.251 2.02 9.181 3.578 14.4 5.232 6.707 2.125 14.309 4.532 19.293 7.703 4.147 2.639 4.147 4.168 4.147 5.182 0 8.66-6.191 24.691-35.688 51.888-10.499 9.681-39.055 15.501-54.588 16.897l-14.572 1.311L16 360.603c0 1.679.312 10.546 6.485 20.319 5.246 8.306 16.073 19.283 37.863 24.407a1139.713 1139.713 0 0 0 15.208 3.454c2.306.512 4.555 1.01 6.454 1.453l.081.623c.9 7.004 1.611 12.535 4.392 17.75 2.453 4.6 8.574 12.316 22.015 12.316 2.478 0 5.249-.246 8.472-.751 1.672-.263 3.386-.554 5.2-.863 7.116-1.212 15.182-2.587 23.451-2.587 10.277 0 18.732 2.188 25.846 6.688 4.531 2.867 8.892 5.972 13.509 9.26C202.967 465.481 223.358 480 256 480c32.726 0 53.293-14.582 71.439-27.446 4.576-3.244 8.898-6.309 13.377-9.142 7.113-4.5 15.568-6.688 25.846-6.688 8.27 0 16.334 1.375 23.449 2.586 1.814.311 3.529.602 5.202.864 3.223.505 5.993.751 8.472.751 13.44 0 19.562-7.715 22.015-12.313 2.781-5.214 3.492-10.746 4.392-17.749l.082-.629c1.898-.441 4.148-.941 6.455-1.452 4.023-.892 9.029-2.001 15.206-3.454 21.851-5.139 32.611-16.17 37.79-24.518 6.097-9.828 6.296-18.736 6.273-20.421zM208 128c8.836 0 16 10.745 16 24s-7.164 24-16 24-16-10.745-16-24 7.164-24 16-24zm103.615 77.698C296.368 220.725 276.617 229 256 229c-20.838 0-40.604-8.29-55.657-23.343a8 8 0 1 1 11.313-11.313C223.688 206.374 239.436 213 256 213c16.387 0 32.15-6.64 44.385-18.698a8 8 0 0 1 11.23 11.396zM304 176c-8.836 0-16-10.746-16-24s7.164-24 16-24 16 10.746 16 24-7.164 24-16 24z"}}]})(props);
	};
	module.exports.IoLogoSnapchat.displayName = "IoLogoSnapchat";
	module.exports.IoLogoSteam = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.8 208.2c0 19.8-16.1 36-36 36-19.8 0-36-16.1-36-36 0-19.8 16.1-36 36-36 19.8 0 36 16.2 36 36zM442.6 139c-38.1 0-69 30.7-69.4 68.7l-43.2 62c-1.8-.2-3.6-.3-5.4-.3-9.7 0-18.7 2.7-26.4 7.3L102.4 198c-5.1-23.2-25.9-40.7-50.6-40.7C23.3 157.2 0 180.6 0 209.1s23.3 51.8 51.8 51.8c9.7 0 18.7-2.7 26.4-7.3L274 332.2c5.1 23.3 25.8 40.8 50.6 40.8 26.8 0 49-20.6 51.5-46.7l66.5-48.6c38.3 0 69.4-31 69.4-69.3S480.9 139 442.6 139zm0 22.9c25.7 0 46.5 20.9 46.5 46.5 0 25.7-20.9 46.4-46.5 46.4-25.7 0-46.5-20.8-46.5-46.4 0-25.7 20.8-46.5 46.5-46.5zm-390.8 9c14.6 0 27.3 8.2 33.7 20.2l-18.9-7.6v.1c-15.3-5.5-32.2 2-38.3 17.1-6.1 15.2.9 32.3 15.7 38.9v.1l16.1 6.4c-2.6.6-5.4.9-8.2.9-21.1 0-38.1-17-38.1-38.1-.1-20.9 16.9-38 38-38zm272.8 112.2c21.1 0 38.1 17 38.1 38.1s-17 38.1-38.1 38.1c-14.7 0-27.4-8.2-33.7-20.3 6.3 2.5 12.5 5 18.8 7.6 15.5 6.2 33.2-1.3 39.4-16.8 6.2-15.5-1.3-33.1-16.9-39.4l-15.9-6.4c2.8-.5 5.5-.9 8.3-.9z"}}]})(props);
	};
	module.exports.IoLogoSteam.displayName = "IoLogoSteam";
	module.exports.IoLogoTumblr = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M321.2 396.3c-11.8 0-22.4-2.8-31.5-8.3-6.9-4.1-11.5-9.6-14-16.4-2.6-6.9-3.6-22.3-3.6-46.4V224h96v-64h-96V48h-61.9c-2.7 21.5-7.5 44.7-14.5 58.6-7 13.9-14 25.8-25.6 35.7-11.6 9.9-25.6 17.9-41.9 23.3V224h48v140.4c0 19 2 33.5 5.9 43.5 4 10 11.1 19.5 21.4 28.4 10.3 8.9 22.8 15.7 37.3 20.5 14.6 4.8 31.4 7.2 50.4 7.2 16.7 0 30.3-1.7 44.7-5.1 14.4-3.4 30.5-9.3 48.2-17.6v-65.6c-20.9 13.7-41.8 20.6-62.9 20.6z"}}]})(props);
	};
	module.exports.IoLogoTumblr.displayName = "IoLogoTumblr";
	module.exports.IoLogoTux = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.3 396c-6.7-4-13.2-11-12-18.8 2.3-15.3 2.5-21.5-.2-25.8-1.9-3.2-5.5-5-8.6-5.8 2-2.5 3.1-5.4 3.8-10.9 1.3-10-4.7-41-12.7-65.7s-29.9-50-44.7-68c-26-31.8-22.8-39.2-26.3-99.7C323.4 62.8 306.3 32 256 32s-67 32-67 59c0 28.7 2 51 2 51 1.3 33.4 1 39.4-8 55.3-4.9 8.7-27 30-35.7 44.7s-7.6 29.5-24.6 52.8c-12.4 17-13.8 28.4-9.7 44-7 8.2-3.6 19.9-5 24.9-2.6 8.7-13.7 10.3-22.3 11s-15.3 0-18.7 5.3.7 16 4.3 30-7.3 15-7.3 31 30 16 59.7 22.7 40.7 16.3 56 16.3 26.8-10.2 38-19.3c7.2-5.9 29-3.7 42.3-3.7s34.3-.6 45.7 2.4S317 480 345 480s34.7-20.7 61-34.3 42-20 42-29.7-15-16-21.7-20zm-226.5 55.5c-1.3 13-12.6 17.1-24.1 16.1-13-1.1-29-7.6-44.1-12.1s-35.5-7.5-49-9.9c-15.3-2.7 0-13.6-.2-34.2-.1-8-7.1-19.4-4.2-24.7s17.3-2.4 22.3-3.8 12.7-5.7 15.3-11.9c1.4-3.4 1.8-17.7 2.9-22.8 1.1-4.9 7.9-7.2 22.2.1s28.9 38.1 42.3 59.8 17.9 30.4 16.6 43.4zm118.5-65.8c2 10.3 3.2 24.5.7 36.3s-7 15.5-10.7 23c-2.2-6.8 5.3-13.8 4.4-30.8-.5-9.5-.8-7.8-11.5 1.8-12.2 10.8-27.6 20.1-53 22.5-21 2-32.5-8.3-32.5-8.3 5 16-4.3 24.7-4.3 24.7.3-3.7.8-14.3-2.5-21.6-4-9-9.3-18.7-9.3-18.7s8.6-2.7 11.6-10 2-17.3-8.7-27.7-52.5-37.6-55.9-42.1c-4.9-6.5-6.7-10.2-7-23.2s5.4-24.8 4.3-20.3c-.8 3.2.1 6.8.1 19.8s7.6 23.3 13.9 25c9.5 2.6 2-26.1 8-53.1s11.7-32.8 19.2-43.8 19.2-20.5 17-43.1-.1-20.1 5.1-11.8c4 6.5 13.3 24 24.7 22 19.4-3.3 43.9-24.6 47.6-28.2 3.7-3.6.7-7.1-2.3-5.8-15.5 6.7-44.3 21.5-51.5 18.2s-18.1-20.6-16.8-19.5c15.4 13.6 19.9 11.1 26.4 9 8.4-2.8 12.8-4.3 28.5-11.3s20.7-5.3 22.3-8.7-.4-6.7-4.7-5.7c-6.4 1.5-3.4 5.1-22.7 12.3-25.3 9.5-33.3 10.3-44 3-8.6-5.9-15-12.7-15-16.7s8.3-8.3 12.3-11.3 12.3-10.9 12.3-10.9 1-7.2-.6-12.7c-1.9-6.5-7.8-9.3-11.9-8.1-4.1 1.1-8 5.5-6.8 14.8 1 8.3 7 11 7 11s-2.7 3.5-5.2 4.7c0 0-.8-.3-3.5-6.3s-6.6-19.5-.3-31.1 19.6-5.2 23.8 3.8c3.9 8.3 2.4 22.7 2.4 22.7 6-2.2 13-2 21 3.5-7.1-29.8 9.5-41.1 22-41.1s22.3 9.6 22.3 25c0 12-3.5 18.2-6.9 22-4.1-.5-8.2-1.5-6.3-3.4 1.3-1.4 4.4-5.7 4.4-13.2s-5.9-13.7-13.7-13.7c-9.2 0-12.6 8.3-13.7 13s-.4 8.6-.2 10.4c.6 5 10.9 9.6 23.9 12.9s11.3 9 8.3 25.3 6.3 18.3 14.3 33.8 5.7 21.8 15.9 35.2 19 47.8 16.4 76.8c-.9 10.5-3.9 10.2 7.3 6.7 5.6-1.7 12-2.7 12-2.7 3.1-6.3 3.4-16.3 3.5-22.3.2-13.5.7-41.5-26.7-71.5 0 0 29.5 21.7 34 62 2.5 22.3-2 32.4-2 32.4 5.3 1.3 9.8 7.3 12.6 11.8 3.7 6.1-3.9-5.8-20-5.8-8.5 0-15.3 3.9-18.5 7.9s-3.1 7.6-3.2 11.7c-7.1-1.2-12.4 0-16.8 4.9-5.6 7-2.8 24.2-.8 34.6zm90.1 47.2c-24.1 10.4-32.7 23.5-47.7 31.5s-27.7 2.3-33.7-8 10.4-28.2 4.7-59.6c-4.4-24.2-6.3-31-4.9-36.8 1.4-5.5 9.4-4.4 11.5-3.9 1.3 5.4 6.7 19.5 27 19.5 0 0 23.2 2.6 32.7-21.2 0 0 5.7-.2 7.2 3.5 2.3 5.8-2.9 16.5-2.8 21.3.3 15.7 11.7 21.1 28.4 32 8.2 5.6 2.1 11.1-22.4 21.7z"}}]})(props);
	};
	module.exports.IoLogoTux.displayName = "IoLogoTux";
	module.exports.IoLogoTwitch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 32l-32 80v304h96v64h64l64-64h80l112-112V32H80zm336 256l-64 64h-96.001L192 416v-64h-80V80h304v208z"}},{"tag":"path","attr":{"d":"M320 143h48v129h-48zM208 143h48v129h-48z"}}]})(props);
	};
	module.exports.IoLogoTwitch.displayName = "IoLogoTwitch";
	module.exports.IoLogoTwitter = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M492 109.5c-17.4 7.7-36 12.9-55.6 15.3 20-12 35.4-31 42.6-53.6-18.7 11.1-39.4 19.2-61.5 23.5C399.8 75.8 374.6 64 346.8 64c-53.5 0-96.8 43.4-96.8 96.9 0 7.6.8 15 2.5 22.1-80.5-4-151.9-42.6-199.6-101.3-8.3 14.3-13.1 31-13.1 48.7 0 33.6 17.2 63.3 43.2 80.7-16-.4-31-4.8-44-12.1v1.2c0 47 33.4 86.1 77.7 95-8.1 2.2-16.7 3.4-25.5 3.4-6.2 0-12.3-.6-18.2-1.8 12.3 38.5 48.1 66.5 90.5 67.3-33.1 26-74.9 41.5-120.3 41.5-7.8 0-15.5-.5-23.1-1.4C62.8 432 113.7 448 168.3 448 346.6 448 444 300.3 444 172.2c0-4.2-.1-8.4-.3-12.5C462.6 146 479 129 492 109.5z"}}]})(props);
	};
	module.exports.IoLogoTwitter.displayName = "IoLogoTwitter";
	module.exports.IoLogoUsd = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M411.387 303.256c-3.119-9.577-7.891-18.561-14.301-26.952-6.422-8.382-14.396-15.826-23.93-22.331-9.539-6.498-20.721-11.63-33.553-15.4-5.143-1.363-14.189-3.506-26.104-6.418-8.516-2.074-16.5-4.2-25.5-6.367V120.065c9 2.396 15.252 6.202 21.926 10.43C324.204 139.535 333.157 155 335.78 176h69.174c-.654-18-4.65-32.76-11.996-46.02-8.07-14.543-18.977-27.024-32.73-36.956-13.75-9.922-30.225-17.49-48.377-22.455C303.967 68.416 297 66.605 288 65.386V32h-64v33.167c-7 1.044-15.148 2.445-22.426 4.25-17.242 4.283-32.388 10.868-45.951 19.764-13.571 8.905-24.352 20.112-32.604 33.627-8.251 13.523-12.312 29.52-12.312 48 0 9.585 1.407 18.993 4.157 28.235 2.752 9.241 7.442 17.967 14.042 26.181 6.603 8.214 15.495 15.658 26.687 22.332 11.183 6.672 24.705 12.064 41.576 16.171 9.287 2.345 18.83 4.534 26.83 6.576v119.586c-11-2.919-21.889-7.399-30.678-13.479-9.17-6.327-16.066-13.953-21.198-23.884-4.779-9.229-7.073-20.526-7.407-32.526H96c.695 21 5.25 39.494 13.672 55.371 8.799 16.604 20.533 29.96 35.204 40.562 14.662 10.613 31.393 18.356 51.198 23.491 8.885 2.304 18.926 3.96 27.926 5.23V480h64v-34.54c10-1.069 18.957-2.69 28.527-4.879 18.701-4.273 35.645-11.036 50.316-20.276 14.662-9.24 26.621-21.128 35.611-35.681 8.98-14.541 13.545-32.085 13.545-52.619.001-9.578-1.501-19.164-4.612-28.749zM224 209.699c-12-3.743-23.912-9.088-32.051-16.048-8.621-7.355-12.673-17.534-12.673-30.545 0-9.241 2.414-16.94 7.004-23.102 4.58-6.161 9.912-11.038 16.88-14.631 6.18-3.189 13.84-5.565 20.84-7.138v91.464zm118.902 149.772c-2.939 6.673-7.699 12.576-14.303 17.711-6.602 5.133-15.744 9.328-26.377 12.577-4.5 1.378-8.223 2.444-14.223 3.236v-107.11c10 2.624 18.18 5.332 26.326 8.131 8.062 2.744 15.748 7.443 22.537 14.116 6.785 6.676 10.309 17.03 10.309 31.06.001 6.85-1.337 13.605-4.269 20.279z"}}]})(props);
	};
	module.exports.IoLogoUsd.displayName = "IoLogoUsd";
	module.exports.IoLogoVimeo = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.9 114c-5-23.4-17.5-38.8-40.6-46.3s-64.9-4.5-94.1 16.8c-29.9 21.8-47.6 59.7-53.8 83.8 14.7-6.3 24-7.7 39-6.9s24.5 12 24.9 25.3c.3 9.8-.2 18.7-3.6 27.7-10.8 28.7-27.7 56.5-47.6 80.8-2.9 3.6-6.4 6.9-10 9.9-10.2 8.3-18.8 6.1-25.4-5.2-5.4-9.3-9-18.9-12.2-29.1-12.4-39.7-16.8-80.9-23.8-121.6-3.3-19.5-7-39.8-18-56.9-11.6-17.8-28.6-24.6-50-22-14.7 1.8-36.9 17.5-47.8 26.4 0 0-56 46.9-81.8 71.4l21.2 27s17.9-12.5 27.5-18.3c5.7-3.4 12.4-4.1 17.2.2 4.5 3.9 9.6 9 12.3 14.1 5.7 10.7 11.2 21.9 14.7 33.4 13.2 44.3 25.5 88.7 37.8 133.3 6.3 22.8 13.9 44.2 28 63.6 19.3 26.6 39.6 32.7 70.9 21.5 25.4-9.1 46.6-26.2 66-43.9 33.1-30.2 59.1-65.4 85.5-101.2 20.4-27.7 37.3-55.7 51.4-87 13.9-31 19.4-63.5 12.3-96.8z"}}]})(props);
	};
	module.exports.IoLogoVimeo.displayName = "IoLogoVimeo";
	module.exports.IoLogoVk = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M427 299.1c-8.6-8-15.7-12.8-18.5-20.5-1-2.7-1.3-4.3-1-7.6.4-6 5.5-13.8 39.6-58.9 14.2-18.8 32.7-41.5 32.7-58.5 0-11-4.5-13.7-20.8-13.7h-74c-6.5 0-10.9 8.9-13.6 16.4-2.8 7.5-8.2 19-21.4 43.8-13.8 26-32.3 48.8-40 52.4-2.2 1-3.6 1-5.5.8-1.2-.1-3.8-.8-6.2-3.7-2.3-2.8-5.9-7.7-4.5-53.9.8-25.8 3.7-43.8-1.7-54.8-1.1-2.2-3.5-4.5-4.8-5.5-7.7-5.5-29.4-7.5-48-7.5s-32.9 2.1-40 4.2c-7.1 2.1-15.1 6.9-18.9 12-2.5 3.3 4.3 1.6 10.9 4.6 4 1.8 9.3 4.6 11.2 9.3 8 20.8 9.7 37.3 5.3 66.7-1.1 7.2-2.3 18.5-6.6 25.5-2.4 3.9-7.9 3.6-9.5 3.1-16.1-4.9-28.6-26-41.2-50.7-13.1-25.8-19.8-43.9-23.4-51.3s-9.1-11.4-18.4-11.4H42.3c-5.2 0-9.9 4.3-9.9 9 0 11 18.6 43 29.8 66 20.2 41.4 46.7 81.4 82.4 120.2C182 376.3 233 384 249.3 384s29-.6 33.3-1.5c2-.4 4.1-1.3 5.7-2.5 7.1-5.5 5.8-16 6.3-24.2.5-8.4 1.4-19.5 7-26 5.2-6.1 11.1-7.8 18.6-4.1 7 3.5 12 9.4 17.2 15.1 10.1 10.9 19.3 23.2 31.3 32.2 5.5 4.1 11.5 6.7 17.9 8.7 8.5 2.6 16.5 2.7 25.3 2.3 9.7-.4 17-.3 29-.3s27.7.5 33.1-3.5c2.6-2 6-5 6-11.3 0-11.9-12.2-31.7-53-69.8z"}}]})(props);
	};
	module.exports.IoLogoVk.displayName = "IoLogoVk";
	module.exports.IoLogoWhatsapp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.062 32C138.605 32 40.134 129.701 40.134 250.232c0 41.23 11.532 79.79 31.559 112.687L32 480l121.764-38.682c31.508 17.285 67.745 27.146 106.298 27.146C381.535 468.464 480 370.749 480 250.232 480 129.701 381.535 32 260.062 32zm109.362 301.11c-5.174 12.827-28.574 24.533-38.899 25.072-10.314.547-10.608 7.994-66.84-16.434-56.225-24.434-90.052-83.844-92.719-87.67-2.669-3.812-21.78-31.047-20.749-58.455 1.038-27.413 16.047-40.346 21.404-45.725 5.351-5.387 11.486-6.352 15.232-6.413 4.428-.072 7.296-.132 10.573-.011 3.274.124 8.192-.685 12.45 10.639 4.256 11.323 14.443 39.153 15.746 41.989 1.302 2.839 2.108 6.126.102 9.771-2.012 3.653-3.042 5.935-5.961 9.083-2.935 3.148-6.174 7.042-8.792 9.449-2.92 2.665-5.97 5.572-2.9 11.269 3.068 5.693 13.653 24.356 29.779 39.736 20.725 19.771 38.598 26.329 44.098 29.317 5.515 3.004 8.806 2.67 12.226-.929 3.404-3.599 14.639-15.746 18.596-21.169 3.955-5.438 7.661-4.373 12.742-2.329 5.078 2.052 32.157 16.556 37.673 19.551 5.51 2.989 9.193 4.529 10.51 6.9 1.317 2.38.901 13.531-4.271 26.359z"}}]})(props);
	};
	module.exports.IoLogoWhatsapp.displayName = "IoLogoWhatsapp";
	module.exports.IoLogoWindows = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 265H232v179l248 36V265zM216 265H32v150l184 26.7V265zM480 32L232 67.4V249h248V32zM216 69.7L32 96v153h184V69.7z"}}]})(props);
	};
	module.exports.IoLogoWindows.displayName = "IoLogoWindows";
	module.exports.IoLogoWordpress = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M259 271.3L226.2 367h-.1l-25.4 73.1c1.8.5 3.5.9 5.3 1.4h.3c15.8 4.2 32.4 6.5 49.5 6.5 8.5 0 16.8-.5 24.9-1.8 11.2-1.4 22-3.8 32.5-7.1 2.6-.8 5.2-1.7 7.8-2.6-2.8-6-8.8-19.3-9.1-19.9L259 271.3zM80.8 180.5C70.8 203.1 64 230.9 64 256c0 6.3.3 12.6.9 18.8 6.9 71.2 52.9 131 116.1 157.9 2.6 1.1 5.3 2.2 8 3.2L96 180.6c-8-.3-9.5.2-15.2-.1z"}},{"tag":"path","attr":{"d":"M430.2 175.4c-4.3-9.3-9.4-18.2-15.1-26.6-1.6-2.4-3.4-4.8-5.1-7.2-21.5-28.8-50.8-51.4-84.9-64.6-21.4-8.4-44.8-13-69.2-13-60.3 0-114.2 28-149.4 71.7-6.5 8-12.3 16.6-17.5 25.6 14.2.1 31.8.1 33.8.1 18.1 0 46-2.2 46-2.2 9.4-.6 10.4 13.1 1.1 14.2 0 0-9.4 1.1-19.8 1.6L213 362l37.8-113.3-26.8-73.6c-9.4-.5-18.1-1.6-18.1-1.6-9.4-.5-8.2-14.8 1-14.2 0 0 28.5 2.2 45.5 2.2 18.1 0 46-2.2 46-2.2 9.3-.6 10.5 13.1 1.1 14.2 0 0-9.3 1.1-19.7 1.6l62.3 185.6 17.3-57.6c8.7-22.4 13.1-40.9 13.1-55.7 0-21.3-7.7-36.1-14.3-47.6-8.7-14.3-16.9-26.3-16.9-40.4 0-15.9 12-30.7 29-30.7h2.2c26.2-.7 34.8 25.3 35.9 43v.6c.4 7.2.1 12.5.1 18.8 0 17.4-3.3 37.1-13.1 61.8l-39 112.8-22.3 65.7c1.8-.8 3.5-1.6 5.3-2.5 56.7-27.4 98-82 106.7-146.7 1.3-8.5 1.9-17.2 1.9-26 0-28.9-6.4-56.3-17.8-80.8z"}}]})(props);
	};
	module.exports.IoLogoWordpress.displayName = "IoLogoWordpress";
	module.exports.IoLogoXbox = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M126.8 248.3c39.7-58.6 77.9-92.8 77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-.8C61.7 128.4 32 188.7 32 256c0 50.7 16.9 97.5 45.2 135 0-4.4.6-70.3 49.6-142.7zM480 256c0-67.3-29.7-127.6-76.6-168.7l-3.2.9c-50.7 18.5-92.9 67.4-92.9 67.4s38.2 34.2 77.9 92.8c49 72.4 49.6 138.3 49.5 142.7C463.2 353.5 480 306.7 480 256zM201.2 80.9c29.3 13.1 54.6 34.6 54.6 34.6s25.5-21.4 54.8-34.6c36.8-16.5 64.9-11.3 72.3-9.5C346.8 46.6 303.1 32 256 32s-90.8 14.6-126.9 39.4c7.2-1.8 35.2-7.1 72.1 9.5zM358.7 292.9C312.4 236 255.8 199 255.8 199s-56.3 37-102.7 93.9c-39.8 48.9-54.6 84.8-62.6 107.8l-1.3 4.8c41 45.7 100.5 74.5 166.8 74.5s125.8-28.8 166.8-74.5l-1.4-4.8c-8-23-22.9-58.9-62.7-107.8z"}}]})(props);
	};
	module.exports.IoLogoXbox.displayName = "IoLogoXbox";
	module.exports.IoLogoXing = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.8 303.9L469 32H365L209.4 303.8c-.4.7-.4 1.1 0 1.7l98.9 173.8c.4.7.8.7 1.6.7H413l-99.3-174.7c-.2-.3-.1-1 .1-1.4zM221.9 216.2L163 113c-.5-.8-1-1-2-1H65l58.9 104.4c.1.2.2.6.1.8L43 352h96.8c.8 0 1.2-.2 1.6-.9l80.5-133.7c.1-.3.1-.9 0-1.2z"}}]})(props);
	};
	module.exports.IoLogoXing.displayName = "IoLogoXing";
	module.exports.IoLogoYahoo = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384.6 68.4c-11.3 0-22.5-.8-32.6-4.4l-96 160-96-160c-10.1 3.6-20.7 4.4-32 4.4-11.1 0-22.1-.9-32-4.4l128 212.7V448c10-3.5 20.8-4.4 32-4.4s22 .9 32 4.4V277L416 64c-9.9 3.4-20.3 4.4-31.4 4.4z"}}]})(props);
	};
	module.exports.IoLogoYahoo.displayName = "IoLogoYahoo";
	module.exports.IoLogoYen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 32h-80L256 253.128 144 32H64l112.368 208H128v48h73.564L216 319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.891-31H384v-48h-48.289L448 32z"}}]})(props);
	};
	module.exports.IoLogoYen.displayName = "IoLogoYen";
	module.exports.IoLogoYoutube = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M508.6 148.8c0-45-33.1-81.2-74-81.2C379.2 65 322.7 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.6-.1 220.2 0 255.8c-.1 35.6 1 71.2 3.4 106.9 0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8 60.8.2 120.3-1 178.6-3.8 40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107 .2-35.6-.9-71.2-3.3-106.9zM207 353.9V157.4l145 98.2-145 98.3z"}}]})(props);
	};
	module.exports.IoLogoYoutube.displayName = "IoLogoYoutube";
	module.exports.IoMdAddCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M363 277h-86v86h-42v-86h-86v-42h86v-86h42v86h86v42z"}},{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422c-44.3 0-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256c0-44.3 17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoMdAddCircleOutline.displayName = "IoMdAddCircleOutline";
	module.exports.IoMdAddCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm107 229h-86v86h-42v-86h-86v-42h86v-86h42v86h86v42z"}}]})(props);
	};
	module.exports.IoMdAddCircle.displayName = "IoMdAddCircle";
	module.exports.IoMdAdd = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416v42.666z"}}]})(props);
	};
	module.exports.IoMdAdd.displayName = "IoMdAdd";
	module.exports.IoMdAirplane = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 336v-40L288 192V79.2c0-17.7-14.8-31.2-32-31.2s-32 13.5-32 31.2V192L64 296v40l160-48v113.6l-48 31.2V464l80-16 80 16v-31.2l-48-31.2V288l160 48z"}}]})(props);
	};
	module.exports.IoMdAirplane.displayName = "IoMdAirplane";
	module.exports.IoMdAlarm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M470 124.837l-98.443-81.78-27.814 32.931 98.442 81.769L470 124.837zM167.192 74.919L139.366 42 42 124.837l27.814 32.919 97.378-82.837zm99.509 97.709H234.6v127.446l101.649 60.539L352.3 334.06l-85.6-49.917V172.628zM256 87.665c-107 0-192.601 86.021-192.601 191.166C63.399 383.98 149 470 256 470c105.936 0 192.601-86.02 192.601-191.169 0-105.144-86.665-191.166-192.601-191.166zm0 339.855c-82.393 0-149.8-66.906-149.8-148.688 0-81.777 67.407-148.684 149.8-148.684 82.394 0 149.8 66.906 149.8 148.684 0 82.839-67.406 148.688-149.8 148.688z"}}]})(props);
	};
	module.exports.IoMdAlarm.displayName = "IoMdAlarm";
	module.exports.IoMdAlbums = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M154.7 464h266.7c23.5 0 42.7-19.2 42.7-42.7V154.7c0-23.5-19.2-42.7-42.7-42.7H154.7c-23.5 0-42.7 19.2-42.7 42.7v266.7c0 23.4 19.2 42.6 42.7 42.6z"}},{"tag":"path","attr":{"d":"M90.7 48h266.7c23.5 0 42.7 19.2 42.7 42.7V96H138.7C115.2 96 96 115.2 96 138.7V400h-5.3C67.2 400 48 380.8 48 357.3V90.7C48 67.2 67.2 48 90.7 48z"}}]})(props);
	};
	module.exports.IoMdAlbums.displayName = "IoMdAlbums";
	module.exports.IoMdAlert = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.601 48 256s93.6 208 208 208 208-93.601 208-208S370.4 48 256 48zm24 312h-48v-40h48v40zm0-88h-48V144h48v128z"}}]})(props);
	};
	module.exports.IoMdAlert.displayName = "IoMdAlert";
	module.exports.IoMdAmericanFootball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 256c14.1 35 36.2 66 64 90.6V165.4C68.2 190 46.1 221 32 256zM480 256c-14.1-35-36.2-66-64-90.6v181.2c27.8-24.6 49.9-55.6 64-90.6z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M256 105c-47.1 0-91 13.4-128 36.5v228.9c37 23.1 80.9 36.5 128 36.5s91-13.4 128-36.5V141.5c-37-23.1-80.9-36.5-128-36.5zm96 135v64h-32v-32h-48v32h-32v-32h-48v32h-32v-96h32v32h48v-32h32v32h48v-32h32v32z"}}]}]})(props);
	};
	module.exports.IoMdAmericanFootball.displayName = "IoMdAmericanFootball";
	module.exports.IoMdAnalytics = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M379.4 178.3l-87.2 133.4C299 320 303 330.5 303 342c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-3 .3-6 .8-8.9l-57.6-33.5c-8.6 8.3-20.3 13.4-33.3 13.4-8.6 0-16.6-2.3-23.6-6.2L32 364.2v57.2c0 23.5 19.2 42.7 42.7 42.7h362.7c23.5 0 42.7-19.2 42.7-42.7V208.8l-58.6-38.9c-8.1 6.3-18.3 10.1-29.4 10.1-4.4 0-8.7-.6-12.7-1.7z"}},{"tag":"path","attr":{"d":"M117 217c26.5 0 48 21.5 48 48 0 2.1-.2 4.2-.4 6.2l60.1 33.6c8.3-6.8 18.8-10.8 30.4-10.8 3.6 0 7.1.4 10.4 1.1l87.4-135.4c-5.6-7.8-8.9-17.4-8.9-27.8 0-26.5 21.5-48 48-48s48 21.5 48 48c0 3.9-.5 7.7-1.3 11.3l41.3 27.6V90.7c0-23.5-19.2-42.7-42.7-42.7H74.7C51.2 48 32 67.2 32 90.7V320l40-38.3c-1.9-5.2-3-10.8-3-16.7 0-26.5 21.5-48 48-48z"}}]})(props);
	};
	module.exports.IoMdAnalytics.displayName = "IoMdAnalytics";
	module.exports.IoMdAperture = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.288 32 32 132.288 32 256s100.288 224 224 224 224-100.288 224-224S379.712 32 256 32zm135.765 359.765C355.5 428.028 307.285 448 256 448s-99.5-19.972-135.765-56.235C83.972 355.5 64 307.285 64 256s19.972-99.5 56.235-135.765C156.5 83.972 204.715 64 256 64s99.5 19.972 135.765 56.235C428.028 156.5 448 204.715 448 256s-19.972 99.5-56.235 135.765z"}},{"tag":"path","attr":{"d":"M200.043 106.067c-40.631 15.171-73.434 46.382-90.717 85.933H256l-55.957-85.933zM412.797 288A160.723 160.723 0 0 0 416 256c0-36.624-12.314-70.367-33.016-97.334L311 288h101.797zM359.973 134.395C332.007 110.461 295.694 96 256 96c-7.966 0-15.794.591-23.448 1.715L310.852 224l49.121-89.605zM99.204 224A160.65 160.65 0 0 0 96 256c0 36.639 12.324 70.394 33.041 97.366L201 224H99.204zM311.959 405.932c40.631-15.171 73.433-46.382 90.715-85.932H256l55.959 85.932zM152.046 377.621C180.009 401.545 216.314 416 256 416c7.969 0 15.799-.592 23.456-1.716L201.164 288l-49.118 89.621z"}}]})(props);
	};
	module.exports.IoMdAperture.displayName = "IoMdAperture";
	module.exports.IoMdApps = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 176h80V96H96v80zm120 240h80v-80h-80v80zm-120 0h80v-80H96v80zm0-120h80v-80H96v80zm120 0h80v-80h-80v80zM336 96v80h80V96h-80zm-120 80h80V96h-80v80zm120 120h80v-80h-80v80zm0 120h80v-80h-80v80z"}}]})(props);
	};
	module.exports.IoMdApps.displayName = "IoMdApps";
	module.exports.IoMdAppstore = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 152H360c0-57-46.562-103.859-104-103.859S152 95 152 152H48c18.688 216 13 312 13 312h389.999c-.001 0-5.688-98 13.001-312zM256 74.105c43.008 0 77.999 34.895 77.999 77.895H178c0-43 34.991-77.895 78-77.895zM204 397.64V228.867l142.999 84.387L204 397.64z"}}]})(props);
	};
	module.exports.IoMdAppstore.displayName = "IoMdAppstore";
	module.exports.IoMdArchive = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.594 100.001l-32.353-39.299C415.469 52.627 405.083 48 394.664 48H117.335c-10.416 0-20.801 4.627-26.576 12.702l-32.351 39.299C51.468 106.923 48 117.335 48 128.886v288.89C48 443.2 68.8 464 94.225 464h323.553C443.202 464 464 443.2 464 417.775v-288.89c0-11.55-3.463-21.962-10.406-28.884zM256 383.109L128.89 256h80.89v-46.224h92.443V256h80.89L256 383.109zM96.534 94.221L115.02 71.11h277.331l21.965 23.111H96.534z"}}]})(props);
	};
	module.exports.IoMdArchive.displayName = "IoMdArchive";
	module.exports.IoMdArrowBack = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M427 234.625H167.296l119.702-119.702L256 85 85 256l171 171 29.922-29.924-118.626-119.701H427v-42.75z"}}]})(props);
	};
	module.exports.IoMdArrowBack.displayName = "IoMdArrowBack";
	module.exports.IoMdArrowDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.375 85v259.704l119.702-119.702L427 256 256 427 85 256l29.924-29.922 119.701 118.626V85h42.75z"}}]})(props);
	};
	module.exports.IoMdArrowDown.displayName = "IoMdArrowDown";
	module.exports.IoMdArrowDropdownCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm0 272l-96-96h192l-96 96z"}}]})(props);
	};
	module.exports.IoMdArrowDropdownCircle.displayName = "IoMdArrowDropdownCircle";
	module.exports.IoMdArrowDropdown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 192l128 128 128-128z"}}]})(props);
	};
	module.exports.IoMdArrowDropdown.displayName = "IoMdArrowDropdown";
	module.exports.IoMdArrowDropleftCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.875-93.125-208-208-208S48 141.125 48 256s93.125 208 208 208 208-93.125 208-208zm-272 0l96-96v192l-96-96z"}}]})(props);
	};
	module.exports.IoMdArrowDropleftCircle.displayName = "IoMdArrowDropleftCircle";
	module.exports.IoMdArrowDropleft = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 128L192 256l128 128z"}}]})(props);
	};
	module.exports.IoMdArrowDropleft.displayName = "IoMdArrowDropleft";
	module.exports.IoMdArrowDroprightCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.875 0 208-93.125 208-208S370.875 48 256 48 48 141.125 48 256s93.125 208 208 208zm-32-112V160l96 96-96 96z"}}]})(props);
	};
	module.exports.IoMdArrowDroprightCircle.displayName = "IoMdArrowDroprightCircle";
	module.exports.IoMdArrowDropright = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 128l128 128-128 128z"}}]})(props);
	};
	module.exports.IoMdArrowDropright.displayName = "IoMdArrowDropright";
	module.exports.IoMdArrowDropupCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.875-93.125-208-208-208S48 141.125 48 256s93.125 208 208 208 208-93.125 208-208zm-112 32H160l96-96 96 96z"}}]})(props);
	};
	module.exports.IoMdArrowDropupCircle.displayName = "IoMdArrowDropupCircle";
	module.exports.IoMdArrowDropup = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 320l128-128 128 128z"}}]})(props);
	};
	module.exports.IoMdArrowDropup.displayName = "IoMdArrowDropup";
	module.exports.IoMdArrowForward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M85 277.375h259.704L225.002 397.077 256 427l171-171L256 85l-29.922 29.924 118.626 119.701H85v42.75z"}}]})(props);
	};
	module.exports.IoMdArrowForward.displayName = "IoMdArrowForward";
	module.exports.IoMdArrowRoundBack = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M401.4 224h-214l83-79.4c11.9-12.5 11.9-32.7 0-45.2s-31.2-12.5-43.2 0L89 233.4c-6 5.8-9 13.7-9 22.4v.4c0 8.7 3 16.6 9 22.4l138.1 134c12 12.5 31.3 12.5 43.2 0 11.9-12.5 11.9-32.7 0-45.2l-83-79.4h214c16.9 0 30.6-14.3 30.6-32 .1-18-13.6-32-30.5-32z"}}]})(props);
	};
	module.exports.IoMdArrowRoundBack.displayName = "IoMdArrowRoundBack";
	module.exports.IoMdArrowRoundDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M99.4 284.9l134 138.1c5.8 6 13.7 9 22.4 9h.4c8.7 0 16.6-3 22.4-9l134-138.1c12.5-12 12.5-31.3 0-43.2-12.5-11.9-32.7-11.9-45.2 0l-79.4 83v-214c0-16.9-14.3-30.6-32-30.6-18 0-32 13.7-32 30.6v214l-79.4-83c-12.5-11.9-32.7-11.9-45.2 0s-12.5 31.2 0 43.2z"}}]})(props);
	};
	module.exports.IoMdArrowRoundDown.displayName = "IoMdArrowRoundDown";
	module.exports.IoMdArrowRoundForward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M284.9 412.6l138.1-134c6-5.8 9-13.7 9-22.4v-.4c0-8.7-3-16.6-9-22.4l-138.1-134c-12-12.5-31.3-12.5-43.2 0-11.9 12.5-11.9 32.7 0 45.2l83 79.4h-214c-17 0-30.7 14.3-30.7 32 0 18 13.7 32 30.6 32h214l-83 79.4c-11.9 12.5-11.9 32.7 0 45.2 12 12.5 31.3 12.5 43.3 0z"}}]})(props);
	};
	module.exports.IoMdArrowRoundForward.displayName = "IoMdArrowRoundForward";
	module.exports.IoMdArrowRoundUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M412.6 227.1L278.6 89c-5.8-6-13.7-9-22.4-9h-.4c-8.7 0-16.6 3-22.4 9l-134 138.1c-12.5 12-12.5 31.3 0 43.2 12.5 11.9 32.7 11.9 45.2 0l79.4-83v214c0 16.9 14.3 30.6 32 30.6 18 0 32-13.7 32-30.6v-214l79.4 83c12.5 11.9 32.7 11.9 45.2 0s12.5-31.2 0-43.2z"}}]})(props);
	};
	module.exports.IoMdArrowRoundUp.displayName = "IoMdArrowRoundUp";
	module.exports.IoMdArrowUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.375 427V167.296l119.702 119.702L427 256 256 85 85 256l29.924 29.922 119.701-118.626V427h42.75z"}}]})(props);
	};
	module.exports.IoMdArrowUp.displayName = "IoMdArrowUp";
	module.exports.IoMdAt = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M265.6 212.3c-10.5 0-18.5 4.4-24 13.2-5.5 8.8-9.1 22-10.8 39.6-.9 11.7 0 20.5 2.7 26.5s7.1 9 13.1 9c5.5 0 10.3-1.5 14.6-4.4 4.3-2.9 8.1-8.3 11.3-16.2l6.1-66c-2.2-.5-4.4-.9-6.5-1.2-2.3-.4-4.4-.5-6.5-.5z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm127.8 201.9c-.9 21.4-7.6 39.9-20 55.6-12.4 15.6-31 23.4-55.6 23.4-8.2 0-15.3-2.2-21.2-6.6-6-4.4-10.2-10.7-12.6-18.8-4.1 8.3-9.4 14.5-15.7 18.6-6.3 4.1-13.7 6.2-22.2 6.2-15.1 0-26.6-5.8-34.6-17.3s-10.9-26.8-8.8-45.9c2.6-24.4 10-44 22.2-58.7 12.2-14.7 27-22 44.4-22 12.2 0 22.1 1.3 29.5 3.8 7.4 2.5 15.6 5.7 24.5 11l-.5-.1h.8l-7.7 83.4c-.5 8.5.1 14.6 1.7 17.8 1.7 3.2 3.9 4.9 6.7 4.9 11.3 0 20.4-5.1 27.2-15.6 6.8-10.5 10.6-23.6 11.4-39.6 1.6-33-5.1-58.7-20.2-77.1-15.1-18.4-38.3-27.7-69.7-27.7-30.5 0-54.8 9.9-72.8 29.8s-27.7 46.9-29.3 81.2c-1.7 33.4 5.6 59.8 21.9 79.1 16.3 19.4 39.7 29.1 70.3 29.1 8.5 0 17.3-.9 26.5-2.7 9.1-1.8 17.1-4.1 23.7-6.8l5.8 24.2c-6.8 4.1-15.4 7.3-25.9 9.6-10.5 2.3-20.7 3.4-30.7 3.4-40.8 0-72.3-12.1-94.3-36.4-22-24.2-32.2-57.4-30.5-99.6 1.8-41.8 14.9-74.9 39.1-99.4 24.3-24.5 56.5-36.7 96.7-36.7 39.5 0 69.8 11.6 90.7 34.7 21.2 23.2 30.8 54.9 29.2 95.2z"}}]})(props);
	};
	module.exports.IoMdAt.displayName = "IoMdAt";
	module.exports.IoMdAttach = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.334 128v234.666C341.334 409.604 302.938 448 256 448c-46.937 0-85.333-38.396-85.333-85.334V117.334C170.667 87.469 194.135 64 224 64c29.864 0 53.333 23.469 53.333 53.334v245.333c0 11.729-9.605 21.333-21.334 21.333s-21.333-9.604-21.333-21.333V160h-32v202.667C202.667 392.531 226.135 416 256 416c29.865 0 53.334-23.469 53.334-53.333V117.334C309.334 70.401 270.938 32 224 32s-85.334 38.401-85.334 85.334v245.332C138.667 427.729 190.938 480 256 480c65.062 0 117.334-52.271 117.334-117.334V128h-32z"}}]})(props);
	};
	module.exports.IoMdAttach.displayName = "IoMdAttach";
	module.exports.IoMdBackspace = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M433.5 96H167.2c-12.2 0-21.8 6.2-28.2 15.6L43 256l96 144.2c6.4 9.4 16 15.8 28.2 15.8h266.2c19.5 0 35.5-16 35.5-35.6V131.6C469 112 453 96 433.5 96zm-53.3 223.8l-25 25.1-63.7-63.8-63.7 63.8-25-25.1 63.7-63.8-63.7-63.8 25-25.1 63.7 63.8 63.7-63.8 25 25.1-63.7 63.8 63.7 63.8z"}}]})(props);
	};
	module.exports.IoMdBackspace.displayName = "IoMdBackspace";
	module.exports.IoMdBarcode = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M88 128h48v256H88zM232 128h48v256h-48zM160 144h48v224h-48zM304 144h48v224h-48zM376 128h48v256h-48z"}},{"tag":"path","attr":{"d":"M104 104V56H16v400h88v-48H64V104zM408 56v48h40v304h-40v48h88V56z"}}]})(props);
	};
	module.exports.IoMdBarcode.displayName = "IoMdBarcode";
	module.exports.IoMdBaseball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M365.9 402.6L343 416.1l-16-28 20.2-11.9c-5.2-8.5-9.8-17.4-13.9-26.7-1.4-3.1-2.7-6.3-3.9-9.5l-25.1 5.8-7.1-31.6 22.6-5.2c-2.8-12.1-4.7-24-5.5-37H290v-32h24.3c.8-12 2.7-24.8 5.5-36.8l-22.6-5.2 7.1-31.6 25.1 5.8c1.3-3.2 2.6-6.4 4-9.6 4.1-9.2 8.7-18.1 13.8-26.6L327 124.1l16-28 22.8 13.5c5.2-6.4 10.8-12.5 16.7-18.3C347.4 64.1 303.5 48 256 48s-91.4 16.1-126.5 43.2c5.9 5.8 11.5 12 16.7 18.3L169 96.1l16 28-20.2 11.9c5.1 8.5 9.8 17.4 13.8 26.6 1.4 3.2 2.7 6.4 4 9.6l25.1-5.8 7.1 31.6-22.6 5.2c2.8 12.1 4.6 24.8 5.5 36.8H222v32h-24.3c-.8 13-2.7 24.9-5.5 37l22.6 5.2-7.1 31.6-25.1-5.8c-1.2 3.2-2.5 6.3-3.9 9.5-4.1 9.2-8.7 18.1-13.9 26.7l20.2 11.9-16 28-22.9-13.5c-5.2 6.3-10.7 12.4-16.6 18.2 35.1 27.1 79 43.2 126.5 43.2s91.4-16.1 126.5-43.2c-5.9-5.8-11.4-11.9-16.6-18.2z"}},{"tag":"path","attr":{"d":"M393.8 126l18.1 10.7-16 28-21.2-12.5c-5 8.3-9.5 16.9-13.3 25.9-.2.4-.4.9-.5 1.3l21 4.9-7.1 31.6-23.9-5.5c-2.3 9.7-3.8 19.6-4.6 29.6H370v32h-23.6c.8 10 2.3 20 4.6 29.8l23.9-5.5 7.1 31.6-21 4.9c.2.4.3.8.5 1.2 3.8 9 8.3 17.7 13.3 26l21.1-12.4 16 28-18 10.6c3.3 3.9 6.8 7.7 10.5 11.3l2 2C442 362 464 311.4 464 256s-22-106-57.7-143.4c-.7.7-1.4 1.3-2 2-3.7 3.7-7.2 7.5-10.5 11.4zM118.2 386.1l-18-10.6 16-28 21.1 12.4c5.1-8.3 9.5-17 13.3-26 .2-.4.3-.8.5-1.2l-21-4.9 7.1-31.6 23.9 5.5c2.3-9.8 3.8-19.8 4.6-29.8H142v-32h23.6c-.8-10-2.3-19.9-4.6-29.6l-23.9 5.5-7.1-31.6 21-4.9c-.2-.4-.3-.9-.5-1.3-3.8-9-8.2-17.7-13.3-25.9L116 164.6l-16-28 18.1-10.7c-3.4-3.9-6.9-7.7-10.6-11.4l-2-2C70 150 48 200.6 48 256s22 106 57.7 143.4c.7-.7 1.4-1.3 2-2 3.6-3.6 7.1-7.4 10.5-11.3z"}}]})(props);
	};
	module.exports.IoMdBaseball.displayName = "IoMdBaseball";
	module.exports.IoMdBasket = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.1 205.2L272.9 72.5C269 66.8 262.5 64 256 64c-6.5 0-13 2.8-16.9 8.7l-89.2 132.5H52.4c-11.2 0-20.4 9.1-20.4 20.2 0 1.8.2 3.6.8 5.5l51.7 187.5c4.7 17 20.4 29.5 39.1 29.5h264.7c18.7 0 34.4-12.5 39.3-29.5l51.7-187.5.6-5.5c0-11.1-9.2-20.2-20.4-20.2h-97.4zm-167.2 0l61.1-89 61.1 89H194.9zM256 367.1c-22.4 0-40.7-18.2-40.7-40.5s18.3-40.5 40.7-40.5 40.7 18.2 40.7 40.5-18.3 40.5-40.7 40.5z"}}]})(props);
	};
	module.exports.IoMdBasket.displayName = "IoMdBasket";
	module.exports.IoMdBasketball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M191.6 272c-3.8 55-26.4 107.1-64.5 147.7 31.6 25 70.9 41 112.9 44.3V272h-48.4zM272 464c42-3.3 81.5-19.4 113.1-44.5-38-40.6-60.5-92.5-64.3-147.5H272v192zM240 48c-42 3.2-80.5 19-111.9 43.6 38 40.9 60.3 93.4 63.7 148.4H240V48zM320.7 240c3.4-55 25.6-107.4 63.5-148.3C352.7 67.1 314 51.2 272 48v192h48.7zM408.6 114.2c-17.2 18.5-30.7 39.7-40.1 62.9-8.2 20.2-13.1 40.9-14.6 62.9H464c-3.7-48-24.1-92.2-55.4-125.8zM368.5 333.1c9.6 23.7 23.3 45.1 40.9 63.8C440.3 363.4 460.3 320 464 272H354.1c1.6 21 6.5 41.5 14.4 61.1zM143.9 177.1c-9.5-23.3-23-44.5-40.3-63.1-31.4 33.6-51.9 78-55.6 126h110.5c-1.6-22-6.5-42.8-14.6-62.9zM102.7 397.1c17.7-18.8 31.5-40.3 41.1-64 8-19.6 12.8-40.1 14.5-61.1H48c3.7 48 23.8 91.6 54.7 125.1z"}}]})(props);
	};
	module.exports.IoMdBasketball.displayName = "IoMdBasketball";
	module.exports.IoMdBatteryCharging = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.2 76.8h-37.4V32h-89.6v44.8h-37.4c-16.4 0-29.8 13.4-29.8 29.8V450c0 16.6 13.4 30 29.8 30H338c16.6 0 30-13.4 30-29.8V106.6c0-16.4-13.4-29.8-29.8-29.8zM233.6 435.2V312h-44.8l89.6-168v123.2h44.8l-89.6 168z"}}]})(props);
	};
	module.exports.IoMdBatteryCharging.displayName = "IoMdBatteryCharging";
	module.exports.IoMdBatteryDead = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.2 76.8h-37.4V32h-89.6v44.8h-37.4c-16.4 0-29.8 13.4-29.8 29.8V450c0 16.6 13.4 30 29.8 30H338c16.6 0 30-13.4 30-29.8V106.6c0-16.4-13.4-29.8-29.8-29.8zM320 432H192V124.8h128V432z"}}]})(props);
	};
	module.exports.IoMdBatteryDead.displayName = "IoMdBatteryDead";
	module.exports.IoMdBatteryFull = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.2 76.8h-37.4V32h-89.6v44.8h-37.4c-16.4 0-29.8 13.4-29.8 29.8V450c0 16.6 13.4 30 29.8 30H338c16.6 0 30-13.4 30-29.8V106.6c0-16.4-13.4-29.8-29.8-29.8z"}}]})(props);
	};
	module.exports.IoMdBatteryFull.displayName = "IoMdBatteryFull";
	module.exports.IoMdBeaker = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448.1 34.9c0-1.2-.4-2.9-2.9-2.9H128.5c-54.3 0-64.4 27.4-64.4 39.8C94.4 76 96 76.5 96 108.5v307c0 35.3 28.9 64.5 64.3 64.5H368c35.3 0 64-29.2 64-64.5V73.3c2.2-17.5 12-31.8 13.1-33.5 1.2-1.9 3-3.8 3-4.9zM354.2 432H176.3c-15.9 0-29.7-11.9-32.3-27.1V80h240v319.7c0 18-12.4 32.3-29.8 32.3z"}},{"tag":"path","attr":{"d":"M182 160v226c0 4.4 3.6 8 8 8h148c4.4 0 8-3.6 8-8V160H182z"}}]})(props);
	};
	module.exports.IoMdBeaker.displayName = "IoMdBeaker";
	module.exports.IoMdBed = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.7 264.5c29 0 52.4-22.9 52.4-51.2s-23.4-51.2-52.4-51.2-52.4 22.9-52.4 51.2 23.5 51.2 52.4 51.2zm209.5-102.4H238.5v119.5H98.9V128H64v256h34.9v-51.2h314.2V384H448V230.4c0-37.7-31.2-68.3-69.8-68.3z"}}]})(props);
	};
	module.exports.IoMdBed.displayName = "IoMdBed";
	module.exports.IoMdBeer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 140h-16v-6c8.9-9 16-22.9 16-38 0-35.3-28.7-64-64-64-16.3 0-31.1 6.1-42.4 16.1C297.2 38 281.4 32 264.2 32c-15.8 0-30.4 5.1-42.3 13.7C212 37.2 199 32 184.9 32c-17.1 0-32.4 7.6-42.8 19.5-11.7-12-28-19.5-46.1-19.5-35.3 0-64 28.7-64 64 0 16.2 6.1 31 16 42.3V193c0 26.5 21.5 48 48 48v174.5c0 35.3 28.8 64.5 64.2 64.5H336c35.3 0 64.1-29.2 64.1-64.5V372h16c50 0 64-32.7 64-68v-96c-.1-35.3-17.1-68-64.1-68zm-64 52H144v-53.7c.3-.4.7-.8 1-1.2 1.2-1.5 2.4-3 3.5-4.6 1.5 1.2 3 2.4 4.6 3.4 9.1 6.1 20 9.7 31.7 9.7 6.4 0 12.6-1.1 18.3-3 12.8 20.2 35.3 33.7 61 33.7 22 0 41.7-9.9 54.9-25.4 5.7-6.7 10.2-14.4 13.1-22.9H352v64zM96 128.1v75c-9 0-16-7.2-16-16v-63.3c-8-4.5-13.4-12.1-15.3-21-.5-2.1-.7-4.4-.7-6.7 0-17.6 14.4-32 32-32 11.8 0 23.3 7.7 30.1 15.4s26.7 7.7 33.9 0c6.8-7.3 14.3-15.4 24.8-15.4 6 0 11.6 2.2 15.9 5.8 1.9 1.6 3.6 3.5 4.9 5.6 1.1 1.8 2 4.2 3.1 5.8 2.7 3.4 6.5 5.5 11.2 5.5 4.4 0 8.3-1.9 11-5 .6-.7 1.2-1.5 1.7-2.3 2-2.5 4.2-4.8 6.7-6.8 6.8-5.4 15.5-8.6 24.8-8.6 10.6 0 20.2 4.1 27.4 10.9 1.7 1.6 6.7 4.5 13.2 5.1 4.5.4 6.1.3 8.2 0 10.3-1.3 14.4-4.7 16.4-6.6 5.8-5.8 13.8-9.4 22.6-9.4 17.6 0 32 14.4 32 32 .2 3.1-.3 6.2-1.2 9.1-2.5-5.5-8.1-9.2-14.6-9.2h-55s-8.7-.7-8.7 8.2c0 8.9-2.9 17.1-7.8 23.7-7.3 9.9-19.1 16.4-32.4 16.4-14.9 0-27.9-8.1-34.8-20.2-1.6-2.7-2.8-5.6-3.7-8.6-.1-.6-.3-1.1-.4-1.6-2-5.9-7.5-10.2-14.1-10.2-3.9 0-7.5 1.5-10.2 4l-.1.1c-2.4 2.1-5.3 3.7-8.4 4.7-2.4.8-5 1.2-7.7 1.2-7.5 0-14.7-4-18.8-8.6-10-11.4-23.7-6.8-29.7-5.5-6 1.3-12.2 11.7-12.2 11.7-1.1 2.1-2.4 4-3.9 5.8-6 6.7-15.2 11-24.2 11zM432 304c0 17.7-6.3 24-24 24h-8V184h8c17.7 0 24 6.3 24 24v96z"}}]})(props);
	};
	module.exports.IoMdBeer.displayName = "IoMdBeer";
	module.exports.IoMdBicycle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330.666 131.202c18.668 0 33.598-14.935 33.598-33.601S349.334 64 330.666 64C312 64 297.07 78.935 297.07 97.601s14.93 33.601 33.596 33.601zm56 130.132c-51.332 0-93.332 42-93.332 93.333s42 93.333 93.332 93.333C438 448 480 406 480 354.667s-42-93.333-93.334-93.333zm0 158.666c-36.402 0-65.332-28.93-65.332-65.333s28.93-65.333 65.332-65.333c36.404 0 65.334 28.93 65.334 65.333S423.07 420 386.666 420zm-81.069-196H384v-32h-58.845l-34.62-60.134c-5.605-9.333-15.869-15.864-27.07-15.864-8.399 0-16.798 3.732-22.399 9.333L169.334 194.4c-5.601 5.601-9.333 14-9.333 22.399 0 12.131 9.202 21.465 18.535 27.065L240 282.134V368h32V256l-39.333-32 42.929-44.533L305.597 224zm-180.264 37.334C74 261.334 32 303.334 32 354.667S74 448 125.333 448s93.333-42 93.333-93.333-41.999-93.333-93.333-93.333zm0 158.666C88.934 420 60 391.07 60 354.667s28.934-65.333 65.333-65.333 65.333 28.93 65.333 65.333S161.732 420 125.333 420z"}}]})(props);
	};
	module.exports.IoMdBicycle.displayName = "IoMdBicycle";
	module.exports.IoMdBluetooth = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399 159.9L270.5 32H248v170L144.7 99.2 113 130.8 238.8 256 113 381.2l31.7 31.6L248 310v170h22.5L399 352.1 302.2 256l96.8-96.1zm-106-42.1l42.3 42.1L293 202v-84.2zm42.3 234.3L293 394.2V310l42.3 42.1z"}}]})(props);
	};
	module.exports.IoMdBluetooth.displayName = "IoMdBluetooth";
	module.exports.IoMdBoat = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M84.255 413h1.063c34.123 0 63.977-19.021 85.305-42.494 21.325 23.473 51.18 42.762 85.304 42.762s63.979-19.334 85.305-42.806C362.559 393.934 392.412 413 426.535 413h1.062l51.253-138.78c2.126-5.329 1.063-11.641-1.07-16.976-2.136-5.333-7.237-8.487-12.567-10.623L427 234.133v-98.15C427 112.51 407.344 93 383.884 93h-63.979l-15.993-53h-95.969l-15.995 53h-63.979C104.511 93 85 112.51 85 135.982v98.15l-38.074 12.533c-5.33 2.136-10.582 5.334-12.718 10.667-2.135 5.335-3.158 10.49-1.031 16.887L84.255 413zM128 136h256v84.261l-128-41.605-128 41.605V136z"}},{"tag":"path","attr":{"d":"M341.231 408.007c-52.253 36.267-118.356 36.258-170.608-.009 0 0-57.638 64.002-106.632 64.002h21.327c29.854 0 58.646-11.726 85.305-25.594 53.315 27.734 117.293 27.728 170.608-.007C367.89 460.268 396.681 472 426.535 472h21.328c-47.651 0-106.632-63.993-106.632-63.993z"}}]})(props);
	};
	module.exports.IoMdBoat.displayName = "IoMdBoat";
	module.exports.IoMdBody = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c22 0 40 18 40 40s-18 40-40 40-40-18-40-40 18-40 40-40zm192 144.1H320V464h-42.7V320h-42.7v144H192V192.1H64v-42.7h384v42.7z"}}]})(props);
	};
	module.exports.IoMdBody.displayName = "IoMdBody";
	module.exports.IoMdBonfire = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272.2 350.6c-.8-8.2-8.2-14.6-17.3-14.6-8.3 0-15.2 5.4-16.9 12.5L221.1 441c-.5 2.3-.8 4.6-.8 7 0 17.7 15.5 32 34.7 32s34.7-14.3 34.7-32c0-2.9-.4-5.7-1.2-8.4l-16.3-89zM310.1 355zM404.3 390.3c-1.9-1.4-3.6-2.9-5.6-3.9l-68.9-47.5c-6.3-3.8-13-3.7-17.9.9-4.5 4.1-5.1 10.4-1.8 15.4l53 65.8c1 1.5 2.3 2.8 3.6 4.2 8.5 9.1 27.2 9.6 37.5 0 10.4-9.8 10.3-27.2.1-34.9zM382.2 335zM450.4 322.5l-64.5-2.3c-4.2-.6-8 2.1-8.7 6-.7 3.6 1.5 7.1 5.1 8.8h.1l62.5 17.8c9 1.9 19.1-2.3 19.1-11.6 0-11.9-3.3-17.5-13.6-18.7zM129.5 335zM129.5 335c3.6-1.6 5.7-5.2 5.1-8.8-.7-4-4.5-6.6-8.7-6l-64.5 2.3C51 323.7 48 329.3 48 341.1c0 9.3 9.9 13.6 18.8 11.6l62.5-17.8c.1.1.1.1.2.1zM182.2 338.8l-68.9 47.4c-2 1.1-3.9 2.4-5.6 3.9-10.4 9.6-10.4 25.1 0 34.6 10.4 9.6 27.1 9.6 37.5 0 1.4-1.3 2.6-2.7 3.6-4.2l53-65.6c3.3-5 2.7-11.2-1.8-15.3-4.8-4.5-12.6-4.8-17.8-.8zM256 32s30.2 35.4 30.2 64.4c0 27.8-18.2 50.3-45.9 50.3-27.9 0-48.9-22.5-48.9-50.3l.4-6.9c-27.2 32.3-43.5 76.2-43.5 121.8 0 59.6 48.2 107.8 107.8 107.8s107.8-48.2 107.8-107.8C363.8 138.7 328 53.7 256 32zm-3.9 246.7c-24 0-43.4-18.9-43.4-42.3 0-21.8 14.1-37.2 37.9-42 23.8-4.9 48.5-16.3 62.3-34.8 5.3 17.4 7.9 35.7 7.9 54.4 0 35.7-29 64.7-64.7 64.7z"}}]})(props);
	};
	module.exports.IoMdBonfire.displayName = "IoMdBonfire";
	module.exports.IoMdBook = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.2 80.4l-170.2 32-170.2-32C64 77 48 97.3 48 118v244.5c0 20.7 16 32.6 37.8 37.6L256 432l170.2-32c21.8-5 37.8-16.9 37.8-37.6V118c0-20.7-16-41-37.8-37.6zm0 282l-151.2 32V149.9l151.2-32v244.5zm-189.2 32l-151.2-32V118L237 150v244.4z"}}]})(props);
	};
	module.exports.IoMdBook.displayName = "IoMdBook";
	module.exports.IoMdBookmark = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360 64H152c-22.002 0-40 17.998-40 40v344l144-64 144 64V104c0-22.002-17.998-40-40-40z"}}]})(props);
	};
	module.exports.IoMdBookmark.displayName = "IoMdBookmark";
	module.exports.IoMdBookmarks = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.2 64h-21c15 5.7 22.8 20.6 22.8 42.7v298.7c0 22.1-7 37.3-22.8 42.7h21c23.7 0 42.8-19.2 42.8-42.7V106.7c0-23.5-19.1-42.7-42.8-42.7zM345.5 64.2c-1.4-.1-2.8-.2-4.2-.2H106.7C83.2 64 64 83.2 64 106.7v298.7c0 23.5 19.2 42.7 42.7 42.7h234.7c1.4 0 2.8-.1 4.2-.2 21.5-2.1 38.5-20.4 38.5-42.5V106.7c-.1-22.1-17.1-40.4-38.6-42.5zM208 256l-56-32-56 32V96h112v160z"}}]})(props);
	};
	module.exports.IoMdBookmarks.displayName = "IoMdBookmarks";
	module.exports.IoMdBowtie = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M276 304h-40c-15.4 0-28-12.6-28-28v-40c0-15.4 12.6-28 28-28h40c15.4 0 28 12.6 28 28v40c0 15.4-12.6 28-28 28zM176 280v-48c0-18.2 8.7-34.4 22.2-44.6C192 160 96 96 64 96c-17.6 0-32 14.4-32 32v256c0 17.6 14.3 32 32 32 32 0 128-64 134.2-91.4-13.5-10.2-22.2-26.4-22.2-44.6zM448 96c-32 0-128 64-134.2 91.4 13.5 10.2 22.2 26.4 22.2 44.6v48c0 18.2-8.7 34.4-22.2 44.6C320 352 416 416 448 416c17.7 0 32-14.4 32-32V128c0-17.6-14.4-32-32-32z"}}]})(props);
	};
	module.exports.IoMdBowtie.displayName = "IoMdBowtie";
	module.exports.IoMdBriefcase = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 144v-39.6C352 82 334 64 311.6 64H200.4C178 64 160 82 160 104.4V144H48v263.6C48 430 66 448 88.4 448h335.2c22.4 0 40.4-18 40.4-40.4V144H352zm-40 0H200v-40h112v40z"}}]})(props);
	};
	module.exports.IoMdBriefcase.displayName = "IoMdBriefcase";
	module.exports.IoMdBrowsers = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 64H88c-26.6 0-48 21.6-48 48v288c0 26.4 21.4 48 48 48h336c26.4 0 48-21.6 48-48V112c0-26.4-21.4-48-48-48zm0 336H88V176h336v224z"}}]})(props);
	};
	module.exports.IoMdBrowsers.displayName = "IoMdBrowsers";
	module.exports.IoMdBrush = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.9 302.2c-39.1 0-70.7 31-70.7 69.3 0 30.3-27.3 46.2-47.2 46.2C53.7 446 90.7 464 126.3 464c52.1 0 94.3-41.4 94.3-92.4 0-38.4-31.6-69.4-70.7-69.4zM473.1 85.7l-31.6-31c-9.2-9-24-9-33.2 0L197 261.8l64.8 63.5 211.2-207c9.3-9 9.3-23.6.1-32.6z"}}]})(props);
	};
	module.exports.IoMdBrush.displayName = "IoMdBrush";
	module.exports.IoMdBug = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 160h-67.4c-10.8-18.7-25.7-34.8-43.7-47L376 73.8 342.2 40l-52.1 52.1C279 89.4 267.8 88 256 88s-23 1.4-33.8 4.1L169.8 40 136 73.8l38.9 39.1c-17.8 12.2-32.6 28.3-43.4 47H64v48h50.2c-1.2 7.9-2.2 15.8-2.2 24v24H64v48h48v24c0 8.2 1 16.1 2.2 24H64v48h67.4c25 43 71.3 72 124.6 72s99.6-29 124.6-72H448v-48h-50.2c1.2-7.9 2.2-15.8 2.2-24v-24h48v-48h-48v-24c0-8.2-1-16.1-2.2-24H448V160z"}}]})(props);
	};
	module.exports.IoMdBug.displayName = "IoMdBug";
	module.exports.IoMdBuild = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.1 398.2L289.1 212c18.3-47 8.1-102.3-30.5-141.1C217.9 30 156.9 21.8 108.1 44.3l87.4 88-61 61.4-89.5-88c-24.3 49-14.1 110.4 26.5 151.3 38.6 38.9 93.5 49.1 140.3 30.7l185 186.2c8.1 8.2 20.3 8.2 28.5 0l46.8-47c10.2-8.3 10.2-22.6 2-28.7z"}}]})(props);
	};
	module.exports.IoMdBuild.displayName = "IoMdBuild";
	module.exports.IoMdBulb = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 428c0 10.6 8.6 20 20 20h88c11.4 0 20-9.4 20-20v-18H192v18zm64-364c-79.7 0-144 59.9-144 134 0 45.7 24.1 86.2 61.4 110.6V352c0 10.6 9.3 19.2 20.6 19.2h123.9c11.4 0 20.6-8.6 20.6-19.2v-43.4C375.9 284.2 400 243.7 400 198c0-74.1-64.3-134-144-134z"}}]})(props);
	};
	module.exports.IoMdBulb.displayName = "IoMdBulb";
	module.exports.IoMdBus = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 352c0 19.198 13.864 24.531 26.667 36.271v38.396c0 11.729 9.599 21.334 21.333 21.334h21.333c11.734 0 21.334-9.604 21.334-21.334v-21.333h170.666v21.333c0 11.729 9.604 21.334 21.334 21.334H384c11.729 0 21.333-9.604 21.333-21.334v-38.396C418.136 376.531 432 370.136 432 352V148.334C432 73.667 349.864 64 256 64S80 73.667 80 148.334V352zm80 15.989c-18.136 0-32-13.864-32-32 0-18.135 13.864-32 32-32s32 13.865 32 32c0 18.136-13.864 32-32 32zm192 0c-18.136 0-32-13.864-32-32 0-18.135 13.864-32 32-32s32 13.865 32 32c0 18.136-13.864 32-32 32zm32-122.656H128V138.667h256v106.666z"}}]})(props);
	};
	module.exports.IoMdBus.displayName = "IoMdBus";
	module.exports.IoMdBusiness = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M261 149.3V64H48v384h416V149.3H261zm-127.8 256H90.6v-42.7h42.6v42.7zm0-85.3H90.6v-42.7h42.6V320zm0-85.3H90.6V192h42.6v42.7zm0-85.4H90.6v-42.7h42.6v42.7zm85.2 256h-42.6v-42.7h42.6v42.7zm0-85.3h-42.6v-42.7h42.6V320zm0-85.3h-42.6V192h42.6v42.7zm0-85.4h-42.6v-42.7h42.6v42.7zm203 256H261v-42.7h42.6V320H261v-42.7h42.6v-42.7H261V192h160.4v213.3zm-37.6-170.6h-42.6v42.7h42.6v-42.7zm0 85.3h-42.6v42.7h42.6V320z"}}]})(props);
	};
	module.exports.IoMdBusiness.displayName = "IoMdBusiness";
	module.exports.IoMdCafe = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 400h368v48H48zM424 64H80v224c0 44 36 80 80 80h144c44 0 80-36 80-80v-64h40c22 0 40-18 40-40v-80c0-22-18-40-40-40zm0 112h-40v-64h40v64z"}}]})(props);
	};
	module.exports.IoMdCafe.displayName = "IoMdCafe";
	module.exports.IoMdCalculator = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 48H144c-26.6 0-48 21.6-48 48v320c0 26.4 21.4 48 48 48h224c26.4 0 48-21.6 48-48V96c0-26.4-21.4-48-48-48zM200 416h-48v-48h48v48zm0-88h-48v-48h48v48zm0-88h-48v-48h48v48zm80 176h-48v-48h48v48zm0-88h-48v-48h48v48zm0-88h-48v-48h48v48zm80 176h-48V280h48v136zm0-176h-48v-48h48v48zm0-96H152V96h208v48z"}}]})(props);
	};
	module.exports.IoMdCalculator.displayName = "IoMdCalculator";
	module.exports.IoMdCalendar = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.005 272h-96v96h96v-96zm-32-208v32h-160V64h-48v32h-24.01c-22.002 0-40 17.998-40 40v272c0 22.002 17.998 40 40 40h304.01c22.002 0 40-17.998 40-40V136c0-22.002-17.998-40-40-40h-24V64h-48zm72 344h-304.01V196h304.01v212z"}}]})(props);
	};
	module.exports.IoMdCalendar.displayName = "IoMdCalendar";
	module.exports.IoMdCall = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.666 330.667a250.385 250.385 0 0 1-75.729-11.729c-7.469-2.136-16-1.073-21.332 5.333l-46.939 46.928c-60.802-30.928-109.864-80-140.802-140.803l46.939-46.927c5.332-5.333 7.462-13.864 5.332-21.333-8.537-24.531-12.802-50.136-12.802-76.803C181.333 73.604 171.734 64 160 64H85.333C73.599 64 64 73.604 64 85.333 64 285.864 226.136 448 426.666 448c11.73 0 21.334-9.604 21.334-21.333V352c0-11.729-9.604-21.333-21.334-21.333z"}}]})(props);
	};
	module.exports.IoMdCall.displayName = "IoMdCall";
	module.exports.IoMdCamera = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"280","r":"63"}},{"tag":"path","attr":{"d":"M440 96h-88l-32-32H192l-32 32H72c-22.092 0-40 17.908-40 40v272c0 22.092 17.908 40 40 40h368c22.092 0 40-17.908 40-40V136c0-22.092-17.908-40-40-40zM256 392c-61.855 0-112-50.145-112-112s50.145-112 112-112 112 50.145 112 112-50.145 112-112 112z"}}]})(props);
	};
	module.exports.IoMdCamera.displayName = "IoMdCamera";
	module.exports.IoMdCar = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.208 117.333c-4.271-12.802-16-21.333-29.875-21.333H138.667c-13.875 0-25.604 8.531-29.875 21.333L64 234.667v160C64 406.396 73.604 416 85.333 416h21.334c11.729 0 21.333-9.604 21.333-21.333V384h256v10.667c0 11.729 9.604 21.333 21.333 21.333h21.334c11.729 0 21.333-9.604 21.333-21.333v-160l-44.792-117.334zM138.667 320c-18.125 0-32-13.865-32-32s13.875-32 32-32 32 13.866 32 32-13.875 32-32 32zm234.666 0c-18.125 0-32-13.865-32-32s13.875-32 32-32 32 13.866 32 32-13.875 32-32 32zM106.667 213.333l32-85.333h234.666l32 85.333H106.667z"}}]})(props);
	};
	module.exports.IoMdCar.displayName = "IoMdCar";
	module.exports.IoMdCard = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.2 80H76.8c-24.9 0-44.6 19.6-44.6 44L32 388c0 24.4 19.9 44 44.8 44h358.4c24.9 0 44.8-19.6 44.8-44V124c0-24.4-19.9-44-44.8-44zm0 308H76.8V256h358.4v132zm0-220H76.8v-44h358.4v44z"}}]})(props);
	};
	module.exports.IoMdCard.displayName = "IoMdCard";
	module.exports.IoMdCart = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M169.6 377.6c-22.882 0-41.6 18.718-41.6 41.601 0 22.882 18.718 41.6 41.6 41.6s41.601-18.718 41.601-41.6c-.001-22.884-18.72-41.601-41.601-41.601zM48 51.2v41.6h41.6l74.883 151.682-31.308 50.954c-3.118 5.2-5.2 12.482-5.2 19.765 0 27.85 19.025 41.6 44.825 41.6H416v-40H177.893c-3.118 0-5.2-2.082-5.2-5.2 0-1.036 2.207-5.2 2.207-5.2l20.782-32.8h154.954c15.601 0 29.128-8.317 36.4-21.836l74.882-128.8c1.237-2.461 2.082-6.246 2.082-10.399 0-11.446-9.364-19.765-20.8-19.765H135.364L115.6 51.2H48zm326.399 326.4c-22.882 0-41.6 18.718-41.6 41.601 0 22.882 18.718 41.6 41.6 41.6S416 442.082 416 419.2c0-22.883-18.719-41.6-41.601-41.6z"}}]})(props);
	};
	module.exports.IoMdCart.displayName = "IoMdCart";
	module.exports.IoMdCash = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96v256h448V96H32zm160.5 224h-80.4c0-26.6-21.5-48.1-48.1-48.1V192c35.3 0 64-28.7 64-64h64.5c-19.9 23.5-32.5 57.8-32.5 96s12.6 72.5 32.5 96zM448 271.9c-26 0-48 21.5-48 48.1h-80.5c19.9-23.5 32.5-57.8 32.5-96s-12.6-72.5-32.5-96H384c0 35.3 28.7 64 64 64v79.9zM32 384h448v32H32z"}}]})(props);
	};
	module.exports.IoMdCash.displayName = "IoMdCash";
	module.exports.IoMdCellular = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 448h384V64L64 448z"}}]})(props);
	};
	module.exports.IoMdCellular.displayName = "IoMdCellular";
	module.exports.IoMdChatboxes = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391.553 64H57.607C53.131 64 48 67.745 48 72.159v214.217c0 4.413 5.131 8.624 9.607 8.624H115v88.894L205.128 295h186.425c4.477 0 7.447-4.211 7.447-8.624V72.159c0-4.414-2.971-8.159-7.447-8.159z"}},{"tag":"path","attr":{"d":"M456.396 127H424v166.57c0 15.987-6.915 26.43-25.152 26.43H218.096l-38.905 39h129.688L399 448v-89h57.396c4.478 0 7.604-4.262 7.604-8.682V136.103c0-4.414-3.126-9.103-7.604-9.103z"}}]})(props);
	};
	module.exports.IoMdChatboxes.displayName = "IoMdChatboxes";
	module.exports.IoMdChatbubbles = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M132.8 368c-20.2 0-44.8-24.6-44.8-44.8V160h-9.6C61.7 160 48 173.7 48 190.4V464l58.5-58h215.1c16.7 0 30.4-14.1 30.4-30.9V368H132.8z"}},{"tag":"path","attr":{"d":"M429.1 48H149.9C130.7 48 115 63.7 115 82.9V309c0 19.2 15.7 35 34.9 35h238.2l75.9 53V82.9c0-19.2-15.7-34.9-34.9-34.9z"}}]})(props);
	};
	module.exports.IoMdChatbubbles.displayName = "IoMdChatbubbles";
	module.exports.IoMdCheckboxOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.531 215.469l-29.864 29.864 96 96L448 128l-29.864-29.864-183.469 182.395-66.136-65.062zm236.802 189.864H106.667V106.667H320V64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333V234.667h-42.667v170.666z"}}]})(props);
	};
	module.exports.IoMdCheckboxOutline.displayName = "IoMdCheckboxOutline";
	module.exports.IoMdCheckbox = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.333 64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333V106.667C448 83.198 428.802 64 405.333 64zm-192 298.667L106.667 256l29.864-29.864 76.802 76.802 162.136-162.136 29.864 29.865-192 192z"}}]})(props);
	};
	module.exports.IoMdCheckbox.displayName = "IoMdCheckbox";
	module.exports.IoMdCheckmarkCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M170.718 216.482L141.6 245.6l93.6 93.6 208-208-29.118-29.118L235.2 279.918l-64.482-63.436zM422.4 256c0 91.518-74.883 166.4-166.4 166.4S89.6 347.518 89.6 256 164.482 89.6 256 89.6c15.6 0 31.2 2.082 45.764 6.241L334 63.6C310.082 53.2 284.082 48 256 48 141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208h-41.6z"}}]})(props);
	};
	module.exports.IoMdCheckmarkCircleOutline.displayName = "IoMdCheckmarkCircleOutline";
	module.exports.IoMdCheckmarkCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm-42.7 318.9L106.7 260.3l29.9-29.9 76.8 76.8 162.1-162.1 29.9 29.9-192.1 191.9z"}}]})(props);
	};
	module.exports.IoMdCheckmarkCircle.displayName = "IoMdCheckmarkCircle";
	module.exports.IoMdCheckmark = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z"}}]})(props);
	};
	module.exports.IoMdCheckmark.displayName = "IoMdCheckmark";
	module.exports.IoMdClipboard = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.333 80h-87.35C310.879 52.396 285.821 32 256 32s-54.879 20.396-61.983 48h-87.35C83.198 80 64 99.198 64 122.667v314.665C64 460.801 83.198 480 106.667 480h298.666C428.802 480 448 460.801 448 437.332V122.667C448 99.198 428.802 80 405.333 80zM256 80c11.729 0 21.333 9.599 21.333 21.333s-9.604 21.334-21.333 21.334-21.333-9.6-21.333-21.334S244.271 80 256 80zm152 360H104V120h40v72h224v-72h40v320z"}}]})(props);
	};
	module.exports.IoMdClipboard.displayName = "IoMdClipboard";
	module.exports.IoMdClock = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0-81.3 81.2-81.2 212.9 0 294.2 81.2 81.2 212.9 81.2 294.2 0 81.2-81.2 81.2-213 0-294.2zm-16.5 53.2c7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.6 1.8 17.5-5.9 21.9-7.6 4.4-17.5 1.8-21.9-5.9-4.4-7.6-1.8-17.5 5.9-21.9zM80 256c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16-16-7.2-16-16zm45.4 93.9c-7.6 4.4-17.5 1.8-21.9-5.9-4.4-7.6-1.8-17.5 5.9-21.9 7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.6 1.8 17.5-5.9 21.9zm5.9-165.9c-4.4 7.6-14.2 10.3-21.9 5.9-7.6-4.4-10.3-14.2-5.9-21.9 4.4-7.6 14.2-10.3 21.9-5.9 7.7 4.4 10.3 14.3 5.9 21.9zm36.7-80.4c7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.6 1.8 17.5-5.9 21.9s-17.5 1.8-21.9-5.9c-4.4-7.7-1.7-17.5 5.9-21.9zm-7.8 110.7l15.6-26.6 95.2 56.9V384h-31V260.6l-79.8-46.3zm29.7 188.3c-4.4 7.6-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9c4.4-7.6 14.2-10.3 21.9-5.9 7.6 4.4 10.3 14.2 5.9 21.9zM256 432c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-320c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm88 296.4c-7.6 4.4-17.5 1.8-21.9-5.9-4.4-7.6-1.8-17.5 5.9-21.9 7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.7 1.7 17.5-5.9 21.9zm5.9-283c-4.4 7.6-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9c4.4-7.6 14.2-10.3 21.9-5.9s10.3 14.3 5.9 21.9zM408.4 344c-4.4 7.6-14.2 10.3-21.9 5.9-7.6-4.4-10.3-14.2-5.9-21.9 4.4-7.6 14.2-10.3 21.9-5.9 7.7 4.4 10.3 14.3 5.9 21.9zm7.6-72c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoMdClock.displayName = "IoMdClock";
	module.exports.IoMdCloseCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M360 330.9L330.9 360 256 285.1 181.1 360 152 330.9l74.9-74.9-74.9-74.9 29.1-29.1 74.9 74.9 74.9-74.9 29.1 29.1-74.9 74.9z"}}]})(props);
	};
	module.exports.IoMdCloseCircleOutline.displayName = "IoMdCloseCircleOutline";
	module.exports.IoMdCloseCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C140.559 48 48 140.559 48 256c0 115.436 92.559 208 208 208 115.435 0 208-92.564 208-208 0-115.441-92.564-208-208-208zm104.002 282.881l-29.12 29.117L256 285.117l-74.881 74.881-29.121-29.117L226.881 256l-74.883-74.881 29.121-29.116L256 226.881l74.881-74.878 29.12 29.116L285.119 256l74.883 74.881z"}}]})(props);
	};
	module.exports.IoMdCloseCircle.displayName = "IoMdCloseCircle";
	module.exports.IoMdClose = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"}}]})(props);
	};
	module.exports.IoMdClose.displayName = "IoMdClose";
	module.exports.IoMdCloudCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm93.6 291.2H172.801c-34.318 0-62.4-28.082-62.4-62.399 0-34.319 28.082-62.4 62.4-62.4h3.117c9.364-36.4 41.601-62.399 80.083-62.399 45.764 0 83.199 37.435 83.199 83.198h10.4c29.118 0 52 22.882 52 52.001 0 29.117-22.882 51.999-52 51.999z"}}]})(props);
	};
	module.exports.IoMdCloudCircle.displayName = "IoMdCloudCircle";
	module.exports.IoMdCloudDone = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM213.333 362.667L138.667 288l29.864-29.864 44.802 44.802L324.271 192l29.865 29.864-140.803 140.803z"}}]})(props);
	};
	module.exports.IoMdCloudDone.displayName = "IoMdCloudDone";
	module.exports.IoMdCloudDownload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM224 268v-76h64v76h68L256 368 156 268h68z"}}]})(props);
	};
	module.exports.IoMdCloudDownload.displayName = "IoMdCloudDownload";
	module.exports.IoMdCloudOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.001 217.001C388.997 148.002 328.998 96 256 96c-57.998 0-107.999 32.998-132.997 81C63.002 183.002 16 233.998 16 296c0 65.996 54.004 120 120 120h260c55 0 100-45 100-100.001 0-52.997-40.997-95.999-92.999-98.998zM396 376H136c-44.004 0-80-35.996-80-80 0-44 35.996-80 80-80h14.004c12.998-46 55-80 105.996-80 60.996 0 110 49 110 110v10h30c32.998 0 60 27.003 60 60 0 32.998-27.002 60-60 60z"}}]})(props);
	};
	module.exports.IoMdCloudOutline.displayName = "IoMdCloudOutline";
	module.exports.IoMdCloudUpload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM288 276v76h-64v-76h-68l100-100 100 100h-68z"}}]})(props);
	};
	module.exports.IoMdCloudUpload.displayName = "IoMdCloudUpload";
	module.exports.IoMdCloud = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999z"}}]})(props);
	};
	module.exports.IoMdCloud.displayName = "IoMdCloud";
	module.exports.IoMdCloudyNight = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M123.4 183c.4-.1.8-.1 1.2-.2-.5.1-.8.2-1.2.2zM341.5 303.4C330.7 247.7 282.2 206 224 206c-34 0-65.1 12-86.5 39.1 29.4 2.2 56.7 13.1 77.7 34.2 15.6 15.7 26.6 34.9 32.1 55.8h-28.7c-13.1-37.6-48-64.5-90.6-64.5-5.1 0-12.3.6-17.7 1.7-45.7 9.4-78.3 47.6-78.3 95 0 53.4 43 96.8 96 96.8h208c44.1 0 80-36.1 80-80.6-.1-42.7-32.9-77.2-74.5-80.1z"}},{"tag":"path","attr":{"d":"M112.5 225.4c13.6-17.3 30.7-30.5 50.8-39.2 18.4-8 38.8-12 60.7-12 6.1 0 12.2.4 18.2 1.1-6.1-18.1-9.4-37.6-9.4-57.8 0-24.6 4.9-48.1 13.8-69.4C161.9 68.7 99 145.7 99 237.3c0 1.6 0 3.2.1 4.8.1 0 .2-.1.3-.1l13.1-16.6zM417.6 306.8c13.3 14.2 22.6 31.5 27.1 50.1 16.5-21.4 28.7-46.4 35.3-73.5-21.2 9-44.5 13.9-68.9 13.9h-3.6c3.5 2.9 6.9 6.1 10.1 9.5z"}}]})(props);
	};
	module.exports.IoMdCloudyNight.displayName = "IoMdCloudyNight";
	module.exports.IoMdCloudy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M123.4 183c.4-.1.8-.1 1.2-.2-.5.1-.8.2-1.2.2z"}},{"tag":"path","attr":{"d":"M393.2 219.2C380.5 154.6 323.9 106 256 106c-39.7 0-76 14-100.9 45.4 34.3 2.6 66.1 15.2 90.7 39.8 18.2 18.2 31 40.5 37.4 64.8h-33.5c-15.3-43.7-56-75-105.7-75-6 0-14.3.7-20.6 2C70 194 32 238.4 32 293.5 32 355.6 82.2 406 144 406h242.7c51.5 0 93.3-42 93.3-93.8 0-49.4-38.3-89.6-86.8-93z"}}]})(props);
	};
	module.exports.IoMdCloudy.displayName = "IoMdCloudy";
	module.exports.IoMdCodeDownload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234.6 160v125.7l-44.7-43.6L160 272l96 96 96-96-29.9-31-44.7 44.7V160h-42.8z"}},{"tag":"path","attr":{"d":"M190.4 354.1L91.9 256l98.4-98.1-30-29.9L32 256l128.4 128 30-29.9zm131.2 0L420 256l-98.4-98.1 30-29.9L480 256 351.6 384l-30-29.9z"}}]})(props);
	};
	module.exports.IoMdCodeDownload.displayName = "IoMdCodeDownload";
	module.exports.IoMdCodeWorking = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.4 354.1L91.9 256l98.4-98.1-30-29.9L32 256l128.4 128 30-29.9zm131.2 0L420 256l-98.4-98.1 30-29.9L480 256 351.6 384l-30-29.9z"}},{"tag":"path","attr":{"d":"M155.6 276h40v-40h-40v40zm200.8-40h-40v40h40v-40zM236 276h40v-40h-40v40z"}}]})(props);
	};
	module.exports.IoMdCodeWorking.displayName = "IoMdCodeWorking";
	module.exports.IoMdCode = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.4 354.1L91.9 256l98.4-98.1-30-29.9L32 256l128.4 128 30-29.9zm131.2 0L420 256l-98.4-98.1 30-29.9L480 256 351.6 384l-30-29.9z"}}]})(props);
	};
	module.exports.IoMdCode.displayName = "IoMdCode";
	module.exports.IoMdCog = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 288v-64h-34.7c-2-12.1-5.2-23.8-9.3-35l30-17.3-32-55.4-30 17.3c-7.7-9.3-16.3-17.9-25.6-25.6l17.3-30-55.4-32L323 76c-11.2-4.2-22.9-7.3-35-9.3V32h-64v34.7c-12.1 2-23.8 5.2-35 9.3l-17.3-30-55.4 32 17.3 30c-9.3 7.7-17.9 16.3-25.6 25.6l-30-17.3-32 55.4L76 189c-4.2 11.2-7.3 22.9-9.3 35H32v64h34.7c2 12.1 5.2 23.8 9.3 35l-30 17.3 32 55.4 30-17.3c7.7 9.3 16.3 17.9 25.6 25.6l-17.3 30 55.4 32 17.3-30c11.2 4.2 22.9 7.3 35 9.3V480h64v-34.7c12.1-2 23.8-5.2 35-9.3l17.3 30 55.4-32-17.3-30c9.3-7.7 17.9-16.3 25.6-25.6l30 17.3 32-55.4-30-17.3c4.2-11.2 7.3-22.9 9.3-35H480zm-224-64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM141.2 343c-18.3-24.2-29.2-54.3-29.2-87 0-6.1.4-12.1 1.1-18l46.9 17.1v.9c0 17.8 4.9 34.5 13.3 48.8L141.2 343zm40.7-148L135 177.9c20.1-31.1 51.8-53.9 89-62.3v49.9c-16.6 5.9-31.1 16.2-42.1 29.5zM256 400c-23.7 0-46-5.7-65.8-15.9l32.1-38.2c10.5 3.9 21.8 6.1 33.7 6.1s23.2-2.2 33.7-6.1l32.1 38.2C302 394.3 279.7 400 256 400zm32-234.5v-49.9c37.2 8.4 68.9 31.2 89 62.3L330.1 195c-11-13.3-25.5-23.6-42.1-29.5zM370.8 343l-32.1-38.2c8.4-14.3 13.3-31 13.3-48.8v-.9l46.9-17.1c.7 5.9 1.1 11.9 1.1 18 0 32.7-10.9 62.8-29.2 87z"}}]})(props);
	};
	module.exports.IoMdCog.displayName = "IoMdCog";
	module.exports.IoMdColorFill = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M136.5 77.7l37 67L32 285.7 216.4 464l152.4-148.6 54.4-11.4L166.4 48l-29.9 29.7zm184 208H114.9l102.8-102.3 102.8 102.3zM423.3 304s-56.7 61.5-56.7 92.1c0 30.7 25.4 55.5 56.7 55.5 31.3 0 56.7-24.9 56.7-55.5S423.3 304 423.3 304z"}}]})(props);
	};
	module.exports.IoMdColorFill.displayName = "IoMdColorFill";
	module.exports.IoMdColorFilter = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.8 120.1l-49.9-49.9c-8.3-8.3-21.8-8.3-30.1 0l-66.6 66.6L254.1 96 224 126.1l30.3 30.3L64 346.7V448h101.3l190.3-190.3 30.3 30.3 30.1-30.1-41-41 66.6-66.6c8.5-8.4 8.5-21.8.2-30.2zM147.6 405.4l-41-41 171.9-171.9 41 41-171.9 171.9z"}}]})(props);
	};
	module.exports.IoMdColorFilter.displayName = "IoMdColorFilter";
	module.exports.IoMdColorPalette = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150.401 64 64 150.401 64 256c0 105.604 86.401 192 192 192 18.136 0 32-13.864 32-32 0-8.531-3.198-16-8.531-21.333-5.333-5.334-8.531-12.803-8.531-21.334 0-18.135 13.864-32 32-32h38.396c58.667 0 106.667-48 106.667-106.666C448 140.802 361.604 64 256 64zM138.667 256c-18.136 0-32-13.864-32-32s13.864-32 32-32c18.135 0 32 13.864 32 32s-13.865 32-32 32zm64-85.333c-18.136 0-32-13.865-32-32 0-18.136 13.864-32 32-32 18.135 0 32 13.864 32 32 0 18.135-13.865 32-32 32zm106.666 0c-18.135 0-32-13.865-32-32 0-18.136 13.865-32 32-32 18.136 0 32 13.864 32 32 0 18.135-13.864 32-32 32zm64 85.333c-18.135 0-32-13.864-32-32s13.865-32 32-32c18.136 0 32 13.864 32 32s-13.864 32-32 32z"}}]})(props);
	};
	module.exports.IoMdColorPalette.displayName = "IoMdColorPalette";
	module.exports.IoMdColorWand = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M200.8 157.2l-36.4 37.4L411.7 448l36.3-37.4zM181 64h37v68h-37zM181 262h37v68h-37zM270 176h69v37h-69zM305.6 115.8l-25.7-26.3-47.1 48.3 25.6 26.2zM168.8 137.8l-47.1-48.3-25.6 26.3 47.1 48.2zM96.1 277.9l25.6 26.2 47.1-48.2-25.6-26.3zM64 176h65v37H64z"}}]})(props);
	};
	module.exports.IoMdColorWand.displayName = "IoMdColorWand";
	module.exports.IoMdCompass = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 231.358c-13.442 0-24.643 11.2-24.643 24.642s11.2 24.643 24.643 24.643 24.643-11.2 24.643-24.643-11.201-24.642-24.643-24.642zM256 32C132.8 32 32 132.8 32 256s100.8 224 224 224 224-100.8 224-224S379.2 32 256 32zm49.284 273.284L121.6 390.4l85.116-183.679L390.4 121.6l-85.116 183.684z"}}]})(props);
	};
	module.exports.IoMdCompass.displayName = "IoMdCompass";
	module.exports.IoMdConstruct = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430.9 393.4l-119.6-119-58.1-57.9-13.4-13.3c15.9-40.6 7.1-88.2-26.6-121.7-35.4-35.3-88.5-42.3-131-22.9l76.1 75.8-53.1 52.9-77.9-75.8C6.2 153.8 15 206.7 50.4 242c33.6 33.5 81.4 42.3 122.1 26.5l14.4 14.3L81.7 388c-7.6 5.7-7.6 19 1.9 26.6l43.8 43.7c7.6 7.6 19.1 7.6 26.7 0l96.1-112.4 113.4 112.9c7.1 7.1 17.7 7.1 24.8 0l40.7-40.6c8.9-7.1 8.9-19.5 1.8-24.8z"}},{"tag":"path","attr":{"d":"M494.4 216.6l-34.5-34.1c-2.2-2.2-5.8-2.2-8 0l-3.7 3.7-18.5-15.8s1.2-10-4.9-18.7c-6.2-8.7-16.1-19.8-23.2-26.9-7.1-7-34.1-33.9-69.7-51.4C296.2 55.7 271 48 241 48v29.7s28.7 16.6 45.1 29.7c16.3 13.1 16.8 59.5 16.8 59.5l-28.5 28.5 56.5 56.1 31-36.3c12.9-3.5 23.8-3.8 30.2-.3l13.7 13.3-9.6 9.5c-2.2 2.2-2.2 5.7 0 7.9l34.5 34.1c2.2 2.2 5.8 2.2 8 0l55.7-55.2c2.1-2.2 2.1-5.8 0-7.9z"}}]})(props);
	};
	module.exports.IoMdConstruct.displayName = "IoMdConstruct";
	module.exports.IoMdContact = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm0 62.4c34.3 0 62.4 28.1 62.4 62.4s-28.1 62.4-62.4 62.4-62.4-28.1-62.4-62.4 28.1-62.4 62.4-62.4zm0 300.4c-52 0-97.8-27-124.8-66.6 1-41.6 83.2-64.5 124.8-64.5s123.8 22.9 124.8 64.5c-27 39.5-72.8 66.6-124.8 66.6z"}}]})(props);
	};
	module.exports.IoMdContact.displayName = "IoMdContact";
	module.exports.IoMdContacts = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M239.208 343.937c-17.78 10.103-38.342 15.876-60.255 15.876-21.909 0-42.467-5.771-60.246-15.87C71.544 358.331 42.643 406 32 448h293.912c-10.639-42-39.537-89.683-86.704-104.063zM178.953 120.035c-58.479 0-105.886 47.394-105.886 105.858 0 58.464 47.407 105.857 105.886 105.857s105.886-47.394 105.886-105.857c0-58.464-47.408-105.858-105.886-105.858zm0 186.488c-33.671 0-62.445-22.513-73.997-50.523H252.95c-11.554 28.011-40.326 50.523-73.997 50.523z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M322.602 384H480c-10.638-42-39.537-81.691-86.703-96.072-17.781 10.104-38.343 15.873-60.256 15.873-14.823 0-29.024-2.654-42.168-7.49-7.445 12.47-16.927 25.592-27.974 34.906C289.245 341.354 309.146 364 322.602 384zM306.545 200h100.493c-11.554 28-40.327 50.293-73.997 50.293-8.875 0-17.404-1.692-25.375-4.51a128.411 128.411 0 0 1-6.52 25.118c10.066 3.174 20.779 4.862 31.895 4.862 58.479 0 105.886-47.41 105.886-105.872 0-58.465-47.407-105.866-105.886-105.866-37.49 0-70.427 19.703-89.243 49.09C275.607 131.383 298.961 163 306.545 200z"}}]}]})(props);
	};
	module.exports.IoMdContacts.displayName = "IoMdContacts";
	module.exports.IoMdContract = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 371.2h76.795V448H192V320H64v51.2zm76.795-230.4H64V192h128V64h-51.205v76.8zM320 448h51.2v-76.8H448V320H320v128zm51.2-307.2V64H320v128h128v-51.2h-76.8z"}}]})(props);
	};
	module.exports.IoMdContract.displayName = "IoMdContract";
	module.exports.IoMdContrast = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm113.1 321.1C338.9 399.4 298.7 416 256 416V96c42.7 0 82.9 16.6 113.1 46.9C399.4 173.1 416 213.3 416 256s-16.6 82.9-46.9 113.1z"}}]})(props);
	};
	module.exports.IoMdContrast.displayName = "IoMdContrast";
	module.exports.IoMdCopy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 48H176.5C154.4 48 136 65.4 136 87.5V96h-7.5C106.4 96 88 113.4 88 135.5v288c0 22.1 18.4 40.5 40.5 40.5h208c22.1 0 39.5-18.4 39.5-40.5V416h8.5c22.1 0 39.5-18.4 39.5-40.5V176L296 48zm0 44.6l83.4 83.4H296V92.6zm48 330.9c0 4.7-3.4 8.5-7.5 8.5h-208c-4.4 0-8.5-4.1-8.5-8.5v-288c0-4.1 3.8-7.5 8.5-7.5h7.5v255.5c0 22.1 10.4 32.5 32.5 32.5H344v7.5zm48-48c0 4.7-3.4 8.5-7.5 8.5h-208c-4.4 0-8.5-4.1-8.5-8.5v-288c0-4.1 3.8-7.5 8.5-7.5H264v128h128v167.5z"}}]})(props);
	};
	module.exports.IoMdCopy.displayName = "IoMdCopy";
	module.exports.IoMdCreate = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 368v80h80l235.727-235.729-79.999-79.998L64 368zm377.602-217.602c8.531-8.531 8.531-21.334 0-29.865l-50.135-50.135c-8.531-8.531-21.334-8.531-29.865 0l-39.468 39.469 79.999 79.998 39.469-39.467z"}}]})(props);
	};
	module.exports.IoMdCreate.displayName = "IoMdCreate";
	module.exports.IoMdCrop = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 312.7h37.8V160c0-20.8-17-37.8-37.8-37.8H199.3V160H352v152.7zm-192 33.5V48h-37.8v74.2H48V160h74.2v186.2c0 20.8 17 37.8 37.8 37.8h192v80h37.8v-80H464v-37.8H160z"}}]})(props);
	};
	module.exports.IoMdCrop.displayName = "IoMdCrop";
	module.exports.IoMdCube = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467.3 168.1c-1.8 0-3.5.3-5.1 1l-177.6 92.1h-.1c-7.6 4.7-12.5 12.5-12.5 21.4v185.9c0 6.4 5.6 11.5 12.7 11.5 2.2 0 4.3-.5 6.1-1.4.2-.1.4-.2.5-.3L466 385.6l.3-.1c8.2-4.5 13.7-12.7 13.7-22.1V179.6c0-6.4-5.7-11.5-12.7-11.5zM454.3 118.5L272.6 36.8S261.9 32 256 32c-5.9 0-16.5 4.8-16.5 4.8L57.6 118.5s-8 3.3-8 9.5c0 6.6 8.3 11.5 8.3 11.5l185.5 97.8c3.8 1.7 8.1 2.6 12.6 2.6 4.6 0 8.9-1 12.7-2.7l185.4-97.9s7.5-4 7.5-11.5c.1-6.3-7.3-9.3-7.3-9.3zM227.5 261.2L49.8 169c-1.5-.6-3.3-1-5.1-1-7 0-12.7 5.1-12.7 11.5v183.8c0 9.4 5.5 17.6 13.7 22.1l.2.1 174.7 92.7c1.9 1.1 4.2 1.7 6.6 1.7 7 0 12.7-5.2 12.7-11.5V282.6c.1-8.9-4.9-16.8-12.4-21.4z"}}]})(props);
	};
	module.exports.IoMdCube.displayName = "IoMdCube";
	module.exports.IoMdCut = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M203.1 158.3c5.2-11.2 8.1-23.5 8.1-36.7 0-49.5-40.1-89.6-89.6-89.6S32 72.1 32 121.6s40.1 89.6 89.6 89.6c13.2 0 25.5-2.9 36.7-8.1l52.9 52.9-52.9 52.9c-11.2-5.2-23.5-8.1-36.7-8.1-49.5 0-89.6 40.1-89.6 89.6S72.1 480 121.6 480s89.6-40.1 89.6-89.6c0-13.2-2.9-25.5-8.1-36.7l52.9-52.9 156.8 156.8H480v-22.4L203.1 158.3zm-81.5 8.1c-24.6 0-44.8-19.9-44.8-44.8S97 76.8 121.6 76.8s44.8 19.9 44.8 44.8-20.2 44.8-44.8 44.8zm0 268.8c-24.6 0-44.8-19.9-44.8-44.8s20.2-44.8 44.8-44.8 44.8 19.9 44.8 44.8-20.2 44.8-44.8 44.8zm134.4-168c-6.3 0-11.2-4.9-11.2-11.2 0-6.3 4.9-11.2 11.2-11.2 6.3 0 11.2 4.9 11.2 11.2 0 6.3-4.9 11.2-11.2 11.2zM412.8 54.4L278.4 188.8l44.8 44.8L480 76.8V54.4h-67.2z"}}]})(props);
	};
	module.exports.IoMdCut.displayName = "IoMdCut";
	module.exports.IoMdDesktop = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.333 32H74.667C51.198 32 32 51.197 32 74.666v282.667C32 380.802 51.198 400 74.667 400h138.666l-42.666 48v32h170.666v-32l-42.666-48h138.666C460.802 400 480 380.802 480 357.333V74.666C480 51.197 460.802 32 437.333 32zm0 288H74.667V74.666h362.666V320z"}}]})(props);
	};
	module.exports.IoMdDesktop.displayName = "IoMdDesktop";
	module.exports.IoMdDisc = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm0 301.6c-51.8 0-93.6-41.8-93.6-93.6s41.8-93.6 93.6-93.6 93.6 41.8 93.6 93.6-41.8 93.6-93.6 93.6zm0-114.4c-11.4 0-20.8 9.4-20.8 20.8s9.4 20.8 20.8 20.8 20.8-9.4 20.8-20.8-9.4-20.8-20.8-20.8z"}}]})(props);
	};
	module.exports.IoMdDisc.displayName = "IoMdDisc";
	module.exports.IoMdDocument = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 48H136c-22.092 0-40 17.908-40 40v336c0 22.092 17.908 40 40 40h240c22.092 0 40-17.908 40-40V176L288 48zm-16 144V80l112 112H272z"}}]})(props);
	};
	module.exports.IoMdDocument.displayName = "IoMdDocument";
	module.exports.IoMdDoneAll = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M387.581 139.712L356.755 109 216.913 248.319l30.831 30.719 139.837-139.326zM481.172 109L247.744 340.469l-91.39-91.051-30.827 30.715L247.744 403 512 139.712 481.172 109zM0 280.133L123.321 403l30.829-30.713L31.934 249.418 0 280.133z"}}]})(props);
	};
	module.exports.IoMdDoneAll.displayName = "IoMdDoneAll";
	module.exports.IoMdDownload = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 199.5h-91.4V64H187.4v135.5H96l160 158.1 160-158.1zM96 402.8V448h320v-45.2H96z"}}]})(props);
	};
	module.exports.IoMdDownload.displayName = "IoMdDownload";
	module.exports.IoMdEasel = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 176h256v128H128z"}},{"tag":"path","attr":{"d":"M448 96H64c-8.8 0-16 7.2-16 16v256c0 8.8 6.9 16 15.8 16H448c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-32 240H96V144h320v192zM80 464h57l22.5-64h-56.4zM279.4 48h-46.8l-11.5 32h69.8zM375 464h57l-23-64h-56.5zM232 400h48v32h-48z"}}]})(props);
	};
	module.exports.IoMdEasel.displayName = "IoMdEasel";
	module.exports.IoMdEgg = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C185.6 32 80 165.2 80 288.9S150.4 480 256 480s176-67.4 176-191.1S326.4 32 256 32z"}}]})(props);
	};
	module.exports.IoMdEgg.displayName = "IoMdEgg";
	module.exports.IoMdExit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.469 332.802l29.863 29.864L352 256 245.332 149.333l-29.863 29.865 55.469 55.469H64v42.666h205.864l-54.395 55.469zM405.334 64H106.666C83.198 64 64 83.198 64 106.666V192h42.666v-85.333h298.668v298.668H106.666V320H64v85.334C64 428.802 83.198 448 106.666 448h298.668C428.802 448 448 428.802 448 405.334V106.666C448 83.198 428.802 64 405.334 64z"}}]})(props);
	};
	module.exports.IoMdExit.displayName = "IoMdExit";
	module.exports.IoMdExpand = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396.795 396.8H320V448h128V320h-51.205zM396.8 115.205V192H448V64H320v51.205zM115.205 115.2H192V64H64v128h51.205zM115.2 396.795V320H64v128h128v-51.205z"}}]})(props);
	};
	module.exports.IoMdExpand.displayName = "IoMdExpand";
	module.exports.IoMdEyeOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.1 144.8c56.2 0 101.9 45.3 101.9 101.1 0 13.1-2.6 25.5-7.3 37l59.5 59c30.8-25.5 55-58.4 69.9-96-35.3-88.7-122.3-151.6-224.2-151.6-28.5 0-55.8 5.1-81.1 14.1l44 43.7c11.6-4.6 24.1-7.3 37.3-7.3zM52.4 89.7l46.5 46.1 9.4 9.3c-33.9 26-60.4 60.8-76.3 100.8 35.2 88.7 122.2 151.6 224.1 151.6 31.6 0 61.7-6.1 89.2-17l8.6 8.5 59.7 59 25.9-25.7L78.2 64 52.4 89.7zM165 201.4l31.6 31.3c-1 4.2-1.6 8.7-1.6 13.1 0 33.5 27.3 60.6 61.1 60.6 4.5 0 9-.6 13.2-1.6l31.6 31.3c-13.6 6.7-28.7 10.7-44.8 10.7-56.2 0-101.9-45.3-101.9-101.1 0-15.8 4.1-30.7 10.8-44.3zm87.8-15.7l64.2 63.7.4-3.2c0-33.5-27.3-60.6-61.1-60.6l-3.5.1z"}}]})(props);
	};
	module.exports.IoMdEyeOff.displayName = "IoMdEyeOff";
	module.exports.IoMdEye = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 105c-101.8 0-188.4 62.4-224 151 35.6 88.6 122.2 151 224 151s188.4-62.4 224-151c-35.6-88.6-122.2-151-224-151zm0 251.7c-56 0-101.8-45.3-101.8-100.7S200 155.3 256 155.3 357.8 200.6 357.8 256 312 356.7 256 356.7zm0-161.1c-33.6 0-61.1 27.2-61.1 60.4s27.5 60.4 61.1 60.4 61.1-27.2 61.1-60.4-27.5-60.4-61.1-60.4z"}}]})(props);
	};
	module.exports.IoMdEye.displayName = "IoMdEye";
	module.exports.IoMdFastforward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 256L262.4 110v292L480 256zM32 110v292l217.6-146L32 110z"}}]})(props);
	};
	module.exports.IoMdFastforward.displayName = "IoMdFastforward";
	module.exports.IoMdFemale = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 176c0-79.5-64.5-144-144-144S112 96.5 112 176c0 71.4 51.9 130.6 120 142v50h-72v48h72v64h48v-64h72v-48h-72v-50c68.1-11.4 120-70.6 120-142zm-240 0c0-52.9 43.1-96 96-96s96 43.1 96 96-43.1 96-96 96-96-43.1-96-96z"}}]})(props);
	};
	module.exports.IoMdFemale.displayName = "IoMdFemale";
	module.exports.IoMdFiling = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M449.2 208H423v-32l-14.4-48H383V96l-15-48H144l-15 48v32h-25.6L89 176v32H62.8L48 256v165.3c0 23.5 35.2 42.7 58.7 42.7h314.7c21.8 0 42.7-19.7 42.7-41V256l-14.9-48zM176 96h160v32H176V96zm-41 80h242v32H135v-32zm282 112h-82.6c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64H95v-32h322v32z"}}]})(props);
	};
	module.exports.IoMdFiling.displayName = "IoMdFiling";
	module.exports.IoMdFilm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 64v42.667h-40V64H176v42.667h-40V64H96v384h40v-42.666h40V448h160v-42.666h40V448h40V64h-40zM176 362.667h-40V320h40v42.667zm0-85.333h-40v-42.667h40v42.667zM176 192h-40v-42.666h40V192zm200 170.667h-40V320h40v42.667zm0-85.333h-40v-42.667h40v42.667zM376 192h-40v-42.666h40V192z"}}]})(props);
	};
	module.exports.IoMdFilm.displayName = "IoMdFilm";
	module.exports.IoMdFingerPrint = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M78.1 205.6c-2.4 0-4.9-.6-7.1-1.9-6.7-3.9-9-12.4-5.1-19.1 17.8-30 71.9-100.1 190.1-100.1 51.2 0 96.1 13.6 133.4 40.4 30.7 22 47.9 46.9 56.1 58.9 4.4 6.4 2.7 15-3.7 19.4-6.4 4.3-15.2 2.7-19.6-3.7-14.9-21.6-60.1-87.2-166.2-87.2-103.6 0-150.4 60.4-165.7 86.3-2.6 4.6-7.3 7-12.2 7z"}},{"tag":"path","attr":{"d":"M315.5 480c-1.2 0-2.3-.1-3.5-.4-85.7-21.5-117.7-108.1-119-111.7l-.2-.8c-.7-2.5-17.9-61.9 8.5-96.7 12.1-15.9 30.5-24 54.8-24 22.6 0 38.9 7.1 50.1 21.8 9.2 12 12.9 26.8 16.5 41.1 7.5 29.7 12.9 45.3 44.1 46.9 13.7.7 22.7-7.4 27.8-14.3 13.8-18.8 16.2-49.5 5.8-76.5-13.4-35-60.8-100.9-144.4-100.9-35.7 0-68.5 11.6-94.8 33.4-21.8 18.1-39.1 43.6-47.4 69.8-15.4 48.8 4.8 125.5 5 126.2 2 7.4-2.5 15.1-10 17-7.5 2-15.3-2.5-17.3-9.9-.9-3.5-22.5-85.3-4.7-141.7C106.2 198.2 166 136.6 256 136.6c41.6 0 80.9 14.3 113.7 41.3 25.4 21 46.2 49.2 57 77.4 13.8 36 10.1 76.4-9.4 102.8-13 17.6-31.5 26.8-52 25.8-53.4-2.7-63-40.4-70-67.9-7.2-28.2-11.8-41.8-39.3-41.8-15.1 0-25.7 4.2-32.3 12.9-9 11.9-9.7 30.5-8.7 44 1 14.1 4 25.5 4.7 27.8 2.2 5.6 30.8 76.5 99.3 93.7 7.6 1.9 12.1 9.5 10.2 16.9-1.7 6.3-7.4 10.5-13.7 10.5z"}},{"tag":"path","attr":{"d":"M205.5 473.6c-3.8 0-7.5-1.5-10.3-4.4-34.3-36.4-53.7-77.1-61-128v-.3c-4.1-33.7 1.9-81.4 31.3-114.2 21.7-24.2 52.2-36.5 90.5-36.5 45.3 0 80.9 21.3 103.1 61.5 16.1 29.2 19.3 58.3 19.4 59.5.8 7.7-4.9 14.5-12.6 15.3-7.7.8-14.7-4.8-15.5-12.4 0-.3-2.8-25.3-16.5-49.7-17.2-30.7-43.4-46.3-78-46.3-29.9 0-53.3 9.1-69.4 27.1-23.2 25.9-27.7 65.8-24.5 92.2 6.4 45 23.5 80.8 53.7 112.8 5.3 5.6 5 14.5-.7 19.7-2.6 2.4-6.1 3.7-9.5 3.7z"}},{"tag":"path","attr":{"d":"M363.5 433.5c-30 0-55.5-8.4-75.9-25.1-41-33.4-45.6-87.8-45.8-90.1-.6-7.7 5.2-14.4 13-15 7.8-.6 14.5 5.1 15.1 12.8.1.8 4.2 45.3 35.8 70.9 18.7 15.1 43.7 21.1 74.5 17.6 7.7-.9 14.7 4.6 15.6 12.3.9 7.7-4.7 14.6-12.4 15.4-6.8.8-13.5 1.2-19.9 1.2zM387.2 62.6C375.5 54.9 334 32 256 32c-81.9 0-123.5 25.3-132.7 31.7-.6.4-1.2.8-1.7 1.3-.1.1-.2.1-.2.1-2.9 2.6-4.7 6.3-4.7 10.4 0 7.7 6.3 13.9 14.1 13.9 3.1 0 5.9-1 8.2-2.6l-.1.1c.4-.3 36.3-27 117.1-27s116.7 26.8 117.1 27l-.1-.1.2-.2c2.4 1.8 5.3 2.8 8.5 2.8 7.8 0 14.1-6.2 14.1-13.9 0-5.8-3.5-10.8-8.6-12.9z"}}]})(props);
	};
	module.exports.IoMdFingerPrint.displayName = "IoMdFingerPrint";
	module.exports.IoMdFitness = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.3 315.5l29.7-29.7-29.7-29.8-74.3 74.3L181.7 152 256 77.7 226.3 48l-29.7 29.7L166.8 48l-44.5 44.5-29.8-29.7-29.7 29.7 29.7 29.7L48 166.8l29.7 29.7L48 226.3 77.7 256l74.3-74.3L330.3 360 256 434.3l29.7 29.7 29.7-29.7 29.7 29.7 44.5-44.5 29.7 29.7 29.7-29.7-29.7-29.7 44.5-44.5-29.5-29.8z"}}]})(props);
	};
	module.exports.IoMdFitness.displayName = "IoMdFitness";
	module.exports.IoMdFlag = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 83.2c-13.8 1.7-31.1 4.2-49.6 4.2-28.8 0-55-6.8-81.5-12.2C238 69.7 210.2 64 180.8 64c-58.6 0-78.5 12.1-80.6 13.4L96 80.3V448h48V269.8c9.7-1.2 21.9-2 36.9-2 27.3 0 52.8 10 79.8 15.5 27.6 5.6 56 11.5 86.9 11.5 18.4 0 34.6-2.4 48.4-4 7.5-.9 14-1.7 20-2.7V80.2c-5 1-12.5 2.1-20 3z"}}]})(props);
	};
	module.exports.IoMdFlag.displayName = "IoMdFlag";
	module.exports.IoMdFlame = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.3 222.1l-.2 10.4c-.8 11.7-7.9 43.4-22.1 54.7 7-15.2 17.3-47.2 10.2-82.7C361.6 107 287.5 65.6 193 50l-17.2-2.2c39.5 47.2 56.1 81.7 49.7 116.8-2.3 12.6-10 23.4-14 31.6 0 0 2.4-12.9 2-28.7-.3-14.2-6.6-31-18-39.6 3.5 18.4-.8 33.5-9.1 47.7-24.7 42.2-85.4 57.8-90.4 135.8v3.8c0 53.7 25.6 99 68.7 125-6.8-12.3-12-35.2-5.7-60.2 4 23.7 14 36 24.9 51.8 8.2 11.7 19.1 19.3 33.1 24.9s31 7.2 47.9 7.2c55.8 0 91.4-18.1 119.1-50.5s32.1-68 32.1-106.4-8.5-60.9-22.8-84.9z"}}]})(props);
	};
	module.exports.IoMdFlame.displayName = "IoMdFlame";
	module.exports.IoMdFlashOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.9 435.5L76.1 52.5 51.9 76.6 160 184.3V272h64v192l72-144 139.9 139.5zM352 208h-64l64-160H160v40.3l168 167.6z"}}]})(props);
	};
	module.exports.IoMdFlashOff.displayName = "IoMdFlashOff";
	module.exports.IoMdFlash = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 48v224h64v192l128-256h-64l64-160H160z"}}]})(props);
	};
	module.exports.IoMdFlash.displayName = "IoMdFlash";
	module.exports.IoMdFlashlight = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 298l64 64v118h128V362l64-64V176l-255.2.4L128 298zM234.8 32h42.4v64h-42.4V32zM80 110.4L109.9 80l44.9 45.6-29.9 30.4L80 110.4zm277.1 15.2l45-45.5 29.9 30.4-44.9 45.5-30-30.4z"}}]})(props);
	};
	module.exports.IoMdFlashlight.displayName = "IoMdFlashlight";
	module.exports.IoMdFlask = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436.9 354.4L336 192V96h32V48H144v48h32v96L76.1 354.4C67.7 370.3 63.6 385.8 64 400c1.1 36.5 28.7 64 65.1 64H385c36.3 0 62.1-27.6 63-64 .3-14.2-2.6-29.7-11.1-45.6zM155.1 304l29.5-48h143.1l29.8 48H155.1z"}}]})(props);
	};
	module.exports.IoMdFlask.displayName = "IoMdFlask";
	module.exports.IoMdFlower = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.1 256c25.2-11.9 42.9-37.1 42.9-66.9 0-41-33.6-74.3-75-74.3-15.9 0-30.3 4.8-42.6 13.1l.6-5.6c0-41-33.6-74.3-75-74.3s-75 33.3-75 74.3l.6 5.6c-12-8.3-26.7-13.1-42.6-13.1-41.4 0-75 33.3-75 74.3 0 29.7 17.7 55 42.9 66.9C81.7 267.9 64 293.1 64 322.9c0 41 33.6 74.3 75 74.3 15.9 0 30.3-4.8 42.6-13.1l-.6 5.6c0 41 33.6 74.3 75 74.3s75-33.3 75-74.3l-.6-5.6c12 8.3 26.7 13.1 42.6 13.1 41.4 0 75-33.3 75-74.3 0-29.8-17.7-55-42.9-66.9zM256 330.3c-41.4 0-75-33.3-75-74.3s33.6-74.3 75-74.3 75 33.3 75 74.3-33.6 74.3-75 74.3z"}}]})(props);
	};
	module.exports.IoMdFlower.displayName = "IoMdFlower";
	module.exports.IoMdFolderOpen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.334 144H256.006l-42.668-48H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144zM448 373.333c0 5.782-4.885 10.667-10.666 10.667H74.666C68.884 384 64 379.115 64 373.333V176h373.334c5.781 0 10.666 4.885 10.666 10.667v186.666z"}}]})(props);
	};
	module.exports.IoMdFolderOpen.displayName = "IoMdFolderOpen";
	module.exports.IoMdFolder = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.338 96H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144H256.006l-42.668-48z"}}]})(props);
	};
	module.exports.IoMdFolder.displayName = "IoMdFolder";
	module.exports.IoMdFootball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.3 48 48 141.3 48 256s93.3 208 208 208 208-93.3 208-208S370.7 48 256 48zM127 238.2l39.2 17.9 17.1 66.9-15.6 29.3-57.2-.7C95.6 329 86.2 303.1 83 276.3l44-38.1zm217.3 114.1L328.7 323l17.1-67 39.1-17.8 44 38.1c-3.1 26.8-12.6 52.7-27.5 75.3l-57.1.7zm32.4-146.2l-43.6 19.6-61.1-51.6v-47.2l47.9-32.6c29.8 11.9 56.4 32.3 75.6 57.8l-18.8 54zM191.3 94.4l47.7 32.5v47.2l-61 51.5-43-19.6-18.7-53.6c19.3-26.1 45.1-46 75-58zM218.4 426c-.7-.2-1.3-.3-2-.5l-20.5-55.1 14.7-29.4h90.8l15 30.3-19.8 53.9c-1 .2-2 .5-3 .7-11.5 2.3-27 3.8-40.4 4.1-11.7-.1-23.4-1.5-34.8-4z"}}]})(props);
	};
	module.exports.IoMdFootball.displayName = "IoMdFootball";
	module.exports.IoMdFunnel = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 400h96v-47.994h-96V400zM32 112v47.994h448V112H32zm80 168.783h288v-49.555H112v49.555z"}}]})(props);
	};
	module.exports.IoMdFunnel.displayName = "IoMdFunnel";
	module.exports.IoMdGift = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 134.5h-45.8c2.3-6.6 3.8-13.9 3.8-21.3 0-35.4-28.1-63.2-63-63.2-22.1 0-41.2 10.7-52.5 28L256 92.3l-10.5-14.5C234.2 60.7 215.1 48 193 48c-34.9 0-63 29.8-63 65.2 0 7.5 1.5 14.7 3.8 21.3H88c-23.3 0-41.8 19-41.8 42.7L46 421.8c0 23.7 17.4 42.2 40.7 42.2h336.7c23.3 0 42.7-18.5 42.7-42.2V177.2c-.1-23.7-18.8-42.7-42.1-42.7zM320 91c11.6 0 21 9.5 21 21 0 11.6-9.4 21-21 21s-21-9.5-21-21 9.4-21 21-21zm-128 0c11.6 0 21 9.5 21 21 0 11.6-9.4 21-21 21s-21-9.5-21-21 9.4-21 21-21zM88 177.2h106.7L151 237.5l34 25 50-69.1.2-.2-.2 228.6H88V177.2zm336 244.6H277V193.4l50 69.1 34-25-43.7-60.4H424v244.7z"}}]})(props);
	};
	module.exports.IoMdGift.displayName = "IoMdGift";
	module.exports.IoMdGitBranch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 160c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.3 32 55.4v8.6c0 19.9-7.8 33.7-25.3 44.9-15.4 9.8-38.1 17.1-67.5 21.5-14 2.1-25.7 6-35.2 10.7V151.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64S96 60.7 96 96c0 23.7 12.9 44.3 32 55.4v209.2c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-16.6-6.3-31.7-16.7-43.1 1.9-4.9 9.7-16.3 29.4-19.3 38.8-5.8 68.9-15.9 92.3-30.8 36-22.8 55-57 55-98.8v-8.6c19.1-11.1 32-31.7 32-55.4zM160 56c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 400c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm192-256c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitBranch.displayName = "IoMdGitBranch";
	module.exports.IoMdGitCommit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 224h-99.8c-14.2-55.2-64.2-96-123.7-96S147 168.8 132.8 224H32v64h100.8c14.2 55.2 64.2 96 123.7 96s109.5-40.8 123.7-96H480v-64zM256.5 336c-44 0-79.8-35.9-79.8-80s35.8-80 79.8-80 79.8 35.9 79.8 80-35.8 80-79.8 80z"}}]})(props);
	};
	module.exports.IoMdGitCommit.displayName = "IoMdGitCommit";
	module.exports.IoMdGitCompare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 382h-22c-24.6 0-29-3.6-33.8-9.6-5.5-6.9-8.2-19.1-8.2-54.2V151.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64S32 60.7 32 96c0 23.7 12.9 44.3 32 55.4v166.8c0 46.4 3.7 70.8 22.1 94 19.9 25.1 45 35.8 83.9 35.8h22v64l96-96-96-96v62zM96 56c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM448 360.6V190.8c0-46.4-3.7-70.8-22.1-94C406 71.7 380.9 62 342 62h-22V0l-96 96 96 96v-64h22c24.6 0 29 2.6 33.8 8.6 5.5 6.9 8.2 19.1 8.2 54.2v169.8c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4zM416 456c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitCompare.displayName = "IoMdGitCompare";
	module.exports.IoMdGitMerge = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 224c-23.7 0-44.4 12.9-55.4 32-18.3-.5-52.4-4.1-75.5-18.1-32.3-19.4-64.6-53.1-87-90.5 15.7-11.7 26-30.3 26-51.4 0-35.3-28.7-64-64-64S64 60.7 64 96c0 23.7 12.9 44.3 32 55.4v209.2c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4V244.2c18.7 19.4 39.1 36 60 48.6 38.8 23.4 87 26.9 108.6 27.3 11.1 19.1 31.7 31.9 55.4 31.9 35.3 0 64-28.7 64-64s-28.7-64-64-64zM88 96c0-22.1 17.9-40 40-40s40 17.9 40 40-17.9 40-40 40-40-17.9-40-40zm80 320c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40zm216-88c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitMerge.displayName = "IoMdGitMerge";
	module.exports.IoMdGitNetwork = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.6 12.9 44.3 32 55.4v52.8l-96 48-96-48v-52.8c19.1-11.1 32-31.8 32-55.4 0-35.3-28.7-64-64-64S64 60.7 64 96c0 23.6 12.9 44.3 32 55.4v92.4l128 64v52.8c-19.1 11.1-32 31.8-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.6-12.9-44.3-32-55.4v-52.8l128-64v-92.4c19.1-11.1 32-31.8 32-55.4zM128 56c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm128 400c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm128-320c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitNetwork.displayName = "IoMdGitNetwork";
	module.exports.IoMdGitPullRequest = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 376.6V206.8c0-46.4-3.7-70.8-22.1-94C374 87.7 348.9 77 310 77h-22V16l-96 96 96 96v-65h22c24.6 0 29 3.6 33.8 9.6 5.5 6.9 8.2 19.1 8.2 54.2v169.8c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4zM384 472c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM128 48c-35.3 0-64 28.7-64 64 0 23.7 12.9 44.3 32 55.4v209.2c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4V167.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64zm0 424c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-320c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitPullRequest.displayName = "IoMdGitPullRequest";
	module.exports.IoMdGlasses = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 176H272v.1h-32v-.1H32v48h11l5 21.5C64 313 88.5 336 144 336s96-17.4 96-90.5V224s1.5-16 16-16 16 16 16 16v21.8c0 73 42.1 90.2 97 90.2s79-25 95-90.2l5-21.8h11v-48z"}}]})(props);
	};
	module.exports.IoMdGlasses.displayName = "IoMdGlasses";
	module.exports.IoMdGlobe = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.124 48 48 141.125 48 256s93.124 208 208 208c114.875 0 208-93.125 208-208S370.875 48 256 48zm-21.549 384.999c-39.464-4.726-75.978-22.392-104.519-50.932C96.258 348.393 77.714 303.622 77.714 256c0-42.87 15.036-83.424 42.601-115.659.71 8.517 2.463 17.648 2.014 24.175-1.64 23.795-3.988 38.687 9.94 58.762 5.426 7.819 6.759 19.028 9.4 28.078 2.583 8.854 12.902 13.498 20.019 18.953 14.359 11.009 28.096 23.805 43.322 33.494 10.049 6.395 16.326 9.576 13.383 21.839-2.367 9.862-3.028 15.937-8.13 24.723-1.557 2.681 5.877 19.918 8.351 22.392 7.498 7.497 14.938 14.375 23.111 21.125 12.671 10.469-1.231 24.072-7.274 39.117zm147.616-50.932c-25.633 25.633-57.699 42.486-92.556 49.081 4.94-12.216 13.736-23.07 21.895-29.362 7.097-5.476 15.986-16.009 19.693-24.352 3.704-8.332 8.611-15.555 13.577-23.217 7.065-10.899-17.419-27.336-25.353-30.781-17.854-7.751-31.294-18.21-47.161-29.375-11.305-7.954-34.257 4.154-47.02-1.417-17.481-7.633-31.883-20.896-47.078-32.339-15.68-11.809-14.922-25.576-14.922-42.997 12.282.453 29.754-3.399 37.908 6.478 2.573 3.117 11.42 17.042 17.342 12.094 4.838-4.043-3.585-20.249-5.212-24.059-5.005-11.715 11.404-16.284 19.803-24.228 10.96-10.364 34.47-26.618 32.612-34.047s-23.524-28.477-36.249-25.193c-1.907.492-18.697 18.097-21.941 20.859.086-5.746.172-11.491.26-17.237.055-3.628-6.768-7.352-6.451-9.692.8-5.914 17.262-16.647 21.357-21.357-2.869-1.793-12.659-10.202-15.622-8.968-7.174 2.99-15.276 5.05-22.45 8.039 0-2.488-.302-4.825-.662-7.133a176.585 176.585 0 0 1 45.31-13.152l14.084 5.66 9.944 11.801 9.924 10.233 8.675 2.795 13.779-12.995L282 87.929V79.59c27.25 3.958 52.984 14.124 75.522 29.8-4.032.361-8.463.954-13.462 1.59-2.065-1.22-4.714-1.774-6.965-2.623 6.531 14.042 13.343 27.89 20.264 41.746 7.393 14.801 23.793 30.677 26.673 46.301 3.394 18.416 1.039 35.144 2.896 56.811 1.788 20.865 23.524 44.572 23.524 44.572s10.037 3.419 18.384 2.228c-7.781 30.783-23.733 59.014-46.769 82.052z"}}]})(props);
	};
	module.exports.IoMdGlobe.displayName = "IoMdGlobe";
	module.exports.IoMdGrid = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409.6 64H102.4C81.3 64 64 81.3 64 102.4v307.2c0 21.1 17.3 38.4 38.4 38.4h307.2c21.1 0 38.4-17.3 38.4-38.4V102.4c0-21.1-17.3-38.4-38.4-38.4zM179.2 409.6h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm115.2 230.4h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm115.2 230.4h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8z"}}]})(props);
	};
	module.exports.IoMdGrid.displayName = "IoMdGrid";
	module.exports.IoMdHammer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.1 398.2L229.8 167.8s8.8-57.7 26.2-71.8c17.5-14.2 48-32 48-32V32c-32 0-58.8 8.3-96.9 27.3-38 18.9-66.8 47.8-74.4 55.4-7.6 7.6-18.1 19.5-24.7 28.9s-5.3 20.1-5.3 20.1l-19.7 17-4-4c-2.3-2.3-6.2-2.3-8.5 0l-36.8 36.8c-2.3 2.3-2.3 6.2 0 8.5l59.4 59.4c2.3 2.3 6.2 2.3 8.5 0l36.8-36.8c2.3-2.3 2.3-6.2 0-8.5l-10.3-10.3 14.6-14.3c6.8-3.7 25.4-8.9 39.1-5.1l214.9 267.3c8.1 8.2 20.3 8.2 28.5 0l46.8-47.1c10.3-8 10.3-22.3 2.1-28.4z"}}]})(props);
	};
	module.exports.IoMdHammer.displayName = "IoMdHammer";
	module.exports.IoMdHand = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.679 273.5c-14.585-14.577-36.054-15.89-50.639-1.312l-41.687 41.664c-10.852 10.836-23.93 10.859-31.564 1.852-5.057-5.968-3.061-24.374-1.644-36.049l20.907-171.849c1.867-15.353-9.07-30.185-24.43-32.051-15.358-1.867-29.322 9.939-31.191 25.289L267.37 236.021c-1.205 3.358-3.79 3.938-4.081-.582L255.44 60c0-15.465-12.542-28-28.014-28-15.473 0-28.015 12.535-28.015 28l-.552 176.752c.146 2.04-1.604 2.624-1.92.294L172.016 99.077c-2.75-15.219-17.323-26.203-32.548-23.453-15.227 2.748-25.339 18.187-22.591 33.403l22.193 161.455c.023 2.872-.941 4.513-2.308.831l-33.109-88.517c-5.18-14.572-21.196-23.065-35.776-17.889-14.579 5.177-22.201 22.061-17.023 36.631l58.042 189.625c.303 1.046.624 2.085.953 3.118l.121.39c.011.031.025.058.035.088C126.079 444.233 172.57 480 227.427 480c35.116 0 71.591-12.378 99.357-33.672l.003-.002c29.99-18.051 126.071-121.347 126.071-121.347 14.587-14.577 12.408-36.899-2.179-51.479z"}}]})(props);
	};
	module.exports.IoMdHand.displayName = "IoMdHand";
	module.exports.IoMdHappy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C140.563 48 48 141.6 48 256s92.563 208 208 208 208-93.6 208-208S370.401 48 256 48zm0 374.4c-91.518 0-166.404-74.883-166.404-166.4 0-91.518 74.887-166.4 166.404-166.4S422.404 164.482 422.404 256 347.518 422.4 256 422.4zm72.8-187.2c17.683 0 31.201-13.518 31.201-31.2s-13.519-31.2-31.201-31.2c-17.682 0-31.2 13.518-31.2 31.2s13.518 31.2 31.2 31.2zm-145.6 0c17.682 0 31.2-13.518 31.2-31.2s-13.519-31.2-31.2-31.2c-17.683 0-31.201 13.518-31.201 31.2s13.519 31.2 31.201 31.2zM256 370.4c48.883 0 89.436-30.164 106.081-72.801H149.919C166.564 340.236 207.117 370.4 256 370.4z"}}]})(props);
	};
	module.exports.IoMdHappy.displayName = "IoMdHappy";
	module.exports.IoMdHeadset = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C150 48 64 136.2 64 245.1v153.3c0 36.3 28.6 65.7 64 65.7h64V288h-85.3v-42.9c0-84.7 66.8-153.3 149.3-153.3s149.3 68.5 149.3 153.3V288H320v176h64c35.4 0 64-29.3 64-65.7V245.1C448 136.2 362 48 256 48z"}}]})(props);
	};
	module.exports.IoMdHeadset.displayName = "IoMdHeadset";
	module.exports.IoMdHeartDislike = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M51.9 76.6l25 25c-18.1 20.3-29 47.3-29 77.6 0 79.5 70.7 143.3 177.8 241.7L256 448l30.2-27.2c20.6-18.9 39.9-36.6 57.5-53.3l92.2 92 24-24-383.8-383-24.2 24.1zM464 179.1C464 114.2 414.1 64 349.6 64c-36.4 0-70.7 16.7-93.6 43.9C233.1 80.7 198.8 64 162.4 64c-8.4 0-16.5.9-24.3 2.5l253.7 253.1C437.3 270.9 464 228 464 179.1z"}}]})(props);
	};
	module.exports.IoMdHeartDislike.displayName = "IoMdHeartDislike";
	module.exports.IoMdHeartEmpty = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.6 64c-36.4 0-70.7 16.7-93.6 43.9C233.1 80.7 198.8 64 162.4 64 97.9 64 48 114.2 48 179.1c0 79.5 70.7 143.3 177.8 241.7L256 448l30.2-27.2C393.3 322.4 464 258.6 464 179.1 464 114.2 414.1 64 349.6 64zm-80.8 329.3l-4.2 3.9-8.6 7.8-8.6-7.8-4.2-3.9c-50.4-46.3-94-86.3-122.7-122-28-34.7-40.4-63.1-40.4-92.2 0-22.9 8.4-43.9 23.7-59.3 15.2-15.4 36-23.8 58.6-23.8 26.1 0 52 12.2 69.1 32.5l24.5 29.1 24.5-29.1c17.1-20.4 43-32.5 69.1-32.5 22.6 0 43.4 8.4 58.7 23.8 15.3 15.4 23.7 36.5 23.7 59.3 0 29-12.5 57.5-40.4 92.2-28.8 35.7-72.3 75.7-122.8 122z"}}]})(props);
	};
	module.exports.IoMdHeartEmpty.displayName = "IoMdHeartEmpty";
	module.exports.IoMdHeartHalf = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.6 64c-36.4 0-70.7 16.7-93.6 43.9C233.1 80.7 198.8 64 162.4 64 97.9 64 48 114.2 48 179.1c0 79.5 70.7 143.3 177.8 241.7L256 448l30.2-27.2C393.3 322.4 464 258.6 464 179.1 464 114.2 414.1 64 349.6 64zM256 406V157.7l24.5-29.1c17.1-20.4 43-32.5 69.1-32.5 22.6 0 43.4 8.4 58.7 23.8 15.3 15.4 23.7 36.5 23.7 59.3 0 29-12.5 57.5-40.4 92.2C362.8 307 306.4 359.7 256 406z"}}]})(props);
	};
	module.exports.IoMdHeartHalf.displayName = "IoMdHeartHalf";
	module.exports.IoMdHeart = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448l-30.164-27.211C118.718 322.442 48 258.61 48 179.095 48 114.221 97.918 64 162.4 64c36.399 0 70.717 16.742 93.6 43.947C278.882 80.742 313.199 64 349.6 64 414.082 64 464 114.221 464 179.095c0 79.516-70.719 143.348-177.836 241.694L256 448z"}}]})(props);
	};
	module.exports.IoMdHeart.displayName = "IoMdHeart";
	module.exports.IoMdHelpBuoy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm61 356l-12.2-39.6c13-5.8 24.9-14 35.3-24.4 10.4-10.4 18.6-22.3 24.4-35.3l39.5 12.1c-7.9 19.3-19.7 37-34.9 52.2-15.1 15.3-32.8 27.1-52.1 35zM195 108l12.2 39.6c-13 5.8-24.9 14-35.3 24.4-10.4 10.4-18.6 22.3-24.4 35.3L108 195.2c7.9-19.3 19.7-37 34.9-52.2 15.1-15.3 32.8-27.1 52.1-35zm61 84c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm113.1-49.1c15.2 15.2 26.9 32.9 34.9 52.1l-39.5 12.2c-5.9-13-14-24.9-24.4-35.3-10.4-10.4-22.3-18.6-35.3-24.4l12.1-39.5c19.3 7.9 37 19.7 52.2 34.9zM142.9 369.1c-15.2-15.1-27-32.8-34.9-52.1l39.5-12.2c5.9 13 14 24.9 24.4 35.3 10.4 10.4 22.3 18.6 35.3 24.4L195.1 404c-19.3-7.9-37-19.7-52.2-34.9z"}}]})(props);
	};
	module.exports.IoMdHelpBuoy.displayName = "IoMdHelpBuoy";
	module.exports.IoMdHelpCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M235 339h42v42h-42zM276.8 318h-41.6c0-67 62.4-62.2 62.4-103.8 0-22.9-18.7-41.7-41.6-41.7S214.4 192 214.4 214h-41.6c0-46 37.2-83 83.2-83s83.2 37.1 83.2 83.1c0 52-62.4 57.9-62.4 103.9z"}}]})(props);
	};
	module.exports.IoMdHelpCircleOutline.displayName = "IoMdHelpCircleOutline";
	module.exports.IoMdHelpCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm21 333h-42v-42h42v42zm-.2-63h-41.6c0-67 62.4-62.2 62.4-103.8 0-22.9-18.7-41.7-41.6-41.7S214.4 192 214.4 214h-41.6c0-46 37.2-83 83.2-83s83.2 37.1 83.2 83.1c0 52-62.4 57.9-62.4 103.9z"}}]})(props);
	};
	module.exports.IoMdHelpCircle.displayName = "IoMdHelpCircle";
	module.exports.IoMdHelp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M289 448h-66v-65h66v65zm-1-98h-64c0-101 96-95.1 96-159 0-35.2-28.8-63.4-64-63.4S192 158 192 192h-64c0-71 57.3-128 128-128s128 56.4 128 127c0 79.9-96 89-96 159z"}}]})(props);
	};
	module.exports.IoMdHelp.displayName = "IoMdHelp";
	module.exports.IoMdHome = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 448V320h96v128h97.6V256H464L256 64 48 256h62.4v192z"}}]})(props);
	};
	module.exports.IoMdHome.displayName = "IoMdHome";
	module.exports.IoMdHourglass = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 48v122.8h.2l-.2.2 85.3 85-85.3 85.2.2.2h-.2V464h256V341.4h-.2l.2-.2-85.3-85.2 85.3-85-.2-.2h.2V48H128zm213.3 303.9v71.5H170.7v-71.5l85.3-85.2 85.3 85.2zM256 245.4l-85.3-85.2V87.6h170.7v72.5L256 245.4z"}}]})(props);
	};
	module.exports.IoMdHourglass.displayName = "IoMdHourglass";
	module.exports.IoMdIceCream = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128.1 256l128 224 128-224zM392 161c3-9 4.7-22.7 4.7-32.9 0-53.1-43-96.1-96.1-96.1-31.4 0-59.2 15-76.8 38.3 0 0-9.1 14-10.8 29l-3.4-1c-2.3-9-3.7-20 1.6-31.5-7.4-2.5-9.4-2.8-17.6-2.8-41.7 0-75.6 33.8-75.6 75.6 0 6.3.8 15.5 2.3 21.4-13.9 3.5-24.3 16.1-24.3 31 0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32 0-14.8-10.2-27.4-24-31z"}}]})(props);
	};
	module.exports.IoMdIceCream.displayName = "IoMdIceCream";
	module.exports.IoMdImage = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 405.333V106.667C448 83.198 428.802 64 405.333 64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333zM181.333 288l53.334 64 74.666-96 96 128H106.667l74.666-96z"}}]})(props);
	};
	module.exports.IoMdImage.displayName = "IoMdImage";
	module.exports.IoMdImages = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M457.6 140.2l-82.5-4-4.8-53.8c-1-11.3-11.1-19.2-22.9-18.3L51.5 88.4c-11.8 1-20.3 10.5-19.4 21.7l21.2 235.8c1 11.3 11.2 19.2 22.9 18.3l15-1.2-2.4 45.8c-.6 12.6 9.2 22.8 22.4 23.5L441.3 448c13.2.6 24.1-8.6 24.8-21.2L480 163.5c.6-12.5-9.3-22.7-22.4-23.3zm-354.9 5.3l-7.1 134.8L78.1 305 62 127v-.5-.5c1-5 4.4-9 9.6-9.4l261-21.4c5.2-.4 9.7 3 10.5 7.9 0 .2.3.2.3.4 0 .1.3.2.3.4l2.7 30.8-219-10.5c-13.2-.4-24.1 8.8-24.7 21.3zm334 236.9l-84.8-99.5-37.4 34.3-69.2-80.8-122.7 130.7L133 168v-.4c1-5.4 6.2-9.3 11.9-9l291.2 14c5.8.3 10.3 4.7 10.4 10.2 0 .2.3.3.3.5l-10.1 199.1z"}},{"tag":"path","attr":{"d":"M384 256c17.6 0 32-14.4 32-32s-14.3-32-32-32c-17.6 0-32 14.3-32 32s14.3 32 32 32z"}}]})(props);
	};
	module.exports.IoMdImages.displayName = "IoMdImages";
	module.exports.IoMdInfinite = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.7 188c-18.8-18-43.8-28-70.5-28-26.6 0-51.6 9.9-70.4 27.9l-17.6 15.9 33.1 32.1 17-15.4.1-.1c10.1-9.6 23.5-15 37.7-15 14.2 0 27.6 5.3 37.7 14.9 10 9.6 15.4 22.3 15.4 35.8 0 13.5-5.5 26.1-15.4 35.6-10.1 9.6-23.5 15-37.7 15s-27.6-5.3-37.7-14.9L218.2 188c-18.9-18-43.9-28-70.4-28-26.7 0-51.7 9.9-70.5 28C58.4 206.1 48 230.2 48 256c0 25.7 10.4 49.9 29.3 68 18.8 18 43.8 28 70.5 28 26.7 0 51.7-9.9 70.4-28l37.8-36.1 37.7 36.1c18.9 18 43.9 28 70.4 28 26.7 0 51.7-9.9 70.4-27.9 19-18.1 29.4-42.2 29.4-68 .1-25.8-10.3-50-29.2-68.1zM185.5 291.7c-10.1 9.6-23.5 15-37.7 15-14.2 0-27.6-5.3-37.7-14.9-10-9.6-15.4-22.3-15.4-35.8 0-13.5 5.5-26.1 15.4-35.6 10.1-9.6 23.5-15 37.7-15 14.2 0 27.6 5.3 37.7 14.9l37.4 35.8-37.4 35.6z"}}]})(props);
	};
	module.exports.IoMdInfinite.displayName = "IoMdInfinite";
	module.exports.IoMdInformationCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M277 360h-42V235h42v125zm0-166h-42v-42h42v42z"}}]})(props);
	};
	module.exports.IoMdInformationCircleOutline.displayName = "IoMdInformationCircleOutline";
	module.exports.IoMdInformationCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm21 312h-42V235h42v125zm0-166h-42v-42h42v42z"}}]})(props);
	};
	module.exports.IoMdInformationCircle.displayName = "IoMdInformationCircle";
	module.exports.IoMdInformation = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232 235h48v137h-48zM232 140h48v48h-48z"}}]})(props);
	};
	module.exports.IoMdInformation.displayName = "IoMdInformation";
	module.exports.IoMdJet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32s-23.4-.7-59.3 27.1C404 72 244.9 186.8 244.9 186.8l-168.8-4.2L32 222l109.8 55.2-8.6 10.8-87.9.1-7.2 40.5 63.1 48.7-26.6 59.8 60-26.4 48.7 63.1 40.5-7.2.1-87.8 10.9-8.5L290.1 480l39.3-44.1-4.2-168.7S440.1 108.2 453 91.6C480.7 55.5 480 32 480 32z"}}]})(props);
	};
	module.exports.IoMdJet.displayName = "IoMdJet";
	module.exports.IoMdJournal = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M117.3 42.7c-17.6 0-32 14.4-32 32v362.7c0 17.6 14.4 32 32 32H320V42.7H117.3zM384.7 42.7H368v426.7h16.7c23.1 0 42-18.9 42-42V84.7c0-23.1-18.9-42-42-42z"}}]})(props);
	};
	module.exports.IoMdJournal.displayName = "IoMdJournal";
	module.exports.IoMdKey = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.2 224c-14.2-40.2-55.1-72-100.2-72-57.2 0-101 46.8-101 104s45.8 104 103 104c45.1 0 84.1-31.8 98.2-72H352v64h69.1v-64H464v-64H249.2zm-97.6 66.5c-19 0-34.5-15.5-34.5-34.5s15.5-34.5 34.5-34.5 34.5 15.5 34.5 34.5-15.5 34.5-34.5 34.5z"}}]})(props);
	};
	module.exports.IoMdKey.displayName = "IoMdKey";
	module.exports.IoMdKeypad = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 398.5c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.3-18.2-40.7-40.5-40.7zM136.5 32C114.2 32 96 50.3 96 72.7s18.2 40.7 40.5 40.7S177 95.1 177 72.7 158.8 32 136.5 32zm0 122.2c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7-18.2-40.7-40.5-40.7zm0 122.2c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.4-18.2-40.7-40.5-40.7zm239-162.9c22.3 0 40.5-18.3 40.5-40.7S397.8 32 375.5 32 335 50.3 335 72.7s18.2 40.8 40.5 40.8zM256 276.4c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.4-18.2-40.7-40.5-40.7zm119.5 0c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.4-18.2-40.7-40.5-40.7zm0-122.2c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7-18.2-40.7-40.5-40.7zm-119.5 0c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7-18.2-40.7-40.5-40.7zM256 32c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7S278.3 32 256 32z"}}]})(props);
	};
	module.exports.IoMdKeypad.displayName = "IoMdKeypad";
	module.exports.IoMdLaptop = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.334 416C460.803 416 480 396.803 480 373.334V106.668C480 83.199 460.803 64 437.334 64H74.666C51.197 64 32 83.199 32 106.668v266.666C32 396.803 51.197 416 74.666 416H0c0 23.469 64 32 96 32h320c32 0 96-8.531 96-32h-74.666zM74.666 106.668h362.668v271.998H74.666V106.668zM256 434.666c-11.729 0-21.333-9.604-21.333-21.334 0-11.729 9.604-21.332 21.333-21.332s21.333 9.604 21.333 21.332c0 11.73-9.604 21.334-21.333 21.334z"}}]})(props);
	};
	module.exports.IoMdLaptop.displayName = "IoMdLaptop";
	module.exports.IoMdLeaf = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 287.6C416 120.9 256 32 256 32S96 120.9 96 287.6c0 118.8 81.3 140.5 128 143.2V480h64v-49.3c46.7-2.6 128-24.3 128-143.1z"}}]})(props);
	};
	module.exports.IoMdLeaf.displayName = "IoMdLeaf";
	module.exports.IoMdLink = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M74.6 256c0-38.3 31.1-69.4 69.4-69.4h88V144h-88c-61.8 0-112 50.2-112 112s50.2 112 112 112h88v-42.6h-88c-38.3 0-69.4-31.1-69.4-69.4zm85.4 22h192v-44H160v44zm208-134h-88v42.6h88c38.3 0 69.4 31.1 69.4 69.4s-31.1 69.4-69.4 69.4h-88V368h88c61.8 0 112-50.2 112-112s-50.2-112-112-112z"}}]})(props);
	};
	module.exports.IoMdLink.displayName = "IoMdLink";
	module.exports.IoMdListBox = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 64H104c-22.091 0-40 17.908-40 40v304c0 22.092 17.909 40 40 40h304c22.092 0 40-17.908 40-40V104c0-22.092-17.908-40-40-40zM304 368H144v-48h160v48zm64-88H144v-48h224v48zm0-88H144v-48h224v48z"}}]})(props);
	};
	module.exports.IoMdListBox.displayName = "IoMdListBox";
	module.exports.IoMdList = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 280h256v48H80zM80 184h320v48H80zM80 88h352v48H80z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M80 376h288v48H80z"}}]}]})(props);
	};
	module.exports.IoMdList.displayName = "IoMdList";
	module.exports.IoMdLocate = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 176c-44.004 0-80.001 36-80.001 80 0 44.004 35.997 80 80.001 80 44.005 0 79.999-35.996 79.999-80 0-44-35.994-80-79.999-80zm190.938 58.667c-9.605-88.531-81.074-160-169.605-169.599V32h-42.666v33.067c-88.531 9.599-160 81.068-169.604 169.599H32v42.667h33.062c9.604 88.531 81.072 160 169.604 169.604V480h42.666v-33.062c88.531-9.604 160-81.073 169.605-169.604H480v-42.667h-33.062zM256 405.333c-82.137 0-149.334-67.198-149.334-149.333 0-82.136 67.197-149.333 149.334-149.333 82.135 0 149.332 67.198 149.332 149.333S338.135 405.333 256 405.333z"}}]})(props);
	};
	module.exports.IoMdLocate.displayName = "IoMdLocate";
	module.exports.IoMdLock = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 186h-20v-40c0-55-45-100-100-100S156 91 156 146v40h-20c-22.002 0-40 17.998-40 40v200c0 22.002 17.998 40 40 40h240c22.002 0 40-17.998 40-40V226c0-22.002-17.998-40-40-40zM256 368c-22.002 0-40-17.998-40-40s17.998-40 40-40 40 17.998 40 40-17.998 40-40 40zm62.002-182H193.998v-40c0-34.004 28.003-62.002 62.002-62.002 34.004 0 62.002 27.998 62.002 62.002v40z"}}]})(props);
	};
	module.exports.IoMdLock.displayName = "IoMdLock";
	module.exports.IoMdLogIn = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-42.9 0-84.2 13-119.2 37.5-34.2 24-60.2 57.2-75.1 96.1L58 192h45.7l1.9-5c8.2-17.8 19.4-33.9 33.5-48 31.2-31.2 72.7-48.4 116.9-48.4s85.7 17.2 116.9 48.4c31.2 31.2 48.4 72.7 48.4 116.9 0 44.1-17.2 85.7-48.4 116.9-31.2 31.2-72.7 48.4-116.9 48.4-44.1 0-85.6-17.2-116.9-48.4-14-14-25.3-30.1-33.5-47.9l-1.9-5H58l3.6 10.4c14.9 38.9 40.9 72.1 75.1 96.1C171.8 451.1 213 464 256 464c114.7 0 208-93.3 208-208S370.7 48 256 48z"}},{"tag":"path","attr":{"d":"M48 277.4h189.7l-43.6 44.7L224 352l96-96-96-96-31 29.9 44.7 44.7H48v42.8z"}}]})(props);
	};
	module.exports.IoMdLogIn.displayName = "IoMdLogIn";
	module.exports.IoMdLogOut = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 277.4h189.7l-43.6 44.7L368 352l96-96-96-96-31 29.9 44.7 44.7H192v42.8z"}},{"tag":"path","attr":{"d":"M255.7 421.3c-44.1 0-85.5-17.2-116.7-48.4-31.2-31.2-48.3-72.7-48.3-116.9 0-44.1 17.2-85.7 48.3-116.9 31.2-31.2 72.6-48.4 116.7-48.4 44 0 85.3 17.1 116.5 48.2l30.3-30.3c-8.5-8.4-17.8-16.2-27.7-23.2C339.7 61 298.6 48 255.7 48 141.2 48 48 141.3 48 256s93.2 208 207.7 208c42.9 0 84-13 119-37.5 10-7 19.2-14.7 27.7-23.2l-30.2-30.2c-31.1 31.1-72.5 48.2-116.5 48.2zM448.004 256.847l-.849-.848.849-.849.848.849z"}}]})(props);
	};
	module.exports.IoMdLogOut.displayName = "IoMdLogOut";
	module.exports.IoMdMagnet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.6 98.8C352.1 65.8 308 48.2 256 48c-51.9.2-96 17.8-127.5 50.8C96.8 132 80 178.8 80 234c0 43.5 1.8 69.2 12.9 115.8 0 0 22.7 75.7 35.5 104.1 3.5 7.8 7.4 11.8 15.5 9.3 6.4-2 46.8-17.9 54.7-21.6 7.9-3.6 11.6-8.6 8.9-15.2-3.8-9.2-33.9-95.6-33.9-95.6-8.4-36.3-11.6-53.9-11.6-94.3 0-28.2 9.8-54.1 27.7-72.9 17.5-18.3 41-28.4 66.3-28.4s48.8 10.1 66.3 28.4c17.9 18.8 27.7 44.6 27.7 72.8 0 40-3.2 64-11.7 94.4s-32.2 90.1-33.9 95.6c-1.7 5.6 2.1 12.5 8.9 15.2 6.8 2.7 49.3 19.6 54.7 21.6 5.4 2 10.6.6 14.5-7.7 4-8.3 24.6-61.4 36.5-105.7 12-44.3 13-72.3 13-115.8 0-55.2-16.7-101.9-48.4-135.2zM173.1 419.7l-22.9 9.6c-6.9-16.3-17.2-43.2-25.9-77.2l22-6.5 26.8 74.1zm188.6 9.6l-22.9-9.6c7.2-16.6 19.1-45.1 26.6-74.1l22 6.5c-8.4 33.9-18.7 60.9-25.7 77.2z"}}]})(props);
	};
	module.exports.IoMdMagnet.displayName = "IoMdMagnet";
	module.exports.IoMdMailOpen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 201.667c0-14.933-7.469-28.803-20.271-36.266L256 64 52.271 165.401C40.531 172.864 32 186.734 32 201.667v203.666C32 428.802 51.197 448 74.666 448h362.668C460.803 448 480 428.802 480 405.333V201.667zM256 304L84.631 192 256 106.667 427.369 192 256 304z"}}]})(props);
	};
	module.exports.IoMdMailOpen.displayName = "IoMdMailOpen";
	module.exports.IoMdMailUnread = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"432","cy":"128","r":"64"}},{"tag":"path","attr":{"d":"M382.9 203.4L256 288 80 170.7V128l176 117.3 101.1-67.4c-9.5-14.3-15.1-31.5-15.1-49.9 0-17.6 5.1-34.1 13.9-48H74.7C51.2 80 32 99.2 32 122.7v266.7c0 23.5 19.2 42.7 42.7 42.7h362.7c23.5 0 42.7-19.2 42.7-42.7V204.1c-13.9 8.8-30.4 13.9-48 13.9-18.2 0-35.1-5.4-49.2-14.6z"}}]})(props);
	};
	module.exports.IoMdMailUnread.displayName = "IoMdMailUnread";
	module.exports.IoMdMail = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667L256 288 80 170.667V128l176 117.333L432 128v42.667z"}}]})(props);
	};
	module.exports.IoMdMail.displayName = "IoMdMail";
	module.exports.IoMdMale = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48H288v48h94.1L275.4 202.6C251.9 185.9 223.1 176 192 176c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-31.1-9.9-59.9-26.6-83.4L416 129.9V224h48V48h-48zM192 416c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"}}]})(props);
	};
	module.exports.IoMdMale.displayName = "IoMdMale";
	module.exports.IoMdMan = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 106.6c20.6.1 37.3-16.6 37.3-37.3 0-20.6-16.7-37.3-37.3-37.3-20.6 0-37.3 16.7-37.3 37.3 0 20.6 16.7 37.3 37.3 37.3zM293.4 115h-74.8c-28.2 0-46.6 24.8-46.6 48.4V277c0 22 31 22 31 0V172h6v285.6c0 30.4 42 29.4 43 0V293h8v164.7c1.7 31.2 43 28.2 43-.1V172h5v105c0 22 32 22 32 0V163.4c0-23.5-18.5-48.4-46.6-48.4z"}}]})(props);
	};
	module.exports.IoMdMan.displayName = "IoMdMan";
	module.exports.IoMdMap = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.333 64c-2.176 0-4.396 1.369-9.176 3.207L320 108.802 192 64 71.469 104.531C67.197 105.604 64 109.864 64 115.197v322.136C64 443.729 68.271 448 74.666 448c1.828 0 6.505-2.33 9.087-3.319L192 403.197 320 448l120.531-40.531c4.271-1.073 7.469-5.334 7.469-10.667V74.666C448 68.271 443.729 64 437.333 64zM320 405.333l-128-44.802V106.666l128 44.803v253.864z"}}]})(props);
	};
	module.exports.IoMdMap.displayName = "IoMdMap";
	module.exports.IoMdMedal = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M273.5 152.1H48l54.1-103.9h240.7z"}},{"tag":"circle","attr":{"cx":"256.2","cy":"377.2","r":"86.6"}},{"tag":"path","attr":{"d":"M348.9 299.1l115.1-147-69.3-103.9L256.4 256c32.3 0 62.7 12.7 85.5 35.5 2.5 2.5 4.8 5 7 7.6zM205.8 266.6L152.3 186H48.4l90.1 161.5c5.2-21.2 16.1-40.6 32-56.4 10.4-10.3 22.3-18.6 35.3-24.5z"}}]})(props);
	};
	module.exports.IoMdMedal.displayName = "IoMdMedal";
	module.exports.IoMdMedical = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M351.9 256L460 193.6l-48-83.2-108 62.4V48h-96v124.8l-108-62.4-48 83.2L160.1 256 52 318.4l48 83.2 108-62.4V464h96V339.2l108 62.4 48-83.2z"}}]})(props);
	};
	module.exports.IoMdMedical.displayName = "IoMdMedical";
	module.exports.IoMdMedkit = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 144v-39.6C352 82 334 64 311.6 64H200.4C178 64 160 82 160 104.4V144H48v263.6C48 430 66 448 88.4 448h335.2c22.4 0 40.4-18 40.4-40.4V144H352zm-152-40h112v40H200v-40zm136 224h-56v56h-48v-56h-56v-48h56v-56h48v56h56v48z"}}]})(props);
	};
	module.exports.IoMdMedkit.displayName = "IoMdMedkit";
	module.exports.IoMdMegaphone = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.1 143.4l-23.1 23c14.7 14.7 23.9 35.2 23.9 57.6s-9.2 42.9-23.9 57.6l23.1 23.1c20.6-20.6 33.4-49.2 33.4-80.6s-12.8-60.1-33.4-80.7z"}},{"tag":"path","attr":{"d":"M428.2 99l-22.7 22.7c26.1 26.1 42.3 62.4 42.3 102.3 0 39.8-16.1 76.1-42.3 102.3l22.7 22.7c31.9-32.1 51.8-76.3 51.8-125s-19.8-92.9-51.8-125zM320 184.1V80h-32l-96 80H64l-32 16v112l32 16 80 128h48l-30-128h30l96 64h32V263.9c18.4-1.7 32-18.9 32-39.9s-13.6-38.2-32-39.9z"}}]})(props);
	};
	module.exports.IoMdMegaphone.displayName = "IoMdMegaphone";
	module.exports.IoMdMenu = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 384h384v-42.666H64V384zm0-106.666h384v-42.667H64v42.667zM64 128v42.665h384V128H64z"}}]})(props);
	};
	module.exports.IoMdMenu.displayName = "IoMdMenu";
	module.exports.IoMdMicOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M367.951 354.654l-26.616-26.562-9.568-9.548-4.698-4.706L187 174.041v.346L76.112 63.531 51.921 87.572 187 222.47v28.816c0 37.79 31.121 68.714 68.91 68.714a68.6 68.6 0 0 0 24.565-4.545l32.389 32.274c-17.333 8.793-36.812 13.86-56.782 13.86-62.986 0-121.365-48.59-121.365-116.59H95.773C95.773 322 158 387.701 233 398.013V480h46v-81.987c22-3.352 43.066-11.222 61.627-22.622l95.278 95.078 24.033-24-33.847-33.785-58.216-57.959 58.224 57.959-58.148-58.03zM325 251.286V100.714C325 62.924 293.791 32 256 32s-69 30.924-69 68.714v25.244l137.109 136.968c.67-3.791.891-7.679.891-11.64zM416.439 245h-38.941c0 20.496-5.498 39.676-14.931 56.197l27.572 27.516c16.523-24.11 26.3-52.787 26.3-83.713zM459.999 446.427l-33.897-33.743 33.855 33.785z"}}]})(props);
	};
	module.exports.IoMdMicOff.displayName = "IoMdMicOff";
	module.exports.IoMdMic = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 320c37.712 0 68.571-30.924 68.571-68.714V100.714C324.571 62.924 293.712 32 256 32s-68.571 30.924-68.571 68.714v150.572c0 37.79 30.859 68.714 68.571 68.714zm121.139-75.452c0 68.714-58.282 116.815-121.139 116.815s-121.139-48.102-121.139-116.815H96c0 77.873 61.719 143.153 137.144 153.465V480h45.713v-81.987C354.281 386.561 416 322.421 416 244.548h-38.861z"}}]})(props);
	};
	module.exports.IoMdMic.displayName = "IoMdMic";
	module.exports.IoMdMicrophone = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 112V84.4c0-29-24.5-52.4-54.8-52.4H182.9C152.5 32 128 55.4 128 84.4V112h152v37H128v43h152v37H128v43h152v37H128v41.8c0 29 24.5 52.2 54.9 52.2H213v77h86v-77h30.2c30.3 0 54.8-23.2 54.8-52.2V309h-56v-37h56v-43h-56v-37h56v-43h-56v-37h56z"}}]})(props);
	};
	module.exports.IoMdMicrophone.displayName = "IoMdMicrophone";
	module.exports.IoMdMoon = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M195 125c0-26.3 5.3-51.3 14.9-74.1C118.7 73 51 155.1 51 253c0 114.8 93.2 208 208 208 97.9 0 180-67.7 202.1-158.9-22.8 9.6-47.9 14.9-74.1 14.9-106 0-192-86-192-192z"}}]})(props);
	};
	module.exports.IoMdMoon.displayName = "IoMdMoon";
	module.exports.IoMdMore = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 136c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0 240c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0-120c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40z"}}]})(props);
	};
	module.exports.IoMdMore.displayName = "IoMdMore";
	module.exports.IoMdMove = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 256l-96-96v64h-96v-96h64l-96-96-96 96h64v96h-96v-64l-96 96 96 96v-64h96v96h-64l96 96 96-96h-64v-96h96v64z"}}]})(props);
	};
	module.exports.IoMdMove.displayName = "IoMdMove";
	module.exports.IoMdMusicalNote = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64v225.1c-12.6-7.3-27.1-11.7-42.7-11.7-47.1 0-85.3 38.2-85.3 85.3s38.2 85.3 85.3 85.3 85.3-38.2 85.3-85.3V149.3H384V64H256z"}}]})(props);
	};
	module.exports.IoMdMusicalNote.displayName = "IoMdMusicalNote";
	module.exports.IoMdMusicalNotes = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 64v257.6c-8.2-2.7-17.2-4.1-26.6-4.1-38.3 0-69.4 27.1-69.4 65.4 0 38.3 31.1 65.1 69.4 65.1 38.3 0 69.6-28.2 69.6-69.1V200h202v121.6c-8.2-2.7-17.2-4.1-26.6-4.1-38.3 0-69.4 27.1-69.4 65.4 0 38.3 31.1 65.1 69.4 65.1 38.3 0 69.6-28.2 69.6-69.1V64H160zm245 96H203v-53h202v53z"}}]})(props);
	};
	module.exports.IoMdMusicalNotes.displayName = "IoMdMusicalNotes";
	module.exports.IoMdNavigate = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64L96 433.062 110.938 448 256 384l145.062 64L416 433.062z"}}]})(props);
	};
	module.exports.IoMdNavigate.displayName = "IoMdNavigate";
	module.exports.IoMdNotificationsOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 463.656c22.814 0 41.475-18.656 41.475-41.656h-82.95c0 23 18.661 41.656 41.475 41.656z"}},{"tag":"path","attr":{"d":"M131.083 107.172l.053.074L98.09 74.277 74.004 98.383l63.042 63.153C126.888 180.521 121 202.196 121 225.07v114.555l-41 41.656V402h297.743l36.182 36.33 24.079-24.301L425.9 402h.316L131.083 107.172zM391 225.07c0-63.526-45-117.677-104-131.218V79.274c0-17.706-13.371-31.243-31-31.243-17.628 0-31 13.537-31 31.243v14.578c-15 3.438-29.048 9.501-41.75 17.663L391 319.355V225.07z"}}]})(props);
	};
	module.exports.IoMdNotificationsOff.displayName = "IoMdNotificationsOff";
	module.exports.IoMdNotificationsOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M257 120.471c7.083 0 23.911 4.479 23.911 4.479 45.589 10.447 77.678 52.439 77.678 99.85V352.412l9.321 9.364 7.788 7.823H136.302l7.788-7.823 9.321-9.364V224.8c0-47.41 32.089-89.403 77.678-99.85 0 0 18.043-4.479 23.911-4.479M256 48c-17.602 0-31.059 13.518-31.059 31.2v14.559c-59.015 13.523-103.53 67.601-103.53 131.041v114.4L80 380.8v20.8h352v-20.8l-41.411-41.6V224.8c0-63.44-44.516-117.518-103.53-131.041V79.2c0-17.682-13.457-31.2-31.059-31.2zm41.411 374.4h-82.823c0 22.881 18.633 41.6 41.412 41.6s41.411-18.719 41.411-41.6z"}}]})(props);
	};
	module.exports.IoMdNotificationsOutline.displayName = "IoMdNotificationsOutline";
	module.exports.IoMdNotifications = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c22.779 0 41.411-18.719 41.411-41.6h-82.823c0 22.881 18.633 41.6 41.412 41.6zm134.589-124.8V224.8c0-63.44-44.516-117.518-103.53-131.041V79.2c0-17.682-13.457-31.2-31.059-31.2s-31.059 13.518-31.059 31.2v14.559c-59.015 13.523-103.53 67.601-103.53 131.041v114.4L80 380.8v20.8h352v-20.8l-41.411-41.6z"}}]})(props);
	};
	module.exports.IoMdNotifications.displayName = "IoMdNotifications";
	module.exports.IoMdNuclear = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 272c0-29.8-16.3-55.7-40.4-69.5l73.1-124.1C335.6 59.1 297.1 48 256 48c-41.2 0-79.9 11.2-113.1 30.6l71.6 125C191.4 217.6 176 243 176 272H32c0 83.3 46.9 153.4 114.4 192l70.1-122.4c11.7 6.6 25.1 10.4 39.5 10.4 14.3 0 27.7-3.8 39.3-10.3L365.6 464C433.1 425.4 480 355.3 480 272H336z"}}]})(props);
	};
	module.exports.IoMdNuclear.displayName = "IoMdNuclear";
	module.exports.IoMdNutrition = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M357.2 235.6L274.7 153h-.8c-8.1-6-18.2-10.3-28.4-10.3-13.7 0-26.1 6.3-34.3 16.3h-.6L53 414.1v.8c-3 6.2-5 13.3-5 20.8 0 24.4 19.7 44.3 44.3 44.3 9.4 0 18-2.9 27.4-9.1l232.9-168.1c10.9-8.3 17.4-21.6 17.4-36 0-12-4.7-23.2-12.8-31.2zM464 145.1l-29.2-49-36.6 20.3 31.5-55.9L380.6 32l-67.3 127.8 41.3 41.4z"}}]})(props);
	};
	module.exports.IoMdNutrition.displayName = "IoMdNutrition";
	module.exports.IoMdOpen = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.34 405.332H106.66V106.668H240V64H106.66C83.191 64 64 83.197 64 106.668v298.664C64 428.803 83.191 448 106.66 448h298.68c23.469 0 42.66-19.197 42.66-42.668V272h-42.66v133.332zM288 64v42.668h87.474L159.999 322.133l29.866 29.866 215.476-215.47V224H448V64H288z"}}]})(props);
	};
	module.exports.IoMdOpen.displayName = "IoMdOpen";
	module.exports.IoMdOptions = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 384h272v32H32zM400 384h80v32h-80zM384 447.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M32 240h80v32H32zM208 240h272v32H208zM192 303.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M32 96h272v32H32zM400 96h80v32h-80zM384 159.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"}}]}]})(props);
	};
	module.exports.IoMdOptions.displayName = "IoMdOptions";
	module.exports.IoMdOutlet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.5 32H142.4C81.5 32 32 82.6 32 144.6v222.8c0 62 49.5 112.6 110.4 112.6h227.2c60.9 0 110.5-50.6 110.5-112.6V144.6C480 82.6 430.5 32 369.5 32zM175 251v.7c0 10.9-9.1 20.4-19.9 20.4h-23.3c-10.8 0-19.9-9.5-19.9-20.4V148.1c1-10.8 9.2-20.2 19.9-20.2h23.3c10.9 0 19.9 9.8 19.9 20.8V251zm122 147.4c0 11.4-8.9 17.6-20.1 17.6h-41.8c-11.2 0-20.1-8.1-20.1-19.6v-29.3c0-23.3 18.1-42.3 41-42.3s41 19 41 42.3v31.3zM400 251v.7c0 10.9-9.1 20.4-19.9 20.4h-24.3c-10.8 0-19.9-9.5-19.9-20.4V148.1c1-10.8 9.2-20.2 19.9-20.2h24.3c10.8 0 19.9 9.8 19.9 20.8V251z"}}]})(props);
	};
	module.exports.IoMdOutlet.displayName = "IoMdOutlet";
	module.exports.IoMdPaperPlane = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 270.9l118.9 44.6L181.7 464 256 360l104 104L464 48 48 270.9zm294.9 126L260 313.4 374.9 152 193.6 289.8 124.9 265l291-156.2-73 288.1z"}}]})(props);
	};
	module.exports.IoMdPaperPlane.displayName = "IoMdPaperPlane";
	module.exports.IoMdPaper = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H192c-8.8 0-16 7.7-16 16.5V112H74c-23.1 0-42 18.9-42 42v207.5c0 47.6 39 86.5 86 86.5h279.7c45.1 0 82.3-36.9 82.3-82V80c0-8.8-7.2-16-16-16zm-288 80v192h-42V163.2c0-6.8-.8-13.3-3.3-19.2H176zm-17 255.4C148 410 133.2 416 118.5 416c-14.5 0-28.1-5.7-38.5-16-10.3-10.3-16-24-16-38.5V163.2c0-10.6 8.4-19.2 19-19.2s19 8.6 19 19.2V352c0 8.8 7.2 16 16 16h57.5c-1.5 11.6-7.2 22.6-16.5 31.4zM448 366c0 13.3-5.4 25.8-14.9 35.3-9.5 9.5-22.2 14.7-35.4 14.7H187.3c12.8-14.9 20.7-33.9 20.7-54.5V97h240v269z"}},{"tag":"path","attr":{"d":"M248 136h160v56H248zM248 224h160v32H248zM248 288h160v32H248zM408 352H248s0 32-8 32h148.7c19.3 0 19.3-21 19.3-32z"}}]})(props);
	};
	module.exports.IoMdPaper.displayName = "IoMdPaper";
	module.exports.IoMdPartlySunny = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M248.03 116.81l24.679-24.678 19.233 19.234-24.678 24.677zM176 125.7c-45.3 0-82.3 37-82.3 82.3 0 17.5 5.5 33.7 14.9 47 15.3-13 33.9-22.6 54.7-27.6l13.2-16.6c13.6-17.1 30.7-30.2 50.8-38.9 6.1-2.6 12.4-4.8 19-6.6-14.5-23.7-40.6-39.6-70.3-39.6zM162 64h28v41h-28zM32 194h41v28H32zM81.6 276.8l-.8-.8-24.7 24.7 19.2 19.2 24.7-24.7zM79.289 92.13l24.678 24.678-19.233 19.233-24.678-24.678zM405.6 288.6C394.7 233.4 346.2 192 288 192c-34 0-65.1 11.9-86.5 38.8 29.4 2.2 56.7 13 77.8 33.9 15.6 15.6 26.6 34.6 32.1 55.3h-28.7c-13.1-37.3-48-64-90.6-64-5.1 0-12.3.6-17.7 1.7C128.6 267.1 96 305 96 352c0 53 43 96 96 96h208c44.2 0 80-35.8 80-80 0-42.2-32.8-76.5-74.4-79.4z"}}]})(props);
	};
	module.exports.IoMdPartlySunny.displayName = "IoMdPartlySunny";
	module.exports.IoMdPause = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 448h106.7V64H96v384zM309.3 64v384H416V64H309.3z"}}]})(props);
	};
	module.exports.IoMdPause.displayName = "IoMdPause";
	module.exports.IoMdPaw = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.5 165.9c-4.7-10.5-12.7-18.1-23.1-22-4.8-1.7-9.7-2.6-14.8-2.6-21.7 0-43.7 16.7-54.9 41.6-13.8 30.9-5.8 61 18.6 70.3 4.9 1.8 10.1 2.8 15.6 2.8 22.1 0 44.6-15.3 55.9-38.1 8.5-17.5 9.5-36.8 2.7-52zM145.3 182.8c-11.1-24.9-33.2-41.6-54.9-41.6-5.1 0-10.1.9-14.8 2.6-10.4 3.9-18.3 11.5-23.1 22-6.9 15.2-5.9 34.6 2.7 51.9 11.3 22.8 33.8 38.1 55.9 38.1 5.4 0 10.7-.9 15.6-2.8 24.4-9.1 32.4-39.3 18.6-70.2zM193.5 179.4c2 .1 4 0 6-.2 11.7-.9 22.3-5.9 30.6-14.3 13.4-13.6 17.1-34.9 14.3-56.8-4.3-33.7-25.8-59-54.8-60.1 0 0-4.1 0-6.2.2-12.8 1.1-24.4 6.5-33.5 15.9-13.3 13.6-19.7 33.7-17.1 53.8 4.3 33.4 30.9 60.4 60.7 61.5zM256 224c-69.3 0-138.7 97.1-138.7 176.3 0 23.6 11.8 42.6 23.5 50.4 14.4 9.6 24.5 13.4 45.5 13.4 13.4 0 21.6-2.5 28.1-6.1 12.3-6.7 25.9-10.4 39.9-10.4h3.5c14 0 27.6 3.8 39.9 10.4 6.5 3.5 14.7 6.1 28.1 6.1 21.1 0 31.2-3.8 45.5-13.4 11.6-7.8 23.5-26.8 23.5-50.4C394.7 321 325.3 224 256 224zM312.6 179.1c2 .2 4 .2 6 .2 29.8-1.1 56.5-28 60.8-61.5 2.6-20.2-3.8-40.4-17.1-53.8-9.2-9.3-20.3-14.6-33.1-15.6-2.1-.2-6.7-.2-6.7-.2-28.9 1.1-50.4 26.1-54.8 59.9-2.8 21.9.9 43.3 14.3 56.8 8.4 8.3 19 13.2 30.6 14.2z"}}]})(props);
	};
	module.exports.IoMdPaw.displayName = "IoMdPaw";
	module.exports.IoMdPeople = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337.454 232c33.599 0 61.092-27.002 61.092-60 0-32.997-27.493-60-61.092-60s-61.09 27.003-61.09 60c0 32.998 27.491 60 61.09 60zm-162.908 0c33.599 0 61.09-27.002 61.09-60 0-32.997-27.491-60-61.09-60s-61.092 27.003-61.092 60c0 32.998 27.493 60 61.092 60zm0 44C126.688 276 32 298.998 32 346v54h288v-54c0-47.002-97.599-70-145.454-70zm162.908 11.003c-6.105 0-10.325 0-17.454.997 23.426 17.002 32 28 32 58v54h128v-54c0-47.002-94.688-58.997-142.546-58.997z"}}]})(props);
	};
	module.exports.IoMdPeople.displayName = "IoMdPeople";
	module.exports.IoMdPersonAdd = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96zM112 224v-64H80v64H16v32h64v64h32v-64h64v-32h-64z"}}]})(props);
	};
	module.exports.IoMdPersonAdd.displayName = "IoMdPersonAdd";
	module.exports.IoMdPerson = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z"}}]})(props);
	};
	module.exports.IoMdPerson.displayName = "IoMdPerson";
	module.exports.IoMdPhoneLandscape = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 358.856V153.143C480 130.512 461.674 112 439.272 112H72.728C50.326 112 32 130.512 32 153.143v205.713C32 381.488 50.326 400 72.728 400h366.545C461.674 400 480 381.488 480 358.856zM112 364V148h288v216H112z"}}]})(props);
	};
	module.exports.IoMdPhoneLandscape.displayName = "IoMdPhoneLandscape";
	module.exports.IoMdPhonePortrait = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M358.856 32H153.143C130.512 32 112 50.326 112 72.728v366.545C112 461.674 130.512 480 153.143 480h205.713C381.488 480 400 461.674 400 439.272V72.728C400 50.326 381.488 32 358.856 32zM364 400H148V112h216v288z"}}]})(props);
	};
	module.exports.IoMdPhonePortrait.displayName = "IoMdPhonePortrait";
	module.exports.IoMdPhotos = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 421.3V154.7c0-23.5-19.2-42.7-42.7-42.7H90.7C67.2 112 48 131.2 48 154.7v266.7c0 23.5 19.2 42.7 42.7 42.7h266.7c23.4-.1 42.6-19.3 42.6-42.8zM157.3 304l45.3 64 66.7-96 88 128H90.7l66.6-96z"}},{"tag":"path","attr":{"d":"M421.3 48H154.7C131.2 48 112 67.2 112 90.7V96h261.3c23.5 0 42.7 19.2 42.7 42.7V400h5.3c23.5 0 42.7-19.2 42.7-42.7V90.7c0-23.5-19.2-42.7-42.7-42.7z"}}]})(props);
	};
	module.exports.IoMdPhotos.displayName = "IoMdPhotos";
	module.exports.IoMdPie = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32.6 256H256V32.6c-5-.4-10.6-.6-16-.6-114.9 0-208 93.1-208 208 0 5.4.2 11 .6 16z"}},{"tag":"path","attr":{"d":"M109.8 402.2C147.9 449.6 206.4 480 272 480c114.9 0 208-93.1 208-208 0-65.6-30.4-124.1-77.8-162.2C370.5 84.3 331 67.9 288 64.6V288H64.6c3.3 43 19.7 82.5 45.2 114.2z"}}]})(props);
	};
	module.exports.IoMdPie.displayName = "IoMdPie";
	module.exports.IoMdPin = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c-88.004 0-160 70.557-160 156.801C96 306.4 256 480 256 480s160-173.6 160-291.199C416 102.557 344.004 32 256 32zm0 212.801c-31.996 0-57.144-24.645-57.144-56 0-31.357 25.147-56 57.144-56s57.144 24.643 57.144 56c0 31.355-25.148 56-57.144 56z"}}]})(props);
	};
	module.exports.IoMdPin.displayName = "IoMdPin";
	module.exports.IoMdPint = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 48l42.9 379.2c2.6 20.8 20.5 36.8 42.5 36.8h213.3c22 0 39.9-16 42.5-36.8L448 48H64zm327 124.8H121l-9.4-83.2h288.6l-9.2 83.2z"}}]})(props);
	};
	module.exports.IoMdPint.displayName = "IoMdPint";
	module.exports.IoMdPizza = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.2 130.4C360.7 111.5 309.8 102 256 102c-53.9 0-108.3 10.3-151.2 28-8.1 3.3-15.3 9-10.1 19.5S255.9 480 255.9 480l161-329.9c3.2-6.9.9-15.4-9.7-19.7zm-221 73.6c-18.7 0-32-14.3-32-32s13.3-32 32-32 32 14.3 32 32-13.3 32-32 32zM256 347c-18.7 0-32-14.3-32-32s13.3-32 32-32 32 14.3 32 32-13.3 32-32 32zm69.8-123c-18.7 0-32-14.3-32-32s13.3-32 32-32 32 14.3 32 32-13.3 32-32 32z"}},{"tag":"path","attr":{"d":"M436.9 66C384.7 45.4 320.3 32 256 32c-64.3 0-127.6 12.1-180.9 33.4C70.4 67.3 64 71 64 79.2l9.7 24.1c2.8 4.9 8.7 8.2 15.1 8.2 1.8 0 4.3-.3 7.3-1.5 49-18.9 103.1-29.6 160-29.6 56.9 0 115.2 11.6 160 29.6 3.6 1.4 5.6 1.5 7.3 1.5 6.6 0 12.2-3.3 15-8.1l9.8-24.1c-.2-7.3-5-10.8-11.3-13.3z"}}]})(props);
	};
	module.exports.IoMdPizza.displayName = "IoMdPizza";
	module.exports.IoMdPlanet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M135.7 151c-2.5 3-4.9 6-7.2 9.2 32.2 36.3 76.1 76.5 124.2 113.7 37.8 29.2 76.3 55.2 111.4 75.1 5.9 3.3 11.7 6.5 17.3 9.4 2.5-3 4.9-6 7.2-9.2 11.7-16.1 18.1-33.2 23.3-53.6.8-3.2 1.5-6.4 2.1-9.5 15.8-83-35.6-164.9-118.5-185.9-37-9.4-74.1-5.1-106.3 9.7-21.4 9.9-38.2 22.9-53.5 41.1z"}},{"tag":"path","attr":{"d":"M418.2 326.8c-4.1 11-7.4 17.5-7.4 17.5 18.2 21.1 24.6 33.9 31.9 46.4 2.4 4.1 7.4 13.1.9 12.4-1.7-.3-3.5-.7-5.5-1.3-21.3-5.4-51.2-18.7-84.3-37.4-35.8-20.3-74.9-46.7-113.3-76.3-51.1-39.5-97.5-82.3-130.6-120.5-15.3-17.6-27.6-34.2-35.7-47.9-2.4-4.1-3.9-6.3-5.6-10.4-2.5-6.2 5-5.1 7-4.6 14.9 3.8 35 9.9 58.2 23.8 0 0 4.3-4.8 13.9-11.4-22.8-15.4-44.6-27.7-65.2-35.5-23.1-8.8-41.1-6.8-47.5 3.7-12.2 19.9 14 72.3 65.3 132-21.5 86 30.6 173.3 116.5 195 41.1 10.4 82.4 3.9 116.8-15 38.1 17.6 72.1 28.6 96.9 34.9 23.9 6.1 40.4 5.5 46.8-4.9 11.1-18.2-12.1-51.8-59.1-100.5z"}}]})(props);
	};
	module.exports.IoMdPlanet.displayName = "IoMdPlanet";
	module.exports.IoMdPlayCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm-41.6 301.6V162.4L339.2 256l-124.8 93.6z"}}]})(props);
	};
	module.exports.IoMdPlayCircle.displayName = "IoMdPlayCircle";
	module.exports.IoMdPlay = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 52v408l320-204L96 52z"}}]})(props);
	};
	module.exports.IoMdPlay.displayName = "IoMdPlay";
	module.exports.IoMdPodium = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 224h128v192H32zM192 128h128v288H192zM352 288h128v128H352z"}}]})(props);
	};
	module.exports.IoMdPodium.displayName = "IoMdPodium";
	module.exports.IoMdPower = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M279.1 48h-46.2v231.1h46.2V48zm111.6 50.2L357.9 131c36.5 29.4 59.9 74.4 59.9 125 0 89.4-72.3 161.8-161.8 161.8S94.2 345.4 94.2 256c0-50.6 23.3-95.7 59.6-125.3l-32.6-32.6C76.4 136.3 48 192.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-63.3-28.4-119.7-73.3-157.8z"}}]})(props);
	};
	module.exports.IoMdPower.displayName = "IoMdPower";
	module.exports.IoMdPricetag = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H257.6L76.5 251.6c-8 8-12.3 18.5-12.5 29-.3 11.3 3.9 22.6 12.5 31.2l123.7 123.6c8 8 20.8 12.5 28.8 12.5s22.8-3.9 31.4-12.5L448 256V96l-32-32zm-30.7 102.7c-21.7 6.1-41.3-10-41.3-30.7 0-17.7 14.3-32 32-32 20.7 0 36.8 19.6 30.7 41.3-2.9 10.3-11.1 18.5-21.4 21.4z"}}]})(props);
	};
	module.exports.IoMdPricetag.displayName = "IoMdPricetag";
	module.exports.IoMdPricetags = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442 107v141L229.2 451.7c8 8 20.8 12.3 28.8 12.3s22.8-3.7 31.4-12.3L480 272V144l-38-37z"}},{"tag":"path","attr":{"d":"M384 48H224L44.3 235.6c-8 8-12 17.8-12.3 28.4-.3 11.3 3.7 23.3 12.3 31.9l123.8 123.6c8 8 20.8 12.5 28.8 12.5s22.7-3.9 31.3-12.5L416 240V80l-32-32zm-30.7 102.7c-21.7 6.1-41.3-10-41.3-30.7 0-17.7 14.3-32 32-32 20.7 0 36.8 19.6 30.7 41.3-2.9 10.3-11.1 18.5-21.4 21.4z"}}]})(props);
	};
	module.exports.IoMdPricetags.displayName = "IoMdPricetags";
	module.exports.IoMdPrint = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399.95 160h-287.9C76.824 160 48 188.803 48 224v138.667h79.899V448H384.1v-85.333H464V224c0-35.197-28.825-64-64.05-64zM352 416H160V288h192v128zm32.101-352H127.899v80H384.1V64z"}}]})(props);
	};
	module.exports.IoMdPrint.displayName = "IoMdPrint";
	module.exports.IoMdPulse = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428 269c-21.5 0-40.6 13.1-48.4 33h-41.2L307 221.3c-2.7-8.2-10.3-13.7-19-13.7h-.4c-8.8.2-16.4 6-18.8 14.5l-33.6 135.4-55.5-291.8C178 55.6 169.6 48 160 48c-9.5 0-16.9 6.2-19.4 16.2L90.3 302H32v40h74c9.2 0 17.2-6.2 19.4-15.2l30.7-160.6 54.1 282.1c1.5 8.8 8.9 15.1 18.6 15.7h1.2c9.3 0 16.9-5.3 19.2-13.5l40.2-162.9 15.5 40.7c2.7 8.2 10.3 13.7 19 13.7h56.4c8.3 19 27.1 31 47.6 31 13.9 0 26.9-5.6 36.8-15.8 9.8-10.1 15.2-23.3 15.2-37.2.1-28.6-22.7-51-51.9-51z"}}]})(props);
	};
	module.exports.IoMdPulse.displayName = "IoMdPulse";
	module.exports.IoMdQrScanner = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 124.2c0-6.9 5.2-12.2 12.2-12.2H176V64h-66.8C75.7 64 48 90.7 48 124.2V192h48v-67.8zM403.6 64H336v48h67.2c6.9 0 12.8 5.2 12.8 12.2V192h48v-67.8c0-33.5-27-60.2-60.4-60.2zM416 386.8c0 6.9-5.2 12.2-12.2 12.2H336v49h67.8c33.5 0 60.2-27.7 60.2-61.2V320h-48v66.8zM108.2 399c-6.9 0-12.2-5.2-12.2-12.2V320H48v66.8c0 33.5 27.7 61.2 61.2 61.2H176v-49h-67.8z"}}]})(props);
	};
	module.exports.IoMdQrScanner.displayName = "IoMdQrScanner";
	module.exports.IoMdQuote = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96.4 416h77.1l50.9-96.6V96h-160v223.4h77.1L96.4 416zm224 0h77.1l50-96.6V96H288.4v223.4h82l-50 96.6z"}}]})(props);
	};
	module.exports.IoMdQuote.displayName = "IoMdQuote";
	module.exports.IoMdRadioButtonOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.601 48 48 141.601 48 256s93.601 208 208 208 208-93.601 208-208S370.399 48 256 48zm0 374.399c-91.518 0-166.399-74.882-166.399-166.399S164.482 89.6 256 89.6 422.4 164.482 422.4 256 347.518 422.399 256 422.399z"}}]})(props);
	};
	module.exports.IoMdRadioButtonOff.displayName = "IoMdRadioButtonOff";
	module.exports.IoMdRadioButtonOn = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 152c-57.2 0-104 46.8-104 104s46.8 104 104 104 104-46.8 104-104-46.8-104-104-104zm0-104C141.601 48 48 141.601 48 256s93.601 208 208 208 208-93.601 208-208S370.399 48 256 48zm0 374.4c-91.518 0-166.4-74.883-166.4-166.4S164.482 89.6 256 89.6 422.4 164.482 422.4 256 347.518 422.4 256 422.4z"}}]})(props);
	};
	module.exports.IoMdRadioButtonOn.displayName = "IoMdRadioButtonOn";
	module.exports.IoMdRadio = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M73.8 141.9c-15.2 6-25.8 21.8-25.8 39.5v256c0 23.5 18.5 42.7 41.6 42.7h332.8c23.1 0 41.6-19.2 41.6-42.7v-256c0-23.7-18.5-42.7-41.6-42.7H179l171.8-71.3L336.7 32 73.8 141.9zM160 438c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zm256-171.3h-32v-46.2h-44.8v46.2H96v-85.3h320v85.3z"}}]})(props);
	};
	module.exports.IoMdRadio.displayName = "IoMdRadio";
	module.exports.IoMdRainy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M139 400s-23 25.3-23 40.7c0 12.8 10.3 23.3 23 23.3s23-10.5 23-23.3c0-15.4-23-40.7-23-40.7zM217 368s-23 25.3-23 40.7c0 12.8 10.4 23.3 23 23.3 12.7 0 23-10.5 23-23.3 0-15.4-23-40.7-23-40.7zM295 400s-23 25.3-23 40.7c0 12.8 10.3 23.3 23 23.3 12.6 0 23-10.5 23-23.3 0-15.4-23-40.7-23-40.7zM373 368s-23 25.3-23 40.7c0 12.8 10.4 23.3 23 23.3 12.7 0 23-10.5 23-23.3 0-15.4-23-40.7-23-40.7zM393.2 161.2C380.5 96.6 323.9 48 256 48c-39.7 0-76 14-100.9 45.4 34.3 2.6 66.1 15.2 90.7 39.8 18.2 18.2 31 40.5 37.4 64.8h-33.5c-15.3-43.7-56-75-105.7-75-6 0-14.3.7-20.6 2C70 136 32 180.4 32 235.5 32 297.6 79.4 352 141.2 352h242.7c51.5 0 96.2-46 96.2-97.8-.1-49.4-38.4-89.6-86.9-93z"}}]})(props);
	};
	module.exports.IoMdRainy.displayName = "IoMdRainy";
	module.exports.IoMdRecording = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.8 160c-53.4 0-96.2 42.8-96.2 96 0 23.6 7.9 44.5 21.9 61.1h-78.8c14-16.6 21.9-37.5 21.9-61.1 0-53.2-42.9-96-96.2-96S46 202.8 46 256s42.9 96 96.2 96h227.5c53.4 0 96.2-42.8 96.2-96s-42.8-96-96.1-96zM142.2 317.1C108.1 317.1 81 290 81 256s27.1-61.1 61.2-61.1 61.2 27.1 61.2 61.1-27 61.1-61.2 61.1zm227.6 0c-34.1 0-61.2-27.1-61.2-61.1s27.1-61.1 61.2-61.1S431 222 431 256s-27.1 61.1-61.2 61.1z"}}]})(props);
	};
	module.exports.IoMdRecording.displayName = "IoMdRecording";
	module.exports.IoMdRedo = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 337.2L83.8 352c22.9-69.7 88.7-117.8 166-117.8 42.8 0 81.5 15.7 111.8 41.1L282.5 352H480V160l-79.6 76.3c-40.4-35.2-92.8-56.8-150.7-56.8-101.5.1-187.3 66.2-217.7 157.7z"}}]})(props);
	};
	module.exports.IoMdRedo.displayName = "IoMdRedo";
	module.exports.IoMdRefreshCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm112 194h-98l44.8-44.8C300.1 181.8 279.1 172 256 172c-46.2 0-84 37.8-84 84s37.8 84 84 84c34.9 0 65.3-21.2 77.6-52h29.8c-13.9 46.3-56.3 80-107.4 80-62.3 0-112-50.4-112-112s50.4-112 112-112c30.8 0 58.8 12.6 79.1 32.9L368 144v98z"}}]})(props);
	};
	module.exports.IoMdRefreshCircle.displayName = "IoMdRefreshCircle";
	module.exports.IoMdRefresh = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 388c-72.597 0-132-59.405-132-132 0-72.601 59.403-132 132-132 36.3 0 69.299 15.4 92.406 39.601L278 234h154V80l-51.698 51.702C348.406 99.798 304.406 80 256 80c-96.797 0-176 79.203-176 176s78.094 176 176 176c81.045 0 148.287-54.134 169.401-128H378.85c-18.745 49.561-67.138 84-122.85 84z"}}]})(props);
	};
	module.exports.IoMdRefresh.displayName = "IoMdRefresh";
	module.exports.IoMdRemoveCircleOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M363 277H149v-42h214v42z"}}]})(props);
	};
	module.exports.IoMdRemoveCircleOutline.displayName = "IoMdRemoveCircleOutline";
	module.exports.IoMdRemoveCircle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm107 229H149v-42h214v42z"}}]})(props);
	};
	module.exports.IoMdRemoveCircle.displayName = "IoMdRemoveCircle";
	module.exports.IoMdRemove = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 235h320v42H96z"}}]})(props);
	};
	module.exports.IoMdRemove.displayName = "IoMdRemove";
	module.exports.IoMdReorder = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 348h320v36H96zM96 128h320v36H96zM96 200.7h320v35.6H96zM96 275.8h320v35.6H96z"}}]})(props);
	};
	module.exports.IoMdReorder.displayName = "IoMdReorder";
	module.exports.IoMdRepeat = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.3 152h213.3v62.4l85.3-83.2L362.7 48v62.4h-256v124.8h42.7V152zm213.4 208H149.3v-62.4L64 380.8l85.3 83.2v-62.4h256V276.8h-42.7V360z"}}]})(props);
	};
	module.exports.IoMdRepeat.displayName = "IoMdRepeat";
	module.exports.IoMdResize = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M297.6 48l64.9 64.9-249.6 249.6L48 297.6V464h166.4l-64.9-64.9 249.6-249.6 64.9 64.9V48z"}}]})(props);
	};
	module.exports.IoMdResize.displayName = "IoMdResize";
	module.exports.IoMdRestaurant = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M164.852 279.939l61.834-60.251L73.72 71.706c-33.626 32.764-33.626 86.677 0 119.44l91.132 88.793z"}},{"tag":"path","attr":{"d":"M312.389 241.88c33.636 14.802 80.283 4.232 113.91-29.593 41.222-40.165 49.909-98.303 17.363-128.96-31.465-31.71-91.131-23.245-132.354 16.921-34.718 33.825-45.566 79.276-30.374 110.986-47.739 47.568-211.552 207.173-211.552 207.173L99.759 448l149.71-145.866L399.177 448l30.374-29.593-149.709-145.869 32.547-30.658z"}}]})(props);
	};
	module.exports.IoMdRestaurant.displayName = "IoMdRestaurant";
	module.exports.IoMdReturnLeft = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432.8 136v96H122.3l84.4-86.2-33.2-33.8L32 256l141.5 144 33.2-33.8-84.4-86.2H480V136h-47.2z"}}]})(props);
	};
	module.exports.IoMdReturnLeft.displayName = "IoMdReturnLeft";
	module.exports.IoMdReturnRight = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 136v144h357.7l-84.4 86.2 33.2 33.8L480 256 338.5 112l-33.2 33.8 84.4 86.2H79.2v-96H32z"}}]})(props);
	};
	module.exports.IoMdReturnRight.displayName = "IoMdReturnRight";
	module.exports.IoMdReverseCamera = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440 96h-88l-32-32H192l-32 32H72c-22.1 0-40 17.9-40 40v272c0 22.1 17.9 40 40 40h368c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40zm-72 171h-97.7l44.8-45.1c-14.7-15.4-35.7-25.5-58.8-25.5-46.2 0-84 37.8-84 84s37.8 84 84 84c35.5 0 66.2-21.5 78.2-53.5h29.6c-13.4 47-56.2 81.5-107.8 81.5-62.3 0-112-50.4-112-112s50.4-112 112-112c30.8 0 58.7 12.6 79 32.9l32.8-32.9V267z"}}]})(props);
	};
	module.exports.IoMdReverseCamera.displayName = "IoMdReverseCamera";
	module.exports.IoMdRewind = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.6 402V110L32 256l217.6 146zm12.8-146L480 402V110L262.4 256z"}}]})(props);
	};
	module.exports.IoMdRewind.displayName = "IoMdRewind";
	module.exports.IoMdRibbon = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128S326.7 32 256 32zm0 208c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM193.7 307.4c-19.1-8.1-36.2-19.6-50.8-34.3-1.4-1.4-2.8-2.8-4.1-4.3L64 400h96l48 80 48-105.8 25.5-56.2c-8.4 1.3-16.9 2-25.5 2-21.6 0-42.5-4.2-62.3-12.6zM373.3 268.9c-1.3 1.4-2.7 2.9-4.1 4.3-14.6 14.6-31.7 26.2-50.7 34.2L294 361.2l-21.9 48.4L304 480l48-80h96l-74.7-131.1z"}}]})(props);
	};
	module.exports.IoMdRibbon.displayName = "IoMdRibbon";
	module.exports.IoMdRocket = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 421.6c-18.1 0-33.2-6.8-42.9-10.9-5.4-2.3-11.3 1.8-10.9 7.6l3.5 51c.2 3.1 3.8 4.7 6.3 2.8l14.5-11c1.8-1.4 4.5-.9 5.7 1l20.5 32.1c1.5 2.4 5.1 2.4 6.6 0l20.5-32.1c1.2-1.9 3.9-2.4 5.7-1l14.5 11c2.5 1.9 6.1.3 6.3-2.8l3.5-51c.4-5.8-5.5-10-10.9-7.6-9.8 4.1-24.8 10.9-42.9 10.9z"}},{"tag":"path","attr":{"d":"M397.7 293.1l-48-49.1c0-158-93.2-228-93.2-228s-94.1 70-94.1 228l-48 49.1c-1.8 1.8-2.6 4.5-2.2 7.1L130.6 412c.9 5.7 7.1 8.5 11.8 5.4l67.1-45.4s20.7 20 47.1 20c26.4 0 46.1-20 46.1-20l67.1 45.4c4.6 3.1 10.8.3 11.8-5.4l18.5-111.9c.2-2.6-.6-5.2-2.4-7zM256.5 192c-17 0-30.7-14.3-30.7-32s13.8-32 30.7-32c17 0 30.7 14.3 30.7 32s-13.7 32-30.7 32z"}}]})(props);
	};
	module.exports.IoMdRocket.displayName = "IoMdRocket";
	module.exports.IoMdRose = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.6 214.8c23.8-40.9 48-71.6 91.4-96.4 8.3-4.8 21.2-8 22.8-8.9C290.7 83.7 256 32 256 32s-34.7 51.7-120.5 76.5c5.8 3.4 16.5 6.5 30.7 13.7 34.5 17.4 62.5 51.3 94.4 92.6zM246.3 253.4C186.7 161.2 131.4 126.8 48 126.8c54.2 78.6 52 174.6 52 215.4 0 76.1 69.8 137.8 156 137.8 57.6 0 107.9-27.6 135-68.7-35.5-27.6-85.1-65.7-144.7-157.9zM464 126.8s-55.2-2.3-85.2 15.4c-43 25.5-74.4 61.3-95.4 103.2 38.8 52 73 87.9 95.4 109.4 10.7 10.2 19.8 18.2 27.5 24.5 3.7-11.8 5.8-24.3 5.8-37.2-.1-40.8-17.4-114.1 51.9-215.3z"}}]})(props);
	};
	module.exports.IoMdRose.displayName = "IoMdRose";
	module.exports.IoMdSad = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 288c-45.443 0-83.675 26.076-102.205 64h204.41c-18.53-37.924-56.762-64-102.205-64z"}},{"tag":"path","attr":{"d":"M256 48C140.563 48 48 141.6 48 256s92.563 208 208 208 208-93.6 208-208S370.401 48 256 48zm0 374.4c-91.518 0-166.404-74.883-166.404-166.4 0-91.518 74.887-166.4 166.404-166.4S422.404 164.482 422.404 256 347.518 422.4 256 422.4z"}},{"tag":"path","attr":{"d":"M328.8 235.2c17.683 0 31.201-13.518 31.201-31.2s-13.519-31.2-31.201-31.2c-17.682 0-31.2 13.518-31.2 31.2s13.518 31.2 31.2 31.2zM183.2 235.2c17.682 0 31.2-13.518 31.2-31.2s-13.519-31.2-31.2-31.2c-17.683 0-31.201 13.518-31.201 31.2s13.519 31.2 31.201 31.2z"}}]})(props);
	};
	module.exports.IoMdSad.displayName = "IoMdSad";
	module.exports.IoMdSave = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.7 64h-256C83 64 64 83.2 64 106.7v298.7c0 23.5 19 42.7 42.7 42.7h298.7c23.5 0 42.7-19.2 42.7-42.7v-256L362.7 64zM256 405.3c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM320 192H106.7v-85.3H320V192z"}}]})(props);
	};
	module.exports.IoMdSave.displayName = "IoMdSave";
	module.exports.IoMdSchool = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M113.5 281.2v85.3L256 448l142.5-81.5v-85.3L256 362.7l-142.5-81.5zM256 64L32 192l224 128 183.3-104.7v147.4H480V192L256 64z"}}]})(props);
	};
	module.exports.IoMdSchool.displayName = "IoMdSchool";
	module.exports.IoMdSearch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337.509 305.372h-17.501l-6.571-5.486c20.791-25.232 33.922-57.054 33.922-93.257C347.358 127.632 283.896 64 205.135 64 127.452 64 64 127.632 64 206.629s63.452 142.628 142.225 142.628c35.011 0 67.831-13.167 92.991-34.008l6.561 5.487v17.551L415.18 448 448 415.086 337.509 305.372zm-131.284 0c-54.702 0-98.463-43.887-98.463-98.743 0-54.858 43.761-98.742 98.463-98.742 54.7 0 98.462 43.884 98.462 98.742 0 54.856-43.762 98.743-98.462 98.743z"}}]})(props);
	};
	module.exports.IoMdSearch.displayName = "IoMdSearch";
	module.exports.IoMdSend = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 448l416-192L48 64v149.333L346 256 48 298.667z"}}]})(props);
	};
	module.exports.IoMdSend.displayName = "IoMdSend";
	module.exports.IoMdSettings = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M413.967 276.8c1.06-6.235 1.06-13.518 1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318c4.26-3.118 5.319-8.317 2.13-13.518L418.215 115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186 20.801c-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098c-5.318 0-9.577 4.164-10.637 8.318l-8.508 55.117c-12.767 5.2-24.464 12.482-36.171 20.801l-53.186-20.801c-5.319-2.071-10.638 0-12.767 4.164L49.1 187.365c-2.119 4.153-1.061 10.399 2.129 13.518L96.97 235.2c0 7.282-1.06 13.518-1.06 20.8s1.06 13.518 1.06 20.8l-44.668 34.318c-4.26 3.118-5.318 8.317-2.13 13.518L92.721 396.4c2.13 4.164 8.508 6.235 12.767 4.164l53.187-20.801c10.637 8.318 23.394 15.601 36.16 20.801l8.508 55.117c1.069 5.2 5.318 8.318 10.637 8.318h85.098c5.319 0 9.578-4.164 10.638-8.318l8.518-55.117c12.757-5.2 24.464-12.482 36.16-20.801l53.187 20.801c5.318 2.071 10.637 0 12.767-4.164l42.549-71.765c2.129-4.153 1.06-10.399-2.13-13.518l-46.8-34.317zm-158.499 52c-41.489 0-74.46-32.235-74.46-72.8s32.971-72.8 74.46-72.8 74.461 32.235 74.461 72.8-32.972 72.8-74.461 72.8z"}}]})(props);
	};
	module.exports.IoMdSettings.displayName = "IoMdSettings";
	module.exports.IoMdShareAlt = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 248L288 96v85.334C138.666 202.667 85.333 309.334 64 416c53.333-74.666 117.333-108.802 224-108.802v87.469L448 248z"}}]})(props);
	};
	module.exports.IoMdShareAlt.displayName = "IoMdShareAlt";
	module.exports.IoMdShare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.822 344.427c-16.045 0-31.024 5.326-41.721 15.979l-152.957-88.42c1.071-5.328 2.142-9.593 2.142-14.919 0-5.328-1.071-9.593-2.142-14.919l150.826-87.35c11.762 10.653 26.741 17.041 43.852 17.041 35.295 0 64.178-28.766 64.178-63.92C448 72.767 419.117 44 383.822 44c-35.297 0-64.179 28.767-64.179 63.92 0 5.327 1.065 9.593 2.142 14.919l-150.821 87.35c-11.767-10.654-26.741-17.041-43.856-17.041-35.296 0-63.108 28.766-63.108 63.92 0 35.153 28.877 63.92 64.178 63.92 17.115 0 32.089-6.389 43.856-17.042l151.891 88.421c-1.076 4.255-2.141 8.521-2.141 13.847 0 34.094 27.806 61.787 62.037 61.787 34.229 0 62.036-27.693 62.036-61.787.001-34.094-27.805-61.787-62.035-61.787z"}}]})(props);
	};
	module.exports.IoMdShare.displayName = "IoMdShare";
	module.exports.IoMdShirt = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 64c-11.1 19.1-40.3 32-64 32s-52.9-12.9-64-32L64 96v96l77-16-13 272h256l-13-272 77 16V96L320 64z"}}]})(props);
	};
	module.exports.IoMdShirt.displayName = "IoMdShirt";
	module.exports.IoMdShuffle = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M222.2 188.1L97.8 64 64 97.8l124.1 124.1 34.1-33.8zM316 64l49 49L64 414.2 97.8 448 399 147l49 49V64H316zm7.9 225.8l-33.8 33.8 75.1 75.1L316 448h132V316l-49 49-75.1-75.2z"}}]})(props);
	};
	module.exports.IoMdShuffle.displayName = "IoMdShuffle";
	module.exports.IoMdSkipBackward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M170.7 256L448 448V64L170.7 256zM64 64h64v384H64z"}}]})(props);
	};
	module.exports.IoMdSkipBackward.displayName = "IoMdSkipBackward";
	module.exports.IoMdSkipForward = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 64v384l277.3-192L64 64zM384 64h64v384h-64z"}}]})(props);
	};
	module.exports.IoMdSkipForward.displayName = "IoMdSkipForward";
	module.exports.IoMdSnow = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.4 298.5l-8.3-30.9-88 23.6-60.4-34.9 60.4-34.9 88 23.6 8.3-30.9-57.1-15.3 57.7-33.3-24-41.5-56.6 32.7 15.3-57.1-30.9-8.3-23.6 88-62.2 35.9v-71.1l64.5-64.4-22.7-22.6L280 98.9V32h-48v65.6l-41.7-41.7-22.6 22.6 64.3 64.4v71.4l-60.7-35-23.6-88-30.9 8.3 15.3 57.1-57.7-33.4-24 41.6 56.7 32.7L50 212.9l8.3 30.9 87.9-23.6 62.6 36.1-62.6 36.2-87.9-23.6-8.3 30.9 57.1 15.3-56.7 32.7 24 41.5 57.7-33.3-15.3 57 30.9 8.3 23.6-87.9 60.7-35.1v70.9l-64.3 64.4 22.6 22.6 41.7-41.8V480h48v-66.8l41.9 41.7 22.5-22.6L280 368v-70.6l62.2 36 23.6 87.9 30.9-8.3-15.3-57 56.6 32.7 24-41.6-57.7-33.3z"}}]})(props);
	};
	module.exports.IoMdSnow.displayName = "IoMdSnow";
	module.exports.IoMdSpeedometer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 416h256v48H128zM256 288c17.7 0 32-14.3 32-32s-14.3-32-32-32c-3 0-6 .4-8.8 1.2l-66.7-48.7-4 3.5 48.9 66.7c-.9 2.9-1.4 6-1.4 9.3 0 17.7 14.3 32 32 32z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256c0 48.3 16.5 92.7 44.1 128h58.8l4-4 22.1-22.1-22.9-22.9-22.1 22c-19.9-24.3-32.1-54-35.2-85H128v-32H96.8c3.1-31 15.3-60.7 35.2-85l22.1 22 22.9-22.9-22-22.1c24.3-19.9 54-32.1 85-35.2V128h32V96.8c31 3.1 60.7 15.3 85 35.2l-22 22.1 22.9 22.9 22.1-22c19.9 24.3 32.1 54 35.2 85H384v32h31.2c-3.1 31-15.3 60.7-35.2 85l-22.1-22-22.9 22.9 22.1 22.1 4 4h58.8c27.6-35.3 44.1-79.7 44.1-128 0-114.9-93.1-208-208-208z"}}]})(props);
	};
	module.exports.IoMdSpeedometer.displayName = "IoMdSpeedometer";
	module.exports.IoMdSquareOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.3 106.7v298.7H106.7V106.7h298.6m0-42.7H106.7C83.2 64 64 83.2 64 106.7v298.7c0 23.5 19.2 42.7 42.7 42.7h298.7c23.5 0 42.7-19.2 42.7-42.7V106.7C448 83.2 428.8 64 405.3 64z"}}]})(props);
	};
	module.exports.IoMdSquareOutline.displayName = "IoMdSquareOutline";
	module.exports.IoMdSquare = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.333 64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333V106.667C448 83.198 428.802 64 405.333 64z"}}]})(props);
	};
	module.exports.IoMdSquare.displayName = "IoMdSquare";
	module.exports.IoMdStarHalf = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458 210.409l-145.267-12.476L256 64l-56.743 133.934L54 210.409l110.192 95.524L131.161 448 256 372.686 380.83 448l-33.021-142.066L458 210.409zM272.531 345.287L256 335.313l-.002-189.277 27.27 64.379 7.52 17.751 19.208 1.65 69.846 5.998-52.993 45.939-14.576 12.636 4.367 18.788 15.875 68.299-59.984-36.189z"}}]})(props);
	};
	module.exports.IoMdStarHalf.displayName = "IoMdStarHalf";
	module.exports.IoMdStarOutline = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458 210.409l-145.267-12.476L256 64l-56.743 133.934L54 210.409l110.192 95.524L131.161 448 256 372.686 380.83 448l-33.021-142.066L458 210.409zM272.531 345.286L256 335.312l-16.53 9.973-59.988 36.191 15.879-68.296 4.369-18.79-14.577-12.637-52.994-45.939 69.836-5.998 19.206-1.65 7.521-17.75 27.276-64.381 27.27 64.379 7.52 17.751 19.208 1.65 69.846 5.998-52.993 45.939-14.576 12.636 4.367 18.788 15.875 68.299-59.984-36.189z"}}]})(props);
	};
	module.exports.IoMdStarOutline.displayName = "IoMdStarOutline";
	module.exports.IoMdStar = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 372.686L380.83 448l-33.021-142.066L458 210.409l-145.267-12.475L256 64l-56.743 133.934L54 210.409l110.192 95.525L131.161 448z"}}]})(props);
	};
	module.exports.IoMdStar.displayName = "IoMdStar";
	module.exports.IoMdStats = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 64h64v384h-64zM80 336h64v112H80zM272 272h64v176h-64zM368 176h64v272h-64z"}}]})(props);
	};
	module.exports.IoMdStats.displayName = "IoMdStats";
	module.exports.IoMdStopwatch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232 306.667h48V176h-48v130.667z"}},{"tag":"path","attr":{"d":"M407.67 170.271l30.786-30.786-33.942-33.941-30.785 30.786C341.217 111.057 300.369 96 256 96 149.961 96 64 181.961 64 288s85.961 192 192 192 192-85.961 192-192c0-44.369-15.057-85.217-40.33-117.729zm-45.604 223.795C333.734 422.398 296.066 438 256 438s-77.735-15.602-106.066-43.934C121.602 365.735 106 328.066 106 288s15.602-77.735 43.934-106.066C178.265 153.602 215.934 138 256 138s77.734 15.602 106.066 43.934C390.398 210.265 406 247.934 406 288s-15.602 77.735-43.934 106.066zM192 32h128v48H192z"}}]})(props);
	};
	module.exports.IoMdStopwatch.displayName = "IoMdStopwatch";
	module.exports.IoMdSubway = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-93.864 0-176 10.668-176 85.334v213.332c0 41.604 33.062 74.666 74.667 74.666L128 448v16h256v-16l-26.667-26.668c41.604 0 74.667-33.062 74.667-74.666V133.334C432 58.668 349.864 48 256 48zm-96 336c-18.136 0-32-13.865-32-32 0-18.137 13.864-32 32-32s32 13.863 32 32c0 18.135-13.864 32-32 32zm80-144H128v-96h112v96zm112 144c-18.136 0-32-13.865-32-32 0-18.137 13.864-32 32-32s32 13.863 32 32c0 18.135-13.864 32-32 32zm32-144H272v-96h112v96z"}}]})(props);
	};
	module.exports.IoMdSubway.displayName = "IoMdSubway";
	module.exports.IoMdSunny = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.3 32h-42.7v64h42.7V32zm129.1 43.7L368 114.1l29.9 29.9 38.4-38.4-29.9-29.9zm-300.8 0l-29.9 29.9 38.4 38.4 29.9-29.9-38.4-38.4zM256 128c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128zm224 106.7h-64v42.7h64v-42.7zm-384 0H32v42.7h64v-42.7zM397.9 368L368 397.9l38.4 38.4 29.9-29.9-38.4-38.4zm-283.8 0l-38.4 38.4 29.9 29.9 38.4-38.4-29.9-29.9zm163.2 48h-42.7v64h42.7v-64z"}}]})(props);
	};
	module.exports.IoMdSunny.displayName = "IoMdSunny";
	module.exports.IoMdSwap = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M131.3 231.1L32 330.6l99.3 99.4v-74.6h174.5v-49.7H131.3v-74.6zM480 181.4L380.7 82v74.6H206.2v49.7h174.5v74.6l99.3-99.5z"}}]})(props);
	};
	module.exports.IoMdSwap.displayName = "IoMdSwap";
	module.exports.IoMdSwitch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168 216h94.9c14.5 14.8 34.7 24 57.1 24 44.2 0 80-35.8 80-80s-35.8-80-80-80c-22.4 0-42.6 9.2-57.1 24H168c-30.8 0-56 25.2-56 56s25.2 56 56 56zm-16.9-72.9c4.6-4.6 10.6-7.1 16.9-7.1h75.7c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24H168c-6.3 0-12.4-2.5-16.9-7.1-4.6-4.6-7.1-10.6-7.1-16.9s2.5-12.4 7.1-16.9zM344 296h-94.9c-14.5-14.8-34.7-24-57.1-24-44.2 0-80 35.8-80 80s35.8 80 80 80c22.4 0 42.6-9.2 57.1-24H344c30.8 0 56-25.2 56-56s-25.2-56-56-56zm16.9 72.9c-4.6 4.6-10.6 7.1-16.9 7.1h-75.7c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24H344c6.3 0 12.4 2.5 16.9 7.1 4.6 4.6 7.1 10.6 7.1 16.9s-2.5 12.4-7.1 16.9z"}}]})(props);
	};
	module.exports.IoMdSwitch.displayName = "IoMdSwitch";
	module.exports.IoMdSync = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 93.09V32l-80 81.454 80 81.456v-61.093c65.996 0 120 54.982 120 122.183 0 20.363-5 39.714-14.004 57.016L391 342.547c15.996-25.457 25-54.988 25-86.547 0-89.599-72.002-162.91-160-162.91zm0 285.094c-66.001 0-120-54.988-120-122.184 0-20.363 5-39.709 13.999-57.02L121 169.454C104.999 193.89 96 224.436 96 256c0 89.599 72.002 162.91 160 162.91V480l80-81.453-80-81.457v61.094z"}}]})(props);
	};
	module.exports.IoMdSync.displayName = "IoMdSync";
	module.exports.IoMdTabletLandscape = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 120v272c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zm384 8v256H80V128h336zm46 128c0 7.7-6.5 14-14.1 14-7.5 0-14-6.2-14-14 0-7.7 6.4-14.1 14-14.1 7.6.1 14.1 6.4 14.1 14.1z"}}]})(props);
	};
	module.exports.IoMdTabletLandscape.displayName = "IoMdTabletLandscape";
	module.exports.IoMdTabletPortrait = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 32H120c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-8 384H128V80h256v336zm-128 46c-7.7 0-14-6.5-14-14.1 0-7.5 6.2-14 14-14 7.7 0 14.1 6.4 14.1 14-.1 7.6-6.4 14.1-14.1 14.1z"}}]})(props);
	};
	module.exports.IoMdTabletPortrait.displayName = "IoMdTabletPortrait";
	module.exports.IoMdTennisball = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.8 92.2C348.5 64.5 304.1 48 256 48c-48 0-92.3 16.5-127.6 44 41.6 44.8 64.3 103 64 164.3-.3 61-23.3 118.6-64.9 162.9 35.4 28 80.1 44.8 128.5 44.8 48.5 0 93.3-16.8 128.8-45-41.5-44.3-64.5-101.8-64.8-162.7-.3-61.2 22.3-119.3 63.8-164.1z"}},{"tag":"path","attr":{"d":"M353.1 255.1c0 26.9 5.1 53 15.1 77.8 9.6 23.6 23.3 44.9 40.8 63.6 34.1-37.1 55-86.5 55-140.5 0-54.5-21.2-104.2-55.8-141.4-17.1 18.5-30.6 39.6-40 62.7-10 24.8-15.1 51-15.1 77.8zM159.3 255.1c0-26.9-5.1-53-15.1-77.8-9.4-23.2-22.9-44.4-40.2-62.9-34.7 37.2-56 87-56 141.6 0 54.2 21 103.6 55.2 140.7 17.6-18.7 31.4-40.1 41-63.8 10-24.7 15.1-50.9 15.1-77.8z"}}]})(props);
	};
	module.exports.IoMdTennisball.displayName = "IoMdTennisball";
	module.exports.IoMdText = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 64H96c-22.002 0-32 17.998-32 40v344l64-64h280c22.002 0 40-17.998 40-40V104c0-22.002-17.998-40-40-40zM198.4 242H160v-40h38.4v40zm76.8 0h-38.4v-40h38.4v40zm76.8 0h-38.4v-40H352v40z"}}]})(props);
	};
	module.exports.IoMdText.displayName = "IoMdText";
	module.exports.IoMdThermometer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M303 300.2V78.4c0-25.7-21-46.5-47-46.5s-47 20.8-47 46.5v221.9c-29 16.5-48.9 47.8-48.9 83.7 0 53 43 96 96 96s96-43 96-96c0-36-20.1-67.3-49.1-83.8zM240 78.4c0-8 7.7-14.5 16-14.5s16 6.5 16 14.5V128h-32V78.4z"}}]})(props);
	};
	module.exports.IoMdThermometer.displayName = "IoMdThermometer";
	module.exports.IoMdThumbsDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M314 64H142c-15.7 0-28.6 9.6-34.2 23.4L50.6 222.8c-1.7 4.4-2.6 9-2.6 14v38.6c0 21.1 17 44.6 37.8 44.6h119.3l-18 81.5-.6 6c0 7.9 3.2 15.1 8.3 20.3l20 20.1L341 320.7c6.8-6.9 11-16.5 11-27.1v-192c0-21.1-17.2-37.6-38-37.6zM400 64h64v224h-64z"}}]})(props);
	};
	module.exports.IoMdThumbsDown.displayName = "IoMdThumbsDown";
	module.exports.IoMdThumbsUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M198 448h172c15.7 0 28.6-9.6 34.2-23.4l57.1-135.4c1.7-4.4 2.6-9 2.6-14v-38.6c0-21.1-17-44.6-37.8-44.6H306.9l18-81.5.6-6c0-7.9-3.2-15.1-8.3-20.3L297 64 171 191.3c-6.8 6.9-11 16.5-11 27.1v192c0 21.1 17.2 37.6 38 37.6zM48 224h64v224H48z"}}]})(props);
	};
	module.exports.IoMdThumbsUp.displayName = "IoMdThumbsUp";
	module.exports.IoMdThunderstorm = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.2 161.2C380.5 96.6 323.9 48 256 48c-39.7 0-76 14-100.9 45.4 34.3 2.6 66.1 15.2 90.7 39.8 18.2 18.2 31 40.5 37.4 64.8h-33.5c-15.3-43.7-56-75-105.7-75-6 0-14.3.7-20.6 2C70 136 32 180.4 32 235.5 32 297.6 82.2 336 144 336h68V233h99.1l-33.2 67H311l-18 36h93.7c51.5 0 93.3-30 93.3-81.8 0-49.4-38.3-89.6-86.8-93zM212 368h22v96l59-128h-81z"}}]})(props);
	};
	module.exports.IoMdThunderstorm.displayName = "IoMdThunderstorm";
	module.exports.IoMdTime = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"g","attr":{"fillOpacity":".9"},"child":[{"tag":"path","attr":{"d":"M255.8 48C141 48 48 141.2 48 256s93 208 207.8 208c115 0 208.2-93.2 208.2-208S370.8 48 255.8 48zm.2 374.4c-91.9 0-166.4-74.5-166.4-166.4S164.1 89.6 256 89.6 422.4 164.1 422.4 256 347.9 422.4 256 422.4z"}},{"tag":"path","attr":{"d":"M266.4 152h-31.2v124.8l109.2 65.5 15.6-25.6-93.6-55.5V152z"}}]}]})(props);
	};
	module.exports.IoMdTime.displayName = "IoMdTime";
	module.exports.IoMdTimer = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232.9 371.6c0 12.7 10.4 23.1 23.1 23.1s23.1-10.4 23.1-23.1c0-12.7-10.4-23.1-23.1-23.1s-23.1 10.3-23.1 23.1zm0-323.6v92.4h46.2V96.1c78.3 11.3 138.7 78.3 138.7 159.9 0 89.4-72.3 161.8-161.8 161.8S94.2 345.4 94.2 256c0-38.8 13.6-74.4 36.5-102.2L256 279.1l32.6-32.6L131.4 89.4v.5C80.8 127.7 48 187.8 48 256c0 114.9 92.9 208 208 208 114.9 0 208-93.1 208-208S370.9 48 256 48h-23.1zm161.8 208c0-12.7-10.4-23.1-23.1-23.1-12.7 0-23.1 10.4-23.1 23.1s10.4 23.1 23.1 23.1c12.7 0 23.1-10.4 23.1-23.1zm-277.4 0c0 12.7 10.4 23.1 23.1 23.1s23.1-10.4 23.1-23.1-10.4-23.1-23.1-23.1-23.1 10.4-23.1 23.1z"}}]})(props);
	};
	module.exports.IoMdTimer.displayName = "IoMdTimer";
	module.exports.IoMdToday = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.3 32H106.7C83.2 32 64 51.2 64 74.7v362.7c0 23.5 19.2 42.7 42.7 42.7h298.7c23.5 0 42.7-19.2 42.7-42.7V74.7C448 51.2 428.8 32 405.3 32zm-4 405.3H110.7c-2.2 0-4-1.8-4-4V78.7c0-2.2 1.8-4 4-4h290.7c2.2 0 4 1.8 4 4v354.7c-.1 2.1-1.9 3.9-4.1 3.9z"}},{"tag":"path","attr":{"d":"M145 194v204c0 1.1.9 2 2 2h218c1.1 0 2-.9 2-2V194c0-1.1-.9-2-2-2H147c-1.1 0-2 .9-2 2zM145 114.7v34c0 1.1.9 2 2 2h171c1.1 0 2-.9 2-2v-34c0-1.1-.9-2-2-2H147c-1.1 0-2 .9-2 2z"}}]})(props);
	};
	module.exports.IoMdToday.displayName = "IoMdToday";
	module.exports.IoMdTrain = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-88 0-176 10.9-176 87.6v208c0 42.3 34.5 76.6 77 76.6L124 453v11h49.1l44-43.8H300l44 43.8h44v-10.9l-33-32.8c42.5 0 77-34.4 77-76.6v-208C432 58.9 353.2 48 256 48zm-99 328.4c-18.3 0-33-14.7-33-32.8s14.7-32.8 33-32.8 33 14.7 33 32.8-14.7 32.8-33 32.8zm77-153.2H124v-87.6h110v87.6zm44 0v-87.6h110v87.6H278zm77 153.2c-18.3 0-33-14.7-33-32.8s14.7-32.8 33-32.8 33 14.7 33 32.8-14.7 32.8-33 32.8z"}}]})(props);
	};
	module.exports.IoMdTrain.displayName = "IoMdTrain";
	module.exports.IoMdTransgender = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 32v35h63.1l-81.4 80.5c-7.5-7.2-13.2-11-13.2-11C302.2 123.6 280 116 256 116c-30.2 0-57.6 12-77.8 31.4l-15.2-15 31.4-31.4-28.5-28.5-31.5 31.5-37.5-37H160V32H32v128h35V91.3l40.3 39.9-31.2 31.2 28.5 28.5 31.4-31.4 19.4 19.2c-7.3 14.9-11.5 31.7-11.5 49.5 0 54.8 39.5 100.4 91.1 110.2v45.3h-63V424h63v56h42v-56h63v-40.2h-63v-45.3c50.8-9.9 91.2-55.5 91.2-110.3 0-17.7-4.2-34.8-11.5-49.6L445 91.3V160h35V32H352zm-96 258c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}}]})(props);
	};
	module.exports.IoMdTransgender.displayName = "IoMdTransgender";
	module.exports.IoMdTrash = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 405.429C128 428.846 147.198 448 170.667 448h170.667C364.802 448 384 428.846 384 405.429V160H128v245.429zM416 96h-80l-26.785-32H202.786L176 96H96v32h320V96z"}}]})(props);
	};
	module.exports.IoMdTrash.displayName = "IoMdTrash";
	module.exports.IoMdTrendingDown = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 397V262.5l-51.3 51.3-141.1-141-89.6 89.7L63.6 128 32 159.6l166 166.3 89.6-89.7 109.3 109.4-51.3 51.4H480z"}}]})(props);
	};
	module.exports.IoMdTrendingDown.displayName = "IoMdTrendingDown";
	module.exports.IoMdTrendingUp = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M345.6 128l51.3 51.3-109.3 109.4-89.6-89.6L32 365.4 63.6 397 198 262.5l89.6 89.7 141.1-141 51.3 51.3V128H345.6z"}}]})(props);
	};
	module.exports.IoMdTrendingUp.displayName = "IoMdTrendingUp";
	module.exports.IoMdTrophy = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 105c.9-27 .2-56 .1-57H119.3c0 1-.8 30 .1 57H48c0 68 9.9 102.3 21 126.7S95.4 277 127.7 302c30.1 23.3 95.5 53.6 104.3 57.6v28.3c-4.6 10-23.5 28.2-83.3 28.2H128v48h256v-48h-25.7c-60.7 0-75-19.1-78.3-28.2v-28.3c9.3-4.6 80.9-40.3 104.4-57.5 25.2-18.4 50.9-51.5 58.7-70.3S464 167 464 105h-72zM109.6 211.9c-8.8-18.2-14-37.9-15.7-61.9h28.7c.7 6 1.4 11.3 2.3 16.3 6.6 39.2 14.8 70.2 25.7 96.5-17.3-13.5-31.3-30.8-41-50.9zm292.8 0c-9.9 20.3-24 37.7-41.6 51.3 11-26.2 19-56.8 25.8-96.9.8-5 1.6-10.3 2.3-16.3h29.3c-1.8 24-6.9 43.7-15.8 61.9z"}}]})(props);
	};
	module.exports.IoMdTrophy.displayName = "IoMdTrophy";
	module.exports.IoMdTv = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M439.3 76H72.7C50.3 76 32 94 32 116v240c0 22 18.3 40 40.7 40h101.8v40h162.9v-40h101.8c22.4 0 40.5-18 40.5-40l.2-240c.1-22-18.2-40-40.6-40zm0 280H72.7V116h366.5v240z"}}]})(props);
	};
	module.exports.IoMdTv.displayName = "IoMdTv";
	module.exports.IoMdUmbrella = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.1 244.1c12 0 26.6 10.9 33.8 25.9H464c-.3-50-21.2-101.5-59.4-140.9-36.3-37.4-83-60.5-132.6-65.7-3-9-11.5-15.4-21.6-15.4-10 0-18.5 6.5-21.5 15.3C125.3 73.8 48 159.7 48 266.2c0 1.1.1 1.8.4 3.8h21.8c6.8-15 22.2-25.9 35.3-25.9 17 0 31.5 10.9 36.5 25.9h19.8c4.1-15 16.9-25.7 33-25.7 17.8 0 33.1 14.5 34.1 32.6v118.3c0 9.3.1 24.1-13.4 24.1-6.9 0-16.6-1.8-16.6-16V382h-43v21.3c0 34.6 23.6 60.7 60 60.7 19.5 0 33.3-8.5 43.5-18.7 13.1-13.2 13.5-34.7 13.5-50.1V276.1c2-25.8 23.9-31.7 41.9-31.7 17.2 0 32.3 11.6 37.8 25.6h20.5c5.1-15 19.8-25.9 37-25.9z"}}]})(props);
	};
	module.exports.IoMdUmbrella.displayName = "IoMdUmbrella";
	module.exports.IoMdUndo = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M262.3 179.6c-57.9 0-110.3 21.6-150.7 56.8L32 160v192h197.5l-79.1-76.8c30.4-25.3 69-41.1 111.8-41.1 77.3 0 143.1 48.2 166 117.8l51.8-14.8c-30.4-91.4-116.2-157.5-217.7-157.5z"}}]})(props);
	};
	module.exports.IoMdUndo.displayName = "IoMdUndo";
	module.exports.IoMdUnlock = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 186h-20v-40c0-55-45-100-100-100S156 91 156 146h37.998c0-34.004 28.003-62.002 62.002-62.002 34.004 0 62.002 27.998 62.002 62.002H318v40H136c-22.002 0-40 17.998-40 40v200c0 22.002 17.998 40 40 40h240c22.002 0 40-17.998 40-40V226c0-22.002-17.998-40-40-40zM256 368c-22.002 0-40-17.998-40-40s17.998-40 40-40 40 17.998 40 40-17.998 40-40 40z"}}]})(props);
	};
	module.exports.IoMdUnlock.displayName = "IoMdUnlock";
	module.exports.IoMdVideocam = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 219.5v-85.2c0-13.4-11.2-24.3-24.9-24.3H56.9C43.2 110 32 120.9 32 134.3v243.3C32 391 43.2 402 56.9 402h302.2c13.7 0 24.9-11 24.9-24.3v-85.2l96 97.3V122.2l-96 97.3z"}}]})(props);
	};
	module.exports.IoMdVideocam.displayName = "IoMdVideocam";
	module.exports.IoMdVolumeHigh = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 192v128h85.334L256 431.543V80.458L149.334 192H64zm288 64c0-38.399-21.333-72.407-53.333-88.863v176.636C330.667 328.408 352 294.4 352 256zM298.667 64v44.978C360.531 127.632 405.334 186.882 405.334 256c0 69.119-44.803 128.369-106.667 147.022V448C384 428.254 448 349.257 448 256c0-93.256-64-172.254-149.333-192z"}}]})(props);
	};
	module.exports.IoMdVolumeHigh.displayName = "IoMdVolumeHigh";
	module.exports.IoMdVolumeLow = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 192v128h85.334L256 431.543V80.458L149.334 192H64zm288 64c0-38.399-21.333-72.407-53.333-88.863v176.636C330.667 328.408 352 294.4 352 256z"}}]})(props);
	};
	module.exports.IoMdVolumeLow.displayName = "IoMdVolumeLow";
	module.exports.IoMdVolumeMute = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 192v128h85.334L256 431.543V80.458L149.334 192H64z"}}]})(props);
	};
	module.exports.IoMdVolumeMute.displayName = "IoMdVolumeMute";
	module.exports.IoMdVolumeOff = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.5 256c0 22.717-4.883 44.362-13.603 63.855l31.88 31.88C439.283 323.33 448 290.653 448 256c0-93.256-64-172.254-149-192v44.978C361 127.632 405.5 186.882 405.5 256zM256 80.458l-51.021 52.48L256 183.957zM420.842 396.885L91.116 67.157l-24 24 90.499 90.413-8.28 10.43H64v128h85.334L256 431.543V280l94.915 94.686C335.795 387.443 318 397.213 299 403.022V448c31-7.172 58.996-22.163 82.315-42.809l39.61 39.693 24-24.043-24.002-24.039-.081.083z"}},{"tag":"path","attr":{"d":"M352.188 256c0-38.399-21.188-72.407-53.188-88.863v59.82l50.801 50.801A100.596 100.596 0 0 0 352.188 256z"}}]})(props);
	};
	module.exports.IoMdVolumeOff.displayName = "IoMdVolumeOff";
	module.exports.IoMdWalk = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 112c22.223 0 39.997-17.776 39.997-40 0-22.225-17.774-40-39.997-40s-40.003 17.775-40.003 40c0 22.224 17.78 40 40.003 40zM288 232h104v-40h-72l-44.802-69.333c-7.698-11.667-18.136-18.136-30.933-18.136-3.198 0-8.828.531-12.799 1.747L120 144v112h40v-80l40.531-16L120 480h40l56.698-164.271L267 384v96h38V352l-57.031-96 19.745-61.864L288 232z"}}]})(props);
	};
	module.exports.IoMdWalk.displayName = "IoMdWalk";
	module.exports.IoMdWallet = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M202.7 341.3V170.7c0-23.5 19-42.7 42.7-42.7h197v-21.3c0-23.5-18.9-42.7-42.3-42.7H92c-23.7 0-44 18.5-44 42v300c0 23.5 20.3 42 44 42h308c23.5 0 42.3-19.2 42.3-42.7V384h-197c-23.6 0-42.6-19.2-42.6-42.7z"}},{"tag":"path","attr":{"d":"M245 186v140c0 8.8 7.2 16 16 16h187c8.8 0 16-7.2 16-16V186c0-8.8-7.2-16-16-16H261c-8.8 0-16 7.2-16 16zm77.1 101.9c-19.3 1.2-35.2-14.7-34-34 1-15.9 13.9-28.8 29.9-29.9 19.3-1.2 35.2 14.7 34 34-1.1 16-14 28.9-29.9 29.9z"}}]})(props);
	};
	module.exports.IoMdWallet.displayName = "IoMdWallet";
	module.exports.IoMdWarning = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 464h448L256 48 32 464zm248-64h-48v-48h48v48zm0-80h-48v-96h48v96z"}}]})(props);
	};
	module.exports.IoMdWarning.displayName = "IoMdWarning";
	module.exports.IoMdWatch = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 256c0-51.001-24.004-96.001-60.996-125L336 16H176l-19.004 115C120.004 159.999 96 204.999 96 256c0 50.996 24.004 95.996 60.996 125L176 496h160l19.004-115C391.996 351.996 416 306.996 416 256zm-280 0c0-66.001 54.004-120 120-120s120 53.999 120 120c0 65.996-54.004 120-120 120s-120-54.004-120-120z"}}]})(props);
	};
	module.exports.IoMdWatch.displayName = "IoMdWatch";
	module.exports.IoMdWater = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.5 163.3L256 32 131.5 163.3c-68.6 72.4-68.6 190 0 262.4C165.8 461.9 210.9 480 256 480s90.2-18.1 124.5-54.3c68.7-72.4 68.7-190 0-262.4z"}}]})(props);
	};
	module.exports.IoMdWater.displayName = "IoMdWater";
	module.exports.IoMdWifi = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 228.719c-22.879 0-41.597 18.529-41.597 41.18 0 22.652 18.718 41.182 41.597 41.182 22.878 0 41.597-18.529 41.597-41.182 0-22.651-18.719-41.18-41.597-41.18zm124.8 41.179c0-67.946-56.163-123.539-124.8-123.539s-124.8 55.593-124.8 123.539c0 45.303 24.961 85.447 62.396 107.072l20.807-36.032c-24.972-14.417-41.604-40.153-41.604-71.04 0-45.295 37.433-82.358 83.201-82.358 45.771 0 83.201 37.063 83.201 82.358 0 30.887-16.633 56.623-41.604 71.04l20.807 36.032c37.433-21.624 62.396-61.769 62.396-107.072zM256 64C141.597 64 48 156.654 48 269.898 48 346.085 89.592 411.968 152 448l20.799-36.032c-49.919-28.824-83.207-81.324-83.207-142.069 0-90.593 74.891-164.718 166.408-164.718 91.517 0 166.406 74.125 166.406 164.718 0 60.745-33.284 114.271-83.205 142.069L360 448c62.406-36.032 104-101.915 104-178.102C464 156.654 370.403 64 256 64z"}}]})(props);
	};
	module.exports.IoMdWifi.displayName = "IoMdWifi";
	module.exports.IoMdWine = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234.667 277.333V408H128v40h256v-40H277.333V277.333L448 106.667V64H64v42.667l170.667 170.666zm-74.667-128l-42.667-42.666h277.334L352 149.333H160z"}}]})(props);
	};
	module.exports.IoMdWine.displayName = "IoMdWine";
	module.exports.IoMdWoman = function (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.4 148.6L161 252.9c-6.3 22.8 20.7 31.7 27.3 10.3l26.3-96.2h7.4l-45.2 169H219v127c0 23 32 23 32 0V336h10v127c0 23 31 23 31 0V336h43.4l-46.2-169h8.4l26.3 96.2c6.5 21.9 33.3 12.5 27.3-10.2l-29.4-104.4c-4-11.8-18.2-32.6-42-33.6h-47.3c-24.6 1-38.7 21.6-42.1 33.6zM292.6 69.2c0-20.6-16.4-37.3-36.6-37.3-20.2 0-36.6 16.7-36.6 37.3 0 20.6 16.4 37.3 36.6 37.3 20.2 0 36.6-16.7 36.6-37.3z"}}]})(props);
	};
	module.exports.IoMdWoman.displayName = "IoMdWoman";


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _io = __webpack_require__(60);
	
	var _sliderNavigationModule = __webpack_require__(546);
	
	var _sliderNavigationModule2 = _interopRequireDefault(_sliderNavigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderNavigation = function SliderNavigation(_ref) {
	  var prevSlide = _ref.prevSlide,
	      nextSlide = _ref.nextSlide,
	      activeSlide = _ref.activeSlide,
	      sliderLength = _ref.sliderLength,
	      navType = _ref.navType,
	      navPos = _ref.navPos,
	      color = _ref.color;
	
	  var handleNextClick = function handleNextClick() {
	    nextSlide();
	  };
	  var handlePrevClick = function handlePrevClick() {
	    prevSlide();
	  };
	  return _react2.default.createElement(
	    'div',
	    {
	      className: navType === 'case-study' ? [_sliderNavigationModule2.default.wrapper, _sliderNavigationModule2.default.csNav].join(' ') : _sliderNavigationModule2.default.wrapper,
	      style: { bottom: navPos + 'em', color: '#' + color }
	    },
	    _react2.default.createElement(_io.IoIosArrowBack, { onClick: handlePrevClick }),
	    _react2.default.createElement(
	      'div',
	      { className: _sliderNavigationModule2.default.numbered },
	      activeSlide + 1,
	      ' / ',
	      sliderLength
	    ),
	    _react2.default.createElement(_io.IoIosArrowForward, { onClick: handleNextClick })
	  );
	};
	
	SliderNavigation.propTypes = {
	  prevSlide: _propTypes2.default.func,
	  nextSlide: _propTypes2.default.func,
	  activeSlide: _propTypes2.default.number,
	  sliderLength: _propTypes2.default.number,
	  navType: _propTypes2.default.string,
	  navPos: _propTypes2.default.number,
	  color: _propTypes2.default.string
	};
	
	exports.default = SliderNavigation;
	module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(217);
	var enumBugKeys = __webpack_require__(138);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(220)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var hide = __webpack_require__(58);
	var has = __webpack_require__(109);
	var SRC = __webpack_require__(159)('src');
	var $toString = __webpack_require__(430);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(45).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputError":"src-components-form-inputs----inputs-module---inputError---3iZ15","input":"src-components-form-inputs----inputs-module---input---27RYq"};

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _heroBgImageModule = __webpack_require__(485);
	
	var _heroBgImageModule2 = _interopRequireDefault(_heroBgImageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroBGImage = function HeroBGImage(_ref) {
	  var heroBGImage = _ref.heroBGImage;
	
	  return _react2.default.createElement(_gatsbyImage2.default, {
	    sizes: heroBGImage.localFile.childImageSharp.sizes,
	    backgroundColor: true,
	    style: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      opacity: 0.45,
	      mixBlendMode: 'multiply',
	      pointerEvents: 'none'
	    }
	  });
	};
	
	exports.default = HeroBGImage;
	module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _projectHeroWrapper = __webpack_require__(321);
	
	var _projectHeroWrapper2 = _interopRequireDefault(_projectHeroWrapper);
	
	var _projectHeroWipe = __webpack_require__(320);
	
	var _projectHeroWipe2 = _interopRequireDefault(_projectHeroWipe);
	
	var _projectButton = __webpack_require__(318);
	
	var _projectButton2 = _interopRequireDefault(_projectButton);
	
	var _projectBreadcrumb = __webpack_require__(20);
	
	var _projectBreadcrumb2 = _interopRequireDefault(_projectBreadcrumb);
	
	var _projectLogo = __webpack_require__(322);
	
	var _projectLogo2 = _interopRequireDefault(_projectLogo);
	
	var _projectHeadline = __webpack_require__(21);
	
	var _projectHeadline2 = _interopRequireDefault(_projectHeadline);
	
	var _projectHeroImage = __webpack_require__(319);
	
	var _projectHeroImage2 = _interopRequireDefault(_projectHeroImage);
	
	var _projectHeroModule = __webpack_require__(520);
	
	var _projectHeroModule2 = _interopRequireDefault(_projectHeroModule);
	
	var _scrollDown = __webpack_require__(28);
	
	var _scrollDown2 = _interopRequireDefault(_scrollDown);
	
	var _helperFunctions = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectHero = function ProjectHero(_ref) {
	  var title = _ref.title,
	      slug = _ref.slug,
	      headline = _ref.headline,
	      featuredImage = _ref.featuredImage,
	      featuredMobileImage = _ref.featuredMobileImage,
	      buttonColor = _ref.buttonColor,
	      buttonColorHover = _ref.buttonColorHover,
	      currentPage = _ref.currentPage,
	      browserDetect = _ref.browserDetect,
	      headerHeight = _ref.headerHeight,
	      mappedIndex = _ref.mappedIndex,
	      currentSectionIndex = _ref.currentSectionIndex;
	
	  var projectHeroDetect = (0, _helperFunctions.detectSection)(mappedIndex, currentSectionIndex);
	
	  return _react2.default.createElement(
	    _projectHeroWrapper2.default,
	    {
	      browserDetect: browserDetect,
	      headerHeight: headerHeight
	    },
	    _react2.default.createElement(_projectHeroWipe2.default, { isHome: projectHeroDetect.home() }),
	    _react2.default.createElement(
	      'div',
	      { className: _projectHeroModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _projectHeroModule2.default.content },
	        _react2.default.createElement(_projectBreadcrumb2.default, {
	          preTitle: 'our-work',
	          title: title,
	          isHome: projectHeroDetect.home(),
	          returnSection: projectHeroDetect.section()
	        }),
	        _react2.default.createElement(_projectLogo2.default, {
	          slug: slug,
	          isHome: projectHeroDetect.home(),
	          returnSection: projectHeroDetect.section()
	        }),
	        _react2.default.createElement(_projectHeadline2.default, {
	          headline: headline,
	          isHome: projectHeroDetect.home(),
	          returnSection: projectHeroDetect.section()
	        }),
	        _react2.default.createElement(_projectButton2.default, {
	          currentPage: currentPage,
	          buttonColor: buttonColor,
	          buttonColorHover: buttonColorHover,
	          linkPath: slug,
	          isHome: projectHeroDetect.home(),
	          returnSection: projectHeroDetect.section()
	        })
	      )
	    ),
	    currentPage === 'ProjectTemplate' && _react2.default.createElement(_scrollDown2.default, { color: 'white' }),
	    _react2.default.createElement(_projectHeroImage2.default, {
	      featuredImage: featuredImage,
	      featuredMobileImage: featuredMobileImage,
	      browserDetect: browserDetect,
	      alt: title,
	      isHome: projectHeroDetect.home(),
	      returnSection: projectHeroDetect.section()
	    })
	  );
	};
	
	ProjectHero.propTypes = {
	  title: _propTypes2.default.string,
	  slug: _propTypes2.default.string,
	  headline: _propTypes2.default.string,
	  featuredImage: _propTypes2.default.object,
	  buttonColor: _propTypes2.default.string,
	  buttonColorHover: _propTypes2.default.string,
	  currentPage: _propTypes2.default.string,
	  browserDetect: _propTypes2.default.string,
	  headerHeight: _propTypes2.default.number,
	  mappedIndex: _propTypes2.default.number,
	  currentSectionIndex: _propTypes2.default.number
	};
	
	exports.default = ProjectHero;
	module.exports = exports['default'];

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(382);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(380);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(208);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(208);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(137);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(105);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var core = __webpack_require__(45);
	var hide = __webpack_require__(58);
	var redefine = __webpack_require__(83);
	var ctx = __webpack_require__(107);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(44);
	var IE8_DOM_DEFINE = __webpack_require__(431);
	var toPrimitive = __webpack_require__(449);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(80) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(832));
	__export(__webpack_require__(831));
	__export(__webpack_require__(236));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(836);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(837);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(237);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(838);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(839);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(840);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(841);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(238);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(175);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(842);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(843);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(844);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(845);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(846);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(59);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! @vimeo/player v2.10.0 | (c) 2019 Vimeo | MIT License | https://github.com/vimeo/player.js */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, (global.Vimeo = global.Vimeo || {}, global.Vimeo.Player = factory()));
	}(this, function () { 'use strict';
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  /**
	   * @module lib/functions
	   */
	
	  /**
	   * Check to see this is a node environment.
	   * @type {Boolean}
	   */
	
	  /* global global */
	  var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
	  /**
	   * Get the name of the method for a given getter or setter.
	   *
	   * @param {string} prop The name of the property.
	   * @param {string} type Either “get” or “set”.
	   * @return {string}
	   */
	
	  function getMethodName(prop, type) {
	    if (prop.indexOf(type.toLowerCase()) === 0) {
	      return prop;
	    }
	
	    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
	  }
	  /**
	   * Check to see if the object is a DOM Element.
	   *
	   * @param {*} element The object to check.
	   * @return {boolean}
	   */
	
	  function isDomElement(element) {
	    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
	  }
	  /**
	   * Check to see whether the value is a number.
	   *
	   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
	   * @param {*} value The value to check.
	   * @param {boolean} integer Check if the value is an integer.
	   * @return {boolean}
	   */
	
	  function isInteger(value) {
	    // eslint-disable-next-line eqeqeq
	    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
	  }
	  /**
	   * Check to see if the URL is a Vimeo url.
	   *
	   * @param {string} url The url string.
	   * @return {boolean}
	   */
	
	  function isVimeoUrl(url) {
	    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
	  }
	  /**
	   * Get the Vimeo URL from an element.
	   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
	   *
	   * @param {object} oEmbedParameters The oEmbed parameters.
	   * @return {string}
	   */
	
	  function getVimeoUrl() {
	    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var id = oEmbedParameters.id;
	    var url = oEmbedParameters.url;
	    var idOrUrl = id || url;
	
	    if (!idOrUrl) {
	      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
	    }
	
	    if (isInteger(idOrUrl)) {
	      return "https://vimeo.com/".concat(idOrUrl);
	    }
	
	    if (isVimeoUrl(idOrUrl)) {
	      return idOrUrl.replace('http:', 'https:');
	    }
	
	    if (id) {
	      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
	    }
	
	    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
	  }
	
	  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
	  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
	
	  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
	    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
	  }
	
	  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  /*!
	   * weakmap-polyfill v2.0.0 - ECMAScript6 WeakMap polyfill
	   * https://github.com/polygonplanet/weakmap-polyfill
	   * Copyright (c) 2015-2016 polygon planet <polygon.planet.aqua@gmail.com>
	   * @license MIT
	   */
	  (function (self) {
	
	    if (self.WeakMap) {
	      return;
	    }
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	    var defineProperty = function (object, name, value) {
	      if (Object.defineProperty) {
	        Object.defineProperty(object, name, {
	          configurable: true,
	          writable: true,
	          value: value
	        });
	      } else {
	        object[name] = value;
	      }
	    };
	
	    self.WeakMap = function () {
	      // ECMA-262 23.3 WeakMap Objects
	      function WeakMap() {
	        if (this === void 0) {
	          throw new TypeError("Constructor WeakMap requires 'new'");
	        }
	
	        defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])
	
	        if (arguments.length > 0) {
	          // Currently, WeakMap `iterable` argument is not supported
	          throw new TypeError('WeakMap iterable is not supported');
	        }
	      } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
	
	
	      defineProperty(WeakMap.prototype, 'delete', function (key) {
	        checkInstance(this, 'delete');
	
	        if (!isObject(key)) {
	          return false;
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          delete key[this._id];
	          return true;
	        }
	
	        return false;
	      }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
	
	      defineProperty(WeakMap.prototype, 'get', function (key) {
	        checkInstance(this, 'get');
	
	        if (!isObject(key)) {
	          return void 0;
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          return entry[1];
	        }
	
	        return void 0;
	      }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
	
	      defineProperty(WeakMap.prototype, 'has', function (key) {
	        checkInstance(this, 'has');
	
	        if (!isObject(key)) {
	          return false;
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          return true;
	        }
	
	        return false;
	      }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
	
	      defineProperty(WeakMap.prototype, 'set', function (key, value) {
	        checkInstance(this, 'set');
	
	        if (!isObject(key)) {
	          throw new TypeError('Invalid value used as weak map key');
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          entry[1] = value;
	          return this;
	        }
	
	        defineProperty(key, this._id, [key, value]);
	        return this;
	      });
	
	      function checkInstance(x, methodName) {
	        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
	          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
	        }
	      }
	
	      function genId(prefix) {
	        return prefix + '_' + rand() + '.' + rand();
	      }
	
	      function rand() {
	        return Math.random().toString().substring(2);
	      }
	
	      defineProperty(WeakMap, '_polyfill', true);
	      return WeakMap;
	    }();
	
	    function isObject(x) {
	      return Object(x) === x;
	    }
	  })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);
	
	  var npo_src = createCommonjsModule(function (module) {
	  /*! Native Promise Only
	      v0.8.1 (c) Kyle Simpson
	      MIT License: http://getify.mit-license.org
	  */
	  (function UMD(name, context, definition) {
	    // special form of UMD for polyfilling across evironments
	    context[name] = context[name] || definition();
	
	    if (module.exports) {
	      module.exports = context[name];
	    }
	  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {
	
	    var builtInProp,
	        cycle,
	        scheduling_queue,
	        ToString = Object.prototype.toString,
	        timer = typeof setImmediate != "undefined" ? function timer(fn) {
	      return setImmediate(fn);
	    } : setTimeout; // dammit, IE8.
	
	    try {
	      Object.defineProperty({}, "x", {});
	
	      builtInProp = function builtInProp(obj, name, val, config) {
	        return Object.defineProperty(obj, name, {
	          value: val,
	          writable: true,
	          configurable: config !== false
	        });
	      };
	    } catch (err) {
	      builtInProp = function builtInProp(obj, name, val) {
	        obj[name] = val;
	        return obj;
	      };
	    } // Note: using a queue instead of array for efficiency
	
	
	    scheduling_queue = function Queue() {
	      var first, last, item;
	
	      function Item(fn, self) {
	        this.fn = fn;
	        this.self = self;
	        this.next = void 0;
	      }
	
	      return {
	        add: function add(fn, self) {
	          item = new Item(fn, self);
	
	          if (last) {
	            last.next = item;
	          } else {
	            first = item;
	          }
	
	          last = item;
	          item = void 0;
	        },
	        drain: function drain() {
	          var f = first;
	          first = last = cycle = void 0;
	
	          while (f) {
	            f.fn.call(f.self);
	            f = f.next;
	          }
	        }
	      };
	    }();
	
	    function schedule(fn, self) {
	      scheduling_queue.add(fn, self);
	
	      if (!cycle) {
	        cycle = timer(scheduling_queue.drain);
	      }
	    } // promise duck typing
	
	
	    function isThenable(o) {
	      var _then,
	          o_type = typeof o;
	
	      if (o != null && (o_type == "object" || o_type == "function")) {
	        _then = o.then;
	      }
	
	      return typeof _then == "function" ? _then : false;
	    }
	
	    function notify() {
	      for (var i = 0; i < this.chain.length; i++) {
	        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
	      }
	
	      this.chain.length = 0;
	    } // NOTE: This is a separate function to isolate
	    // the `try..catch` so that other code can be
	    // optimized better
	
	
	    function notifyIsolated(self, cb, chain) {
	      var ret, _then;
	
	      try {
	        if (cb === false) {
	          chain.reject(self.msg);
	        } else {
	          if (cb === true) {
	            ret = self.msg;
	          } else {
	            ret = cb.call(void 0, self.msg);
	          }
	
	          if (ret === chain.promise) {
	            chain.reject(TypeError("Promise-chain cycle"));
	          } else if (_then = isThenable(ret)) {
	            _then.call(ret, chain.resolve, chain.reject);
	          } else {
	            chain.resolve(ret);
	          }
	        }
	      } catch (err) {
	        chain.reject(err);
	      }
	    }
	
	    function resolve(msg) {
	      var _then,
	          self = this; // already triggered?
	
	
	      if (self.triggered) {
	        return;
	      }
	
	      self.triggered = true; // unwrap
	
	      if (self.def) {
	        self = self.def;
	      }
	
	      try {
	        if (_then = isThenable(msg)) {
	          schedule(function () {
	            var def_wrapper = new MakeDefWrapper(self);
	
	            try {
	              _then.call(msg, function $resolve$() {
	                resolve.apply(def_wrapper, arguments);
	              }, function $reject$() {
	                reject.apply(def_wrapper, arguments);
	              });
	            } catch (err) {
	              reject.call(def_wrapper, err);
	            }
	          });
	        } else {
	          self.msg = msg;
	          self.state = 1;
	
	          if (self.chain.length > 0) {
	            schedule(notify, self);
	          }
	        }
	      } catch (err) {
	        reject.call(new MakeDefWrapper(self), err);
	      }
	    }
	
	    function reject(msg) {
	      var self = this; // already triggered?
	
	      if (self.triggered) {
	        return;
	      }
	
	      self.triggered = true; // unwrap
	
	      if (self.def) {
	        self = self.def;
	      }
	
	      self.msg = msg;
	      self.state = 2;
	
	      if (self.chain.length > 0) {
	        schedule(notify, self);
	      }
	    }
	
	    function iteratePromises(Constructor, arr, resolver, rejecter) {
	      for (var idx = 0; idx < arr.length; idx++) {
	        (function IIFE(idx) {
	          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
	            resolver(idx, msg);
	          }, rejecter);
	        })(idx);
	      }
	    }
	
	    function MakeDefWrapper(self) {
	      this.def = self;
	      this.triggered = false;
	    }
	
	    function MakeDef(self) {
	      this.promise = self;
	      this.state = 0;
	      this.triggered = false;
	      this.chain = [];
	      this.msg = void 0;
	    }
	
	    function Promise(executor) {
	      if (typeof executor != "function") {
	        throw TypeError("Not a function");
	      }
	
	      if (this.__NPO__ !== 0) {
	        throw TypeError("Not a promise");
	      } // instance shadowing the inherited "brand"
	      // to signal an already "initialized" promise
	
	
	      this.__NPO__ = 1;
	      var def = new MakeDef(this);
	
	      this["then"] = function then(success, failure) {
	        var o = {
	          success: typeof success == "function" ? success : true,
	          failure: typeof failure == "function" ? failure : false
	        }; // Note: `then(..)` itself can be borrowed to be used against
	        // a different promise constructor for making the chained promise,
	        // by substituting a different `this` binding.
	
	        o.promise = new this.constructor(function extractChain(resolve, reject) {
	          if (typeof resolve != "function" || typeof reject != "function") {
	            throw TypeError("Not a function");
	          }
	
	          o.resolve = resolve;
	          o.reject = reject;
	        });
	        def.chain.push(o);
	
	        if (def.state !== 0) {
	          schedule(notify, def);
	        }
	
	        return o.promise;
	      };
	
	      this["catch"] = function $catch$(failure) {
	        return this.then(void 0, failure);
	      };
	
	      try {
	        executor.call(void 0, function publicResolve(msg) {
	          resolve.call(def, msg);
	        }, function publicReject(msg) {
	          reject.call(def, msg);
	        });
	      } catch (err) {
	        reject.call(def, err);
	      }
	    }
	
	    var PromisePrototype = builtInProp({}, "constructor", Promise,
	    /*configurable=*/
	    false); // Note: Android 4 cannot use `Object.defineProperty(..)` here
	
	    Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise
	
	    builtInProp(PromisePrototype, "__NPO__", 0,
	    /*configurable=*/
	    false);
	    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
	      var Constructor = this; // spec mandated checks
	      // note: best "isPromise" check that's practical for now
	
	      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
	        return msg;
	      }
	
	      return new Constructor(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        resolve(msg);
	      });
	    });
	    builtInProp(Promise, "reject", function Promise$reject(msg) {
	      return new this(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        reject(msg);
	      });
	    });
	    builtInProp(Promise, "all", function Promise$all(arr) {
	      var Constructor = this; // spec mandated checks
	
	      if (ToString.call(arr) != "[object Array]") {
	        return Constructor.reject(TypeError("Not an array"));
	      }
	
	      if (arr.length === 0) {
	        return Constructor.resolve([]);
	      }
	
	      return new Constructor(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        var len = arr.length,
	            msgs = Array(len),
	            count = 0;
	        iteratePromises(Constructor, arr, function resolver(idx, msg) {
	          msgs[idx] = msg;
	
	          if (++count === len) {
	            resolve(msgs);
	          }
	        }, reject);
	      });
	    });
	    builtInProp(Promise, "race", function Promise$race(arr) {
	      var Constructor = this; // spec mandated checks
	
	      if (ToString.call(arr) != "[object Array]") {
	        return Constructor.reject(TypeError("Not an array"));
	      }
	
	      return new Constructor(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        iteratePromises(Constructor, arr, function resolver(idx, msg) {
	          resolve(msg);
	        }, reject);
	      });
	    });
	    return Promise;
	  });
	  });
	
	  /**
	   * @module lib/callbacks
	   */
	  var callbackMap = new WeakMap();
	  /**
	   * Store a callback for a method or event for a player.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name.
	   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
	   *        The callback to call or an object with resolve and reject functions for a promise.
	   * @return {void}
	   */
	
	  function storeCallback(player, name, callback) {
	    var playerCallbacks = callbackMap.get(player.element) || {};
	
	    if (!(name in playerCallbacks)) {
	      playerCallbacks[name] = [];
	    }
	
	    playerCallbacks[name].push(callback);
	    callbackMap.set(player.element, playerCallbacks);
	  }
	  /**
	   * Get the callbacks for a player and event or method.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name
	   * @return {function[]}
	   */
	
	  function getCallbacks(player, name) {
	    var playerCallbacks = callbackMap.get(player.element) || {};
	    return playerCallbacks[name] || [];
	  }
	  /**
	   * Remove a stored callback for a method or event for a player.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name
	   * @param {function} [callback] The specific callback to remove.
	   * @return {boolean} Was this the last callback?
	   */
	
	  function removeCallback(player, name, callback) {
	    var playerCallbacks = callbackMap.get(player.element) || {};
	
	    if (!playerCallbacks[name]) {
	      return true;
	    } // If no callback is passed, remove all callbacks for the event
	
	
	    if (!callback) {
	      playerCallbacks[name] = [];
	      callbackMap.set(player.element, playerCallbacks);
	      return true;
	    }
	
	    var index = playerCallbacks[name].indexOf(callback);
	
	    if (index !== -1) {
	      playerCallbacks[name].splice(index, 1);
	    }
	
	    callbackMap.set(player.element, playerCallbacks);
	    return playerCallbacks[name] && playerCallbacks[name].length === 0;
	  }
	  /**
	   * Return the first stored callback for a player and event or method.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name.
	   * @return {function} The callback, or false if there were none
	   */
	
	  function shiftCallbacks(player, name) {
	    var playerCallbacks = getCallbacks(player, name);
	
	    if (playerCallbacks.length < 1) {
	      return false;
	    }
	
	    var callback = playerCallbacks.shift();
	    removeCallback(player, name, callback);
	    return callback;
	  }
	  /**
	   * Move callbacks associated with an element to another element.
	   *
	   * @param {HTMLElement} oldElement The old element.
	   * @param {HTMLElement} newElement The new element.
	   * @return {void}
	   */
	
	  function swapCallbacks(oldElement, newElement) {
	    var playerCallbacks = callbackMap.get(oldElement);
	    callbackMap.set(newElement, playerCallbacks);
	    callbackMap.delete(oldElement);
	  }
	
	  /**
	   * @module lib/embed
	   */
	  var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
	  /**
	   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
	   *
	   * @param {HTMLElement} element The element.
	   * @param {Object} [defaults={}] The default values to use.
	   * @return {Object<string, string>}
	   */
	
	  function getOEmbedParameters(element) {
	    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return oEmbedParameters.reduce(function (params, param) {
	      var value = element.getAttribute("data-vimeo-".concat(param));
	
	      if (value || value === '') {
	        params[param] = value === '' ? 1 : value;
	      }
	
	      return params;
	    }, defaults);
	  }
	  /**
	   * Create an embed from oEmbed data inside an element.
	   *
	   * @param {object} data The oEmbed data.
	   * @param {HTMLElement} element The element to put the iframe in.
	   * @return {HTMLIFrameElement} The iframe embed.
	   */
	
	  function createEmbed(_ref, element) {
	    var html = _ref.html;
	
	    if (!element) {
	      throw new TypeError('An element must be provided');
	    }
	
	    if (element.getAttribute('data-vimeo-initialized') !== null) {
	      return element.querySelector('iframe');
	    }
	
	    var div = document.createElement('div');
	    div.innerHTML = html;
	    element.appendChild(div.firstChild);
	    element.setAttribute('data-vimeo-initialized', 'true');
	    return element.querySelector('iframe');
	  }
	  /**
	   * Make an oEmbed call for the specified URL.
	   *
	   * @param {string} videoUrl The vimeo.com url for the video.
	   * @param {Object} [params] Parameters to pass to oEmbed.
	   * @param {HTMLElement} element The element.
	   * @return {Promise}
	   */
	
	  function getOEmbedData(videoUrl) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var element = arguments.length > 2 ? arguments[2] : undefined;
	    return new Promise(function (resolve, reject) {
	      if (!isVimeoUrl(videoUrl)) {
	        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
	      }
	
	      var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
	
	      for (var param in params) {
	        if (params.hasOwnProperty(param)) {
	          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
	        }
	      }
	
	      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
	      xhr.open('GET', url, true);
	
	      xhr.onload = function () {
	        if (xhr.status === 404) {
	          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
	          return;
	        }
	
	        if (xhr.status === 403) {
	          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
	          return;
	        }
	
	        try {
	          var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed
	
	          if (json.domain_status_code === 403) {
	            // We still want to create the embed to give users visual feedback
	            createEmbed(json, element);
	            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
	            return;
	          }
	
	          resolve(json);
	        } catch (error) {
	          reject(error);
	        }
	      };
	
	      xhr.onerror = function () {
	        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
	        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
	      };
	
	      xhr.send();
	    });
	  }
	  /**
	   * Initialize all embeds within a specific element
	   *
	   * @param {HTMLElement} [parent=document] The parent element.
	   * @return {void}
	   */
	
	  function initializeEmbeds() {
	    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
	
	    var handleError = function handleError(error) {
	      if ('console' in window && console.error) {
	        console.error("There was an error creating an embed: ".concat(error));
	      }
	    };
	
	    elements.forEach(function (element) {
	      try {
	        // Skip any that have data-vimeo-defer
	        if (element.getAttribute('data-vimeo-defer') !== null) {
	          return;
	        }
	
	        var params = getOEmbedParameters(element);
	        var url = getVimeoUrl(params);
	        getOEmbedData(url, params, element).then(function (data) {
	          return createEmbed(data, element);
	        }).catch(handleError);
	      } catch (error) {
	        handleError(error);
	      }
	    });
	  }
	  /**
	   * Resize embeds when messaged by the player.
	   *
	   * @param {HTMLElement} [parent=document] The parent element.
	   * @return {void}
	   */
	
	  function resizeEmbeds() {
	    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	    // Prevent execution if users include the player.js script multiple times.
	    if (window.VimeoPlayerResizeEmbeds_) {
	      return;
	    }
	
	    window.VimeoPlayerResizeEmbeds_ = true;
	
	    var onMessage = function onMessage(event) {
	      if (!isVimeoUrl(event.origin)) {
	        return;
	      } // 'spacechange' is fired only on embeds with cards
	
	
	      if (!event.data || event.data.event !== 'spacechange') {
	        return;
	      }
	
	      var iframes = parent.querySelectorAll('iframe');
	
	      for (var i = 0; i < iframes.length; i++) {
	        if (iframes[i].contentWindow !== event.source) {
	          continue;
	        } // Change padding-bottom of the enclosing div to accommodate
	        // card carousel without distorting aspect ratio
	
	
	        var space = iframes[i].parentElement;
	        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
	        break;
	      }
	    };
	
	    if (window.addEventListener) {
	      window.addEventListener('message', onMessage, false);
	    } else if (window.attachEvent) {
	      window.attachEvent('onmessage', onMessage);
	    }
	  }
	
	  /**
	   * @module lib/postmessage
	   */
	  /**
	   * Parse a message received from postMessage.
	   *
	   * @param {*} data The data received from postMessage.
	   * @return {object}
	   */
	
	  function parseMessageData(data) {
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (error) {
	        // If the message cannot be parsed, throw the error as a warning
	        console.warn(error);
	        return {};
	      }
	    }
	
	    return data;
	  }
	  /**
	   * Post a message to the specified target.
	   *
	   * @param {Player} player The player object to use.
	   * @param {string} method The API method to call.
	   * @param {object} params The parameters to send to the player.
	   * @return {void}
	   */
	
	  function postMessage(player, method, params) {
	    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
	      return;
	    }
	
	    var message = {
	      method: method
	    };
	
	    if (params !== undefined) {
	      message.value = params;
	    } // IE 8 and 9 do not support passing messages, so stringify them
	
	
	    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
	
	    if (ieVersion >= 8 && ieVersion < 10) {
	      message = JSON.stringify(message);
	    }
	
	    player.element.contentWindow.postMessage(message, player.origin);
	  }
	  /**
	   * Parse the data received from a message event.
	   *
	   * @param {Player} player The player that received the message.
	   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
	   * @return {void}
	   */
	
	  function processData(player, data) {
	    data = parseMessageData(data);
	    var callbacks = [];
	    var param;
	
	    if (data.event) {
	      if (data.event === 'error') {
	        var promises = getCallbacks(player, data.data.method);
	        promises.forEach(function (promise) {
	          var error = new Error(data.data.message);
	          error.name = data.data.name;
	          promise.reject(error);
	          removeCallback(player, data.data.method, promise);
	        });
	      }
	
	      callbacks = getCallbacks(player, "event:".concat(data.event));
	      param = data.data;
	    } else if (data.method) {
	      var callback = shiftCallbacks(player, data.method);
	
	      if (callback) {
	        callbacks.push(callback);
	        param = data.value;
	      }
	    }
	
	    callbacks.forEach(function (callback) {
	      try {
	        if (typeof callback === 'function') {
	          callback.call(player, param);
	          return;
	        }
	
	        callback.resolve(param);
	      } catch (e) {// empty
	      }
	    });
	  }
	
	  var playerMap = new WeakMap();
	  var readyMap = new WeakMap();
	
	  var Player =
	  /*#__PURE__*/
	  function () {
	    /**
	     * Create a Player.
	     *
	     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
	     *        player iframe, and id, or a jQuery object.
	     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
	     * @return {Player}
	     */
	    function Player(element) {
	      var _this = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, Player);
	
	      /* global jQuery */
	      if (window.jQuery && element instanceof jQuery) {
	        if (element.length > 1 && window.console && console.warn) {
	          console.warn('A jQuery object with multiple elements was passed, using the first element.');
	        }
	
	        element = element[0];
	      } // Find an element by ID
	
	
	      if (typeof document !== 'undefined' && typeof element === 'string') {
	        element = document.getElementById(element);
	      } // Not an element!
	
	
	      if (!isDomElement(element)) {
	        throw new TypeError('You must pass either a valid element or a valid id.');
	      }
	
	      var win = element.ownerDocument.defaultView; // Already initialized an embed in this div, so grab the iframe
	
	      if (element.nodeName !== 'IFRAME') {
	        var iframe = element.querySelector('iframe');
	
	        if (iframe) {
	          element = iframe;
	        }
	      } // iframe url is not a Vimeo url
	
	
	      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
	        throw new Error('The player element passed isn’t a Vimeo embed.');
	      } // If there is already a player object in the map, return that
	
	
	      if (playerMap.has(element)) {
	        return playerMap.get(element);
	      }
	
	      this.element = element;
	      this.origin = '*';
	      var readyPromise = new npo_src(function (resolve, reject) {
	        var onMessage = function onMessage(event) {
	          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
	            return;
	          }
	
	          if (_this.origin === '*') {
	            _this.origin = event.origin;
	          }
	
	          var data = parseMessageData(event.data);
	          var isError = data && data.event === 'error';
	          var isReadyError = isError && data.data && data.data.method === 'ready';
	
	          if (isReadyError) {
	            var error = new Error(data.data.message);
	            error.name = data.data.name;
	            reject(error);
	            return;
	          }
	
	          var isReadyEvent = data && data.event === 'ready';
	          var isPingResponse = data && data.method === 'ping';
	
	          if (isReadyEvent || isPingResponse) {
	            _this.element.setAttribute('data-ready', 'true');
	
	            resolve();
	            return;
	          }
	
	          processData(_this, data);
	        };
	
	        if (win.addEventListener) {
	          win.addEventListener('message', onMessage, false);
	        } else if (win.attachEvent) {
	          win.attachEvent('onmessage', onMessage);
	        }
	
	        if (_this.element.nodeName !== 'IFRAME') {
	          var params = getOEmbedParameters(element, options);
	          var url = getVimeoUrl(params);
	          getOEmbedData(url, params, element).then(function (data) {
	            var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
	            // but store reference to the original element
	
	            _this.element = iframe;
	            _this._originalElement = element;
	            swapCallbacks(element, iframe);
	            playerMap.set(_this.element, _this);
	            return data;
	          }).catch(reject);
	        }
	      }); // Store a copy of this Player in the map
	
	      readyMap.set(this, readyPromise);
	      playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
	      // the player is already ready.
	
	      if (this.element.nodeName === 'IFRAME') {
	        postMessage(this, 'ping');
	      }
	
	      return this;
	    }
	    /**
	     * Get a promise for a method.
	     *
	     * @param {string} name The API method to call.
	     * @param {Object} [args={}] Arguments to send via postMessage.
	     * @return {Promise}
	     */
	
	
	    _createClass(Player, [{
	      key: "callMethod",
	      value: function callMethod(name) {
	        var _this2 = this;
	
	        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return new npo_src(function (resolve, reject) {
	          // We are storing the resolve/reject handlers to call later, so we
	          // can’t return here.
	          // eslint-disable-next-line promise/always-return
	          return _this2.ready().then(function () {
	            storeCallback(_this2, name, {
	              resolve: resolve,
	              reject: reject
	            });
	            postMessage(_this2, name, args);
	          }).catch(reject);
	        });
	      }
	      /**
	       * Get a promise for the value of a player property.
	       *
	       * @param {string} name The property name
	       * @return {Promise}
	       */
	
	    }, {
	      key: "get",
	      value: function get(name) {
	        var _this3 = this;
	
	        return new npo_src(function (resolve, reject) {
	          name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
	          // can’t return here.
	          // eslint-disable-next-line promise/always-return
	
	          return _this3.ready().then(function () {
	            storeCallback(_this3, name, {
	              resolve: resolve,
	              reject: reject
	            });
	            postMessage(_this3, name);
	          }).catch(reject);
	        });
	      }
	      /**
	       * Get a promise for setting the value of a player property.
	       *
	       * @param {string} name The API method to call.
	       * @param {mixed} value The value to set.
	       * @return {Promise}
	       */
	
	    }, {
	      key: "set",
	      value: function set(name, value) {
	        var _this4 = this;
	
	        return new npo_src(function (resolve, reject) {
	          name = getMethodName(name, 'set');
	
	          if (value === undefined || value === null) {
	            throw new TypeError('There must be a value to set.');
	          } // We are storing the resolve/reject handlers to call later, so we
	          // can’t return here.
	          // eslint-disable-next-line promise/always-return
	
	
	          return _this4.ready().then(function () {
	            storeCallback(_this4, name, {
	              resolve: resolve,
	              reject: reject
	            });
	            postMessage(_this4, name, value);
	          }).catch(reject);
	        });
	      }
	      /**
	       * Add an event listener for the specified event. Will call the
	       * callback with a single parameter, `data`, that contains the data for
	       * that event.
	       *
	       * @param {string} eventName The name of the event.
	       * @param {function(*)} callback The function to call when the event fires.
	       * @return {void}
	       */
	
	    }, {
	      key: "on",
	      value: function on(eventName, callback) {
	        if (!eventName) {
	          throw new TypeError('You must pass an event name.');
	        }
	
	        if (!callback) {
	          throw new TypeError('You must pass a callback function.');
	        }
	
	        if (typeof callback !== 'function') {
	          throw new TypeError('The callback must be a function.');
	        }
	
	        var callbacks = getCallbacks(this, "event:".concat(eventName));
	
	        if (callbacks.length === 0) {
	          this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
	            // will trigger the error callback if they are listening.
	          });
	        }
	
	        storeCallback(this, "event:".concat(eventName), callback);
	      }
	      /**
	       * Remove an event listener for the specified event. Will remove all
	       * listeners for that event if a `callback` isn’t passed, or only that
	       * specific callback if it is passed.
	       *
	       * @param {string} eventName The name of the event.
	       * @param {function} [callback] The specific callback to remove.
	       * @return {void}
	       */
	
	    }, {
	      key: "off",
	      value: function off(eventName, callback) {
	        if (!eventName) {
	          throw new TypeError('You must pass an event name.');
	        }
	
	        if (callback && typeof callback !== 'function') {
	          throw new TypeError('The callback must be a function.');
	        }
	
	        var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener
	
	        if (lastCallback) {
	          this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
	            // will trigger the error callback if they are listening.
	          });
	        }
	      }
	      /**
	       * A promise to load a new video.
	       *
	       * @promise LoadVideoPromise
	       * @fulfill {number} The video with this id successfully loaded.
	       * @reject {TypeError} The id was not a number.
	       */
	
	      /**
	       * Load a new video into this embed. The promise will be resolved if
	       * the video is successfully loaded, or it will be rejected if it could
	       * not be loaded.
	       *
	       * @param {number|object} options The id of the video or an object with embed options.
	       * @return {LoadVideoPromise}
	       */
	
	    }, {
	      key: "loadVideo",
	      value: function loadVideo(options) {
	        return this.callMethod('loadVideo', options);
	      }
	      /**
	       * A promise to perform an action when the Player is ready.
	       *
	       * @todo document errors
	       * @promise LoadVideoPromise
	       * @fulfill {void}
	       */
	
	      /**
	       * Trigger a function when the player iframe has initialized. You do not
	       * need to wait for `ready` to trigger to begin adding event listeners
	       * or calling other methods.
	       *
	       * @return {ReadyPromise}
	       */
	
	    }, {
	      key: "ready",
	      value: function ready() {
	        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
	          reject(new Error('Unknown player. Probably unloaded.'));
	        });
	        return npo_src.resolve(readyPromise);
	      }
	      /**
	       * A promise to add a cue point to the player.
	       *
	       * @promise AddCuePointPromise
	       * @fulfill {string} The id of the cue point to use for removeCuePoint.
	       * @reject {RangeError} the time was less than 0 or greater than the
	       *         video’s duration.
	       * @reject {UnsupportedError} Cue points are not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Add a cue point to the player.
	       *
	       * @param {number} time The time for the cue point.
	       * @param {object} [data] Arbitrary data to be returned with the cue point.
	       * @return {AddCuePointPromise}
	       */
	
	    }, {
	      key: "addCuePoint",
	      value: function addCuePoint(time) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return this.callMethod('addCuePoint', {
	          time: time,
	          data: data
	        });
	      }
	      /**
	       * A promise to remove a cue point from the player.
	       *
	       * @promise AddCuePointPromise
	       * @fulfill {string} The id of the cue point that was removed.
	       * @reject {InvalidCuePoint} The cue point with the specified id was not
	       *         found.
	       * @reject {UnsupportedError} Cue points are not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Remove a cue point from the video.
	       *
	       * @param {string} id The id of the cue point to remove.
	       * @return {RemoveCuePointPromise}
	       */
	
	    }, {
	      key: "removeCuePoint",
	      value: function removeCuePoint(id) {
	        return this.callMethod('removeCuePoint', id);
	      }
	      /**
	       * A representation of a text track on a video.
	       *
	       * @typedef {Object} VimeoTextTrack
	       * @property {string} language The ISO language code.
	       * @property {string} kind The kind of track it is (captions or subtitles).
	       * @property {string} label The human‐readable label for the track.
	       */
	
	      /**
	       * A promise to enable a text track.
	       *
	       * @promise EnableTextTrackPromise
	       * @fulfill {VimeoTextTrack} The text track that was enabled.
	       * @reject {InvalidTrackLanguageError} No track was available with the
	       *         specified language.
	       * @reject {InvalidTrackError} No track was available with the specified
	       *         language and kind.
	       */
	
	      /**
	       * Enable the text track with the specified language, and optionally the
	       * specified kind (captions or subtitles).
	       *
	       * When set via the API, the track language will not change the viewer’s
	       * stored preference.
	       *
	       * @param {string} language The two‐letter language code.
	       * @param {string} [kind] The kind of track to enable (captions or subtitles).
	       * @return {EnableTextTrackPromise}
	       */
	
	    }, {
	      key: "enableTextTrack",
	      value: function enableTextTrack(language, kind) {
	        if (!language) {
	          throw new TypeError('You must pass a language.');
	        }
	
	        return this.callMethod('enableTextTrack', {
	          language: language,
	          kind: kind
	        });
	      }
	      /**
	       * A promise to disable the active text track.
	       *
	       * @promise DisableTextTrackPromise
	       * @fulfill {void} The track was disabled.
	       */
	
	      /**
	       * Disable the currently-active text track.
	       *
	       * @return {DisableTextTrackPromise}
	       */
	
	    }, {
	      key: "disableTextTrack",
	      value: function disableTextTrack() {
	        return this.callMethod('disableTextTrack');
	      }
	      /**
	       * A promise to pause the video.
	       *
	       * @promise PausePromise
	       * @fulfill {void} The video was paused.
	       */
	
	      /**
	       * Pause the video if it’s playing.
	       *
	       * @return {PausePromise}
	       */
	
	    }, {
	      key: "pause",
	      value: function pause() {
	        return this.callMethod('pause');
	      }
	      /**
	       * A promise to play the video.
	       *
	       * @promise PlayPromise
	       * @fulfill {void} The video was played.
	       */
	
	      /**
	       * Play the video if it’s paused. **Note:** on iOS and some other
	       * mobile devices, you cannot programmatically trigger play. Once the
	       * viewer has tapped on the play button in the player, however, you
	       * will be able to use this function.
	       *
	       * @return {PlayPromise}
	       */
	
	    }, {
	      key: "play",
	      value: function play() {
	        return this.callMethod('play');
	      }
	      /**
	       * A promise to unload the video.
	       *
	       * @promise UnloadPromise
	       * @fulfill {void} The video was unloaded.
	       */
	
	      /**
	       * Return the player to its initial state.
	       *
	       * @return {UnloadPromise}
	       */
	
	    }, {
	      key: "unload",
	      value: function unload() {
	        return this.callMethod('unload');
	      }
	      /**
	       * Cleanup the player and remove it from the DOM
	       *
	       * It won't be usable and a new one should be constructed
	       *  in order to do any operations.
	       *
	       * @return {Promise}
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        var _this5 = this;
	
	        return new npo_src(function (resolve) {
	          readyMap.delete(_this5);
	          playerMap.delete(_this5.element);
	
	          if (_this5._originalElement) {
	            playerMap.delete(_this5._originalElement);
	
	            _this5._originalElement.removeAttribute('data-vimeo-initialized');
	          }
	
	          if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
	            _this5.element.parentNode.removeChild(_this5.element);
	          }
	
	          resolve();
	        });
	      }
	      /**
	       * A promise to get the autopause behavior of the video.
	       *
	       * @promise GetAutopausePromise
	       * @fulfill {boolean} Whether autopause is turned on or off.
	       * @reject {UnsupportedError} Autopause is not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Get the autopause behavior for this player.
	       *
	       * @return {GetAutopausePromise}
	       */
	
	    }, {
	      key: "getAutopause",
	      value: function getAutopause() {
	        return this.get('autopause');
	      }
	      /**
	       * A promise to set the autopause behavior of the video.
	       *
	       * @promise SetAutopausePromise
	       * @fulfill {boolean} Whether autopause is turned on or off.
	       * @reject {UnsupportedError} Autopause is not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Enable or disable the autopause behavior of this player.
	       *
	       * By default, when another video is played in the same browser, this
	       * player will automatically pause. Unless you have a specific reason
	       * for doing so, we recommend that you leave autopause set to the
	       * default (`true`).
	       *
	       * @param {boolean} autopause
	       * @return {SetAutopausePromise}
	       */
	
	    }, {
	      key: "setAutopause",
	      value: function setAutopause(autopause) {
	        return this.set('autopause', autopause);
	      }
	      /**
	       * A promise to get the buffered property of the video.
	       *
	       * @promise GetBufferedPromise
	       * @fulfill {Array} Buffered Timeranges converted to an Array.
	       */
	
	      /**
	       * Get the buffered property of the video.
	       *
	       * @return {GetBufferedPromise}
	       */
	
	    }, {
	      key: "getBuffered",
	      value: function getBuffered() {
	        return this.get('buffered');
	      }
	      /**
	       * A promise to get the color of the player.
	       *
	       * @promise GetColorPromise
	       * @fulfill {string} The hex color of the player.
	       */
	
	      /**
	       * Get the color for this player.
	       *
	       * @return {GetColorPromise}
	       */
	
	    }, {
	      key: "getColor",
	      value: function getColor() {
	        return this.get('color');
	      }
	      /**
	       * A promise to set the color of the player.
	       *
	       * @promise SetColorPromise
	       * @fulfill {string} The color was successfully set.
	       * @reject {TypeError} The string was not a valid hex or rgb color.
	       * @reject {ContrastError} The color was set, but the contrast is
	       *         outside of the acceptable range.
	       * @reject {EmbedSettingsError} The owner of the player has chosen to
	       *         use a specific color.
	       */
	
	      /**
	       * Set the color of this player to a hex or rgb string. Setting the
	       * color may fail if the owner of the video has set their embed
	       * preferences to force a specific color.
	       *
	       * @param {string} color The hex or rgb color string to set.
	       * @return {SetColorPromise}
	       */
	
	    }, {
	      key: "setColor",
	      value: function setColor(color) {
	        return this.set('color', color);
	      }
	      /**
	       * A representation of a cue point.
	       *
	       * @typedef {Object} VimeoCuePoint
	       * @property {number} time The time of the cue point.
	       * @property {object} data The data passed when adding the cue point.
	       * @property {string} id The unique id for use with removeCuePoint.
	       */
	
	      /**
	       * A promise to get the cue points of a video.
	       *
	       * @promise GetCuePointsPromise
	       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
	       * @reject {UnsupportedError} Cue points are not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Get an array of the cue points added to the video.
	       *
	       * @return {GetCuePointsPromise}
	       */
	
	    }, {
	      key: "getCuePoints",
	      value: function getCuePoints() {
	        return this.get('cuePoints');
	      }
	      /**
	       * A promise to get the current time of the video.
	       *
	       * @promise GetCurrentTimePromise
	       * @fulfill {number} The current time in seconds.
	       */
	
	      /**
	       * Get the current playback position in seconds.
	       *
	       * @return {GetCurrentTimePromise}
	       */
	
	    }, {
	      key: "getCurrentTime",
	      value: function getCurrentTime() {
	        return this.get('currentTime');
	      }
	      /**
	       * A promise to set the current time of the video.
	       *
	       * @promise SetCurrentTimePromise
	       * @fulfill {number} The actual current time that was set.
	       * @reject {RangeError} the time was less than 0 or greater than the
	       *         video’s duration.
	       */
	
	      /**
	       * Set the current playback position in seconds. If the player was
	       * paused, it will remain paused. Likewise, if the player was playing,
	       * it will resume playing once the video has buffered.
	       *
	       * You can provide an accurate time and the player will attempt to seek
	       * to as close to that time as possible. The exact time will be the
	       * fulfilled value of the promise.
	       *
	       * @param {number} currentTime
	       * @return {SetCurrentTimePromise}
	       */
	
	    }, {
	      key: "setCurrentTime",
	      value: function setCurrentTime(currentTime) {
	        return this.set('currentTime', currentTime);
	      }
	      /**
	       * A promise to get the duration of the video.
	       *
	       * @promise GetDurationPromise
	       * @fulfill {number} The duration in seconds.
	       */
	
	      /**
	       * Get the duration of the video in seconds. It will be rounded to the
	       * nearest second before playback begins, and to the nearest thousandth
	       * of a second after playback begins.
	       *
	       * @return {GetDurationPromise}
	       */
	
	    }, {
	      key: "getDuration",
	      value: function getDuration() {
	        return this.get('duration');
	      }
	      /**
	       * A promise to get the ended state of the video.
	       *
	       * @promise GetEndedPromise
	       * @fulfill {boolean} Whether or not the video has ended.
	       */
	
	      /**
	       * Get the ended state of the video. The video has ended if
	       * `currentTime === duration`.
	       *
	       * @return {GetEndedPromise}
	       */
	
	    }, {
	      key: "getEnded",
	      value: function getEnded() {
	        return this.get('ended');
	      }
	      /**
	       * A promise to get the loop state of the player.
	       *
	       * @promise GetLoopPromise
	       * @fulfill {boolean} Whether or not the player is set to loop.
	       */
	
	      /**
	       * Get the loop state of the player.
	       *
	       * @return {GetLoopPromise}
	       */
	
	    }, {
	      key: "getLoop",
	      value: function getLoop() {
	        return this.get('loop');
	      }
	      /**
	       * A promise to set the loop state of the player.
	       *
	       * @promise SetLoopPromise
	       * @fulfill {boolean} The loop state that was set.
	       */
	
	      /**
	       * Set the loop state of the player. When set to `true`, the player
	       * will start over immediately once playback ends.
	       *
	       * @param {boolean} loop
	       * @return {SetLoopPromise}
	       */
	
	    }, {
	      key: "setLoop",
	      value: function setLoop(loop) {
	        return this.set('loop', loop);
	      }
	      /**
	       * A promise to set the muted state of the player.
	       *
	       * @promise SetMutedPromise
	       * @fulfill {boolean} The muted state that was set.
	       */
	
	      /**
	       * Set the muted state of the player. When set to `true`, the player
	       * volume will be muted.
	       *
	       * @param {boolean} muted
	       * @return {SetMutedPromise}
	       */
	
	    }, {
	      key: "setMuted",
	      value: function setMuted(muted) {
	        return this.set('muted', muted);
	      }
	      /**
	       * A promise to get the muted state of the player.
	       *
	       * @promise GetMutedPromise
	       * @fulfill {boolean} Whether or not the player is muted.
	       */
	
	      /**
	       * Get the muted state of the player.
	       *
	       * @return {GetMutedPromise}
	       */
	
	    }, {
	      key: "getMuted",
	      value: function getMuted() {
	        return this.get('muted');
	      }
	      /**
	       * A promise to get the paused state of the player.
	       *
	       * @promise GetLoopPromise
	       * @fulfill {boolean} Whether or not the video is paused.
	       */
	
	      /**
	       * Get the paused state of the player.
	       *
	       * @return {GetLoopPromise}
	       */
	
	    }, {
	      key: "getPaused",
	      value: function getPaused() {
	        return this.get('paused');
	      }
	      /**
	       * A promise to get the playback rate of the player.
	       *
	       * @promise GetPlaybackRatePromise
	       * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
	       */
	
	      /**
	       * Get the playback rate of the player on a scale from `0.5` to `2`.
	       *
	       * @return {GetPlaybackRatePromise}
	       */
	
	    }, {
	      key: "getPlaybackRate",
	      value: function getPlaybackRate() {
	        return this.get('playbackRate');
	      }
	      /**
	       * A promise to set the playbackrate of the player.
	       *
	       * @promise SetPlaybackRatePromise
	       * @fulfill {number} The playback rate was set.
	       * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
	       */
	
	      /**
	       * Set the playback rate of the player on a scale from `0.5` to `2`. When set
	       * via the API, the playback rate will not be synchronized to other
	       * players or stored as the viewer's preference.
	       *
	       * @param {number} playbackRate
	       * @return {SetPlaybackRatePromise}
	       */
	
	    }, {
	      key: "setPlaybackRate",
	      value: function setPlaybackRate(playbackRate) {
	        return this.set('playbackRate', playbackRate);
	      }
	      /**
	       * A promise to get the played property of the video.
	       *
	       * @promise GetPlayedPromise
	       * @fulfill {Array} Played Timeranges converted to an Array.
	       */
	
	      /**
	       * Get the played property of the video.
	       *
	       * @return {GetPlayedPromise}
	       */
	
	    }, {
	      key: "getPlayed",
	      value: function getPlayed() {
	        return this.get('played');
	      }
	      /**
	       * A promise to get the seekable property of the video.
	       *
	       * @promise GetSeekablePromise
	       * @fulfill {Array} Seekable Timeranges converted to an Array.
	       */
	
	      /**
	       * Get the seekable property of the video.
	       *
	       * @return {GetSeekablePromise}
	       */
	
	    }, {
	      key: "getSeekable",
	      value: function getSeekable() {
	        return this.get('seekable');
	      }
	      /**
	       * A promise to get the seeking property of the player.
	       *
	       * @promise GetSeekingPromise
	       * @fulfill {boolean} Whether or not the player is currently seeking.
	       */
	
	      /**
	       * Get if the player is currently seeking.
	       *
	       * @return {GetSeekingPromise}
	       */
	
	    }, {
	      key: "getSeeking",
	      value: function getSeeking() {
	        return this.get('seeking');
	      }
	      /**
	       * A promise to get the text tracks of a video.
	       *
	       * @promise GetTextTracksPromise
	       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
	       */
	
	      /**
	       * Get an array of the text tracks that exist for the video.
	       *
	       * @return {GetTextTracksPromise}
	       */
	
	    }, {
	      key: "getTextTracks",
	      value: function getTextTracks() {
	        return this.get('textTracks');
	      }
	      /**
	       * A promise to get the embed code for the video.
	       *
	       * @promise GetVideoEmbedCodePromise
	       * @fulfill {string} The `<iframe>` embed code for the video.
	       */
	
	      /**
	       * Get the `<iframe>` embed code for the video.
	       *
	       * @return {GetVideoEmbedCodePromise}
	       */
	
	    }, {
	      key: "getVideoEmbedCode",
	      value: function getVideoEmbedCode() {
	        return this.get('videoEmbedCode');
	      }
	      /**
	       * A promise to get the id of the video.
	       *
	       * @promise GetVideoIdPromise
	       * @fulfill {number} The id of the video.
	       */
	
	      /**
	       * Get the id of the video.
	       *
	       * @return {GetVideoIdPromise}
	       */
	
	    }, {
	      key: "getVideoId",
	      value: function getVideoId() {
	        return this.get('videoId');
	      }
	      /**
	       * A promise to get the title of the video.
	       *
	       * @promise GetVideoTitlePromise
	       * @fulfill {number} The title of the video.
	       */
	
	      /**
	       * Get the title of the video.
	       *
	       * @return {GetVideoTitlePromise}
	       */
	
	    }, {
	      key: "getVideoTitle",
	      value: function getVideoTitle() {
	        return this.get('videoTitle');
	      }
	      /**
	       * A promise to get the native width of the video.
	       *
	       * @promise GetVideoWidthPromise
	       * @fulfill {number} The native width of the video.
	       */
	
	      /**
	       * Get the native width of the currently‐playing video. The width of
	       * the highest‐resolution available will be used before playback begins.
	       *
	       * @return {GetVideoWidthPromise}
	       */
	
	    }, {
	      key: "getVideoWidth",
	      value: function getVideoWidth() {
	        return this.get('videoWidth');
	      }
	      /**
	       * A promise to get the native height of the video.
	       *
	       * @promise GetVideoHeightPromise
	       * @fulfill {number} The native height of the video.
	       */
	
	      /**
	       * Get the native height of the currently‐playing video. The height of
	       * the highest‐resolution available will be used before playback begins.
	       *
	       * @return {GetVideoHeightPromise}
	       */
	
	    }, {
	      key: "getVideoHeight",
	      value: function getVideoHeight() {
	        return this.get('videoHeight');
	      }
	      /**
	       * A promise to get the vimeo.com url for the video.
	       *
	       * @promise GetVideoUrlPromise
	       * @fulfill {number} The vimeo.com url for the video.
	       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
	       */
	
	      /**
	       * Get the vimeo.com url for the video.
	       *
	       * @return {GetVideoUrlPromise}
	       */
	
	    }, {
	      key: "getVideoUrl",
	      value: function getVideoUrl() {
	        return this.get('videoUrl');
	      }
	      /**
	       * A promise to get the volume level of the player.
	       *
	       * @promise GetVolumePromise
	       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
	       */
	
	      /**
	       * Get the current volume level of the player on a scale from `0` to `1`.
	       *
	       * Most mobile devices do not support an independent volume from the
	       * system volume. In those cases, this method will always return `1`.
	       *
	       * @return {GetVolumePromise}
	       */
	
	    }, {
	      key: "getVolume",
	      value: function getVolume() {
	        return this.get('volume');
	      }
	      /**
	       * A promise to set the volume level of the player.
	       *
	       * @promise SetVolumePromise
	       * @fulfill {number} The volume was set.
	       * @reject {RangeError} The volume was less than 0 or greater than 1.
	       */
	
	      /**
	       * Set the volume of the player on a scale from `0` to `1`. When set
	       * via the API, the volume level will not be synchronized to other
	       * players or stored as the viewer’s preference.
	       *
	       * Most mobile devices do not support setting the volume. An error will
	       * *not* be triggered in that situation.
	       *
	       * @param {number} volume
	       * @return {SetVolumePromise}
	       */
	
	    }, {
	      key: "setVolume",
	      value: function setVolume(volume) {
	        return this.set('volume', volume);
	      }
	    }]);
	
	    return Player;
	  }(); // Setup embed only if this is not a node environment
	
	
	  if (!isNode) {
	    initializeEmbeds();
	    resizeEmbeds();
	  }
	
	  return Player;
	
	}));
	
	//# sourceMappingURL=player.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(940).setImmediate))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(19);
	var normalizeHeaderName = __webpack_require__(263);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(191);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(191);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(174)))

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(78);
	var dPs = __webpack_require__(407);
	var enumBugKeys = __webpack_require__(138);
	var IE_PROTO = __webpack_require__(143)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(211)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(401).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(55).f;
	var has = __webpack_require__(43);
	var TAG = __webpack_require__(57)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(144)('keys');
	var uid = __webpack_require__(104);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(25);
	var global = __webpack_require__(36);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(100) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(54);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var core = __webpack_require__(25);
	var LIBRARY = __webpack_require__(100);
	var wksExt = __webpack_require__(148);
	var defineProperty = __webpack_require__(55).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(57);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(106);
	var TAG = __webpack_require__(18)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	var document = __webpack_require__(17).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(105);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(110).f;
	var has = __webpack_require__(109);
	var TAG = __webpack_require__(18)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(156)('keys');
	var uid = __webpack_require__(159);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(45);
	var global = __webpack_require__(17);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(152) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(433);
	var defined = __webpack_require__(150);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(176);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(242);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var consolidatedEvents = __webpack_require__(388);
	var PropTypes = _interopDefault(__webpack_require__(2));
	var reactIs = __webpack_require__(834);
	
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = parseOffsetAsPixels(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = parseOffsetAsPercentage(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	
	var constants = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	
	var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if more that one child was provided to "children"
	 *
	 * @param {?React.element} children
	 * @return {undefined}
	 */
	function ensureChildrenIsValid(children) {
	  if (children) {
	    try {
	      React.Children.only(children);
	    } catch (e) {
	      throw new Error(errorMessage);
	    }
	  }
	}
	
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	
	var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
	 *
	 * @param {?React.element} children
	 * @param {?HTMLElement} ref
	 * @return {undefined}
	 */
	function ensureRefIsProvidedByChild(children, ref) {
	  if (children && !isDOMElement(children) && !ref) {
	    throw new Error(errorMessage$1);
	  }
	}
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return constants.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return constants.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return constants.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return constants.above;
	  }
	
	  return constants.invisible;
	}
	
	var timeout = void 0;
	var timeoutQueue = [];
	
	function onNextTick(cb) {
	  timeoutQueue.push(cb);
	
	  if (!timeout) {
	    timeout = setTimeout(function () {
	      timeout = null;
	
	      // Drain the timeoutQueue
	      var item = void 0;
	      // eslint-disable-next-line no-cond-assign
	      while (item = timeoutQueue.shift()) {
	        item();
	      }
	    }, 0);
	  }
	
	  var isSubscribed = true;
	
	  return function () {
	    function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      var index = timeoutQueue.indexOf(cb);
	      if (index === -1) {
	        return;
	      }
	
	      timeoutQueue.splice(index, 1);
	
	      if (!timeoutQueue.length && timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	    }
	
	    return unsubscribe;
	  }();
	}
	
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function () {
	    function onEnter() {}
	
	    return onEnter;
	  }(),
	  onLeave: function () {
	    function onLeave() {}
	
	    return onLeave;
	  }(),
	  onPositionChange: function () {
	    function onPositionChange() {}
	
	    return onPositionChange;
	  }(),
	
	  fireOnRapidScroll: true
	};
	
	// React.PureComponent was added in React 15.3.0
	var BaseClass = typeof React.PureComponent !== 'undefined' ? React.PureComponent : React.Component;
	
	// Calls a function when you scroll to the element.
	
	var Waypoint = function (_BaseClass) {
	  _inherits(Waypoint, _BaseClass);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function () {
	      function componentWillMount() {
	        ensureChildrenIsValid(this.props.children);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        // this._ref may occasionally not be set at this time. To help ensure that
	        // this works smoothly and to avoid layout thrashing, we want to delay the
	        // initial execution until the next tick.
	        this.cancelOnNextTick = onNextTick(function () {
	          _this2.cancelOnNextTick = null;
	
	          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
	          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);
	
	          _this2._handleScroll = _this2._handleScroll.bind(_this2);
	          _this2.scrollableAncestor = _this2._findScrollableAncestor();
	
	          if (false) {
	            debugLog('scrollableAncestor', _this2.scrollableAncestor);
	          }
	
	          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });
	
	          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });
	
	          _this2._handleScroll(null);
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(newProps) {
	        ensureChildrenIsValid(newProps.children);
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        var _this3 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (!this.scrollableAncestor) {
	          // The Waypoint has not yet initialized.
	          return;
	        }
	
	        // The element may have moved, so we need to recompute its position on the
	        // page. This happens via handleScroll in a way that forces layout to be
	        // computed.
	        //
	        // We want this to be deferred to avoid forcing layout during render, which
	        // causes layout thrashing. And, if we already have this work enqueued, we
	        // can just wait for that to happen instead of enqueueing again.
	        if (this.cancelOnNextTick) {
	          return;
	        }
	
	        this.cancelOnNextTick = onNextTick(function () {
	          _this3.cancelOnNextTick = null;
	          _this3._handleScroll(null);
	        });
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (this.scrollEventListenerUnsubscribe) {
	          this.scrollEventListenerUnsubscribe();
	        }
	        if (this.resizeEventListenerUnsubscribe) {
	          this.resizeEventListenerUnsubscribe();
	        }
	
	        if (this.cancelOnNextTick) {
	          this.cancelOnNextTick();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function () {
	      function _findScrollableAncestor() {
	        var _props = this.props,
	            horizontal = _props.horizontal,
	            scrollableAncestor = _props.scrollableAncestor;
	
	
	        if (scrollableAncestor) {
	          return resolveScrollableAncestorProp(scrollableAncestor);
	        }
	
	        var node = this._ref;
	
	        while (node.parentNode) {
	          node = node.parentNode;
	
	          if (node === document.body) {
	            // We've reached all the way to the root node.
	            return window;
	          }
	
	          var style = window.getComputedStyle(node);
	          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	          var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	          if (overflow === 'auto' || overflow === 'scroll') {
	            return node;
	          }
	        }
	
	        // A scrollable ancestor element was not found, which means that we need to
	        // do stuff on window.
	        return window;
	      }
	
	      return _findScrollableAncestor;
	    }()
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function () {
	      function _handleScroll(event) {
	        if (!this._ref) {
	          // There's a chance we end up here after the component has been unmounted.
	          return;
	        }
	
	        var bounds = this._getBounds();
	        var currentPosition = getCurrentPosition(bounds);
	        var previousPosition = this._previousPosition;
	
	        if (false) {
	          debugLog('currentPosition', currentPosition);
	          debugLog('previousPosition', previousPosition);
	        }
	
	        // Save previous position as early as possible to prevent cycles
	        this._previousPosition = currentPosition;
	
	        if (previousPosition === currentPosition) {
	          // No change since last trigger
	          return;
	        }
	
	        var callbackArg = {
	          currentPosition: currentPosition,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        };
	        this.props.onPositionChange.call(this, callbackArg);
	
	        if (currentPosition === constants.inside) {
	          this.props.onEnter.call(this, callbackArg);
	        } else if (previousPosition === constants.inside) {
	          this.props.onLeave.call(this, callbackArg);
	        }
	
	        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
	        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;
	
	        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	          // If the scroll event isn't fired often enough to occur while the
	          // waypoint was visible, we trigger both callbacks anyway.
	          this.props.onEnter.call(this, {
	            currentPosition: constants.inside,
	            previousPosition: previousPosition,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	          this.props.onLeave.call(this, {
	            currentPosition: currentPosition,
	            previousPosition: constants.inside,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	        }
	      }
	
	      return _handleScroll;
	    }()
	  }, {
	    key: '_getBounds',
	    value: function () {
	      function _getBounds() {
	        var horizontal = this.props.horizontal;
	
	        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	            left = _ref$getBoundingClien.left,
	            top = _ref$getBoundingClien.top,
	            right = _ref$getBoundingClien.right,
	            bottom = _ref$getBoundingClien.bottom;
	
	        var waypointTop = horizontal ? left : top;
	        var waypointBottom = horizontal ? right : bottom;
	
	        var contextHeight = void 0;
	        var contextScrollTop = void 0;
	        if (this.scrollableAncestor === window) {
	          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	          contextScrollTop = 0;
	        } else {
	          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	        }
	
	        if (false) {
	          debugLog('waypoint top', waypointTop);
	          debugLog('waypoint bottom', waypointBottom);
	          debugLog('scrollableAncestor height', contextHeight);
	          debugLog('scrollableAncestor scrollTop', contextScrollTop);
	        }
	
	        var _props2 = this.props,
	            bottomOffset = _props2.bottomOffset,
	            topOffset = _props2.topOffset;
	
	        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
	        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
	        var contextBottom = contextScrollTop + contextHeight;
	
	        return {
	          waypointTop: waypointTop,
	          waypointBottom: waypointBottom,
	          viewportTop: contextScrollTop + topOffsetPx,
	          viewportBottom: contextBottom - bottomOffsetPx
	        };
	      }
	
	      return _getBounds;
	    }()
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this4 = this;
	
	        var children = this.props.children;
	
	
	        if (!children) {
	          // We need an element that we can locate in the DOM to determine where it is
	          // rendered relative to the top of its context.
	          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	        }
	
	        if (isDOMElement(children) || reactIs.isForwardRef(children.type)) {
	          var ref = function () {
	            function ref(node) {
	              _this4.refElement(node);
	              if (children.ref) {
	                if (typeof children.ref === 'function') {
	                  children.ref(node);
	                } else {
	                  children.ref.current = node;
	                }
	              }
	            }
	
	            return ref;
	          }();
	
	          return React.cloneElement(children, { ref: ref });
	        }
	
	        return React.cloneElement(children, { innerRef: this.refElement });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Waypoint;
	}(BaseClass);
	
	
	Waypoint.propTypes = {
	  children: PropTypes.node,
	  debug: PropTypes.bool,
	  onEnter: PropTypes.func,
	  onLeave: PropTypes.func,
	  onPositionChange: PropTypes.func,
	  fireOnRapidScroll: PropTypes.bool,
	  scrollableAncestor: PropTypes.any,
	  horizontal: PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	Waypoint.above = constants.above;
	Waypoint.below = constants.below;
	Waypoint.inside = constants.inside;
	Waypoint.invisible = constants.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	
	module.exports = Waypoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	var settle = __webpack_require__(256);
	var buildURL = __webpack_require__(258);
	var parseHeaders = __webpack_require__(264);
	var isURLSameOrigin = __webpack_require__(262);
	var createError = __webpack_require__(194);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(260);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(255);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(379);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(384);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(383);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(397);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	var document = __webpack_require__(36).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(42) && !__webpack_require__(52)(function () {
	  return Object.defineProperty(__webpack_require__(211)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(209);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(100);
	var $export = __webpack_require__(51);
	var redefine = __webpack_require__(218);
	var hide = __webpack_require__(53);
	var Iterators = __webpack_require__(139);
	var $iterCreate = __webpack_require__(403);
	var setToStringTag = __webpack_require__(142);
	var getPrototypeOf = __webpack_require__(409);
	var ITERATOR = __webpack_require__(57)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(101);
	var createDesc = __webpack_require__(102);
	var toIObject = __webpack_require__(56);
	var toPrimitive = __webpack_require__(146);
	var has = __webpack_require__(43);
	var IE8_DOM_DEFINE = __webpack_require__(212);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(42) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(217);
	var hiddenKeys = __webpack_require__(138).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(43);
	var toIObject = __webpack_require__(56);
	var arrayIndexOf = __webpack_require__(399)(false);
	var IE_PROTO = __webpack_require__(143)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(53);


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(17).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(152);
	var $export = __webpack_require__(108);
	var redefine = __webpack_require__(83);
	var hide = __webpack_require__(58);
	var Iterators = __webpack_require__(82);
	var $iterCreate = __webpack_require__(436);
	var setToStringTag = __webpack_require__(154);
	var getPrototypeOf = __webpack_require__(442);
	var ITERATOR = __webpack_require__(18)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(443);
	var enumBugKeys = __webpack_require__(219);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(44);
	var isObject = __webpack_require__(81);
	var newPromiseCapability = __webpack_require__(153);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(44);
	var aFunction = __webpack_require__(105);
	var SPECIES = __webpack_require__(18)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(107);
	var invoke = __webpack_require__(432);
	var html = __webpack_require__(221);
	var cel = __webpack_require__(151);
	var global = __webpack_require__(17);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(106)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(157);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	exports.DefaultContext = {
	    color: undefined,
	    size: undefined,
	    className: undefined,
	    style: undefined,
	    attr: undefined,
	};
	exports.IconContext = React.createContext && React.createContext(exports.DefaultContext);


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(240);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(177);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(242);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(234)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	module.exports = murmurhash2_32_gc;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	module.exports = memoize;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

	'use strict';
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        switch (d.constructor) {
	          case Array:
	            for (var c = 0, e = d.length; c < e; ++c) {
	              T(d[c]);
	            }
	
	            break;
	
	          case Function:
	            S[A++] = d;
	            break;
	
	          case Boolean:
	            Y = !!d | 0;
	        }
	
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	module.exports = stylis_min;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	module.exports = unitlessKeys;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	var bind = __webpack_require__(195);
	var Axios = __webpack_require__(252);
	var defaults = __webpack_require__(116);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(192);
	axios.CancelToken = __webpack_require__(251);
	axios.isCancel = __webpack_require__(193);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(265);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(192);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(116);
	var utils = __webpack_require__(19);
	var InterceptorManager = __webpack_require__(253);
	var dispatchRequest = __webpack_require__(254);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	var transformData = __webpack_require__(257);
	var isCancel = __webpack_require__(193);
	var defaults = __webpack_require__(116);
	var isAbsoluteURL = __webpack_require__(261);
	var combineURLs = __webpack_require__(259);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(194);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpring = __webpack_require__(8);
	
	var _gradientsModule = __webpack_require__(482);
	
	var _gradientsModule2 = _interopRequireDefault(_gradientsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Gradients = [function (style) {
	  return _react2.default.createElement(_reactSpring.animated.div, {
	    className: _gradientsModule2.default.gradientBlock,
	    style: _extends({}, style, {
	      background: 'radial-gradient(at bottom left, #1805C1, #2AD9C7)'
	    })
	  });
	}, function (style) {
	  return _react2.default.createElement(_reactSpring.animated.div, {
	    className: _gradientsModule2.default.gradientBlock,
	    style: _extends({}, style, {
	      background: 'radial-gradient(at bottom left, #8837B6, #1805C1)'
	    })
	  });
	}, function (style) {
	  return _react2.default.createElement(_reactSpring.animated.div, {
	    className: _gradientsModule2.default.gradientBlock,
	    style: _extends({}, style, {
	      background: 'radial-gradient(at bottom left, #8237B7, #F1319E)'
	    })
	  });
	}, function (style) {
	  return _react2.default.createElement(_reactSpring.animated.div, {
	    className: _gradientsModule2.default.gradientBlock,
	    style: _extends({}, style, {
	      background: 'radial-gradient(at bottom left, #2AD9C7, #1805C1)'
	    })
	  });
	}];
	
	exports.default = Gradients;
	module.exports = exports['default'];

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n          background-color: ', ';\n          position: absolute;\n          margin-top: 1em;\n          font-size: 1em;\n          display: flex;\n          transition: background-color 0.25s ease;\n          &:hover {\n            background-color: ', ';\n          }\n        '], ['\n          background-color: ', ';\n          position: absolute;\n          margin-top: 1em;\n          font-size: 1em;\n          display: flex;\n          transition: background-color 0.25s ease;\n          &:hover {\n            background-color: ', ';\n          }\n        ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpring = __webpack_require__(8);
	
	var _emotion = __webpack_require__(5);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _projectButtonModule = __webpack_require__(512);
	
	var _projectButtonModule2 = _interopRequireDefault(_projectButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectButton = function ProjectButton(_ref) {
	  var currentPage = _ref.currentPage,
	      linkPath = _ref.linkPath,
	      buttonColor = _ref.buttonColor,
	      buttonColorHover = _ref.buttonColorHover,
	      isHome = _ref.isHome,
	      returnSection = _ref.returnSection;
	
	  var renderButton = function renderButton(animation) {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: animation,
	        className: (0, _emotion.css)(_templateObject, buttonColor, buttonColorHover)
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _projectButtonModule2.default.link, to: '/our-work/' + linkPath },
	        'View case study'
	      )
	    );
	  };
	
	  var renderHomeButton = function renderHomeButton() {
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0, transform: 'translateY(20px)' },
	        to: {
	          opacity: returnSection === 'active' ? 1 : 0,
	          transform: returnSection === 'active' ? 'translateY(0)' : 'translateY(20px)'
	        },
	        delay: 800,
	        config: { tension: 180, friction: 60 }
	      },
	      function (animation) {
	        return renderButton(animation);
	      }
	    );
	  };
	
	  var renderProjectButton = function renderProjectButton() {
	    if (isHome) {
	      return renderHomeButton();
	    } else if (currentPage !== 'ProjectTemplate') {
	      return renderButton();
	    }
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    renderProjectButton()
	  );
	};
	
	exports.default = ProjectButton;
	module.exports = exports['default'];

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n              background-image: url(', ');\n            '], ['\n              background-image: url(', ');\n            ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpring = __webpack_require__(8);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _emotion = __webpack_require__(5);
	
	var _projectHeroImageModule = __webpack_require__(517);
	
	var _projectHeroImageModule2 = _interopRequireDefault(_projectHeroImageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectHeroImage = function ProjectHeroImage(_ref) {
	  var featuredImage = _ref.featuredImage,
	      featuredMobileImage = _ref.featuredMobileImage,
	      browserDetect = _ref.browserDetect,
	      isHome = _ref.isHome,
	      returnSection = _ref.returnSection;
	  var desktopFeaturedImgIE = featuredImage.localFile.childImageSharp.sizes.originalImg;
	  var mobileFeaturedImg = featuredMobileImage.localFile.childImageSharp.sizes.originalImg;
	
	
	  var defaultImgStyles = {
	    transform: 'scale(1, 1)',
	    position: 'absolute',
	    left: 0,
	    top: 0,
	    width: '100%',
	    height: '100%'
	  };
	
	  var renderDefaultImages = function renderDefaultImages(imgStyles) {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: featuredImage.localFile.childImageSharp.sizes,
	        backgroundColor: true,
	        style: imgStyles,
	        className: _projectHeroImageModule2.default.desktopFeaturedImg
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: featuredMobileImage.localFile.childImageSharp.sizes,
	        backgroundColor: true,
	        style: imgStyles,
	        className: _projectHeroImageModule2.default.mobileFeaturedImg
	      })
	    );
	  };
	
	  var renderHomeAnimation = function renderHomeAnimation() {
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: defaultImgStyles,
	        to: {
	          transform: returnSection === 'active' ? 'scale(1.05, 1.05)' : 'scale(1, 1)'
	        },
	        delay: 200,
	        config: { tension: 180, friction: 60 }
	      },
	      function (animation) {
	        return renderDefaultImages(animation);
	      }
	    );
	  };
	
	  var renderDefaultAnimation = function renderDefaultAnimation() {
	    return renderDefaultImages(defaultImgStyles);
	  };
	
	  var renderIEImages = function renderIEImages() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement('div', {
	        className: [(0, _emotion.css)(_templateObject, desktopFeaturedImgIE), _projectHeroImageModule2.default.desktopFeaturedImg, _projectHeroImageModule2.default.desktopFeaturedImgIE].join(' ')
	      }),
	      _react2.default.createElement('div', {
	        className: [(0, _emotion.css)(_templateObject, mobileFeaturedImg), _projectHeroImageModule2.default.mobileFeaturedImg, _projectHeroImageModule2.default.mobileFeaturedImgIE].join(' ')
	      })
	    );
	  };
	
	  var renderProjectHeroImages = function renderProjectHeroImages() {
	    if (isHome !== true) {
	      return renderDefaultAnimation();
	    } else {
	      return renderHomeAnimation();
	    }
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    browserDetect !== 'IE' ? renderProjectHeroImages() : renderIEImages()
	  );
	};
	
	exports.default = ProjectHeroImage;
	module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpring = __webpack_require__(8);
	
	var _projectHeroWipeModule = __webpack_require__(518);
	
	var _projectHeroWipeModule2 = _interopRequireDefault(_projectHeroWipeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectHeroWipe = function ProjectHeroWipe(_ref) {
	  var isHome = _ref.isHome;
	
	  if (isHome !== true) {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactSpring.Spring,
	        { from: { top: '0%' }, to: { top: '100%' }, delay: 300 },
	        function (animation) {
	          return _react2.default.createElement('div', { className: _projectHeroWipeModule2.default.heroWipe, style: animation });
	        }
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	exports.default = ProjectHeroWipe;
	module.exports = exports['default'];

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectHeroWrapperModule = __webpack_require__(519);
	
	var _projectHeroWrapperModule2 = _interopRequireDefault(_projectHeroWrapperModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectHeroWrapper = function (_Component) {
	  _inherits(ProjectHeroWrapper, _Component);
	
	  function ProjectHeroWrapper() {
	    _classCallCheck(this, ProjectHeroWrapper);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProjectHeroWrapper.prototype.render = function render() {
	    var _props = this.props,
	        browserDetect = _props.browserDetect,
	        headerHeight = _props.headerHeight;
	
	
	    var renderIOSHeight = browserDetect === 'iOS' ? 'calc(100vh - 74px)' : '100vh';
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _projectHeroWrapperModule2.default.wrapper,
	        style: typeof headerHeight !== 'undefined' ? {
	          height: 'calc(100% - ' + headerHeight + 'px)',
	          position: 'absolute',
	          bottom: 0,
	          left: 0,
	          right: 0
	        } : {
	          position: 'relative',
	          height: renderIOSHeight
	        }
	      },
	      this.props.children
	    );
	  };
	
	  return ProjectHeroWrapper;
	}(_react.Component);
	
	exports.default = ProjectHeroWrapper;
	module.exports = exports['default'];

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logos = __webpack_require__(48);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _projectLogoModule = __webpack_require__(521);
	
	var _projectLogoModule2 = _interopRequireDefault(_projectLogoModule);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectLogo = function ProjectLogo(_ref) {
	  var logoImage = _ref.logoImage,
	      slug = _ref.slug,
	      isHome = _ref.isHome,
	      returnSection = _ref.returnSection;
	
	  var animationConfig = {
	    delay: 600,
	    duration: 800,
	    easing: easings.easeCubicOut
	  };
	
	  var renderProjectLogo = function renderProjectLogo(animation) {
	    return _react2.default.createElement(
	      'div',
	      { style: animation, className: _projectLogoModule2.default.svg },
	      _react2.default.createElement(_logos2.default, { slug: slug })
	    );
	  };
	  var renderDefaultAnimation = function renderDefaultAnimation() {
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0 },
	        to: { opacity: 1 },
	        config: animationConfig
	      },
	      function (animation) {
	        return renderProjectLogo(animation);
	      }
	    );
	  };
	
	  var renderHomeAnimation = function renderHomeAnimation() {
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0 },
	        to: { opacity: returnSection === 'active' ? 1 : 0 },
	        config: animationConfig
	      },
	      function (animation) {
	        return renderProjectLogo(animation);
	      }
	    );
	  };
	
	  if (isHome !== true) {
	    return renderDefaultAnimation();
	  } else {
	    return renderHomeAnimation();
	  }
	};
	
	ProjectLogo.propTypes = {};
	
	exports.default = ProjectLogo;
	module.exports = exports['default'];

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(390), __esModule: true };

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(391), __esModule: true };

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(392), __esModule: true };

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(393), __esModule: true };

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(396), __esModule: true };

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(385)
	var ieee754 = __webpack_require__(716)
	var isArray = __webpack_require__(234)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 387 */,
/* 388 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
	function testPassiveEventListeners() {
	  if (!CAN_USE_DOM) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    var noop = function noop() {};
	    window.addEventListener('testPassiveEventSupport', noop, opts);
	    window.removeEventListener('testPassiveEventSupport', noop, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!canUsePassiveEventListeners()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}
	
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	function TargetEventHandlers(target) {
	  this.target = target;
	  this.events = {};
	}
	
	TargetEventHandlers.prototype.getEventHandlers = function () {
	  function getEventHandlers(eventName, options) {
	    var key = String(eventName) + ' ' + String(eventOptionsKey(options));
	
	    if (!this.events[key]) {
	      this.events[key] = {
	        handlers: [],
	        handleEvent: undefined
	      };
	      this.events[key].nextHandlers = this.events[key].handlers;
	    }
	
	    return this.events[key];
	  }
	
	  return getEventHandlers;
	}();
	
	TargetEventHandlers.prototype.handleEvent = function () {
	  function handleEvent(eventName, options, event) {
	    var eventHandlers = this.getEventHandlers(eventName, options);
	    eventHandlers.handlers = eventHandlers.nextHandlers;
	    eventHandlers.handlers.forEach(function (handler) {
	      if (handler) {
	        // We need to check for presence here because a handler function may
	        // cause later handlers to get removed. This can happen if you for
	        // instance have a waypoint that unmounts another waypoint as part of an
	        // onEnter/onLeave handler.
	        handler(event);
	      }
	    });
	  }
	
	  return handleEvent;
	}();
	
	TargetEventHandlers.prototype.add = function () {
	  function add(eventName, listener, options) {
	    var _this = this;
	
	    // options has already been normalized at this point.
	    var eventHandlers = this.getEventHandlers(eventName, options);
	
	    ensureCanMutateNextEventHandlers(eventHandlers);
	
	    if (eventHandlers.nextHandlers.length === 0) {
	      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	    }
	
	    eventHandlers.nextHandlers.push(listener);
	
	    var isSubscribed = true;
	    var unsubscribe = function () {
	      function unsubscribe() {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	        var index = eventHandlers.nextHandlers.indexOf(listener);
	        eventHandlers.nextHandlers.splice(index, 1);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          // All event handlers have been removed, so we want to remove the event
	          // listener from the target node.
	
	          if (_this.target) {
	            // There can be a race condition where the target may no longer exist
	            // when this function is called, e.g. when a React component is
	            // unmounting. Guarding against this prevents the following error:
	            //
	            //   Cannot read property 'removeEventListener' of undefined
	            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	          }
	
	          eventHandlers.handleEvent = undefined;
	        }
	      }
	
	      return unsubscribe;
	    }();
	    return unsubscribe;
	  }
	
	  return add;
	}();
	
	var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	// eslint-disable-next-line import/prefer-default-export
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
	  }
	  var normalizedEventOptions = normalizeEventOptions(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	exports.addEventListener = addEventListener;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(453);
	__webpack_require__(455);
	__webpack_require__(458);
	__webpack_require__(454);
	__webpack_require__(456);
	__webpack_require__(457);
	module.exports = __webpack_require__(45).Promise;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(25);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416);
	module.exports = __webpack_require__(25).Object.assign;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(417);
	var $Object = __webpack_require__(25).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(418);
	module.exports = __webpack_require__(25).Object.keys;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(419);
	module.exports = __webpack_require__(25).Object.setPrototypeOf;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(422);
	__webpack_require__(420);
	__webpack_require__(423);
	__webpack_require__(424);
	module.exports = __webpack_require__(25).Symbol;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(421);
	__webpack_require__(425);
	module.exports = __webpack_require__(148).f('iterator');


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(56);
	var toLength = __webpack_require__(414);
	var toAbsoluteIndex = __webpack_require__(413);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(79);
	var gOPS = __webpack_require__(141);
	var pIE = __webpack_require__(101);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(36).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(209);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(140);
	var descriptor = __webpack_require__(102);
	var setToStringTag = __webpack_require__(142);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(53)(IteratorPrototype, __webpack_require__(57)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(104)('meta');
	var isObject = __webpack_require__(54);
	var has = __webpack_require__(43);
	var setDesc = __webpack_require__(55).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(52)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(42);
	var getKeys = __webpack_require__(79);
	var gOPS = __webpack_require__(141);
	var pIE = __webpack_require__(101);
	var toObject = __webpack_require__(103);
	var IObject = __webpack_require__(213);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(52)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(55);
	var anObject = __webpack_require__(78);
	var getKeys = __webpack_require__(79);
	
	module.exports = __webpack_require__(42) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(56);
	var gOPN = __webpack_require__(216).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(43);
	var toObject = __webpack_require__(103);
	var IE_PROTO = __webpack_require__(143)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(51);
	var core = __webpack_require__(25);
	var fails = __webpack_require__(52);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(54);
	var anObject = __webpack_require__(78);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(210)(Function.call, __webpack_require__(215).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(145);
	var defined = __webpack_require__(137);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(145);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(145);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(398);
	var step = __webpack_require__(404);
	var Iterators = __webpack_require__(139);
	var toIObject = __webpack_require__(56);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(214)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(51);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(406) });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(51);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(140) });


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(103);
	var $keys = __webpack_require__(79);
	
	__webpack_require__(410)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(51);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(411).set });


/***/ }),
/* 420 */
/***/ (function(module, exports) {



/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(412)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(214)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(36);
	var has = __webpack_require__(43);
	var DESCRIPTORS = __webpack_require__(42);
	var $export = __webpack_require__(51);
	var redefine = __webpack_require__(218);
	var META = __webpack_require__(405).KEY;
	var $fails = __webpack_require__(52);
	var shared = __webpack_require__(144);
	var setToStringTag = __webpack_require__(142);
	var uid = __webpack_require__(104);
	var wks = __webpack_require__(57);
	var wksExt = __webpack_require__(148);
	var wksDefine = __webpack_require__(147);
	var enumKeys = __webpack_require__(400);
	var isArray = __webpack_require__(402);
	var anObject = __webpack_require__(78);
	var isObject = __webpack_require__(54);
	var toObject = __webpack_require__(103);
	var toIObject = __webpack_require__(56);
	var toPrimitive = __webpack_require__(146);
	var createDesc = __webpack_require__(102);
	var _create = __webpack_require__(140);
	var gOPNExt = __webpack_require__(408);
	var $GOPD = __webpack_require__(215);
	var $GOPS = __webpack_require__(141);
	var $DP = __webpack_require__(55);
	var $keys = __webpack_require__(79);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(216).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(101).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(100)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(53)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(147)('asyncIterator');


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(147)('observable');


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(415);
	var global = __webpack_require__(36);
	var hide = __webpack_require__(53);
	var Iterators = __webpack_require__(139);
	var TO_STRING_TAG = __webpack_require__(57)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(18)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(58)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(158);
	var toLength = __webpack_require__(229);
	var toAbsoluteIndex = __webpack_require__(447);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(107);
	var call = __webpack_require__(435);
	var isArrayIter = __webpack_require__(434);
	var anObject = __webpack_require__(44);
	var toLength = __webpack_require__(229);
	var getIterFn = __webpack_require__(451);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(156)('native-function-to-string', Function.toString);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(80) && !__webpack_require__(220)(function () {
	  return Object.defineProperty(__webpack_require__(151)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(106);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(82);
	var ITERATOR = __webpack_require__(18)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(44);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(440);
	var descriptor = __webpack_require__(226);
	var setToStringTag = __webpack_require__(154);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(58)(IteratorPrototype, __webpack_require__(18)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(18)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var macrotask = __webpack_require__(228).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(106)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(44);
	var dPs = __webpack_require__(441);
	var enumBugKeys = __webpack_require__(219);
	var IE_PROTO = __webpack_require__(155)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(151)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(221).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(110);
	var anObject = __webpack_require__(44);
	var getKeys = __webpack_require__(223);
	
	module.exports = __webpack_require__(80) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(109);
	var toObject = __webpack_require__(448);
	var IE_PROTO = __webpack_require__(155)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(109);
	var toIObject = __webpack_require__(158);
	var arrayIndexOf = __webpack_require__(428)(false);
	var IE_PROTO = __webpack_require__(155)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(83);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var dP = __webpack_require__(110);
	var DESCRIPTORS = __webpack_require__(80);
	var SPECIES = __webpack_require__(18)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(157);
	var defined = __webpack_require__(150);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(157);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(150);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(81);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(149);
	var ITERATOR = __webpack_require__(18)('iterator');
	var Iterators = __webpack_require__(82);
	module.exports = __webpack_require__(45).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(426);
	var step = __webpack_require__(438);
	var Iterators = __webpack_require__(82);
	var toIObject = __webpack_require__(158);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(222)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(149);
	var test = {};
	test[__webpack_require__(18)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(83)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(152);
	var global = __webpack_require__(17);
	var ctx = __webpack_require__(107);
	var classof = __webpack_require__(149);
	var $export = __webpack_require__(108);
	var isObject = __webpack_require__(81);
	var aFunction = __webpack_require__(105);
	var anInstance = __webpack_require__(427);
	var forOf = __webpack_require__(429);
	var speciesConstructor = __webpack_require__(227);
	var task = __webpack_require__(228).set;
	var microtask = __webpack_require__(439)();
	var newPromiseCapabilityModule = __webpack_require__(153);
	var perform = __webpack_require__(224);
	var userAgent = __webpack_require__(450);
	var promiseResolve = __webpack_require__(225);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(18)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(444)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(154)($Promise, PROMISE);
	__webpack_require__(445)(PROMISE);
	Wrapper = __webpack_require__(45)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(437)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(446)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(222)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(108);
	var core = __webpack_require__(45);
	var global = __webpack_require__(17);
	var speciesConstructor = __webpack_require__(227);
	var promiseResolve = __webpack_require__(225);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(108);
	var newPromiseCapability = __webpack_require__(153);
	var perform = __webpack_require__(224);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(452);
	var getKeys = __webpack_require__(223);
	var redefine = __webpack_require__(83);
	var global = __webpack_require__(17);
	var hide = __webpack_require__(58);
	var Iterators = __webpack_require__(82);
	var wks = __webpack_require__(18);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(247));
	var unitless = _interopDefault(__webpack_require__(249));
	var hashString = _interopDefault(__webpack_require__(246));
	var Stylis = _interopDefault(__webpack_require__(248));
	var stylisRuleSheet = _interopDefault(__webpack_require__(875));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        if (false) {
	          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
	        }
	
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	    this.tags = [];
	    this.ctr = 0;
	    this.opts = options;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.inject = function inject() {
	    if (this.injected) {
	      throw new Error('already injected!');
	    }
	
	    this.tags[0] = makeStyleTag(this.opts);
	    this.injected = true;
	  };
	
	  _proto.speedy = function speedy(bool) {
	    if (this.ctr !== 0) {
	      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	      throw new Error("cannot change speedy now");
	    }
	
	    this.isSpeedy = !!bool;
	  };
	
	  _proto.insert = function insert(rule, sourceMap) {
	    // this is the ultrafast version, works across browsers
	    if (this.isSpeedy) {
	      var tag = this.tags[this.tags.length - 1];
	      var sheet = sheetForTag(tag);
	
	      try {
	        sheet.insertRule(rule, sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn('illegal rule', rule); // eslint-disable-line no-console
	        }
	      }
	    } else {
	      var _tag = makeStyleTag(this.opts);
	
	      this.tags.push(_tag);
	
	      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	    }
	
	    this.ctr++;
	
	    if (this.ctr % 65000 === 0) {
	      this.tags.push(makeStyleTag(this.opts));
	    }
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	    this.injected = false;
	  };
	
	  return StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (context.__SECRET_EMOTION__ !== undefined) {
	    return context.__SECRET_EMOTION__;
	  }
	
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var caches = {
	    registered: {},
	    inserted: {},
	    nonce: options.nonce,
	    key: key
	  };
	  var sheet = new StyleSheet(options);
	
	  if (isBrowser) {
	    // 🚀
	    sheet.inject();
	  }
	
	  var stylis = new Stylis(stylisOptions);
	  stylis.use(options.stylisPlugins)(insertionPlugin);
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation.__emotion_styles !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        if (this === undefined && ("production") !== 'production') {
	          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    if (Array.isArray(obj)) {
	      obj.forEach(function (interpolation) {
	        string += handleInterpolation.call(this, interpolation, false);
	      }, this);
	    } else {
	      Object.keys(obj).forEach(function (key) {
	        if (typeof obj[key] !== 'object') {
	          if (caches.registered[obj[key]] !== undefined) {
	            string += key + "{" + caches.registered[obj[key]] + "}";
	          } else {
	            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	          }
	        } else {
	          if (key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
	            obj[key].forEach(function (value) {
	              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
	            });
	          } else {
	            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	          }
	        }
	      }, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var stylesWithLabel;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createClassName = function createClassName(styles, identifierName) {
	    return hashString(styles + identifierName) + identifierName;
	  };
	
	  if (false) {
	    var oldCreateClassName = createClassName;
	    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
	
	    createClassName = function createClassName(styles, identifierName) {
	      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
	        currentSourceMap = sourceMap;
	        return '';
	      }), identifierName);
	    };
	  }
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    stylesWithLabel = styles;
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = createClassName(styles, identifierName);
	    return styles;
	  };
	
	  if (false) {
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = stylesWithLabel;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, function (node) {
	      // $FlowFixMe
	      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	    });
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  context.__SECRET_EMOTION__ = emotion;
	  return emotion;
	}
	
	module.exports = createEmotion;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(111);
	
	var emptyObject = __webpack_require__(573);
	var _invariant = __webpack_require__(574);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(460);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(62);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(160));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(62);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(160));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(62);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(230));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(62);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(230));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(62);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(160));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(470);
	var each = __webpack_require__(231).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(468);
	var Util = __webpack_require__(231);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(469);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-form-form-buttons-form-submit----form-submit-module---wrapper---3cAsP","submit":"src-components-form-form-buttons-form-submit----form-submit-module---submit---1Apl0"};

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gradientBlock":"src-components-gradient-bg-transition-gradients----gradients-module---gradientBlock---13bdJ"};

/***/ }),
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-hero-hero-bg-image----hero-bg-image-module---wrapper---O_Ofh"};

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"copy":"src-components-hero-hero-message----hero-message-module---copy---3mXw4"};

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"message":"src-components-project-project-blurb----project-blurb-module---message---3khZK"};

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"src-components-project-project-button----project-button-module---link---2Atqc"};

/***/ }),
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"preTitle":"src-components-project-project-hero-project-breadcrumb----project-breadcrumb-module---preTitle---2jbQc","link":"src-components-project-project-hero-project-breadcrumb----project-breadcrumb-module---link---2Hy0c","title":"src-components-project-project-hero-project-breadcrumb----project-breadcrumb-module---title---h4hND","pageTitle":"src-components-project-project-hero-project-breadcrumb----project-breadcrumb-module---pageTitle---FbbEP","dash":"src-components-project-project-hero-project-breadcrumb----project-breadcrumb-module---dash---3ZEx3"};

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-components-project-project-hero-project-headline----project-headline-module---content---27nF1"};

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobileFeaturedImg":"src-components-project-project-hero-project-hero-image----project-hero-image-module---mobileFeaturedImg---2YV_j","desktopFeaturedImg":"src-components-project-project-hero-project-hero-image----project-hero-image-module---desktopFeaturedImg---2H4Ym","desktopFeaturedImgIE":"src-components-project-project-hero-project-hero-image----project-hero-image-module---desktopFeaturedImgIE---3r6la","mobileFeaturedImgIE":"src-components-project-project-hero-project-hero-image----project-hero-image-module---mobileFeaturedImgIE---3Lg0P"};

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heroWipe":"src-components-project-project-hero-project-hero-wipe----project-hero-wipe-module---heroWipe---i1L6D"};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-project-project-hero-project-hero-wrapper----project-hero-wrapper-module---wrapper---NcM7B"};

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-project-project-hero----project-hero-module---container---1xo5O","content":"src-components-project-project-hero----project-hero-module---content---_9cyQ"};

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"svg":"src-components-project-project-hero-project-logo----project-logo-module---svg---2hDNJ"};

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoWrapper":"src-components-project-project-video-loop----project-video-loop-module---videoWrapper---3WPe2"};

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"align":"src-components-scroll-down----scroll-down-module---align---Uok1H","wrapper":"src-components-scroll-down----scroll-down-module---wrapper---2ho70","direction":"src-components-scroll-down----scroll-down-module---direction---27sx5","directionWhite":"src-components-scroll-down----scroll-down-module---directionWhite---2KSVc","lineAlign":"src-components-scroll-down----scroll-down-module---lineAlign---7yTcz","lineWrapper":"src-components-scroll-down----scroll-down-module---lineWrapper---25soG","bounce":"src-components-scroll-down----scroll-down-module---bounce---2gLvr","line":"src-components-scroll-down----scroll-down-module---line---1ky_b","scroll-down-line":"src-components-scroll-down----scroll-down-module---scroll-down-line---2dgL4","lineWhite":"src-components-scroll-down----scroll-down-module---lineWhite---2dbpy"};

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"copy":"src-components-section-message----section-message-module---copy---3v6ER","copySecondary":"src-components-section-message----section-message-module---copySecondary---XftOD","wrapper":"src-components-section-message----section-message-module---wrapper---2TbUv"};

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"copy":"src-components-section-title----section-title-module---copy---35vJ5"};

/***/ }),
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-slider-slider-navigation----slider-navigation-module---wrapper---8RchC","csNav":"src-components-slider-slider-navigation----slider-navigation-module---csNav---2DoHS","numbered":"src-components-slider-slider-navigation----slider-navigation-module---numbered---3AjuW"};

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(111),r=__webpack_require__(867);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
	function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
	return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
	function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
	function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
	function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
	n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
	var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
	function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
	function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
	var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
	!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
	function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
	function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
	var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
	60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
	function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
	function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
	sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
	function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
	function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
	function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
	function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
	var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
	var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
	function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
	function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
	a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
	var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
	zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
	function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
	function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
	function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
	if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
	function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
	function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
	var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
	case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
	function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
	function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
	function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
	function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
	function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
	!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
	function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
	function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
	function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
	function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
	function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
	function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
	14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
	function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
	function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
	b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
	function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
	function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
	sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
	function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
	function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
	function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
	function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
	hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
	q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
	for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
	w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
	function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
	var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
	function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
	function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
	function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
	function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
	function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
	var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
	useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
	lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
	b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
	function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
	var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
	function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
	function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
	null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
	function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
	function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
	function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
	function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
	nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
	var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
	function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
	function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
	2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
	function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
	var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
	function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
	function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
	function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
	e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
	function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
	function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
	f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
	b>c?b:c;0===b&&(Fh=null);$h(a,b)}
	function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
	p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
	m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
	Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
	function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
	h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
	function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
	(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
	function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
	function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
	function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
	function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
	function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
	function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
	function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
	function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
	function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
	function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
	Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
	function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
	Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
	function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
	function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
	function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
	var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
	x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
	X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(111),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 706 */,
/* 707 */,
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(77);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(98);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(97);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(113);
	
	var _scrollBehavior = __webpack_require__(868);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StateStorage = __webpack_require__(710);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _propTypes2.default.object.isRequired
	};
	
	var ScrollContext = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContext, _React$Component);
	
	  function ScrollContext(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContext);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.registerElement = function (key, element, shouldUpdateScroll) {
	      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
	    };
	
	    _this.unregisterElement = function (key) {
	      _this.scrollBehavior.unregisterElement(key);
	    };
	
	    var history = props.history;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: history.listen,
	      stateStorage: new _StateStorage2.default(),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
	    return _this;
	  }
	
	  ScrollContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history;
	
	    var prevLocation = prevProps.location;
	
	    if (location === prevLocation) {
	      return;
	    }
	
	    var prevRouterProps = {
	      history: prevProps.history,
	      location: prevProps.location
	
	      // The "scroll-behavior" package expects the "action" to be on the location
	      // object so let's copy it over.
	    };location.action = history.action;
	    this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
	  };
	
	  ScrollContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollContext.prototype.getRouterProps = function getRouterProps() {
	    var _props2 = this.props,
	        history = _props2.history,
	        location = _props2.location;
	
	    return { history: history, location: location };
	  };
	
	  ScrollContext.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScrollContext;
	}(_react2.default.Component);
	
	ScrollContext.propTypes = propTypes;
	ScrollContext.childContextTypes = childContextTypes;
	
	exports.default = (0, _reactRouterDom.withRouter)(ScrollContext);

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(77);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(98);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(97);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(59);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(948);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  scrollKey: _propTypes2.default.string.isRequired,
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _propTypes2.default.object
	
	  /* eslint-disable react/no-deprecated */
	};
	var ScrollContainer = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, "<ScrollContainer> does not support changing scrollKey.") : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(this.domNode === prevDomNode, "<ScrollContainer> does not support changing DOM node.") : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	/* eslint-enable */
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _stringify = __webpack_require__(378);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(77);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_KEY_PREFIX = "@@scroll|";
	var GATSBY_ROUTER_SCROLL_STATE = "___GATSBY_REACT_ROUTER_SCROLL";
	
	var SessionStorage = function () {
	  function SessionStorage() {
	    (0, _classCallCheck3.default)(this, SessionStorage);
	  }
	
	  SessionStorage.prototype.read = function read(location, key) {
	    var stateKey = this.getStateKey(location, key);
	
	    try {
	      var value = window.sessionStorage.getItem(stateKey);
	      return JSON.parse(value);
	    } catch (e) {
	      console.warn("[gatsby-react-router-scroll] Unable to access sessionStorage; sessionStorage is not available.");
	
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE] && window[GATSBY_ROUTER_SCROLL_STATE][stateKey]) {
	        return window[GATSBY_ROUTER_SCROLL_STATE][stateKey];
	      }
	
	      return {};
	    }
	  };
	
	  SessionStorage.prototype.save = function save(location, key, value) {
	    var stateKey = this.getStateKey(location, key);
	    var storedValue = (0, _stringify2.default)(value);
	
	    try {
	      window.sessionStorage.setItem(stateKey, storedValue);
	    } catch (e) {
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE]) {
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      } else {
	        window[GATSBY_ROUTER_SCROLL_STATE] = {};
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      }
	
	      console.warn("[gatsby-react-router-scroll] Unable to save state in sessionStorage; sessionStorage is not available.");
	    }
	  };
	
	  SessionStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var stateKeyBase = "" + STATE_KEY_PREFIX + location.pathname;
	    return key === null || typeof key === "undefined" ? stateKeyBase : stateKeyBase + "|" + key;
	  };
	
	  return SessionStorage;
	}();
	
	exports.default = SessionStorage;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ScrollBehaviorContext = __webpack_require__(708);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	var _ScrollContainer = __webpack_require__(709);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer2.default;
	exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(n){return n&&"object"==typeof n&&"default"in n?n.default:n}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(864)),valueEqual=_interopDefault(__webpack_require__(947));__webpack_require__(942);var invariant=_interopDefault(__webpack_require__(941));function _extends(){return(_extends=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(n[a]=e[a])}return n}).apply(this,arguments)}function addLeadingSlash(n){return"/"===n.charAt(0)?n:"/"+n}function stripLeadingSlash(n){return"/"===n.charAt(0)?n.substr(1):n}function hasBasename(n,t){return new RegExp("^"+t+"(\\/|\\?|#|$)","i").test(n)}function stripBasename(n,t){return hasBasename(n,t)?n.substr(t.length):n}function stripTrailingSlash(n){return"/"===n.charAt(n.length-1)?n.slice(0,-1):n}function parsePath(n){var t=n||"/",e="",a="",o=t.indexOf("#");-1!==o&&(a=t.substr(o),t=t.substr(0,o));var r=t.indexOf("?");return-1!==r&&(e=t.substr(r),t=t.substr(0,r)),{pathname:t,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(n){var t=n.pathname,e=n.search,a=n.hash,o=t||"/";return e&&"?"!==e&&(o+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(o+="#"===a.charAt(0)?a:"#"+a),o}function createLocation(n,t,e,a){var o;"string"==typeof n?(o=parsePath(n)).state=t:(void 0===(o=_extends({},n)).pathname&&(o.pathname=""),o.search?"?"!==o.search.charAt(0)&&(o.search="?"+o.search):o.search="",o.hash?"#"!==o.hash.charAt(0)&&(o.hash="#"+o.hash):o.hash="",void 0!==t&&void 0===o.state&&(o.state=t));try{o.pathname=decodeURI(o.pathname)}catch(n){throw n instanceof URIError?new URIError('Pathname "'+o.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):n}return e&&(o.key=e),a?o.pathname?"/"!==o.pathname.charAt(0)&&(o.pathname=resolvePathname(o.pathname,a.pathname)):o.pathname=a.pathname:o.pathname||(o.pathname="/"),o}function locationsAreEqual(n,t){return n.pathname===t.pathname&&n.search===t.search&&n.hash===t.hash&&n.key===t.key&&valueEqual(n.state,t.state)}function createTransitionManager(){var r=null;var a=[];return{setPrompt:function(n){return r=n,function(){r===n&&(r=null)}},confirmTransitionTo:function(n,t,e,a){if(null!=r){var o="function"==typeof r?r(n,t):r;"string"==typeof o?"function"==typeof e?e(o,a):a(!0):a(!1!==o)}else a(!0)},appendListener:function(n){var t=!0;function e(){t&&n.apply(void 0,arguments)}return a.push(e),function(){t=!1,a=a.filter(function(n){return n!==e})}},notifyListeners:function(){for(var n=arguments.length,t=new Array(n),e=0;e<n;e++)t[e]=arguments[e];a.forEach(function(n){return n.apply(void 0,t)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(n,t){t(window.confirm(n))}function supportsHistory(){var n=window.navigator.userAgent;return(-1===n.indexOf("Android 2.")&&-1===n.indexOf("Android 4.0")||-1===n.indexOf("Mobile Safari")||-1!==n.indexOf("Chrome")||-1!==n.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(n){void 0===n.state&&navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(n){return{}}}function createBrowserHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var c=window.history,s=supportsHistory(),t=!supportsPopStateOnHashChange(),e=n,a=e.forceRefresh,h=void 0!==a&&a,o=e.getUserConfirmation,u=void 0===o?getConfirmation:o,r=e.keyLength,i=void 0===r?6:r,f=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"";function l(n){var t=n||{},e=t.key,a=t.state,o=window.location,r=o.pathname+o.search+o.hash;return f&&(r=stripBasename(r,f)),createLocation(r,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(n){_extends(T,n),T.length=c.length,v.notifyListeners(T.location,T.action)}function g(n){isExtraneousPopstateEvent(n)||w(l(n.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(t){if(m)m=!1,p();else{v.confirmTransitionTo(t,"POP",u,function(n){n?p({action:"POP",location:t}):function(n){var t=T.location,e=H.indexOf(t.key);-1===e&&(e=0);var a=H.indexOf(n.key);-1===a&&(a=0);var o=e-a;o&&(m=!0,L(o))}(t)})}}var y=l(getHistoryState()),H=[y.key];function x(n){return f+createPath(n)}function L(n){c.go(n)}var O=0;function E(n){1===(O+=n)&&1===n?(window.addEventListener(PopStateEvent,g),t&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),t&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:c.length,action:"POP",location:y,createHref:x,push:function(n,t){var i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.pushState({key:e,state:a},null,t),h)window.location.href=t;else{var o=H.indexOf(T.location.key),r=H.slice(0,-1===o?0:o+1);r.push(i.key),H=r,p({action:"PUSH",location:i})}else window.location.href=t}})},replace:function(n,t){var r="REPLACE",i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,r,u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.replaceState({key:e,state:a},null,t),h)window.location.replace(t);else{var o=H.indexOf(T.location.key);-1!==o&&(H[o]=i.key),p({action:r,location:i})}else window.location.replace(t)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(n){void 0===n&&(n=!1);var t=v.setPrompt(n);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),t()}},listen:function(n){var t=v.appendListener(n);return E(1),function(){E(-1),t()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(n){return"!"===n.charAt(0)?n:"!/"+stripLeadingSlash(n)},decodePath:function(n){return"!"===n.charAt(0)?n.substr(1):n}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function getHashPath(){var n=window.location.href,t=n.indexOf("#");return-1===t?"":n.substring(t+1)}function pushHashPath(n){window.location.hash=n}function replaceHashPath(n){var t=window.location.href.indexOf("#");window.location.replace(window.location.href.slice(0,0<=t?t:0)+"#"+n)}function createHashHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var t=window.history,e=(supportsGoWithoutReloadUsingHash(),n),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,o=e.hashType,r=void 0===o?"slash":o,c=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"",s=HashPathCoders[r],h=s.encodePath,u=s.decodePath;function f(){var n=u(getHashPath());return c&&(n=stripBasename(n,c)),createLocation(n)}var l=createTransitionManager();function d(n){_extends(E,n),E.length=t.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var n=getHashPath(),t=h(n);if(n!==t)replaceHashPath(t);else{var e=f(),a=E.location;if(!v&&locationsAreEqual(a,e))return;if(p===createPath(e))return;p=null,function(t){if(v)v=!1,d();else{l.confirmTransitionTo(t,"POP",i,function(n){n?d({action:"POP",location:t}):function(n){var t=E.location,e=y.lastIndexOf(createPath(t));-1===e&&(e=0);var a=y.lastIndexOf(createPath(n));-1===a&&(a=0);var o=e-a;o&&(v=!0,H(o))}(t)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(n){t.go(n)}var x=0;function L(n){1===(x+=n)&&1===n?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:t.length,action:"POP",location:w,createHref:function(n){return"#"+h(c+createPath(n))},push:function(n,t){var r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,"PUSH",i,function(n){if(n){var t=createPath(r),e=h(c+t);if(getHashPath()!==e){p=t,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),o=y.slice(0,-1===a?0:a+1);o.push(t),y=o,d({action:"PUSH",location:r})}else d()}})},replace:function(n,t){var o="REPLACE",r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,o,i,function(n){if(n){var t=createPath(r),e=h(c+t);getHashPath()!==e&&(p=t,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=t),d({action:o,location:r})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(n){void 0===n&&(n=!1);var t=l.setPrompt(n);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),t()}},listen:function(n){var t=l.appendListener(n);return L(1),function(){L(-1),t()}}};return E}function clamp(n,t,e){return Math.min(Math.max(n,t),e)}function createMemoryHistory(n){void 0===n&&(n={});var t=n,o=t.getUserConfirmation,e=t.initialEntries,a=void 0===e?["/"]:e,r=t.initialIndex,i=void 0===r?0:r,c=t.keyLength,s=void 0===c?6:c,h=createTransitionManager();function u(n){_extends(g,n),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,s)}var l=clamp(i,0,a.length-1),d=a.map(function(n){return createLocation(n,void 0,"string"==typeof n?f():n.key||f())}),v=createPath;function p(n){var t=clamp(g.index+n,0,g.entries.length-1),e=g.entries[t];h.confirmTransitionTo(e,"POP",o,function(n){n?u({action:"POP",location:e,index:t}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(n,t){var a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,"PUSH",o,function(n){if(n){var t=g.index+1,e=g.entries.slice(0);e.length>t?e.splice(t,e.length-t,a):e.push(a),u({action:"PUSH",location:a,index:t,entries:e})}})},replace:function(n,t){var e="REPLACE",a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,e,o,function(n){n&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(n){var t=g.index+n;return 0<=t&&t<g.entries.length},block:function(n){return void 0===n&&(n=!1),h.setPrompt(n)},listen:function(n){return h.appendListener(n)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(714)('createBrowserHistory');
	module.exports = __webpack_require__(29).createBrowserHistory;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(format, subs) {
	    var index = 0;
	    var message =
	      'Warning: ' +
	      (subs.length > 0
	        ? format.replace(/%s/g, function() {
	            return subs[index++];
	          })
	        : format);
	
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	
	    try {
	      // --- Welcome to debugging history ---
	      // This error was thrown as a convenience so that you can use the
	      // stack trace to find the callsite that triggered this warning.
	      throw new Error(message);
	    } catch (e) {}
	  };
	}
	
	module.exports = function(member) {
	  printWarning(
	    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
	      'Support for the latter will be removed in the next major release.',
	    [member, member]
	  );
	};


/***/ }),
/* 715 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 717 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ }),
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(873);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 823 */,
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(825);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(111);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var iconContext_1 = __webpack_require__(236);
	function Tree2Element(tree) {
	    return tree && tree.map(function (node, i) { return React.createElement(node.tag, __assign({ key: i }, node.attr), Tree2Element(node.child)); });
	}
	function GenIcon(data) {
	    return function (props) { return (React.createElement(IconBase, __assign({ attr: __assign({}, data.attr) }, props), Tree2Element(data.child))); };
	}
	exports.GenIcon = GenIcon;
	function IconBase(props) {
	    var elem = function (conf) {
	        var computedSize = props.size || conf.size || "1em";
	        var className;
	        if (conf.className)
	            className = conf.className;
	        if (props.className)
	            className = (className ? className + ' ' : '') + props.className;
	        var attr = props.attr, title = props.title, svgProps = __rest(props, ["attr", "title"]);
	        return (React.createElement("svg", __assign({ stroke: "currentColor", fill: "currentColor", strokeWidth: "0" }, conf.attr, attr, svgProps, { className: className, style: __assign({ color: props.color || conf.color }, conf.style, props.style), height: computedSize, width: computedSize, xmlns: "http://www.w3.org/2000/svg" }),
	            title && React.createElement("title", null, title),
	            props.children));
	    };
	    return iconContext_1.IconContext !== undefined
	        ? React.createElement(iconContext_1.IconContext.Consumer, null, function (conf) { return elem(conf); })
	        : elem(iconContext_1.DefaultContext);
	}
	exports.IconBase = IconBase;


/***/ }),
/* 832 */
/***/ (function(module, exports) {

	module.exports.IconsManifest = [
	  {
	    "id": "fa",
	    "name": "Font Awesome",
	    "projectUrl": "https://fontawesome.com/",
	    "license": "CC BY 4.0 License",
	    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
	  },
	  {
	    "id": "io",
	    "name": "Ionicons",
	    "projectUrl": "https://ionicons.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
	  },
	  {
	    "id": "md",
	    "name": "Material Design icons",
	    "projectUrl": "http://google.github.io/material-design-icons/",
	    "license": "Apache License Version 2.0",
	    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
	  },
	  {
	    "id": "ti",
	    "name": "Typicons",
	    "projectUrl": "http://s-ings.com/typicons/",
	    "license": "CC BY-SA 3.0",
	    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
	  },
	  {
	    "id": "go",
	    "name": "Github Octicons icons",
	    "projectUrl": "https://octicons.github.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
	  },
	  {
	    "id": "fi",
	    "name": "Feather",
	    "projectUrl": "https://feathericons.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
	  },
	  {
	    "id": "gi",
	    "name": "Game Icons",
	    "projectUrl": "https://game-icons.net/",
	    "license": "CC BY 3.0",
	    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
	  },
	  {
	    "id": "wi",
	    "name": "Weather Icons",
	    "projectUrl": "https://erikflowers.github.io/weather-icons/",
	    "license": "SIL OFL 1.1",
	    "licenseUrl": "http://scripts.sil.org/OFL"
	  },
	  {
	    "id": "di",
	    "name": "Devicons",
	    "projectUrl": "https://vorillaz.github.io/devicons/",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  }
	]

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(833);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 835 */,
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(239);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(29);
	
	var _Router = __webpack_require__(175);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(239);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(29);
	
	var _Router = __webpack_require__(175);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(847);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(238);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(237);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(848);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(849);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(850);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(851);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(241);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(177);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(852);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(29);
	
	var _Router = __webpack_require__(176);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(29);
	
	var _generatePath = __webpack_require__(241);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(29);
	
	var _Router = __webpack_require__(176);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(177);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(715);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(240);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(472));
	var shallowEqual = _interopDefault(__webpack_require__(872));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(99);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(99);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(59);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(857);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(822);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(99);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(114);
	
	var _track = __webpack_require__(860);
	
	var _dots = __webpack_require__(856);
	
	var _arrows = __webpack_require__(854);
	
	var _resizeObserverPolyfill = __webpack_require__(243);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	      // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(858);
	
	var _json2mq = __webpack_require__(821);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(855);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(471);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(99);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ }),
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(386)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 866 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(866);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(462);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(463);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(464);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(465);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(466);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(869);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._restoreScrollRestoration = function () {
	      /* istanbul ignore if: not supported by any browsers on Travis */
	      if (_this._oldScrollRestoration) {
	        try {
	          window.history.scrollRestoration = _this._oldScrollRestoration;
	        } catch (e) {
	          /* silence */
	        }
	      }
	    };
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget,
	            xTarget = _windowScrollTarget[0],
	            yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore else: Travis browsers all support this */
	    if ('scrollRestoration' in window.history &&
	    // Unfortunately, Safari on iOS freezes for 2-6s after the user swipes to
	    // navigate through history with scrollRestoration being 'manual', so we
	    // need to detect this browser and exclude it from the following code
	    // until this bug is fixed by Apple.
	    !(0, _utils.isMobileSafari)()) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      try {
	        window.history.scrollRestoration = 'manual';
	
	        // Scroll restoration persists across page reloads. We want to reset
	        // this to the original value, so that we can let the browser handle
	        // restoring the initial scroll position on server-rendered pages.
	        (0, _on2.default)(window, 'beforeunload', this._restoreScrollRestoration);
	      } catch (e) {
	        this._oldScrollRestoration = null;
	      }
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	      _this._saveWindowPositionHandle = null;
	
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	        _requestAnimationFrame2.default.cancel(scrollElement.savePositionHandle);
	        scrollElement.savePositionHandle = null;
	
	        // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame2.default)(saveElementPosition);
	        }
	      }
	    };
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on2.default)(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var _scrollElements$key = this._scrollElements[key],
	        element = _scrollElements$key.element,
	        onScroll = _scrollElements$key.onScroll,
	        savePositionHandle = _scrollElements$key.savePositionHandle;
	
	
	    (0, _off2.default)(element, 'scroll', onScroll);
	    _requestAnimationFrame2.default.cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.stop = function stop() {
	    this._restoreScrollRestoration();
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	    this._checkWindowScrollHandle = null;
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key2 = this._scrollElements[key],
	        element = _scrollElements$key2.element,
	        shouldUpdateScroll = _scrollElements$key2.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	    return [0, 0];
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  ScrollBehavior.prototype._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  ScrollBehavior.prototype.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      }
	
	      // Fallback to scrolling to top when target fragment doesn't exist.
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	
	    (0, _scrollLeft2.default)(element, left);
	    (0, _scrollTop2.default)(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobileSafari = isMobileSafari;
	function isMobileSafari() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent)
	  );
	}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(174)))

/***/ }),
/* 871 */,
/* 872 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 873 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(865).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(244)(module)))

/***/ }),
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BrandingMessaging (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Branding Messaging"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"home","transform":"translate(-159.000000, -3687.000000)"},React.createElement("g",{"id":"Group-11","transform":"translate(159.000000, 3687.000000)"},[React.createElement("path",{"d":"M47,4.47619048 C23.5522222,4.47619048 4.47619048,23.5522222 4.47619048,47 C4.47619048,70.4477778 23.5522222,89.5238095 47,89.5238095 C70.4477778,89.5238095 89.5238095,70.4477778 89.5238095,47 C89.5238095,23.5522222 70.4477778,4.47619048 47,4.47619048 M47,94 C21.0843492,94 0,72.9156508 0,47 C0,21.0843492 21.0843492,0 47,0 C72.9156508,0 94,21.0843492 94,47 C94,72.9156508 72.9156508,94 47,94","id":"Fill-1","fill":"#2AD9C7","key":0}),React.createElement("path",{"d":"M47,16.4680851 C30.165,16.4680851 16.4680851,30.165 16.4680851,47 C16.4680851,63.835 30.165,77.5319149 47,77.5319149 C63.835,77.5319149 77.5319149,63.835 77.5319149,47 C77.5319149,30.165 63.835,16.4680851 47,16.4680851 M47,82 C27.7008511,82 12,66.2991489 12,47 C12,27.7008511 27.7008511,12 47,12 C66.2991489,12 82,27.7008511 82,47 C82,66.2991489 66.2991489,82 47,82","id":"Fill-3","fill":"#2AD9C7","key":1}),React.createElement("path",{"d":"M47,28.4516129 C36.7724194,28.4516129 28.4516129,36.7724194 28.4516129,47 C28.4516129,57.2275806 36.7724194,65.5483871 47,65.5483871 C57.2275806,65.5483871 65.5483871,57.2275806 65.5483871,47 C65.5483871,36.7724194 57.2275806,28.4516129 47,28.4516129 M47,70 C34.3180968,70 24,59.6826452 24,47 C24,34.3173548 34.3180968,24 47,24 C59.6819032,24 70,34.3173548 70,47 C70,59.6826452 59.6819032,70 47,70","id":"Fill-5","fill":"#2AD9C7","key":2}),React.createElement("path",{"d":"M47,40.4 C43.3612,40.4 40.4,43.3604667 40.4,47 C40.4,50.6395333 43.3612,53.6 47,53.6 C50.6388,53.6 53.6,50.6395333 53.6,47 C53.6,43.3604667 50.6388,40.4 47,40.4 M47,58 C40.9346,58 36,53.0654 36,47 C36,40.9346 40.9346,36 47,36 C53.0654,36 58,40.9346 58,47 C58,53.0654 53.0654,58 47,58","id":"Fill-7","fill":"#2AD9C7","key":3}),React.createElement("polygon",{"id":"Fill-9","fill":"#FFFFFF","points":"115.362278 48.7000926 115.362278 44.2999074 112.755594 44.2999074 117 40.110931 113.847905 37 106.451403 44.2999074 104.396077 44.2999074 108.640482 40.110931 105.488387 37 98.0918857 44.2999074 47 44.2999074 47 48.7000926 98.0911426 48.7000926 105.487644 56 108.639739 52.889069 104.395334 48.7000926 106.45066 48.7000926 113.847161 56 116.999257 52.889069 112.754851 48.7000926","key":4})])))]);
	}
	
	BrandingMessaging.defaultProps = {"width":"117px","height":"94px","viewBox":"0 0 117 94","version":"1.1"};
	
	module.exports = BrandingMessaging;
	
	BrandingMessaging.default = BrandingMessaging;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Digital (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Digital"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("polygon",{"id":"path-1","points":"0 106 118 106 118 0 0 0"})),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"home","transform":"translate(-454.000000, -3679.000000)"},React.createElement("g",{"id":"Group-9","transform":"translate(454.000000, 3679.000000)"},[React.createElement("path",{"d":"M11.2025316,4.47058824 C7.49598734,4.47058824 4.48101266,7.47854902 4.48101266,11.1764706 L4.48101266,64.8235294 C4.48101266,68.521451 7.49598734,71.5294118 11.2025316,71.5294118 L106.797468,71.5294118 C110.504013,71.5294118 113.518987,68.521451 113.518987,64.8235294 L113.518987,11.1764706 C113.518987,7.47854902 110.504013,4.47058824 106.797468,4.47058824 L11.2025316,4.47058824 Z M106.797468,76 L11.2025316,76 C5.0254557,76 0,70.9862353 0,64.8235294 L0,11.1764706 C0,5.01376471 5.0254557,0 11.2025316,0 L106.797468,0 C112.974544,0 118,5.01376471 118,11.1764706 L118,64.8235294 C118,70.9862353 112.974544,76 106.797468,76 L106.797468,76 Z","id":"Fill-1","fill":"#2AD9C7","key":0}),React.createElement("path",{"d":"M40.4512548,101.565217 L76.5851166,101.565217 L71.6230199,76.4347826 L45.583332,76.4347826 L40.4512548,101.565217 Z M82,106 L35,106 L41.9447085,72 L75.2868807,72 L82,106 Z","id":"Fill-3","fill":"#FFFFFF","key":1}),React.createElement("mask",{"id":"mask-2","fill":"white","key":2},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("g",{"id":"Clip-6","key":3}),React.createElement("polygon",{"id":"Fill-5","fill":"#FFFFFF","mask":"url(#mask-2)","points":"2 64 116 64 116 60 2 60","key":4}),React.createElement("path",{"d":"M37.4571429,44.5652174 L80.5428571,44.5652174 L80.5428571,19.4347826 L37.4571429,19.4347826 L37.4571429,44.5652174 Z M33,49 L85,49 L85,15 L33,15 L33,49 Z","id":"Fill-7","fill":"#FFFFFF","mask":"url(#mask-2)","key":5}),React.createElement("path",{"d":"M57.3537415,30.0586165 L57.3537415,33.9413835 L60.4608617,32 L57.3537415,30.0586165 Z M53,42 L53,22 L69,32 L53,42 Z","id":"Fill-8","fill":"#FFFFFF","mask":"url(#mask-2)","key":6})])))]);
	}
	
	Digital.defaultProps = {"width":"118px","height":"106px","viewBox":"0 0 118 106","version":"1.1"};
	
	module.exports = Digital;
	
	Digital.default = Digital;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function EmployeeExperience (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Employee Experience"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},[React.createElement("polygon",{"id":"path-1","points":"0 0.4425 79.6261682 0.4425 79.6261682 71.9736 0 71.9736","key":0}),React.createElement("polygon",{"id":"path-3","points":"0.124249541 0.455654082 81 0.455654082 81 72.9997765 0.124249541 72.9997765","key":1})]),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"home","transform":"translate(-772.000000, -3672.000000)"},React.createElement("g",{"id":"Group-7","transform":"translate(772.000000, 3672.000000)"},[React.createElement("g",{"id":"Group-3","key":0},[React.createElement("mask",{"id":"mask-2","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("g",{"id":"Clip-2","key":1}),React.createElement("path",{"d":"M39.8130841,4.94235 C20.3334579,4.94235 4.48598131,17.21685 4.48598131,32.30385 C4.48598131,41.50185 10.4328972,50.0391 20.3940187,55.14135 L21.7099065,55.8156 L21.6119626,57.29385 C21.4190654,60.20685 20.5368224,62.7276 19.4915888,64.75635 C24.8882243,62.5776 28.7147664,59.2866 28.7663551,59.24235 L29.604486,58.51335 L30.6900935,58.73835 C33.6538318,59.35335 36.7229907,59.66535 39.8130841,59.66535 C59.2927103,59.66535 75.1401869,47.39085 75.1401869,32.30385 C75.1401869,17.21685 59.2927103,4.94235 39.8130841,4.94235 L39.8130841,4.94235 Z M6.78056075,71.9736 L12.3738318,66.9711 C12.4583178,66.8931 16.073271,63.5286 16.966729,58.40535 C6.3117757,52.43985 0,42.77985 0,32.30385 C0,14.7351 17.8601869,0.44235 39.8130841,0.44235 C61.7659813,0.44235 79.6261682,14.7351 79.6261682,32.30385 C79.6261682,49.8726 61.7659813,64.16535 39.8130841,64.16535 C36.7813084,64.16535 33.7659813,63.8916 30.8328972,63.35085 C28.5435514,65.1351 22.0403738,69.70635 14.2003738,70.8711 L6.78056075,71.9736 Z","id":"Fill-1","fill":"#2AD9C7","mask":"url(#mask-2)","key":2})]),React.createElement("g",{"id":"Group-6","transform":"translate(37.000000, 51.000000)","key":1},[React.createElement("mask",{"id":"mask-4","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-3"})),React.createElement("g",{"id":"Clip-5","key":1}),React.createElement("path",{"d":"M50.9298275,59.4746643 L51.7628642,60.1987051 C51.8133963,60.2426541 55.786855,63.6401337 61.3357266,65.85695 C60.2500294,63.7809194 59.3233596,61.1842051 59.1234606,58.1755622 L59.026855,56.7073684 L60.3340018,56.0377051 C70.4827817,50.8435316 76.541433,42.1498276 76.541433,32.7827357 C76.541433,17.42145 60.4008826,4.92504184 40.5625706,4.92504184 C20.7235156,4.92504184 4.58296514,17.42145 4.58296514,32.7827357 C4.58296514,48.1440214 20.7235156,60.6404296 40.5625706,60.6404296 C43.7096807,60.6404296 46.8344972,60.323848 49.8508183,59.6981337 L50.9298275,59.4746643 Z M73.8862679,72.9997765 L66.6170752,71.9256337 C58.6344881,70.740501 52.0162679,66.0796745 49.7073963,64.280001 C46.7215431,64.8312255 43.6502312,65.1098173 40.5625706,65.1098173 C18.2645339,65.1098173 0.124249541,50.6081439 0.124249541,32.7827357 C0.124249541,14.9573276 18.2645339,0.455654082 40.5625706,0.455654082 C62.8598642,0.455654082 81.0001486,14.9573276 81.0001486,32.7827357 C81.0001486,43.4206235 74.578855,53.2294398 63.7389743,59.2817357 C64.6463229,64.5600827 68.3923872,68.0149194 68.4340018,68.0521643 L73.8862679,72.9997765 Z","id":"Fill-4","fill":"#FFFFFF","mask":"url(#mask-4)","key":2})])])))]);
	}
	
	EmployeeExperience.defaultProps = {"width":"118px","height":"124px","viewBox":"0 0 118 124","version":"1.1"};
	
	module.exports = EmployeeExperience;
	
	EmployeeExperience.default = EmployeeExperience;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StrategicMarketing (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Strategic Marketing"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"home","transform":"translate(-1103.000000, -3667.000000)"},React.createElement("g",{"id":"Group-23","transform":"translate(1103.000000, 3667.000000)"},[React.createElement("path",{"d":"M0,118 L82,118 L82,12 L0,12 L0,118 Z M4.47272727,113.521127 L77.5272727,113.521127 L77.5272727,16.4788732 L4.47272727,16.4788732 L4.47272727,113.521127 Z","id":"Fill-1","fill":"#2AD9C7","key":0}),React.createElement("g",{"id":"Group-22","transform":"translate(15.000000, 0.000000)","fill":"#FFFFFF","key":1},[React.createElement("path",{"d":"M7.46666667,23.8344828 L44.8,23.8344828 L44.8,16.3862069 L35.84,16.3862069 L35.84,14.1517241 C35.84,8.8128 31.48544,4.46896552 26.1333333,4.46896552 C20.7812267,4.46896552 16.4266667,8.8128 16.4266667,14.1517241 L16.4266667,16.3862069 L7.46666667,16.3862069 L7.46666667,23.8344828 Z M49.28,28.3034483 L2.98666667,28.3034483 L2.98666667,11.9172414 L12.12288,11.9172414 C13.20032,5.17208276 19.0728533,0 26.1333333,0 C33.1938133,0 39.0663467,5.17208276 40.1437867,11.9172414 L49.28,11.9172414 L49.28,28.3034483 Z","id":"Fill-2","key":0}),React.createElement("path",{"d":"M21.3266667,13.4068966 C21.3266667,11.1724138 23.4793067,8.61244138 26.13296,8.61244138 C28.78736,8.61244138 30.94,11.1724138 30.94,13.4068966 L21.3266667,13.4068966 Z","id":"Fill-4","key":1}),React.createElement("path",{"d":"M8.21333333,40.2206897 C6.15477333,40.2206897 4.48,41.8913379 4.48,43.9448276 C4.48,45.9983172 6.15477333,47.6689655 8.21333333,47.6689655 C10.2718933,47.6689655 11.9466667,45.9983172 11.9466667,43.9448276 C11.9466667,41.8913379 10.2718933,40.2206897 8.21333333,40.2206897 M8.21333333,52.137931 C3.6848,52.137931 0,48.4622069 0,43.9448276 C0,39.4274483 3.6848,35.7517241 8.21333333,35.7517241 C12.7418667,35.7517241 16.4266667,39.4274483 16.4266667,43.9448276 C16.4266667,48.4622069 12.7418667,52.137931 8.21333333,52.137931","id":"Fill-6","key":2}),React.createElement("path",{"d":"M47.4322987,95.3990069 C45.3737387,95.3990069 43.6989653,97.0696552 43.6989653,99.1231448 C43.6989653,101.176634 45.3737387,102.847283 47.4322987,102.847283 C49.4908587,102.847283 51.165632,101.176634 51.165632,99.1231448 C51.165632,97.0696552 49.4908587,95.3990069 47.4322987,95.3990069 M47.4322987,107.316248 C42.9037653,107.316248 39.2189653,103.640524 39.2189653,99.1231448 C39.2189653,94.6057655 42.9037653,90.9300414 47.4322987,90.9300414 C51.960832,90.9300414 55.645632,94.6057655 55.645632,99.1231448 C55.645632,103.640524 51.960832,107.316248 47.4322987,107.316248","id":"Fill-8","key":3}),React.createElement("polygon",{"id":"Fill-10","points":"48.442912 61.1351503 36.4962453 49.217909 39.6636053 46.0583503 51.610272 57.9755917","key":4}),React.createElement("polygon",{"id":"Fill-12","points":"39.6637547 61.1351503 36.4963947 57.9755917 48.4430613 46.0583503 51.6104213 49.217909","key":5}),React.createElement("polygon",{"id":"Fill-14","points":"12.602912 90.2143366 0.656245333 78.2970952 3.82360533 75.1375366 15.770272 87.0547779","key":6}),React.createElement("polygon",{"id":"Fill-16","points":"3.82375467 90.2143366 0.656394667 87.0547779 12.6030613 75.1375366 15.7704213 78.2970952","key":7}),React.createElement("polygon",{"id":"Fill-18","points":"20.9066667 65.5448276 16.4266667 65.5448276 16.4266667 54.3724138 28.3733333 54.3724138 28.3733333 58.8413793 20.9066667 58.8413793","key":8}),React.createElement("path",{"d":"M29.9184107,101.973377 L26.1776107,99.5147007 C30.547104,92.8976524 32.0732907,84.985349 30.4746773,77.2361628 C28.876064,69.4869766 24.3415573,62.8185352 17.707424,58.4598041 L20.171424,54.7274731 C27.805344,59.7431421 33.022304,67.4163559 34.8628373,76.3356662 C36.702624,85.2542317 34.946464,94.3590041 29.9184107,101.973377","id":"Fill-20","key":9})])])))]);
	}
	
	StrategicMarketing.defaultProps = {"width":"82px","height":"118px","viewBox":"0 0 82 118","version":"1.1"};
	
	module.exports = StrategicMarketing;
	
	StrategicMarketing.default = StrategicMarketing;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function AdLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Case-Study","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"AD-Case-Study-12-col-Copy-2","transform":"translate(-108.000000, -260.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"Hero","transform":"translate(0.000000, -45.000000)"},React.createElement("g",{"id":"Group-8","transform":"translate(108.000000, 305.000000)"},[React.createElement("polygon",{"id":"Fill-1","points":"0 0 0 30 1.7952064 30 3.21021538 30 17.8140891 8.36529726 18.8795618 6.78762491 18.885694 6.78762491 22.0913102 11.5342687 23.1598489 13.1164833 26.3639321 17.8661552 25.2953934 19.4483698 18.1758899 30 20.3114343 30 26.3639321 21.0320985 27.4340039 19.4483698 27.9659737 18.6565055 29.0360455 17.0742909 32.2385956 21.8224488 33.3071343 23.4046634 37.7575905 30 41 30 41 0","key":0}),React.createElement("polygon",{"id":"Fill-2","points":"9.62758002 30.3427123 8.20337272 32.4849348 1.7952064 32.4849348 1.78600808 32.4849348 0 32.4849348 0 41 41 41 41 32.4849348 39.1817978 32.4849348 37.0462534 32.4849348 35.9777146 32.4849348 33.8421702 32.4849348 27.4340039 32.4849348 28.8566781 30.3427123 30.636554 27.6637808 31.7050927 26.0567295 30.636554 24.4481403 29.5695483 26.0567295 26.7196007 30.3427123 25.2938603 32.4849348 18.885694 32.4849348 16.7501496 32.4849348 10.3389171 32.4849348 11.7631244 30.3427123 21.5562743 15.6085892 20.4892686 14","key":1}),React.createElement("g",{"id":"Group-7","transform":"translate(49.000000, 7.000000)","key":2},[React.createElement("path",{"d":"M33.3577765,19.2094118 C33.4082471,19.2124706 33.4403647,19.2155294 33.4694235,19.2155294 C35.1747176,19.2155294 36.8800118,19.2247059 38.5853059,19.2078824 C38.9737765,19.2032941 39.3744824,19.1528235 39.7491882,19.0503529 C41.0751882,18.6909412 42.0891882,17.8818824 42.8493059,16.7562353 C43.8877765,15.2161176 44.2670706,13.5092941 44.0300118,11.6694118 C43.8082471,9.96411765 43.1016588,8.502 41.7940118,7.358 C40.8671882,6.54894118 39.7904824,6.10847059 38.5531882,6.10082353 C36.8800118,6.09164706 35.2053059,6.09929412 33.5306,6.09929412 L33.3577765,6.09929412 L33.3577765,19.2094118 Z M26.8853059,0.188117647 L39.2246,0.188117647 C39.2628353,0.198823529 39.3041294,0.218705882 39.3423647,0.220235294 C40.0994235,0.255411765 40.8457765,0.377764706 41.5753059,0.570470588 C44.4444824,1.33670588 46.7416588,2.938 48.4576588,5.356 C49.7454235,7.16988235 50.4764824,9.19635294 50.6844824,11.4109412 C50.7028353,11.5990588 50.7273059,11.7856471 50.7502471,11.9737647 L50.7502471,13.2661176 C50.7150706,13.5827059 50.6783647,13.8977647 50.6447176,14.2143529 C50.4917765,15.5801176 50.1124824,16.8831765 49.5190706,18.1174118 C48.4087176,20.4298824 46.7508353,22.2468235 44.5255412,23.5330588 C43.0511882,24.3849412 41.4621294,24.8927059 39.7644824,25.0578824 C39.5840118,25.0747059 39.4035412,25.1037647 39.2246,25.1251765 L26.8853059,25.1251765 L26.8853059,0.188117647 Z","id":"Fill-3","key":0}),React.createElement("path",{"d":"M13.4738941,6.94123529 C12.4767176,9.659 11.4994235,12.3217059 10.5190706,14.9920588 L16.4287176,14.9920588 C15.4453059,12.3171176 14.4695412,9.65441176 13.4738941,6.94123529 M6.82248235,25.1259412 C4.6186,25.1259412 2.41471765,25.1259412 0.209305882,25.1244118 C0.161894118,25.1244118 0.112952941,25.1014706 0.0624823529,25.0877059 C0.0976588235,25.0188824 0.137423529,24.9500588 0.166482353,24.8797059 C2.28471765,19.6047647 4.40142353,14.3298235 6.51812941,9.05641176 C7.70495294,6.10005882 8.88871765,3.14523529 10.0740118,0.188882353 L16.8737765,0.188882353 C17.5742471,1.93394118 18.2747176,3.679 18.9751882,5.42558824 C20.4893059,9.20017647 22.0049529,12.9747647 23.5206,16.7508824 C24.6416588,19.5420588 25.7627176,22.3332353 26.8853059,25.1259412 L20.1237765,25.1259412 C19.6251882,23.7693529 19.1250706,22.4127647 18.6310706,21.0546471 C18.5897765,20.9384118 18.5331882,20.9108824 18.4184824,20.9108824 C15.1073059,20.9139412 11.7976588,20.9139412 8.48648235,20.9108824 C8.36718824,20.9108824 8.31824706,20.9506471 8.28001176,21.0607647 C7.79671765,22.4158235 7.31036471,23.7708824 6.82248235,25.1259412","id":"Fill-5","key":1})])]))))]);
	}
	
	AdLogo.defaultProps = {"width":"164px","height":"38px","viewBox":"0 0 163.8 37.5","version":"1.1"};
	
	module.exports = AdLogo;
	
	AdLogo.default = AdLogo;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function AdWorkLogo (props) {
	    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1},[React.createElement("polygon",{"id":"path-1","points":"0.0353129412 0.176670968 10.6402306 0.176670968 10.6402306 15.483871 0.0353129412 15.483871","key":0}),React.createElement("polygon",{"id":"path-3","points":"0 94.4516129 266.459788 94.4516129 266.459788 0.032516129 0 0.032516129","key":1})]),React.createElement("g",{"id":"Case-Study","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"AD-Case-Study-12-col-Copy-2","transform":"translate(-899.000000, -1759.000000)"},React.createElement("g",{"id":"ad-logos","transform":"translate(108.000000, 1500.000000)"},React.createElement("g",{"id":"Group-37","transform":"translate(791.000000, 259.000000)"},[React.createElement("polygon",{"id":"Fill-1","points":"0 0.549316129 0 56.0187355 3.33738824 56.0187355 5.97167059 56.0187355 33.1216471 16.0177032 35.1016941 13.1020903 35.1158824 13.1020903 41.0733647 21.8798968 43.0597176 24.8048 49.0187765 33.5841548 47.0324235 36.5106065 33.7900706 56.0187355 37.7627765 56.0187355 49.0187765 39.4370581 51.0051294 36.5106065 51.9967294 35.0473806 53.9830824 32.120929 59.9405647 40.9002839 61.9269176 43.8267355 70.2033882 56.0187355 76.2318118 56.0187355 76.2318118 0.549316129","key":0}),React.createElement("polygon",{"id":"Fill-2","points":"17.9012965 56.0181161 15.2544024 59.9200516 3.33786118 59.9200516 3.32367294 59.9200516 0.00047294167 59.9200516 0.00047294167 75.4225032 76.2322847 75.4225032 76.2322847 59.9200516 72.8523318 59.9200516 68.8796259 59.9200516 66.8948494 59.9200516 62.9205671 59.9200516 51.0056024 59.9200516 53.6524965 56.0181161 56.9630847 51.1422452 58.9494376 48.2157935 56.9630847 45.2893419 54.9767318 48.2157935 49.6797906 56.0181161 47.0328965 59.9200516 35.1163553 59.9200516 31.1436494 59.9200516 19.2271082 59.9200516 21.8740024 56.0181161 40.0806612 29.1954065 38.0943082 26.2705032","key":1}),React.createElement("g",{"id":"Group-36","transform":"translate(0.000000, 0.516181)","key":2},[React.createElement("path",{"d":"M155.244202,48.4770581 C155.340367,48.4817032 155.39712,48.4863484 155.453873,48.4863484 C158.630461,48.4878968 161.808626,48.504929 164.986791,48.4739613 C165.711967,48.4662194 166.456061,48.3733161 167.157591,48.1875097 C169.62792,47.5278968 171.518108,46.0460903 172.933779,43.9867355 C174.869685,41.1655742 175.575944,38.0440258 175.132955,34.6762839 C174.71992,31.5516387 173.405144,28.8760258 170.96792,26.7826065 C169.240108,25.3008 167.231685,24.4940903 164.930038,24.4817032 C161.808626,24.464671 158.688791,24.4770581 155.567379,24.4770581 L155.244202,24.4770581 L155.244202,48.4770581 Z M143.181049,13.6584774 L166.177026,13.6584774 C166.25112,13.6786065 166.323638,13.7157677 166.399308,13.7188645 C167.810249,13.7838968 169.200696,14.0037677 170.561191,14.3598968 C175.905426,15.7611871 180.18712,18.6922839 183.387355,23.1191226 C185.785167,26.4388645 187.148814,30.1472516 187.535049,34.2024774 C187.569732,34.5462194 187.617026,34.8884129 187.659591,35.2306065 L187.659591,37.5980903 C187.593379,38.1771871 187.527167,38.7562839 187.462532,39.3353806 C187.177191,41.832929 186.472508,44.2174452 185.364249,46.4780903 C183.294344,50.7098323 180.206038,54.0388645 176.058344,56.3893161 C173.308979,57.9485419 170.348367,58.8791226 167.185967,59.1810581 C166.848602,59.2151226 166.512814,59.264671 166.177026,59.3064774 L143.181049,59.3064774 L143.181049,13.6584774 Z","key":0}),React.createElement("path",{"d":"M118.186424,26.0208 C116.327765,30.9957677 114.508518,35.8669935 112.681388,40.7568 L123.693035,40.7568 C121.862753,35.8592516 120.043506,30.9880258 118.186424,26.0208 M105.793788,59.3064774 C101.683929,59.3064774 97.5772235,59.3064774 93.4673647,59.3033806 C93.3759294,59.3033806 93.2844941,59.2615742 93.1930588,59.2383484 C93.2576941,59.1098323 93.3317882,58.9875097 93.3869647,58.8543484 C97.3328706,49.2001548 101.278776,39.5459613 105.223106,29.8902194 C107.434894,24.4801548 109.641953,19.0700903 111.852165,13.6584774 L124.522259,13.6584774 L128.438212,23.2429935 C131.263247,30.1549935 134.086706,37.0654452 136.911741,43.9758968 C139.000565,49.0855742 141.090965,54.1952516 143.179788,59.3064774 L130.579059,59.3064774 C129.650518,56.8228645 128.7204,54.3408 127.799741,51.8556387 C127.720918,51.6435097 127.615294,51.5924129 127.402471,51.5924129 C121.232165,51.5970581 115.063435,51.5970581 108.891553,51.5908645 C108.669271,51.5908645 108.577835,51.6651871 108.503741,51.864929 C107.606729,54.3485419 106.698682,56.8275097 105.793788,59.3064774","key":1}),React.createElement("polygon",{"id":"Fill-7","points":"98.3604141 77.5319226 93.4008376 77.5319226 93.4008376 75.2108903 106.069355 75.2108903 106.069355 77.5319226 101.106626 77.5319226 101.106626 90.0599226 98.3604141 90.0599226","key":2}),React.createElement("path",{"d":"M110.989047,88.0516645 C112.7342,88.0516645 114.203471,86.7138581 114.203471,84.7272774 C114.203471,82.7608258 112.7342,81.4013419 110.989047,81.4013419 C109.221824,81.4013419 107.750976,82.7608258 107.750976,84.7272774 C107.750976,86.7138581 109.221824,88.0516645 110.989047,88.0516645 M110.966976,79.1437935 C114.2886,79.1437935 116.949682,81.4648258 116.949682,84.7272774 C116.949682,88.0114065 114.2886,90.3107613 110.989047,90.3107613 C107.667424,90.3107613 105.004765,88.0114065 105.004765,84.7272774 C105.004765,81.4648258 107.667424,79.1437935 110.966976,79.1437935","key":3}),React.createElement("g",{"transform":"translate(118.235294, 78.967742)","key":4},React.createElement("path",{"d":"M7.99964235,5.50776774 C7.99964235,3.08299355 6.78576,2.43421935 5.31648941,2.43421935 C3.67853647,2.43421935 2.76260706,3.6048 2.76260706,5.40402581 C2.76260706,7.2651871 3.74159529,8.6448 5.48674824,8.6448 C6.78576,8.6448 7.99964235,7.91396129 7.99964235,5.50776774 M4.87034824,13.224929 C6.53037176,13.224929 7.93658353,12.5358968 7.93658353,10.632929 L7.93658353,10.0042839 C7.93658353,9.75344516 7.97757176,9.43912258 7.97757176,9.43912258 L7.93658353,9.43912258 C7.29811294,10.3805419 6.36011294,10.8837677 4.91291294,10.8837677 C1.80253647,10.8837677 0.0353129412,8.41563871 0.0353129412,5.48763871 C0.0353129412,2.55963871 1.71898353,0.176670968 4.84827765,0.176670968 C7.21140706,0.176670968 8.06270118,1.53460645 8.06270118,1.53460645 L8.12733647,1.53460645 C8.12733647,1.53460645 8.10684235,1.4091871 8.10684235,1.24196129 L8.10684235,0.42596129 L10.6402306,0.42596129 L10.6402306,10.4440258 C10.6402306,14.1044129 7.74425412,15.4840258 4.91291294,15.4840258 C3.54926588,15.4840258 2.10206588,15.1077677 1.05844235,14.5642839 L1.86717176,12.5358968 C1.86717176,12.5358968 3.23081882,13.224929 4.87034824,13.224929","mask":"url(#mask-2)"})),React.createElement("path",{"d":"M138.563409,83.4094452 C138.522421,81.9663484 137.606492,81.1921548 136.41468,81.1921548 C135.030539,81.1921548 134.070468,82.0282839 133.81508,83.4094452 L138.563409,83.4094452 Z M136.477739,79.1436387 C139.607033,79.1436387 141.289127,81.3810581 141.289127,84.2037677 C141.289127,84.5180903 141.224492,85.2288 141.224492,85.2288 L133.731527,85.2288 C133.900209,87.0899613 135.371056,88.0515097 136.988515,88.0515097 C138.733668,88.0515097 140.117809,86.880929 140.117809,86.880929 L141.161433,88.7838968 C141.161433,88.7838968 139.501409,90.3106065 136.796186,90.3106065 C133.19868,90.3106065 130.963245,87.7604129 130.963245,84.7271226 C130.963245,81.4429935 133.239668,79.1436387 136.477739,79.1436387 Z","key":5}),React.createElement("path",{"d":"M143.867129,81.6735484 L142.460918,81.6735484 L142.460918,79.5615484 L143.930188,79.5615484 L143.930188,76.4864516 L146.570776,76.4864516 L146.570776,79.5615484 L149.041106,79.5615484 L149.041106,81.6735484 L146.570776,81.6735484 L146.570776,85.8154839 C146.570776,87.5713548 147.975412,87.8221935 148.721082,87.8221935 C149.020612,87.8221935 149.211365,87.7788387 149.211365,87.7788387 L149.211365,90.1014194 C149.211365,90.1014194 148.892918,90.1649032 148.380565,90.1649032 C146.868729,90.1649032 143.867129,89.7251613 143.867129,86.1499355 L143.867129,81.6735484 Z","key":6}),React.createElement("path",{"d":"M151.299873,75.2108903 L154.00352,75.2108903 L154.00352,80.3561806 C154.00352,80.8779871 153.959379,81.2542452 153.959379,81.2542452 L154.00352,81.2542452 C154.534791,80.2307613 155.855873,79.1437935 157.750791,79.1437935 C160.156485,79.1437935 161.518555,80.3763097 161.518555,83.2005677 L161.518555,90.0599226 L158.835402,90.0599226 L158.835402,83.7440516 C158.835402,82.4480516 158.494885,81.5685677 157.11232,81.5685677 C155.684038,81.5685677 154.577355,82.4883097 154.172202,83.7858581 C154.046085,84.2039226 154.00352,84.6637935 154.00352,85.165471 L154.00352,90.0599226 L151.299873,90.0599226 L151.299873,75.2108903 Z","key":7}),React.createElement("path",{"d":"M171.059671,83.4094452 C171.017106,81.9663484 170.101176,81.1921548 168.909365,81.1921548 C167.525224,81.1921548 166.565153,82.0282839 166.309765,83.4094452 L171.059671,83.4094452 Z M168.972424,79.1436387 C172.101718,79.1436387 173.785388,81.3810581 173.785388,84.2037677 C173.785388,84.5180903 173.719176,85.2288 173.719176,85.2288 L166.226212,85.2288 C166.396471,87.0899613 167.865741,88.0515097 169.4832,88.0515097 C171.228353,88.0515097 172.612494,86.880929 172.612494,86.880929 L173.656118,88.7838968 C173.656118,88.7838968 171.996094,90.3106065 169.292447,90.3106065 C165.693365,90.3106065 163.457929,87.7604129 163.457929,84.7271226 C163.457929,81.4429935 165.735929,79.1436387 168.972424,79.1436387 Z","key":8}),React.createElement("path",{"d":"M175.89376,79.3933935 L178.490207,79.3933935 L178.490207,81.2344258 C178.490207,81.6308129 178.447642,81.9884903 178.447642,81.9884903 L178.490207,81.9884903 C178.980489,80.4602323 180.279501,79.2462968 181.941101,79.2462968 C182.194913,79.2462968 182.429807,79.2912 182.429807,79.2912 L182.429807,81.903329 C182.429807,81.903329 182.153925,81.8615226 181.791336,81.8615226 C180.642089,81.8615226 179.343078,82.5102968 178.830725,84.0989419 C178.662042,84.6222968 178.597407,85.2091355 178.597407,85.8346839 L178.597407,90.0602323 L175.89376,90.0602323 L175.89376,79.3933935 Z","key":9}),React.createElement("polygon",{"points":"183.688461 87.3621677 186.349544 87.3621677 184.306438 92.255071 182.261755 92.255071","key":10}),React.createElement("path",{"d":"M192.759315,79.3933935 L195.612727,79.3933935 L197.507645,86.3998452 C197.655833,86.9650065 197.720468,87.5301677 197.720468,87.5301677 L197.763033,87.5301677 C197.763033,87.5301677 197.870233,86.9650065 198.019998,86.3998452 L200.018962,79.415071 L202.426233,79.415071 L204.426774,86.3998452 C204.576539,86.9650065 204.663245,87.5301677 204.663245,87.5301677 L204.704233,87.5301677 C204.704233,87.5301677 204.789362,86.9650065 204.939127,86.3998452 L206.834045,79.3933935 L209.644892,79.3933935 L206.343762,90.0602323 L203.342162,90.0602323 L201.510304,83.9735226 C201.340045,83.4099097 201.234421,82.8246194 201.234421,82.8246194 L201.191856,82.8246194 C201.191856,82.8246194 201.106727,83.4099097 200.936468,83.9735226 L199.104609,90.0602323 L196.080939,90.0602323 L192.759315,79.3933935 Z","key":11}),React.createElement("path",{"d":"M218.142856,83.4094452 C218.100292,81.9663484 217.184362,81.1921548 215.992551,81.1921548 C214.608409,81.1921548 213.649915,82.0282839 213.392951,83.4094452 L218.142856,83.4094452 Z M216.055609,79.1436387 C219.184904,79.1436387 220.868574,81.3810581 220.868574,84.2037677 C220.868574,84.5180903 220.802362,85.2288 220.802362,85.2288 L213.309398,85.2288 C213.479656,87.0899613 214.948927,88.0515097 216.567962,88.0515097 C218.313115,88.0515097 219.697256,86.880929 219.697256,86.880929 L220.739304,88.7838968 C220.739304,88.7838968 219.080856,90.3106065 216.375633,90.3106065 C212.776551,90.3106065 210.541115,87.7604129 210.541115,84.7271226 C210.541115,81.4429935 212.819115,79.1436387 216.055609,79.1436387 Z","key":12}),React.createElement("path",{"d":"M226.832047,79.3933935 L229.685459,79.3933935 L231.580376,86.3998452 C231.728565,86.9650065 231.791624,87.5301677 231.791624,87.5301677 L231.834188,87.5301677 C231.834188,87.5301677 231.941388,86.9650065 232.091153,86.3998452 L234.091694,79.415071 L236.497388,79.415071 L238.497929,86.3998452 C238.647694,86.9650065 238.7344,87.5301677 238.7344,87.5301677 L238.775388,87.5301677 C238.775388,87.5301677 238.860518,86.9650065 239.010282,86.3998452 L240.9052,79.3933935 L243.716047,79.3933935 L240.414918,90.0602323 L237.413318,90.0602323 L235.581459,83.9735226 C235.4112,83.4099097 235.305576,82.8246194 235.305576,82.8246194 L235.263012,82.8246194 C235.263012,82.8246194 235.177882,83.4099097 235.0092,83.9735226 L233.175765,90.0602323 L230.152094,90.0602323 L226.832047,79.3933935 Z","key":13}),React.createElement("mask",{"id":"mask-4","key":14},React.createElement("use",{"xlinkHref":"#path-3"})),React.createElement("g",{"id":"Clip-33","key":15}),React.createElement("path",{"d":"M245.379224,90.0603871 L248.084447,90.0603871 L248.084447,79.3935484 L245.379224,79.3935484 L245.379224,90.0603871 Z M245.379224,77.5741935 L248.062376,77.5741935 L248.062376,75.2113548 L245.379224,75.2113548 L245.379224,77.5741935 Z","id":"Fill-32","key":16}),React.createElement("path",{"d":"M250.937859,79.3933935 L253.534306,79.3933935 L253.534306,80.6290065 C253.534306,81.0253935 253.491741,81.3613935 253.491741,81.3613935 L253.534306,81.3613935 C254.002518,80.4602323 255.195906,79.1441032 257.388776,79.1441032 C259.794471,79.1441032 261.156541,80.3766194 261.156541,83.2008774 L261.156541,90.0602323 L258.473388,90.0602323 L258.473388,83.7443613 C258.473388,82.4483613 258.132871,81.5688774 256.750306,81.5688774 C255.303106,81.5688774 254.237412,82.4669419 253.833835,83.7443613 C253.684071,84.1841032 253.641506,84.6641032 253.641506,85.1657806 L253.641506,90.0602323 L250.937859,90.0602323 L250.937859,79.3933935 Z","key":17}),React.createElement("polygon",{"points":"263.756141 90.0603871 266.459788 90.0603871 266.459788 87.4049032 263.756141 87.4049032","key":18})])]))))]);
	}
	
	AdWorkLogo.defaultProps = {"width":"267px","height":"95px","viewBox":"0 0 267 95","version":"1.1"};
	
	module.exports = AdWorkLogo;
	
	AdWorkLogo.default = AdWorkLogo;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function AdpLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Case-Study","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"ADP-Case-Study-12-col","transform":"translate(-108.000000, -261.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"Hero","transform":"translate(0.000000, -45.000000)"},React.createElement("g",{"id":"ADP-Logo","transform":"translate(108.000000, 306.000000)"},React.createElement("g",{"id":"Group"},React.createElement("path",{"d":"M76.4517812,38.5660319 C75.3293226,38.5660319 74.423791,37.6750239 74.423791,36.5642853 C74.423791,35.4700265 75.3293226,34.568032 76.4517812,34.568032 C77.5653403,34.568032 78.4686469,35.4700265 78.4686469,36.5642853 C78.4686469,37.6750239 77.5653403,38.5660319 76.4517812,38.5660319 Z M76.4517812,39 C77.8123034,39 78.8991637,37.9101358 78.8991637,36.5642853 C78.8991637,35.2316187 77.8123034,34.1483464 76.4517812,34.1483464 C75.0901465,34.1483464 73.9877119,35.2316187 73.9877119,36.5642853 C73.9877119,37.9101358 75.0901465,39 76.4517812,39 Z M76.3116129,36.7235901 C76.4640181,36.7411685 76.613086,36.7235901 76.727668,36.8444419 C76.8533744,36.9762804 76.8533744,37.2037016 76.8867478,37.4476027 C76.9101092,37.6156967 76.9490448,37.7947772 76.986868,37.9573779 L77.5564407,37.9573779 C77.4641076,37.7024903 77.4285093,37.4025579 77.3895737,37.1355851 C77.3495256,36.8246662 77.3016904,36.6499803 76.8978723,36.5741732 L76.8978723,36.5543974 C77.2872286,36.4785903 77.4885814,36.2204068 77.4885814,35.8941067 C77.4885814,35.2502958 76.9412577,35.1074708 76.4150705,35.1074708 L75.4783904,35.1074708 L75.4783904,37.9573779 L75.9311562,37.9573779 L75.9311562,36.7235901 L76.3116129,36.7235901 Z M75.9311562,36.2808327 L75.9311562,35.5524255 L76.4673554,35.5524255 C76.8289006,35.5524255 76.9267959,35.6589949 76.9267959,35.8776269 C76.9267959,36.089667 76.8289006,36.2687475 76.4072833,36.2808327 L75.9311562,36.2808327 Z M54.6300284,19.4989013 C54.6300284,25.6513606 49.5739585,30.6381486 43.3487073,30.6381486 L39.0435389,30.6381486 L39.0435389,25.7678179 L43.3487073,25.7678179 C46.8529141,25.7678179 49.6918779,22.961857 49.6918779,19.4989013 C49.6918779,16.0447349 46.8529141,13.2277875 43.3487073,13.2277875 L39.0435389,13.2277875 L39.0435389,8.3563581 L43.3487073,8.3563581 C49.5739585,8.3563581 54.6300284,13.3464421 54.6300284,19.4989013 Z M30.580045,8.3563581 L30.580045,17.4092625 L22.7105977,17.4092625 L19.8338107,22.2894811 L35.5204204,22.2894811 L35.5204204,8.3563581 L30.580045,8.3563581 Z M87,15.3207223 C87,23.7836498 80.0460962,30.6381486 71.4791448,30.6381486 L71.4791448,39 L58.0864,39 L58.0864,32.4805905 C54.4631614,36.4807877 49.2079636,39 43.3487073,39 L30.580045,39 L30.580045,30.6381486 L20.6069611,30.6381486 L15.6688106,39 L0,39 L23.0298698,0 L43.3487073,0 C49.2079636,0 54.4631614,2.52690292 58.0864,6.52600146 L58.0864,0 L71.4791448,0 C80.0460962,0 87,6.86658403 87,15.3207223 Z M43.3487073,34.1296693 C49.2535739,34.1296693 54.3474669,30.7128571 56.7292151,25.7678179 L63.0212132,25.7678179 L63.0212132,34.1296693 L66.5432192,34.1296693 L66.5432192,25.7678179 L71.4791448,25.7678179 C77.3261642,25.7678179 82.0585121,21.0886529 82.0585121,15.3207223 C82.0585121,9.55718632 77.3261642,4.87582399 71.4791448,4.87582399 L63.0212132,4.87582399 L63.0212132,17.4092625 L57.9962918,17.4092625 C56.9750659,10.3240464 50.8043245,4.87582399 43.3487073,4.87582399 L25.984528,4.87582399 L8.71824412,34.1296693 L12.8376339,34.1296693 L17.7691098,25.7678179 L35.5204204,25.7678179 L35.5204204,34.1296693 L43.3487073,34.1296693 Z M71.4791448,8.3563581 L66.5432192,8.3563581 L66.5432192,13.2277875 L71.4791448,13.2277875 C72.6550009,13.2277875 73.5927934,14.1704321 73.5927934,15.3207223 C73.5927934,16.4809003 72.6550009,17.4092625 71.4791448,17.4092625 L66.5432192,17.4092625 L66.5432192,22.2894811 L71.4791448,22.2894811 C75.3738204,22.2894811 78.5276066,19.1660094 78.5276066,15.3207223 C78.5276066,11.4776325 75.3738204,8.3563581 71.4791448,8.3563581 Z","id":"Fill-1"}))))))]);
	}
	
	AdpLogo.defaultProps = {"width":"164px","height":"38px","viewBox":"0 0 163.8 37.5","version":"1.1"};
	
	module.exports = AdpLogo;
	
	AdpLogo.default = AdpLogo;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function AllCladLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Case-Study","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"All-clad-Case-Study-12-col","transform":"translate(-111.000000, -242.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"Group-53","transform":"translate(111.000000, 242.000000)"},[React.createElement("polygon",{"id":"Fill-1","points":"47 24 97 24 97 20 47 20","key":0}),React.createElement("polygon",{"id":"Fill-2","points":"0 24 21 24 21 20 0 20","key":1}),React.createElement("polygon",{"id":"Fill-3","points":"0 71 98 71 98 67 0 67","key":2}),React.createElement("path",{"d":"M11.253948,29 L0,53.2693822 L4.53365385,54 L7.14502674,47.9430648 L15.7246243,47.9430648 L18.3989748,54 L23,53.2693822 L11.3198548,29 L11.253948,29 Z M11.2869014,37.425954 L13.8638563,43.903089 L8.84102776,43.903089 L11.2869014,37.425954 Z","id":"Fill-4","key":3}),React.createElement("polygon",{"id":"Fill-5","points":"24 53 24 29.541696 29 29 29 52.7295195","key":4}),React.createElement("polygon",{"id":"Fill-6","points":"30 53 30 29.541696 35 29 35 52.7295195","key":5}),React.createElement("polygon",{"id":"Fill-7","points":"35 45 43 45 43 41 35 41","key":6}),React.createElement("g",{"id":"Group-52","key":7},[React.createElement("path",{"d":"M58.8990473,52.5586264 C57.9332611,53.1436264 56.1984366,53.4529368 55.1668183,53.4529368 C48.0995969,53.4529368 43.4000855,47.988454 43.4000855,41.1171322 C43.4000855,34.314546 48.2005893,28.7820747 55.033658,28.7820747 C56.1326046,28.7820747 57.7993527,29.0570172 58.7299786,29.640523 L59.4653527,35.1042586 C58.2669099,34.1053506 56.732574,33.4209828 54.8316733,33.4209828 C50.7994595,33.4209828 48.0001008,37.1327069 48.0001008,41.1171322 C48.0001008,45.5154655 51.1989405,48.8132816 55.033658,48.8132816 C56.8649863,48.8132816 58.2990779,47.8509828 59.4975206,46.8558103 L58.8990473,52.5586264","id":"Fill-8","key":0}),React.createElement("polygon",{"id":"Fill-10","points":"60.3463053 53.4778908 60.3463053 29.6326034 64.5782595 29.0819713 64.5782595 53.2029483","key":1}),React.createElement("path",{"d":"M72.3186885,50.1107414 C73.8178641,50.1107414 75.4165359,49.1835575 75.4165359,47.6026379 C75.4165359,46.0560862 73.817116,45.0960287 72.3186885,45.0960287 C70.819513,45.0960287 69.2185969,46.0560862 69.2185969,47.6026379 C69.219345,49.1835575 70.819513,50.1107414 72.3186885,50.1107414 M68.2198947,35.6799943 C69.8185664,35.3706839 71.4860626,35.1980977 73.1176504,35.1980977 C76.1511618,35.1980977 79.4861542,36.5720632 79.4861542,40.1112011 L79.4861542,53.2030977 L75.6177725,53.6162586 L75.6177725,52.1033276 C74.4522458,53.1321207 72.951574,53.7522356 71.3865664,53.7522356 C67.7860015,53.7522356 64.9858947,51.5885575 64.9858947,47.6018908 C64.9858947,44.4400517 67.5518489,41.6585 70.7170244,41.6585 C72.551345,41.6585 73.7535282,41.9670632 75.3866122,42.8277529 C75.417284,42.4482126 75.4846122,42.1060287 75.4846122,41.6585 C75.4846122,39.2886149 73.8178641,38.8410862 71.8511313,38.8410862 C70.1836351,38.8410862 68.5872076,39.2520057 67.0513756,39.8691322 L68.2198947,35.6799943","id":"Fill-12","key":2}),React.createElement("path",{"d":"M89.125913,49.7685575 C91.9589359,49.7685575 94.0251649,47.3284425 94.0251649,44.4759138 C94.0251649,41.6248793 91.9589359,39.1847644 89.125913,39.1847644 C86.2928901,39.1847644 84.2251649,41.6248793 84.2251649,44.4759138 C84.2251649,47.3276954 86.2928901,49.7685575 89.125913,49.7685575 M93.8598366,51.3136149 C92.0920962,53.1321207 90.9243252,53.7522356 88.5917756,53.7522356 C83.7606,53.7522356 80.2266153,49.3210287 80.2266153,44.4759138 C80.2266153,39.6300517 83.7606,35.1988448 88.5917756,35.1988448 C90.293684,35.1988448 92.0599282,35.7136149 93.6249359,37.0562011 L93.6249359,29.6327529 L97.8576382,29.0821207 L97.8576382,53.2030977 L93.8598366,53.6162586 L93.8598366,51.3136149","id":"Fill-14","key":3}),React.createElement("path",{"d":"M47.9381588,10.4050805 C48.4004794,9.43157471 49.3729985,8.76214943 50.495884,8.76214943 L51.9860824,8.76214943 L51.9845863,6.45427586 L50.495884,6.45427586 C48.4842656,6.45427586 46.7434565,7.65789655 45.9183115,9.40691954 L42.1022962,17.6619195 C40.6532427,20.7856552 37.5591359,22.9411149 33.9772733,22.9411149 C29.0077008,22.9411149 23.8002351,22.9381264 23.8002351,22.9381264 L23.8002351,25.2430115 L33.9772733,25.2430115 C38.4463725,25.2430115 42.3057771,22.5541034 44.1161588,18.6615747 L47.9381588,10.4050805 Z M45.1642351,9.03410345 C46.1232885,6.99668966 48.1498687,5.59358621 50.495884,5.59358621 C51.0098229,5.59358621 51.9860824,5.5905977 51.9860824,5.5905977 L51.9860824,3.28645977 L50.495884,3.28645977 C47.2641282,3.28645977 44.469258,5.22301149 43.1488763,8.03295402 L39.3306168,16.287954 C38.3782962,18.3470345 36.3397466,19.7703103 33.9772733,19.7703103 C30.7066168,19.7703103 23.799487,19.7688161 23.799487,19.7688161 L23.799487,22.0722069 C23.799487,22.0722069 29.4715176,22.0751954 33.9772733,22.0751954 C37.2292275,22.0751954 40.0323267,20.1177241 41.3452275,17.2853678 L45.1642351,9.03410345 Z M38.5772885,15.9114023 C37.7596244,17.6843333 36.0068458,18.9081264 33.9772733,18.9081264 C31.1681893,18.9081264 23.799487,18.9043908 23.799487,18.9043908 L23.799487,16.5987586 C23.799487,16.5987586 32.4047847,16.5980115 33.9772733,16.5980115 C35.1173649,16.5980115 36.1018534,15.9084138 36.5574412,14.9124943 L40.3794412,6.65824138 C42.1973038,2.78737931 46.0439908,0.115655172 50.495884,0.115655172 L51.9860824,0.115655172 L51.9845863,2.42203448 C51.9845863,2.42203448 51.002342,2.42054023 50.495884,2.42054023 C46.9297313,2.42054023 43.8490901,4.55657471 42.3933038,7.65714943 L38.5772885,15.9114023 Z","id":"Fill-16","key":4}),React.createElement("path",{"d":"M7.3066855,63.7436322 C7.35381527,64.7134023 8.05926565,64.2875402 8.05926565,64.6894943 C8.05926565,64.8045517 7.93508244,64.8045517 7.83109771,64.8045517 C7.64931145,64.8045517 7.31715878,64.7574828 6.93712824,64.7574828 C6.64312824,64.7574828 6.33790687,64.8045517 6.10076183,64.8045517 C6.01323511,64.8045517 5.99602901,64.7477701 5.99602901,64.6992069 C5.99602901,64.3532874 6.59599847,64.6102989 6.5847771,63.7570805 L6.49051756,59.2825402 C6.49051756,58.9934023 6.4418916,58.832023 6.38503664,58.832023 C6.31995267,58.832023 6.23317405,58.9351264 6.13816641,59.1764483 L4.16918931,64.0424828 C4.12056336,64.1485747 3.97169313,64.6200115 3.87369313,64.6200115 C3.78018168,64.6200115 3.71285344,64.3644943 3.68367786,64.2867931 L1.65934198,59.1428276 C1.6309145,59.0516782 1.58453282,59.0173103 1.54413588,59.0173103 C1.51496031,59.0173103 1.48802901,59.0718506 1.47755573,59.1884023 L1.36234962,63.2348391 C1.31746412,64.770931 2.21816641,64.2613908 2.21816641,64.6775402 C2.21816641,64.7911034 2.11418168,64.8045517 1.98251756,64.8045517 C1.85908244,64.8045517 1.43117405,64.7567356 1.14465496,64.7567356 C0.650914504,64.7567356 0.490074809,64.8045517 0.317265649,64.8045517 C0.252181679,64.8045517 0.223754198,64.7477701 0.223754198,64.664092 C0.223754198,64.2733448 0.831952672,64.747023 0.897784733,63.5478851 C1.01224275,61.6673678 1.12520458,60.4465632 1.12520458,59.2242644 C1.12520458,56.5144368 0.223754198,57.1592069 0.223754198,56.7669655 C0.223754198,56.6631149 0.298563359,56.6407011 0.383845802,56.6407011 C0.556654962,56.6407011 0.726471756,56.6862759 0.907509924,56.6862759 C1.07807481,56.6862759 1.2478916,56.6407011 1.42219695,56.6407011 C1.55460916,56.6407011 1.57181527,56.8379425 1.62044122,56.9612184 L3.88416641,62.8231724 C3.98815115,63.0637471 4.02705191,63.1668506 4.09363206,63.1668506 C4.14076183,63.1668506 4.23651756,62.9217931 4.38763206,62.5459885 L6.65135725,57.0329425 C6.70896031,56.9051839 6.78376947,56.628 6.89822748,56.6407011 C6.9947313,56.6407011 7.29696031,56.6862759 7.34633435,56.6862759 C7.56328092,56.6862759 7.64931145,56.6407011 7.80192214,56.6407011 C7.85952519,56.6407011 7.89842595,56.7079425 7.89842595,56.7796667 C7.89842595,57.1457586 7.13612061,56.6504138 7.17427328,58.0251264 L7.3066855,63.7436322","id":"Fill-18","key":5}),React.createElement("path",{"d":"M10.1401573,59.9962701 C10.1401573,60.3877644 10.1222031,60.3877644 10.5022336,60.3877644 L11.5286153,60.3877644 C12.5168443,60.3877644 12.261745,59.4650632 12.4891649,59.4650632 C12.5662183,59.4650632 12.5953939,59.5905805 12.5953939,59.6854655 C12.5953939,60.0889138 12.5744473,60.4811552 12.5744473,60.8494885 C12.5744473,61.1490862 12.5953939,61.4501782 12.5953939,61.7602356 C12.5953939,61.8640862 12.555745,61.9081667 12.4891649,61.9081667 C12.1944168,61.9081667 12.5168443,60.8950632 11.7178824,60.8950632 L10.3129664,60.8950632 C10.1109817,60.8950632 10.1401573,61.0893161 10.1401573,61.2641437 L10.1401573,63.3867299 C10.1401573,64.0666149 10.0631038,64.3437989 10.8635618,64.3437989 C13.0599588,64.3437989 13.3831344,63.1566149 13.5058214,63.1566149 C13.5724015,63.1566149 13.5836229,63.2709253 13.5836229,63.2955805 C13.5836229,63.7087414 13.3360046,64.114431 13.1085847,64.4147759 C12.8041115,64.8279368 12.5953939,64.805523 12.1749664,64.805523 C11.4515618,64.805523 10.7289053,64.7367874 10.0062489,64.7577069 C9.62621832,64.7719023 9.22598931,64.805523 8.84670687,64.805523 C8.76217252,64.805523 8.70606565,64.7838563 8.70606565,64.6889713 C8.72476794,64.5522471 8.81827939,64.5769023 9.12125649,64.3901207 C9.3696229,64.2519023 9.38907328,63.9291437 9.38907328,63.387477 L9.38907328,58.128454 C9.38907328,57.6092011 9.38907328,57.0555805 8.87513435,56.9614425 C8.7995771,56.9397759 8.58936336,56.9173621 8.58936336,56.7791437 C8.58936336,56.6865 8.6477145,56.6416724 8.92376031,56.6416724 C10.7199282,56.6416724 11.2151649,56.6865 11.6146458,56.6865 C11.803913,56.6865 12.6799282,56.6416724 12.9731802,56.6416724 C13.0517298,56.6416724 13.0704321,56.7559828 13.0704321,56.8956954 C13.0704321,58.1732816 12.9372718,58.2674195 12.8804168,58.2674195 C12.6522489,58.2674195 12.8041115,57.7123046 12.6522489,57.4470747 C12.4046305,57.0555805 11.4149053,57.1258103 11.0341267,57.1258103 C10.1222031,57.1258103 10.1401573,57.0794885 10.1401573,57.8497759 L10.1401573,59.9962701","id":"Fill-20","key":6}),React.createElement("path",{"d":"M16.4634763,57.8045747 C16.4634763,57.7246322 16.5023771,57.2875632 16.3669725,57.2741149 L14.8184229,57.2741149 C14.2281786,57.2741149 14.2079802,57.4467011 14.0381634,58.0832529 C14.0089878,58.1945747 14.0000107,58.3462414 13.8765756,58.3462414 C13.8197206,58.3462414 13.7808198,58.267046 13.7808198,58.2072759 L13.8848046,57.0903218 C13.8945298,56.9506092 13.8848046,56.6405517 14.0583618,56.6405517 C14.7974763,56.6405517 15.5321023,56.6861264 16.7589725,56.6861264 C18.4803313,56.6861264 19.3555985,56.6405517 19.5448656,56.6405517 C19.7648046,56.6405517 19.8119344,56.7077931 19.8209115,56.9745172 L19.8695374,57.8979655 C19.8770183,58.0115287 19.8882397,58.1504943 19.7648046,58.1504943 C19.4117053,58.1504943 19.9248962,57.2741149 18.9546214,57.2741149 L17.596087,57.2741149 C17.1666824,57.2741149 17.2160565,57.2285402 17.2160565,57.8396897 L17.2160565,63.7218161 C17.2160565,64.6893448 17.988087,64.3083103 17.988087,64.6646897 C17.988087,64.6998046 17.9948198,64.8044023 17.8990641,64.8044023 C17.6716443,64.8044023 17.4053237,64.7580805 17.130026,64.7580805 C16.0639954,64.7580805 15.8844534,64.8044023 15.8283466,64.8044023 C15.7415679,64.8044023 15.7131405,64.7707816 15.7131405,64.654977 C15.7131405,64.3785402 16.4642244,64.4928506 16.4642244,63.8017586 L16.4642244,57.8045747","id":"Fill-22","key":7}),React.createElement("path",{"d":"M20.9524,60.8952126 C20.887316,61.0588333 20.9524,61.104408 21.0780794,61.104408 L22.961026,61.104408 C23.1689954,61.104408 23.1615145,61.0237184 23.1113924,60.8713046 L22.1800183,58.0919943 C22.1328885,57.954523 22.0865069,57.954523 22.0274076,58.0919943 L20.9524,60.8952126 Z M23.5205985,62.049523 C23.427087,61.783546 23.3679878,61.6117069 23.1046595,61.6117069 L21.0107511,61.6117069 C20.829713,61.6117069 20.6584,61.6117069 20.5641405,61.8522816 L19.955942,63.467569 C19.9275145,63.5490057 19.8886137,63.721592 19.8886137,63.8687759 C19.8886137,64.6779138 20.5648885,64.3334885 20.5648885,64.6308448 C20.5648885,64.8407874 20.4324763,64.8041782 20.3090412,64.8041782 C20.0419725,64.8041782 19.7749038,64.7578563 19.5093313,64.7578563 C19.253484,64.7578563 18.9953924,64.8041782 18.7485221,64.8041782 C18.6916672,64.8041782 18.6632397,64.7473966 18.6632397,64.6771667 C18.6632397,64.4336034 19.106858,64.6300977 19.3552244,63.9741207 L21.6294229,58.0919943 C22.1912397,56.6410747 22.2174229,56.4550402 22.3416061,56.4550402 C22.4478351,56.4550402 22.5136672,56.7905 22.5428427,56.8838908 L24.521545,62.8227989 C24.6621863,63.2471667 24.7766443,63.7327989 24.9965832,64.1355 C25.2831023,64.6644655 25.8329496,64.4141782 25.8329496,64.6995805 C25.8329496,64.8041782 25.7663695,64.8041782 25.7005374,64.8041782 C25.3115298,64.8041782 24.9202779,64.7571092 24.5312702,64.7571092 C24.2731786,64.7571092 24.0173313,64.8041782 23.7592397,64.8041782 C23.7038809,64.8041782 23.549774,64.8041782 23.549774,64.6891207 C23.549774,64.4141782 24.121316,64.5277414 24.121316,64.088431 C24.121316,63.8373966 23.9215756,63.3054425 23.8288122,62.9961322 L23.5205985,62.049523 Z","id":"Fill-24","key":8}),React.createElement("path",{"d":"M27.6848504,63.3868046 C27.6848504,64.0666897 27.608545,64.3438736 28.4075069,64.3438736 C30.6039038,64.3438736 30.9270794,63.1566897 31.0512626,63.1566897 C31.1178427,63.1566897 31.128316,63.271 31.128316,63.2956552 C31.128316,63.7088161 30.8814458,64.1145057 30.6517817,64.4148506 C30.3488046,64.8280115 30.1385908,64.8048506 29.7196595,64.8048506 C28.9984992,64.8048506 28.2735985,64.7368621 27.5516901,64.7577816 C27.1701634,64.771977 26.7721786,64.8048506 26.3921481,64.8048506 C26.3068656,64.8048506 26.2507588,64.783931 26.2507588,64.689046 C26.2672168,64.5523218 26.3629725,64.576977 26.6666977,64.3901954 C26.914316,64.251977 26.9337664,63.9292184 26.9337664,63.3875517 L26.9337664,57.539046 C26.9337664,56.9398506 26.1348046,57.0197931 26.1348046,56.7904253 C26.1348046,56.6634138 26.2021328,56.6417471 26.326316,56.6417471 C26.5260565,56.6417471 26.8193084,56.6865747 27.2861176,56.6865747 C27.8277359,56.6865747 28.0574,56.6417471 28.196545,56.6417471 C28.3214763,56.6417471 28.3790794,56.6634138 28.3790794,56.8023793 C28.3790794,57.0691034 27.6848504,56.7792184 27.6848504,57.7811149 L27.6848504,63.3868046","id":"Fill-26","key":9}),React.createElement("path",{"d":"M34.6178641,56.5357299 C36.405055,56.5357299 36.9002916,57.4263046 37.1748412,57.4263046 C37.2511466,57.4263046 37.3087496,57.3090057 37.4060015,57.3090057 C37.5092382,57.3090057 37.5092382,57.4920517 37.5376656,58.2436609 C37.5563679,58.8548103 37.6409023,59.2343506 37.4800626,59.2343506 C37.3648565,59.2343506 37.2990244,58.9355 37.2601237,58.8548103 C36.6713756,57.6220517 35.9951008,56.8704425 34.7689786,56.8704425 C32.9144595,56.8704425 32.0219863,58.368431 32.0219863,60.5141782 C32.0219863,62.5217069 32.9728107,64.5284885 34.7981542,64.5284885 C36.2898489,64.5284885 37.2234672,63.3764195 37.3656046,62.8444655 C37.3835588,62.764523 37.4411618,62.6942931 37.4987649,62.6942931 C37.5473908,62.6942931 37.5945206,62.764523 37.5847954,62.8227989 L37.3656046,63.9741207 C37.3566275,64.0219368 36.6811008,64.8848678 34.5400626,64.8848678 C32.5920321,64.8848678 31.1938489,63.2598678 31.1938489,60.8705575 C31.1931008,58.4834885 32.6114824,56.5357299 34.6178641,56.5357299","id":"Fill-28","key":10}),React.createElement("path",{"d":"M39.5137496,60.3757356 C39.5137496,60.5968851 40.1039939,60.5378621 40.5491084,60.5378621 C40.9598107,60.5378621 41.8724824,60.3294138 41.8724824,58.9001609 C41.8724824,57.4925747 40.9882382,57.0196437 40.056116,57.0196437 C39.712742,57.0196437 39.5137496,56.997977 39.5137496,57.447 L39.5137496,60.3757356 Z M42.9759176,63.5480345 C43.6604214,64.8144138 44.1257344,64.3892989 44.1257344,64.6642414 C44.1257344,64.8047011 43.592345,64.8047011 43.5063145,64.8047011 C42.8143298,64.8047011 42.4432763,64.2182069 42.0797038,63.5584943 L41.0241466,61.542 C40.6830168,60.8949885 40.8259023,60.9286092 39.7598718,60.9286092 C39.4568947,60.9286092 39.5137496,61.1385517 39.5137496,61.2528621 L39.5137496,63.6862529 C39.5137496,64.6784368 40.5034748,64.3213103 40.5034748,64.7135517 C40.5034748,64.8278621 40.4152,64.8047011 40.3411389,64.8047011 C40.2536122,64.8047011 40.0374137,64.7576322 39.2481771,64.7576322 C38.8868489,64.7576322 38.5247725,64.8047011 38.1619481,64.8047011 C38.1058412,64.8047011 38.0676885,64.7479195 38.0676885,64.6776897 C38.0676885,64.3885517 38.7626656,64.5506782 38.7626656,63.675046 L38.7626656,57.8048736 C38.7626656,56.6976322 37.9457496,57.1728046 37.9457496,56.7798161 C37.9457496,56.7088391 38.0198107,56.6415977 38.1335206,56.6415977 C38.3055817,56.6415977 38.2584519,56.6871724 38.7432153,56.6871724 C39.2930626,56.6871724 39.835429,56.6415977 40.3299176,56.6415977 C40.4825282,56.6415977 42.5854137,56.4099885 42.5854137,58.6341839 C42.5854137,59.532977 42.0520244,60.3077471 41.3862229,60.6312529 L42.9759176,63.5480345 Z","id":"Fill-30","key":11}),React.createElement("path",{"d":"M45.9627481,60.8952126 C45.8939237,61.0588333 45.9627481,61.104408 46.0854351,61.104408 L47.9691298,61.104408 C48.1785954,61.104408 48.1688702,61.0237184 48.1194962,60.8713046 L47.187374,58.0919943 C47.1402443,57.954523 47.0923664,57.954523 47.0355115,58.0919943 L45.9627481,60.8952126 Z M48.5294504,62.049523 C48.4344427,61.783546 48.3768397,61.6117069 48.1112672,61.6117069 L46.0181069,61.6117069 C45.8378168,61.6117069 45.6672519,61.6117069 45.5722443,61.8522816 L44.9618015,63.467569 C44.9341221,63.5490057 44.8974656,63.721592 44.8974656,63.8687759 C44.8974656,64.6779138 45.5722443,64.3334885 45.5722443,64.6308448 C45.5722443,64.8407874 45.4383359,64.8041782 45.3156489,64.8041782 C45.047084,64.8041782 44.7837557,64.7578563 44.516687,64.7578563 C44.2585954,64.7578563 44.0034962,64.8041782 43.7543817,64.8041782 C43.6982748,64.8041782 43.6690992,64.7473966 43.6690992,64.6771667 C43.6690992,64.4336034 44.1179542,64.6300977 44.3633282,63.9741207 L46.6375267,58.0919943 C47.1970992,56.6410747 47.2247786,56.4550402 47.3489618,56.4550402 C47.4536947,56.4550402 47.521771,56.7905 47.5494504,56.8838908 L49.5281527,62.8227989 C49.6717863,63.2471667 49.7854962,63.7327989 50.004687,64.1355 C50.2897099,64.6644655 50.8388092,64.4141782 50.8388092,64.6995805 C50.8388092,64.8041782 50.7729771,64.8041782 50.7063969,64.8041782 C50.3173893,64.8041782 49.9261374,64.7571092 49.5356336,64.7571092 C49.2790382,64.7571092 49.0224427,64.8041782 48.7680916,64.8041782 C48.7112366,64.8041782 48.5578779,64.8041782 48.5578779,64.6891207 C48.5578779,64.4141782 49.1271756,64.5277414 49.1271756,64.088431 C49.1271756,63.8373966 48.9281832,63.3054425 48.8324275,62.9961322 L48.5294504,62.049523 Z","id":"Fill-32","key":12}),React.createElement("path",{"d":"M52.7105344,59.9962701 C52.7105344,60.3877644 52.6940763,60.3877644 53.0718626,60.3877644 L54.0997405,60.3877644 C55.0887176,60.3877644 54.8321221,59.4650632 55.059542,59.4650632 C55.1358473,59.4650632 55.1642748,59.5905805 55.1642748,59.6854655 C55.1642748,60.0889138 55.1463206,60.4811552 55.1463206,60.8494885 C55.1463206,61.1490862 55.1642748,61.4501782 55.1642748,61.7602356 C55.1642748,61.8640862 55.1261221,61.9081667 55.059542,61.9081667 C54.7647939,61.9081667 55.0887176,60.8950632 54.2890076,60.8950632 L52.8825954,60.8950632 C52.6634046,60.8950632 52.7105344,61.0893161 52.7105344,61.2641437 L52.7105344,63.594431 C52.7105344,64.6889713 53.606,64.3893736 53.606,64.6546034 C53.606,64.8144885 53.4646107,64.8144885 53.3957863,64.8144885 C53.3299542,64.8144885 53.2349466,64.7577069 52.3499542,64.7577069 C51.8629466,64.7577069 51.531542,64.8144885 51.3609771,64.8144885 C51.2846718,64.8144885 51.2659695,64.7360402 51.2659695,64.7128793 C51.2659695,64.3893736 51.9594504,64.7255805 51.9594504,63.4465 L51.9594504,58.128454 C51.9594504,57.6092011 51.9594504,57.0555805 51.4447634,56.9614425 C51.3692061,56.9390287 51.1604885,56.9173621 51.1604885,56.7791437 C51.1604885,56.6857529 51.2173435,56.6416724 51.4941374,56.6416724 C53.2918015,56.6416724 53.7870382,56.6857529 54.1850229,56.6857529 C54.3757863,56.6857529 55.2503053,56.6416724 55.5450534,56.6416724 C55.6221069,56.6416724 55.6400611,56.7552356 55.6400611,56.8956954 C55.6400611,58.1725345 55.5083969,58.2674195 55.451542,58.2674195 C55.2211298,58.2674195 55.3729924,57.7123046 55.2211298,57.4470747 C54.9742595,57.0555805 53.9852824,57.1250632 53.606,57.1250632 C52.6948244,57.1250632 52.7105344,57.0794885 52.7105344,57.8490287 L52.7105344,59.9962701","id":"Fill-34","key":13}),React.createElement("path",{"d":"M58.7946137,57.8045747 C58.7946137,57.7246322 58.8335145,57.2875632 58.6996061,57.2741149 L57.1495603,57.2741149 C56.5578198,57.2741149 56.5398656,57.4467011 56.3693008,58.0832529 C56.3401252,58.1945747 56.3296519,58.3462414 56.2069649,58.3462414 C56.1501099,58.3462414 56.1119573,58.267046 56.1119573,58.2072759 L56.2174382,57.0903218 C56.2271634,56.9506092 56.2174382,56.6405517 56.387255,56.6405517 C57.1286137,56.6405517 57.8624916,56.6861264 59.0886137,56.6861264 C60.8099725,56.6861264 61.6844916,56.6405517 61.8737588,56.6405517 C62.0944458,56.6405517 62.1430718,56.7077931 62.1520489,56.9745172 L62.1961863,57.8979655 C62.2074076,58.0115287 62.2163847,58.1504943 62.0944458,58.1504943 C61.7413466,58.1504943 62.2575298,57.2741149 61.2857588,57.2741149 L59.9257282,57.2741149 C59.4970718,57.2741149 59.5456977,57.2285402 59.5456977,57.8396897 L59.5456977,63.7218161 C59.5456977,64.6893448 60.3169802,64.3083103 60.3169802,64.6646897 C60.3169802,64.6998046 60.3274534,64.8044023 60.2302015,64.8044023 C60.0012855,64.8044023 59.735713,64.7580805 59.4596672,64.7580805 C58.3943847,64.7580805 58.2133466,64.8044023 58.1557435,64.8044023 C58.0712092,64.8044023 58.0435298,64.7707816 58.0435298,64.654977 C58.0435298,64.3785402 58.7946137,64.4928506 58.7946137,63.8017586 L58.7946137,57.8045747","id":"Fill-36","key":14}),React.createElement("path",{"d":"M64.1006779,59.9962701 C64.1006779,60.3877644 64.0842198,60.3877644 64.4620061,60.3877644 L65.4891359,60.3877644 C66.4773649,60.3877644 66.2207695,59.4650632 66.4496855,59.4650632 C66.5252427,59.4650632 66.5529221,59.5905805 66.5529221,59.6854655 C66.5529221,60.0889138 66.535716,60.4811552 66.535716,60.8494885 C66.535716,61.1490862 66.5529221,61.4501782 66.5529221,61.7602356 C66.5529221,61.8640862 66.5155176,61.9081667 66.4496855,61.9081667 C66.1526931,61.9081667 66.4773649,60.8950632 65.6784031,60.8950632 L64.2719908,60.8950632 C64.0722504,60.8950632 64.1006779,61.0893161 64.1006779,61.2641437 L64.1006779,63.3867299 C64.1006779,64.0666149 64.0236244,64.3437989 64.8233344,64.3437989 C67.0204794,64.3437989 67.3421588,63.1566149 67.466342,63.1566149 C67.532174,63.1566149 67.5433954,63.2709253 67.5433954,63.2955805 C67.5433954,63.7087414 67.2957771,64.114431 67.0676092,64.4147759 C66.763884,64.8279368 66.5529221,64.805523 66.1339908,64.805523 C65.4120824,64.805523 64.690174,64.7367874 63.9667695,64.7577069 C63.5867389,64.7719023 63.1850137,64.805523 62.8072275,64.805523 C62.7204489,64.805523 62.6635939,64.7838563 62.6635939,64.6889713 C62.6830443,64.5522471 62.7788,64.5769023 63.0825252,64.3901207 C63.3286473,64.2519023 63.3488458,63.9291437 63.3488458,63.387477 L63.3488458,58.128454 C63.3488458,57.6092011 63.3488458,57.0555805 62.8364031,56.9614425 C62.7586015,56.9397759 62.5506321,56.9173621 62.5506321,56.7791437 C62.5506321,56.6865 62.6067389,56.6416724 62.8820366,56.6416724 C64.6797008,56.6416724 65.1741893,56.6865 65.5744183,56.6865 C65.7644336,56.6865 66.6397008,56.6416724 66.9329527,56.6416724 C67.0107542,56.6416724 67.0302046,56.7559828 67.0302046,56.8956954 C67.0302046,58.1732816 66.8933038,58.2674195 66.8394412,58.2674195 C66.6112733,58.2674195 66.763884,57.7123046 66.6112733,57.4470747 C66.3629069,57.0555805 65.3746779,57.1258103 64.9931511,57.1258103 C64.0842198,57.1258103 64.1006779,57.0794885 64.1006779,57.8497759 L64.1006779,59.9962701","id":"Fill-38","key":15}),React.createElement("path",{"d":"M69.0443664,60.3757356 C69.0443664,60.5968851 69.6346107,60.5378621 70.0804733,60.5378621 C70.4896794,60.5378621 71.4038473,60.3294138 71.4038473,58.9001609 C71.4038473,57.4925747 70.5173588,57.0196437 69.5874809,57.0196437 C69.2463511,57.0196437 69.0443664,56.997977 69.0443664,57.447 L69.0443664,60.3757356 Z M72.5072824,63.5480345 C73.1910382,64.8144138 73.6570992,64.3892989 73.6570992,64.6642414 C73.6570992,64.8047011 73.1237099,64.8047011 73.0384275,64.8047011 C72.3449466,64.8047011 71.9753893,64.2182069 71.613313,63.5584943 L70.5570076,61.542 C70.2143817,60.8949885 70.3565191,60.9286092 69.2934809,60.9286092 C68.9875115,60.9286092 69.0443664,61.1385517 69.0443664,61.2528621 L69.0443664,63.6862529 C69.0443664,64.6784368 70.0318473,64.3213103 70.0318473,64.7135517 C70.0318473,64.8278621 69.9480611,64.8047011 69.8710076,64.8047011 C69.7864733,64.8047011 69.5680305,64.7576322 68.7787939,64.7576322 C68.4167176,64.7576322 68.0568855,64.8047011 67.6940611,64.8047011 C67.6372061,64.8047011 67.5975573,64.7479195 67.5975573,64.6776897 C67.5975573,64.3885517 68.2932824,64.5506782 68.2932824,63.675046 L68.2932824,57.8048736 C68.2932824,56.6976322 67.4763664,57.1728046 67.4763664,56.7798161 C67.4763664,56.7088391 67.5526718,56.6415977 67.6678779,56.6415977 C67.8376947,56.6415977 67.7898168,56.6871724 68.2745802,56.6871724 C68.8266718,56.6871724 69.367542,56.6415977 69.8627786,56.6415977 C70.0146412,56.6415977 72.1152824,56.4099885 72.1152824,58.6341839 C72.1152824,59.532977 71.5841374,60.3077471 70.9175878,60.6312529 L72.5072824,63.5480345 Z","id":"Fill-40","key":16}),React.createElement("path",{"d":"M73.7330305,62.7644483 C73.6933817,62.5335862 73.7427557,62.408069 73.8355191,62.408069 C73.9694275,62.408069 73.9694275,62.5470345 74.0173053,62.7876092 C74.1325115,63.3173218 74.7033053,64.5172069 76.0169542,64.5172069 C76.9176565,64.5172069 77.8033969,63.9060575 77.8033969,62.6942184 C77.8033969,60.4692759 73.9417481,61.7154828 73.9417481,58.7045632 C73.9417481,57.2387011 74.9606489,56.5356552 76.0521145,56.5356552 C77.2049237,56.5356552 77.517626,56.9510575 77.6515344,56.9510575 C77.7368168,56.9510575 77.7555191,56.8255402 77.8505267,56.8255402 C77.9073817,56.8255402 77.9552595,56.8584138 77.9649847,56.9861724 L78.1071221,58.5543908 C78.1175954,58.6462874 78.0959008,58.726977 78.000145,58.726977 C77.8984046,58.726977 77.8318244,58.4834138 77.8033969,58.3825517 C77.517626,57.3903678 76.8233969,56.8838161 75.9870305,56.8838161 C75.2351985,56.8838161 74.4369847,57.3201379 74.4369847,58.3825517 C74.4369847,60.5499655 78.2986336,59.2828391 78.2986336,62.4626092 C78.2986336,63.4331264 77.7368168,64.8847931 75.5770763,64.8847931 C74.8738702,64.8847931 74.0098244,64.4604253 73.9694275,64.2512299 L73.7330305,62.7644483","id":"Fill-42","key":17}),React.createElement("path",{"d":"M82.7803008,63.3868046 C82.7803008,64.0666897 82.7062397,64.3438736 83.5044534,64.3438736 C85.7023466,64.3438736 86.0255221,63.1566897 86.1504534,63.1566897 C86.2155374,63.1566897 86.2252626,63.271 86.2252626,63.2956552 C86.2252626,63.7088161 85.9768962,64.1145057 85.7479802,64.4148506 C85.444255,64.8280115 85.2347893,64.8048506 84.815858,64.8048506 C84.0939496,64.8048506 83.3727893,64.7368621 82.6486366,64.7577816 C82.2686061,64.771977 81.8691252,64.8048506 81.4883466,64.8048506 C81.4045603,64.8048506 81.344713,64.783931 81.344713,64.689046 C81.3656595,64.5523218 81.4606672,64.576977 81.7651405,64.3901954 C82.0127588,64.251977 82.030713,63.9292184 82.030713,63.3875517 L82.030713,57.539046 C82.030713,56.9398506 81.2324992,57.0197931 81.2324992,56.7904253 C81.2324992,56.6634138 81.2975832,56.6417471 81.4217664,56.6417471 C81.6200107,56.6417471 81.9177511,56.6865747 82.3830641,56.6865747 C82.9254305,56.6865747 83.1528504,56.6417471 83.2942397,56.6417471 C83.419171,56.6417471 83.4775221,56.6634138 83.4775221,56.8023793 C83.4775221,57.0691034 82.7803008,56.7792184 82.7803008,57.7811149 L82.7803008,63.3868046","id":"Fill-44","key":18}),React.createElement("path",{"d":"M88.0680366,63.3868046 C88.0680366,64.0666897 87.9924794,64.3438736 88.7929374,64.3438736 C90.9855939,64.3438736 91.3095176,63.1566897 91.435945,63.1566897 C91.501029,63.1566897 91.5129985,63.271 91.5129985,63.2956552 C91.5129985,63.7088161 91.263884,64.1145057 91.0349679,64.4148506 C90.7319908,64.8280115 90.5225252,64.8048506 90.1035939,64.8048506 C89.3816855,64.8048506 88.6560366,64.7368621 87.9348763,64.7577816 C87.556342,64.771977 87.1538687,64.8048506 86.7745863,64.8048506 C86.6885557,64.8048506 86.6317008,64.783931 86.6317008,64.689046 C86.6518992,64.5523218 86.7439145,64.576977 87.0491359,64.3901954 C87.2967542,64.251977 87.3162046,63.9292184 87.3162046,63.3875517 L87.3162046,57.539046 C87.3162046,56.9398506 86.5179908,57.0197931 86.5179908,56.7904253 C86.5179908,56.6634138 86.5853191,56.6417471 86.7080061,56.6417471 C86.9062504,56.6417471 87.2032427,56.6865747 87.6685557,56.6865747 C88.210174,56.6865747 88.4375939,56.6417471 88.5812275,56.6417471 C88.7061588,56.6417471 88.7622656,56.6634138 88.7622656,56.8023793 C88.7622656,57.0691034 88.0680366,56.7792184 88.0680366,57.7811149 L88.0680366,63.3868046","id":"Fill-46","key":19}),React.createElement("path",{"d":"M95.0003023,56.5357299 C96.7882412,56.5357299 97.2827298,57.4263046 97.5580275,57.4263046 C97.6343328,57.4263046 97.6904397,57.3090057 97.7876916,57.3090057 C97.8909282,57.3090057 97.8909282,57.4920517 97.9193557,58.2436609 C97.9388061,58.8548103 98.0255847,59.2343506 97.8617527,59.2343506 C97.7480427,59.2343506 97.6822107,58.9355 97.6425618,58.8548103 C97.0545618,57.6220517 96.3790351,56.8704425 95.152913,56.8704425 C93.2968977,56.8704425 92.4044244,58.368431 92.4044244,60.5141782 C92.4044244,62.5217069 93.3537527,64.5284885 95.1790962,64.5284885 C96.672287,64.5284885 97.6059053,63.3764195 97.7480427,62.8444655 C97.766745,62.764523 97.8243481,62.6942931 97.8819511,62.6942931 C97.9275847,62.6942931 97.9777069,62.764523 97.9687298,62.8227989 L97.7480427,63.9741207 C97.7390656,64.0219368 97.0627908,64.8848678 94.924745,64.8848678 C92.9744702,64.8848678 91.576287,63.2598678 91.576287,60.8705575 C91.576287,58.4834885 92.9931725,56.5357299 95.0003023,56.5357299","id":"Fill-48","key":20}),React.createElement("path",{"d":"M96.6382489,55.2333391 L96.8260198,55.2333391 L96.8260198,54.8015 L96.9733939,54.8015 C97.0736382,54.8015 97.1424626,54.8127069 97.1821115,54.8351207 C97.2494397,54.8754655 97.2831038,54.9606379 97.2831038,55.0869023 L97.2831038,55.173569 L97.2860962,55.209431 C97.2868443,55.2146609 97.2868443,55.2183966 97.2890885,55.2228793 C97.2890885,55.2266149 97.2890885,55.2296034 97.2920809,55.2333391 L97.4686305,55.2333391 L97.4618977,55.2183966 C97.4574092,55.209431 97.4551649,55.1915 97.4514244,55.1646034 C97.4499282,55.1339713 97.4484321,55.1055805 97.4484321,55.0801782 L97.4484321,55.0002356 C97.4484321,54.9442011 97.431226,54.8889138 97.3915771,54.8298908 C97.3519282,54.7723621 97.2890885,54.7357529 97.2075466,54.7208103 C97.2718824,54.7103506 97.325745,54.6931667 97.3631496,54.6692586 C97.431226,54.6221897 97.4648901,54.5512126 97.4648901,54.4540862 C97.4648901,54.3143736 97.4117756,54.2217299 97.3025542,54.1739138 C97.2419588,54.1492586 97.1424626,54.1350632 97.0085542,54.1350632 L96.6389969,54.1350632 L96.6389969,55.2333391 L96.6382489,55.2333391 Z M97.1738824,54.6423621 C97.1334855,54.6580517 97.0736382,54.6640287 96.9943405,54.6640287 L96.8260198,54.6640287 L96.8260198,54.2687989 L96.9861115,54.2687989 C97.0900962,54.2687989 97.1649053,54.2822471 97.2105389,54.3083966 C97.2569206,54.3360402 97.2823557,54.3890862 97.2823557,54.470523 C97.2823557,54.5519598 97.2456992,54.6117299 97.1738824,54.6423621 Z M97.7155008,53.9811552 C97.5269817,53.7869023 97.2965695,53.6912701 97.0287527,53.6912701 C96.7609359,53.6912701 96.533516,53.7869023 96.3464931,53.9811552 C96.1549817,54.1769023 96.0637145,54.4129943 96.0637145,54.6871897 C96.0637145,54.9636264 96.1549817,55.2004655 96.3435008,55.3962126 C96.5305237,55.5912126 96.7601878,55.6898333 97.0287527,55.6898333 C97.2973176,55.6898333 97.5277298,55.5912126 97.7155008,55.3962126 C97.9062641,55.1997184 97.9997756,54.9636264 97.9997756,54.6871897 C97.9997756,54.4115 97.905516,54.1769023 97.7155008,53.9811552 Z M97.619745,54.080523 C97.7798366,54.2471322 97.8606305,54.4496034 97.8606305,54.6871897 C97.8606305,54.925523 97.7798366,55.1294885 97.619745,55.2990862 C97.4581573,55.4679368 97.2569206,55.5516149 97.0287527,55.5516149 C96.7968443,55.5516149 96.6023405,55.4679368 96.4400046,55.2990862 C96.279913,55.1294885 96.1991191,54.925523 96.1991191,54.6871897 C96.1991191,54.4496034 96.279913,54.2471322 96.4400046,54.080523 C96.6053328,53.9109253 96.7983405,53.8265 97.0287527,53.8265 C97.2569206,53.8265 97.4566611,53.9109253 97.619745,54.080523 Z","id":"Fill-50","key":21})])])))]);
	}
	
	AllCladLogo.defaultProps = {"width":"98px","height":"71px","viewBox":"0 0 160 71","version":"1.1"};
	
	module.exports = AllCladLogo;
	
	AllCladLogo.default = AllCladLogo;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function AmerluxLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".eb305871-dc51-4f32-ba65-80621958253f{fill:#fff;}.af84f118-9799-43c4-b12a-5e196ea07a8c{fill:#f9a526;}.fdc7c882-9687-4990-88e7-28a355d81b63{fill:#fff100;}.ed0f78f9-ede6-4a51-9d14-1a218084a362{fill:#ec1a3b;}.ec5363fc-59bd-44e4-8ec9-8edf9eeb9bd4{fill:#ce118b;}.ec811bcb-6d63-47e5-8171-3f0fc6e71be3{fill:#00adee;}")),React.createElement("title",{"key":1},"amerlux-logo"),React.createElement("path",{"className":"eb305871-dc51-4f32-ba65-80621958253f","d":"M78.61,38.85l-2.49,1.32a7.25,7.25,0,0,1-4.06,6.75,7.51,7.51,0,0,1-9.78-2.17,10.2,10.2,0,0,1-1.7-3.43,7.69,7.69,0,0,1,13.73-6.27L62.49,41.32l1,1.91L77.68,35.7a10.32,10.32,0,1,0-18.53,9,10.15,10.15,0,0,0,14,4.26,10.3,10.3,0,0,0,4.17-4.05,10.42,10.42,0,0,0,1.28-6.09","transform":"translate(0 -0.12)","key":2}),React.createElement("path",{"className":"eb305871-dc51-4f32-ba65-80621958253f","d":"M16.12,48.29a9.22,9.22,0,0,1-1.69,1.07,9.52,9.52,0,0,1-4.32,1,9.56,9.56,0,0,1-7.14-3A10.16,10.16,0,0,1,0,40a10,10,0,0,1,3-7.27,9.72,9.72,0,0,1,7.16-3,9.36,9.36,0,0,1,4.38,1A10.1,10.1,0,0,1,18,33.79V30.18h2.49l.06,19.65H18.12V40.1a7.83,7.83,0,0,0-2.26-5.69,7.45,7.45,0,0,0-5.54-2.27,7.57,7.57,0,0,0-6.72,4,7.91,7.91,0,0,0,0,7.93A7.8,7.8,0,0,0,6.51,47a7.4,7.4,0,0,0,3.85,1A7.85,7.85,0,0,0,14.29,47a7.72,7.72,0,0,0,1.84-1.44v2.76","transform":"translate(0 -0.12)","key":3}),React.createElement("path",{"className":"eb305871-dc51-4f32-ba65-80621958253f","d":"M24.8,30.16h2.53v3.39A9.83,9.83,0,0,1,30,30.79a7.8,7.8,0,0,1,4-1.17,6.61,6.61,0,0,1,2.71.56,5.73,5.73,0,0,1,2.1,1.48,7.74,7.74,0,0,1,1.42,2.66,9.31,9.31,0,0,1,3.15-3.53,7.42,7.42,0,0,1,4.06-1.21,6.35,6.35,0,0,1,3.6,1,6.09,6.09,0,0,1,2.32,2.86A15.35,15.35,0,0,1,54.21,39l0,10.72H51.66l0-10.73a14.18,14.18,0,0,0-.47-4.34,4,4,0,0,0-1.54-1.9A4.72,4.72,0,0,0,47,32a5.66,5.66,0,0,0-3.35,1.09A6.22,6.22,0,0,0,41.45,36a18.06,18.06,0,0,0-.69,6l0,7.69H38.26l0-10.06a17.26,17.26,0,0,0-.46-4.83,4.06,4.06,0,0,0-1.55-2,4.47,4.47,0,0,0-2.62-.76,5.65,5.65,0,0,0-3.27,1.07A6.13,6.13,0,0,0,28.08,36a15.29,15.29,0,0,0-.72,5.47l0,8.33H24.86L24.8,30.16","transform":"translate(0 -0.12)","key":4}),React.createElement("path",{"className":"eb305871-dc51-4f32-ba65-80621958253f","d":"M82.58,30h2.58v2.87a9.2,9.2,0,0,1,2.43-2.55,4.86,4.86,0,0,1,2.67-.84,4.67,4.67,0,0,1,2.24.66L91.2,32.24a3.2,3.2,0,0,0-3.78.71,6.58,6.58,0,0,0-1.77,3.23A30.85,30.85,0,0,0,85.2,43l0,6.65H82.64L82.58,30","transform":"translate(0 -0.12)","key":5}),React.createElement("polyline",{"className":"eb305871-dc51-4f32-ba65-80621958253f","points":"96.1 22.24 98.63 22.23 98.71 49.46 96.18 49.47 96.1 22.24","key":6}),React.createElement("path",{"className":"eb305871-dc51-4f32-ba65-80621958253f","d":"M103.22,29.91h2.53l0,9.17a19.46,19.46,0,0,0,.37,4.62,5.18,5.18,0,0,0,2.08,2.85,6.36,6.36,0,0,0,3.65,1,6.05,6.05,0,0,0,3.58-1,5.23,5.23,0,0,0,2-2.68,19,19,0,0,0,.36-4.83l0-9.17h2.58l0,9.65a15.17,15.17,0,0,1-.93,6.12,7.31,7.31,0,0,1-2.84,3.23,10.41,10.41,0,0,1-9.57,0,7.09,7.09,0,0,1-2.88-3.24,15.83,15.83,0,0,1-1-6.27l0-9.47","transform":"translate(0 -0.12)","key":7}),React.createElement("polyline",{"className":"eb305871-dc51-4f32-ba65-80621958253f","points":"124.34 29.73 127.37 29.72 132.62 36.9 137.76 29.69 140.8 29.68 134.15 38.99 148.9 59.33 145.96 59.33 132.63 41.1 126.71 49.37 123.69 49.38 131.1 39.01 124.34 29.73","key":8}),React.createElement("path",{"className":"eb305871-dc51-4f32-ba65-80621958253f","d":"M115.37,18.31a58.19,58.19,0,0,1,6.94,8.18h3a58,58,0,0,0-7.94-9.67,59.33,59.33,0,0,0-77.29-4.51,59.31,59.31,0,0,1,75.26,6Z","transform":"translate(0 -0.12)","key":9}),React.createElement("path",{"className":"af84f118-9799-43c4-b12a-5e196ea07a8c","d":"M49.69,12.63c0,.3-.86.53-1.93.53s-1.94-.23-1.94-.53.86-.53,1.94-.53S49.69,12.34,49.69,12.63Z","transform":"translate(0 -0.12)","key":10}),React.createElement("path",{"className":"fdc7c882-9687-4990-88e7-28a355d81b63","d":"M42.56,16.88c0,.27-.82.5-1.83.5s-1.82-.23-1.82-.5.82-.5,1.82-.5S42.56,16.6,42.56,16.88Z","transform":"translate(0 -0.12)","key":11}),React.createElement("path",{"className":"ed0f78f9-ede6-4a51-9d14-1a218084a362","d":"M57.86,9c0,.31-.92.56-2,.56S53.75,9.34,53.75,9s.92-.56,2.06-.56S57.86,8.72,57.86,9Z","transform":"translate(0 -0.12)","key":12}),React.createElement("path",{"className":"ec5363fc-59bd-44e4-8ec9-8edf9eeb9bd4","d":"M66.53,6.49c0,.32-1,.59-2.17.59s-2.16-.27-2.16-.59,1-.59,2.16-.59S66.53,6.16,66.53,6.49Z","transform":"translate(0 -0.12)","key":13}),React.createElement("path",{"className":"ec811bcb-6d63-47e5-8171-3f0fc6e71be3","d":"M76.91,5.46c0,.35-1,.63-2.28.63s-2.28-.28-2.28-.63,1-.62,2.28-.62S76.91,5.12,76.91,5.46Z","transform":"translate(0 -0.12)","key":14})]);
	}
	
	AmerluxLogo.defaultProps = {"id":"a2bf2ff7-140e-496c-a8ea-0804d4da856e","data-name":"Layer 1","width":"98px","height":"71px","viewBox":"0 0 160 71"};
	
	module.exports = AmerluxLogo;
	
	AmerluxLogo.default = AmerluxLogo;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function CentricaLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".f3e05613-e80d-4fc3-9ed6-b2132b0eadb9{fill:#fff;}")),React.createElement("title",{"key":1},"centrica-logo"),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M80.17.82C78.41,1.94,77.67,4,78.56,5.33s3,1.42,4.8.29S85.81,2.43,85,1.11A2.61,2.61,0,0,0,82.7,0a4.62,4.62,0,0,0-2.53.82M57.72,3c-1.87,0-2.51,0-2.51,0l-1,4.41H51.59a3.76,3.76,0,0,1,1.22,1.38,5.92,5.92,0,0,1,.25,3.28c-.45,2.5-1,4.91-1,4.91-.93,4.26.79,5.63,4.81,5.63a21,21,0,0,0,3.53-.29l.84-4a14.77,14.77,0,0,1-2.26.2,1.13,1.13,0,0,1-1.27-1.18A8.43,8.43,0,0,1,58,15.77l1-4.51h3.83l.88-3.78h-4l1-4.56s-.88.05-2.94.1M0,15.57c0,3.24,1.37,7.17,8,7.17a8.41,8.41,0,0,0,8.48-6.62H10.89c-.45,1.27-1.43,2.69-2.85,2.69-1.71,0-2.16-1.27-2-3.38.1-1.08.74-4.91,3.34-4.91,1.86,0,2,1.92,2,2.65H17c0-4.26-3-6.57-7.46-6.57a9.27,9.27,0,0,0-9.56,9m119,0-101.36.35c0,4,2.36,6.82,7.85,6.82a8.1,8.1,0,0,0,7.94-5H28a2.19,2.19,0,0,1-2.21,1.33,2.09,2.09,0,0,1-2-1.08,4.12,4.12,0,0,1-.39-2.11H34a9.73,9.73,0,0,0,.29-2.55C34.32,8.86,31,6.8,27,6.8c-4.32,0-9.37,2.69-9.37,9.12m9.17-5.64c1.62,0,2.4.93,2.11,2.7H23.88a3.17,3.17,0,0,1,2.94-2.7m73.61,6.27c0,2.7,1.07,6.18,5.44,6.18a6.3,6.3,0,0,0,4.75-2.15v.05a4.11,4.11,0,0,0,.3,1.76h5.69a7,7,0,0,1,0-3.68C117,17.39,119,7.48,119,7.48h-5.69l-.44,1.92c-.69-1.38-2.16-2.31-4.41-2.31-5.25,0-8,5.1-8,9.46m6-.44c0-2.35,1.32-5.15,3.33-5.15,1.67,0,2.26,1.13,2.26,2.65,0,3.14-1.52,5.1-3.39,5.1-1.32,0-2.2-.73-2.2-2.6m-23.59-.24c.05,3.19,1.52,6.86,8.09,6.86,3.88,0,7.55-2.15,8.49-6.37H93.76a3.24,3.24,0,0,1-2.9,2.45c-1.61,0-2.1-1-2-3.14,0-1.12.69-4.71,3.34-4.71,1.86,0,2,1.77,2,2.46h5.64c0-4.27-3-6.33-7.46-6.33-5.83,0-9.56,4.37-9.56,8.78M42,9.59l.59-2.11H37.07L34,22.39h5.69l1.67-7.89c.34-1.57.93-2.85,2.74-2.85.94,0,1.62.49,1.62,1.42a22.38,22.38,0,0,1-.44,2.51l-1.47,6.81h5.59L51.19,14a14.14,14.14,0,0,0,.4-2.85c0-3.09-2.46-4-4.42-4A6.67,6.67,0,0,0,42,9.59m28,.49V10l.59-2.55H65.07L62,22.39h5.69L69,16.16c.59-2.74,1.77-3.82,3.58-3.82a5.85,5.85,0,0,1,2.36.39L76,7.63a3.87,3.87,0,0,0-1.62-.24A5.58,5.58,0,0,0,70,10.08m7.51-2.6L74.39,22.39h5.68L83.16,7.48Z","key":2}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M4.89,30.49v.2a1.77,1.77,0,0,1-1.26,1.88v0a1.9,1.9,0,0,1,1.8,2v.19c0,1.79-1.33,2.44-3.38,2.44-.61,0-1.16,0-1.72,0-.21,0-.3-.09-.3-.34V29c0-.24,0-.31.26-.36a8.7,8.7,0,0,1,1.79-.19C3.85,28.42,4.89,29,4.89,30.49ZM1,29.46v2.86h.94c1.28,0,2-.34,2-1.64v-.14c0-1-.59-1.37-1.82-1.37a4.55,4.55,0,0,0-1,.1C1,29.3,1,29.34,1,29.46Zm0,3.62v3.19c0,.13.06.17.16.18a9.75,9.75,0,0,0,1,0c1.29,0,2.36-.28,2.36-1.68v-.15c0-1.19-.66-1.57-2.33-1.57Z","key":3}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M11.47,30.65c.11,0,.15.07.15.18v4.51A1.94,1.94,0,0,1,11,36.87a2.57,2.57,0,0,1-1.83.49,2.76,2.76,0,0,1-1.83-.49,1.89,1.89,0,0,1-.6-1.53V30.87A.2.2,0,0,1,7,30.65h.5a.17.17,0,0,1,.18.19v4.39A1.26,1.26,0,0,0,8,36.28a1.7,1.7,0,0,0,1.21.32,1.62,1.62,0,0,0,1.24-.37,1.19,1.19,0,0,0,.31-1v-4.4a.16.16,0,0,1,.16-.18Z","key":4}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M13.13,37c-.14-.05-.19-.1-.17-.23l.11-.39c0-.14.12-.18.26-.13A4.49,4.49,0,0,0,15,36.6a1.61,1.61,0,0,0,1.14-.27,1,1,0,0,0,.34-.86v-.08c0-.47-.08-.72-.36-.9a3.57,3.57,0,0,0-.94-.28l-.38-.07a3.33,3.33,0,0,1-1.05-.33,1.47,1.47,0,0,1-.68-1.4v-.13c0-1.2.74-1.75,2.15-1.75a5.58,5.58,0,0,1,1.5.19c.16,0,.23.12.2.24l-.08.35c0,.16-.12.23-.31.17a5.77,5.77,0,0,0-1.33-.2,1.55,1.55,0,0,0-1.06.27,1,1,0,0,0-.27.7v.09A.87.87,0,0,0,14,33c.17.18.42.28,1.05.41l.35.06a2.55,2.55,0,0,1,1.46.65,2,2,0,0,1,.34,1.18v.13a2.06,2.06,0,0,1-.38,1.25,2.28,2.28,0,0,1-1.91.68A5.06,5.06,0,0,1,13.13,37Z","key":5}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M19.84,29a.56.56,0,0,1-.59.64H19.2c-.45,0-.62-.2-.62-.64v-.08a.56.56,0,0,1,.62-.63h.05c.35,0,.59.17.59.63Zm-.19,8.17c0,.06,0,.1-.12.1h-.64c-.08,0-.11,0-.11-.1V30.8c0-.09,0-.15.16-.15h.55a.14.14,0,0,1,.16.15Z","key":6}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M26.34,37.23H26c-.22,0-.24,0-.24-.22V33.08c0-.82-.16-1.29-.62-1.57A2.07,2.07,0,0,0,24,31.26a1.5,1.5,0,0,0-1.32.56,1.72,1.72,0,0,0-.24,1V37c0,.15-.08.2-.24.2H21.8c-.16,0-.21,0-.21-.2V30.8c0-.09,0-.15.13-.15h.41c.1,0,.14,0,.16.15l.06.54h0a1.51,1.51,0,0,1,.55-.51,2.61,2.61,0,0,1,1.26-.3,2.25,2.25,0,0,1,2.09.9,3.54,3.54,0,0,1,.32,1.73V37C26.6,37.19,26.49,37.23,26.34,37.23Z","key":7}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M32.82,33.93c0,.38-.12.51-.5.51H28.86c.05,1.61.49,2.16,1.76,2.16a4,4,0,0,0,1.47-.27c.18-.06.29,0,.33.1l.09.31c0,.13.05.23-.29.36a4.67,4.67,0,0,1-1.6.26c-2,0-2.65-1-2.65-3.15v-.54c0-2.1.65-3.14,2.53-3.14a2.43,2.43,0,0,1,1.73.55,2.23,2.23,0,0,1,.59,1.75Zm-4-.26h2.89c.13,0,.18,0,.18-.2V33a1.81,1.81,0,0,0-.31-1.25,1.33,1.33,0,0,0-1.11-.43C29.37,31.28,28.87,31.79,28.86,33.67Z","key":8}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M34.11,37c-.13-.05-.19-.1-.16-.23l.11-.39c0-.14.12-.18.25-.13a4.55,4.55,0,0,0,1.63.32,1.65,1.65,0,0,0,1.14-.27,1,1,0,0,0,.33-.86v-.08c0-.47-.08-.72-.36-.9a3.45,3.45,0,0,0-.94-.28l-.37-.07a3.17,3.17,0,0,1-1.05-.33,1.46,1.46,0,0,1-.69-1.4v-.13c0-1.2.74-1.75,2.15-1.75a5.6,5.6,0,0,1,1.51.19c.16,0,.22.12.2.24l-.08.35c0,.16-.12.23-.31.17a5.77,5.77,0,0,0-1.33-.2,1.52,1.52,0,0,0-1.06.27,1,1,0,0,0-.27.7v.09A.86.86,0,0,0,35,33a1.92,1.92,0,0,0,1,.41l.35.06a2.49,2.49,0,0,1,1.46.65,1.88,1.88,0,0,1,.34,1.18v.13a2,2,0,0,1-.38,1.25,2.28,2.28,0,0,1-1.9.68A5.12,5.12,0,0,1,34.11,37Z","key":9}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M39.4,37c-.13-.05-.18-.1-.16-.23l.11-.39c0-.14.12-.18.26-.13a4.49,4.49,0,0,0,1.62.32,1.61,1.61,0,0,0,1.14-.27,1,1,0,0,0,.34-.86v-.08c0-.47-.08-.72-.36-.9a3.67,3.67,0,0,0-1-.28L41,34.14A3.33,3.33,0,0,1,40,33.81a1.45,1.45,0,0,1-.68-1.4v-.13c0-1.2.73-1.75,2.15-1.75a5.58,5.58,0,0,1,1.5.19c.16,0,.23.12.2.24l-.08.35c0,.16-.12.23-.31.17a5.77,5.77,0,0,0-1.33-.2,1.54,1.54,0,0,0-1.06.27,1,1,0,0,0-.27.7v.09a.87.87,0,0,0,.22.66c.17.18.41.28,1,.41l.35.06a2.55,2.55,0,0,1,1.47.65,2,2,0,0,1,.33,1.18v.13a2.06,2.06,0,0,1-.37,1.25,2.3,2.3,0,0,1-1.91.68A5.16,5.16,0,0,1,39.4,37Z","key":10}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M47.71,37c-.14-.06-.17-.11-.14-.23l.11-.45c0-.12.12-.17.28-.1a5.17,5.17,0,0,0,1.95.41c1.28,0,1.89-.6,1.89-1.64v-.14c0-1-.29-1.32-1.42-1.59l-.9-.21c-1.29-.31-1.91-.94-1.91-2.18v-.2c0-1.45,1-2.22,2.58-2.22a6.5,6.5,0,0,1,1.92.26c.19.05.22.13.18.29l-.1.33c0,.14-.15.17-.32.12a5,5,0,0,0-1.65-.25c-1.1,0-1.67.51-1.67,1.48v.14c0,1,.51,1.23,1.41,1.45l.85.2c1.48.35,2,.93,2,2.24v.22c0,1.65-1,2.46-2.8,2.46A6,6,0,0,1,47.71,37Z","key":11}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M59,34.21a3.41,3.41,0,0,1-.7,2.51,3.1,3.1,0,0,1-3.77,0,3.41,3.41,0,0,1-.7-2.51v-.54a3.47,3.47,0,0,1,.7-2.52,3.18,3.18,0,0,1,3.77,0,3.47,3.47,0,0,1,.7,2.52Zm-4.28-.15a6.7,6.7,0,0,0,.13,1.48,1.69,1.69,0,0,0,3.13,0,6.7,6.7,0,0,0,.13-1.48v-.25a6.76,6.76,0,0,0-.13-1.48,1.69,1.69,0,0,0-3.13,0,6.76,6.76,0,0,0-.13,1.48Z","key":12}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M61.3,35.47c0,.43,0,.7.12.85s.23.15.49.15h.36c.09,0,.16,0,.16.15v.45c0,.1,0,.16-.13.16h-.51a1.44,1.44,0,0,1-1-.3,1.79,1.79,0,0,1-.32-1.24v-7.4c0-.11.07-.15.16-.15h.55c.09,0,.16,0,.16.15Z","key":13}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M68.31,30.65c.11,0,.15.07.15.18v4.51a1.94,1.94,0,0,1-.59,1.53,2.57,2.57,0,0,1-1.83.49,2.73,2.73,0,0,1-1.82-.49,1.87,1.87,0,0,1-.61-1.53V30.87a.2.2,0,0,1,.19-.22h.5a.18.18,0,0,1,.19.19v4.39a1.23,1.23,0,0,0,.35,1.05,1.68,1.68,0,0,0,1.2.32,1.62,1.62,0,0,0,1.24-.37,1.19,1.19,0,0,0,.31-1v-4.4a.16.16,0,0,1,.16-.18Z","key":14}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M72.33,37.23a1.86,1.86,0,0,1-1.5-.53,2.31,2.31,0,0,1-.45-1.55V31.42h-.82c-.09,0-.13,0-.13-.15V31c0-.12,0-.16.13-.17l.82-.18V29.13a.16.16,0,0,1,.17-.16h.56a.15.15,0,0,1,.15.16v1.52h1.57c.09,0,.13,0,.13.14v.49a.12.12,0,0,1-.13.14H71.26V35a1.77,1.77,0,0,0,.24,1.11,1.16,1.16,0,0,0,1,.33H73c.08,0,.16,0,.16.15v.46c0,.09,0,.14-.16.14Z","key":15}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M75.54,29a.56.56,0,0,1-.59.64h0c-.45,0-.62-.2-.62-.64v-.08a.56.56,0,0,1,.62-.63h0c.35,0,.59.17.59.63Zm-.19,8.17c0,.06,0,.1-.12.1h-.64c-.08,0-.11,0-.11-.1V30.8c0-.09,0-.15.16-.15h.55a.14.14,0,0,1,.16.15Z","key":16}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M82.14,34.21a3.41,3.41,0,0,1-.7,2.51,3.1,3.1,0,0,1-3.77,0,3.41,3.41,0,0,1-.7-2.51v-.54a3.47,3.47,0,0,1,.7-2.52,3.18,3.18,0,0,1,3.77,0,3.47,3.47,0,0,1,.7,2.52Zm-4.29-.15A6.08,6.08,0,0,0,78,35.54a1.69,1.69,0,0,0,3.13,0,6.7,6.7,0,0,0,.13-1.48v-.25a6.76,6.76,0,0,0-.13-1.48,1.69,1.69,0,0,0-3.13,0,6.13,6.13,0,0,0-.14,1.48Z","key":17}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M88.33,37.23H88c-.22,0-.25,0-.25-.22V33.08c0-.82-.16-1.29-.61-1.57A2.07,2.07,0,0,0,86,31.26a1.49,1.49,0,0,0-1.32.56,1.72,1.72,0,0,0-.24,1V37c0,.15-.08.2-.24.2h-.42c-.16,0-.21,0-.21-.2V30.8c0-.09,0-.15.13-.15h.4c.11,0,.15,0,.17.15l.06.54h0a1.51,1.51,0,0,1,.55-.51,2.61,2.61,0,0,1,1.26-.3,2.22,2.22,0,0,1,2.08.9,3.42,3.42,0,0,1,.33,1.73V37C88.59,37.19,88.48,37.23,88.33,37.23Z","key":18}),React.createElement("path",{"className":"f3e05613-e80d-4fc3-9ed6-b2132b0eadb9","d":"M90.09,37c-.13-.05-.18-.1-.16-.23l.11-.39c0-.14.12-.18.25-.13a4.59,4.59,0,0,0,1.63.32,1.63,1.63,0,0,0,1.14-.27,1,1,0,0,0,.34-.86v-.08c0-.47-.08-.72-.37-.9a3.45,3.45,0,0,0-.94-.28l-.37-.07a3.33,3.33,0,0,1-1-.33,1.45,1.45,0,0,1-.68-1.4v-.13c0-1.2.73-1.75,2.14-1.75a5.6,5.6,0,0,1,1.51.19c.16,0,.23.12.2.24l-.08.35c0,.16-.12.23-.31.17a5.77,5.77,0,0,0-1.33-.2,1.52,1.52,0,0,0-1.06.27,1,1,0,0,0-.27.7v.09A.87.87,0,0,0,91,33c.17.18.41.28,1,.41l.35.06a2.55,2.55,0,0,1,1.47.65,2,2,0,0,1,.33,1.18v.13a2.06,2.06,0,0,1-.37,1.25,2.31,2.31,0,0,1-1.91.68A5.12,5.12,0,0,1,90.09,37Z","key":19})]);
	}
	
	CentricaLogo.defaultProps = {"id":"e16d83ef-ab59-471b-9136-a5a5b58fb631","data-name":"Layer 1","width":"164px","height":"38px","viewBox":"0 0 163.8 37.5"};
	
	module.exports = CentricaLogo;
	
	CentricaLogo.default = CentricaLogo;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DupontLogo (props) {
	    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"Case-Study","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"DuPont-Case-Study-12-col-Copy-6","transform":"translate(-108.000000, -264.000000)","fill":"#FEFEFE"},React.createElement("g",{"id":"Hero","transform":"translate(-57.000000, -10.000000)"},React.createElement("g",{"id":"Group-6","transform":"translate(165.000000, 274.000000)"},[React.createElement("g",{"id":"Group-3","key":0},React.createElement("path",{"d":"M69.3589672,16.7234167 L69.3589672,32.9666667 C69.3589672,36.609125 66.5692951,37.1824583 63.6786393,37.2738333 C60.8078197,37.469125 58.0127377,36.9871667 58.0127377,33.4522083 L58.0127377,16.7234167 L61.0927377,16.7234167 L61.0927377,32.5814583 C61.0927377,34.2154583 62.5389672,34.3050417 63.6786393,34.3050417 C64.944541,34.2154583 66.3781475,34.115125 66.3781475,32.68 L66.3781475,16.7234167 L69.3589672,16.7234167 Z M69.3589672,16.7234167 L66.3781475,16.7234167 L66.3781475,9.551375 C66.3781475,8.0195 64.944541,7.92633333 63.6786393,7.820625 C62.5389672,7.734625 61.0927377,7.92633333 61.0927377,9.45283333 L61.0927377,16.7234167 L58.0127377,16.7234167 L58.0127377,8.68241667 C58.0127377,5.154625 60.8078197,4.66729167 63.6786393,4.875125 C66.5692951,4.97366667 69.3589672,5.62941667 69.3589672,9.07658333 L69.3589672,16.7234167 Z M54.8317541,16.7234167 L54.8317541,24.1785417 C54.8317541,27.2387083 52.2314262,27.907 50.4101148,27.907 L46.4609344,27.907 L46.4609344,37.2738333 C45.7955246,37.2738333 44.0517541,37.1824583 43.3809344,37.1824583 L43.3809344,16.7234167 L46.4609344,16.7234167 L46.4609344,24.84325 L50.5074918,24.9364167 C51.1710984,24.9364167 51.7517541,24.751875 51.7517541,23.5980417 L51.7517541,16.7234167 L54.8317541,16.7234167 Z M43.3809344,16.7234167 L43.3809344,5.06145833 C45.4132295,4.875125 48.6807705,4.66729167 51.5624098,4.66729167 C53.0086393,4.66729167 54.8317541,5.44129167 54.8317541,8.0195 L54.8317541,16.7234167 L51.7517541,16.7234167 L51.7517541,8.39933333 C51.7517541,7.820625 51.3640492,7.734625 51.0773279,7.734625 C50.7942131,7.734625 46.749459,7.820625 46.4609344,7.820625 L46.4609344,16.7234167 L43.3809344,16.7234167 Z M94.4768361,31.255625 C93.4201148,31.7357917 92.6356885,32.0224583 91.4888033,32.4900833 L91.4888033,12.9 C90.0479836,12.3159167 88.5999508,11.8447083 87.2529016,11.5652083 L87.2529016,8.39933333 C92.6356885,9.83804167 95.4289672,11.1817917 98.6207705,13.0917083 L98.6207705,16.7234167 C97.4558525,15.8634167 96.0042131,14.9980417 94.4768361,14.2240417 L94.4768361,31.255625 Z M75.711918,36.0322083 C74.5578197,36.2203333 73.8942131,36.318875 72.6229016,36.5105833 L72.6229016,5.724375 C73.8942131,5.82291667 74.6497869,5.91966667 75.8002787,6.10779167 L80.991918,24.84325 L80.991918,6.874625 C82.2560164,7.16129167 82.8312623,7.25266667 83.9853607,7.541125 L83.9853607,34.6006667 C82.9214262,34.88375 81.9747049,34.9661667 80.804377,35.27075 L75.711918,17.398875 L75.711918,36.0322083 Z M35.8738852,5.62941667 L35.8738852,32.207 C35.8738852,36.2203333 33.089623,36.318875 30.204377,35.845875 C27.2127377,35.27075 24.5330656,34.88375 24.5330656,31.255625 L24.5330656,7.541125 L27.5084754,6.874625 L27.5084754,30.9617917 C27.5084754,32.38975 28.8609344,32.4900833 30.204377,32.77675 C31.4468361,32.9666667 32.8065082,33.2622917 32.8065082,31.63725 L32.8065082,6.01283333 L35.8738852,5.62941667 Z M21.2565082,16.7234167 L21.2565082,29.8133333 C21.2565082,31.9149583 19.4135574,33.35725 17.7906066,32.77675 C16.1622459,32.207 12.4186393,30.8668333 10.5684754,29.627 L10.5684754,16.7234167 L13.6610984,16.7234167 L13.6610984,27.907 C14.6042131,28.2904167 15.8665082,28.8565833 16.732082,29.2435833 C17.7906066,29.627 18.1801148,29.1611667 18.1801148,28.38 L18.1801148,16.7234167 L21.2565082,16.7234167 Z M18.1801148,16.7234167 L18.1801148,13.754625 C18.1801148,13.0917083 17.7004426,12.6115417 16.9304426,12.9 C16.3588033,13.0917083 14.7051967,13.754625 13.6610984,14.2240417 L13.6610984,16.7234167 L10.5684754,16.7234167 L10.5684754,12.513 C12.6025738,11.2785417 15.8665082,9.94016667 17.3091311,9.551375 C18.9356885,8.98341667 21.2565082,9.74845833 21.2565082,12.3159167 L21.2565082,16.7234167 L18.1801148,16.7234167 Z M54.164541,2.47429167 C24.0606066,2.47429167 2.20667213,9.74845833 2.20667213,21.0252083 C2.20667213,32.38975 24.0606066,39.6710833 54.164541,39.6710833 L54.164541,41.769125 C22.7892951,41.769125 -0.000540983607,33.6403333 -0.000540983607,21.0252083 C-0.000540983607,8.49966667 22.7892951,0.370875 54.164541,0.370875 L54.164541,2.47429167 Z M54.164541,39.6710833 C84.2648689,39.6710833 106.118803,32.38975 106.118803,21.0252083 C106.118803,9.74845833 84.2648689,2.47429167 54.164541,2.47429167 L54.164541,0.370875 C85.5217541,0.370875 108.225033,8.49966667 108.225033,21.0252083 C108.225033,33.6403333 85.5217541,41.769125 54.164541,41.769125 L54.164541,39.6710833 Z","id":"Fill-1"})),React.createElement("path",{"d":"M101.959459,38.637111 C102.482961,38.6177334 102.594007,38.4133881 102.594007,38.1456254 C102.594007,37.8725778 102.482961,37.7457428 102.042303,37.7457428 L101.37074,37.7457428 L101.37074,38.637111 L101.959459,38.637111 Z M101.37074,39.1920141 L101.37074,40.7140341 L100.808461,40.7140341 L100.808461,37.1890781 L101.970035,37.1890781 C102.611633,37.1890781 103.283196,37.359953 103.283196,38.1614797 C103.283196,38.5684087 103.025852,38.8872578 102.558754,38.9788608 L102.558754,39 C103.041716,39.0827951 103.096357,39.3047563 103.158049,39.6940693 C103.210928,40.0252496 103.244418,40.3934234 103.362515,40.7140341 L102.666275,40.7140341 C102.627497,40.5167352 102.571093,40.2912507 102.553467,40.0886671 C102.505875,39.7874339 102.505875,39.4950088 102.347239,39.3329419 C102.216804,39.1920141 102.031727,39.1990605 101.848414,39.1920141 L101.37074,39.1920141 Z M104.474736,38.9876688 C104.474736,37.6277158 103.378378,36.524956 102.012338,36.524956 C100.630435,36.524956 99.5217391,37.6277158 99.5217391,38.9876688 C99.5217391,40.3617146 100.630435,41.4644745 102.012338,41.4644745 C103.378378,41.4644745 104.474736,40.3617146 104.474736,38.9876688 Z M99,38.9876688 C99,37.3388139 100.33255,36 102.012338,36 C103.670975,36 105,37.3388139 105,38.9876688 C105,40.6576629 103.670975,42 102.012338,42 C100.33255,42 99,40.6576629 99,38.9876688 Z","id":"Fill-4","key":1})]))))]);
	}
	
	DupontLogo.defaultProps = {"width":"164px","height":"38px","viewBox":"0 0 163.8 42.5","version":"1.1"};
	
	module.exports = DupontLogo;
	
	DupontLogo.default = DupontLogo;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function FirmenichLogo (props) {
	    return React.createElement("svg",props,[React.createElement("pattern",{"x":"0","y":"90.37","width":"69","height":"69","patternUnits":"userSpaceOnUse","id":"Polka_Dot_Pattern","viewBox":"2.12 -70.9 69 69","style":{"overflow":"visible"},"key":0},React.createElement("g",null,[React.createElement("rect",{"x":"2.12","y":"-70.9","style":{"fill":"none"},"width":"69","height":"69","key":0}),React.createElement("rect",{"x":"2.12","y":"-70.9","style":{"fill":"#F7BC60"},"width":"69","height":"69","key":1}),React.createElement("g",{"key":2},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.77-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.11-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.44-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.77-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.11-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.44-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.77-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.11-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.44-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tC0-70.92,0.16-70.75,0.15-70.62c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8})]),React.createElement("g",{"key":3},React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03"})),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-71.65c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("g",{"key":5},[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-64c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tC3.58-63,3.54-63.05,3.53-63.12c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-56.35c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":2},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-48.7c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":3},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-41.04c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":4},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-33.39c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":5},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tC69-25,69.16-24.83,69.15-24.71c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tC7.72-25,7.88-24.83,7.87-24.71c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-25.74c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tC0.06-25,0.22-24.83,0.21-24.71c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":6},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-18.08c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})]),React.createElement("g",{"key":7},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tC69-9.69,69.16-9.52,69.15-9.4c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46C57.1-8.93,57.09-9,57.12-9.07c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46C41.78-8.93,41.77-9,41.8-9.07c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46C18.8-8.93,18.79-9,18.82-9.07c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tC7.72-9.69,7.88-9.52,7.87-9.4c0,0.05-0.04,0.11-0.04,0.16C7.82-9.12,7.84-8.97,7.89-8.87c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-10.43c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\t\tC0.06-9.69,0.22-9.52,0.21-9.4c0,0.05-0.04,0.11-0.04,0.16C0.16-9.12,0.18-8.97,0.23-8.87c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14C2-7.88,2.22-7.83,2.39-7.89c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46C3.48-8.93,3.47-9,3.5-9.07c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\t\tC3.58-9.43,3.54-9.48,3.53-9.55c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})])]),React.createElement("g",{"key":6},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M69.44-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tC69-2.04,69.16-1.87,69.15-1.75c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.43,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63C70.4,0,70.6-0.15,70.76-0.18c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05C72.23-0.81,72.37-1,72.4-1.2c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M61.78-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21C62.14-3.28,62.18-3.2,62-3.14c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M54.12-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M46.46-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tC46.82-0.52,47-0.1,47.24-0.04c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M38.8-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.14-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63C32.1,0,32.3-0.15,32.46-0.18c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05C33.93-0.81,34.07-1,34.1-1.2c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M23.48-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.04,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M15.82-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.16,0.13c-0.05,0.06-0.1,0.28-0.08,0.36\n\t\t\t\tc-0.17,0.06-0.01,0.23-0.02,0.35c0,0.05-0.04,0.11-0.05,0.16c-0.01,0.12,0.02,0.27,0.07,0.37c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tc0.19,0.15,0.36,0.57,0.61,0.63c0.18,0.04,0.38-0.1,0.54-0.14c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tc-0.18,0.03-0.29,0.13-0.44,0.21c-0.17,0.09-0.14,0.17-0.32,0.22c-0.08,0.03-0.22,0.12-0.21,0.22c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M8.16-2.78c0.02,0.07,0.01,0.13-0.03,0.19c-0.05,0.1-0.11,0.06-0.17,0.13C7.91-2.4,7.87-2.18,7.89-2.1\n\t\t\t\tC7.72-2.04,7.88-1.87,7.87-1.75c0,0.05-0.04,0.11-0.04,0.16C7.82-1.47,7.84-1.32,7.89-1.22c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tC8.52-0.52,8.69-0.1,8.94-0.04C9.11,0,9.32-0.15,9.48-0.18c0.18-0.04,0.4,0.01,0.57-0.05c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05c0.2-0.07,0.34-0.26,0.38-0.46c0.02-0.08,0.01-0.14,0.04-0.22c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tc-0.01-0.06-0.05-0.12-0.06-0.19c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55c-0.38-0.69-1.24-0.93-1.97-0.79\n\t\t\t\tC8.95-3.54,8.85-3.45,8.69-3.37C8.52-3.28,8.55-3.2,8.37-3.14C8.29-3.12,8.16-3.02,8.16-2.92c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M0.5-2.78C0.51-2.71,0.5-2.65,0.47-2.59C0.42-2.49,0.36-2.53,0.3-2.46C0.25-2.4,0.21-2.18,0.23-2.1\n\t\t\t\tC0.06-2.04,0.21-1.87,0.21-1.75c0,0.05-0.04,0.11-0.04,0.16C0.15-1.47,0.18-1.32,0.23-1.22c0.1,0.2,0.27,0.41,0.44,0.54\n\t\t\t\tC0.86-0.52,1.03-0.1,1.28-0.04C1.45,0,1.66-0.15,1.82-0.18C2-0.23,2.22-0.17,2.39-0.24c0.22-0.08,0.13-0.34,0.29-0.45\n\t\t\t\tc0.1-0.07,0.29-0.01,0.41-0.05C3.28-0.81,3.42-1,3.46-1.2C3.48-1.28,3.47-1.34,3.5-1.42c0.04-0.1,0.11-0.16,0.09-0.29\n\t\t\t\tC3.58-1.77,3.54-1.83,3.53-1.9c-0.02-0.11,0-0.22,0-0.34c0-0.2,0.02-0.38-0.08-0.55C3.07-3.47,2.21-3.71,1.47-3.57\n\t\t\t\tC1.29-3.54,1.19-3.45,1.03-3.37C0.86-3.28,0.89-3.2,0.71-3.14C0.63-3.12,0.5-3.02,0.5-2.92c0,0.12,0,0.05,0.01,0.17\n\t\t\t\tc-0.02,0.01-0.02,0-0.03-0.03","key":9})])])),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M35.18,21.51v9.14h3.1v-9.14c0-1.87,1.53-3.39,3.41-3.39c1.2,0,2.26,0.63,2.87,1.56\n\tc0.29-1.09,0.83-2.09,1.55-2.92c-1.16-1.07-2.71-1.73-4.42-1.73C38.1,15.05,35.18,17.95,35.18,21.51z M17.75,3.67H47.4V0.59H1.23\n\tv3.08h13.42v11.55H6.84v3.08h7.81v20.08h3.1V18.29h10.54v12.36h3.1V15.21H17.75V3.67z M63.15,15.05c-1.98,0-3.76,0.89-4.96,2.29\n\tc-1.19-1.4-2.97-2.29-4.96-2.29c-3.59,0-6.5,2.9-6.5,6.47v9.14h3.1v-9.14c0-1.87,1.53-3.39,3.41-3.39c1.88,0,3.41,1.52,3.41,3.39\n\tv9.14h3.1v-9.14c0-1.87,1.53-3.39,3.41-3.39c1.88,0,3.41,1.52,3.41,3.39v9.14h3.1v-9.14C69.65,17.95,66.73,15.05,63.15,15.05z\n\t M28.29,11.36h3.1V7.5h-3.1V11.36z M120.76,27.97c-2.8,0-5.09-2.27-5.09-5.06c0-2.79,2.28-5.06,5.09-5.06c1.71,0,3.3,0.85,4.24,2.27\n\tl2.45-1.62c-1.49-2.24-4-3.58-6.7-3.58c-4.43,0-8.03,3.58-8.03,7.98c0,4.4,3.6,7.98,8.03,7.98c2.77,0,5.31-1.39,6.79-3.72\n\tl-2.49-1.57C124.12,27.09,122.51,27.97,120.76,27.97z M106.83,11.36h3.1V7.5h-3.1V11.36z M136.22,15.05c-1.25,0-2.42,0.35-3.41,0.96\n\tV0.59h-3.1v30.07h3.1v-9.14c0-1.87,1.53-3.39,3.41-3.39c1.88,0,3.41,1.52,3.41,3.39v16.85h3.1V21.51\n\tC142.73,17.95,139.81,15.05,136.22,15.05z M106.83,30.65h3.1V15.21h-3.1V30.65z M97.16,15.05c-3.59,0-6.5,2.9-6.5,6.47v9.14h3.1\n\tv-9.14c0-1.87,1.53-3.39,3.41-3.39c1.88,0,3.41,1.52,3.41,3.39v9.14h3.1v-9.14C103.66,17.95,100.75,15.05,97.16,15.05z M87.97,23.1\n\tv-0.19c0-4.34-3.55-7.87-7.92-7.87c-4.36,0-7.91,3.53-7.91,7.87c0,4.34,3.55,7.87,7.91,7.87c2.51,0,4.81-1.14,6.32-3.14l-2.39-1.38\n\tc-0.94,1.16-2.38,1.83-3.93,1.83c-2.28,0-4.27-1.5-4.96-3.72l-0.02-0.05c0,0,12.9,0,12.91,0C87.98,24.29,87.97,24.08,87.97,23.1z\n\t M75.06,21.51l0.06-0.08c0.65-2.2,2.64-3.69,4.93-3.69c2.28,0,4.27,1.5,4.96,3.72c0-0.01,0.01,0.03,0.02,0.05H75.06z","key":1})]);
	}
	
	FirmenichLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"164px","height":"38px","viewBox":"0 0 215.75 39","style":{"enableBackground":"new 0 0 215.75 39"},"xmlSpace":"preserve"};
	
	module.exports = FirmenichLogo;
	
	FirmenichLogo.default = FirmenichLogo;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Heineken (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("polygon",{"id":"path-1","points":"0 0.484505062 24.30729 0.484505062 24.30729 23.5319993 0 23.5319993"})),React.createElement("g",{"id":"Case-Study","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Heineken-Case-Study-12-col-Copy-5","transform":"translate(-108.000000, -264.000000)"},React.createElement("g",{"id":"Hero","transform":"translate(0.000000, -1.000000)"},React.createElement("g",{"id":"Group-6","transform":"translate(108.000000, 265.000000)"},[React.createElement("path",{"d":"M153,17 L153,17.7462477 C153,17.7462477 152.179096,18.0696217 152.179096,19.0210876 L152.182697,34.9792397 C152.182697,35.5398139 151.720039,36 151.152067,36 L147.974666,36 L140.980785,25.1101136 C140.980785,25.1101136 141.126603,26.0136064 141.126603,27.1480806 L141.126603,36 L137.256115,36 L137.256115,17 L139.764731,17 C141.044693,17 141.97901,17.521485 142.649595,18.5635667 C143.219367,19.4475148 148.503933,27.6589049 148.503933,27.6589049 C148.503933,27.6589049 148.315809,27.0992192 148.315809,25.600505 L148.315809,17 L153,17 Z M78.6245222,17 L78.6245222,34.9792397 C78.6245222,35.5398139 78.1582634,36 77.5902918,36 L74.4128912,36 L67.4199095,25.1101136 C67.4199095,25.1101136 67.5648277,26.0136064 67.5648277,27.1480806 L67.5648277,36 L63.6943397,36 L63.6943397,17 L66.2020559,17 C67.4838175,17 68.4172352,17.521485 69.0878198,18.5635667 C69.6575916,19.4475148 74.943058,27.6589049 74.943058,27.6589049 C74.943058,27.6589049 74.7531341,27.0992192 74.7531341,25.600505 L74.7531341,17 L78.6245222,17 Z M30.7168817,17 L25.5412291,17 L25.5412291,24.2812456 L21.011858,24.2812456 L21.011858,17 L15,17 L15,17.7462477 C15,17.7462477 15.8209035,18.0518539 15.8209035,19.0210876 L15.8209035,36 L21.011858,36 L21.011858,27.7566279 L25.5412291,27.7566279 L25.5412291,36 L30.7168817,36 L30.7168817,17 Z M47.4850959,17 L35.9492414,17 L35.9492414,34.3005097 C35.9492414,35.2875111 36.8988612,35.9991116 37.8934866,36 L47.4850959,36 C48.0530676,36 48.5193263,35.5398139 48.5193263,34.9774629 L48.5193263,32.5255061 L41.9043923,32.5255061 C41.474138,32.5255061 41.1275943,32.1763688 41.1275943,31.7517183 L41.1275943,27.7530743 L47.0233377,27.7530743 L47.0233377,24.2812456 L41.1275943,24.2812456 L41.1275943,20.4727171 L48.5193263,20.4727171 L48.5193263,18.0234254 C48.5193263,17.4601861 48.0530676,17 47.4850959,17 Z M58.4151741,17 L53.2377213,17 L53.2377213,34.9792397 C53.2377213,35.5398139 53.7057803,36 54.2737519,36 L58.4151741,36 L58.4151741,17 Z M131.830231,17 L120.295276,17 L120.295276,34.3005097 C120.295276,35.2484219 121.243096,35.9991116 122.239522,36 L131.830231,36 C132.400903,36 132.867162,35.5398139 132.867162,34.9774629 L132.867162,32.5255061 L126.249527,32.5255061 C125.821973,32.5255061 125.472729,32.1763688 125.472729,31.7517183 L125.472729,27.7530743 L131.371173,27.7530743 L131.371173,24.2812456 L125.472729,24.2812456 L125.472729,20.4727171 L132.867162,20.4727171 L132.867162,18.0234254 C132.867162,17.4601861 132.400903,17 131.830231,17 Z M95.3909362,17 L83.8559818,17 L83.8559818,34.3005097 C83.8559818,35.2484219 84.8047015,35.9991116 85.8011271,36 L95.3909362,36 C95.959808,36 96.4269669,35.5398139 96.4269669,34.9774629 L96.4269669,32.5255061 L89.8102326,32.5255061 C89.3808785,32.5255061 89.0334347,32.1763688 89.0334347,31.7517183 L89.0334347,27.7530743 L94.9309783,27.7530743 L94.9309783,24.2812456 L89.0334347,24.2812456 L89.0334347,20.4727171 L96.4269669,20.4727171 L96.4269669,18.0234254 C96.4269669,17.4601861 95.959808,17 95.3909362,17 Z M117.299699,17 L113.565128,17 C112.665014,17 111.976427,17.2238743 111.263538,18.0358629 C110.550648,18.8478515 105.987972,24.0360499 105.987972,24.0360499 L105.987972,17 L100.809619,17 L100.809619,34.9792397 C100.81052,35.5407023 101.276778,36 101.84385,36 L105.987972,36 L105.987972,27.3843924 C105.987972,27.3843924 109.870162,33.3774723 110.550648,34.4284378 C111.232934,35.4802918 111.909819,36 113.463415,36 L117.717351,36 L110.450735,24.7885164 L117.299699,17 Z","id":"Fill-1","fill":"#FFFFFF","key":0}),React.createElement("g",{"id":"Group-5","key":1},[React.createElement("mask",{"id":"mask-2","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("g",{"id":"Clip-4","key":1}),React.createElement("path",{"d":"M5.03107143,23.4659556 C4.77303571,23.6544 4.43642857,23.4090667 4.53464286,23.1139556 C4.67660714,22.6917333 7.25696429,14.7752889 7.25696429,14.7752889 L0.135535714,9.6224 C-0.121607143,9.43395556 0.0114285714,9.04195556 0.324821429,9.04462222 C0.77125,9.04728889 9.1275,9.04462222 9.1275,9.04462222 C9.1275,9.04462222 11.7114286,1.13351111 11.8471429,0.709511111 C11.9417857,0.412622222 12.3623214,0.4064 12.45875,0.709511111 C12.5944643,1.1344 15.1792857,9.04462222 15.1792857,9.04462222 C15.1792857,9.04462222 23.5355357,9.04728889 23.9828571,9.04462222 C24.2953571,9.04195556 24.4292857,9.43395556 24.1703571,9.6224 L19.9221429,12.6952889 L14.8953571,12.6952889 L13.3426786,7.93884444 L11.7908929,12.6952889 L6.76321429,12.6952889 L10.8310714,15.6348444 L9.27660714,20.3939556 C9.27660714,20.3939556 5.29,23.2792889 5.03107143,23.4659556","id":"Fill-3","fill":"#FFFFFF","mask":"url(#mask-2)","key":2})])]))))]);
	}
	
	Heineken.defaultProps = {"width":"164px","height":"38px","viewBox":"0 0 163.8 37.5","version":"1.1"};
	
	module.exports = Heineken;
	
	Heineken.default = Heineken;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function InfosysLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".f87b3264-2574-4dd0-b3fb-a01153f69f02{fill:#fff;}")),React.createElement("title",{"key":1},"infosys-logo"),React.createElement("path",{"className":"f87b3264-2574-4dd0-b3fb-a01153f69f02","d":"M104.29,5.74h0l-.28,0h-.28l-.5-.17-.45-.27L102.37,5,102,4.57l-.24-.44-.17-.48-.06-.26V2.83l.06-.26.17-.49.24-.43.36-.39.41-.35.45-.22.5-.17L104,.47h.55l.28.05.54.17.46.22.41.35.32.39.28.43.13.49.06.26,0,.26,0,.3-.06.26-.13.48-.28.44-.32.38-.41.31-.46.27-.54.17h-.28Zm0-5.7H104l-.33,0-.32.08-.26.1-.32.12-.24.19-.27.17L102,.91l-.19.21-.22.27-.15.26-.13.26-.09.27-.1.29,0,.31,0,.31,0,.34,0,.31.1.3.09.26.13.27.15.26.22.26.19.22.22.17.27.17.24.19.32.12.26.09.32.08.33,0h.64l.32,0,.32-.08.32-.09.27-.12.27-.19.24-.17.22-.17.23-.22.18-.26.14-.26.13-.27L107.4,4l.09-.3,0-.31V2.78l0-.31-.09-.29-.15-.27-.13-.26L107,1.39l-.18-.27-.23-.21-.22-.17-.24-.17-.27-.19-.27-.12-.32-.1-.32-.08-.32,0Z","transform":"translate(0 -0.04)","key":2}),React.createElement("path",{"className":"f87b3264-2574-4dd0-b3fb-a01153f69f02","d":"M104.54,2.74h-.75V1.88h.7l.22.05.19.09.13.13.06.17-.06.15-.13.14-.13.08Zm.6.41h0l.17-.07.19-.14.09-.13.06-.07,0-.17,0-.22,0-.3-.1-.24-.13-.17-.19-.13L105,1.42l-.22,0-.51,0h-1.15V4.5h.64V3.23h.75l.55,1.27h.69Z","transform":"translate(0 -0.04)","key":3}),React.createElement("polygon",{"className":"f87b3264-2574-4dd0-b3fb-a01153f69f02","points":"0 0.74 0 4.33 0 4.37 0 27.21 0 27.25 0 30.88 3.86 30.88 3.86 27.3 3.86 27.21 3.86 4.37 3.86 4.33 3.86 0.74 0 0.74","key":4}),React.createElement("path",{"className":"f87b3264-2574-4dd0-b3fb-a01153f69f02","d":"M47.33,29.71h0l-.81,0-.79-.14L45,29.32,44.26,29l-.73-.38-.64-.48-.64-.56-.56-.65-.5-.7-.51-.75-.41-.82L40,23.77l-.28-.89-.23-1-.13-1-.05-1v-1l.09-1,.19-1,.27-.92.32-.87.38-.82.45-.77.45-.7.56-.65.6-.61.64-.48.69-.43.73-.34.73-.27.79-.17L47,9.82l.83,0,.78.14.73.25.73.31.74.43.65.48.64.56.54.6.51.7.5.78.42.82.33.87.26.91.23,1,.15,1,0,1v1l-.1,1-.18.94-.27.92-.32.86-.37.83-.45.77-.47.75-.56.63-.58.58-.64.51-.69.43-.75.36-.73.25-.77.18ZM93.69,18.15h0L91,16.89l-1-.48-.37-.25L89.27,16,89,15.68l-.22-.22-.23-.26-.18-.31-.1-.29-.09-.31,0-.39V13l.09-.48.14-.43.18-.39.23-.39L89,11l.32-.29.32-.22.37-.22.37-.18.36-.13.41-.12.41-.09.42,0,.82-.05.88.05.82.09.79.22.73.26.73.35.69.38.79.48L99,12V8.44l-.64-.17-.65-.17-.64-.19-.6-.07-.64-.1-.65,0-1.41,0h-.73l-.74,0-.74.09-.69.12-.64.14-.69.22-.6.22-.58.26-.56.3-.51.31-.45.38-.41.39-.41.48-.28.47-.28.57-.23.56-5,11.56-.49,1.45-.47-1.45-3.9-9L74,11.39l-1.28-3-1.2-.26-1.38-.25-1.46-.21-.68,0-.6,0h-.56l-.86,0-.83,0-.82.12-.84.12-.77.22-.73.26-.75.32-.64.34L60,9.43l-.55.44-.51.52-.41.56-.32.61-.24.7L57.8,13l0,.78v.73l-.37-.73L57,13l-.47-.68L56,11.6l-.56-.6-.6-.56-.64-.57-.64-.48L52.89,9l-.73-.38-.73-.35L50.64,8l-.82-.22L49,7.57l-.82-.09-.88,0-.82,0-.83.09h-13l0-.55-.05-.58V6l.1-.48.09-.44.13-.39L33,4.29,33.2,4l.23-.31.28-.25L34,3.2,34.35,3l.37-.19.36-.07.41,0,.43-.05,1,.05.86.12.75.14.68.27.6.25.5.35.51.34.46.39h.13V1.25l-.31-.13L40.73,1,40.27.86,39.72.77,39.07.72,38.34.64,36.6.6l-.74,0-.73.08-.69.14-.64.22-.65.26-.54.3L32.06,2l-.51.43-.46.48-.41.53L30.32,4l-.32.6-.28.7-.23.7-.14.77-.1.82H26.14V9.79h3.07V27.25l-.05.17v3.52h3.5V9.79h7.85l-.56.43-.51.44-.45.51-.46.53-.42.51-.41.56-.36.62L37,14l-.27.6-.28.68-.22.66-.19.74-.13.7-.11.73-.08.74v1.38l0,.61.09.65.1.55.13.62.15.56.17.56.24.57.23.56.22.51.28.53.32.48L38,27l.32.47.37.43.41.44.36.38.47.41.41.34.47.34.45.36.5.24.51.31.51.22.5.22.55.21.55.13.55.17.6.09.56.1.58,0h1.2l.6,0,.54-.1.6-.09.55-.17.56-.13.54-.21.51-.22.5-.22.51-.31.5-.24.47-.36.45-.34.41-.34.42-.41.41-.38.41-.44.32-.43.37-.47.32-.48L57.2,26l.28-.53.23-.51.22-.56.24-.57.19-.56.13-.56.14-.62.09-.55.09-.65,0-.61v-.6l0-1.21-.18-1.18.22.36.28.29.28.26.28.27.68.51.73.43.88.44.91.38,2.07.87,1.23.53,1.07.51,1,.53.41.26.37.25.32.31.28.29.22.27.23.35.15.3.08.36.09.38v.83l-.09.43-.14.39-.18.34-.23.35-.28.3-.32.31-.32.26-.41.22L68,29l-.41.17-.47.12-.49.1-.52.08-.49,0H65.1l-1,0-1-.13-.92-.26-.86-.34-.88-.44-.88-.52-.86-.64-.88-.7v3.89l.56.31.69.3.68.22.78.21.79.19.86.08.88.09H64.6l.69-.05.68-.09.78-.12.79-.18.77-.21.73-.27.78-.34.7-.43.69-.48.32-.31.26-.3.28-.31.23-.34.24-.38.22-.39.19-.39.13-.43.1-.48.09-.53,0-.51,0-.53,0-.7-.09-.6L73,22.83l-.22-.53-.32-.46-.32-.48-.42-.44-.46-.39-.45-.35-.51-.34-.56-.34-.58-.31L68,18.63l-1.25-.56L64,16.84l-1-.51-.79-.48-.32-.21-.26-.27-.24-.26-.19-.25-.13-.31L61,14.21l-.06-.36v-.43l.06-.51.09-.53.13-.43.19-.39.24-.34.32-.36.26-.25.37-.26.38-.22.41-.17.41-.14.4-.08.43-.09L65,9.57l.82,0,.68,0,.65,0,.6.14.6.17.51.22.41.22.32.31.28.34.26.34.23.36.37.77.36.82,6.57,15L76,31.76l-1.5,2.94v0L73.72,36,73,37.43h3.39l1.88-4.12L81,27l4.55-10.4.19.43.22.39.23.36.28.29.28.31.36.29.32.27.41.26.88.53,1,.46,1.1.44,1.2.53,1.23.51,1,.52,1,.48.43.3.36.26.33.27.27.29.22.31.24.3.13.35.1.34.09.34v.84l-.09.44-.15.38-.17.39-.24.34-.27.31-.32.27-.33.24-.41.22-.4.22-.43.14-.45.17-.5.08-.51.09-.51,0h-1l-.5,0-.51-.09-.46-.08-.51-.14-.45-.13L88.65,29l-.47-.21-.92-.44-.87-.6-.92-.65-.92-.78-.23-.18v4l.55.38.69.34.73.31.84.22.92.22.9.12,1,.1,1.06,0h.59l.7,0,.69-.1.77-.12.78-.19.79-.21.73-.3.77-.34.69-.4.69-.52.32-.26.28-.29.27-.36.24-.29.22-.41.23-.39.19-.43.13-.43.09-.47.1-.48,0-.53,0-.55,0-.66-.09-.6-.19-.56-.24-.53-.32-.52-.32-.42L98.73,21l-.45-.41-.47-.39-.5-.34-.55-.31-.6-.29-1.23-.61Z","transform":"translate(0 -0.04)","key":5}),React.createElement("polygon",{"className":"f87b3264-2574-4dd0-b3fb-a01153f69f02","points":"11.05 7.75 11.1 10.39 11.1 10.56 11.14 10.56 11.29 10.29 11.87 9.74 12.47 9.22 13.16 8.74 13.52 8.53 13.93 8.31 14.38 8.14 14.88 7.97 15.39 7.78 15.98 7.71 16.58 7.57 17.22 7.49 17.95 7.44 18.68 7.44 19.46 7.49 20.14 7.57 20.82 7.75 21.42 7.97 22.02 8.26 22.56 8.57 23.07 8.91 23.57 9.3 23.97 9.74 24.34 10.17 24.66 10.61 24.94 11.04 25.11 11.47 25.3 11.91 25.39 12.34 25.44 12.73 25.44 27.19 25.44 27.29 25.44 30.88 22.02 30.88 22.02 26.56 22.02 14.25 21.97 13.77 21.87 13.29 21.74 12.85 21.61 12.46 21.37 12.08 21.09 11.74 20.77 11.38 20.47 11.09 20.1 10.82 19.68 10.56 19.22 10.34 18.77 10.17 18.32 10.05 17.8 9.91 17.26 9.88 16.75 9.83 16.3 9.88 15.8 9.91 15.35 10.05 14.88 10.17 14.38 10.39 13.93 10.61 13.52 10.87 13.11 11.13 12.69 11.43 12.32 11.74 12.02 12.08 11.74 12.42 11.51 12.82 11.33 13.21 11.18 13.6 11.14 13.98 11.14 27.19 11.14 27.29 11.14 30.88 7.72 30.88 7.72 27.19 7.72 10.78 7.72 7.75 8.32 7.75 10.19 7.75 11.05 7.75","key":6})]);
	}
	
	InfosysLogo.defaultProps = {"id":"b52f3ac3-2b5d-4d06-a0ab-425c16baac88","data-name":"Layer 1","width":"164px","height":"38px","viewBox":"0 0 163.8 37.5"};
	
	module.exports = InfosysLogo;
	
	InfosysLogo.default = InfosysLogo;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LgLogo (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.stLG{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},React.createElement("path",{"className":"stLG","d":"M15.2,12.8c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4\n\t\t\tC14.1,10.4,15.2,11.4,15.2,12.8 M23.4,25.4v1.8h-5.5V10.4h1.8v15H23.4z M30,30c-3,3-7,4.6-11.2,4.6c-4.2,0-8.2-1.6-11.2-4.6\n\t\t\tc-3-3-4.6-7-4.6-11.2C2.9,10,10,2.9,18.8,2.9l0.9,0v1.6v0.1l-0.9,0c-3.8,0-7.3,1.5-10,4.1c-2.7,2.7-4.1,6.2-4.1,10\n\t\t\tc0,3.8,1.5,7.3,4.1,10c2.7,2.7,6.2,4.1,10,4.1c7.4,0,13.6-5.8,14.1-13.2c0,0,0,0,0,0h-9.7v-1.8h10.7l0.8,0v0.9\n\t\t\tC34.6,23,33,27,30,30 M18.8,0C8.4,0,0,8.4,0,18.8c0,10.4,8.4,18.8,18.8,18.8c10.4,0,18.8-8.4,18.8-18.8C37.5,8.4,29.1,0,18.8,0"})),React.createElement("path",{"className":"stLG","d":"M110,11.4c0.5,0.2,1,0.5,1.3,0.9c0.3,0.4,0.5,0.9,0.5,1.6c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.4,0.7-0.8,0.9\n\t\tc-0.3,0.2-0.7,0.4-1.1,0.5c-0.4,0.1-0.9,0.2-1.4,0.2h-4.4V6.6h4.1c0.5,0,1,0,1.5,0.1c0.4,0.1,0.8,0.2,1.1,0.4\n\t\tc0.3,0.2,0.5,0.5,0.7,0.8c0.2,0.3,0.2,0.7,0.2,1.2c0,0.5-0.1,0.9-0.4,1.3C110.8,10.9,110.4,11.2,110,11.4z M109.3,9.5\n\t\tc0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.5-0.1h-2v2.6h2c0.4,0,0.8-0.1,1-0.3\n\t\tC109.2,10.2,109.3,9.9,109.3,9.5z M107.9,15.3c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.3-0.3,0.4-0.4\n\t\tc0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.6-0.1-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2,0-0.4-0.1-0.6-0.1h-2.1v3\n\t\tH107.9z","key":1}),React.createElement("path",{"className":"stLG","d":"M119.5,15l0.1,1.9h-1.9l-0.1-0.5c-0.2,0.1-0.5,0.3-0.8,0.4c-0.5,0.2-1,0.3-1.5,0.3c-0.5,0-0.8-0.1-1.1-0.2\n\t\tc-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.3-0.1-0.7-0.1-1V9.7h2v4.4c0,0.2,0,0.4,0,0.5c0,0.2,0.1,0.3,0.1,0.4\n\t\tc0.1,0.1,0.1,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6,0,0.8-0.1c0.2-0.1,0.4-0.2,0.6-0.3V9.7h2V15z","key":2}),React.createElement("path",{"className":"stLG","d":"M123.6,12.3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.3,0.1\n\t\tc0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.8c0,0.8-0.3,1.3-0.8,1.7\n\t\tc-0.6,0.4-1.3,0.6-2.3,0.6c-0.6,0-1.2-0.1-1.7-0.2c-0.5-0.1-0.9-0.2-1.3-0.4l0.6-1.4c0.3,0.2,0.6,0.3,1,0.4\n\t\tc0.4,0.1,0.8,0.1,1.3,0.1c0.4,0,0.7,0,0.9-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.3-0.3-0.6-1-0.8c-0.2-0.1-0.4-0.1-0.7-0.2\n\t\tc-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.1-0.5-0.1-0.8\n\t\tc0-0.8,0.3-1.3,0.8-1.7c0.6-0.4,1.3-0.6,2.3-0.6c0.6,0,1.1,0,1.6,0.1c0.5,0.1,0.9,0.2,1.3,0.4l-0.6,1.4c-0.3-0.2-0.6-0.3-1-0.4\n\t\tc-0.4-0.1-0.8-0.1-1.2-0.1c-0.4,0-0.7,0-0.9,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.2,0.1,0.3,0.2,0.4C123,12.1,123.3,12.2,123.6,12.3z","key":3}),React.createElement("path",{"className":"stLG","d":"M127.9,6.6h2.1v1.6h-2.1V6.6z M127.9,9.7h2v7.2h-2V9.7z","key":4}),React.createElement("path",{"className":"stLG","d":"M133.2,9.7l0,0.5c0.2-0.2,0.5-0.3,0.8-0.4c0.6-0.2,1.1-0.3,1.6-0.3c0.5,0,0.9,0.1,1.2,0.2\n\t\tc0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.1,0.7,0.1,1v4.8h-2v-4.4c0-0.2,0-0.3,0-0.5c0-0.2-0.1-0.3-0.1-0.4\n\t\tc-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0-0.9,0.1c-0.2,0.1-0.4,0.2-0.6,0.3v5.3h-2v-5.2l-0.1-1.9H133.2z","key":5}),React.createElement("path",{"className":"stLG","d":"M142.8,17.1c-1.3,0-2.3-0.3-2.8-1c-0.5-0.6-0.8-1.6-0.8-2.8c0-2.5,1.2-3.7,3.6-3.7c0.7,0,1.2,0.1,1.6,0.3\n\t\tc0.4,0.2,0.7,0.4,1,0.7c0.2,0.3,0.4,0.7,0.5,1.1c0.1,0.4,0.1,0.9,0.1,1.4v0.7h-4.7c0,0.5,0.1,0.9,0.3,1.2c0.3,0.4,0.8,0.6,1.6,0.6\n\t\tc0.6,0,1-0.1,1.4-0.2c0.3-0.1,0.7-0.3,1-0.4l0.4,1.3c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.5,0.2-0.7,0.2c-0.3,0.1-0.6,0.1-0.9,0.2\n\t\tC143.3,17,143,17.1,142.8,17.1z M143.8,12.4c0-0.5-0.1-0.9-0.3-1.2c-0.2-0.3-0.5-0.4-0.8-0.4c-0.3,0-0.6,0.1-0.8,0.1\n\t\tc-0.2,0.1-0.3,0.2-0.5,0.4c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.1,0,0.2,0,0.3H143.8z","key":6}),React.createElement("path",{"className":"stLG","d":"M149.7,12.3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.3,0.1\n\t\tc0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.8c0,0.8-0.3,1.3-0.8,1.7\n\t\tc-0.6,0.4-1.3,0.6-2.3,0.6c-0.6,0-1.2-0.1-1.7-0.2c-0.5-0.1-0.9-0.2-1.3-0.4l0.6-1.4c0.3,0.2,0.6,0.3,1,0.4\n\t\tc0.4,0.1,0.8,0.1,1.3,0.1c0.4,0,0.7,0,0.9-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.3-0.3-0.6-1-0.8c-0.2-0.1-0.4-0.1-0.7-0.2\n\t\tc-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.1-0.5-0.1-0.8\n\t\tc0-0.8,0.3-1.3,0.8-1.7c0.6-0.4,1.3-0.6,2.3-0.6c0.6,0,1.1,0,1.6,0.1c0.4,0.1,0.9,0.2,1.3,0.4l-0.6,1.4c-0.3-0.2-0.6-0.3-1-0.4\n\t\tc-0.4-0.1-0.8-0.1-1.2-0.1c-0.4,0-0.7,0-0.9,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.2,0.1,0.3,0.2,0.4C149.1,12.1,149.4,12.2,149.7,12.3\n\t\tz","key":7}),React.createElement("path",{"className":"stLG","d":"M156.6,12.3c0.1,0,0.1,0.1,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.3,0.1\n\t\tc0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.8c0,0.8-0.3,1.3-0.8,1.7\n\t\tc-0.6,0.4-1.3,0.6-2.3,0.6c-0.6,0-1.2-0.1-1.7-0.2c-0.5-0.1-0.9-0.2-1.3-0.4l0.6-1.4c0.3,0.2,0.6,0.3,1,0.4\n\t\tc0.4,0.1,0.8,0.1,1.3,0.1c0.4,0,0.7,0,0.9-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.3-0.3-0.6-1-0.8c-0.2-0.1-0.4-0.1-0.7-0.2\n\t\tc-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.1-0.5-0.1-0.8\n\t\tc0-0.8,0.3-1.3,0.8-1.7c0.6-0.4,1.3-0.6,2.3-0.6c0.6,0,1.1,0,1.6,0.1c0.5,0.1,0.9,0.2,1.3,0.4l-0.6,1.4c-0.3-0.2-0.6-0.3-1-0.4\n\t\tc-0.4-0.1-0.8-0.1-1.2-0.1c-0.4,0-0.7,0-0.9,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.2,0.1,0.3,0.2,0.4C156,12.1,156.2,12.2,156.6,12.3z","key":8}),React.createElement("path",{"className":"stLG","d":"M108.1,27.1c-0.4-0.2-0.8-0.4-1.3-0.5c-0.5-0.2-0.9-0.3-1.4-0.5c-0.3-0.2-0.6-0.3-0.9-0.5\n\t\tc-0.2-0.2-0.4-0.3-0.6-0.6c-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-1c0-0.9,0.3-1.6,1-2.2c0.7-0.5,1.6-0.8,2.9-0.8\n\t\tc0.5,0,1.1,0.1,1.7,0.2c0.6,0.1,1.2,0.3,1.7,0.6l-0.7,1.5c-0.3-0.2-0.7-0.4-1.2-0.5c-0.5-0.1-1-0.2-1.5-0.2c-0.7,0-1.1,0.1-1.4,0.3\n\t\tc-0.3,0.2-0.4,0.5-0.4,0.8c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.7,0.4c0.3,0.1,0.8,0.3,1.2,0.5c0.5,0.2,0.9,0.3,1.3,0.5\n\t\tc0.3,0.1,0.5,0.3,0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.3,0.5,0.4,0.7c0.1,0.3,0.1,0.6,0.1,1c0,0.9-0.4,1.6-1.1,2.2\n\t\tc-0.7,0.5-1.7,0.8-2.9,0.8c-0.6,0-1.2-0.1-1.8-0.2c-0.6-0.1-1.2-0.4-1.8-0.6l0.8-1.6c0.5,0.2,0.9,0.4,1.4,0.5\n\t\tc0.5,0.1,0.9,0.2,1.4,0.2c0.7,0,1.2-0.1,1.5-0.3c0.3-0.2,0.5-0.5,0.5-0.8c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3\n\t\tc-0.1-0.1-0.2-0.2-0.3-0.2C108.2,27.1,108.2,27.1,108.1,27.1z","key":9}),React.createElement("path",{"className":"stLG","d":"M115.4,31c-0.7,0-1.2-0.1-1.7-0.3c-0.4-0.2-0.8-0.4-1.1-0.8c-0.3-0.3-0.5-0.7-0.6-1.2c-0.1-0.5-0.2-1-0.2-1.6\n\t\tc0-1.2,0.3-2.2,0.9-2.8c0.6-0.6,1.6-0.9,2.9-0.9c0.7,0,1.2,0.1,1.7,0.3c0.4,0.2,0.8,0.4,1.1,0.8c0.3,0.3,0.5,0.7,0.6,1.2\n\t\tc0.1,0.5,0.2,1,0.2,1.6c0,1.2-0.3,2.2-0.9,2.8C117.6,30.7,116.7,31,115.4,31z M115.4,29.6c0.7,0,1.1-0.2,1.4-0.6\n\t\tc0.2-0.4,0.4-1,0.4-1.8c0-0.3,0-0.6-0.1-0.9c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.7-0.2\n\t\tc-0.7,0-1.1,0.2-1.3,0.6c-0.2,0.4-0.4,1-0.4,1.9c0,0.3,0,0.6,0.1,0.9c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.4,0.5\n\t\tC114.9,29.5,115.1,29.6,115.4,29.6z","key":10}),React.createElement("path",{"className":"stLG","d":"M123.2,30.8c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0h-0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.7-0.5\n\t\tc-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-1v-8.3l2-0.3v8.6c0,0.2,0,0.4,0,0.5c0,0.1,0.1,0.2,0.1,0.3\n\t\tc0.1,0.1,0.1,0.1,0.3,0.1c0.1,0,0.2,0,0.4,0V30.8z","key":11}),React.createElement("path",{"className":"stLG","d":"M130.5,28.9l0.1,1.9h-1.9l-0.1-0.5c-0.2,0.1-0.5,0.3-0.8,0.4c-0.5,0.2-1,0.3-1.5,0.3c-0.5,0-0.8-0.1-1.1-0.2\n\t\tc-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.3-0.1-0.7-0.1-1v-4.8h2V28c0,0.2,0,0.4,0,0.5c0,0.2,0.1,0.3,0.1,0.4\n\t\tc0.1,0.1,0.1,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6,0,0.8-0.1c0.2-0.1,0.4-0.2,0.6-0.3v-5.4h2V28.9z","key":12}),React.createElement("path",{"className":"stLG","d":"M134.7,25.1v2.9c0,0.2,0,0.3,0,0.5c0,0.2,0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0.1\n\t\tc0.3,0,0.6,0,0.8-0.1c0.2-0.1,0.5-0.2,0.7-0.3l0.3,1.3c-0.7,0.4-1.5,0.6-2.5,0.6c-0.5,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.7-0.5\n\t\tc-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.3-0.1-0.6-0.1-1v-3.4h-1.2v-1.3l1.2-0.1v-1.4l2-0.4v1.7h2.5v1.5H134.7z","key":13}),React.createElement("path",{"className":"stLG","d":"M138.4,20.5h2.1v1.6h-2.1V20.5z M138.4,23.6h2v7.2h-2V23.6z","key":14}),React.createElement("path",{"className":"stLG","d":"M145.1,31c-0.7,0-1.2-0.1-1.7-0.3c-0.4-0.2-0.8-0.4-1.1-0.8c-0.3-0.3-0.5-0.7-0.6-1.2c-0.1-0.5-0.2-1-0.2-1.6\n\t\tc0-1.2,0.3-2.2,0.9-2.8c0.6-0.6,1.6-0.9,2.9-0.9c0.7,0,1.2,0.1,1.7,0.3c0.4,0.2,0.8,0.4,1.1,0.8c0.3,0.3,0.5,0.7,0.6,1.2\n\t\tc0.1,0.5,0.2,1,0.2,1.6c0,1.2-0.3,2.2-0.9,2.8C147.3,30.7,146.4,31,145.1,31z M145.1,29.6c0.7,0,1.1-0.2,1.4-0.6\n\t\tc0.2-0.4,0.4-1,0.4-1.8c0-0.3,0-0.6-0.1-0.9c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.7-0.2\n\t\tc-0.7,0-1.1,0.2-1.3,0.6c-0.2,0.4-0.4,1-0.4,1.9c0,0.3,0,0.6,0.1,0.9c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.4,0.5\n\t\tC144.6,29.5,144.8,29.6,145.1,29.6z","key":15}),React.createElement("path",{"className":"stLG","d":"M151.9,23.6l0,0.5c0.2-0.2,0.5-0.3,0.8-0.4c0.6-0.2,1.1-0.3,1.6-0.3c0.5,0,0.9,0.1,1.2,0.2\n\t\tc0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.1,0.7,0.1,1v4.8h-2v-4.4c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.3-0.1-0.4\n\t\tc-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0-0.9,0.1c-0.2,0.1-0.4,0.2-0.6,0.3v5.3h-2v-5.2l-0.1-1.9H151.9z","key":16}),React.createElement("path",{"className":"stLG","d":"M160.7,26.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.3,0.1\n\t\tc0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.8c0,0.8-0.3,1.3-0.8,1.7\n\t\tc-0.6,0.4-1.3,0.6-2.3,0.6c-0.6,0-1.2-0.1-1.7-0.2c-0.5-0.1-0.9-0.2-1.3-0.4l0.6-1.4c0.3,0.2,0.6,0.3,1,0.4\n\t\tc0.4,0.1,0.8,0.1,1.3,0.1c0.4,0,0.7,0,0.9-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.3-0.3-0.6-1-0.8c-0.2-0.1-0.4-0.1-0.7-0.2\n\t\tc-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.1-0.5-0.1-0.8\n\t\tc0-0.8,0.3-1.3,0.8-1.7c0.6-0.4,1.3-0.6,2.3-0.6c0.6,0,1.1,0,1.6,0.1c0.4,0.1,0.9,0.2,1.3,0.4l-0.6,1.4c-0.3-0.2-0.6-0.3-1-0.4\n\t\tc-0.4-0.1-0.8-0.1-1.2-0.1c-0.4,0-0.7,0-0.9,0.1s-0.3,0.2-0.3,0.4c0,0.2,0.1,0.3,0.2,0.4C160.1,26,160.3,26.1,160.7,26.2z","key":17}),React.createElement("polygon",{"className":"stLG","points":"51.5,6.5 45.9,6.5 45.9,30.8 63.1,30.8 63.1,26.1 51.5,26.1 \t","key":18}),React.createElement("path",{"className":"stLG","d":"M75.5,21.5H80v4.2c-0.8,0.3-2.5,0.6-4,0.6c-5,0-6.7-2.6-6.7-7.8c0-5,1.6-7.9,6.6-7.9c2.8,0,4.4,0.9,5.7,2.6\n\t\tl3.5-3.2c-2.1-3-5.8-4-9.3-4c-7.8,0-12,4.3-12,12.5c0,8.1,3.7,12.5,11.9,12.5c3.8,0,7.4-1,9.4-2.4V17h-9.7V21.5z","key":19}),React.createElement("rect",{"x":"98.3","y":"6.5","className":"stLG","width":"1.1","height":"24.3","key":20})])]);
	}
	
	LgLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"164px","height":"38px","viewBox":"0 0 163.8 37.5","style":{"enableBackground":"new 0 0 163.8 37.5"},"xmlSpace":"preserve"};
	
	module.exports = LgLogo;
	
	LgLogo.default = LgLogo;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LupinLogo (props) {
	    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M2.58,1.96h10.07v25.6h15.72v8.36H2.58V1.96z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M29.02,36.57H1.94V1.32H13.3v25.6h15.72V36.57z M3.22,35.28h24.52V28.2H12.01V2.6H3.22V35.28z","key":1})]),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M53.76,1.96h9.84V22.2c0,2.01-0.29,3.9-0.88,5.68c-0.59,1.78-1.51,3.34-2.77,4.68\n\t\t\tc-1.26,1.33-2.57,2.27-3.95,2.81c-1.92,0.76-4.22,1.13-6.9,1.13c-1.55,0-3.25-0.12-5.08-0.35c-1.84-0.23-3.37-0.69-4.61-1.38\n\t\t\tc-1.23-0.69-2.36-1.66-3.39-2.93c-1.02-1.27-1.72-2.57-2.1-3.91C33.31,25.78,33,23.86,33,22.2V1.96h9.84v20.72\n\t\t\tc0,1.85,0.48,3.3,1.45,4.34c0.97,1.04,2.3,1.56,4.02,1.56c1.7,0,3.03-0.51,4-1.54c0.97-1.03,1.45-2.48,1.45-4.36V1.96z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M49.1,37.14c-1.57,0-3.31-0.12-5.16-0.35c-1.91-0.24-3.54-0.73-4.84-1.45c-1.3-0.72-2.5-1.76-3.57-3.09\n\t\t\tc-1.07-1.33-1.82-2.72-2.22-4.14c-0.62-2.21-0.94-4.2-0.94-5.92V1.32h11.13v21.36c0,1.68,0.43,2.99,1.28,3.9\n\t\t\tc0.85,0.91,2.01,1.36,3.55,1.36c1.53,0,2.68-0.44,3.53-1.34c0.85-0.9,1.27-2.22,1.27-3.92V1.32h11.13V22.2\n\t\t\tc0,2.07-0.31,4.05-0.91,5.88c-0.61,1.86-1.59,3.52-2.91,4.92c-1.32,1.4-2.72,2.4-4.19,2.97C54.25,36.75,51.85,37.14,49.1,37.14z\n\t\t\t M33.64,2.6V22.2c0,1.6,0.3,3.47,0.89,5.57c0.35,1.25,1.02,2.49,1.98,3.68c0.97,1.2,2.04,2.13,3.2,2.77\n\t\t\tc1.16,0.64,2.63,1.08,4.37,1.3c4.88,0.62,8.77,0.4,11.67-0.75c1.29-0.5,2.54-1.4,3.72-2.66c1.19-1.26,2.07-2.75,2.62-4.44\n\t\t\tc0.56-1.71,0.85-3.55,0.85-5.48V2.6H54.4v20.07c0,2.04-0.55,3.66-1.62,4.8c-1.09,1.16-2.59,1.74-4.46,1.74\n\t\t\tc-1.89,0-3.4-0.59-4.49-1.77c-1.07-1.16-1.62-2.77-1.62-4.78V2.6H33.64z","key":1})]),React.createElement("g",{"key":2},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M71,1.96h18.32c3.99,0,6.98,0.9,8.96,2.71c1.99,1.81,2.98,4.38,2.98,7.71c0,3.43-1.08,6.11-3.25,8.04\n\t\t\ts-5.47,2.9-9.91,2.9h-6.03v12.6H71V1.96z M82.07,16.44h2.7c2.13,0,3.62-0.35,4.48-1.05c0.86-0.7,1.29-1.6,1.29-2.7\n\t\t\tc0-1.07-0.37-1.97-1.12-2.71c-0.75-0.74-2.15-1.11-4.21-1.11h-3.14V16.44z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M82.71,36.57H70.36V1.32h18.96c4.13,0,7.29,0.97,9.4,2.88c2.12,1.93,3.19,4.68,3.19,8.19\n\t\t\tc0,3.6-1.16,6.47-3.46,8.52c-2.28,2.03-5.75,3.06-10.34,3.06h-5.39V36.57z M71.64,35.28h9.79v-12.6h6.67\n\t\t\tc4.26,0,7.45-0.92,9.49-2.73c2.04-1.82,3.03-4.29,3.03-7.56c0-3.13-0.93-5.57-2.77-7.24c-1.86-1.69-4.73-2.54-8.53-2.54H71.64\n\t\t\tV35.28z M84.77,17.08h-3.34V8.22h3.78c2.26,0,3.78,0.42,4.66,1.3c0.87,0.86,1.31,1.93,1.31,3.17c0,1.29-0.51,2.37-1.53,3.2\n\t\t\tC88.66,16.69,87.07,17.08,84.77,17.08z M82.71,15.8h2.06c1.96,0,3.33-0.31,4.07-0.91c0.71-0.58,1.06-1.3,1.06-2.2\n\t\t\tc0-0.9-0.3-1.63-0.93-2.26c-0.61-0.61-1.91-0.93-3.76-0.93h-2.5V15.8z","key":1})]),React.createElement("g",{"key":3},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M107.25,1.96h10.2v33.96h-10.2V1.96z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M118.09,36.57h-11.48V1.32h11.48V36.57z M107.89,35.28h8.92V2.6h-8.92V35.28z","key":1})]),React.createElement("g",{"key":4},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M124.83,1.96h9.9l12.92,18.79V1.96h9.99v33.96h-9.99L134.8,17.28v18.65h-9.97V1.96z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M158.27,36.57H147.3l-11.87-17.23v17.23h-11.25V1.32h10.88L147,18.69V1.32h11.27V36.57z M147.98,35.28h9.01\n\t\t\tV2.6h-8.71v20.21L134.39,2.6h-8.92v32.68h8.68V15.22L147.98,35.28z","key":1})])]),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M177.08,25.01l4.32-0.37c0.2,1.7,0.68,3.09,1.43,4.18c0.75,1.09,1.91,1.97,3.49,2.64\n\t\t\tc1.58,0.67,3.35,1.01,5.32,1.01c1.75,0,3.29-0.25,4.63-0.76c1.34-0.51,2.33-1.21,2.99-2.1c0.65-0.89,0.98-1.86,0.98-2.91\n\t\t\tc0-1.07-0.32-2-0.95-2.79c-0.63-0.8-1.67-1.46-3.12-2c-0.93-0.36-2.99-0.91-6.17-1.66c-3.18-0.75-5.41-1.46-6.69-2.12\n\t\t\tc-1.65-0.85-2.89-1.9-3.7-3.16c-0.81-1.26-1.22-2.67-1.22-4.23c0-1.71,0.5-3.32,1.49-4.81c0.99-1.49,2.44-2.62,4.35-3.39\n\t\t\tc1.91-0.77,4.02-1.16,6.36-1.16c2.57,0,4.83,0.41,6.79,1.22c1.96,0.81,3.47,2,4.53,3.58c1.06,1.58,1.62,3.36,1.7,5.35l-4.4,0.32\n\t\t\tc-0.24-2.15-1.04-3.77-2.4-4.86c-1.36-1.1-3.38-1.64-6.04-1.64c-2.77,0-4.79,0.5-6.06,1.49c-1.27,1-1.9,2.2-1.9,3.6\n\t\t\tc0,1.22,0.45,2.22,1.35,3.01c0.88,0.79,3.19,1.59,6.91,2.42c3.73,0.83,6.28,1.55,7.67,2.17c2.02,0.91,3.51,2.07,4.47,3.46\n\t\t\tc0.96,1.4,1.44,3.01,1.44,4.83c0,1.81-0.53,3.51-1.58,5.11c-1.06,1.6-2.57,2.84-4.55,3.73c-1.98,0.89-4.2,1.33-6.68,1.33\n\t\t\tc-3.14,0-5.76-0.45-7.88-1.34c-2.12-0.9-3.78-2.24-4.99-4.04C177.77,29.32,177.14,27.28,177.08,25.01z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M191.85,36.66c-3.14,0-5.81-0.46-7.94-1.36c-2.14-0.9-3.84-2.28-5.06-4.1c-1.22-1.82-1.87-3.9-1.93-6.19\n\t\t\tl0-0.15l4.63-0.4l0.02,0.15c0.2,1.67,0.67,3.05,1.4,4.11c0.73,1.06,1.88,1.93,3.42,2.58c1.55,0.66,3.32,0.99,5.25,0.99\n\t\t\tc1.72,0,3.26-0.25,4.57-0.75c1.3-0.5,2.28-1.18,2.92-2.04c0.63-0.86,0.95-1.8,0.95-2.81c0-1.02-0.31-1.93-0.91-2.69\n\t\t\tc-0.61-0.77-1.63-1.43-3.05-1.95c-0.92-0.35-2.99-0.91-6.15-1.65c-3.18-0.75-5.44-1.47-6.72-2.13c-1.67-0.86-2.94-1.94-3.76-3.22\n\t\t\tc-0.82-1.28-1.24-2.73-1.24-4.31c0-1.74,0.51-3.39,1.52-4.9c1.01-1.51,2.49-2.67,4.42-3.45c1.92-0.78,4.08-1.17,6.42-1.17\n\t\t\tc2.58,0,4.88,0.41,6.85,1.23c1.98,0.82,3.53,2.04,4.6,3.64c1.07,1.59,1.65,3.42,1.73,5.43l0.01,0.15l-4.7,0.35l-0.02-0.15\n\t\t\tc-0.23-2.09-1.02-3.69-2.34-4.76c-1.33-1.07-3.33-1.61-5.94-1.61c-2.72,0-4.73,0.49-5.96,1.46c-1.22,0.96-1.84,2.13-1.84,3.48\n\t\t\tc0,1.17,0.43,2.14,1.29,2.89c0.86,0.77,3.16,1.57,6.84,2.38c3.72,0.83,6.31,1.56,7.7,2.18c2.03,0.92,3.56,2.1,4.53,3.52\n\t\t\tc0.97,1.42,1.47,3.07,1.47,4.92c0,1.83-0.54,3.58-1.61,5.2c-1.07,1.62-2.62,2.89-4.62,3.79C196.6,36.21,194.33,36.66,191.85,36.66\n\t\t\tz M177.24,25.16c0.09,2.17,0.71,4.14,1.87,5.87c1.18,1.76,2.84,3.1,4.92,3.98c2.09,0.88,4.72,1.33,7.82,1.33\n\t\t\tc2.44,0,4.66-0.44,6.61-1.32c1.94-0.87,3.45-2.11,4.48-3.67c1.03-1.56,1.56-3.25,1.56-5.02c0-1.78-0.48-3.38-1.41-4.74\n\t\t\tc-0.94-1.37-2.42-2.51-4.4-3.41c-1.37-0.61-3.94-1.34-7.64-2.16c-3.79-0.84-6.07-1.64-6.98-2.46c-0.93-0.81-1.4-1.87-1.4-3.13\n\t\t\tc0-1.45,0.66-2.71,1.96-3.73c1.29-1.01,3.36-1.53,6.16-1.53c2.69,0,4.75,0.57,6.14,1.68c1.36,1.09,2.18,2.71,2.44,4.82l4.09-0.3\n\t\t\tc-0.1-1.89-0.66-3.61-1.67-5.11c-1.03-1.54-2.53-2.73-4.45-3.52c-1.93-0.8-4.2-1.2-6.73-1.2c-2.3,0-4.42,0.39-6.3,1.15\n\t\t\tc-1.87,0.76-3.3,1.88-4.27,3.33c-0.97,1.46-1.46,3.04-1.46,4.72c0,1.52,0.4,2.91,1.19,4.14c0.79,1.23,2.01,2.27,3.64,3.11\n\t\t\tc1.26,0.66,3.5,1.36,6.65,2.11c3.17,0.75,5.26,1.31,6.19,1.66c1.47,0.55,2.54,1.24,3.19,2.05c0.65,0.82,0.98,1.79,0.98,2.89\n\t\t\tc0,1.08-0.34,2.09-1.01,3c-0.67,0.91-1.7,1.63-3.06,2.15c-1.35,0.51-2.93,0.78-4.69,0.78c-1.98,0-3.79-0.34-5.38-1.02\n\t\t\tc-1.6-0.68-2.79-1.59-3.55-2.7c-0.74-1.07-1.22-2.45-1.44-4.1L177.24,25.16z","key":1})]),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M208.84,19.38c0-5.64,1.54-10.05,4.63-13.24c3.09-3.19,7.07-4.78,11.96-4.78c3.2,0,6.08,0.75,8.65,2.25\n\t\t\ts4.53,3.59,5.87,6.27c1.35,2.68,2.02,5.72,2.02,9.12c0,3.44-0.71,6.53-2.13,9.24c-1.42,2.72-3.43,4.78-6.03,6.17\n\t\t\tc-2.6,1.4-5.4,2.1-8.41,2.1c-3.26,0-6.18-0.77-8.74-2.32c-2.57-1.54-4.51-3.65-5.84-6.32C209.5,25.19,208.84,22.36,208.84,19.38z\n\t\t\t M213.57,19.45c0,4.09,1.12,7.32,3.37,9.67c2.25,2.36,5.06,3.53,8.45,3.53c3.45,0,6.29-1.19,8.52-3.57\n\t\t\tc2.23-2.38,3.34-5.75,3.34-10.12c0-2.76-0.48-5.18-1.43-7.24c-0.95-2.06-2.35-3.66-4.18-4.8c-1.84-1.14-3.9-1.7-6.18-1.7\n\t\t\tc-3.25,0-6.04,1.09-8.38,3.28C214.74,10.69,213.57,14.34,213.57,19.45z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M225.41,36.66c-3.28,0-6.24-0.79-8.83-2.34c-2.58-1.55-4.57-3.7-5.9-6.39c-1.33-2.68-2-5.56-2-8.55\n\t\t\tc0-5.65,1.57-10.15,4.68-13.35c3.1-3.21,7.17-4.83,12.07-4.83c3.21,0,6.15,0.76,8.73,2.27c2.58,1.51,4.58,3.64,5.93,6.33\n\t\t\tc1.35,2.69,2.04,5.78,2.04,9.19c0,3.45-0.72,6.59-2.15,9.32c-1.43,2.73-3.48,4.83-6.09,6.24\n\t\t\tC231.29,35.95,228.43,36.66,225.41,36.66z M225.43,1.52c-4.82,0-8.8,1.59-11.84,4.73C210.55,9.4,209,13.82,209,19.38\n\t\t\tc0,2.94,0.66,5.77,1.97,8.41c1.3,2.63,3.25,4.74,5.78,6.26c2.53,1.52,5.44,2.29,8.66,2.29c2.97,0,5.77-0.7,8.34-2.08\n\t\t\tc2.56-1.38,4.56-3.43,5.96-6.11c1.4-2.68,2.11-5.77,2.11-9.17c0-3.36-0.67-6.4-2-9.04c-1.33-2.64-3.28-4.72-5.81-6.2\n\t\t\tC231.47,2.27,228.59,1.52,225.43,1.52z M225.38,32.82c-3.42,0-6.3-1.21-8.56-3.58c-2.26-2.37-3.41-5.67-3.41-9.78\n\t\t\tc0-5.13,1.2-8.86,3.56-11.06c2.36-2.2,5.21-3.32,8.49-3.32c2.3,0,4.41,0.58,6.26,1.73c1.85,1.15,3.28,2.78,4.24,4.86\n\t\t\tc0.96,2.07,1.44,4.53,1.44,7.31c0,4.39-1.14,7.84-3.39,10.23C231.77,31.6,228.86,32.82,225.38,32.82z M225.46,5.39\n\t\t\tc-3.19,0-5.97,1.09-8.27,3.23c-2.29,2.14-3.46,5.79-3.46,10.83c0,4.03,1.12,7.25,3.32,9.56c2.2,2.31,5.01,3.48,8.33,3.48\n\t\t\tc3.39,0,6.21-1.18,8.4-3.52c2.19-2.34,3.3-5.71,3.3-10.01c0-2.73-0.48-5.14-1.41-7.17c-0.94-2.02-2.32-3.61-4.12-4.73\n\t\t\tC229.75,5.95,227.7,5.39,225.46,5.39z","key":1})]),React.createElement("g",{"key":2},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M247.54,35.92V1.96h6.9l8.2,24.05c0.76,2.24,1.31,3.92,1.65,5.03c0.39-1.24,1.01-3.05,1.84-5.44l8.29-23.63\n\t\t\th6.17v33.96h-4.42V7.5l-10.07,28.43h-4.13L251.96,7.01v28.91H247.54z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M280.76,36.08h-4.74V8.43l-9.79,27.65h-4.36l-0.04-0.11l-9.71-28.01v28.12h-4.74V1.8h7.18l8.24,24.16\n\t\t\tc0.65,1.92,1.15,3.45,1.5,4.55c0.4-1.22,0.96-2.89,1.69-4.97l8.33-23.74h6.44V36.08z M276.34,35.76h4.1V2.12h-5.89l-8.26,23.52\n\t\t\tc-0.83,2.37-1.45,4.2-1.84,5.44l-0.15,0.48l-0.15-0.49c-0.35-1.12-0.91-2.81-1.65-5.02l-8.16-23.94h-6.63v33.64h4.1V6.06\n\t\t\tl10.29,29.7H266l10.34-29.2V35.76z","key":1})]),React.createElement("g",{"key":3},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M287.66,35.92V1.96h25.05v4.01h-20.46v10.4h19.16v3.98h-19.16v11.56h21.27v4.01H287.66z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M313.67,36.08H287.5V1.8h25.37v4.33H292.4v10.08h19.16v4.31H292.4v11.24h21.27V36.08z M287.82,35.76h25.53\n\t\t\tv-3.69h-21.27V20.2h19.16v-3.66h-19.16V5.81h20.46V2.12h-24.73V35.76z","key":1})]),React.createElement("g",{"key":4},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M319.96,35.92V1.96h15.36c3.09,0,5.43,0.3,7.04,0.91c1.61,0.61,2.89,1.69,3.85,3.23\n\t\t\tc0.96,1.54,1.44,3.25,1.44,5.12c0,2.41-0.8,4.44-2.39,6.09c-1.59,1.65-4.05,2.7-7.37,3.15c1.21,0.57,2.13,1.14,2.76,1.69\n\t\t\tc1.34,1.2,2.61,2.71,3.8,4.52l6.03,9.24h-5.77l-4.58-7.07c-1.34-2.04-2.44-3.6-3.31-4.68c-0.87-1.08-1.64-1.84-2.33-2.27\n\t\t\tc-0.68-0.43-1.38-0.73-2.09-0.9c-0.52-0.11-1.37-0.16-2.55-0.16h-5.32v15.08H319.96z M324.55,16.95h9.85\n\t\t\tc2.1,0,3.73-0.21,4.92-0.64c1.18-0.42,2.08-1.1,2.69-2.04c0.61-0.93,0.92-1.95,0.92-3.05c0-1.61-0.59-2.93-1.78-3.96\n\t\t\tc-1.19-1.03-3.07-1.55-5.64-1.55h-10.96V16.95z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M350.79,36.08h-6.15l-4.63-7.14c-1.33-2.02-2.44-3.59-3.3-4.67c-0.85-1.06-1.62-1.81-2.29-2.24\n\t\t\tc-0.67-0.42-1.35-0.72-2.04-0.88c-0.5-0.1-1.35-0.16-2.51-0.16h-5.16v15.08h-4.91V1.8h15.52c3.09,0,5.48,0.31,7.1,0.93\n\t\t\tc1.63,0.62,2.96,1.73,3.93,3.3c0.97,1.56,1.47,3.31,1.47,5.2c0,2.44-0.82,4.53-2.43,6.2c-1.53,1.58-3.86,2.63-6.95,3.12\n\t\t\tc1,0.5,1.78,1,2.33,1.49c1.34,1.21,2.63,2.74,3.83,4.55L350.79,36.08z M344.81,35.76h5.38l-5.86-9c-1.18-1.79-2.46-3.3-3.78-4.49\n\t\t\tc-0.61-0.54-1.53-1.1-2.73-1.66l-0.49-0.23l0.54-0.07c3.27-0.44,5.72-1.48,7.28-3.1c1.55-1.61,2.34-3.63,2.34-5.98\n\t\t\tc0-1.83-0.48-3.52-1.42-5.04c-0.94-1.51-2.21-2.57-3.77-3.17c-1.58-0.6-3.93-0.9-6.99-0.9h-15.2v33.64h4.26V20.68h5.48\n\t\t\tc1.2,0,2.05,0.05,2.58,0.17c0.73,0.17,1.45,0.49,2.14,0.93c0.7,0.44,1.49,1.22,2.37,2.31c0.87,1.08,1.98,2.66,3.32,4.69\n\t\t\tL344.81,35.76z M334.4,17.11h-10.01V5.55h11.12c2.6,0,4.53,0.54,5.74,1.59c1.22,1.06,1.84,2.44,1.84,4.08\n\t\t\tc0,1.12-0.32,2.18-0.95,3.13c-0.63,0.96-1.56,1.67-2.77,2.1C338.18,16.89,336.5,17.11,334.4,17.11z M324.71,16.79h9.69\n\t\t\tc2.07,0,3.7-0.21,4.86-0.63c1.14-0.41,2.02-1.08,2.61-1.98c0.59-0.9,0.89-1.9,0.89-2.96c0-1.55-0.58-2.84-1.73-3.84\n\t\t\tc-1.15-1-3.01-1.51-5.53-1.51h-10.8V16.79z","key":1})]),React.createElement("g",{"key":5},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M353.81,25.01l4.32-0.37c0.2,1.7,0.68,3.09,1.43,4.18c0.75,1.09,1.91,1.97,3.49,2.64\n\t\t\tc1.58,0.67,3.35,1.01,5.32,1.01c1.75,0,3.29-0.25,4.63-0.76c1.34-0.51,2.34-1.21,2.99-2.1c0.65-0.89,0.98-1.86,0.98-2.91\n\t\t\tc0-1.07-0.31-2-0.94-2.79c-0.63-0.8-1.67-1.46-3.12-2c-0.93-0.36-2.99-0.91-6.17-1.66c-3.18-0.75-5.41-1.46-6.69-2.12\n\t\t\tc-1.65-0.85-2.89-1.9-3.7-3.16c-0.81-1.26-1.22-2.67-1.22-4.23c0-1.71,0.5-3.32,1.49-4.81c0.99-1.49,2.44-2.62,4.35-3.39\n\t\t\tc1.91-0.77,4.02-1.16,6.36-1.16c2.57,0,4.83,0.41,6.79,1.22c1.96,0.81,3.47,2,4.53,3.58c1.06,1.58,1.62,3.36,1.7,5.35l-4.4,0.32\n\t\t\tc-0.24-2.15-1.04-3.77-2.4-4.86c-1.36-1.1-3.38-1.64-6.04-1.64c-2.77,0-4.79,0.5-6.06,1.49c-1.27,1-1.9,2.2-1.9,3.6\n\t\t\tc0,1.22,0.45,2.22,1.35,3.01c0.88,0.79,3.19,1.59,6.91,2.42c3.73,0.83,6.28,1.55,7.67,2.17c2.02,0.91,3.51,2.07,4.47,3.46\n\t\t\tc0.96,1.4,1.44,3.01,1.44,4.83c0,1.81-0.53,3.51-1.58,5.11c-1.06,1.6-2.57,2.84-4.55,3.73c-1.98,0.89-4.2,1.33-6.68,1.33\n\t\t\tc-3.14,0-5.76-0.45-7.88-1.34c-2.12-0.9-3.78-2.24-4.99-4.04C354.51,29.32,353.87,27.28,353.81,25.01z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M368.58,36.66c-3.14,0-5.81-0.46-7.94-1.36c-2.14-0.9-3.84-2.28-5.06-4.1c-1.22-1.82-1.87-3.9-1.93-6.19\n\t\t\tl0-0.15l4.63-0.4l0.02,0.15c0.2,1.67,0.67,3.05,1.4,4.11c0.73,1.06,1.88,1.93,3.42,2.58c1.55,0.66,3.32,0.99,5.25,0.99\n\t\t\tc1.72,0,3.26-0.25,4.57-0.75c1.3-0.5,2.29-1.18,2.92-2.04c0.63-0.86,0.95-1.8,0.95-2.81c0-1.02-0.31-1.93-0.91-2.69\n\t\t\tc-0.61-0.77-1.64-1.43-3.05-1.95c-0.92-0.35-2.99-0.91-6.15-1.65c-3.18-0.75-5.44-1.47-6.72-2.13c-1.67-0.86-2.94-1.94-3.76-3.22\n\t\t\tc-0.82-1.28-1.24-2.73-1.24-4.31c0-1.74,0.51-3.39,1.52-4.9c1.01-1.51,2.49-2.67,4.42-3.45c1.92-0.78,4.08-1.17,6.42-1.17\n\t\t\tc2.58,0,4.88,0.41,6.86,1.23c1.98,0.82,3.53,2.04,4.6,3.64c1.07,1.59,1.65,3.42,1.73,5.43l0.01,0.15l-4.7,0.35l-0.02-0.15\n\t\t\tc-0.23-2.09-1.02-3.69-2.34-4.76c-1.33-1.07-3.33-1.61-5.94-1.61c-2.72,0-4.73,0.49-5.96,1.46c-1.22,0.96-1.84,2.13-1.84,3.48\n\t\t\tc0,1.17,0.43,2.14,1.29,2.89c0.86,0.77,3.16,1.57,6.84,2.38c3.72,0.83,6.31,1.56,7.7,2.18c2.03,0.92,3.56,2.1,4.53,3.52\n\t\t\tc0.97,1.42,1.47,3.08,1.47,4.92c0,1.83-0.54,3.58-1.61,5.2c-1.07,1.62-2.62,2.89-4.62,3.79\n\t\t\tC373.33,36.21,371.06,36.66,368.58,36.66z M353.98,25.16c0.09,2.17,0.71,4.14,1.87,5.87c1.18,1.76,2.84,3.1,4.92,3.98\n\t\t\tc2.09,0.88,4.72,1.33,7.82,1.33c2.44,0,4.66-0.44,6.61-1.32c1.94-0.87,3.45-2.11,4.48-3.67c1.03-1.57,1.56-3.25,1.56-5.02\n\t\t\tc0-1.78-0.48-3.37-1.41-4.74c-0.94-1.37-2.42-2.51-4.4-3.41c-1.37-0.61-3.94-1.34-7.64-2.16c-3.79-0.84-6.07-1.64-6.98-2.46\n\t\t\tc-0.93-0.81-1.4-1.87-1.4-3.13c0-1.45,0.66-2.71,1.96-3.73c1.29-1.01,3.36-1.53,6.16-1.53c2.69,0,4.75,0.57,6.14,1.68\n\t\t\tc1.36,1.09,2.18,2.71,2.44,4.82l4.09-0.3c-0.1-1.89-0.66-3.61-1.67-5.11c-1.03-1.54-2.53-2.73-4.45-3.52\n\t\t\tc-1.93-0.8-4.2-1.2-6.73-1.2c-2.3,0-4.42,0.39-6.3,1.15c-1.87,0.76-3.3,1.88-4.27,3.33c-0.97,1.46-1.46,3.04-1.46,4.72\n\t\t\tc0,1.52,0.4,2.92,1.19,4.14c0.79,1.23,2.02,2.27,3.64,3.11c1.26,0.66,3.5,1.36,6.65,2.11c3.17,0.75,5.26,1.31,6.19,1.66\n\t\t\tc1.47,0.55,2.54,1.24,3.19,2.05c0.65,0.82,0.98,1.79,0.98,2.89c0,1.08-0.34,2.09-1.01,3c-0.67,0.91-1.7,1.63-3.06,2.15\n\t\t\tc-1.35,0.51-2.93,0.78-4.69,0.78c-1.98,0-3.79-0.34-5.38-1.02c-1.6-0.68-2.79-1.59-3.55-2.7c-0.74-1.07-1.22-2.45-1.44-4.1\n\t\t\tL353.98,25.16z","key":1})]),React.createElement("g",{"key":6},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M386.83,35.92V1.96h25.05v4.01h-20.46v10.4h19.16v3.98h-19.16v11.56h21.27v4.01H386.83z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M412.84,36.08h-26.17V1.8h25.37v4.33h-20.46v10.08h19.16v4.31h-19.16v11.24h21.27V36.08z M386.99,35.76h25.53\n\t\t\tv-3.69h-21.27V20.2h19.16v-3.66h-19.16V5.81h20.46V2.12h-24.73V35.76z","key":1})]),React.createElement("g",{"key":7},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M428.6,35.92V5.97h-11.41V1.96h27.46v4.01h-11.46v29.95H428.6z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M433.34,36.08h-4.9V6.13h-11.41V1.8h27.78v4.33h-11.46V36.08z M428.76,35.76h4.26V5.81h11.46V2.12h-27.14\n\t\t\tv3.69h11.41V35.76z","key":1})])]),React.createElement("text",{"transform":"matrix(1 0 0 1 48.5068 127.5781)","style":{"fill":"#FFFFFF"},"key":2},"an Operating Division of Lupin Inc.")]);
	}
	
	LupinLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"164px","height":"38px","viewBox":"0 0 446.01 38","style":{"enableBackground":"new 0 0 446.01 38"},"xmlSpace":"preserve"};
	
	module.exports = LupinLogo;
	
	LupinLogo.default = LupinLogo;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function PeprotechLogo (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"11.82,0.62 1.24,19.22 11.82,23.08 \t","key":0}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"1.64,20.5 11.82,38.56 11.82,24.22 \t","key":1}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"23.47,19.22 12.89,0.62 12.89,23.08 \t","key":2}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"12.89,38.56 23.07,20.5 12.89,24.22 \t","key":3})]),React.createElement("g",{"key":2},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M31.99,25.75V4.47h7.96c2.52,0,4.46,0.62,5.84,1.85c1.37,1.24,2.06,3,2.06,5.28s-0.69,4.04-2.06,5.27\n\t\tc-1.37,1.23-3.32,1.85-5.84,1.85h-4.12v7.03H31.99z M35.82,15.28h3.83c1.68,0,2.83-0.31,3.44-0.93c0.61-0.62,0.92-1.54,0.92-2.75\n\t\tc0-1.2-0.31-2.1-0.93-2.72c-0.62-0.61-1.76-0.92-3.44-0.92h-3.83V15.28z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M50.1,25.75V6.95h12.51v3.04h-9.12v4.76h7.91v3.19h-7.91v4.76h9.12v3.04H50.1z","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M65.13,25.75V6.95h7.03c2.22,0,3.94,0.55,5.16,1.64c1.21,1.09,1.82,2.65,1.82,4.67s-0.61,3.57-1.82,4.66\n\t\tc-1.21,1.09-2.93,1.63-5.16,1.63h-3.64v6.21H65.13z M68.52,16.5h3.39c1.49,0,2.5-0.27,3.04-0.82c0.54-0.55,0.81-1.36,0.81-2.43\n\t\tc0-1.06-0.27-1.86-0.82-2.4c-0.55-0.54-1.56-0.81-3.03-0.81h-3.39V16.5z","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M81.33,25.75V6.95h7.22c2.2,0,3.92,0.52,5.14,1.57c1.22,1.04,1.83,2.54,1.83,4.48c0,2.86-1.38,4.72-4.13,5.56\n\t\tl4.94,7.2h-4.09l-4.49-6.63h-3.04v6.63H81.33z M84.72,16.02h3.74c1.15,0,2.05-0.2,2.7-0.61c0.65-0.41,0.98-1.18,0.98-2.32\n\t\tc0-1.16-0.33-1.94-0.98-2.34c-0.65-0.4-1.55-0.6-2.7-0.6h-3.74V16.02z","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M97.41,16.35c0-1.54,0.18-2.89,0.54-4.05c0.36-1.16,0.82-2.09,1.38-2.78c0.56-0.69,1.25-1.26,2.04-1.69\n\t\tc0.8-0.44,1.58-0.73,2.34-0.87c0.76-0.15,1.58-0.22,2.46-0.22s1.7,0.07,2.46,0.22c0.76,0.15,1.54,0.44,2.34,0.87\n\t\tc0.8,0.44,1.48,1,2.06,1.69s1.04,1.62,1.4,2.78c0.36,1.16,0.54,2.52,0.54,4.05c0,1.53-0.18,2.88-0.54,4.05\n\t\tc-0.36,1.18-0.82,2.11-1.4,2.79c-0.57,0.68-1.26,1.24-2.06,1.68c-0.8,0.44-1.58,0.73-2.34,0.88c-0.76,0.15-1.58,0.22-2.46,0.22\n\t\ts-1.7-0.07-2.46-0.22c-0.76-0.15-1.54-0.44-2.34-0.88c-0.8-0.44-1.48-1-2.04-1.68c-0.56-0.68-1.03-1.61-1.38-2.79\n\t\tC97.59,19.23,97.41,17.88,97.41,16.35z M100.79,16.32c0,1.41,0.14,2.58,0.42,3.5c0.28,0.92,0.69,1.6,1.24,2.04\n\t\tc0.55,0.44,1.11,0.73,1.68,0.89c0.57,0.16,1.25,0.23,2.04,0.23c0.64,0,1.2-0.04,1.67-0.12c0.47-0.08,0.95-0.26,1.44-0.53\n\t\tc0.5-0.27,0.9-0.65,1.21-1.13c0.31-0.48,0.57-1.13,0.78-1.96c0.21-0.82,0.31-1.8,0.31-2.93c0-1.39-0.14-2.55-0.42-3.48\n\t\tc-0.28-0.92-0.7-1.6-1.25-2.04c-0.56-0.43-1.12-0.73-1.68-0.87c-0.56-0.15-1.25-0.22-2.06-0.22c-0.62,0-1.17,0.04-1.64,0.12\n\t\tc-0.47,0.08-0.95,0.26-1.45,0.54c-0.5,0.27-0.9,0.65-1.21,1.11c-0.31,0.47-0.56,1.11-0.77,1.92\n\t\tC100.9,14.23,100.79,15.2,100.79,16.32z","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M116,6.7V4.47h17.31V6.7h-7.49v19.06h-2.31V6.7H116z","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M135.36,25.75V6.95h11.86v1.91h-9.83v6.5h8.64v1.97h-8.64v6.51h9.83v1.91H135.36z","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M148.73,16.34c0-6.42,2.91-9.63,8.73-9.63c2.01,0,3.92,0.36,5.73,1.09v1.95c-1.79-0.75-3.62-1.13-5.51-1.13\n\t\tc-2.39,0-4.13,0.62-5.24,1.86c-1.11,1.24-1.67,3.19-1.67,5.86s0.56,4.62,1.67,5.86c1.11,1.24,2.86,1.86,5.24,1.86\n\t\tc1.92,0,3.75-0.37,5.51-1.1v1.95c-1.8,0.71-3.68,1.06-5.66,1.06c-0.03,0-0.05,0-0.07,0C151.64,25.97,148.73,22.76,148.73,16.34z","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M165.65,25.75V6.95h2.04v8.42h10.01V6.95h2.04v18.8h-2.04v-8.41h-10.01v8.41H165.65z","key":8}),React.createElement("g",{"key":9},React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M181.09,23.98c0-0.5,0.18-0.93,0.53-1.29c0.35-0.35,0.78-0.53,1.28-0.53c0.5,0,0.93,0.18,1.29,0.53\n\t\t\tc0.35,0.35,0.53,0.78,0.53,1.29c0,0.5-0.18,0.93-0.53,1.28c-0.35,0.35-0.78,0.53-1.29,0.53c-0.5,0-0.93-0.18-1.28-0.53\n\t\t\tC181.27,24.9,181.09,24.48,181.09,23.98z M181.36,23.98c0,0.43,0.15,0.79,0.45,1.09c0.3,0.3,0.66,0.45,1.09,0.45\n\t\t\tc0.43,0,0.79-0.15,1.1-0.45c0.3-0.3,0.45-0.66,0.45-1.09c0-0.43-0.15-0.79-0.45-1.1c-0.3-0.3-0.67-0.45-1.1-0.45\n\t\t\tc-0.43,0-0.79,0.15-1.09,0.45C181.51,23.18,181.36,23.55,181.36,23.98z M182.2,25.01v-2.07h0.79c0.24,0,0.43,0.06,0.56,0.17\n\t\t\tc0.13,0.11,0.2,0.28,0.2,0.49c0,0.32-0.15,0.52-0.45,0.61l0.54,0.79h-0.45l-0.49-0.73h-0.33v0.73H182.2z M182.57,23.94h0.41\n\t\t\tc0.12,0,0.22-0.02,0.3-0.07c0.07-0.05,0.11-0.13,0.11-0.26c0-0.13-0.04-0.21-0.11-0.26c-0.07-0.05-0.17-0.07-0.3-0.07h-0.41V23.94\n\t\t\tz"}))]),React.createElement("g",{"key":3},React.createElement("path",{"style":{"fill":"none"},"d":"M50.03-16.51v-40.02H65c4.74,0,8.4,1.16,10.98,3.49c2.58,2.33,3.88,5.63,3.88,9.93s-1.29,7.6-3.88,9.92\n\t\tc-2.58,2.32-6.25,3.47-10.99,3.47h-7.75v13.21H50.03z M57.23-36.19h7.21c3.16,0,5.32-0.58,6.47-1.75c1.15-1.17,1.73-2.89,1.73-5.16\n\t\tc0-2.26-0.58-3.96-1.74-5.11c-1.16-1.15-3.32-1.72-6.46-1.72h-7.21V-36.19z"})),React.createElement("g",{"key":4},React.createElement("path",{"style":{"fill":"none"},"d":"M117.53,95.49V55.47h14.97c4.74,0,8.4,1.16,10.98,3.49c2.58,2.33,3.88,5.63,3.88,9.93s-1.29,7.6-3.88,9.92\n\t\tc-2.58,2.32-6.25,3.47-10.99,3.47h-7.75v13.21H117.53z M124.73,75.81h7.21c3.16,0,5.32-0.58,6.47-1.75\n\t\tc1.15-1.17,1.73-2.89,1.73-5.16c0-2.26-0.58-3.96-1.74-5.11c-1.16-1.15-3.32-1.72-6.46-1.72h-7.21V75.81z"})),React.createElement("g",{"key":5},React.createElement("path",{"style":{"fill":"none"},"d":"M40.12,29.84H0.1V14.87c0-4.74,1.16-8.4,3.49-10.98c2.33-2.58,5.63-3.88,9.93-3.88c4.3,0,7.6,1.29,9.92,3.88\n\t\tc2.32,2.58,3.47,6.25,3.47,10.99v7.75h13.21V29.84z M20.43,22.63v-7.21c0-3.16-0.58-5.32-1.75-6.47c-1.17-1.15-2.89-1.73-5.16-1.73\n\t\tc-2.26,0-3.96,0.58-5.11,1.74c-1.15,1.16-1.72,3.32-1.72,6.46v7.21H20.43z"})),React.createElement("g",{"key":6},React.createElement("path",{"style":{"fill":"none"},"d":"M415.82,29.84H375.8V14.87c0-4.74,1.16-8.4,3.49-10.98c2.33-2.58,5.63-3.88,9.93-3.88\n\t\tc4.3,0,7.6,1.29,9.92,3.88c2.32,2.58,3.47,6.25,3.47,10.99v7.75h13.21V29.84z M396.14,22.63v-7.21c0-3.16-0.58-5.32-1.75-6.47\n\t\tc-1.17-1.15-2.89-1.73-5.16-1.73c-2.26,0-3.96,0.58-5.11,1.74c-1.15,1.16-1.72,3.32-1.72,6.46v7.21H396.14z"}))]);
	}
	
	PeprotechLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"164px","height":"38px","viewBox":"0 0 189.86 39","style":{"enableBackground":"new 0 0 189.86 39"},"xmlSpace":"preserve"};
	
	module.exports = PeprotechLogo;
	
	PeprotechLogo.default = PeprotechLogo;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Philips (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M14.2,9.6c0,3.2-1.5,5.4-5.5,5.4H7.6V4.8c0.4,0,0.9,0,1.2,0C12.5,4.7,14.2,6.5,14.2,9.6z M10.2,19.5\n\tc7,0,11.4-3.6,11.4-10c0-7-4.7-9.5-12.5-9.5c-3,0-6.6,0.2-9.2,0.5v24.8h7.5v-5.9L10.2,19.5L10.2,19.5z M110.9,9.6\n\tc0,3.2-1.5,5.4-5.5,5.4h-1.2V4.8c0.4,0,0.9,0,1.2,0C109.2,4.7,110.9,6.5,110.9,9.6z M106.9,19.5c7,0,11.4-3.6,11.4-10\n\tc0-7-4.7-9.5-12.5-9.5c-3,0-6.6,0.2-9.2,0.5v24.8h7.5v-5.9L106.9,19.5L106.9,19.5z M128.1,6.9c0-1.3,1.3-2,3.5-2\n\tc2.4,0,4.9,0.5,6.7,1.2l-0.6-5.4c-2-0.4-3.7-0.7-6.9-0.7c-6.1,0-10.2,2.4-10.2,7.5c0,8.7,11.7,7,11.7,11c0,1.6-1.1,2.4-3.9,2.4\n\tc-2.5,0-6.3-0.8-8.5-2l0.8,5.7c2.3,0.8,5.4,1.2,7.8,1.2c6.3,0,11.4-2.1,11.4-8.3C140,9.3,128.1,10.9,128.1,6.9z M91.1,0.6h-7.5v24.8\n\th7.5V0.6z M60.6,0.6h-7.5v24.8h7.5V0.6z M73.7,20.4V0.6h-7.5v24.8h13.6l1.1-5L73.7,20.4L73.7,20.4z M47.5,0.6H40v9.9h-7.8V0.6h-7.5\n\tv24.8h7.5v-9.8H40v9.8h7.5V0.6z","key":1})]);
	}
	
	Philips.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"170px","height":"26px","viewBox":"0 0 170 26","style":{"enableBackground":"new 0 0 170 26"},"xmlSpace":"preserve"};
	
	module.exports = Philips;
	
	Philips.default = Philips;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function PinnacleLogo (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M33.84,38.27v-2.21h-4.42v2.21h-1.1v-5.46h1.1v2.22h4.42v-2.22h1.1v5.46H33.84z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M37.46,38.27v-5.46h6.15v1.02h-5.08v1.24h4.96v0.96h-4.96v1.22h5.14v1.02H37.46z","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M51.97,38.27l-0.58-0.91h-4.2l-0.55,0.91H45.4l3.38-5.46h1.1l3.42,5.46H51.97z M49.28,33.9l-1.53,2.55\n\t\t\tc0,0,3.12,0,3.11,0L49.28,33.9z","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M55.36,38.27v-5.46h1.1v4.44h4.56v1.02H55.36z","key":3}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M65.02,33.83v4.44H63.9v-4.44h-2.99v-1.02h7.1v1.02H65.02z","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M75.63,38.27v-2.21h-4.42v2.21h-1.1v-5.46h1.1v2.22h4.42v-2.22h1.1v5.46H75.63z","key":5}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M89.45,38.27l-0.58-0.91h-4.2l-0.55,0.91h-1.24l3.38-5.46h1.1l3.42,5.46H89.45z M86.75,33.9l-1.53,2.55\n\t\t\tc0,0,3.12,0,3.11,0L86.75,33.9z","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M98.47,38.27l-4.5-4.03v4.03h-1.1v-5.46h1.06l4.39,3.92v-3.92h1.1v5.46H98.47z","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M106.24,38.27h-3.77v-5.46h3.64c2.07,0,3.38,0.96,3.38,2.66c0,0.03,0,0.04,0,0.07c0,0.03,0,0.06,0,0.08\n\t\t\tC109.48,37.37,108.16,38.27,106.24,38.27z M108.33,35.51c0-0.02,0-0.05,0-0.07c0-0.94-0.73-1.64-2.35-1.64h-2.42v3.47h2.43\n\t\t\tc1.66,0,2.33-0.6,2.33-1.66C108.33,35.59,108.33,35.55,108.33,35.51z","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M117.13,33.83v1.23h4.59v0.98h-4.58v2.23h-1.1v-5.46h5.88v1.02H117.13z","key":9}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M124.48,38.27v-5.46h1.1v5.46H124.48z","key":10}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M131.86,33.83v4.44h-1.13v-4.44h-2.99v-1.02h7.1v1.02H131.86z","key":11}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M142.62,38.27l-4.5-4.03v4.03h-1.1v-5.46h1.06l4.39,3.92v-3.92h1.1v5.46H142.62z","key":12}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M146.65,38.27v-5.46h6.15v1.02h-5.08v1.24h4.96v0.96h-4.96v1.22h5.14v1.02H146.65z","key":13}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M158.78,38.35c-2.47,0-3.52-0.59-3.82-1.98h1.22c0.24,0.66,0.87,0.96,2.4,0.96c1.92,0,2.49-0.22,2.49-0.68\n\t\t\tc0-0.42-0.38-0.61-2.57-0.66c-2.59-0.07-3.26-0.7-3.26-1.61c0-0.96,0.91-1.66,3.31-1.66c2.26,0,3.2,0.8,3.46,1.91h-1.18\n\t\t\tc-0.22-0.53-0.69-0.91-2.36-0.91c-1.49,0-2.07,0.23-2.07,0.63c0,0.43,0.41,0.65,2.32,0.67c2.77,0.03,3.52,0.5,3.52,1.53\n\t\t\tC162.24,37.73,161.06,38.35,158.78,38.35z","key":14}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M168.18,38.35c-2.47,0-3.52-0.59-3.82-1.98h1.22c0.24,0.66,0.87,0.96,2.4,0.96c1.92,0,2.49-0.22,2.49-0.68\n\t\t\tc0-0.42-0.38-0.61-2.57-0.66c-2.59-0.07-3.26-0.7-3.26-1.61c0-0.96,0.91-1.66,3.31-1.66c2.26,0,3.2,0.8,3.46,1.91h-1.18\n\t\t\tc-0.22-0.53-0.69-0.91-2.36-0.91c-1.49,0-2.07,0.23-2.07,0.63c0,0.43,0.41,0.65,2.32,0.67c2.77,0.03,3.52,0.5,3.52,1.53\n\t\t\tC171.63,37.73,170.46,38.35,168.18,38.35z","key":15})]),React.createElement("g",{"key":1},[React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"72.16,0.71 63.85,17.65 52.27,0.71 49.44,0.71 37.53,24.97 43,24.97 51.32,8.02 62.91,24.97 \n\t\t\t65.73,24.97 77.62,0.71 \t\t","key":0}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"165.24,0.71 153.33,24.97 170.43,24.97 172.83,20.06 161.21,20.06 170.71,0.71 \t\t","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M33.67,2.65c-1.31-1.95-3.62-1.95-8.69-1.95H13.02L1.11,24.97h5.47l2.64-5.38h11.61c3.66,0,7.14,0,9.34-4.57\n\t\t\tl2.73-5.54l0.08-0.17C34.06,6.62,34.91,4.5,33.67,2.65z M28.45,7.4l-2.7,5.47l-0.01,0.02c-0.81,1.69-1.32,1.79-4.9,1.79h-9.22\n\t\t\tl4.45-9.07h8.9c1.54,0,3.12,0,4.13,0.07C28.91,6.26,28.63,6.95,28.45,7.4z","key":2}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"40.33,0.71 28.42,24.97 33.89,24.97 45.8,0.71 \t\t","key":3}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"103.44,0.71 95.16,17.65 83.58,0.71 80.76,0.71 68.85,24.97 74.32,24.97 82.64,8.02 94.22,24.97 \n\t\t\t97.05,24.97 108.9,0.71 \t\t","key":4}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M133.09,2.65c-1.31-1.95-3.62-1.95-8.69-1.95h-11.96l-11.91,24.27h5.47l2.64-5.38h11.61\n\t\t\tc0.55,0,1.09,0,1.63-0.02l-2.65,5.4h5.47l4.64-9.45c0.09-0.16,0.17-0.32,0.25-0.49l2.73-5.54l0.08-0.17\n\t\t\tC133.49,6.62,134.34,4.5,133.09,2.65z M126.78,9.64l-0.01-0.01l-1.82,3.71c-0.71,1.25-1.44,1.34-4.66,1.34h-9.22l4.45-9.07h13.25\n\t\t\tL126.78,9.64z","key":5}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"199.28,5.62 201.71,0.71 185.8,0.71 173.89,24.97 192.03,24.97 194.43,20.06 181.77,20.06 \n\t\t\t184.11,15.3 192.42,15.3 194.86,10.39 186.52,10.39 188.86,5.62 \t\t","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M137.71,15.4l3.38-6.89c1.29-2.63,2.93-2.89,6.64-2.89h8.81l2.4-4.91h-11.21c-3.5,0-8.28,0-11.05,5.64\n\t\t\tl-3.38,6.89c-1.18,2.41-2.55,5.93-0.82,8.71c1.27,2.03,3.72,3.02,7.49,3.02h9.49l2.4-4.91h-11.89\n\t\t\tC139.97,20.06,135.31,20.35,137.71,15.4z","key":7})])]));
	}
	
	PinnacleLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"164px","height":"38px","viewBox":"0 0 275.72 39","style":{"enableBackground":"new 0 0 275.72 39"},"xmlSpace":"preserve"};
	
	module.exports = PinnacleLogo;
	
	PinnacleLogo.default = PinnacleLogo;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function QuestDiagnosticsLogo (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"-12.9","y":"-15.8","style":{"fill":"none"},"width":"148.97","height":"70.71","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M32.18,9.74c2.09,2.09,2.05,5.14,1.83,6.77c-0.33,2.51-1.46,5.11-3.18,7.43l-7.97,0l3.99,3.98\n\t\tc-2.8,2.09-6,3.29-8.94,3.29c-1.52,0-3.67-0.34-5.27-1.93c-2.09-2.1-2.05-5.14-1.83-6.77c0.44-3.32,2.27-6.81,5.03-9.57\n\t\tc3.21-3.21,7.37-5.13,11.07-5.13C27.54,7.8,30.24,7.8,32.18,9.74z M34.84,27.95l2.79,2.79c2.31-3.13,3.68-7,3.68-11.19\n\t\tc0-2.91-0.66-5.67-1.84-8.13c-0.01-0.02-0.04-0.04-0.06-0.04c-0.04,0-0.08,0.02-0.09,0.07c0,0.01,0,0.02,0,0.04\n\t\tC40.57,16.56,38.98,22.78,34.84,27.95z M5.29,27.37c0.02,0.04,0.07,0.05,0.1,0.04c0.03-0.02,0.05-0.06,0.04-0.09\n\t\tc-1.31-5.76,0.97-12.9,6.42-18.36c4.45-4.45,10.02-6.78,15.05-6.78c1.14,0,2.25,0.12,3.31,0.37c0.04,0.01,0.09-0.02,0.09-0.07\n\t\tc0.01-0.04-0.02-0.07-0.05-0.08C27.88,1.3,25.24,0.7,22.46,0.7C12.04,0.7,3.6,9.14,3.6,19.55C3.6,22.34,4.2,24.99,5.29,27.37\n\t\t M22.46,38.41c4.19,0,8.07-1.37,11.2-3.68l-2.79-2.79c-4.03,3.22-8.69,4.9-12.95,4.9c-1.22,0-2.4-0.14-3.53-0.42\n\t\tc-0.01,0-0.02-0.01-0.03-0.01c-0.04,0-0.08,0.03-0.08,0.08c0,0.03,0.02,0.06,0.04,0.07C16.78,37.75,19.54,38.41,22.46,38.41z\n\t\t M74.61,9.46h2.47v10.78h-2.47v-1.67c-0.69,1.02-1.69,1.9-3.37,1.9c-2.43,0-3.84-1.63-3.84-4.14V9.46h2.47v6.12\n\t\tc0,1.67,0.84,2.63,2.31,2.63c1.43,0,2.43-1,2.43-2.67V9.46z M103.21,16.86v-5.29h3.52l-2.12-2.12h-1.4V6.5h-2.47v10.76\n\t\tc0,2.37,1.29,3.16,3.1,3.16c0.92,0,1.61-0.2,2.22-0.55v-2.02c-0.49,0.24-0.98,0.37-1.53,0.37\n\t\tC103.7,18.21,103.21,17.82,103.21,16.86z M63.74,17.48c0.92-1.25,1.45-2.78,1.45-4.41c0-4.04-3.06-7.37-7.45-7.37\n\t\tc-4.39,0-7.49,3.37-7.49,7.41c0,4.04,3.06,7.37,7.45,7.37c1.67,0,3.14-0.51,4.35-1.35l1.25,1.12h3.72L63.74,17.48z M61.82,15.8\n\t\th-3.6l1.97,1.67c-0.67,0.43-1.51,0.69-2.45,0.69c-2.84,0-4.86-2.31-4.86-5.1c0-2.8,1.98-5.06,4.82-5.06c2.84,0,4.86,2.31,4.86,5.1\n\t\tC62.55,14.11,62.31,15.05,61.82,15.8z M95.66,13.86c-1.27-0.41-2.43-0.74-2.43-1.51v-0.04c0-0.63,0.55-1.08,1.51-1.08\n\t\tc0.76,0,1.66,0.28,2.54,0.74l1.48-1.48c-1.14-0.75-2.61-1.22-3.96-1.22c-2.14,0-3.84,1.24-3.84,3.29v0.04\n\t\tc0,2.06,1.78,2.71,3.37,3.16c1.26,0.39,2.41,0.67,2.41,1.51v0.04c0,0.71-0.61,1.16-1.67,1.16c-1,0-2.13-0.37-3.19-1.09l-1.44,1.44\n\t\tl0,0c1.35,1.06,3.04,1.61,4.57,1.61c2.24,0,4-1.12,4-3.39v-0.04C99.01,15.07,97.23,14.35,95.66,13.86z M89.32,15.05\n\t\tc0-3.12-1.73-5.82-5.16-5.82c-3.08,0-5.26,2.53-5.26,5.63c0,3.35,2.41,5.61,5.53,5.61c1.93,0,3.32-0.76,4.33-1.93l-1.37-1.37l0,0\n\t\tc-0.86,0.84-1.71,1.29-2.92,1.29c-1.59,0-2.82-0.98-3.1-2.74h7.92C89.3,15.48,89.32,15.27,89.32,15.05z M84.14,11.25\n\t\tc1.59,0,2.52,1.18,2.72,2.7h-5.49C81.63,12.35,82.67,11.25,84.14,11.25z M61.61,26.31h0.61v6.38h-0.61V26.31z M61.54,23.94v0.76\n\t\th0.76v-0.76H61.54z M59.63,28.31v-0.03c0-2.46-1.9-4.35-4.65-4.35h-2.91v8.75h2.91C57.74,32.68,59.63,30.77,59.63,28.31z\n\t\t M58.96,28.33c0,2.09-1.54,3.75-3.97,3.75h-2.26v-7.55h2.26c2.44,0,3.97,1.7,3.97,3.77V28.33z M69.49,32.68v-3.97\n\t\tc0-1.65-1.03-2.5-2.66-2.5c-0.88,0-1.56,0.23-2.26,0.55l0.23,0.54c0.59-0.3,1.22-0.51,2-0.51c1.31,0,2.1,0.66,2.1,1.95v0.28\n\t\tc-0.61-0.16-1.23-0.28-2.11-0.28c-1.65,0-2.79,0.75-2.79,2.07v0.03c0,1.32,1.28,2,2.46,2c1.21,0,2-0.6,2.44-1.21v1.06H69.49z\n\t\t M68.9,30.3c0,1.16-1.11,1.96-2.41,1.96c-0.98,0-1.85-0.54-1.85-1.46v-0.03c0-0.89,0.75-1.49,2.1-1.49c0.91,0,1.63,0.15,2.16,0.29\n\t\tV30.3z M77.65,26.31v5.39c0,1.94-1.31,3.01-3.12,3.01c-1.06,0-2.05-0.32-2.92-0.97l0.44-0.44c0.74,0.55,1.59,0.84,2.49,0.84\n\t\tc1.46,0,2.5-0.84,2.5-2.48v-0.92c-0.55,0.79-1.4,1.47-2.66,1.47c-1.54,0-3.06-1.18-3.06-3v-0.02c0-1.84,1.53-3.03,3.06-3.03\n\t\tc1.28,0,2.14,0.68,2.66,1.43v-1.28H77.65z M77.08,29.17c0-1.47-1.31-2.42-2.64-2.42c-1.34,0-2.46,0.92-2.46,2.41v0.02\n\t\tc0,1.44,1.15,2.44,2.46,2.44c1.32,0,2.64-0.97,2.64-2.42V29.17z M85.34,32.68v-3.9c0-1.52-0.94-2.62-2.55-2.62\n\t\tc-1.16,0-1.87,0.59-2.3,1.34v-1.19h-0.61v6.38h0.61V29c0-1.32,0.96-2.28,2.21-2.28c1.29,0,2.02,0.86,2.02,2.18v3.79H85.34z\n\t\t M93.31,29.5v-0.02c0-1.79-1.38-3.31-3.26-3.31c-1.9,0-3.29,1.55-3.29,3.34v0.03c0,1.79,1.38,3.31,3.26,3.31\n\t\tC91.92,32.83,93.31,31.28,93.31,29.5z M92.65,29.52c0,1.5-1.09,2.74-2.6,2.74c-1.48,0-2.62-1.23-2.62-2.76v-0.02\n\t\tc0-1.5,1.09-2.74,2.6-2.74c1.47,0,2.62,1.23,2.62,2.76V29.52z M97.01,29.13c-0.91-0.26-1.78-0.53-1.78-1.24v-0.02\n\t\tc0-0.64,0.58-1.11,1.45-1.11c0.63,0,1.28,0.22,1.85,0.56l0.44-0.44c-0.64-0.42-1.5-0.7-2.26-0.7c-1.24,0-2.1,0.74-2.1,1.76v0.03\n\t\tc0,1.14,1.15,1.45,2.19,1.75c0.89,0.25,1.69,0.52,1.69,1.27v0.03c0,0.74-0.68,1.21-1.54,1.21c-0.78,0-1.53-0.28-2.21-0.78\n\t\tl-0.44,0.44c0.68,0.55,1.69,0.92,2.61,0.92c1.22,0,2.2-0.72,2.2-1.86v-0.03C99.11,29.8,98.03,29.42,97.01,29.13z M101.35,30.99\n\t\tv-4.11h2.23l-0.56-0.56h-1.66v-2.04h-0.61v6.77c0,1.21,0.8,1.75,1.79,1.75c0.4,0,0.71-0.07,1.04-0.22V32\n\t\tc-0.36,0.16-0.62,0.23-0.94,0.23C101.89,32.22,101.35,31.9,101.35,30.99z M105.44,32.68h0.61v-6.38h-0.61V32.68z M105.36,23.94\n\t\tv0.76h0.76v-0.76H105.36z M111.06,32.26c-1.46,0-2.63-1.23-2.63-2.76v-0.02c0-1.52,1.12-2.74,2.58-2.74c0.95,0,1.57,0.48,2.12,1.04\n\t\tl0.44-0.44c-0.6-0.62-1.35-1.18-2.55-1.18c-1.83,0-3.25,1.55-3.25,3.34v0.03c0,1.79,1.41,3.31,3.25,3.31\n\t\tc1.16,0,1.93-0.51,2.57-1.24l-0.4-0.4C112.66,31.8,111.96,32.26,111.06,32.26z M117.47,29.13c-0.91-0.26-1.77-0.53-1.77-1.24v-0.02\n\t\tc0-0.64,0.57-1.11,1.45-1.11c0.63,0,1.28,0.22,1.84,0.56l0.44-0.44c-0.64-0.42-1.5-0.7-2.26-0.7c-1.24,0-2.1,0.74-2.1,1.76v0.03\n\t\tc0,1.14,1.15,1.45,2.19,1.75c0.89,0.25,1.69,0.52,1.69,1.27v0.03c0,0.74-0.68,1.21-1.54,1.21c-0.78,0-1.53-0.28-2.21-0.78\n\t\tl-0.43,0.44c0.67,0.55,1.69,0.92,2.61,0.92c1.23,0,2.2-0.72,2.2-1.86v-0.03C119.57,29.8,118.5,29.42,117.47,29.13z M120.36,25.93\n\t\th-0.33v-1.39h-0.48v-0.28h1.29v0.28h-0.48V25.93z M122.37,24.27l-0.45,1.14l-0.46-1.14h-0.41v1.66h0.3v-1.11l0.45,1.11h0.23\n\t\tl0.44-1.11v1.11h0.32v-1.66H122.37z","key":1})]));
	}
	
	QuestDiagnosticsLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"164px","height":"38px","viewBox":"0 0 173.54 39","style":{"enableBackground":"new 0 0 173.54 39"},"xmlSpace":"preserve"};
	
	module.exports = QuestDiagnosticsLogo;
	
	QuestDiagnosticsLogo.default = QuestDiagnosticsLogo;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function RicohLogo (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ricoh"),React.createElement("path",{"d":"M63.81,19c0,5.77,4.27,10,11.4,10A20.07,20.07,0,0,0,84,27.18l2.67,3.65A25,25,0,0,1,74,33.8C62.57,33.8,54.2,28.31,54.2,19h0C54.2,9.69,62.58,4.2,74,4.2A28,28,0,0,1,86.4,6.65l-2.74,4.19A16.68,16.68,0,0,0,75.2,9c-7.12,0-11.39,4.26-11.39,10","transform":"translate(0 -4.2)","style":{"fill":"#fff"},"key":1}),React.createElement("path",{"d":"M107.25,4.2c-11,0-19,5.49-19,14.8s8,14.8,19,14.8,19-5.49,19-14.8S118.28,4.2,107.25,4.2Zm0,25c-6.07,0-9.42-4.55-9.42-10.19s3.35-10.19,9.42-10.19,9.42,4.55,9.42,10.19S113.32,29.19,107.25,29.19Z","transform":"translate(0 -4.2)","style":{"fill":"#fff"},"key":2}),React.createElement("polygon",{"points":"154.89 16.94 154.89 28.85 164 28.85 164 0.74 154.89 0.74 154.89 11.46 140.96 11.46 140.96 0.74 131.88 0.74 131.88 28.85 140.96 28.85 140.96 16.94 154.89 16.94","style":{"fill":"#fff"},"key":3}),React.createElement("rect",{"x":"39.12","y":"0.74","width":"9.59","height":"28.1","style":{"fill":"#fff"},"key":4}),React.createElement("path",{"d":"M11.6,17.81V20.5A71.31,71.31,0,0,1,24.09,33.05H34.82A68.4,68.4,0,0,0,21.13,20.83c5-.21,10.49-2.22,10.49-7.9,0-7.31-7.8-8.64-15.69-8.64-6.45,0-12.39.29-15.93.58V33H9V9.1a56.35,56.35,0,0,1,7-.37c4.61,0,7,1.52,7,4.19C22.91,15.19,22,17.91,11.6,17.81Z","transform":"translate(0 -4.2)","style":{"fill":"#fff"},"key":5})]);
	}
	
	RicohLogo.defaultProps = {"id":"e1d3e6b8-bb7d-4572-8f34-c5d2c5f49bb2","data-name":"Layer 1","width":"164px","height":"38px","viewBox":"0 0 163.8 37.5"};
	
	module.exports = RicohLogo;
	
	RicohLogo.default = RicohLogo;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function SignifyLogo (props) {
	    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".acc4ae33-a569-44e7-ae8e-e7adba41c9b8{fill:#fff;}")),React.createElement("title",{"key":1},"signify-logo"),React.createElement("path",{"className":"acc4ae33-a569-44e7-ae8e-e7adba41c9b8","d":"M41.23,27.41V25a.35.35,0,0,1,.38-.38h5V12.13H42.55a.34.34,0,0,1-.39-.37V9.32q0-.36.39-.36h6.83a.34.34,0,0,1,.38.36V24.61h5.59a.35.35,0,0,1,.38.38v2.42a.34.34,0,0,1-.38.37H41.61a.34.34,0,0,1-.38-.37M51,3.25a2.58,2.58,0,1,0-2.58,2.58A2.58,2.58,0,0,0,51,3.25M85.56,27.56V16.46a4.63,4.63,0,0,1,9.26,0v11.1h0a.35.35,0,0,0,.39.37h2.42a.32.32,0,0,0,.37-.37V16.4h0a7.73,7.73,0,0,0-2.09-5.32A8,8,0,0,0,90.25,8.8a5.47,5.47,0,0,0-4.69,2.34V9.48a.32.32,0,0,0-.37-.37H82.78c-.26,0-.38.12-.38.37V27.56c0,.25.12.37.38.37h2.41a.32.32,0,0,0,.37-.37M132.77,2.2a.77.77,0,0,0-.38-.77,7.35,7.35,0,0,0-4.08-1c-3.87,0-5.6,3.21-5.6,6.18V9h-3.87a.47.47,0,0,0-.53.53v2a.47.47,0,0,0,.53.53h3.87V27.24a.48.48,0,0,0,.53.54h2.1a.48.48,0,0,0,.53-.54V12h6a.47.47,0,0,0,.53-.53v-2a.47.47,0,0,0-.53-.53h-6V6.56c0-2,1-3.13,2.66-3.13A5.75,5.75,0,0,1,132,4.57a.51.51,0,0,0,.34.11c.26,0,.43-.22.43-.54V2.2M102.56,27.41c0,.24.13.37.39.37h13.73c.26,0,.39-.13.39-.37V25c0-.25-.14-.38-.39-.38H111.1V9.32a.34.34,0,0,0-.38-.36h-6.84c-.25,0-.38.12-.38.36v2.44a.34.34,0,0,0,.38.37h4.05V24.61h-5c-.26,0-.39.14-.39.38v2.42m9.75-24.16a2.58,2.58,0,1,0-2.58,2.58,2.59,2.59,0,0,0,2.58-2.58m-38,22.4V28c0,3.61-1.89,5.59-5.32,5.59-2.59,0-4.17-1-4.71-3.14-.07-.25-.14-.49-.52-.49H61.58a.48.48,0,0,0-.53.55c.35,3.67,3.52,6.13,7.89,6.13,5.09,0,8.51-3.4,8.51-8.46V9.35c0-.25-.13-.37-.39-.37H74.65a.38.38,0,0,0-.37.37v1.57A9,9,0,0,0,70,8.64a.27.27,0,0,0-.34.27v2.85a.27.27,0,0,0,.2.26,6.53,6.53,0,0,1,4.57,6.36,6.15,6.15,0,1,1-12.27,0,6.53,6.53,0,0,1,4.41-6.31.28.28,0,0,0,.2-.27V8.89a.28.28,0,0,0-.33-.27,9.7,9.7,0,0,0-7.49,9.67c0,5.44,4.13,9.84,9.24,9.84a8.87,8.87,0,0,0,6.12-2.47M18.8,28.13c4.3,0,7.3-2.43,7.3-5.91,0-3.81-3.36-4.69-6.51-5.22-3.95-.65-4.49-1.79-4.49-2.93,0-1.75,1.85-2.38,3.44-2.38,2.16,0,3.46.83,3.85,2.46.07.25.14.48.51.48H25a.48.48,0,0,0,.52-.52c0-3.25-2.81-5.44-7-5.44-4.51,0-6.57,2.8-6.57,5.4,0,3.25,1.7,4.86,5.85,5.58l.11,0c2.85.5,4.9.87,4.9,2.91,0,1.74-2,2.53-3.88,2.53-2.32,0-3.76-1.11-4-3.14,0-.24-.13-.49-.52-.49H12a.48.48,0,0,0-.52.52c0,3.61,3,6.13,7.31,6.13m2-28.08h0a.6.6,0,0,0-.46.12.49.49,0,0,0-.12.34V2.93h0a.25.25,0,0,0,.22.26,15.6,15.6,0,1,1-3.32,0,.25.25,0,0,0,.21-.26h0V.51a.45.45,0,0,0-.12-.34.58.58,0,0,0-.45-.12h0a18.76,18.76,0,1,0,4.13,0m121.9,29.34a15.21,15.21,0,0,1-1.2,2.62,2.67,2.67,0,0,1-1.18,1,2,2,0,0,1-.92.22,1.58,1.58,0,0,1-.38,0,8.48,8.48,0,0,1-1.41-.42,2.25,2.25,0,0,0-.74-.23.43.43,0,0,0-.44.48v2.07h0a.74.74,0,0,0,.45.72,6,6,0,0,0,2.78.6,5.24,5.24,0,0,0,2.52-.83,6.64,6.64,0,0,0,2.05-2,9.15,9.15,0,0,0,.72-1.29c.45-1,7.26-18.92,8.67-22.75h0a.77.77,0,0,0,.05-.3.4.4,0,0,0-.45-.41H151a.54.54,0,0,0-.6.39h0L145,23.34l-5.52-14c-.13-.34-.28-.47-.62-.47h-2.3a.41.41,0,0,0-.44.44.72.72,0,0,0,.05.27h0l7.14,18.18-.62,1.62","transform":"translate(0 -0.05)","key":2})]);
	}
	
	SignifyLogo.defaultProps = {"id":"a0a0604f-e46e-410c-95a5-655a7ab041b4","data-name":"Layer 1","width":"164px","height":"38px","viewBox":"0 0 163.8 37.5"};
	
	module.exports = SignifyLogo;
	
	SignifyLogo.default = SignifyLogo;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function SteveMaddenLogo (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M3.9,16.3v2.2c0,1.2,0.1,1.6,0.2,1.9c0.4,0.8,1.1,0.9,1.7,0.9c0.4,0,1.1,0,1.5-0.5c0.3-0.4,0.4-1.2,0.4-1.6\n\t\tv-1.6c0-1-0.3-1.9-1.2-2.7l-4-3.7c-0.6-0.6-1.2-1.1-1.6-1.9c-0.6-1-0.8-2-0.8-3.1V4.3c0-1.1,0.5-2.3,1.3-3C2.8,0.1,5,0,5.9,0\n\t\tc1.4,0,3,0.2,4.3,1.4c1.3,1.2,1.4,2.7,1.4,3.7v2.4H7.6v-2c0-0.5,0-1.1-0.4-1.6C6.8,3.5,6.4,3.4,5.9,3.4c-0.5,0-1.1,0.1-1.4,0.5\n\t\tC4,4.2,4,4.7,4,5.1v1.1c0,0.9,0.2,1.3,1,2l4,3.7c1.3,1.2,2.7,2.5,2.7,5.1v2.7c0,1.1-0.1,2.5-1.4,3.7c-1.3,1.2-2.8,1.4-4.2,1.4\n\t\tc-1.3,0-2.7-0.2-4-1.1c-1.8-1.2-2.1-3-2.1-4.2v-3H3.9z","key":0}),React.createElement("rect",{"x":"0","style":{"fill":"none"},"width":"162","height":"24.6","key":1}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"17.2,24.3 17.2,3.7 13,3.7 13,0.3 25.3,0.3 25.3,3.7 21.1,3.7 21.1,24.3 \t","key":2}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"27.3,0.3 37.3,0.3 37.3,3.7 31.2,3.7 31.2,9.4 35.9,9.4 35.9,12.8 31.2,12.8 31.2,20.9 37.8,20.9 \n\t\t37.8,24.3 27.3,24.3 \t","key":3}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"42.9,24.3 39,0.3 43.1,0.3 45.2,16.9 47.4,0.3 51.5,0.3 47.6,24.3 \t","key":4}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"53.5,0.3 63.5,0.3 63.5,3.7 57.4,3.7 57.4,9.4 62.1,9.4 62.1,12.8 57.4,12.8 57.4,20.9 64,20.9 \n\t\t64,24.3 53.5,24.3 \t","key":5}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"80.9,24.3 78.1,6.3 77.9,6.3 78.1,9.4 78.1,24.3 74.2,24.3 74.2,0.3 80.4,0.3 82.7,15.8 82.8,15.8 \n\t\t85.1,0.3 91.3,0.3 91.3,24.3 87.4,24.3 87.4,9.4 87.6,6.3 87.4,6.3 84.6,24.3 \t","key":6}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M102.9,24.3l-0.7-4.4H98l-0.7,4.4h-4l4.4-24h4.8l4.4,24H102.9z M101.7,16.5L100.1,7h-0.1l-1.6,9.5H101.7z","key":7}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M108.9,0.3h7.4c0.8,0,2.1,0.1,3.3,1.2c1.3,1.3,1.3,2.8,1.3,4.2v12.8c0,1.4-0.1,3.3-1.6,4.6\n\t\tc-1.1,1-2.4,1.1-3.4,1.1h-7V0.3z M114.7,21c1,0,1.6-0.4,1.8-0.8c0.3-0.5,0.4-1.6,0.4-2.2V6.4c0-0.6,0-1.4-0.4-2\n\t\tc-0.4-0.6-1-0.7-1.6-0.7h-2.1V21H114.7z","key":8}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M123.1,0.3h7.4c0.8,0,2.1,0.1,3.3,1.2c1.3,1.3,1.3,2.8,1.3,4.2v12.8c0,1.4-0.1,3.3-1.6,4.6\n\t\tc-1.1,1-2.4,1.1-3.4,1.1h-7V0.3z M128.9,21c1,0,1.6-0.4,1.8-0.8c0.3-0.5,0.4-1.6,0.4-2.2V6.4c0-0.6,0-1.4-0.4-2\n\t\tc-0.4-0.6-1-0.7-1.6-0.7H127V21H128.9z","key":9}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"137.3,0.3 147.3,0.3 147.3,3.7 141.2,3.7 141.2,9.4 146,9.4 146,12.8 141.2,12.8 141.2,20.9 \n\t\t147.8,20.9 147.8,24.3 137.3,24.3 \t","key":10}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"157.8,24.3 153.8,10.2 153.6,10.2 153.8,12.9 153.8,24.3 149.9,24.3 149.9,0.3 154.2,0.3 158.2,13.9 \n\t\t158.3,13.9 158.1,11.3 158.1,0.3 162,0.3 162,24.3 \t","key":11})]));
	}
	
	SteveMaddenLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"170px","height":"26px","viewBox":"0 0 162 24.6","style":{"enableBackground":"new 0 0 162 24.6"},"xmlSpace":"preserve"};
	
	module.exports = SteveMaddenLogo;
	
	SteveMaddenLogo.default = SteveMaddenLogo;


/***/ }),
/* 938 */,
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function WeichertLogo (props) {
	    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFFFFF","d":"M58,10.8C57.9,10.8,57.9,10.8,58,10.8H54h0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0l0,0c0-0.1,0.1-0.3,0.1-0.4\n\tc0.1-0.2,0.2-0.5,0.3-0.7c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.2,0.6-0.2,1.1-0.2c0.7,0,1.1,0.2,1.5,0.5c0.3,0.3,0.5,0.7,0.6,1.3\n\tc0,0,0,0,0,0.1C58.1,10.7,58,10.8,58,10.8 M60.7,10.3c-0.2-0.7-0.5-1.3-0.9-1.8c-0.4-0.5-0.9-1-1.5-1.3c-0.6-0.3-1.3-0.5-2.2-0.5\n\tc-0.7,0-1.4,0.1-2,0.4c-0.6,0.3-1.1,0.6-1.6,1.1c-0.4,0.4-0.8,1-1,1.6c-0.3,0.6-0.3,1.3-0.3,2c0,0.8,0.1,1.4,0.3,2.1\n\tc0.2,0.6,0.6,1.2,1,1.6c0.4,0.4,1,0.8,1.6,1s1.3,0.4,2.1,0.4c1.1,0,2-0.3,2.8-0.8c0.7-0.4,1.2-1.2,1.6-2.1c0,0,0,0,0-0.1\n\tc0,0,0,0,0-0.1c0-0.1-0.1-0.2-0.2-0.3h0h-1.8h0c-0.1,0-0.2,0-0.2,0.1c0,0,0,0,0,0.1c-0.1,0.3-0.3,0.5-0.6,0.7\n\tc-0.4,0.3-0.9,0.4-1.4,0.4c-0.8,0-1.3-0.2-1.7-0.6c-0.3-0.3-0.6-0.9-0.6-1.7c0,0,0,0,0-0.1c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h6.6h0\n\tc0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1C60.9,11.5,60.8,10.9,60.7,10.3","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M17.4,3.2C17.4,3.2,17.3,3.2,17.4,3.2C17.3,3.2,17.3,3.2,17.4,3.2H15c0,0,0,0,0,0c0,0,0,0,0,0\n\tc-0.1,0-0.2,0.1-0.2,0.2v0.1l-2,8.4v0l0,0l0,0c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.1l0,0l0,0l0,0l-2.1-8.5v0\n\tc0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0c0,0,0,0,0,0H7.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.2,0.2l0,0.1l-2.1,8.3l0,0\n\tc0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2l0,0L3,3.4V3.3c0-0.1-0.1-0.1-0.2-0.2h0h0H0.4c0,0,0,0,0,0c0,0,0,0,0,0\n\tc-0.1,0-0.2,0.1-0.2,0.3v0v0l3.4,12.9l0,0.1c0,0.1,0.1,0.2,0.2,0.2l0,0l0,0h2.6l0,0l0,0c0.1,0,0.2-0.1,0.2-0.2v0l2-8.3l0,0\n\tC8.6,8.1,8.7,8,8.8,8S9,8.1,9,8.2l0,0l2.1,8.3l0,0.1c0,0.1,0.1,0.2,0.2,0.2l0,0l0,0h2.5h0h0c0.1,0,0.2-0.1,0.2-0.2l0-0.1l3.5-12.9v0\n\tv0C17.6,3.3,17.5,3.2,17.4,3.2","key":1}),React.createElement("path",{"fill":"#FFFFFF","d":"M28.7,6.1c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3S29.4,6.1,28.7,6.1","key":2}),React.createElement("path",{"fill":"#FFFFFF","d":"M28.7,3.4c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3S29.4,3.4,28.7,3.4 M28.7,3.5\n\tc0.7,0,1.3,0.6,1.3,1.3S29.4,6,28.7,6s-1.3-0.6-1.3-1.3C27.3,4,28,3.5,28.7,3.5","key":3}),React.createElement("path",{"fill":"#FFFFFF","d":"M30,7.2c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0c0,0,0,0,0,0h-2.2c0,0,0,0,0,0c0,0,0,0,0,0\n\tc-0.1,0-0.2,0.1-0.2,0.3l0,0l0,0v9.2v0.1c0,0.1,0.1,0.2,0.2,0.2h0.1h2.2l0,0c0.1,0,0.2-0.1,0.2-0.2v0L30,7.2C30,7.2,30,7.2,30,7.2\n\tL30,7.2","key":4}),React.createElement("path",{"fill":"#FFFFFF","d":"M40.3,12.9L40.3,12.9L40.3,12.9h-2.1l0,0l0,0c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0.1,0,0.1\n\tc-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.3-0.8,0.5-1.5,0.5c-0.4,0-0.8-0.1-1-0.3s-0.5-0.4-0.7-0.7c-0.2-0.3-0.3-0.6-0.4-1\n\tc-0.1-0.3-0.1-0.7-0.1-1.1s0-0.7,0.1-1.1c0.1-0.4,0.2-0.7,0.4-1s0.4-0.6,0.7-0.8c0.3-0.2,0.6-0.3,1.1-0.3c1.1,0,1.7,0.5,1.9,1.5v0\n\tc0,0.1,0.1,0.2,0.2,0.2l0,0l0,0h2.1l0,0l0,0c0.1,0,0.2-0.1,0.3-0.2c0,0,0-0.1,0-0.1c-0.1-0.5-0.2-0.9-0.4-1.3\n\tc-0.3-0.4-0.6-0.8-1-1.1c-0.4-0.3-0.9-0.5-1.4-0.7s-1.1-0.2-1.7-0.2c-0.8,0-1.5,0.1-2.1,0.4c-0.6,0.3-1.1,0.6-1.6,1.1\n\tc-0.4,0.5-0.8,1-1,1.7c-0.2,0.6-0.3,1.3-0.3,2.1c0,0.7,0.1,1.4,0.3,2s0.6,1.1,1,1.6c0.4,0.4,1,0.8,1.6,1c0.6,0.3,1.3,0.4,2,0.4\n\tc1.3,0,2.4-0.3,3.2-1c0.8-0.6,1.2-1.5,1.5-2.6v0v0C40.5,13,40.4,12.9,40.3,12.9","key":5}),React.createElement("path",{"fill":"#FFFFFF","d":"M23.5,10.8C23.5,10.8,23.4,10.8,23.5,10.8h-3.9h0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0l0,0\n\tc0-0.1,0.1-0.3,0.1-0.4c0.1-0.2,0.2-0.5,0.3-0.7c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.2,0.6-0.2,1.1-0.2c0.7,0,1.1,0.2,1.5,0.5\n\tc0.3,0.3,0.5,0.7,0.6,1.3c0,0,0,0,0,0.1C23.7,10.7,23.6,10.8,23.5,10.8 M26.2,10.3C26,9.6,25.7,9,25.3,8.4c-0.4-0.5-0.9-1-1.5-1.3\n\tc-0.6-0.3-1.3-0.5-2.2-0.5c-0.7,0-1.4,0.1-2,0.4C19,7.3,18.4,7.7,18,8.1c-0.4,0.4-0.8,1-1,1.6c-0.3,0.6-0.3,1.3-0.3,2\n\tc0,0.8,0.1,1.4,0.3,2.1s0.6,1.2,1,1.6c0.4,0.4,1,0.8,1.6,1c0.6,0.3,1.3,0.4,2.1,0.4c1.1,0,2-0.3,2.8-0.8c0.7-0.4,1.2-1.2,1.6-2.1\n\tc0,0,0,0,0-0.1c0,0,0,0,0-0.1c0-0.1-0.1-0.2-0.2-0.3h0H24h0c-0.1,0-0.2,0-0.2,0.1c0,0,0,0,0,0.1c-0.1,0.3-0.3,0.5-0.6,0.7\n\tc-0.4,0.3-0.9,0.4-1.4,0.4c-0.8,0-1.3-0.2-1.7-0.6c-0.3-0.3-0.6-0.9-0.6-1.7c0,0,0,0,0-0.1c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h6.5h0\n\tc0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1C26.4,11.5,26.3,10.9,26.2,10.3","key":6}),React.createElement("path",{"fill":"#FFFFFF","d":"M50.3,16.3L50.3,16.3L50.3,16.3 M50,16.6L50,16.6L50,16.6 M50,16.6C50,16.6,50,16.7,50,16.6\n\tC50,16.7,50,16.6,50,16.6 M48.1,16.6L48.1,16.6L48.1,16.6 M48.1,16.6C48.1,16.6,48.1,16.7,48.1,16.6C48.1,16.7,48.1,16.6,48.1,16.6\n\t M47.8,16.3C47.7,16.3,47.7,16.3,47.8,16.3C47.7,16.3,47.7,16.3,47.8,16.3 M47.8,16.3L47.8,16.3L47.8,16.3 M47.7,16.3\n\tC47.7,16.3,47.7,16.4,47.7,16.3C47.7,16.4,47.7,16.3,47.7,16.3 M50.4,10.7c0-0.6-0.1-1.1-0.2-1.7c-0.1-0.5-0.3-0.9-0.6-1.3\n\tc-0.3-0.3-0.6-0.6-1.1-0.8c-0.4-0.2-1-0.3-1.7-0.3c-0.5,0-1,0.1-1.6,0.4c-0.4,0.2-0.7,0.5-1,0.8l0,0c0,0-0.1,0.1-0.2,0.1\n\tc-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0V3.5l0,0l0,0c0-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0c0,0,0,0,0,0h-2.1c0,0,0,0,0,0c0,0,0,0,0,0\n\tc-0.1,0-0.2,0.1-0.2,0.2l0,0l0,0v12.9l0,0c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.2l0,0l0,0h2.2l0,0l0,0c0.1,0,0.2-0.1,0.2-0.3l0,0l0,0\n\tv-4.8c0-1,0.2-1.7,0.5-2.1c0.3-0.4,0.9-0.6,1.6-0.6c0.6,0,1.1,0.2,1.3,0.6c0.3,0.4,0.4,1,0.4,1.8v5.2v0v0c0,0.1,0.1,0.3,0.3,0.3\n\tc0,0,0.1,0,0.1,0c0,0-0.1,0-0.1,0H50c0,0-0.1,0-0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.3-0.3c0-0.1,0-0.1,0-0.1c0,0,0,0.1,0,0.1\n\tv-5.8H50.4z","key":7}),React.createElement("path",{"fill":"#FFFFFF","d":"M74.6,14.9L74.6,14.9c0-0.2-0.1-0.3-0.3-0.3l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0\n\tc-0.4,0-0.8-0.1-0.9-0.2c-0.2-0.2-0.2-0.4-0.2-0.9V9l0,0v0c0-0.1,0.1-0.2,0.2-0.2h0l0,0h1.5h0.1c0.1,0,0.2-0.1,0.2-0.3V7.2v0v0\n\tc0-0.1-0.1-0.2-0.2-0.2l0,0l0,0h-1.6l0,0c-0.1,0-0.2-0.1-0.2-0.2l0,0V4.2c0,0,0,0,0,0c0,0,0,0,0,0C72.6,4,72.5,4,72.4,4l0,0l0,0\n\th-2.2l0,0l0,0C70.1,4,70,4,70,4.2c0,0,0,0,0,0l0,0v2.5l0,0l0,0c0,0.1-0.1,0.2-0.2,0.2l0,0h-1.2l0,0l0,0c-0.1,0-0.2,0.1-0.2,0.2\n\tc0,0,0,0,0,0l0,0v1.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0.1,0.2,0.3,0.2l0,0l0,0h1.2l0,0C69.9,8.8,70,8.9,70,9v5.5\n\tc0,0.5,0.1,0.9,0.3,1.2c0.2,0.3,0.4,0.5,0.7,0.7c0.3,0.2,0.6,0.3,1,0.3c0.4,0.1,0.8,0.1,1.2,0.1c0.3,0,0.5,0,0.8,0\n\tc0.2,0,0.3,0,0.5,0l0,0c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.2-0.2l0,0l0,0L74.6,14.9C74.6,14.9,74.6,14.9,74.6,14.9","key":8}),React.createElement("path",{"fill":"#FFFFFF","d":"M67.7,7.2C67.7,7.2,67.7,7.2,67.7,7.2c0-0.2-0.1-0.3-0.3-0.3l0,0l0,0c-1.7,0-2.2,0.4-2.7,0.9\n\tc-0.1,0.1-0.1,0.2-0.2,0.3c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.2-0.2l0,0l0,0V7.2l0,0l0,0c0-0.1-0.1-0.3-0.3-0.3h-2\n\tc0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0c0,0,0,0,0,0v9.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0.1,0.2,0.3,0.2l0,0\n\tl0,0H64c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.3l0,0l0,0v-4.1c0-0.4,0-0.9,0.1-1.2c0.1-0.4,0.2-0.7,0.4-1\n\tc0.2-0.3,0.5-0.5,0.8-0.7c0.5-0.3,1-0.3,1.7-0.3l0,0l0,0c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0c0,0,0,0,0,0L67.7,7.2L67.7,7.2","key":9}),React.createElement("path",{"fill":"#FFFFFF","d":"M75.8,7.5C75.8,7.5,75.8,7.5,75.8,7.5c0.1,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0\n\tc0,0,0,0-0.1,0c0,0,0,0-0.1,0h-0.2v0.3L75.8,7.5C75.7,7.5,75.7,7.5,75.8,7.5 M75.5,7.9V7.2h0.3c0.1,0,0.2,0,0.2,0.1\n\tc0,0,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0L76.1,8H76l-0.2-0.3h-0.2V8L75.5,7.9L75.5,7.9z\n\t M75.5,7c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2s0.1,0.1,0.1,0.2\n\tc0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0S76,8.1,76.1,8c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2\n\tc0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2C76,7.1,76,7.1,75.9,7c-0.1,0-0.1,0-0.2,0C75.6,7,75.5,7,75.5,7 M75.9,6.9\n\tC76,7,76.1,7,76.2,7.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.2\n\tc-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2\n\tc0-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2C75.3,7,75.3,7,75.4,6.9c0.1,0,0.2-0.1,0.3-0.1\n\tC75.8,6.9,75.9,6.9,75.9,6.9","key":10}),React.createElement("polygon",{"fill":"#FFFFFF","points":"86.5,16.7 87.4,16.7 87.4,11.8 92.3,11.8 92.3,11 87.4,11 87.4,7.3 92.9,7.3 92.9,6.5 86.5,6.5 ","key":11}),React.createElement("path",{"fill":"#FFFFFF","d":"M93.8,16.7h0.9v-3.9c0-1.5,1.1-2.7,2.7-2.6V9.2c-1.3-0.1-2.3,0.6-2.8,1.8h0V9.3h-0.8V16.7z","key":12}),React.createElement("path",{"fill":"#FFFFFF","d":"M99,11.6c0-1.2,0.9-1.7,2-1.7c1,0,1.9,0.3,1.9,1.5c0,0.8-0.4,0.9-1.1,1c-1.9,0.2-3.9,0.3-3.9,2.4\n\tc0,1.5,1.1,2.2,2.5,2.2c1.4,0,2.1-0.5,2.7-1.5h0c0,0.8,0.1,1.3,1,1.3c0.3,0,0.4,0,0.6-0.1v-0.8c-0.1,0-0.2,0.1-0.3,0.1\n\tc-0.3,0-0.5-0.2-0.5-0.5v-3.9c0-2-1.4-2.4-2.7-2.4c-1.7,0-2.9,0.7-3,2.5L99,11.6L99,11.6z M102.9,13.8c0,1.4-1.2,2.3-2.6,2.3\n\tc-0.8,0-1.7-0.5-1.7-1.5c0-1.4,1.9-1.4,3.4-1.7c0.3,0,0.6-0.1,0.8-0.3h0C102.9,12.7,102.9,13.8,102.9,13.8z","key":13}),React.createElement("path",{"fill":"#FFFFFF","d":"M105.4,16.7h0.9v-4.3c0-1.4,0.9-2.5,2.3-2.5c1.5,0,1.9,1,1.9,2.2v4.6h0.9v-4.7c0-1.7-0.6-2.8-2.7-2.8\n\tc-1,0-2,0.6-2.4,1.5h0V9.3h-0.9C105.4,9.3,105.4,16.7,105.4,16.7z","key":14}),React.createElement("path",{"fill":"#FFFFFF","d":"M119,11.6c-0.2-1.7-1.4-2.5-3-2.5c-2.3,0-3.5,1.8-3.5,3.9s1.2,3.9,3.5,3.9c1.7,0,2.8-1.1,3.1-2.9h-0.9\n\tc-0.1,1.2-1,2.1-2.1,2.1c-1.7,0-2.6-1.6-2.6-3.1c0-1.6,0.9-3.1,2.6-3.1c1.2,0,1.8,0.7,2.1,1.8L119,11.6L119,11.6z","key":15}),React.createElement("path",{"fill":"#FFFFFF","d":"M120.2,16.7h0.9v-4.3c0-1.4,0.9-2.5,2.3-2.5c1.5,0,1.9,1,1.9,2.2v4.6h0.9v-4.7c0-1.7-0.6-2.8-2.7-2.8\n\tc-1,0-2,0.6-2.4,1.5h0V6.5h-0.9C120.2,6.5,120.2,16.7,120.2,16.7z","key":16}),React.createElement("path",{"fill":"#FFFFFF","d":"M127.8,7.9h0.9V6.5h-0.9V7.9z M127.8,16.7h0.9V9.3h-0.9V16.7z","key":17}),React.createElement("path",{"fill":"#FFFFFF","d":"M135.6,11.5c-0.1-1.6-1.2-2.4-2.7-2.4c-1.3,0-2.8,0.6-2.8,2.1c0,1.2,0.9,1.7,2.1,2l1.1,0.3\n\tc0.8,0.2,1.6,0.5,1.6,1.3c0,1-1.2,1.4-2,1.4c-1.2,0-2.1-0.6-2.2-1.8h-0.9c0.1,1.8,1.3,2.6,3,2.6c1.4,0,3-0.6,3-2.2\n\tc0-1.3-1.1-1.9-2.1-2l-1.2-0.3c-0.6-0.2-1.5-0.4-1.5-1.2c0-1,1-1.3,1.7-1.3c1,0,1.9,0.5,1.9,1.6L135.6,11.5L135.6,11.5z","key":18}),React.createElement("path",{"fill":"#FFFFFF","d":"M137,7.9h0.9V6.5H137V7.9z M137,16.7h0.9V9.3H137V16.7z","key":19}),React.createElement("path",{"fill":"#FFFFFF","d":"M139.5,16.7h0.9v-4.3c0-1.4,0.9-2.5,2.3-2.5c1.5,0,1.9,1,1.9,2.2v4.6h0.9v-4.7c0-1.7-0.6-2.8-2.7-2.8\n\tc-1,0-2,0.6-2.4,1.5h0V9.3h-0.9C139.5,9.3,139.5,16.7,139.5,16.7z","key":20}),React.createElement("path",{"fill":"#FFFFFF","d":"M153.2,9.3h-0.9v1.3h0C152,9.8,151,9.1,150,9.1c-2.1,0-3.3,1.7-3.3,3.7c0,2.1,1,3.8,3.3,3.8\n\tc1,0,1.9-0.6,2.4-1.5h0v1c0,1.8-0.7,2.8-2.4,2.8c-1,0-1.9-0.4-2.2-1.5h-0.9c0.1,1.6,1.6,2.2,3.1,2.2c2.4,0,3.2-1.3,3.3-3.5\n\tL153.2,9.3L153.2,9.3z M150,15.8c-1.7,0-2.4-1.4-2.4-2.9c0-1.5,0.7-3.1,2.4-3.1c1.7,0,2.4,1.6,2.4,3.1\n\tC152.3,14.4,151.5,15.8,150,15.8z","key":21}),React.createElement("path",{"fill":"#FFF21F","d":"M80.6,19c-0.2,0-0.3-0.2-0.3-0.3l0-16.5c0-0.2,0.2-0.3,0.3-0.3C80.8,1.8,81,2,81,2.2v16.5\n\tC80.9,18.8,80.8,19,80.6,19","key":22}),React.createElement("path",{"fill":"none","stroke":"#FFF21F","strokeWidth":"0.1133","strokeMiterlimit":"1.1328","d":"M80.6,19c-0.2,0-0.3-0.2-0.3-0.3l0-16.5\n\tc0-0.2,0.2-0.3,0.3-0.3C80.8,1.8,81,2,81,2.2v16.5C80.9,18.8,80.8,19,80.6,19","key":23})]);
	}
	
	WeichertLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"100%","viewBox":"0 0 154.2 20.2","enableBackground":"new 0 0 154.2 20.2","xmlSpace":"preserve"};
	
	module.exports = WeichertLogo;
	
	WeichertLogo.default = WeichertLogo;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(870);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// commons-055924226f462ba474d8.js